(function () {
    'use strict';

    angular
        .module('app.seleccion_admin', ['datatables', 'infinite-scroll', 'lr.upload', 'ngFileUpload', 'ngFileSaver', 'angular-img-cropper', 'textAngular', 'ng-currency', 'ckeditor', 'chart.js'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdThemingProvider) {
        /*
        $mdThemingProvider.theme('default')
            .primaryPalette('blue')
            .accentPalette('blue')
            .backgroundPalette('blue')
            .warnPalette('blue');
        */

        var theme = localStorage.getItem('THEME_SELECTION');

        if (theme) {
            var theme = JSON.parse(theme);
            $mdThemingProvider.definePalette(theme.primary.name, theme.primary.palette);
            $mdThemingProvider.definePalette(theme.accent.name, theme.accent.palette);
            $mdThemingProvider.definePalette(theme.warn.name, theme.warn.palette);

            $mdThemingProvider.theme('default')
                .primaryPalette(theme.primary.name)
                .accentPalette(theme.accent.name)
                .warnPalette(theme.warn.name);
        }

        // State
        $stateProvider
            .state('app.seleccion_dashboard_requester', {
                url: '/dashboard-requester',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/dashboard-requester/dashboard-requester.html',
                        controller: 'DashboardRequesterController as vm'
                    }
                }
            })
            .state('app.seleccion_requisiciones_jefe', {
                url: '/requests',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/requests/requests.html',
                        controller: 'RequestsController as vm'
                    }
                }
            })
            //Requester
            .state('app.seleccion_requisiciones_todas', {
                url: '/all-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/requests/requests.html',
                        controller: 'RequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_requisiciones_noaprobadas', {
                url: '/no-approved-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/requests/requests.html',
                        controller: 'RequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_requisiciones_aprobadas', {
                url: '/approved-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/requests/requests.html',
                        controller: 'RequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_requisiciones_enaprobacion', {
                url: '/process-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/requests/requests.html',
                        controller: 'RequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_requisiciones_construccion', {
                url: '/draft-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/requests/requests.html',
                        controller: 'RequestsController as vm'
                    }
                }
            })
            //Approver
            .state('app.seleccion_requisiciones_aprobador', {
                url: '/approver-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/approver/requests/requests.html',
                        controller: 'ApproverRequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_requisiciones_aprobacion', {
                url: '/pending-approver-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/approver/requests/requests.html',
                        controller: 'ApproverRequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_requisiciones_proceso', {
                url: '/process-approver-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/approver/requests/requests.html',
                        controller: 'ApproverRequestsController as vm'
                    }
                }
            })
            //Admin
            .state('app.seleccion_requisiciones_admin_proceso', {
                url: '/process-admin-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/requests/requests.html',
                        controller: 'AdminRequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_requisiciones_admin_aprobadas', {
                url: '/approved-admin-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/requests/requests.html',
                        controller: 'AdminRequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_requisiciones_admin_noaprobadas', {
                url: '/dismiss-admin-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/requests/requests.html',
                        controller: 'AdminRequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_requisiciones_admin', {
                url: '/all-admin-requests/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/requests/requests.html',
                        controller: 'AdminRequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_nueva_requisicion', {
                url: '/new-request',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/new-request/new-request.html',
                        controller: 'NewRequestsController as vm'
                    }
                }
            })
            .state('app.seleccion_ver_requisicion', {
                url: '/show-request/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/show-request/show-request.html',
                        controller: 'ShowRequestController as vm'
                    }
                }
            })
            .state('app.seleccion_ver_admin_requisicion', {
                url: '/show-admin-request/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/show-request/show-request.html',
                        controller: 'ShowAdminRequestController as vm'
                    }
                }
            })
            .state('app.seleccion_ver_approver_requisicion', {
                url: '/show-approver-request/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/approver/show-request/show-request.html',
                        controller: 'ShowApproverRequestController as vm'
                    }
                }
            })
            .state('app.seleccion_update_requisicion', {
                url: '/update-request/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/update-request/update-request.html',
                        controller: 'UdpateRequestController as vm'
                    }
                }
            })
            .state('app.seleccion_update_admin_requisicion', {
                url: '/update-admin-request/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/update-request/update-request.html',
                        controller: 'UdpateAdminRequestController as vm'
                    }
                }
            })
            .state('app.seleccion_update_approver_requisicion', {
                url: '/update-approver-request/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/approver/update-request/update-request.html',
                        controller: 'UdpateApproverRequestController as vm'
                    }
                }
            })
            .state('app.seleccion_informe_requisiciones_anio', {
                url: '/admin-dashboard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/dashboard/admin-dashboard.html',
                        controller: 'AdminDashboardController as vm'
                    }
                }
            })
            .state('app.seleccion_informe_nivel_servicio', {
                url: '/service-performance',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/service-performance/service-performance.html',
                        controller: 'ServicePerformanceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_requisiciones_admin', {
                url: '/request-admin',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_nivel_servicio', {
                url: '/request-report-service',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_base_requisiciones', {
                url: '/request-report-base-requisiciones',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_base_ingresos', {
                url: '/request-reporte-base-ingresos',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_acuerdo_servicio', {
                url: '/request-reporte-acuerdo-servicio',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_estadistico', {
                url: '/request-reporte-estadistico',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_suspensiones', {
                url: '/request-reporte-suspensiones',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_hoja_vidas', {
                url: '/request-reporte-hoja-vidas',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_hoja_vidas_detallado', {
                url: '/request-reporte-hoja-vidas-detallado',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_vacantes_activas', {
                url: '/request-reporte-vacantes-activas',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_demografico', {
                url: '/request-reporte-demografico',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_semilleros', {
                url: '/request-reporte-semilleros',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_procesos_totales', {
                url: '/request-reporte-procesos-totales',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_proceso_detalle', {
                url: '/request-reporte-proceso-detalle',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_pruebas', {
                url: '/request-reporte-pruebas',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/reports/request-report-service/request-report-service.html',
                        controller: 'RequestReportServiceController as vm'
                    }
                }
            })
            
            //Config
            .state('app.core_get_configuracions', {
                url: '/settings',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/config/settings/settings.html',
                        controller: 'SettingsController as vm'
                    }
                }
            })
            .state('app.core_get_plantillas', {
                url: '/mail-templates',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/config/mail-templates/mail-templates.html',
                        controller: 'MailTemplatesController as vm'
                    }
                }
            })
            .state('app.core_get_bandeja_salida', {
                url: '/outbox',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/config/outbox/outbox.html',
                        controller: 'OutboxController as vm'
                    }
                },
                bodyClass: 'mail'
            })
            .state('app.seleccion_requisiciones_aprobadores', {
                url: '/approvers',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/config/approvers/approvers.html',
                        controller: 'ApproversController as vm'
                    }
                },
                bodyClass: 'mail'
            })
            .state('app.approve_understanding_position', {
                url: '/approve-understanding-position/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/approver/understanding/understanding-position.html',
                        controller: 'approve-understanding-position as vm'
                    }
                }
            })
            .state('app.show_finalist_candidate', {
                url: '/show-finalist-candidate/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/show-finalist-candidate/show-finalist-candidate.html',
                        controller: 'show-finalist-candidate as vm'
                    }
                }
            })
            .state('app.dashboard_finalist_candidate', {
                url: '/dashboard-finalist',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/requester/dashboard-finalist-candidate/dashboard-finalist-candidate.html',
                        controller: 'DashboardFinalistController as vm'
                    }
                }
            })
            .state('app.create_analyst', {
                url: '/create-analyst',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/analyst/create/createanalyst.html',
                        controller: 'createAnalyst as vm'
                    }
                }
            })
            .state('app.update_analyst', {
                url: '/update-analyst/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/analyst/update/update.html',
                        controller: 'updateAnalyst as vm'
                    }
                }
            })
            .state('app.seleccion_get_all_analysts', {
                url: '/list-analysts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/analyst/dashboard/dashboard.html',
                        controller: 'dashboardAnalyst as vm'
                    }
                }
            })
            .state('app.seleccion_get_colaborators', {
                url: '/list-colaborators',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/collaborators/collaborators/collaborators.html',
                        controller: 'collaboratorsController as vm'
                    }
                }
            })
            .state('app.show_collaborator', {
                url: '/show-colaborator/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/collaborators/collaborators/collaborator.html',
                        controller: 'collaboratorController as vm'
                    }
                }
            })
            .state('app.seleccion_get_procesos_admin', {
                url: '/lists-requests',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/lists-requests/lists-requests.html',
                        controller: 'ListsRequestsAdmin as vm'
                    }
                }
            })
            .state('app.seleccion_proceso_admin', {
                url: '/detail-request/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/request/request.html',
                        controller: 'DetailRequestAdmin as vm'
                    }
                }
            })
            .state('app.understanding_charge_admin', {
                url: '/understanding-charge/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/understanding-charge/understanding-charge.html',
                        controller: 'understandingChargeAdmin as vm'
                    }
                }
            })
            .state('app.suspension_request_admin', {
                url: '/suspension_request/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/suspension-request/suspension-request.html',
                        controller: 'suspensionRequest as vm'
                    }
                }
            })
            .state('app.seleccion_history_request_admin', {
                url: '/historial-request/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/history-request/history-request.html',
                        controller: 'historyRequest as vm'
                    }
                }
            })
            .state('app.seleccion_search_candidate_admin', {
                url: '/search-candidate',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/search_hv/search_hv.html',
                        controller: 'SearchcandidateControllerAdmin as vm'
                    }
                }
            })
            .state('app.seleccion_get_team_processes_admin', {
                url: '/team_processes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/team-processes/team_processes.html',
                        controller: 'teamProcesses as vm'
                    }
                }
            })
            .state('app.seleccion_get_sociedades_paises', {
                url: '/admin-societies',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/crud-society/crud-society.html',
                        controller: 'societyController as vm'
                    }
                }
            })
            .state('app.seleccion_upload_structures', {
                url: '/admin-upload-structures',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/upload-structures/upload-structures.html',
                        controller : 'AdminUploadStructuresController as vm'
                    }
                }
            })
            .state('app.get_tiempos_objetivos', {
                url: '/admin-update-tiempos-objetivos',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/update-tiempos/update-tiempos.html',
                        controller : 'AdminUpdateTiemposController as vm'
                    }
                }
            })
            .state('app.get_info_rol_aprobadores', {
                url: '/admin-update-roles-aprobadores',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/admin/admin/update-rol-aprobadores/update-rol-aprobadores.html',
                        controller : 'AdminUpdateRolesAprobadoresController as vm'
                    }
                }
            })
            ;


        // Translation
        $translatePartialLoaderProvider.addPart('app/main');

        // Navigation
        var menu = JSON.parse(localStorage.getItem('MENU_SELECTION'));
        angular.forEach(menu, function (data_menu) {
            // Navigation
            msNavigationServiceProvider.saveItem(data_menu.name, {
                title: capitalize(data_menu.label, true),
                group: true,
                icon: "",
                weight: 2
            });

            for (var index = 0; index < data_menu.childrens.length; index++) {
                var element = data_menu.childrens[index];
                msNavigationServiceProvider.saveItem(data_menu.name + '.' + element.name, {
                    title: capitalize(element.label, false),
                    state: 'app.' + element.url,
                    icon: element.icon,
                    weight: 3,
                    stateParams: { filter: element.url },
                    badge: (element.badge ? { content: element.badge, color: 'md-warn' } : ""),
                });
            }
        });


        function capitalize(input, all) {
            var reg = (all) ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
            return (!!input) ? input.replace(reg, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }) : '';
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.seleccion_admin')
        .controller('ProbarMailTemplateDialogController', ProbarMailTemplateDialogController);

    /** @ngInject */
    function ProbarMailTemplateDialogController($mdDialog, $document, $state, template, AdminService, IkanoFactory) {
        var vm = this;

        vm.loading = false;

        vm.template = template;

        vm.data = {};

        function getVarsTemplate() {
            AdminService.getVarMailTemplate({ id: vm.template.id }, {},
                function (response) {
                    if (response.data.status) {
                        vm.vars = response.data.data.vars;
                    }
                    
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );
        }

        vm.save = function () {
            vm.loading = true;
            vm.data.name = vm.template.name;
            AdminService.probarTemplate(vm.data, {},
                function (response) {
                    if (response.data.status) {
                        vm.closeDialog();
                    }
                    vm.loading = false;
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );
        }

        vm.closeDialog = function () {
            $mdDialog.hide();
        }

        getVarsTemplate();
    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('EditMailTemplateDialogController', EditMailTemplateDialogController);

	/** @ngInject */
	function EditMailTemplateDialogController($mdDialog, $document, $state, template, AdminService, IkanoFactory) {
		var vm = this;

        vm.loading = false;

		vm.template = template;

		vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo']
        ];

		vm.save = function() {
			vm.loading = true;
			AdminService.updateMailTemplate(vm.template, {}, 
				function(response) {
					if (response.data.result.status) {
						vm.closeDialog();
					}
					vm.loading = false;
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.loading = false;
				}
			);
		}

		vm.closeDialog = function(){
            $mdDialog.hide();
        }
    }
})();
(function (){
    'use strict';

    angular.module('app.seleccion_admin').controller('deleteDialogAnalyst', deleteDialogAnalyst);

    function deleteDialogAnalyst(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, ValidationService, $scope,analyst){

        //constructor
        var vm = this;

        vm.analyst = analyst;

        vm.deleteAnalyst = function(){
            analystService.deleteAnalyst({analista_id:analyst.id},function(resolve){
                $mdDialog.hide(resolve);
            },function(reject){
                IkanoFactory.showAlert("Error", reject.data.message);
            })
        }
       
        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate', ['infinite-scroll', 'lr.upload', 'ngFileUpload', 'ngFileSaver', 'angular-img-cropper'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdThemingProvider) {
        /*
        $mdThemingProvider.theme('default')
            .primaryPalette('light-blue')
            .accentPalette('blue')
            //.backgroundPalette('white')
            .warnPalette('orange');
        */

        // State
        $stateProvider
            .state('app.seleccion_dashboard', {
                url: '/dashboard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/candidate/dashboard/dashboard.html',
                        controller : 'DashboardController as vm'
                    }
                }
            })
            .state('app.seleccion_ofertas_aplico', {
                url: '/applied-offers',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/candidate/applied-offers/applied-offers.html',
                        controller : 'AppliedOffersController as vm'
                    }
                }
            })
            .state('app.seleccion_ofertas_disponibles', {
                url: '/offers-available',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/candidate/offers-available/offers-available.html',
                        controller : 'OffersAvailableController as vm'
                    }
                }
            })
            .state('app.seleccion_ver_hojavida', {
                url: '/resume',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/candidate/resume/resume.html',
                        controller : 'ResumeController as vm'
                    }
                }
            })
            .state('app.seleccion_acuerdo_servicio', {
                url: '/service-agreement',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/candidate/service-agreement/service-agreement.html',
                        controller : 'ServiceAgreementController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');

        // Navigation
        if (!localStorage.getItem('SERVICE_AGREEMENT_SELECTION')) {
            var menu = JSON.parse(localStorage.getItem('MENU_SELECTION'));

            angular.forEach(menu, function(data_menu) {
                msNavigationServiceProvider.saveItem(data_menu.name, {
                    title: capitalize(data_menu.label, true),
                    icon: data_menu.icon,
                    weight: 4
                });
                
                for (var index = 0; index < data_menu.childrens.length; index++) {
                    var element = data_menu.childrens[index];
                    msNavigationServiceProvider.saveItem(data_menu.name +'.'+ element.name, {
                        title: capitalize(element.label, false),
                        state: 'app.'+ element.url,
                        icon: element.icon,
                        weight: 3
                    });
                }
            });
        }

        function capitalize(input, all) {
            var reg = (all) ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
			return (!!input) ? input.replace(reg, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}) : '';
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('NoticeDialogController', NoticeDialogController);

    /** @ngInject */
    function NoticeDialogController($mdDialog, $document, event, offer, CandidateService) {
        var vm = this;
        vm.title = "Importante";
        vm.availableOffers = 10;
        vm.offersUsed = 3;
        vm.offer = offer;
        vm.applyData = null

        CandidateService.getApplyOfferInfo({proceso_id: offer.id}, {}, function(response){
			if (response.data.result) {
                vm.applyData = response.data.result;
			}
		});

        vm.openApplyDialog = function(ev) {
			$mdDialog.show({
				controller: 'ApplyDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/candidate/dashboard/dialogs/apply/apply.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					event: ev,
                    offer: vm.offer,
                    applyData: vm.applyData
				}
			});	 

            vm.closeDialog();
		};

        /**
         * Close dialog
         */
        vm.closeDialog = function() {
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('ApplyDialogController', ApplyDialogController);

    /** @ngInject */
    function ApplyDialogController($mdDialog, event, offer, CandidateService, IkanoFactory) {
        var vm = this;
        vm.title = '<span class="h1 text-light-200">Importante</span>';
        vm.offer = offer;

        // Data
        vm.steps = [1, 2];
        vm.finalStep = 0;
        vm.offer = offer;
        vm.step = 0;
        
        vm.requeriments = [];
        vm.argument = null;

        vm.nextStep = function() {
            vm.step = vm.step + 1;
            
            if (vm.step > vm.steps.length) {
                 vm.finalStep = 1;
                 vm.finish();
            }

            if (vm.step == 1) {
                vm.title = "<div class='h5'><strong>Usted desea aplicar al cargo " + vm.offer.name + "</strong> por favor indique con cuales de los siguientes aspectos cumple. Recuerde que esta información será verificada en las entrevistas realizadas y en las solicitudes de referencias.</div>"
            } else if (vm.step == 2) {
                vm.title = "<div class='h5'><strong>Usted desea aplicar al cargo " + vm.offer.name + "</strong> por favor indique con cuales de los siguientes aspectos cumple. Recuerde que esta información será verificada en las entrevistas realizadas y en las solicitudes de referencias.</div>"
            } 

            if (vm.step == 2 && !vm.offer.requeriments.length) {
                vm.nextStep();
            }
        };

        vm.finish = function() {
            vm.title = '<div class="h2">Estamos procesando la información...</div>';
            vm.loading = true;

            var req = [];
            for (var index = 0; index < vm.requeriments.length; index++) {
                var element = vm.requeriments[index];
                if (element.value) {
                    req.push(element.id);
                }
            }

            var source = localStorage.getItem('SOURCE');
            //var source = localStorage.getItem('ORIGEN');


            var data = {
                proceso_id: offer.id,
                proceso_requisitos: req,
                proceso_argumento: [vm.argument],
                origen: (typeof source !== 'undefined') ? source : 0
            };

            CandidateService.applyOffer(data, {}, function(response){
                vm.loading = false;
                if (response.data.result.error) {
                    vm.title = "";
                    vm.closeDialog();
                    IkanoFactory.showAlert("Ha ocurrido un error", response.data.result.error);
                } else if (response.data.result) {
                    vm.applyResponse = response.data.result;
                    offer.applied = true;
                    vm.title = '<div class="h2">Gracias por aplicar al cargo <strong>' + vm.offer.name + '</strong></div>';
                    vm.finalStep = 1;
                }
            });
        };

        /**
         * Close dialog
         */
        vm.closeDialog = function() {
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_analyst', ['datatables', 'infinite-scroll', 'lr.upload', 'ngFileUpload', 'ngFileSaver', 'angular-img-cropper', 'textAngular', 'ng-currency', 'ckeditor', 'ngAnimate', 'md.time.picker'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdThemingProvider, $mdDateLocaleProvider) {
        var theme = localStorage.getItem('THEME_SELECTION');

        if (theme) {
            var theme = JSON.parse(theme);
            $mdThemingProvider.definePalette(theme.primary.name, theme.primary.palette);
            $mdThemingProvider.definePalette(theme.accent.name, theme.accent.palette);
            $mdThemingProvider.definePalette(theme.warn.name, theme.warn.palette);

            $mdThemingProvider.theme('default')
                .primaryPalette(theme.primary.name)
                .accentPalette(theme.accent.name)
                .warnPalette(theme.warn.name);
        }
        //DATEPICKER
        $mdDateLocaleProvider.formatDate = function (date) {
            var m = moment(date);
            return m.isValid()? m.format('MMM D, YYYY') : '';
        };
        // State
        $stateProvider
            .state('app.seleccion_get_procesos_analista', {
                url: '/request',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/dashboard/dashboard.html',
                        controller: 'DashboardAnalystController as vm'
                    }
                }
            })
            .state('app.seleccion_get_procesos_analista_nuevos', {
                url: '/request-news/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/dashboard/dashboard.html',
                        controller: 'DashboardAnalystController as vm'
                    }
                }
            })
            .state('app.seleccion_get_procesos_analista_encurso', {
                url: '/request-curso/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/dashboard/dashboard.html',
                        controller: 'DashboardAnalystController as vm'
                    }
                }
            })
            .state('app.seleccion_get_procesos_analista_enaprobacion', {
                url: '/request-curso/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/dashboard/dashboard.html',
                        controller: 'DashboardAnalystController as vm'
                    }
                }
            })
            .state('app.seleccion_get_procesos_analista_compartidos', {
                url: '/request-share/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/dashboard/dashboard.html',
                        controller: 'DashboardAnalystController as vm'
                    }
                }
            })
            .state('app.seleccion_get_procesos_analista_suspendidos', {
                url: '/request-discontinued/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/dashboard/dashboard.html',
                        controller: 'DashboardAnalystController as vm'
                    }
                }
            })
            .state('app.seleccion_get_procesos_analista_finalizados', {
                url: '/request-finalized/:filter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/dashboard/dashboard.html',
                        controller: 'DashboardAnalystController as vm'
                    }
                }
            })
            .state('app.detail_seleccion_analyst', {
                abstract: true,
                url: '/request_detail',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/detail/detail.html',
                        controller: 'DetailAnalystController as vm'
                    }
                }
            })
            .state('app.detail_seleccion_analyst.index', {
                url: '/:request_id',
                templateUrl: 'app/main/analyst/detail/partial/route.index.html',
                controller: 'DetailAnalystIndexController as vm'
            })
            /*.state('app.detail_seleccion_analyst.detail', {
                url: '/:request_id/:candidate_id',
                templateUrl: 'app/main/analyst/detail/partial/route.detail.html',
                controller: 'CandidateDetailController as vm'
            })
            .state('app.seleccion_detalle_candidato', {
                url: '/candidate_detail/:request_id/:candidate_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/candidate-detail/candidate-detail.html',
                        controller: 'CandidateDetailController as vm'
                    }
                }
            })*/
            .state('app.entendimiento_cargo', {
                abstract: true,
                url: '/understanding_charge',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/understanding-charge/understanding-charge.html',
                        controller: 'understanding-charge as vm'
                    }
                }
            })
            .state('app.entendimiento_cargo.index', {
                url: '/:request_id',
                templateUrl: 'app/main/analyst/understanding-charge/understanding-charge-primary.html',
                controller: 'understanding-charge-primary as vm'
            })
            .state('app.entendimiento_cargo.autocompletar', {
                url: '/autocomplete/:request_id',
                templateUrl: 'app/main/analyst/understanding-charge/understanding-charge-autocomplete.html',
                controller: 'understanding-charge-autocomplete as vm'
            })
            .state('app.share_request', {
                url: '/share_request/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/share-request/share-request.html',
                        controller: 'shareRequest as vm'
                    }
                }
            })
            .state('app.send_candidate_applicant', {
                url: '/send_candidate_applicant/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/send-candidate-applicant/send-candidate-applicant.html',
                        controller: 'sendCandidateApplicant as vm'
                    }
                }
            })
            .state('app.suspension_request', {
                url: '/suspension_request/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/suspension-request/suspension-request.html',
                        controller: 'suspensionRequest as vm'
                    }
                }
            })
            .state('app.publish_request', {
                url: '/publish_request/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/publish_request/publish_request.html',
                        controller: 'publishRequest as vm'
                    }
                }
            })
            .state('app.seleccion_get_team_processes', {
                url: '/team_processes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/team-processes/team_processes.html',
                        controller: 'teamProcesses as vm'
                    }
                }
            })
            .state('app.seleccion-history-request', {
                url: '/historial-request/:request_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/history-request/history-request.html',
                        controller: 'historyRequest as vm'
                    }
                }
            })
            .state('app.seleccion_reporte_procesos_admin', {
                url: '/reports-analyst/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/reports/reports.html',
                        controller: 'reportsAnalyst as vm'
                    }
                }
            })
            .state('app.seleccion_create_request_analyst', {
                url: '/new-request-analyst/:idRequest',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/analyst/create-request/create-request.html',
                        controller: 'createRequestAnalyst as vm'
                    }
                }
            })
            .state('app.seleccion_history_process_candidate',{
                url: '/history-process-candidate/:request_id/:hv',
                views: {
                    'content@app':{
                        templateUrl: 'app/main/analyst/history-process-candidate/history-process-candidate.html',
                        controller: 'historyRequestCandidate as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');

        // Navigation
        var menu = JSON.parse(localStorage.getItem('MENU_SELECTION'));

        angular.forEach(menu, function (data_menu) {
            // Navigation
            msNavigationServiceProvider.saveItem(data_menu.name, {
                title: capitalize(data_menu.label, true),
                group: true,
                icon: "",
                weight: 2
            });

            for (var index = 0; index < data_menu.childrens.length; index++) {
                var element = data_menu.childrens[index];
                msNavigationServiceProvider.saveItem(data_menu.name + '.' + element.name, {
                    title: capitalize(element.label, false),
                    state: 'app.' + element.url,
                    icon: element.icon,
                    weight: 3,
                    stateParams: { filter: element.url },
                    badge: (element.badge ? { content: element.badge, color: 'md-warn' } : ""),
                });
            }
        });


        function capitalize(input, all) {
            var reg = (all) ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
            return (!!input) ? input.replace(reg, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }) : '';
        };
    }

})();

(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('reportsAnalystHome', reportsAnalystHome);

    function reportsAnalystHome($mdDialog, AdminService, IkanoFactory, analystConstant, analystService, $q, $filter, $state, $scope, paginationService, analystMisc) {
        //Le asignamos un alias al controlador
        var vm = this;

        vm.limit = analystConstant.LIMITROW;

        //DATATABLE
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            iDisplayLength: 20,
            responsive: true,
            order: [0, "desc"],
            paging: false,
            info: false,
            searching: false
        };

        //BACKUP
        vm.backup = {};

        function getReport(data) {
            analystService.getReport('getRequestReport',data, function (response) {
                vm.backup.filtros = data.filtros;
                if (response.data.status) {
                    modelRows(response.data.data.data);
                    modelFilter(response.data.data.lists);
                    //modelPagination(response.data.pagination);
                } else {
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }
            },
                function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la informacion de los candidatos, por favor intente de nuevo.");
                });
        }

        function modelRows(data){
            var baseJson = {
                "fecha_creacion": { key: "fecha_creacion", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } }
            };
            analystMisc.modeldataarray(data, baseJson,{createIfNotExist:true}).then(function (resolve) {
                vm.rows = resolve;
            });
        }

        function modelFilter(data){
            console.log(data);
        }

        function modelPagination(filterPage) {
            vm.pagination = filterPage;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        function createPagination() {
            var elemt = $('.right');
            //elemt.appendTo('<div class="paginations"></div>');

            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.endPage}}, {{vm.pagination.total_rows}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        getReport({
            filtros: {},
            pagination: {
                page: 1,
                limit: vm.limit
            }
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('DivideRequestController', DivideRequestController);

    /** @ngInject */
    function DivideRequestController($state, $mdDialog, AdminService, IkanoFactory, idRequest, values) {
        var vm = this;
        vm.idRequest = idRequest;
		vm.form = {};
        vm.values = values;
        vm.loading = false;
		vm.error = null;

		vm.options = [
			{id: 1, name: 'Todas'},
			{id: 2, name: 'Algunas'},
		];

		vm.validate = function() {
			if (vm.option == 1) {
				$state.go('app.seleccion_update_approver_requisicion', {id: vm.idRequest});
				vm.closeDialog();
			} else {
				vm.divide();
			}
		}

        vm.divide = function() {
			vm.error = null;
			
			var data = {
				id: vm.idRequest,
				no_vacantes: (vm.form.no_vacantes * 1)
			};

			AdminService.divideRequest(data, {}, 
				function(response) {
					if (response.data.result.status) {
						$state.go('app.seleccion_update_approver_requisicion', {id: response.data.result.data.id});
						vm.closeDialog();
					} else {
						vm.error = "Ocurrió un error, por favor intente de nuevo";
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				}
			);
		};

        vm.save = function() {
			var data = {
				id: vm.idRequest,
				data: vm.values
			};

			AdminService.saveRequest(data, {}, 
				function(response) {
					if (response.data.result.status) {
						IkanoFactory.showAlert("", "Se ha guardado la requisición exitosamente.");
						vm.idRequest = response.data.result.data.id;
						$state.go('app.seleccion_ver_requisicion', {id: response.data.result.data.id});
					} else {
						var def_msg = "Ha ocurrido un error, por favor intente de nuevo.";

						if (response.data.result.cust_msg) def_msg = response.data.result.cust_msg;

						IkanoFactory.showAlert("Error", def_msg);
					}

					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				}
			);
		};

		vm.closeDialog = function() {
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('SelectTypeNewRequestController', SelectTypeNewRequestController);

    /** @ngInject */
    function SelectTypeNewRequestController($mdDialog, $state, AdminService, IkanoFactory, requestTypes, extraRequests,listCountry,$filter) {
        var vm = this;

        vm.requestTypes = requestTypes;
        vm.extraRequests = extraRequests;
        vm.listCountry = IkanoFactory.jsonToArray(listCountry);

        vm.confirm = function() {
            var types = {
                tipo_solicitud: (vm.requestType != undefined  ? vm.requestType.id : null), 
                tipo_solicitud_b: (vm.extraType1 != undefined ? vm.extraType1.id : null), 
                tipo_solicitud_c: (vm.extraType2 != undefined ? vm.extraType2.id : null),
                pais_proceso_id: (vm.countryProcess != undefined ? vm.countryProcess : null)
            };

            IkanoFactory.removeRequestTypes();
            IkanoFactory.setRequestTypes(types);
            $state.go('app.seleccion_nueva_requisicion');
            vm.closeDialog();
        };

        vm.checkAvailability = function(type, item) {
            if (type != 1 && vm.requestType && vm.requestType.id == item.id) {
                return true;
            } else if (type != 2 && vm.extraType1 && vm.extraType1.id == item.id) {
                return true;
            } else if (type != 3 && vm.extraType2 && vm.extraType2.id == item.id) {
                return true;
            } 

            return false;
        }

        vm.closeDialog = function() {
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('AddEmployeeController', AddEmployeeController);

    /** @ngInject */
    function AddEmployeeController($mdDialog, AdminService, IkanoFactory, values, index, field, errors, lists) {
        var vm = this;
        vm.values = angular.copy(values);
        vm.field = field;
        vm.errors = errors;
        vm.lists = lists;
        vm.value = null;
        vm.index = index;
        vm.backupValues = angular.copy(vm.values);
        if (vm.values[vm.field.name] && vm.values[vm.field.name][vm.index]) {
            vm.value = vm.values[vm.field.name][vm.index];
        }
        
        vm.confirm = function () {
            $mdDialog.hide(vm.values);
        }

        vm.cancel = function () {
            if (vm.value) {
                vm.values.sociedad_id = vm.backupValues.sociedad_id;
                vm.values.area_funcional_id = vm.backupValues.area_funcional_id;
                vm.values.regional_id = vm.backupValues.regional_id;
                vm.values.division_id = vm.backupValues.division_id;
                vm.values.grupo_id = vm.backupValues.grupo_id;
                vm.values.centro_gasto = vm.backupValues.centro_gasto;
                vm.values.ubicacion_id = vm.backupValues.ubicacion_id;

                vm.values.notChangeInfoActual = true;
                vm.values[vm.field.name][index] = vm.value;
            } else {
                vm.values[vm.field.name][index] = '';
            }

            $mdDialog.cancel();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('RemoveColaboratorController', RemoveColaboratorController);

    /** @ngInject */
    function RemoveColaboratorController($mdDialog, $state, AdminService, IkanoFactory, data, item, type) {
        var vm = this;

        vm.title = "Retirar";
        vm.content = "¿Está seguro(a)?";
        vm.data = data;
        vm.item = item;
        vm.id = {id: vm.item.id};
        vm.loading = false;

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.removeSubstitute = function() {
            vm.loading = true;
            AdminService.removeSubstitute(vm.id, {}, 
              function(response) {
                  if (response.data.result) {
                      vm.data.aprobadores = response.data.aprobadores;
                  }
                  vm.loading = false;
                  vm.closeDialog();
                },
                function(response) {
                    vm.errors.general = "Ha ocurrido un error, por favor intente de nuevo.";
                    vm.loading = false;
                }
            );
        };

        vm.removeAssistant = function() {
            vm.loading = true;
            AdminService.removeAssistant(vm.id, {}, 
              function(response) {
                  if (response.data.result) {
                      vm.data.aprobadores = response.data.aprobadores;
                  }
                  vm.loading = false;
                  vm.closeDialog();
                },
                function(response) {
                    vm.errors.general = "Ha ocurrido un error, por favor intente de nuevo.";
                    vm.loading = false;
                }
            );
        };

        if (type == "assistant") {
            vm.title = "Remover asistente";
            vm.content = "¿Está seguro(a) que desea retirar a <strong>" + IkanoFactory.capitalize(vm.item.asistente, true) + "</strong> como asistente de <strong>" + IkanoFactory.capitalize(vm.item.aprobador, true) + "</strong>";
            vm.remove = vm.removeAssistant;
        } else if (type == "substitute") {
            vm.title = "Remover suplente";
            vm.content = "¿Está seguro(a) que desea retirar a <strong>" + IkanoFactory.capitalize(vm.item.suplente, true) + "</strong> como suplente de <strong>" + IkanoFactory.capitalize(vm.item.aprobador, true) + "</strong>";
            vm.remove = vm.removeSubstitute;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('ApproverDetailController', ApproverDetailController);

    /** @ngInject */
    function ApproverDetailController($mdDialog, $state, $scope, $mdDateLocale, AdminService, IkanoFactory, data, approver) {
        var vm = this;

        vm.loading = false;
        vm.data = data;
        vm.approver = approver;

        vm.extraFields = {};

        var locale = IkanoFactory.getDateLocaleFormat('es');
        if (locale != false) {
          $mdDateLocale.months = locale.months;
          $mdDateLocale.shortMonths = locale.shortMonths;
          $mdDateLocale.days = locale.days;
          $mdDateLocale.shortDays = locale.shortDays;
        }

        $mdDateLocale.formatDate = function(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        };

        //Substitute
        vm.substitutes = IkanoFactory.convertObjToArrayObjects(data.colaboradors);
        vm.substitute = null;
        vm.date = null;
        if (vm.approver.fecha_max_suplente) {
            vm.date = moment(vm.approver.fecha_max_suplente).toDate();
        }

        vm.selectedSubstitute = null
        if (vm.approver.suplente) {
            vm.selectedSubstitute = {id: vm.approver.suplente_id, name: vm.approver.suplente};
            vm.substitute = vm.selectedSubstitute;
        }
        //Assistant
        vm.assistants = IkanoFactory.convertObjToArrayObjects(data.asistentes);
        vm.assistant = null;
        vm.selectedAssitant = null
        if (vm.approver.asistente) {
            vm.selectedAssitant = {id: vm.approver.asistente_id, name: vm.approver.asistente};
            vm.assistant = vm.selectedAssitant;
        }
        
        vm.title = IkanoFactory.capitalize(vm.approver.aprobador, true);
        vm.today = new Date();
        vm.errors = {};

        //Assitants
        vm.addAssistant = function() {
            vm.errors = {};
            vm.loading = true;
            if (vm.validateAssistant()) {
                var data = {
                    id: vm.approver.id,
                    asistente_id: vm.assistant.id,
                };

                AdminService.addAssistant(data, {}, 
                    function(response) {
                        if (response.data.result) {
                            //vm.data.aprobadores = response.data.aprobadores;
                            vm.addApprover();
                        }
                        //vm.loading = false;
                    },
                    function(response) {
                        vm.errors.general = "Ha ocurrido un error, por favor intente de nuevo.";
                        vm.loading = false;
                    }
                );
            } else {
                vm.loading = false;
            }
        };

        vm.validateAssistant = function() {
          if (!vm.assistant) {
            vm.errors.assistant = "Este campo es obligatorio";
            return false;
          }

          return true;
        };

        vm.assistantQuerySearch = function(query) {
          var results = query ? vm.assistants.filter(createFilterFor(query) ) : vm.assistants;
          return results;
        };

        vm.selectedAssistantChange = function(item) {
          if (item) {
            vm.assistant = item;
            //vm.addAssistant();
          } else {
            vm.assistant = null;
            //vm.removeAssistant();
          }
        };

        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);

          return function filterFn(res) {
            res = angular.lowercase(res.name);
            return res.indexOf(lowercaseQuery.toLowerCase())!=-1;
          };
        };

        vm.removeAssistant = function() {
            vm.errors = {};
            vm.loading = true;
            AdminService.removeAssistant({id: vm.approver.id}, {}, 
              function(response) {
                  if (response.data.result) {
                      //vm.data.aprobadores = response.data.aprobadores;
                      vm.addApprover();
                  }
                  //vm.loading = false;
                },
                function(response) {
                    vm.errors.general = "Ha ocurrido un error, por favor intente de nuevo.";
                    vm.loading = false;
                }
            );
        };

        //Substitutes
        vm.addSubstitute = function() {
            vm.errors = {};
            vm.loading = true;
            if (vm.validateSubstitute()) {
                var data = {
                    id: vm.approver.id,
                    suplente_id: vm.substitute.id,
                    fecha_limite: moment(vm.date).format('YYYY-MM-DD')
                };

                AdminService.addSubstitute(data, {}, 
                    function(response) {
                        if (response.data.result) {
                            //vm.data.aprobadores = response.data.aprobadores;
                            if (vm.assistant == null) {
                                vm.removeAssistant();
                            } else {
                                vm.addAssistant();
                            }
                        }
                        //vm.loading = false;
                    },
                    function(response) {
                        vm.errors.general = "Ha ocurrido un error, por favor intente de nuevo.";
                        vm.loading = false;
                    }
                );
            }
        };

        $scope.$watch('vm.date',function(newValue, oldValue) {
            if(newValue != oldValue && !vm.loading && vm.substitute) {
                //vm.addSubstitute();			
            }
        },true);

        vm.validateSubstitute = function() {
          if (!vm.substitute) {
            vm.errors.substitute = "Este campo es obligatorio";
            return false;
          } else if (!vm.date) {
            vm.errors.date = "Este campo es obligatorio";
            return false;
          }

          return true;
        };

        vm.substituteQuerySearch = function(query) {
          var results = query ? vm.substitutes.filter(createFilterFor(query) ) : vm.substitutes;
          return results;
        };

        vm.selectedSubstituteChange = function(item) {
          if (item) {
            vm.substitute = item;
            //vm.addSubstitute();
          } else {
            vm.substitute = null;
            //vm.removeSubstitute();
          }
        };

        vm.removeSubstitute = function() {
            vm.errors = {};
            vm.loading = true;
            AdminService.removeSubstitute({id: vm.approver.id}, {}, 
                function(response) {
                    if (response.data.result) {
                        //vm.data.aprobadores = response.data.aprobadores;
                            if (vm.assistant == null) {
                                vm.removeAssistant();
                            } else {
                                vm.addAssistant();
                            }
                    }
                    //vm.loading = false;
                },
                function(response) {
                    vm.errors.general = "Ha ocurrido un error, por favor intente de nuevo.";
                    vm.loading = false;
                }
            );
        };

        vm.enableApprover = function(approver) {
            vm.errors = {};
            vm.loading = true;
            AdminService.enableApprover({id: vm.approver.id}, {}, 
                function(response) {
                    if (response.data.result) {
                        vm.data.aprobadores = response.data.aprobadores;
                        vm.approver.estado = true;
                    } else {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
                    vm.loading = false;
                },
                function(response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );
        };

        vm.disableApprover = function(approver) {
            vm.errors = {};
            vm.loading = true;
            AdminService.disableApprover({id: vm.approver.id}, {}, 
                function(response) {
                    if (response.data.result) {
                        vm.data.aprobadores = response.data.aprobadores;
                        vm.approver.estado = false;
                    } else {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
                    vm.loading = false;
                },
                function(response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );
        };

        if (vm.approver.estado) {
            vm.changeStatus = vm.disableApprover;
        } else {
            vm.changeStatus = vm.enableApprover;
        }

        vm.save = function() {
            vm.loading = true;

            if (vm.substitute == null) {
                vm.removeSubstitute();
            } else {
                vm.addSubstitute();
            }
        };
        
        vm.addApprover = function() {
            vm.loading = true;
            var data = {
                id: vm.approver.id,
                extra_data: vm.extraFields
            };

            AdminService.addApprover(data, {}, 
                function(response) {
                    if (response.data.result) {
                        vm.data.aprobadores = response.data.aprobadores;
                        //delete vm.data.colaboradors[vm.colaborator.id];
                        vm.closeDialog();
                    } else {
                        vm.errors.general = response.data.message;
                    }

                    vm.loading = false;
                },
                function(response) {
                    vm.errors.general = "Ha ocurrido un error, por favor intente de nuevo.";
                    vm.loading = false;
                }
            );
        };

        vm.closeDialog = function() {
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('AddSubstituteController', AddSubstituteController);

    /** @ngInject */
    function AddSubstituteController($mdDialog, $state, $mdDateLocale, AdminService, IkanoFactory, approver, data) {
        var vm = this;

        vm.title = "Agregar suplente";

        vm.loading = false;
        vm.date = null;
        vm.approver = approver;
        vm.colaborators = IkanoFactory.convertObjToArrayObjects(data.colaboradors);
        vm.colaborator = null;
        vm.data = data;
        vm.errors = {};

        vm.today = new Date();

        var locale = IkanoFactory.getDateLocaleFormat('es');
        if (locale != false) {
          $mdDateLocale.months = locale.months;
          $mdDateLocale.shortMonths = locale.shortMonths;
          $mdDateLocale.days = locale.days;
          $mdDateLocale.shortDays = locale.shortDays;
        }

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.addSubstitute = function() {
          vm.loading = true;
          if (vm.validate()) {
            var data = {
              id: vm.approver.id,
              suplente_id: vm.colaborator.id,
              fecha_limite: vm.date
            };

            AdminService.addSubstitute(data, {}, 
              function(response) {
                  if (response.data.result) {
                      vm.data.aprobadores = response.data.aprobadores;
                  }
                  vm.loading = false;
                  vm.closeDialog();
                },
                function(response) {
                    vm.errors.general = "Ha ocurrido un error, por favor intente de nuevo.";
                    vm.loading = false;
                }
            );
          }
        }

        vm.validate = function() {
          if (!vm.colaborator) {
            vm.errors.aprobador_id = "Este campo es obligatorio";
            return false;
          } else if (!vm.date) {
            vm.errors.date = "Este campo es obligatorio";
            return false;
          }

          return true;
        }

        vm.colaboratorQuerySearch = function(query) {
          var results = query ? vm.colaborators.filter(createFilterFor(query) ) : vm.colaborators;
          return results;
        }

        vm.selectedColaboratorChange = function(item) {
          if (item) {
            vm.colaborator = item;
          } else {
            vm.colaborator = null;
          }
        }

        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);

          return function filterFn(res) {
            res = angular.lowercase(res.name);
            return res.indexOf(lowercaseQuery.toLowerCase())!=-1;
          };
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('AddAssistantController', AddAssistantController);

    /** @ngInject */
    function AddAssistantController($mdDialog, $state, AdminService, IkanoFactory, approver, data) {
        var vm = this;

        vm.title = "Título";

        vm.loading = false;
        vm.approver = approver;
        vm.assistants = IkanoFactory.convertObjToArrayObjects(data.asistentes);
        vm.assistant = null;
        vm.data = data;
        vm.errors = {};

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.addAssistant = function() {
          vm.loading = true;
          if (vm.validate()) {
            var data = {
              id: vm.approver.id,
              asistente_id: vm.assistant.id,
            };

            AdminService.addAssistant(data, {}, 
              function(response) {
                  if (response.data.result) {
                      vm.data.aprobadores = response.data.aprobadores;
                  }
                  vm.loading = false;
                  vm.closeDialog();
                },
                function(response) {
                    vm.errors.general = "Ha ocurrido un error, por favor intente de nuevo.";
                    vm.loading = false;
                }
            );
          }
        }

        vm.validate = function() {
          if (!vm.assistant) {
            vm.errors.assistant = "Este campo es obligatorio";
            return false;
          }

          return true;
        }

        vm.colaboratorQuerySearch = function(query) {
          var results = query ? vm.assistants.filter(createFilterFor(query) ) : vm.assistants;
          return results;
        }

        vm.selectedColaboratorChange = function(item) {
          if (item) {
            vm.assistant = item;
          } else {
            vm.assistant = null;
          }
        }

        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);

          return function filterFn(res) {
            res = angular.lowercase(res.name);
            return res.indexOf(lowercaseQuery.toLowerCase())!=-1;
          };
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('AddApproverController', AddApproverController);

    /** @ngInject */
    function AddApproverController($mdDialog, $state, AdminService, IkanoFactory, data) {
        var vm = this;
        vm.loading = false;
        vm.title = "Agregar aprobador";

        vm.types = data.roles;
        vm.type = null;
        vm.colaborators = IkanoFactory.convertObjToArrayObjects(data.colaboradors);
        vm.colaborator = null;
        vm.data = data;
        vm.extraFields = {};
        vm.errors = {};

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.addApprover = function() {
          vm.loading = true;
          if (vm.validate()) {
            var data = {
              aprobador_id: vm.colaborator.id,
              rol: vm.type,
              extra_data: vm.extraFields
            };

            AdminService.addApprover(data, {}, 
              function(response) {
                  if (response.data.result) {
                      vm.data.aprobadores = response.data.aprobadores;
                      //delete vm.data.colaboradors[vm.colaborator.id];
                      vm.closeDialog();
                  } else {
                      vm.errors.general = response.data.message;
                  }

                  vm.loading = false;
                },
                function(response) {
                    vm.errors.general = "Ha ocurrido un error, por favor intente de nuevo.";
                    vm.loading = false;
                }
            );
          } else {
            vm.loading = false;
          }
        }

        vm.validate = function() {
          if (!vm.colaborator) {
            vm.errors.aprobador_id = "Este campo es obligatorio";
            return false;
          } else if (!vm.type) {
            vm.errors.type = "Este campo es obligatorio";
            return false;
          }

          return true;
        }

        vm.colaboratorQuerySearch = function(query) {
          var results = query ? vm.colaborators.filter(createFilterFor(query) ) : vm.colaborators;
          return results;
        }

        vm.selectedColaboratorChange = function(item) {
          if (item) {
            vm.colaborator = item;
          } else {
            vm.colaborator = null;
          }
        }

        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);

          return function filterFn(res) {
            res = angular.lowercase(res.name);
            return res.indexOf(lowercaseQuery.toLowerCase())!=-1;
          };
        }
    }
})();
(function(){
    'use strict';

    angular.module('app.seleccion_admin').controller('positionControllerDialog',positionControllerDialog);

    function positionControllerDialog($mdDialog,positions,sociedades,$filter){
        //constructor
        var vm = this;

        vm.filter = {};

        vm.data = {};

        vm.misc = {};

        vm.limit = 15;

        vm.positions = positions;

        vm.sociedades = sociedades;
        
        vm.misc.positions = positions.slice(0,vm.limit);
        vm.misc.sociedades = sociedades.slice(0,vm.limit);
        

        vm.loadData = function(filter){
            if (vm.filter[filter] && vm.filter[filter].length >= 3) {
                vm.loadDataFilter(filter);
            } else {
                var length = vm.misc[filter].length;
                if (length == vm[filter].length) {
                    return;
                }
                for (var i = 0; i < vm.limit; i++) {
                    var pushIndex = i + length;
                    if(typeof vm.misc[filter][pushIndex] == "undefined"){
                        break;
                    }
                    vm.misc[filter].push(vm[filter][pushIndex]);
                }
            }
        }

        vm.loadDataFilter = function (filter) {
            vm.misc[filter] = $filter('filter')(vm[filter], vm.filter[filter]);
        }

        vm.save = function(){
            $mdDialog.hide(vm.data);
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('UpdateRequestTypeController', UpdateRequestTypeController);

    /** @ngInject */
    function UpdateRequestTypeController($mdDialog, $state, AdminService, IkanoFactory, idRequest, data, requestTypes, extraRequests, getRequest, newRequest, listCountry) {
        var vm = this;
        vm.idRequest = idRequest;
        vm.data = data;
        vm.requestTypes = requestTypes;
        vm.extraRequests = extraRequests;
        vm.listCountry = IkanoFactory.jsonToArray(listCountry);

        vm.setData = function() {
            for (var index = 0; index < vm.requestTypes.length; index++) {
                var element = vm.requestTypes[index];
                if (element.id == vm.data.data.tipo_solicitud) {
                    vm.requestType = element;
                    break;
                }
            }

            for (var index = 0; index < vm.extraRequests.length; index++) {
                var element = vm.extraRequests[index];
                if (element.id == vm.data.data.tipo_solicitud_b) {
                    vm.extraType1 = element;
                }

                if (element.id == vm.data.data.tipo_solicitud_c) {
                    vm.extraType2 = element;
                }
            }

            if (vm.data.data.pais_proceso_id != null){
                vm.countryProcess = vm.data.data.pais_proceso_id
            }

        };
        vm.setData();

        vm.confirm = function() {
            var types = {
                id: vm.idRequest,
                tipo_solicitud: (vm.requestType ? vm.requestType.id : null), 
                tipo_solicitud_b: (vm.extraType1 ? vm.extraType1.id : null), 
                tipo_solicitud_c: (vm.extraType2 ? vm.extraType2.id : null),
                pais_proceso_id: (vm.countryProcess ? vm.countryProcess : null)
            };

            if (!newRequest) {
                AdminService.updateRequestType(types, {}, 
                    function(response) {
                        if (response.data.result.status) {
                            vm.data.data.tipo_solicitud = types.tipo_solicitud;
                            vm.data.data.tipo_solicitud_b = types.tipo_solicitud_b;
                            vm.data.data.tipo_solicitud_c = types.tipo_solicitud_c;
                            vm.data.data.pais_proceso_id = types.pais_proceso_id;
                            IkanoFactory.setRequestTypes({
                                tipo_solicitud:types.tipo_solicitud,
                                tipo_solicitud_b:types.tipo_solicitud_b,
                                tipo_solicitud_c: types.tipo_solicitud_c,
                                pais_proceso_id: types.pais_proceso_id
                            });
                            getRequest();
                            $mdDialog.hide();
                        }
                    },
                    function(response) {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
                );
            } else {
                vm.data.data.tipo_solicitud = types.tipo_solicitud;
                vm.data.data.tipo_solicitud_b = types.tipo_solicitud_b;
                vm.data.data.tipo_solicitud_c = types.tipo_solicitud_c;
                vm.data.data.pais_proceso_id = types.pais_proceso_id;
                $mdDialog.hide();
            }
        };

        vm.checkAvailability = function(type, item) {
            if (type != 1 && vm.requestType && vm.requestType.id == item.id) {
                return true;
            } else if (type != 2 && vm.extraType1 && vm.extraType1.id == item.id) {
                return true;
            } else if (type != 3 && vm.extraType2 && vm.extraType2.id == item.id) {
                return true;
            } 

            return false;
        }

        vm.closeDialog = function() {
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('GivebackRequestController', GivebackRequestController);

    /** @ngInject */
    function GivebackRequestController($mdDialog, AdminService, IkanoFactory, idRequest, data) {
        var vm = this;
        vm.idRequest = idRequest;
        vm.data = data;
        vm.formData = {};
        vm.colaborator = null;

        vm.giveBackRequest =  function() {
            vm.formData.id = vm.idRequest * 1;
			AdminService.giveBackRequest(vm.formData, {}, 
				function(response) {
                    $mdDialog.hide();
                    if (response.data.requisicion.status) {
                        vm.data.options.anular = false;
                        vm.data.options.aprobar = false;
                        vm.data.options.devolver = false;
                        vm.data.options.rechazar = false;
                        vm.data.options.update = false;

                        vm.data.aprobadores = response.data.requisicion.data.requisicion.aprobadores;
                        //vm.data.data = response.data.requisicion.data.requisicion.data;
                        vm.data.data.estado = response.data.requisicion.data.requisicion.data.estado;
                        vm.data.data.estado_color = response.data.requisicion.data.requisicion.data.estado_color;
                        vm.data.data.estado_label = response.data.requisicion.data.requisicion.data.estado_label;
                        vm.data.extra = response.data.requisicion.data.requisicion.extra;
                    } else {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");    
                    }
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
        }
        
        vm.setRole = function() {
            if (vm.colaborator) {
                vm.formData.colaborador_id = vm.colaborator.colaborador_id;
                vm.formData.rol = vm.colaborator.rol;
            }
        };

        vm.closeDialog = function() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('DismissRequestController', DismissRequestController);

    /** @ngInject */
    function DismissRequestController($mdDialog, AdminService, IkanoFactory, idRequest, data) {
        var vm = this;
        vm.idRequest = idRequest;
        vm.data = data;
        vm.formData = {};
        vm.loading = false;

        vm.dismissRequest =  function() {
            vm.loading = true;
            vm.formData.id = vm.idRequest;

			AdminService.dismissRequest(vm.formData, {}, 
				function(response) {
                    if (response.data.requisicion.status) {
                        vm.data.options.anular = false;
                        vm.data.options.aprobar = false;
                        vm.data.options.devolver = false;
                        vm.data.options.rechazar = false;
                        vm.data.options.update = false;
                        vm.data.options.undoDismiss = true;
                        vm.data.data.estado = response.data.requisicion.data.requisicion.data.estado;
                        vm.data.data.estado_color = response.data.requisicion.data.requisicion.data.estado_color;
                        vm.data.data.estado_label = response.data.requisicion.data.requisicion.data.estado_label;
                        vm.data.aprobadores = response.data.requisicion.data.requisicion.aprobadores;
                        //vm.data.data = response.data.requisicion.data.requisicion.data;
                        vm.data.extra = response.data.requisicion.data.requisicion.extra;

                        vm.closeDialog();
                    } else {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

        vm.closeDialog = function() {
            $mdDialog.hide();
        };
    }
})();
(function () {
  'use strict';

  angular
      .module('app.seleccion_admin').controller('ApproveRequestController', ApproveRequestController);

  /** @ngInject */
  function ApproveRequestController($mdDialog, $state, AdminService, IkanoFactory, idRequest, data, update, set_storage, $window) {
    var vm = this;
    vm.idRequest = idRequest;
    vm.data = data;
    vm.disable_aprrove_button = false;

    function compare( a, b ) {
      if ( a.orden < b.orden ){
        return -1;
      }
      if ( a.orden > b.orden ){
        return 1;
      }
      return 0;
    }

    vm.message = '¿Está seguro(a) que desea aprobar la requisición?'
    
    vm.last_aprobador = vm.data.aprobadores.listado.sort(compare)[vm.data.aprobadores.listado.length - 1].estado == 2

    if(vm.last_aprobador && vm.data.data.no_vacantes > 1 && (
        vm.data.data.tipo_solicitud == 3 || vm.data.data.tipo_solicitud == 4
      )
    ){
      var adicional_procesos = vm.data.data.no_vacantes - 1
      vm.message = 'La requisición generara ' + adicional_procesos + ' proceso(s) adicionales ¿Está seguro(a) que desea aprobarla?'
    }

    vm.approveRequest =  function() {

      vm.disable_aprrove_button = true;

      AdminService.approveRequest({id: vm.idRequest}, {},
			  function(response) {
          if (response.data.requisicion.status) {
            if(set_storage) {
              $window.localStorage.setItem('undo_approve', 1);
            }
            
            vm.data.options.anular = false;
            vm.data.options.aprobar = false;
            vm.data.options.devolver = false;
            vm.data.options.rechazar = false;
            vm.data.options.update = false;
            vm.data.options.undoApprove = true;
            vm.data.aprobadores = response.data.requisicion.data.requisicion.aprobadores;
            vm.data.data.estado = response.data.requisicion.data.requisicion.data.estado;
            vm.data.data.estado_color = response.data.requisicion.data.requisicion.data.estado_color;
            vm.data.data.estado_label = response.data.requisicion.data.requisicion.data.estado_label;
            //vm.data.data = response.data.requisicion.data.requisicion.data;
            vm.data.extra = response.data.requisicion.data.requisicion.extra;
                    
            vm.closeDialog();

            if (update) {
              $state.go('app.seleccion_ver_approver_requisicion', {id: vm.idRequest});
            }
          } else {
            vm.disable_aprrove_button = false;
            $mdDialog.hide({
               requisicion: response.data.requisicion
            });

						var def_msg = "Ha ocurrido un error, por favor intente de nuevo.";
						if (response.data.result.cust_msg) def_msg = response.data.result.cust_msg;
						IkanoFactory.showAlert("Error", def_msg);
          }
			  },
			  function(response) {
          vm.disable_aprrove_button = false;
			    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
        }
      );
    };

    vm.closeDialog = function() {
      $mdDialog.cancel();
    };
  }
})();
(function () {
  'use strict';

  angular.module('app.seleccion_analyst').controller('modalTiempos', modalTiempos);

  function modalTiempos(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, analystMisc, $scope, $mdConstant, rol) {

      //constructo
      var vm = this;
      
      vm.errorMensaje = '';
      vm.hasError = false;

      vm.rol = rol
      vm.updateTiemposRequests = AdminService.update_tiempo_objetivo;


      function getRequetsSucess(response) {
        $mdDialog.hide(vm.rol);
      }

      function getRequetsReject(response) {
        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
      }

      vm.updateTiempo = function () {

        if(vm.rol.horas == null){

          vm.errorMensaje = 'Campo requerido';
          vm.hasError = true;
          return false;
        }

        if(vm.rol.horas <= 0){

          vm.errorMensaje = 'La cantidad de horas debe ser superior a 0';
          vm.hasError = true;
          return false;
        }

         vm.updateTiemposRequests({"rol_id": vm.rol.rol_id, "horas" : vm.rol.horas}, getRequetsSucess, getRequetsReject, {})
      }


      vm.closeDialog = function () {
          $mdDialog.cancel();
      }

  }

})();
(function () {
  'use strict';

  angular.module('app.seleccion_analyst').controller('modalRolAprobadores', modalRolAprobadores);

  function modalRolAprobadores(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, analystMisc, $scope, $mdConstant, rol) {

      //constructo
      var vm = this;
      
      vm.errorMensaje = '';
      vm.hasError = false;

      vm.rol = rol
      vm.updateRolAprobadoresRequests = AdminService.update_rol_aprobadores;


      function getRequetsSucess(response) {
        $mdDialog.hide(vm.rol);
      }

      function getRequetsReject(response) {
        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
      }

      vm.updateRolAprobador = function () {

        if(vm.rol.label == ""){

          vm.errorMensaje = 'Campo requerido';
          vm.hasError = true;
          return false;
        }

         vm.updateRolAprobadoresRequests({"id": vm.rol.id, "label" : vm.rol.label}, getRequetsSucess, getRequetsReject, {})
      }


      vm.closeDialog = function () {
          $mdDialog.cancel();
      }

  }

})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('ServicePerformanceController', ServicePerformanceController);

	/** @ngInject */
	function ServicePerformanceController($mdDialog, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory) {
        var vm = this;
        vm.loading = true;
        vm.report = null;
        vm.headers = [];

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['Reportes'],
			title: "Nivel de servicio",
        };

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			language: IkanoFactory.getLanguajeDataTable(),
            autoWidth : true,
            searching: false
        };

        vm.getReport = function() {
            AdminService.getServicePerformanceReport({}, {}, 
                function(response) {
                    if (response.data.data.requisiciones) {
                        vm.report = response.data.data.requisiciones;
                        vm.setHeaders();
                    }

                    vm.loading = false;
                },
                function(response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );    
        };

        vm.getReport();

        vm.setHeaders = function() {
            for (var index = 0; index < (Object.keys(vm.report.roles).length * 2); index++) {
                vm.headers.push(index);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin')
        .controller('RequestReportServiceOldController', RequestReportServiceOldController);

    /** @ngInject */
    function RequestReportServiceOldController($mdDialog, $document, $state, $scope, $filter, $window, $mdDateLocale, api, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, paginationService, analystConstant, $compile) {
        var vm = this;
        vm.loading = true;
        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Reportes'],
            title: "",
        };

        vm.valueFilter = {};
        vm.valueFilterTmp = {};
        vm.searchFilter = {};
        vm.headersColumn = {};
        vm.filters = [];

        vm.limit = analystConstant.LIMITROW;
        vm.pager = {};

        $mdDateLocale.formatDate = function (date) {
            return date ? moment(date).format('DD/MMMM/YYYY') : '';
        };

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            responsive: true,
            autoWidth: true,
            sPagingationType: "full_numbers",
            iDisplayLength: 20,
            deferRender: true,
            sorting: false,
            searching: false
        };

        $scope.$watch('vm.valueFilterTmp', function (current) {
            if (vm.filters.length == 0) { return; }
            changeDependency(current);
            changeDate(current);
        }, true);


        vm.init = function () {
            vm.filtrosinit = {
                "report_name_id": vm.report_name,
                "type": "info",
                'page': 1,
                'per_page': vm.limit,
            }
            getReport(vm.filtrosinit);

        }

        vm.filterByCriteria = function () {
            vm.page = 1;
            vm.valueFilter = angular.copy(vm.valueFilterTmp);
            if (validateDate()) {
                var filter = serializeFilter('info');
                getReport(filter);
            } else {
                IkanoFactory.showAlert("Error", "Hay campos fechas sin valor, por favor validar.");
            }

        };

        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.total_results, page, vm.limit);
            if (!noConsult) {
                var filter = serializeFilter('info');
                getReport(filter);
            }
            setTimeout(function () {
                createPagination();
            }, 1000);
        }

        vm.resetFilter = function () {
            vm.valueFilter = {};
            vm.valueFilterTmp = {};
            vm.page = 1;
            var filter = serializeFilter('info');
            getReport(filter);
        };

        vm.downloadExcel = function () {
            vm.valueFilter = angular.copy(vm.valueFilterTmp);
            var filter = serializeFilter('excel');
            AdminService.getServiceReportLevelService(filter, {}, function (response) {
                $window.open(api.general.getUrlBase() + '/' + response.data.report_filename, "_blank");
            },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                },

                false,
                {
                    old: true
                });
        };

        vm.search = function (arr, filter) {
            var arrReturn = [];
            if (filter && filter.length >= 3) {
                return $filter('filter')(arr, filter);
            } else {
                for (var i = 0; i < vm.limit; i++) {
                    var pushIndex = i + length;
                    arrReturn.push(arr[pushIndex]);
                }
            }
            return arrReturn;
        }



        function getReport(filtros) {
            AdminService.getServiceReportLevelService(filtros, {},
                function (response) {
                    if (vm.filters.length == 0) {
                        vm.filters = serializeFilters(response.data.filters);
                    }
                    vm.pageInfo.title = response.data.report_name;
                    vm.headersColumn = response.data.data_results.headers;
                    vm.reportData = response.data.data_results.data;
                    modelPagination(response.data.total_results);
                    vm.loading = false;
                    $("input.md-datepicker-input").prop('readonly', true);
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                },
                false,
                {
                    old: true
                }
            );
        };

        function modelPagination(total_results) {
            vm.total_results = total_results;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        function serializeFilter(type) {

            var filter = {
                "report_name_id": vm.report_name,
                "type": type,
                'per_page': vm.limit,
                'page': vm.page
            }
            for (var i in vm.filters) {
                var filternow = vm.filters[i].id;
                filter["filters[" + filternow + "]"] = '';
                if (vm.valueFilter[filternow]) {
                    filter["filters[" + filternow + "]"] = vm.valueFilter[filternow];
                } else {
                    continue;
                }

                if (vm.filters[i].type == 'DATE' || vm.filters[i].type == 'DATE_BETWEEN') {
                    filter["filters[" + filternow + "]"] = moment(vm.valueFilter[filternow]).format('YYYY-MM-DD');
                    continue;
                }

                if (typeof vm.valueFilter[filternow] == 'object') {
                    filter["filters[" + filternow + "]"] = vm.valueFilter[filternow].id;
                }
            }
            return filter;
        }

        function serializeFilters(filter) {
            var dependency = [];
            for (var i in filter) {
                if (filter[i].dependency) {
                    filter[i].show = false;
                } else {
                    filter[i].show = true;
                }
                if (filter[i].onchange) {
                    onChange(filter[i]);
                }
            }
            return filter;
        }

        function onChange(filter) {
            $scope.$watch("vm.valueFilterTmp['" + filter.id + "']", function (newValue, oldValue) {
                if (newValue) {
                    sendOnchange(filter);
                }
            }, true);
        }

        function sendOnchange(filter) {
            var onchange = filter.onchange;
            var data = {
                function: onchange.function,
                values: {}
            };

            for (var i in onchange.fields) {
                var valueFiels = vm.valueFilterTmp[onchange.fields[i]];
                if (valueFiels) {
                    data.values[onchange.fields[i]] = valueFiels;
                }
            }

            AdminService.get_onchange_data(data, function (response) {
                serializeListas(response.data.data.lista);
            }, function (reject) {
                console.error(reject);
            });

        }

        function serializeListas(data) {
            for (var i in vm.filters) {
                var filter = vm.filters[i];
                if (data[filter.id]) {
                    var options = [];
                    if (data[filter.id] instanceof Array) {
                        options = data[filter.id];
                    } else {
                        for (var j in data[filter.id]) {
                            options.push({ id: j, name: data[filter.id][j] });
                        }
                    }
                    vm.filters[i].values = options;

                }
            }
        }

        function createPagination() {
            var elemt = $('.right');
            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}} de {{vm.total_results}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        function changeDependency(current) {
            var dependency = vm.filters.filter(function (row) {
                return row.dependency;
            });
            if (dependency.length == 0) {
                return;
            }
            for (var i in vm.filters) {
                for (var j in dependency) {
                    if (vm.valueFilterTmp[dependency[j].dependency] && vm.filters[i].id == dependency[j].id) {
                        vm.filters[i].show = true;
                        break;
                    } else if (!vm.valueFilterTmp[dependency[j].dependency] && vm.filters[i].id == dependency[j].id) {
                        vm.filters[i].show = false;
                        break;
                    }
                }
            }
        }

        function changeDate(current) {
            var date = vm.filters.filter(function (row) {
                return row.type == 'DATE';
            });

            if (date.length == 0) {
                return;
            }


            for (var i in date) {
                getDateBetween(date[i].relation, date[i].id);
            }

        }

        function getDateBetween(id, idOrigin) {
            var date_between = vm.filters.filter(function (row) {
                return (row.type == 'DATE_BETWEEN' && row.id == id);
            });

            if (date_between.length == 0) {
                return;
            }

            if (vm.valueFilterTmp[date_between[0].id]) {

                if (vm.valueFilterTmp[idOrigin]) {
                    if (moment(vm.valueFilterTmp[date_between[0].id]) > moment(vm.valueFilterTmp[idOrigin])) {
                        vm.valueFilterTmp[idOrigin] = '';
                    }
                }

                for (var i in vm.filters) {
                    if (vm.filters[i].id == idOrigin) {
                        vm.filters[i].min_date = vm.valueFilterTmp[date_between[0].id];
                    }
                }
            }
        };

        function validateDate() {
            var date = vm.filters.filter(function (row) {
                return row.type == 'DATE';
            });

            if (date.length == 0) {
                return true;
            }

            for (var i in date) {

                if ((!vm.valueFilterTmp[date[i].id] || vm.valueFilterTmp[date[i].id] == "") && (vm.valueFilterTmp[date[i].relation] && vm.valueFilterTmp[date[i].relation] != "")) {
                    return false;
                }

                if ((!vm.valueFilterTmp[date[i].relation] || vm.valueFilterTmp[date[i].relation] == "") && (vm.valueFilterTmp[date[i].id] && vm.valueFilterTmp[date[i].id] != "")) {
                    return false;
                }

            }



            return true;
        }

        //FILTROS
        if ($state.current) {
            switch ($state.current.name) {
                

                

            }
        }
        //vm.getListsFilters();
        vm.init();

    }
})();

(function () {
    'use strict';

    angular
        .module('app.seleccion_admin')
        .controller('RequestReportServiceController', RequestReportServiceController);

    /** @ngInject */
    function RequestReportServiceController($mdDialog, $document, $state, $scope, $filter, $window, $mdDateLocale, api, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, paginationService, analystConstant, $compile) {
        var vm = this;
        vm.loading = true;
        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Reportes'],
            title: "",
        };

        vm.valueFilter = {};
        vm.valueFilterTmp = {};
        vm.prueba = {};
        vm.searchFilter = {};
        vm.headersColumn = {};
        vm.filters = [];
        vm.values = {};

        vm.limit = analystConstant.LIMITROW;
        vm.pager = {};

        vm.configReportStyle = {};
        vm.configReportClass = {};

        $mdDateLocale.formatDate = function (date) {
            return date ? moment(date).format('DD/MMMM/YYYY') : '';
        };

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            responsive: true,
            autoWidth: true,
            sPagingationType: "full_numbers",
            iDisplayLength: 20,
            deferRender: true,
            sorting: false,
            searching: false
        };

        $scope.$watch('vm.valueFilterTmp', function (current) {
            if (vm.filters.length == 0) { return; }
            changeDependency(current);
            changeDate(current);
        }, true);

        vm.configFilter = {
            page: 1,
            limit: vm.limit,
            formatolist: 'json',
            formatodownload: 'excel',
            type_report: 'license',
            clase: 'Ikano'
        }


        vm.init = function () {
            vm.filtrosinit = {
                "report_name_id": vm.report_name,
                'page': vm.configFilter.page,
                'per_page': vm.configFilter.limit,
                "formato": vm.configFilter.formatolist,
                "type_report": vm.configFilter.type_report,
                "clase": vm.configFilter.clase,
            }
            getReport(vm.filtrosinit);

        }

        vm.filterByCriteria = function () {
            vm.page = 1;
            vm.valueFilter = angular.copy(vm.valueFilterTmp);
            if (validateDate()) {
                var filter = serializeFilter(vm.configFilter.formatolist);
                console.log(filter);
                getReport(filter);
            } else {
                IkanoFactory.showAlert("Error", "Hay campos fechas sin valor, por favor validar.");
            }

        };

        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.total_results, page, vm.limit);
            if (!noConsult) {
                var filter = serializeFilter(vm.configFilter.formatolist);
                getReport(filter);
            }
            setTimeout(function () {
                createPagination();
            }, 1000);
        }

        vm.resetFilter = function () {
            vm.valueFilter = {};
            vm.valueFilterTmp = {};
            vm.page = 1;
            var filter = serializeFilter(vm.configFilter.formatolist);
            getReport(filter);
        };

        vm.downloadExcel = function () {
            vm.valueFilter = angular.copy(vm.valueFilterTmp);
            var filter = serializeFilter(vm.configFilter.formatodownload);
            AdminService.getServiceReportLevelService(filter, {}, function (response) {
                $window.open(api.general.getUrlBase() + '/' + response.data.report_filename, "_blank");
            },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                },
                false,
                {
                    old: false
                });
        };

        vm.search = function (arr, filter) {
            var arrReturn = [];
            if (filter && filter.length >= 3) {
                return $filter('filter')(arr, filter);
            } else {
                for (var i = 0; i < vm.limit; i++) {
                    var pushIndex = i + length;
                    arrReturn.push(arr[pushIndex]);
                }
            }
            return arrReturn;
        }

        vm.removeChip = function (chip, model) {
            var values = model;
            for (var i in values) {
                if (values[i] == chip.id) {
                    values.splice(i, 1);
                    break;
                }
            }
            model = values;
        }

        vm.validationChip = function (data, chip, model) {
            console.log(data, chip, model);
            if (!model) {
                model = [];
            }
            if (!angular.isObject(chip)) {
                data.pop();
            } else {
                model.push(chip.id);
            }
        }

        function getReport(filtros) {
            AdminService.getServiceReportLevelService(filtros, {},
                function (response) {

                    if (vm.filters.length == 0) {
                        vm.filters = serializeFilters(response.data.filters);
                    }
                    vm.pageInfo.title = response.data.report_name;
                    vm.headersColumn = response.data.data_headers;
                    vm.reportData = response.data.data_results;
                    vm.reportConfig = response.data.report_config;
                    serializeResult(response.data.data_results, response.data.report_config);
                    if (!response.data.report_config || !response.data.report_config.nopagination) {
                        modelPagination(response.data.total_results);
                    }

                    vm.loading = false;
                    $("input.md-datepicker-input").prop('readonly', true);
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                },
                false,
                {
                    old: false
                }
            );
        };

        function serializeResult(data, config) {
            angular.forEach(config, function (value, key) {
                for (var d in data) {
                    var element = data[d];
                    if (element[key]) {
                        if (value.class) {
                            applyClass(d, element, key, value, config);
                        }
                        if (value.style) {
                            if (!vm.configReportStyle[key]) {
                                vm.configReportStyle[key] = {};
                            }
                            var style = value.style.replace("value", element[key]) + "";
                            vm.configReportStyle[key][d] = JSON.parse(style);
                        }
                    } else {
                        continue;
                    }
                }
            });
        }

        function applyClass(d, data, key, value, config) {
            if (!vm.configReportClass[key]) {
                vm.configReportClass[key] = {};
            }
            if (value.apply_class) {
                vm.configReportClass[key][d] = value.apply_class.indexOf(data[key]) !== -1 ? value.class : '';
                return;
            }

            vm.configReportClass[key][d] = value.class;
        }

        function modelPagination(total_results) {
            vm.total_results = total_results;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        function serializeFilter(type, page) {

            var filter = {
                "report_name_id": vm.report_name,
                "formato": type,
                "type_report": vm.configFilter.type_report,
                "clase": vm.configFilter.clase,
                'per_page': vm.configFilter.limit,
                'page': vm.page
            }
            console.log(vm.valueFilter);
            for (var i in vm.filters) {
                var filternow = vm.filters[i].id;
                //filter["filter_" + filternow] = '';
                if (vm.valueFilter[filternow]) {
                    filter["filter_" + filternow] = vm.valueFilter[filternow];
                } else {
                    continue;
                }

                if (vm.filters[i].type == 'DATE' || vm.filters[i].type == 'DATE_BETWEEN' && vm.valueFilter[filternow]) {
                    filter["filter_" + filternow] = moment(vm.valueFilter[filternow]).format('YYYY-MM-DD');
                    continue;
                }

                if (typeof vm.valueFilter[filternow] == 'object') {
                    if (vm.valueFilter[filternow] instanceof Array) {
                        filter["filter_" + filternow] = vm.valueFilter[filternow];
                    } else {
                        filter["filter_" + filternow] = vm.valueFilter[filternow].id;
                    }

                }


            }
            console.log(filter);
            return filter;
        }

        function serializeFilters(filter) {
            return filter.map(function (element) {
                element.show = getDependencyShow(element);
                vm.valueFilterTmp[element.id] = setValueFilter(element);

                if (element.onchange) {
                    setOnchange(element);
                }
                return element;
            });

        }

        function setOnchange(filter) {
            $scope.$watch("vm.valueFilterTmp['" + filter.id + "']", function (newValue, oldValue) {
                if (newValue) {
                    sendOnchange(filter);
                }
            }, true);
        }

        function sendOnchange(filter) {
            var onchange = filter.onchange;
            var data = {
                function: onchange.function,
                values: {}
            };

            for (var i in onchange.fields) {
                var valueFiels = vm.valueFilterTmp[onchange.fields[i]];
                if (valueFiels) {
                    data.values[onchange.fields[i]] = valueFiels;
                }
            }

            AdminService.get_onchange_data(data, function (response) {
                serializeListas(response.data.data.lista);
            }, function (reject) {
                console.error(reject);
            });

        }

        function serializeListas(data) {
            for (var i in vm.filters) {
                var filter = vm.filters[i];
                if (data[filter.id]) {
                    var options = [];
                    if (data[filter.id] instanceof Array) {
                        options = data[filter.id];
                    } else {
                        for (var j in data[filter.id]) {
                            options.push({ id: j, name: data[filter.id][j] });
                        }
                    }
                    vm.filters[i].options = options;

                }
            }
        }

        function getDependencyShow(filter) {
            return filter.dependency ? false : true;
        }

        function setValueFilter(filter) {
            if (filter.type == "AUTOCOMPLETECHIP") {
                return [];
            }
            if (!filter.value) {
                return null;
            }
            if (filter.type == "DATE_BETWEEN" || filter.type == "DATE") {
                return moment(filter.value).toDate();
            }

        }

        function createPagination() {
            var elemt = $('.right');
            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}} de {{vm.total_results}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        function changeDependency(current) {
            var dependency = vm.filters.filter(function (row) {
                return row.dependency;
            });
            if (dependency.length == 0) {
                return;
            }
            for (var i in vm.filters) {
                for (var j in dependency) {
                    if (vm.valueFilterTmp[dependency[j].dependency] && vm.filters[i].id == dependency[j].id) {
                        vm.filters[i].show = true;
                        break;
                    } else if (!vm.valueFilterTmp[dependency[j].dependency] && vm.filters[i].id == dependency[j].id) {
                        vm.filters[i].show = false;
                        break;
                    }
                }
            }
        }

        function changeDate(current) {
            var date = vm.filters.filter(function (row) {
                return row.type == 'DATE';
            });

            if (date.length == 0) {
                return;
            }


            for (var i in date) {
                getDateBetween(date[i].relation, date[i].id);
            }

        }

        function getDateBetween(id, idOrigin) {
            var date_between = vm.filters.filter(function (row) {
                return (row.type == 'DATE_BETWEEN' && row.id == id);
            });

            if (date_between.length == 0) {
                return;
            }

            if (vm.valueFilterTmp[date_between[0].id]) {

                if (vm.valueFilterTmp[idOrigin]) {
                    if (moment(vm.valueFilterTmp[date_between[0].id]) > moment(vm.valueFilterTmp[idOrigin])) {
                        vm.valueFilterTmp[idOrigin] = '';
                    }
                }

                for (var i in vm.filters) {
                    if (vm.filters[i].id == idOrigin) {
                        vm.filters[i].min_date = vm.valueFilterTmp[date_between[0].id];
                    }
                }
            }
        };

        function validateDate() {
            var date = vm.filters.filter(function (row) {
                return row.type == 'DATE';
            });

            if (date.length == 0) {
                return true;
            }

            for (var i in date) {
                if ((!vm.valueFilterTmp[date[i].id] || vm.valueFilterTmp[date[i].id] == "") && (vm.valueFilterTmp[date[i].relation] && vm.valueFilterTmp[date[i].relation] != "")) {
                    return false;
                }
                if ((!vm.valueFilterTmp[date[i].relation] || vm.valueFilterTmp[date[i].relation] == "") && (vm.valueFilterTmp[date[i].id] && vm.valueFilterTmp[date[i].id] != "")) {
                    return false;
                }
            }

            return true;
        }

        //FILTROS
        if ($state.current) {
            switch ($state.current.name) {
                
                case 'app.seleccion_reporte_base_requisiciones':
                    vm.report_name = 'reporte_base_requisiciones'
                    break;
                case 'app.seleccion_reporte_base_ingresos':
                    vm.report_name = 'reporte_base_ingresos'
                    break;
                
                case 'app.seleccion_reporte_acuerdo_servicio':
                    vm.report_name = 'reporte_acuerdo_servicio';
                    break;
                case 'app.seleccion_reporte_estadistico':
                    vm.report_name = 'reporte_estadistico';
                    break;
                case 'app.seleccion_reporte_suspensiones':
                    vm.report_name = 'reporte_suspensiones';
                    break;
                case 'app.seleccion_reporte_hoja_vidas':
                    vm.report_name = 'reporte_hoja_vidas';
                    break;
                case 'app.seleccion_reporte_hoja_vidas_detallado':
                    vm.report_name = 'reporte_hoja_vidas_detallado';
                    break;
                case 'app.seleccion_reporte_vacantes_activas':
                    vm.report_name = 'reporte_vacantes_activas';
                    break;
                case 'app.seleccion_reporte_demografico':
                    vm.report_name = 'reporte_demografico';
                    break;
                case 'app.seleccion_reporte_semilleros':
                    vm.report_name = 'reporte_semilleros';
                    break;
                case 'app.seleccion_reporte_procesos_totales':
                    vm.report_name = 'reporte_procesos_totales';
                    break;
                case 'app.seleccion_reporte_proceso_detalle':
                    vm.report_name = 'reporte_proceso_detalle';
                    break;
                case 'app.seleccion_reporte_requisiciones_admin':
                    vm.report_name = 'reporte_requisiciones';
                    break;
                case 'app.seleccion_reporte_nivel_servicio':
                    vm.report_name = 'reporte_nivel_servicio';
                    break;
                case 'app.seleccion_reporte_pruebas':
                    vm.report_name = 'reporte_pruebas';
                    break;
            }
        }
        //vm.getListsFilters();
        vm.init();

    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('RequestAdminController', RequestAdminController);

	/** @ngInject */
	function RequestAdminController($mdDialog, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder) {
        var vm = this;
        vm.loading = true;
        vm.headers = [];

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['Reportes'],
			title: "Requisiciones",
        };

        vm.reportData = [];
        vm.allReportData = [];

        vm.filterType = null;
        vm.filters = [
            {id: 1, name: "Fecha ingreso"},
            {id: 2, name: "fecha aprobacion compensacion"},
        ]

        var locale = IkanoFactory.getDateLocaleFormat('es');
        if (locale != false) {
          $mdDateLocale.months = locale.months;
          $mdDateLocale.shortMonths = locale.shortMonths;
          $mdDateLocale.days = locale.days;
          $mdDateLocale.shortDays = locale.shortDays;
        }

        $mdDateLocale.formatDate = function (date) {
            return date ? moment(date).format('DD/MMMM/YYYY') : '';
        };

        jQuery.extend(jQuery.fn.dataTableExt.oSort, {
            "date-nl-pre": function (date) {
                return moment(date, 'DD/MMMM/YYYY');
            },

            "date-nl-asc": function (a, b) {
                return (a.isBefore(b) ? -1 : (a.isAfter(b) ? 1 : 0));
            },

            "date-nl-desc": function (a, b) {
                return (a.isBefore(b) ? 1 : (a.isAfter(b) ? -1 : 0));
            }
        });

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(3).withOption('type', 'date-nl'),
            DTColumnDefBuilder.newColumnDef(15).withOption('type', 'date-nl')
        ];

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			language: IkanoFactory.getLanguajeDataTable(),
            responsive: true,
            autoWidth : true,
            sPagingationType: "full_numbers",
            iDisplayLength: 20,
            deferRender: true,
            searching: false
        };

        vm.getReport = function() {
            AdminService.getServiceReportAdmin({}, {}, 
                function(response) {
                    if (response.data.data.requisiciones) {
                        vm.allReportData = response.data.data.requisiciones;
                        vm.reportData = response.data.data.requisiciones;
                    }

                    vm.loading = false;
                },
                function(response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );    
        };

        vm.downloadExcel = function() {
            var f1 = document.querySelectorAll(".filtro_fechas input")[0].value;
            var f2 = document.querySelectorAll(".filtro_fechas input")[1].value;
            var tipo_sel = document.querySelectorAll("#tipo_sel")[0].innerText;

            if(f1 != '') {
                f1 = moment(f1).format('YYYY-MM-DD')
            }
            if(f2 != '') {
                f2 = moment(f2).format('YYYY-MM-DD')
            }
            if(tipo_sel != '') {
                if(tipo_sel.substr(0,13) == 'Fecha ingreso') {
                    tipo_sel = 'fi';
                }
                else {
                    tipo_sel = 'fac';
                }
            }

            var data_params = {
                type: 'excel',
                filtros: {
                    text: document.querySelector('.dataTables_filter input[type="search"]').value,
                    tipo_sel: tipo_sel,
                    fecha_1: f1,
                    fecha_2: f2
                }
            };
            //console.log(data_params);
            AdminService.getServiceReportAdmin(data_params, {responseType: 'arraybuffer'}, function(response) {
                IkanoFactory.downloadExcel(response.data);
            });
        }

        vm.filterByDate = function() {
            if (vm.filterType && vm.startDate && vm.endDate) {
                vm.reportData = [];
                for (var index = 0; index < vm.allReportData.length; index++) {
                    var element = vm.allReportData[index];
                    var criteria = null;
                    if (vm.filterType == 1) {
                        criteria = element.seleccionado_fecha_ingreso;
                    } else if (vm.filterType == 2) {
                        criteria = element.fecha_compensacion;
                    }

                    if (criteria) {
                        var date = moment(criteria);
                        var sd = moment(vm.startDate);
                        var ed = moment(vm.endDate);
                        if (date.isBetween(sd.subtract(1, "days"), ed.add(1, "days"))) {
                            vm.reportData.push(element);
                        }
                    }
                }
            }
        }

        vm.resetFilter = function() {
            vm.reportData = vm.allReportData;
            vm.filterType = null;
            vm.startDate = null; 
            vm.endDate = null;
        }

        vm.getReport();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('UploadProfilePictureController', UploadProfilePictureController);

    /** @ngInject */
    function UploadProfilePictureController($mdDialog, $document, event, item, CandidateService, IkanoFactory, AuthService) {
        var vm = this;
        vm.title = "Cambiar imagen de perfil";
        vm.parts = vm.title.split(" ");
        vm.saveButtonTitle = "Guardar";
        vm.saving = false;
        vm.item = item;

        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage   = null;
        vm.bounds = {};
        vm.bounds.left = 0;
        vm.bounds.right = 0;
        vm.bounds.top = 0;
        vm.bounds.bottom = 0;

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

		vm.uploadImage = function() {
            vm.saveButtonTitle = "Guardando...";
            vm.saving = true;

            var imageUrl = vm.cropper.croppedImage;
            var block = imageUrl.split(";");
            var contentType = block[0].split(":")[1];
            var realData = block[1].split(",")[1];

            var blob = vm.b64toBlob(realData, contentType);
    
			var fd = new FormData();
			fd.append('img', blob, "profile-picture.png");

			var config = {
				transformRequest: angular.identity,
				headers: {'Content-Type': undefined}
			};

			CandidateService.saveResumePhoto(fd, config, 
				function(response){
					if (response.data.result.status) {
                        var url = response.data.result.msg + "?v=" + Math.floor((Math.random() * 100000) + 1)
						vm.item.data.foto = url;
                        AuthService.refreshProfilePicture(url);
					}
                    vm.closeDialog();
                    vm.saving = false;
				},
				function(response){
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo");
                    vm.saving = false;
				}
			);
		};


        vm.b64toBlob = function(b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        };

        vm.getImageExtension = function(mime) {
            if (mime == "") {

            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('EditController', EditController);

    /** @ngInject */
    function EditController($mdDialog, $document, event, attachments, fields, lists, indicators, validations, CandidateService, IkanoFactory, ValidationService,structure,$scope) {
        var vm = this;
        vm.title = "";
        vm.fields = fields;
        vm.fields.item = (fields.item ? fields.item : fields.data);
        vm.lists = lists;
        vm.attachments = attachments;
        vm.indicators = indicators;
        vm.validations = validations;
        vm.data = vm.fields.item;
        vm.values = vm.data;
        vm.errors = {};
        vm.saving = false;
        vm.structure = structure;
        vm.saveButtonTitle = "Guardar";
        if (vm.fields.model == 'hv_padre') {
            if (vm.fields.name == 'madre') {
                vm.fields.data.madre_genero = 2;
                vm.fields.data.madre_parentesco = 1;
            } else {
                vm.fields.data.padre_genero = 1;
                vm.fields.data.padre_parentesco = 1;
            }

        }
        console.log(vm);

        vm.dataReturn = {};

        
		ValidationService.watchFunctions($scope, vm, {fields:'structure',aliaskey:'data'});
        vm.closeDialog = function () {
            $mdDialog.hide();
        };

        vm.onchange_structureFields = function(strcuture_fields){
            for(var c in vm.fields.campos){
                var strcuture_fields_key = vm.fields.campos[c].field;
                if(strcuture_fields[strcuture_fields_key]){
                    strcuture_fields[strcuture_fields_key].field = vm.fields.campos[c].field;
                    vm.fields.campos[c] = strcuture_fields[strcuture_fields_key];

                }
            }
            vm.dataReturn.structureFields = strcuture_fields; 
        }

        vm.onchange_data = function(data){
            if(vm.fields.name == "personales"){
                delete(data.rangos_salario_id);
            }
            vm.dataReturn.data = data;
        }

        vm.onchange_lists = function(lista){
            $.each(vm.lists,function(key,value){
                if(lista[key]){
                    vm.lists[key] = lista[key];
                }
            });
            vm.dataReturn.lista = lista;
        }

        vm.getOptions = function (key) {
            return vm.lists[key];
        };

        vm.save = function () {
            vm.saving = true;
            vm.saveButtonTitle = "Guardando...";

            vm.data._id = vm.fields.item._id;

            vm.errors = IkanoFactory.validateFields(vm.fields.campos, vm.data);
            if (!angular.equals(vm.errors, {})) {
                vm.saving = false;
                vm.saveButtonTitle = "Guardar";
            } else {
                var data = {
                    bloque: vm.fields.name,
                    data: vm.data
                }

                CandidateService.saveResumeBlock(data, {}, function (response) {
                    if (response.data.result.status) {

                        if (localStorage.getItem('FormData')) {
                            saveFile(response.data);
                        }

                        if (response.data.result.data && response.data.result.data.indicadores) {
                            vm.fields.indicadores = response.data.result.data.indicadores;
                        }

                        if (response.data.result.data && response.data.result.data.completo) {
                            vm.fields.completo = response.data.result.data.completo;
                        }

                        if (response.data.result.data && response.data.result.data.porcentaje) {
                            vm.indicators.percentage = response.data.result.data.porcentaje;
                        }

                        if (response.data.result.data && response.data.result.data.inconsistencias) {
                            var array = $.map(response.data.result.data.inconsistencias, function (value, index) {
                                vm.validations[index] = value;
                            });
                        }

                        if (response.data.result.data && response.data.result.data.data) {
                            vm.data = response.data.result.data.data;
                        }

                        if (vm.fields.data.length) {
                            for (var index = 0; index < vm.fields.data.length; index++) {
                                var element = vm.fields.data[index];
                                if (element._id == response.data.result.id) {
                                    vm.refreshData(vm.fields.data[index]);
                                    break;
                                }
                            }
                        } else {
                            vm.refreshData(vm.fields.data);
                        }

                        response.data.objExtra = vm.dataReturn;

                        $mdDialog.hide(response.data);
                        var message = response.data.result.msg ? response.data.result.msg : "El bloque " + vm.fields.titulo.join(" ") + " ha sido actualizado exitosamente";
                        IkanoFactory.showToast({ class: "success", message: message, showClose: true });
                        //IkanoFactory.showAlert("", "El bloque " + vm.fields.titulo.join(" ") + " ha sido actualizado exitosamente");
                    } else {
                        vm.errors = IkanoFactory.getFormErrors(response.data.result.errors);
                        var message = response.data.result.msg ? response.data.result.msg : "Ocurrio un error guardando la información, por favor intentar después.";
                        IkanoFactory.showToast({ class: "error", message: message, showClose: true });
                    }

                    vm.saving = false;
                    vm.saveButtonTitle = "Guardar";
                });
            }
        };

        vm.refreshData = function (fields) {
            var array = $.map(vm.data, function (value, index) {
                fields[index] = value;
            });
        };

        vm.removeAttachment = function (mod, attachment) {
            vm.saving = true;
            vm.saveButtonTitle = "Removiendo...";

            var attachments = vm.getAttachments(mod);

            CandidateService.removeFile(attachment.id, {}, {}, function (response) {
                if (response.data.status) {
                    var index = attachments.indexOf(attachment);
                    if (index > -1) {
                        attachments.splice(index, 1);
                    }
                    vm.saving = false;
                    vm.saveButtonTitle = "Guardar";
                }

            });
        };

        vm.getAttachments = function (mod) {
            if (vm.attachments[mod][vm.fields.item._id]) {
                return vm.attachments[mod][vm.fields.item._id];
            } else if (vm.attachments[mod] && vm.attachments[mod].length) {
                return vm.attachments[mod];
            }

            return [];
        };

        function saveFile(dataSave) {
            var localDatas = JSON.parse(localStorage.getItem('FormData'));

            for (var i in localDatas) {
                var localData = localDatas[i];

                var fd = new FormData();
                fd.append("field", localData.formData.field);
                fd.append("model", localData.formData.model);
                fd.append("id", dataSave.result.id);
                fd.append("file_id", localData.formData.file.id);
                fd.append("file_name", localData.formData.file.name);

                var config = {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                };
                save_file(localData, dataSave);
            }
        }

        function save_file(fd,config,localData, dataSave) {
            if(!localData || !dataSave){
                return;
            }
            CandidateService.saveFile(fd, config,
                function (response) {
                    if (response.data.result.status) {
                        localStorage.removeItem('FormData');
                        if (vm.attachments[localData.fieldModule] && vm.attachments[localData.fieldModule][dataSave.result.id]) {
                            vm.attachments[localData.fieldModule][dataSave.result.id].push(response.data.result.data);
                        } else if (vm.attachments[localData.fieldModule] && vm.attachments[localData.fieldModule] instanceof Array) {
                            vm.attachments[localData.fieldModule].push(response.data.result.data);
                        } else if (vm.attachments[localData.fieldModule] && vm.attachments[localData.fieldModule] instanceof Object) {
                            vm.attachments[localData.fieldModule][dataSave.result.id] = [];
                            vm.attachments[localData.fieldModule][dataSave.result.id].push(response.data.result.data);
                        } else {
                            vm.attachments[localData.fieldModule] = {};
                            vm.attachments[localData.fieldModule][dataSave.result.id] = [];
                            vm.attachments[localData.fieldModule][dataSave.result.id].push(response.data.result.data);
                        }

                        if (vm.attachments[localData.field]) {
                            vm.attachments[localData.field].push(response.data.data);
                        }

                    } else {
                        vm.errors[localData.field] = "Formato de archivo no soportado";
                    }
                },
                function (response) {
                    vm.errors[localData.field] = "Ha ocurrido un error";
                }
            );
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('DeleteController', DeleteController);

    /** @ngInject */
    function DeleteController($mdDialog, $document, event, block, item, indicators, validations, CandidateService, IkanoFactory) {
        var vm = this;
        vm.title = "";
        vm.block = block;
        vm.item = item;
        vm.indicators = indicators;
        vm.validations = validations;
        vm.itemName = (item.titulo ? item.titulo : "");

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.delete = function() {
            var data = {
                bloque: vm.block.name,
                data: {
                    id: vm.item._id
                }
            }

            CandidateService.deleteBlock(data, {}, function(response){
                if (response.data.result.status) {

                    if (response.data.result && response.data.result.porcentaje) {
                        vm.indicators.percentage = response.data.result.porcentaje;
                    }

                    if (response.data.result && response.data.result.indicadores){
                        vm.block.indicadores = response.data.result.indicadores;
                    }

                    if (response.data.result && response.data.result.inconsistencias) {
                        var array = $.map(response.data.result.inconsistencias, function(value, index) {
                            vm.validations[index] = value;
                        });
                    }

                    var index = vm.block.data.indexOf(vm.item);
                    if (index > -1) {
                        vm.block.data.splice(index, 1);
                    }

                    vm.closeDialog();
                    var message = response.data.result.msg ? response.data.result.msg : "El bloque " + vm.fields.titulo.join(" ") + " ha sido actualizado exitosamente";
                        IkanoFactory.showToast({ class: "success", message: message, showClose: true });
                    //IkanoFactory.showAlert("", response.data.result.msg);
                    IkanoFactory.showAlert("", "Se eliminado el elemento " + vm.itemName + " exitosamente");
                }
            });
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('AddController', AddController);

    /** @ngInject */
    function AddController($mdDialog, $document, event, fields, lists, attachments, indicators, validations, CandidateService, IkanoFactory) {
        var vm = this;
        vm.title = "";
        vm.fields = fields;
        vm.fields.block = [];
        vm.lists = lists;
        vm.indicators = indicators;
        vm.validations = validations;
        vm.attachments = attachments;
        vm.data = {};
        vm.errors = {};
        vm.saving = false;
        vm.saveButtonTitle = "Guardar";
        if (vm.fields.model == 'hv_padre') {
            if (vm.fields.name == 'madre') {
                vm.fields.block['madre_genero'] = 2;
                vm.fields.block['madre_parentesco'] = 1;
            } else {
                vm.fields.block['padre_genero'] = 1;
                vm.fields.block['padre_parentesco'] = 1;
            }
        }

        for(var i in vm.fields.campos){
            var campo = vm.fields.campos[i];
            if(typeof vm.data[campo.field] == "undefined"){
                vm.data[campo.field] = '';
            }
        }

        localStorage.removeItem('FormData');

        vm.closeDialog = function () {
            $mdDialog.hide();
        };

        vm.getOptions = function (key) {
            return vm.lists[key];
        };

        vm.save = function () {
            vm.saving = true;
            vm.saveButtonTitle = "Guardando...";

            vm.errors = IkanoFactory.validateFields(vm.fields.campos, vm.data);
            if (!angular.equals(vm.errors, {})) {
                vm.saving = false;
                vm.saveButtonTitle = "Guardar";
            } else {
                vm.data._id = null;

                var data = {
                    bloque: vm.fields.name,
                    data: vm.data
                }

                CandidateService.saveResumeBlock(data, {}, function (response) {
                    if (response.data.result.status) {

                        if (localStorage.getItem('FormData')) {
                            saveFile(response.data);
                        }

                        if (response.data.result.data && response.data.result.data.indicadores) {
                            vm.fields.indicadores = response.data.result.data.indicadores;
                        }

                        if (response.data.result.data && response.data.result.data.completo) {
                            vm.fields.completo = response.data.result.data.completo;
                        }

                        if (response.data.result.data && response.data.result.data.porcentaje) {
                            vm.indicators.percentage = response.data.result.data.porcentaje;
                        }

                        if (response.data.result.data && response.data.result.data.inconsistencias) {
                            var array = $.map(response.data.result.data.inconsistencias, function (value, index) {
                                vm.validations[index] = value;
                            });
                        }

                        vm.data._id = response.data.result.id;
                        if (vm.fields.data instanceof Array) {
                            vm.fields.data.push(vm.data);
                        } else {
                            vm.fields.data = vm.data;
                        }

                        vm.closeDialog();
                        var message = response.data.result.msg ? response.data.result.msg : "El bloque " + vm.fields.titulo.join(" ") + " ha sido actualizado exitosamente";
                        IkanoFactory.showToast({ class: "success", message: message, showClose: true });
                        //IkanoFactory.showAlert("", "El bloque " + vm.fields.titulo.join(" ") + " ha sido actualizado exitosamente");
                    } else {
                        vm.errors = IkanoFactory.getFormErrors(response.data.result.errors);
                    }

                    vm.saving = false;
                    vm.saveButtonTitle = "Guardar";
                });
            }
        };

        function saveFile(dataSave) {
            var localDatas = JSON.parse(localStorage.getItem('FormData'));

            for (var i in localDatas) {
                var localData = localDatas[i];

                var fd = new FormData();
                fd.append("field", localData.formData.field);
                fd.append("model", localData.formData.model);
                fd.append("id", dataSave.result.id);
                fd.append("file_id", localData.formData.file.id);
                fd.append("file_name", localData.formData.file.name);

                var config = {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                };
                save_file(fd,config,localData, dataSave);
            }
        }

        function save_file(fd,config,localData, dataSave) {
            if(!localData || !dataSave){
                return;
            }
            CandidateService.saveFile(fd, config,
                function (response) {
                    if (response.data.result.status) {
                        localStorage.removeItem('FormData');
                        if (vm.attachments[localData.fieldModule] && vm.attachments[localData.fieldModule][dataSave.result.id]) {
                            vm.attachments[localData.fieldModule][dataSave.result.id].push(response.data.result.data);
                        } else if (vm.attachments[localData.fieldModule] && vm.attachments[localData.fieldModule] instanceof Array) {
                            vm.attachments[localData.fieldModule].push(response.data.result.data);
                        } else if (vm.attachments[localData.fieldModule] && vm.attachments[localData.fieldModule] instanceof Object) {
                            vm.attachments[localData.fieldModule][dataSave.result.id] = [];
                            vm.attachments[localData.fieldModule][dataSave.result.id].push(response.data.result.data);
                        } else {
                            vm.attachments[localData.fieldModule] = {};
                            vm.attachments[localData.fieldModule][dataSave.result.id] = [];
                            vm.attachments[localData.fieldModule][dataSave.result.id].push(response.data.result.data);
                        }

                        if (vm.attachments[localData.field]) {
                            vm.attachments[localData.field].push(response.data.data);
                        }

                    } else {
                        vm.errors[localData.field] = "Formato de archivo no soportado";
                    }
                },
                function (response) {
                    vm.errors[localData.field] = "Ha ocurrido un error";
                }
            );
        }

        console.log(vm);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('AddExperienceController', AddExperienceController);

    /** @ngInject */
    function AddExperienceController($mdDialog, $document, event, fields, lists, indicators, validations, CandidateService, IkanoFactory) {
        
        var vm = this;
        vm.ready = false;
        vm.title = "";
        vm.fields = fields;
        vm.fields.item = [];
        vm.lists = lists;
        vm.indicators = indicators;
        vm.validations = validations;
        vm.data = {};
        vm.offerType = null;
        vm.company = null;
        vm.showCompaniesSelector = false;
        vm.errors = {};
        vm.saving = false;
        vm.saveButtonTitle = "Guardar";
        


        vm.validate = function() {
            if (vm.offerType == 0) {
                vm.ready = true;
            } else {
                vm.showCompaniesSelector = true;
            }
        };

        vm.serializeCompanies = function(companies){
            var arrCompaniesReturn = [];
            var arrAuxReturn = [];
            for(var i in companies){
                if(arrAuxReturn.indexOf(companies[i].name) == -1 ){
                    arrAuxReturn.push(companies[i].name);
                    arrCompaniesReturn.push(companies[i]);
                }
            }
            return arrCompaniesReturn;
        }

        vm.companies = vm.serializeCompanies(angular.copy(vm.fields.companies));

        if (!vm.fields.data.length) {
            vm.offerType = 0;
            vm.validate();
        };
        
        vm.setCompanyData = function() {
            for (var index = 0; index < vm.fields.data.length; index++) {
                var element = vm.fields.data[index];
                if (element._id == vm.company.idBlock) {
                    vm.fields.item = {
                        empresa: element.empresa,
                        industria_id: element.industria_id,
                        industria_name: element.industria_name,
                        telefono: element.telefono,
                    };
                    vm.ready = true;
                    break;
                }
            }
        };

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.getOptions = function(key) {
            return vm.lists[key];
        };

        vm.save = function() {
            vm.saving = true;
            vm.saveButtonTitle = "Guardando...";

            vm.errors = IkanoFactory.validateFields(vm.fields.campos, vm.data);

            if (!angular.equals(vm.errors, {})) {
                vm.saving = false;
                vm.saveButtonTitle = "Guardar";
            } else {

                vm.data._id = null;

                var data = {
                    bloque: vm.fields.name,
                    data: vm.data
                }

                CandidateService.saveResumeBlock(data, {}, function(response){
                    vm.errors = {};
                    if (response.data.result.status) {
                        if (response.data.result.data && response.data.result.data.indicadores) {
                            vm.fields.indicadores = response.data.result.data.indicadores;
                        }
                        
                        if (response.data.result.data && response.data.result.data.completo) {
                            vm.fields.completo = response.data.result.data.completo;
                        }

                        if (response.data.result.data && response.data.result.data.porcentaje) {
                            vm.indicators.percentage = response.data.result.data.porcentaje;
                        }

                        if (response.data.result.data && response.data.result.data.inconsistencias) {
                            var array = $.map(response.data.result.data.inconsistencias, function(value, index) {
                                vm.validations[index] = value;
                            });
                        }

                        vm.data._id = response.data.result.id;
                        //console.log(response);
                        if (vm.fields.data instanceof Array) {
                            vm.fields.data.push(vm.data);
                        } else {
                            vm.fields.data = vm.data;
                        }

                        //vm.fields.data = response.data.result.data.data;

                        vm.closeDialog();
                        var message = response.data.result.msg ? response.data.result.msg : "El bloque " + vm.fields.titulo.join(" ") + " ha sido actualizado exitosamente";
                        IkanoFactory.showToast({ class: "success", message: message, showClose: true });
                        //IkanoFactory.showAlert("", "El bloque " + vm.fields.titulo.join(" ") + " ha sido actualizado exitosamente");
                    } else {
                        vm.errors = IkanoFactory.getFormErrors(response.data.result.errors);
                    }

                    vm.saving = false;
                    vm.saveButtonTitle = "Guardar";
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('ChangePasswordController', ChangePasswordController);

    /** @ngInject */
    function ChangePasswordController($mdDialog, $document, CandidateService, IkanoFactory) {
        var vm = this;
        vm.message = null;
        vm.title = "Cambiar contraseña";
        vm.password_anterior_type = "password";
        vm.password_anterior_icon = "icon-eye";

        vm.password_type = "password";
        vm.password_icon = "icon-eye";

        vm.password_confirm_type = "password";
        vm.password_confirm_icon = "icon-eye";
        vm.closeDialog = function () {
            $mdDialog.hide();
        };

        vm.changePassword = function () {
            vm.errors = {};
            vm.message = null;
            CandidateService.changePassword(vm.form, {}, function (response) {
                if (!response.data.status) {
                    if (response.data.errors) {
                        vm.errors = IkanoFactory.getFormErrors(response.data.errors);
                        if (vm.errors['password'] && vm.errors['password'] == "El valor de este campo debe ser diferente al valor del campo anterior") {
                            vm.errors['password'] = "La nueva contraseña debe ser diferente a las contraseñas utilizadas.";
                        }
                        if(vm.errors['password_confirm'] && vm.errors['password_confirm'] == "El valor de este campo debe ser igual al valor del campo anterior"){
                            vm.errors['password_confirm'] = "Las contraseñas no coinciden, por favor validar.";
                        }

                    } else {
                        vm.message = response.data.msg;
                    }
                } else {
                    IkanoFactory.showToast({ class: "success", message: response.data.msg, showClose: true });
                    vm.closeDialog();
                }
            });
        };
        
        vm.showPassword = function(password) {
            if (password == "password_anterior_type") {
                if (vm.password_anterior_type == "text") {
                    vm.password_anterior_type = "password";
                    vm.password_anterior_icon = "icon-eye";
                } else {
                    vm.password_anterior_type = "text";
                    vm.password_anterior_icon = "icon-eye-off";
                }
            } else if (password == "password_type") {
                if (vm.password_type == "text") {
                    vm.password_type = "password";
                    vm.password_icon = "icon-eye";
                } else {
                    vm.password_type = "text";
                    vm.password_icon = "icon-eye-off";
                }
            } else if (password == "password_confirm_type") {
                if (vm.password_confirm_type == "text") {
                    vm.password_confirm_type = "password";
                    vm.password_confirm_icon = "icon-eye";
                } else {
                    vm.password_confirm_type = "text";
                    vm.password_confirm_icon = "icon-eye-off";
                }
            } 
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('UploadProfilePictureFinalistController', UploadProfilePictureFinalistController);

    /** @ngInject */
    function UploadProfilePictureFinalistController($mdDialog, $document, event, item, CandidateService, IkanoFactory, AuthService) {
        var vm = this;
        vm.title = "Cambiar imagen de perfil";
        vm.parts = vm.title.split(" ");
        vm.saveButtonTitle = "Guardar";
        vm.saving = false;
        vm.item = item;

        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage   = null;
        vm.bounds = {};
        vm.bounds.left = 0;
        vm.bounds.right = 0;
        vm.bounds.top = 0;
        vm.bounds.bottom = 0;

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

		vm.uploadImage = function() {
            vm.saveButtonTitle = "Guardando...";
            vm.saving = true;

            var imageUrl = vm.cropper.croppedImage;
            var block = imageUrl.split(";");
            var contentType = block[0].split(":")[1];
            var realData = block[1].split(",")[1];

            var blob = vm.b64toBlob(realData, contentType);
    
			var fd = new FormData();
			fd.append('img', blob, "profile-picture.png");

			var config = {
				transformRequest: angular.identity,
				headers: {'Content-Type': undefined}
			};

			CandidateService.saveResumePhoto(fd, config, 
				function(response){
					if (response.data.result.status) {
                        var url = response.data.result.msg + "?v=" + Math.floor((Math.random() * 100000) + 1)
						vm.item.data.foto = url;
                        AuthService.refreshProfilePicture(url);
					}
                    vm.closeDialog();
                    vm.saving = false;
				},
				function(response){
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo");
                    vm.saving = false;
				}
			);
		};


        vm.b64toBlob = function(b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        };

        vm.getImageExtension = function(mime) {
            if (mime == "") {

            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('EditFinalistController', EditFinalistController);

    /** @ngInject */
    function EditFinalistController($mdDialog, $document, event, attachments, fields, lists, indicators, validations, CandidateService, IkanoFactory, ValidationService) {
        var vm = this;
        vm.title = "";
        vm.fields = fields;
        vm.fields.item = (fields.item ? fields.item : fields.data);
        vm.lists = lists;
        vm.attachments = attachments;
        vm.indicators = indicators;
        vm.validations = validations;
        vm.data = {};
        vm.errors = {};
        vm.saving = false;
        vm.saveButtonTitle = "Guardar";

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.getOptions = function(key) {
            return vm.lists[key];
        };

        vm.save = function() {
            vm.saving = true;
            vm.saveButtonTitle = "Guardando...";

            vm.data._id = vm.fields.item._id;

            vm.errors = IkanoFactory.validateFields(vm.fields.campos, vm.data);

            if (!angular.equals(vm.errors, {})) {
                vm.saving = false;
                vm.saveButtonTitle = "Guardar";
            } else {
                var data = {
                    bloque: vm.fields.name,
                    data: vm.data
                }

                CandidateService.saveResumeBlock(data, {}, function(response){
                    if (response.data.result.status) {
                        if (response.data.result.data && response.data.result.data.indicadores) {
                            vm.fields.indicadores = response.data.result.data.indicadores;
                        }
                        
                        if (response.data.result.data && response.data.result.data.completo) {
                            vm.fields.completo = response.data.result.data.completo;
                        }

                        if (response.data.result.data && response.data.result.data.porcentaje) {
                            vm.indicators.percentage = response.data.result.data.porcentaje;
                        }

                        if (response.data.result.data && response.data.result.data.inconsistencias) {
                            var array = $.map(response.data.result.data.inconsistencias, function(value, index) {
                                vm.validations[index] = value;
                            });
                        }
                        
                        if (vm.fields.data.length) {
                            for (var index = 0; index < vm.fields.data.length; index++) {
                                var element = vm.fields.data[index];
                                if (element._id == response.data.result.id) {
                                    vm.refreshData(vm.fields.data[index]);
                                    break;
                                }
                            }
                        } else {
                            vm.refreshData(vm.fields.data);
                        }

                        vm.closeDialog();
                        //IkanoFactory.showAlert("", "El bloque " + vm.fields.titulo.join(" ") + " ha sido actualizado exitosamente");
                    } else {
                        vm.errors = IkanoFactory.getFormErrors(response.data.result.errors);
                    }

                    vm.saving = false;
                    vm.saveButtonTitle = "Guardar";
                });
            }
        };

        vm.refreshData = function(fields) {
            var array = $.map(vm.data, function(value, index) {
                fields[index] = value;
            });
        };

        vm.removeAttachment = function(mod, attachment) {
            vm.saving = true;
            vm.saveButtonTitle = "Removiendo...";

            var attachments = vm.getAttachments(mod);

            CandidateService.removeFile(attachment.id, {}, {}, function(response){
                if (response.data.status) {
                    var index = attachments.indexOf(attachment);
                    if (index > -1) {
                        attachments.splice(index, 1);
                    }
                    vm.saving = false;
                    vm.saveButtonTitle = "Guardar";
                }
                
			});
        };

        vm.getAttachments = function(mod) {
            if (vm.attachments[mod][vm.fields.item._id]) {
                return vm.attachments[mod][vm.fields.item._id];
            } else if (vm.attachments[mod] && vm.attachments[mod].length) {
                return vm.attachments[mod];
            }

            return [];
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('DeleteFinalistController', DeleteFinalistController);

    /** @ngInject */
    function DeleteFinalistController($mdDialog, $document, event, block, item, indicators, validations, CandidateService, IkanoFactory) {
        var vm = this;
        vm.title = "";
        vm.block = block;
        vm.item = item;
        vm.indicators = indicators;
        vm.validations = validations;
        vm.itemName = (item.titulo ? item.titulo : "");

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.delete = function() {
            var data = {
                bloque: vm.block.name,
                data: {
                    id: vm.item._id
                }
            }

            CandidateService.deleteBlock(data, {}, function(response){
                if (response.data.result.status) {

                    if (response.data.result && response.data.result.porcentaje) {
                        vm.indicators.percentage = response.data.result.porcentaje;
                    }

                    if (response.data.result && response.data.result.inconsistencias) {
                        var array = $.map(response.data.result.inconsistencias, function(value, index) {
                            vm.validations[index] = value;
                        });
                    }

                    var index = vm.block.data.indexOf(vm.item);
                    if (index > -1) {
                        vm.block.data.splice(index, 1);
                    }

                    vm.closeDialog();
                    //IkanoFactory.showAlert("", response.data.result.msg);
                    IkanoFactory.showAlert("", "Se eliminado el elemento " + vm.itemName + " exitosamente");
                }
            });
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('AddFinalistController', AddFinalistController);

    /** @ngInject */
    function AddFinalistController($mdDialog, $document, event, fields, lists, indicators, validations, CandidateService, IkanoFactory) {
        var vm = this;
        vm.title = "";
        vm.fields = fields;
        vm.fields.block = [];
        vm.lists = lists;
        vm.indicators = indicators;
        vm.validations = validations;
        vm.data = {};
        vm.errors = {};
        vm.saving = false;
        vm.saveButtonTitle = "Guardar";

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.getOptions = function(key) {
            return vm.lists[key];
        };

        vm.save = function() {
            vm.saving = true;
            vm.saveButtonTitle = "Guardando...";

            vm.errors = IkanoFactory.validateFields(vm.fields.campos, vm.data);

            if (!angular.equals(vm.errors, {})) {
                vm.saving = false;
                vm.saveButtonTitle = "Guardar";
            } else {
                vm.data._id = null;

                var data = {
                    bloque: vm.fields.name,
                    data: vm.data
                }

                CandidateService.saveResumeBlock(data, {}, function(response){
                    if (response.data.result.status) {
                        
                        if (response.data.result.data && response.data.result.data.indicadores) {
                            vm.fields.indicadores = response.data.result.data.indicadores;
                        }
                        
                        if (response.data.result.data && response.data.result.data.completo) {
                            vm.fields.completo = response.data.result.data.completo;
                        }

                        if (response.data.result.data && response.data.result.data.porcentaje) {
                            vm.indicators.percentage = response.data.result.data.porcentaje;
                        }
                        
                        if (response.data.result.data && response.data.result.data.inconsistencias) {
                            var array = $.map(response.data.result.data.inconsistencias, function(value, index) {
                                vm.validations[index] = value;
                            });
                        }

                        vm.data._id = response.data.result.id;
                        if (vm.fields.data instanceof Array) {
                            vm.fields.data.push(vm.data);
                        } else {
                            vm.fields.data = vm.data;
                        }

                        vm.closeDialog();
                        //IkanoFactory.showAlert("", "El bloque " + vm.fields.titulo.join(" ") + " ha sido actualizado exitosamente");
                    } else {
                        vm.errors = IkanoFactory.getFormErrors(response.data.result.errors);
                    }

                    vm.saving = false;
                    vm.saveButtonTitle = "Guardar";
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .controller('AddExperienceFinalistController', AddExperienceFinalistController);

    /** @ngInject */
    function AddExperienceFinalistController($mdDialog, $document, event, fields, lists, indicators, validations, CandidateService, IkanoFactory) {
        var vm = this;
        vm.ready = false;
        vm.title = "";
        vm.fields = fields;
        vm.fields.item = [];
        vm.lists = lists;
        vm.indicators = indicators;
        vm.validations = validations;
        vm.data = {};
        vm.offerType = null;
        vm.company = null;
        vm.showCompaniesSelector = false;
        vm.errors = {};
        vm.saving = false;
        vm.saveButtonTitle = "Guardar";


        vm.validate = function() {
            if (vm.offerType == 0) {
                vm.ready = true;
            } else {
                vm.showCompaniesSelector = true;
            }
        };

        if (!vm.fields.companies.length) {
            vm.offerType = 0;
            vm.validate();
        };
        
        vm.setCompanyData = function() {
            for (var index = 0; index < vm.fields.data.length; index++) {
                var element = vm.fields.data[index];
                if (element._id == vm.company.idBlock) {
                    vm.fields.item = {
                        empresa: element.empresa,
                        industria_id: element.industria_id,
                        industria_name: element.industria_name,
                        telefono: element.telefono,
                    };
                    vm.ready = true;
                    break;
                }
            }
        };

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.getOptions = function(key) {
            return vm.lists[key];
        };

        vm.save = function() {
            vm.saving = true;
            vm.saveButtonTitle = "Guardando...";

            vm.errors = IkanoFactory.validateFields(vm.fields.campos, vm.data);

            if (!angular.equals(vm.errors, {})) {
                vm.saving = false;
                vm.saveButtonTitle = "Guardar";
            } else {

                vm.data._id = null;

                var data = {
                    bloque: vm.fields.name,
                    data: vm.data
                }

                CandidateService.saveResumeBlock(data, {}, function(response){
                    vm.errors = {};
                    if (response.data.result.status) {
                        if (response.data.result.data && response.data.result.data.indicadores) {
                            vm.fields.indicadores = response.data.result.data.indicadores;
                        }
                        
                        if (response.data.result.data && response.data.result.data.completo) {
                            vm.fields.completo = response.data.result.data.completo;
                        }

                        if (response.data.result.data && response.data.result.data.porcentaje) {
                            vm.indicators.percentage = response.data.result.data.porcentaje;
                        }

                        if (response.data.result.data && response.data.result.data.inconsistencias) {
                            var array = $.map(response.data.result.data.inconsistencias, function(value, index) {
                                vm.validations[index] = value;
                            });
                        }

                        vm.data._id = response.data.result.id;
                        if (vm.fields.data instanceof Array) {
                            vm.fields.data.push(vm.data);
                        } else {
                            vm.fields.data = vm.data;
                        }

                        vm.closeDialog();
                        //IkanoFactory.showAlert("", "El bloque " + vm.fields.titulo.join(" ") + " ha sido actualizado exitosamente");
                    } else {
                        vm.errors = IkanoFactory.getFormErrors(response.data.result.errors);
                    }

                    vm.saving = false;
                    vm.saveButtonTitle = "Guardar";
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.recover-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.auth-recover-password', {
                url: '/recover-password',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.auth-recover-password': {
                        templateUrl: 'app/main/auth/recover-password/recover-password-params.html',
                        controller: 'RecoverPasswordController as vm'
                    }
                },
                bodyClass: 'login'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.recover-password')
        .controller('SecurityQuestionsController', SecurityQuestionsController);

    /** @ngInject */
    function SecurityQuestionsController($mdDialog, $document, $state, questions, id, CandidateService, IkanoFactory, AuthService) {
        var vm = this;
        vm.title = "PREGUNTAS DE SEGURIDAD".split(" ");
        vm.saving = false;
        vm.saveButtonTitle = "Enviar";
        vm.questions = questions;
        vm.answers = {};
        vm.errors = {};
        vm.error = null;
        vm.questionsForm = true;
        vm.data = {};
        
        vm.sendAnswers = function() {
            vm.errors = {};
            vm.error = null;
            vm.setButtonTitle(true);

            if (vm.validate()) {
                vm.data = {
                    cedula: id + "",
                    preguntas: vm.answers
                }

                AuthService.recoverPasswordByQuestions(vm.data, {}, 
                    function(response) {
                        vm.setButtonTitle(false);
                        if (response.data.result.status) {
                            vm.questionsForm = false;
                        } else {
                            if (response.data.result.msg == "invalid choices") {
                                IkanoFactory.showAlert("Error", "Has respondido de manera incorrecta, por favor intente de nuevo (Solo tienes 3 oportunidades).");
                            }
                        }
                    },
                    function(response){
                        vm.setButtonTitle(false);
                        if (response.status == 404) {
                            vm.error = "Número de documento de identidad incorrecto.";
                        }
                    }
                );
            } else {
                vm.setButtonTitle(false);
            }
        };

        vm.validate = function() {
            for (var index = 0; index < vm.questions.length; index++) {
                var element = vm.questions[index];

                if (!vm.answers[element.key]) {
                    vm.errors[element.key] = "Este campo es obligatorio";
                    return false;
                }
            }

            return true;
        };

        vm.recoverPassword = function() {
            vm.data.passwd = vm.form;
            AuthService.recoverPasswordByQuestions(vm.data, {}, 
                function(response) {
                    if (response.data.result.status) {
                        IkanoFactory.showAlert("Existoso", "Has cambiado la contraseña exitosamente");
                        $state.transitionTo('app.auth-login');
                    } 
                },
                function(response){
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };

        vm.setButtonTitle = function(btn) {
            if (btn) {
                vm.saving = true;
                vm.saveButtonTitle = "Enviando";
            } else {
                vm.saving = false;
                vm.saveButtonTitle = "Enviar";
            }
        };

        vm.closeDialog = function() {
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('BlockPopUp', BlockPopUp);

    function BlockPopUp(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, ValidationService, $scope, data, idRequest) {

        //Constructor
        var vm = this;

        vm.validationService = ValidationService;
        vm.blocksStage = [];
        vm.idRequest = idRequest;
        vm.loadingBlock = true;

        vm.initBlock = function () {
            vm.data = data;
            vm.bloque = Object.keys(data.bloques);
            vm.values = vm.data.data;
            vm.lists = vm.data.listas;
            
            vm.setBlocks();
            vm.setValuesWatch();
            vm.data.estructura_campos = serializeEstructuraCampos(vm.data.estructura_campos,vm.data.bloques);
            vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
            vm.loadingBlock = false;
            ValidationService.watchFunctions($scope, vm);
        }


        /**
        * BLOQUES ETAPA
        */

        function serializeEstructuraCampos(structura,bloques){
            var campos = $.map(bloques,function(value,index){
                return value.campos;
            });

            var structure = {};
            if(vm.blocksStage[0].type == "two-column-multiple-rows"){
                structure[vm.blocksStage[0].model] = structura[vm.blocksStage[0].model];
            }else{
                for(var i in structura){
                    if(campos.indexOf(i) !== -1){
                        structure[i] = structura[i];
                    }
                }
            }
            
            return structure;
        }

        vm.setBlocks = function () {
            vm.blocksStage = $.map(vm.data.bloques, function (value, index) {
                return [vm.getBlock(index, value)];
            });
        };

        vm.setValuesWatch = function () {
            ValidationService.setWarchers($scope, vm);
        };

        vm.getPositionColaborators = function (position) {
            AdminService.getPositionColaborators({ cargo_id: position,proceso_id:vm.idRequest }, {},
                function (response) {
                    if (response.data.colaboradores) {
                        vm.lists.position_colaborators = response.data.colaboradores;
                    }
                },
                function (response) {
                    //IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };

        vm.getBlock = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "one-column",
                block: data.model.type,
                fields: data.campos
            };

            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }

            return block;
        };

        vm.addModelToBlock = function (block) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            if (vm.values[block.model] == "undefined" || vm.values[block.model] == null) {
                vm.values[block.model] = [];
            }

            vm.values[block.model].push(model);
        }

        vm.removeModelToBlock = function (block, index) {
            vm.values[block.model].splice(index, 1);
        }

        vm.save = function () {
            var data = {
                id: vm.idRequest,
                data: vm.values,
                bloque: vm.bloque[0]
            };

            if (!data.data.tipo_proceso) {
                data.data.tipo_proceso = 'proceso_analista';
            }
            vm.saving = true;

            /* if (data.bloque == 'acuerdo_servicio') {
                 analystService.sendApproveUnderstanding(data,
                     function (response) {
                         vm.saving = false;
                         response.data.values = vm.values;
                         $mdDialog.hide(response);
                     },
                     function (reject) {
                         vm.saving = false;
                         $mdDialog.hide(reject);
                     }
                 );
                 AdminService.sendApproveUnderstanding({
                     proceso_id: vm.idRequest,
                     aprobacion: 1
                 },function(response){
                     vm.saving = false;
                     console.log(response);
                 },function(reject){
                     vm.saving = false;
                     console.log(reject);
                 })
             } else {*/
            analystService.saveRequestAnalyst(data,
                function (response) {
                    vm.saving = false;
                    response.data.values = vm.values;
                    $mdDialog.hide(response);

                },
                function (reject) {
                    vm.saving = false;
                    $mdDialog.hide(reject);
                }
            );
            //}



        };

        vm.validateDataStage = function () {
            vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values, true);
            if (angular.equals(vm.errors, {})) {
                vm.errors = {};
                vm.save();
            } else {
                return;
            }
        }

        /**
         * END BLOQUES ETAPA
         */

        vm.initBlock();

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('suspensionDialogController', SuspensionDialogController);

    function SuspensionDialogController($mdDialog,analystMisc, analystConstant, analystService, IkanoFactory, AdminService, AuthService, idRequest, criterio,request,data) {
        //contructor
        var vm = this;
        vm.data = data;
        vm.misc = {};
    
        vm.misc.arrCrSuspension = criterio;
        vm.idRequest = idRequest;
        vm.request = request;
        vm.misc.arrOpPublish = [{id:"1",name:"Si"},{id:"0",name:"No"}];
        vm.statusOffer = analystConstant.OFFERSTATUS;
        vm.data.publish = (vm.request.status_publish == 'No Publicada')? {id:"0",name:"No"} : {id:"1",name:"Si"};


        vm.saveSuspensionRequest = function (formValid) {

            $mdDialog.hide(vm.data);
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };
    }
})();
(function(){
    'use strict';

    angular.module('app.seleccion_analyst').controller('updateRequestDialog', updateRequestDialog);

    function updateRequestDialog(AuthService, AdminService, analystService,analystMisc, IkanoFactory, $mdDialog,request,$mdDateLocale){
        //contructor
        var vm = this;

        vm.request = request;

        vm.fechaAcuerdoFilter = vm.request.fecha_creacion_bloques.filter(function(element){
            return element[2] == 'acuerdo_servicio'
        });
        vm.fechaAcuerdo = (vm.fechaAcuerdoFilter[0]) ? analystMisc.misc.setFormatDate(vm.fechaAcuerdoFilter[0][3], 'MMM D, YYYY') : null;

        $mdDateLocale.formatDate = function (date) {
            return date ? moment(date).format('DD/MMMM/YYYY') : '';
        };

        vm.save = function(){
            var dataDate = analystMisc.misc.setFormatDate(vm.newDate, 'YYYY-MM-DD');;
            
            analystService.updateProcessData({proceso_id:vm.request.id,bloque:'acuerdo_servicio',fecha:dataDate},function(resolve){
                $mdDialog.hide(resolve);
            },function(reject){
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

    }
})();
(function () {
    angular.module('app.seleccion_analyst').controller('understandingDialogController', understandingDialog);

    function understandingDialog(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, analystMisc,procesos) {

        var vm = this;
        vm.procesos = procesos;
        
        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        vm.SelectedRequest = function(proceso){
            $mdDialog.hide(proceso);
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('showHv', showHv);

    function showHv(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, ValidationService, analystConstant, $scope, $filter, candidate) {
        //contructor
        var vm = this;
        vm.candidate = candidate;
        vm.blocks = [];
        vm.analyst = true;

        vm.validationService = ValidationService;

        /**
         * BLOCKS
         */
        vm.setTitles = function () {
            vm.blocks = $.map(vm.resume, function (value, index) {
                value.titulo = value.titulo.split(" ");
                value.name = index;
                value.emptyRowsMessage = "Por favor completa todos lo datos solicitados. Esto hará que la calidad de la información de tu hoja de vida mejore y agilize el proceso de selección";
                value.item = (value.data && !value.data.length ? value.data : null);

                if (value.name == "personales") {
                    value.data.foto = value.data.foto + "?v=" + vm.getRandomNumber();
                }
                value.campos = IkanoFactory.getStructureForFields(value.campos,vm.estructuraCampo); 
                return [{ name: index, data: value }];
            });
        };

        vm.getAttachmentUrl = function (attachment) {
            var id = (typeof attachment !== "number")?attachment.id : attachment;
            analystService.getFile({ id: id }, { responseType: 'arraybuffer' },
                function (response) {
                    IkanoFactory.downloadFile(response.data, attachment.name)
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error descargando el archivo, por favor intente de nuevo.");
                });
        }

        vm.getRandomNumber = function () {
            return Math.floor((Math.random() * 100) + 1);
        };
        /**
         * END BLOCKS
         */

        vm.getHojaVida = function () {
            analystService.getHojaVida({ hoja_vida_id: vm.candidate.id }, function (response) {
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        vm.resume = response.data.data_bloques;
                        vm.attachments = response.data.adjuntos;
                        vm.lists = response.data.listas;
                        vm.estructuraCampo = response.data.estructura_campos;
                        vm.setTitles();
                        break;
                    case analystConstant.CODEPETITION.NOTFOUND:
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            });
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        vm.getHojaVida();
    }

})();
(function () {
    angular.module('app.seleccion_analyst').controller('searchOfferDialogController', searchOfferDialogController);

    function searchOfferDialogController(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state,$scope,idRequest,ValidationService) {

        var vm = this;

        vm.idRequest = idRequest;

        vm.errorSearch = {};

        vm.pageInfo = {};

        vm.validationService = ValidationService;

        vm.loading = false;

        vm.searchOffer = function (idRequest,query){
            var data = {
                proceso_id: idRequest,
                published: 1
            }

            if (query) {
                if (query.length >= 3) {
                    data.query = query;
                } else {
                    return;
                }
            }

            analystService.searchProcess(data, function (resolve) {
                if (resolve.data.data.length <= 0) {
                    vm.errorSearch.valid = false;
                    vm.errorSearch.message = resolve.data.message;
                }else{
                    vm.errorSearch.valid = true;
                }
                vm.process = resolve.data.data;
            }, function (reject) {
                console.log(reject);
            });
        }

        vm.getOffer = function(data){
            
            if(!data || !data.id){
                return;
            }
            vm.loading = true;
            analystService.getPublicRequest({ proceso_id: data.id }, function (response) {
                vm.modelUnderstanding(response.data.requisicion);
                vm.loading = false;
            }, function (reject) {
                vm.loading = false;
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información de la oferta, por favor intente de nuevo.");
            });

        }

        //MODELS
        vm.modelUnderstanding = function (data) {
            vm.data = data;
            vm.values = vm.data.data;
            vm.lists = vm.data.listas;
            //vm.fields = vm.data.estructura_campos;
            vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
            vm.extra = vm.data.extra;
            vm.observations = vm.data.observaciones;
            vm.setPageData();
            vm.setValuesWatch();
            vm.change = false;
            vm.setBlocks();
            //vm.getPositionColaborators(vm.values.cargo_id);
            ValidationService.generalFunctions($scope, vm);
        }

        //BLOQUES
        vm.setPageData = function () {
            vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
            vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
            if (vm.data.data.no_vacantes) {
                var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
                vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
            }

            vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
            if (vm.data.data.tipo_solicitud_b_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
            }
            if (vm.data.data.tipo_solicitud_c_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
            }
        };

        vm.setValuesWatch = function () {
            ValidationService.setWarchers($scope, vm);
        };

        vm.setBlocks = function () {
            vm.blocks = $.map(vm.data.bloques, function (value, index) {
                return [vm.getBlock(index, value)];
            });
        };

        vm.getBlock = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.campos
            };

            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }

            return block;
        };


        vm.addModelToBlock = function (block) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            vm.values[block.model].push(model);
        }

        vm.removeModelToBlock = function (block, index) {
            vm.values[block.model].splice(index, 1);
        }

        vm.getPositionColaborators = function (position) {
            AdminService.getPositionColaborators({ cargo_id: position }, {},
                function (response) {
                    if (response.data.colaboradores) {
                        vm.lists.position_colaborators = response.data.colaboradores;
                    }
                },
                function (response) {
                    //IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };

        vm.hideModal = function(){
            $mdDialog.hide(vm.data);
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        vm.searchOffer(vm.idRequest,null);
    }
})();
(function () {

    'use strict';

    angular.module('app.seleccion_analyst').controller('scheduledCitationCandidateDialog', scheduledCitationCandidateDialog);

    function scheduledCitationCandidateDialog(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, analystMisc, config, $q) {
        //constructor
        var vm = this;
        vm.data = config.data;
        vm.showForm = false;
        vm.config = config;
        vm.candidate = config.dataCandidate;
        vm.config.lists.placeCita = vm.config.lists.placeCita ? vm.config.lists.placeCita : vm.config.lists.lugares;
        vm.config.lists.typeCita = vm.config.lists.typeCita ? vm.config.lists.typeCita : vm.config.lists.tipos_cita;


        vm.mergeCita = function () {
            for (var c in vm.config.citas) {
                vm.config.citas[c].place = vm.getPlaceCita(vm.config.citas[c].lugar);
                vm.config.citas[c].type = vm.getTypeCita(vm.config.citas[c].tipo_cita);
            }
        }

        vm.getPlaceCita = function (codPlace) {
            for (var i in vm.config.lists.placeCita) {
                if (codPlace == vm.config.lists.placeCita[i].id) {
                    return vm.config.lists.placeCita[i].name;
                }
            }
        }

        vm.getTypeCita = function (codType) {
            for (var i in vm.config.lists.typeCita) {
                if (codType == vm.config.lists.typeCita[i].id) {
                    return vm.config.lists.typeCita[i].name;
                }
            }
        }

        vm.changeForm = function () {
            if (vm.showForm) {
                $scope.showForm = false;
            } else {
                vm.showForm = true;
            }
        }

        vm.closeDialog = function () {
            $mdDialog.hide();
        }

        vm.executeCallback = function () {
            vm.config.callbackSuccess(vm.data);
            $mdDialog.hide();
        }

        vm.mergeCita();

    }

})();
(function(){
    'use strict';

    angular.module('app.seleccion_analyst').controller('referredCandidateDialog',referredCandidateDialog);

    function referredCandidateDialog(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, ValidationService, $scope, $filter, candidate, request){
        var vm = this;

        vm.data = {};
        vm.data.hoja_vida_id = candidate.id;

        vm.request = request;

        vm.candidate = candidate;

        vm.errors = {};

        vm.loading = false;

        vm.sendReferred = function(){
            if(!vm.data.referente || vm.data.referente == ""){
                vm.errors.referente = "Este campo es obligatorio";
                return;
            }
            vm.loading = true;
            var dataPost = vm.data;

            analystService.referredCandidate(dataPost, function (response) { 
                vm.loading = false;
                $mdDialog.hide(response);
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });

        }

        vm.closeDialog = function(){
            $mdDialog.cancel();
        }
    }
})();
(function(){
    'use strict';

    angular.module('app.seleccion_analyst').controller('historyRequestDialog',historyRequestDialog);

    function historyRequestDialog($mdDialog,analystMisc,history,IkanoFactory,DTColumnDefBuilder){
        //contructor
        var vm = this;

        vm.history = angular.copy(history);

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            iDisplayLength: 20,
            paging: false,
            info: false,
            searching:false,
        };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notVisible(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable()
        ];

        vm.closeDialog = function(){
            $mdDialog.cancel();
        }

        function modelLog(data){
            console.log(data);
            var baseJson = {
                id:"id",
                date:"date",
                user:"usuario",
                action:{key:"action",callback:"replacestr",dataCallback: { search:'_',replace:' '}},
                detail:"detalle",
                data:{key:"data",callback:"parsejson"},
                ip:"ip",
                navegador:"navegador",
                url:"url",
            };
            analystMisc.modeldata(data, baseJson).then(function(resolve){
                console.log(resolve);
                vm.logDetail = resolve;
                console.log(vm.logDetail);
            });
        }

        modelLog(vm.history);

    }
})();
(function(){
    'use strict';

    angular.module('app.seleccion_analyst').controller('finishRequestDialog', finishRequestDialog);

    function finishRequestDialog(AuthService, AdminService, analystService, IkanoFactory, $mdDialog,request,analystConstant){
        //contructor
        var vm = this;

        vm.request = request;

        vm.status_process_status = analystConstant.STATUSPROCESS;

        vm.validatePetition = function(){
            if(vm.request.status_process.id == vm.status_process_status.PROCESO_FINALIZADO){
                vm.reOpenRequest();
            }else{
                vm.finishRequest();
            }
        }

        vm.reOpenRequest = function(){
            analystService.reOpenRequest({proceso_id:vm.request.id},function(resolve){
                $mdDialog.hide(resolve);
            },function(reject){
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.finishRequest = function(){
            analystService.finishRequest({proceso_id:vm.request.id},function(resolve){
                $mdDialog.hide(resolve);
            },function(reject){
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('FilterHv', FilterHv);

    function FilterHv(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, ValidationService, $scope,ListFilter, $filter, lists, request, form, analystConstant, candidate) {

        //constructor
        var vm = this;
        vm.collapse = {};
        vm.candidate = candidate;
        //listas
        vm.lists = lists;

        vm.request = request;

        vm.limit = 30;
        vm.data = form;
        vm.data.ciudades = (form.ciudades) ? form.ciudades : [];
        vm.data.instituciones = (form.instituciones) ? form.instituciones : [];
        vm.data.profesiones = (form.profesiones) ? form.profesiones : [];
        vm.data.areas_trabajo = (form.areas_trabajo) ? form.areas_trabajo : [];
        vm.data.cargos_recomendados = (form.cargos_recomendados) ? form.cargos_recomendados : [];
        vm.data.origenes = (form.origenes) ? form.origenes : [];
        vm.data.sector = (form.sector) ? form.sector : [];
        vm.data.cargo_equivalente = (form.cargo_equivalente) ? form.cargo_equivalente : [];

        vm.filter = {};

        vm.misc = {};

        vm.selected = {};

        vm.user = AuthService.getUserData();


        $scope.$watch('vm.data', function () {
            vm.filtrosClear = angular.equals(vm.serializeData(angular.copy(vm.data)), {});
        }, true);

        vm.showCollapse = function (key) {
            vm.collapse[key] = (vm.collapse[key]) ? false : true;
        }

        vm.init = function () {
            if (vm.candidate) {
                vm.filters = serializeFilter(JSON.parse(localStorage.getItem('filterSearchCandidate')));
            } else {
                vm.filters = serializeFilter(JSON.parse(localStorage.getItem('filterSearchHv')));
            }
        }

        function serializeFilter(filter) {
            var dependency = [];
            for (var i in filter) {
                for (var j in filter[i]) {
                    var children = angular.copy(filter[i][j]);
                    if (children.dependency) {
                        children.show = false;
                    } else {
                        children.show = true;
                    }
                    if (children.onchange) {
                        setOnchange(children);
                    }
                }
            }
            return filter;
        }

        function setOnchange(filter) {
            $scope.$watch("vm.data['" + filter.id + "']", function (newValue, oldValue) {
                if (newValue) {
                    sendOnchange(filter);
                }
            }, true);
        }

        function sendOnchange(filter) {
            var onchange = filter.onchange;
            var data = {
                function: onchange.function,
                values: {}
            };

            for (var i in onchange.fields) {
                var valueFiels = vm.data[onchange.fields[i]];
                if (valueFiels) {
                    data.values[onchange.fields[i]] = valueFiels;
                }
            }

            AdminService.get_onchange_data(data, function (response) {
                serializeEstructura_campos(response.data.data.estructura_campos);
                serializeListas(response.data.data.lista);
            }, function (reject) {
                console.error(reject);
            });

        }

        function serializeEstructura_campos(data) {
            for (var parent in vm.filters) {
                var filterChildrens = vm.filters[parent];
                for (var children in filterChildrens) {
                    var filter = filterChildrens[children];
                    if (filter.id == data.id) {
                        vm.filters[parent][children].name = data.name;
                        break;
                    }
                }
            }
        }

        function serializeListas(data) {
            for (var parent in vm.filters) {
                var filterChildrens = vm.filters[parent];
                for (var children in filterChildrens) {
                    var filter = filterChildrens[children];
                    
                    if (data[filter.id]) {
                        var options = [];
                        if (data[filter.id] instanceof Array) {
                            options = data[filter.id];
                        } else {
                            for (var i in data[filter.id]) {
                                options.push({ id: i, name: data[filter.id][i] });
                            }
                        }
                        vm.filters[parent][children].options = options;
                        vm.filters[parent][children].optionsshow = options.slice(0, vm.limit);
                        ListFilter.setList(filter.id,options);
                    }
                }
            }
        }

        vm.backup = {};

        vm.loadData = function (campo, key, filter) {
            var index = vm.filters[key].map(function (e) { return e.id; }).indexOf(campo);
            if (vm.filter[campo] && vm.filter[campo].length >= 3) {
                vm.loadDataFilter(campo, key, index);
            } else {
                var length = vm.filters[key][index].optionsshow.length;
                var lengthBackup = vm.filters[key][index].options.length;
                if (length == lengthBackup) {
                    return;
                }
                for (var i = 0; i < vm.limit; i++) {
                    var pushIndex = i + length;
                    if (pushIndex == lengthBackup) {
                        break;
                    }
                    vm.filters[key][index].optionsshow.push(vm.filters[key][index].options[pushIndex]);
                }
            }
        }

        vm.loadDataFilter = function (campo, key, index) {
            vm.filters[key][index].optionsshow = $filter('filter')(vm.filters[key][index].options, vm.filter[campo]);
        }

        vm.inSelectedGroups = function (campo, idOption) {
            angular.forEach(vm.data[campo], function (id) {
                if (idOption == id) {
                    return true;
                }
                return false;
            });
        }

        vm.serializeData = function (data) {
            //Validar key
            if (data.candidate_process) {
                if (data.hayan_participado_proceso) {
                    delete (data.hayan_participado_proceso);
                } else if (data.hayan_participado_cualquier) {
                    delete (data.hayan_participado_cualquier);
                }

                if (data.candidate_process == vm.request.id) {
                    data.hayan_participado_proceso = data.candidate_process;
                } else {
                    data.hayan_participado_cualquier = 1;
                }
            }
            for (var i in data) {
                switch (typeof data[i]) {

                    case "object":
                        if (data[i].length == 0) {
                            delete (data[i]);
                        } else {
                            if (angular.isObject(data[i][0])) {
                                var key = 'id';
                                if (i == 'profesiones') {
                                    key = 'name';
                                }

                                data[i] = vm.ArrayObjToArray(data[i], key);
                            }
                        }
                        break;
                    case "string":
                        if (!data[i]) {
                            delete (data[i]);
                        }
                        break;
                }
            }
            return data;
        }

        vm.ArrayObjToArray = function (arr, key) {
            return arr.map(function (v, k) {
                return v[key]
            });
        }

        vm.saveSearch = function () {
            var dataPost = {};
            dataPost.filtros = vm.serializeData(angular.copy(vm.data));
            dataPost.pagination = {
                page: 1,
                limit: analystConstant.LIMITROW
            }
            vm.loading = true;

            if (vm.candidate) {
                dataPost.proceso_id = vm.request.id;
                analystService.searchCandidate(dataPost, function (response) {
                    vm.loading = false;
                    $mdDialog.hide({ candidate: response.data, filter: dataPost.filtros, data: vm.data });
                }, function (reject) {
                    vm.loading = false;
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
                });
            } else {
                searchHv(dataPost);
            }

        }

        function searchHv(dataPost) {
            if (vm.user.group_id == 1) {
                AdminService.filterAllCandidateHv(dataPost, function (response) {
                    vm.loading = false;
                    $mdDialog.hide({ candidates: response.data, filter: dataPost.filtros, data: vm.data });
                }, function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
                });
            } else {
                analystService.filterAllCandidate(dataPost, function (response) {
                    vm.loading = false;
                    $mdDialog.hide({ candidates: response.data, filter: dataPost.filtros, data: vm.data });
                }, function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
                });
            }
        }

        vm.clearFilters = function () {
            vm.data = {};
            vm.data.ciudades = [];
            vm.data.instituciones = [];
            vm.data.profesiones = [];
            vm.data.areas_trabajo = [];
            vm.data.cargos_recomendados = [];
            vm.data.origenes = [];
            vm.data.sector = [];
            vm.data.cargo_equivalente = [];


        }

        vm.validateSearch = function (data) {
            data = angular.copy(data);
            angular.forEach(data, function (val, i) {
                switch (typeof val) {
                    case "object":
                        if (angular.equals(val, []) || angular.equals(val, {})) {
                            delete (data[i]);
                        }
                        break;
                    case "string":
                        if (val == "" || typeof val === "undefined") {
                            delete (data[i]);
                        }
                        break;
                }
            });
            return data;
        }

        /**
        * VALIDATION CHIP
        */

        vm.validationChip = function (data, chip) {
            if (!angular.isObject(chip)) {
                data.pop();
            }
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        vm.init();
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('FilterCandidate', FilterCandidate);

    function FilterCandidate(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, ValidationService, $scope, $filter, lists, request, data) {

        //constructor
        var vm = this;
        vm.collapse = {};

        //listas
        vm.lists = lists;

        vm.request = request;

        vm.limit = 30;

        vm.data = data;
        vm.data.ciudades = (data.ciudades) ? data.ciudades : [];
        vm.data.instituciones = (data.instituciones) ? data.instituciones : [];
        vm.data.profesiones = (data.profesiones) ? data.profesiones : [];
        vm.data.areas_trabajo = (data.areas_trabajo) ? data.areas_trabajo : [];
        vm.data.cargos_recomendados = (data.cargos_recomendados)?data.cargos_recomendados:[];
        vm.data.origenes = (data.origenes)?data.origenes:[];

        vm.filter = {};

        vm.misc = {};

        vm.loading = false;



        /*$scope.$watch('vm.data', function () {
            console.log(vm.data);
        }, true)*/

        vm.showCollapse = function (item) {
            switch (item) {
                case 1:
                    vm.collapse.showCollapseOne = (vm.collapse.showCollapseOne) ? false : true;
                    break;

                case 2:
                    vm.collapse.showCollapseTwo = (vm.collapse.showCollapseTwo) ? false : true;
                    break;

                case 3:
                    vm.collapse.showCollapseThree = (vm.collapse.showCollapseThree) ? false : true;
                    break;
                case 4:
                    vm.collapse.showCollapseFour = (vm.collapse.showCollapseFour) ? false : true;
                    break;
            }
        }

        vm.init = function () {
            vm.initCity();
            vm.initSalario();
            vm.initAge();
            vm.initIntituciones();
            vm.initProfesiones();
            vm.initAreas();
            vm.initlanguage();
            vm.initAcademi();
            vm.lastUpdate();
            vm.charge();
            vm.initAnalist();
            vm.initOrigen();
        }

        vm.backup = {};

        /**
         * CITY
         */

        vm.initCity = function () {
            vm.backup.ciudades = [];
            $.each(vm.lists.ciudades, function (index, v) {
                vm.backup.ciudades.push({ id: index, value: v });
            });
            vm.misc.ciudades = vm.backup.ciudades.slice(0, vm.limit);
        }

        /**
         * ASPIRACION SALARIAL
         */
        vm.initSalario = function () {
            vm.backup.salario = [];
            $.each(vm.lists.salarios, function (index, v) {
                vm.backup.salario.push({ id: index, value: v });
            });
            vm.misc.salario = vm.backup.salario.slice(0, vm.limit);
        }

        /**
         * FILTRO EDAD
         */

        vm.initAge = function () {
            vm.backup.edades = [];
            $.each(vm.lists.edades, function (index, v) {
                vm.backup.edades.push({ id: index, value: v });
            });
            vm.misc.edades = vm.backup.edades.slice(0, vm.limit);
        }

        /**
         * INTITUCIONES
         */
        vm.initIntituciones = function () {
            vm.backup.institutos = [];
            $.each(vm.lists.institutos, function (index, v) {
                vm.backup.institutos.push({ id: index, value: v });
            });
            vm.misc.institutos = vm.backup.institutos.slice(0, vm.limit);
        }

        /**
         * profesiones
         */

        vm.initProfesiones = function () {
            vm.backup.profesiones = [];
            $.each(vm.lists.profesiones, function (index, v) {
                vm.backup.profesiones.push({ id: index, value: v });
            });
            vm.misc.profesiones = vm.backup.profesiones.slice(0, vm.limit);
        }

        /**
         * Areas
         */
        vm.initAreas = function () {
            vm.backup.areas = [];
            $.each(vm.lists.areas, function (index, v) {
                vm.backup.areas.push({ id: index, value: v });
            });
            vm.misc.areas = vm.backup.areas.slice(0, vm.limit);
        }

        /**
         * IDIOMAS
         */

        vm.initlanguage = function () {
            vm.backup.idiomas = [];
            $.each(vm.lists.idiomas, function (index, v) {
                vm.backup.idiomas.push({ id: index, value: v });
            });
            vm.misc.idiomas = vm.backup.idiomas.slice(0, vm.limit);
        }

        /**
         * NIVEL EDUCATIVOS
         */

        vm.initAcademi = function () {
            vm.backup.niveles_academicos = [];
            $.each(vm.lists.niveles_academicos, function (index, v) {
                vm.backup.niveles_academicos.push({ id: index, value: v });
            });
            vm.misc.niveles_academicos = vm.backup.niveles_academicos.slice(0, vm.limit);
        }

        /**
         * Ultima modificacion
         */

        vm.lastUpdate = function () {
            vm.backup.ultimas_modificaciones = [];
            $.each(vm.lists.ultimas_modificaciones, function (index, v) {
                vm.backup.ultimas_modificaciones.push({ id: index, value: v });
            });
            vm.misc.ultimas_modificaciones = vm.backup.ultimas_modificaciones.slice(0, vm.limit);
        }

         /**
         * Cargos Recomendados
         */

        vm.charge = function () {
            vm.backup.cargos_recomendados = [];
            /*$.each(vm.lists.cargos_recomendados, function (index, v) {
                vm.backup.cargos_recomendados.push({ id: index, value: v });
            });*/
            vm.backup.cargos_recomendados = angular.copy(vm.lists.cargos_recomendados);
            vm.misc.cargos_recomendados = vm.backup.cargos_recomendados.slice(0, vm.limit);
        }

        /**
         * ANALISTAS
         */
        vm.initAnalist = function(){
            vm.backup.recomendado_por = [];
            $.each(vm.lists.analistas, function (index, v) {
                vm.backup.recomendado_por.push({ id: index, value: v });
            });
            vm.misc.recomendado_por = vm.backup.recomendado_por.slice(0, vm.limit);
        }

        /**
         * ORIGEN
         */
        vm.initOrigen = function(){
            vm.backup.origenes = [];
            $.each(vm.lists.origenes, function (index, v) {
                vm.backup.origenes.push({ id: index, value: v });
            });
            vm.misc.origenes = vm.backup.origenes.slice(0, vm.limit);
        }

        vm.loadData = function (campo) {
            if (vm.filter[campo] && vm.filter[campo].length >= 3) {
                vm.loadDataFilter(campo);
            } else {
                var length = vm.misc[campo].length;
                if (length == vm.backup[campo].length) {
                    return;
                }
                for (var i = 0; i < vm.limit; i++) {
                    var pushIndex = i + length;
                    if(typeof vm.backup[campo][pushIndex] == "undefined"){
                        break;
                    }
                    vm.misc[campo].push(vm.backup[campo][pushIndex]);
                }
            }
        }

        vm.loadDataFilter = function (campo) {
            vm.misc[campo] = $filter('filter')(vm.backup[campo], vm.filter[campo]);
        }

        vm.inSelectedGroups = function (campo, idOption) {
            angular.forEach(vm.data[campo], function (id) {
                if (idOption == id) {
                    return true;
                }
                return false;
            });
        }

        vm.serializeData = function (data) {
            //Validar key
            if(data.candidate_process){
                if(data.hayan_participado_proceso){
                    delete(data.hayan_participado_proceso);
                }else if(data.hayan_participado_cualquier){
                    delete(data.hayan_participado_cualquier);
                }

                if(data.candidate_process == vm.request.id){
                    data.hayan_participado_proceso = data.candidate_process;
                }else{
                    data.hayan_participado_cualquier = 1;
                }
            }
            for (var i in data) {
                switch (typeof data[i]) {
                    case "object":
                        if (data[i].length == 0) {
                            delete (data[i]);
                        } else {
                            if (angular.isObject(data[i][0])) {
                                data[i] = vm.ArrayObjToArray(data[i], 'id');
                            }
                        }
                        break;
                    case "string":
                        if (!data[i]) {
                            delete (data[i]);
                        }
                        break;
                }
            }
            return data;
        }

        vm.ArrayObjToArray = function (arr, key) {
            return arr.map(function (v, k) {
                return v[key]
            });
        }

        vm.saveSearch = function () {
            var dataPost = {};
            dataPost.proceso_id = vm.request.id;
            dataPost.filtros = vm.serializeData(angular.copy(vm.data));
            dataPost.pagination = {
                page: 1,
                limite: 12
            }
            vm.loading = true;
            analystService.searchCandidate(dataPost, function (response) {
                vm.loading = false;
                $mdDialog.hide({ candidate: response.data, filter: dataPost.filtros, data: vm.data });
            }, function (reject) {
                vm.loading = false;
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            });
        }

        vm.clearFilters = function(){
            vm.data = {};
            vm.data.ciudades = [];
            vm.data.instituciones = [];
            vm.data.profesiones = [];
            vm.data.areas_trabajo = [];
            vm.data.cargos_recomendados = [];
            vm.data.origenes = [];
        }


        /**
         * VALIDATION CHIP
         */

        vm.validationChip = function (data, chip) {
            if (!angular.isObject(chip)) {
                data.pop();
            }
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        vm.init();
    }
})();
(function () {

    'use strict';

    angular.module('app.seleccion_analyst').controller('changeDatePublicController', changeDatePublicController);

    function changeDatePublicController(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, analystMisc, request) {
        //constructor
        var vm = this;

        vm.data = {};

        vm.data.emptyDateEnd = false;

        vm.error = {};

        vm.tomorrow = new Date(moment().add(1, 'days'));

        vm.closeDialog = function (request) {
            $mdDialog.cancel();
        };


        vm.save = function () {
            var data = {};

            data.proceso_id = request.id;

            if(vm.data.emptyDateEnd){
                data.fecha_final = null;
            }else{
                if(vm.data.dateEnd){
                    data.fecha_final = moment(vm.data.dateEnd).format('YYYY-MM-DD');;
                }else{
                    vm.error.dateEmpty = true;
                    return;
                }
            }

            analystService.changeDateEndOffer(data,
                function (response) {
                    $mdDialog.hide();
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error enviando la información de cierre de publicación, por favor intente de nuevo.");
                }
            );
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('approveEmailsDialog', ApproveEmailsDialog);

    function ApproveEmailsDialog(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, analystMisc, $scope, $mdConstant, email,title) {

        //constructo
        var vm = this;
        vm.data = {};
        vm.data.emails = [];
        vm.emailsError = [];
        vm.emptyCorrectEmails = false;
        vm.emailsCorrects = [];
        vm.title = title;
        if (email) {
            vm.data.emails.push(email.toLowerCase());
        } 
        vm.keysSeparator = [$mdConstant.KEY_CODE.SPACE, $mdConstant.KEY_CODE.ENTER,$mdConstant.KEY_CODE.COMMA,$mdConstant.KEY_CODE.TAB];

        vm.sendEmail = function () {
            vm.serializeEmails();
            if (vm.emailsCorrects.length > 0) {
                $mdDialog.hide(vm.emailsCorrects);
            } else {
                vm.emptyCorrectEmails = true;
            }
        }

        $scope.$watch('vm.data.emails', function (newValue, oldValue) {
            if (newValue.length > oldValue.length) {
                if (!IkanoFactory.validateEmail(newValue[newValue.length - 1])) {
                    vm.emailsError.push(newValue[newValue.length - 1]);
                }
            }
            vm.deleteEmailsFailed();
        }, true);

        vm.deleteEmailsFailed = function () {
            for (var i in vm.emailsError) {
                if (vm.data.emails.indexOf(vm.emailsError[i]) == -1) {
                    vm.emailsError.splice(i, 1);
                }
            }
        }

        vm.serializeEmails = function () {
            for (var i in vm.data.emails) {
                if (vm.emailsError.indexOf(vm.data.emails[i]) == -1) {

                    vm.emailsCorrects.push(vm.data.emails[i]);
                }
            }
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        }
    }

})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('ShowRequestNotesController', ShowRequestNotesController);

    function ShowRequestNotesController(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, request, analystMisc) {
        var vm = this;
        vm.request = request;
        vm.noteSelected = {};
        vm.noteSelectedIndex = null;

        vm.user = AuthService.getUserData();

        vm.changeForm = function () {
            if (vm.showForm) {
                vm.showForm = false;
            } else {
                vm.showForm = true;
            }
        }

        vm.editNote = function (note, index) {
            vm.noteSelected = note;
            vm.noteSelectedIndex = index;
        }

        vm.deselectedNote = function () {
            vm.noteSelected = {};
            vm.noteSelectedIndex = null;
        }


        vm.addNoteRequest = function (data) {
            var dataPost = {};
            dataPost.observacion_id = (data.id) ? data.id : null;
            dataPost.proceso_id = vm.request.id;
            dataPost.observacion = data.note;
            analystService.addNoteRequest(dataPost, function (response) {
                if (!dataPost.observacion_id) {
                    var newNota = {};
                    newNota.name = AuthService.getUserData().name;
                    newNota.id = response.data.result.id;
                    newNota.date_create_note = analystMisc.misc.setFormatDate(response.data.result.created_at, { format: 'MMM D, YYYY H:mm ' });
                    newNota.note = response.data.result.descripcion;
                    newNota.newNote = true;
                    request.notes.unshift(newNota);
                } else {
                    request.notes[vm.noteSelectedIndex] = angular.copy(vm.noteSelected);
                }
                vm.deselectedNote();

            },
                function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error creando la nota para el proceso, por favor intente de nuevo.");
                });
        }

        vm.deleteNote = function (note, index) {
            var dataPost = {};
            dataPost.observacion_id = note.id;
            dataPost.proceso_id = vm.request.id;

            analystService.deleteObservacion(
                dataPost,
                function (response) {
                    request.notes.splice(index, 1);
                }, function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error eliminando la nota, por favor intente de nuevo.");
                });
        }

        vm.closeDialog = function () {
            $mdDialog.hide();
        };
    }

})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('ShowCandidateNotesController', ShowCandidateNotesController);

    function ShowCandidateNotesController(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, candidate, request, analystMisc, title) {
        var vm = this;
        vm.candidate = candidate;
        vm.request = request;
        vm.showForm = false;
        vm.noteSelected = {};
        vm.noteSelectedIndex = null;
        vm.title = title;
        vm.data = {};
        vm.data.visibility = 1;

        vm.user = AuthService.getUserData();

        vm.changeForm = function () {
            if (vm.showForm) {
                vm.showForm = false;
                vm.data.note = "";
            } else {
                vm.showForm = true;
            }
        }

        vm.editNote = function (note, index) {
            vm.noteSelected = angular.copy(note);
            vm.noteSelectedIndex = index;
        }

        vm.deselectedNote = function () {
            vm.noteSelected = {};
            vm.noteSelectedIndex = null;
        }

        vm.addNoteCandidate = function (data) {
            var dataPost = {};
            dataPost.nota_id = (data.id) ? data.id : null;
            dataPost.proceso_id = vm.request.id;
            dataPost.hoja_vida_id = vm.candidate.id;
            dataPost.nota = data.note;
            dataPost.visibilidad = data.visibility;
            vm.noteSelected.owner = 1;
            analystService.addNote(dataPost, function (response) {
                if (!dataPost.nota_id) {
                    var newNota = {};
                    newNota.name = AuthService.getUserData().name;
                    newNota.id = response.data.result.id;
                    newNota.date_create_note = analystMisc.misc.setFormatDate(response.data.result.created_at, { format: 'MMM D, YYYY H:mm A' });
                    newNota.note = response.data.result.nota;
                    newNota.visibility = response.data.result.visibilidad;
                    newNota.newNote = true;
                    newNota.owner = 1;
                    candidate.notes.unshift(newNota);
                    newNota = {};

                } else {
                    candidate.notes[vm.noteSelectedIndex] = angular.copy(vm.noteSelected);
                }
                vm.deselectedNote();
            },
                function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                });
        }

        vm.deleteNote = function (note, index) {
            var dataPost = {};
            dataPost.nota_id = note.id;
            dataPost.proceso_id = vm.request.id;
            dataPost.hoja_vida_id = vm.candidate.id;

            analystService.deleteNote(
                dataPost,
                function (response) {
                    candidate.notes.splice(index,1);
                }, function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error eliminando la nota, por favor intente de nuevo.");
                });
        }


        vm.closeDialog = function () {
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('ShowCandidateHistoryController', ShowCandidateHistoryController);

    function ShowCandidateHistoryController(AuthService, AdminService, analystService, IkanoFactory, $scope, $mdDialog, $state, ValidationService, candidate, history, stages, lists, request) {
        var vm = this;
        vm.candidate = candidate;
        vm.historyBackup = history;
        vm.history = history;
        vm.title = "Historial de procesos";
        vm.blockStage = {};
        vm.stagesBackup = stages;
        vm.stages = [];
        vm.showDetalle = true;
        vm.showBlocks = false;
        vm.listas = lists;
        vm.proceso = request;
        vm.procesList = [];
        vm.misc = {};
        vm.processSelected = -1;
        vm.stageSelected = -1;
        vm.stageData = {};
        vm.loading = {};


        vm.setHistory = function (history) {
            if (vm.blockStage[history.proceso.id]) {
                vm.showDetalle = false;
                vm.showBlocks = true;
                vm.historySelected = history;
                vm.stages = [];
                serializeStages(vm.blockStage[history.proceso.id].data);
            } else {
                getHistoryProcessCandidate(history);
            }
        }

        vm.setResume = function () {
            vm.showDetalle = true;
            vm.showBlocks = false;
            vm.historySelected = null;
            vm.blocksStage = [];
            vm.stageSelected = -1;
        }

        vm.setStage = function () {
            var blockStage = vm.blockStage[vm.historySelected.proceso.id];
            var stage = vm.stageSelected;
            if(stage == -1){
                return;
            }
            var valueStage = (blockStage.data[stage.id]) ? blockStage.data[stage.id] : {};
            vm.blockAutoRellenar = [];
            vm.stageData.data = {
                bloques: blockStage.bloques[stage.etapa],
                data: valueStage,
                estructura_campos: blockStage.estructura_campos,
                listas: vm.listas
            }

            vm.stageData.attachments = blockStage.adjuntos;

            vm.stageData.extra = {
                etapa_id: stage.id,
                //proceso_id: vm.proceso.id,
                hv_id: vm.candidate.id
            }

            vm.stageData.getAttachmentUrl = getAttachmentUrl;

            vm.stageData.values = angular.copy(vm.stageData.data.data);
            if (!angular.equals(vm.stageData.values, {})) {
                vm.misc.values = {};
                vm.misc.values.created_at = moment(vm.stageData.values.created_at).format('MMM D, YYYY hh:mm a');
                vm.misc.values.updated_at = moment(vm.stageData.values.updated_at).format('MMM D, YYYY hh:mm a');
                vm.misc.values.analista = angular.copy(vm.stageData.values.analista);
            } else {
                vm.misc.values = false;
            }

            vm.stageData.lists = angular.copy(vm.listas);
            vm.stageData.fields = getFieldsEtapa(vm.stageData.data.estructura_campos, vm.stageData.data.bloques);
            vm.backupValues = angular.copy(vm.stageData.values);
            setBlocksStage();
            setValuesWatch(vm.stageData);
        }

        vm.filterProcess = function () {
            if (vm.processSelected == -1) {
                vm.history = angular.copy(vm.historyBackup);
            } else {
                vm.history = vm.historyBackup.filter(function (element) {
                    return element.proceso.id == vm.processSelected;
                });
            }

        }

        function getHistoryProcessCandidate(history) {
            vm.loading[history.proceso.id] = true;
            analystService.getHistoryProcessCandidate({ proceso_id: history.proceso.id, hv_id: vm.candidate.id }, function (response) {

                if (!response.data.status) {
                    IkanoFactory.showAlert("Error", response.data.message);
                } else {
                    vm.showDetalle = false;
                    vm.showBlocks = true;
                    vm.historySelected = history;
                    vm.stages = [];
                    vm.blockStage[history.proceso.id] = response.data.data.historial_participacion;
                    vm.blockStage[history.proceso.id].estructura_campos  = response.data.data.estructura_campos;
                    serializeStages(vm.blockStage[history.proceso.id].data);
                }
                vm.loading[history.proceso.id] = false;
            }, function (reject) {
                vm.loading[history.proceso.id] = false;
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada. por favor intente de nuevo.");
            },true);
        }

        function serializeFiltroHistory() {
            for (var h in vm.history) {
                //if (vm.history[h].proceso.id != vm.proceso.id) {
                    vm.procesList.push({id:vm.history[h].proceso.id,name:vm.history[h].proceso.cargo.name});
                //}
            }
        }

        function getAttachmentUrl(attachment) {
            var id = (typeof attachment !== "number") ? attachment.id : attachment;
            analystService.getFile({ id: id }, { responseType: 'arraybuffer' },
                function (response) {
                    IkanoFactory.downloadFile(response.data, attachment.name)
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error descargando el archivo, por favor intente de nuevo.");
                });
        }

        function setBlocksStage() {
            vm.blocksStage = $.map(vm.stageData.data.bloques, function (value, index) {
                return [getBlockStage(index, value)];
            });
        };

        function getBlockStage(index, data) {
            var block = {
                id: null,
                name: index,
                model: (data.etapa == "informacion_seleccion" ? data.etapa : data.model),
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.type == "has_many" ? IkanoFactory.getStructureForFieldsHasMany(data.campos, vm.stageData.fields, data.model) : IkanoFactory.getStructureForFields(data.campos, vm.stageData.fields),
                collapse: (data.etapa == 'pruebas'),
                hideCollapse: (data.etapa == 'pruebas'),
                subtitle: data.subtitle
            };
            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            } else if (block.model == 'kbit_pruebas' || block.model == 'waiss4_pruebas' || block.model == 'btsa_pruebas' || block.model == 'pruebas_16pf' || block.model == 'mips_pruebas') {
                block.type = "one-column";
            }

            return block;
        };

        function setValuesWatch(root) {
            ValidationService.setWarchers($scope, root);
        };

        function getFieldsEtapa(fields, bloques) {
            var objReturn = {};
            for (var i in bloques) {
                if (bloques[i].auto_rellenar) {
                    vm.blockAutoRellenar.push(bloques[i]);
                }
                for (var j in bloques[i].campos) {
                    var keySearch = "";
                    if (bloques[i].type == "has_many") {
                        keySearch = bloques[i].model;
                    } else {
                        keySearch = bloques[i].campos[j];
                    }

                    objReturn[keySearch] = fields[keySearch];
                }
            }
            return objReturn;
        }

        function serializeStages(data) {
            for (var i in vm.stagesBackup) {
                if (data[vm.stagesBackup[i].id]) {
                    vm.stages.push(vm.stagesBackup[i]);
                }
            }

        }

        serializeFiltroHistory();

        vm.closeDialog = function () {
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('ReportForTheClient', ReportForTheClient);

    function ReportForTheClient(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state,ValidationService, blocks,$scope) {
        var vm = this;
        
        vm.validationService = ValidationService;

        vm.pageInfo = {};

        vm.closeDialog = function() {
            $mdDialog.hide();
        };

        vm.modelUnderstanding = function (data) {
            vm.data = data;
            vm.values = data.data;
            vm.lists = vm.data.listas;
            //vm.fields = vm.data.estructura_campos;
            vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
            vm.extra = vm.data.extra;
            vm.observations = vm.data.observaciones;
            vm.setPageData();
            vm.setValuesWatch();
            vm.change = false;
            vm.setBlocks();
            ValidationService.generalFunctions($scope, vm);
        }

        vm.setPageData = function () {
            vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
            vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
            if (vm.data.data.no_vacantes) {
                var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
                vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
            }

            vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
            if (vm.data.data.tipo_solicitud_b_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
            }
            if (vm.data.data.tipo_solicitud_c_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
            }
        };

        vm.setValuesWatch = function () {
            ValidationService.setWarchers($scope, vm);
        };

        vm.setBlocks = function () {
            vm.blocks = $.map(vm.data.bloques, function (value, index) {
                return [vm.getBlock(index, value)];
            });
        };

        vm.getBlock = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.campos
            };

            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }

            return block;
        };

        vm.addModelToBlock = function (block) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            vm.values[block.model].push(model);
        }

        vm.removeModelToBlock = function (block, index) {
            vm.values[block.model].splice(index, 1);
        }

        vm.getPositionColaborators = function (position) {
            AdminService.getPositionColaborators({ cargo_id: position }, {},
                function (response) {
                    if (response.data.colaboradores) {
                        vm.lists.position_colaborators = response.data.colaboradores;
                    }
                },
                function (response) {
                    //IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };


        vm.modelUnderstanding(blocks);

    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('RecommendCandidateController', RecommendCandidateController);

    function RecommendCandidateController(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, positions, candidate) {
        var vm = this;
        vm.positions = positions;

        vm.candidate = candidate;

        vm.data = {
            hoja_vida_id: vm.candidate.id,
            descripcion: ''
        }

        vm.title = "Recomendar candidato";
        vm.selectedItem = null;


        vm.addRecommendCandidate = function () {
            vm.data.cargo_id = vm.selectedItem.id;

            analystService.addRecommendCandidate(
                vm.data, 
                function (response) {
                    if (response.data.status) {
                        vm.candidate.recomendaciones = response.data.data;
                        vm.candidate.recomendaciones[(vm.candidate.recomendaciones.length - 1)].new = true;

                        vm.selectedItem = null;
                        vm.searchText = "";
                        $mdDialog.hide();
                    }
                },
                function (response) {
                    IkanoFactory.showAlert("Error", response.data.message);
                }
            );
        }

        vm.querySearch = function(query) {
            var results = query ? vm.positions.filter(createFilterFor(query)) : vm.positions, deferred;
            if (self.simulateQuery) {
                deferred = $q.defer();

                $timeout(function () {
                    deferred.resolve(results);
                },
                    Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        //filter function for search query
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(position) {
                var value = angular.lowercase(position.name);
                return value.indexOf(lowercaseQuery.toLowerCase())!=-1;
            };
        }

        vm.closeDialog = function() {
            $mdDialog.hide();
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('ImportStage', ImportStage);

    function ImportStage(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, ValidationService, $scope, idRequest, candidate, stages) {

        //Constructor
        var vm = this;

        vm.validationService = ValidationService;
        vm.blocksStage = [];
        vm.stages = stages;
        vm.idRequest = idRequest;
        vm.candidate = candidate;
        vm.loading = false;
        vm.etapasImport = [];
        vm.stagesData = {};
        vm.checkStages = [];

        vm.requestSelectedChange = function (request) {
            var dataPost = {
                proceso_id: request,
                hoja_vida_id: vm.candidate.candidato.id
            };
            vm.loading = true;
            analystService.importStages(dataPost, function (response) {
                mergeStages(response.data.etapas);
                vm.loading = false;
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error enviado la información, por favor intente de nuevo.");
                vm.loading = true;
            });
        }

        vm.stagesSelecteds = function (index) {
            var indexBlock = vm.checkStages.indexOf(index);
            if (indexBlock == -1) {
                vm.checkStages.push(index);
            } else {
                vm.checkStages.splice(indexBlock, 1);
            }
        }

        vm.sendStagesData = function () { 
            var objReturn = {}; 
            var objMisc = {}; 
            var keyDiscard = [
                '_id',
                'analista',
                'analista_id',
                'updated_at',
                'created_at'
            ];
            for (var i in vm.checkStages) {
                objMisc[vm.etapasImport[vm.checkStages[i]].id] = vm.stagesData[vm.etapasImport[vm.checkStages[i]].id];
            }

            angular.forEach(objMisc, function (v, k) {
                objReturn[k] = {};
                angular.forEach(v,function(value,key){
                    if(keyDiscard.indexOf(key) === -1 ){
                        objReturn[k][key] = value;
                    }
                });
            });

            $mdDialog.hide(objReturn);
        }

        function mergeStages(etapas) {
            vm.etapasImport = [];
            vm.stagesData = etapas;
            angular.forEach(etapas, function (v, k) {

                var stages = vm.stages.filter(function (element) {
                    return element.id == k;
                });
                if (stages.length > 0) {
                    vm.etapasImport.push(stages[0]);
                }
            });
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('DiscardStage', DiscardStage);

    function DiscardStage(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, ValidationService, $scope, data, stage, idRequest, idCandidate, candidate, title, incompletStage, config, $mdToast) {

        //Constructor
        var vm = this;

        vm.validationService = ValidationService;
        vm.blocksStage = [];
        vm.stage = stage;
        vm.idRequest = idRequest;
        vm.idCandidate = idCandidate;
        vm.candidate = candidate;
        vm.title = title;
        vm.incompletStage = incompletStage;
        vm.config = config;
        vm.hideMessage = vm.stage.id == 9 ? (candidate.candidato.es_colaborador ? false : true) : true;

    

        vm.sendCenso = function () {
            AdminService.restablecer_colaborador_enviado({
                proceso_id: vm.idRequest,
                hoja_vida_id: vm.idCandidate
            }, function (resolve) {
                showToast({ class: "success", message: resolve.data.message, showClose: true });
                vm.hideMessage = true;
            }, function (reject) {
                showToast({ class: "error", message: reject.data.message, showClose: true });
            });
        }

        function showToast(data, options) {
            options = (options) ? options : [];
            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        vm.initBlock = function () {
            vm.data = angular.copy(data);

            vm.values = vm.data.data;
            vm.values.objetivo_cumpliento = null;
            vm.values.validacionFechasIncumplimiento = true; // Flag de validación de fechas de incumplimiento, afecta el botón de Aceptar
            
            vm.lists = vm.data.listas;
            vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
            
            if (vm.stage.id == 9) {
                if (vm.fields.fecha_requisicion) {
                    vm.fields.fecha_requisicion.permiso = false;
                }
                if (vm.fields.fecha_acuerdo_servicio) {
                    vm.fields.fecha_acuerdo_servicio.permiso = false;
                }
                /*if (!vm.values.salario_basico_sugerida || vm.values.salario_basico_sugerida == 0) {
                    vm.values.salario_basico_sugerida = vm.values.compensacion_salario * 1;
                    //vm.values.salario_variable_sugerida = vm.values.compensacion_salario;
                }*/
            }
            vm.setBlocksStage();
            vm.setValuesWatch();
        }


        /**
        * BLOQUES ETAPA
        */

        vm.setBlocksStage = function () {
            vm.blocksStage = $.map(vm.data.bloques, function (value, index) {
                return [vm.getBlockStage(index, value)];
            });
            vm.blocksStageBackup = angular.copy(vm.blocksStage);
            vm.blocksStage.splice(2,1);
        };

        vm.setValuesWatch = function () {
            ValidationService.setWarchers($scope, vm);
            if (vm.stage.id == 9) {

                function onChangeDates(){
                    vm.values.objetivo_cumpliento = undefined;

                    var dateAccept = vm.values["fecha_aceptacion"] || null;
                    var dateIngreso = vm.values["fecha_ingreso"] || null;
                    var dateRequest = vm.values["fecha_acuerdo_servicio"] || null;

                    if (dateAccept && dateIngreso) {                      
                        get_onchange_data(dateAccept, dateRequest, dateIngreso);
                    }
                }

                $scope.$watch("vm.values['fecha_aceptacion']", onChangeDates, true);
                $scope.$watch("vm.values['fecha_ingreso']", onChangeDates, true);
            }
        };

        function get_onchange_data(fecha_aceptacion, fecha_acuerdo_servicio, fecha_ingreso) {
            AdminService.get_onchange_data({
                function: 'incumplimiento',
                values: {
                    proceso_id: vm.idRequest,
                    fecha_acuerdo_servicio: fecha_acuerdo_servicio,
                    fecha_aceptacion: fecha_aceptacion,
                    fecha_ingreso: fecha_ingreso
                }
            }, function (resolve) {
                if (resolve.data.status){
                    if (resolve.data.data.data.tiempo_aceptacion === false){
                        vm.values.objetivo_cumpliento = resolve.data.data.data;

                        if (!vm.blocksStage[2]){
                            vm.blocksStage.push(vm.blocksStageBackup[2]);
                        }
                    } else {
                        vm.values.validacionFechasIncumplimiento = true;
                        vm.blocksStage.splice(2,1);
                    }
                }
            }, function (reject) {
                showToast({ class: "error", message: reject.data.message, showClose: true });
            });
        }

        vm.getBlockStage = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "one-column",
                block: data.model.type,
                fields: data.type == "has_many" ? IkanoFactory.getStructureForFieldsHasMany(data.campos,vm.fields,data.model) : IkanoFactory.getStructureForFields(data.campos,vm.fields)
            };

            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }
            return block;
        };

        function getEstructureCampos(campos){
            return campos.map(function(element){
                return vm.fields[element];
            });
        }

        vm.addModelToBlock = function (block) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            if (vm.values[block.model] == "undefined" || vm.values[block.model] == null) {
                vm.values[block.model] = [];
            }

            vm.values[block.model].push(model);
        }

        vm.removeModelToBlock = function (block, index) {
            vm.values[block.model].splice(index, 1);
        }

        vm.saveStage = function (stage, data, approve) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.hv_id = vm.idCandidate;
            dataPost.etapa_id = stage.id;
            dataPost.aprueba = approve;
            dataPost.data = (!data) ? {} : data;
            dataPost.pasar_etapa = 1;
            analystService.saveStage(dataPost, function (response) {
                $mdDialog.hide(response);
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error enviado la información, por favor intente de nuevo.");
            });
        }

        vm.validateDataStage = function (approve) {
          if (!approve) {
            vm.saveStage(vm.stage, {}, approve);
          } else {
            console.log(vm.fields, vm.values);
            var validateFields = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values, true,true);
            console.log(validateFields);
            var value = validateFields.data;
            vm.errors = validateFields.messages;

            if(vm.values.objetivo_cumpliento && vm.values.objetivo_cumpliento.tiempo_aceptacion === false){
              if(typeof vm.values.causas_incumplimiento_seleccionado == 'undefined'){
                vm.errors['causas_incumplimiento_seleccionado'] = 'Este campo es obligatorio'
              }
              if(typeof vm.values.causas_incumplimiento_as_aceptacion == 'undefined'){
                vm.errors['causas_incumplimiento_as_aceptacion'] = 'Este campo es obligatorio'
              }
              if(typeof vm.values.causas_incumplimiento_aceptaction_ingreso == 'undefined'){
                vm.errors['causas_incumplimiento_aceptaction_ingreso'] = 'Este campo es obligatorio'
              }
            }

            console.log(vm.errors)
              
            if (!angular.equals(vm.errors, {})) {
              return;
            }

            vm.errors = {};
            vm.saveStage(vm.stage, value, approve);

            return;
          }

        }

        /**
         * END BLOQUES ETAPA
         */


        vm.initBlock();

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };
    }
})();
(function (){
    'use strict';

    angular.module('app.seleccion_analyst').controller('ConfirmStage', ConfirmStage);

    function ConfirmStage(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, ValidationService, $scope,stage,candidate,stageIncomplet,idRequest){

        //constructor
        var vm = this;

        vm.candidate = candidate;
        vm.stage = stage;
        vm.stageIncomplet = stageIncomplet;
        vm.idRequest = idRequest;


        vm.validateStage = function(approve){
            if(vm.stageIncomplet.length > 0){
                $mdDialog.cancel();
            }else{
                vm.saveStage(approve);
            }
        }
        vm.saveStage = function (approve) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.hv_id = vm.candidate.id;
            dataPost.etapa_id = vm.stage.id;
            dataPost.aprueba = approve;
            dataPost.data = {};
            analystService.saveStage(dataPost, function (response) {
                $mdDialog.hide(response);
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error pasando el candidato a la etapa "+vm.stage.name+", por favor intente de nuevo.");
            });
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin').controller('CancelRequestController', CancelRequestController);

    /** @ngInject */
    function CancelRequestController($mdDialog, AdminService, IkanoFactory, idRequest, data) {
        var vm = this;
        vm.idRequest = idRequest;
        vm.data = data;
        vm.formData = {};
        vm.loading = false;

        vm.cancel =  function() {
            vm.loading = true;
            vm.formData.id = vm.idRequest;
			AdminService.cancelRequest(vm.formData, {}, 
				function(response) {
                    if (response.data.result.status) {
                        //IkanoFactory.showAlert("", "Se ha anulado la resquisición.");
                        vm.data.options.anular = false;
                        vm.data.options.aprobar = false;
                        vm.data.options.devolver = false;
                        vm.data.options.rechazar = false;
                        vm.data.options.update = false;
                        vm.data.options.enviar_aprobacion = false;
                        
                        vm.data.aprobadores = response.data.result.data.requisicion.aprobadores;
                        vm.data.data = response.data.result.data.requisicion.data;
                        vm.data.extra = response.data.result.data.requisicion.extra;
                        
                        vm.loading = false;
                        vm.closeDialog();
                    }
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
				}
			);
		}

        vm.closeDialog = function() {
            $mdDialog.hide();
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('UdpateRequestController', UdpateRequestController);

	/** @ngInject */
	function UdpateRequestController($mdDialog, $document, $mdSidenav, $state, $scope, AdminService, ValidationService, CandidateService, IkanoFactory, IkanoFactoryPagination) {
		var vm = this;

		vm.id = $state.params.id + "";
		vm.data = null;
		vm.blocks = [];
		vm.lists = null;
		vm.fields = null;
		vm.extra = null;
		vm.loading = true;
		vm.loadPositions = false;
		vm.errors = {};
		vm.values = {};
		vm.oldValues = {};
		vm.change = false;
		vm.type = 0;

		vm.saveButtonTitle = "Guardar";
		vm.saving = false;

		vm.observations = [];
		vm.obsForm = {};
		vm.showObsForm = false;
		vm.showRequest = true;
		vm.validationService = ValidationService;

		vm.pageInfo = {
			icon: "icon-home",
			parents: ['EDITAR REQUISICIÓN'],
			title: "",
		};

		vm.cleanDataTables = function(){
			IkanoFactoryPagination.setKey('app.seleccion_requisiciones_enaprobacion');
			IkanoFactoryPagination.clear();
			IkanoFactoryPagination.setKey('app.seleccion_requisiciones_todas');
			IkanoFactoryPagination.clear();
			IkanoFactoryPagination.setKey('app.seleccion_requisiciones_construccion');
			IkanoFactoryPagination.clear();
		}

		vm.getRequest = function () {
			vm.requestTypes = [];
			vm.extraRequests = [];

			if (vm.type) {
				var data = {
					tipo_solicitud: vm.type
				};

        vm.type = 0;
			} else {
				var data = {
					id: vm.id
				};
			}

			AdminService.getRequest(data,  {},
				function (response) {
          if (response.data.requisicion && response.data.requisicion.data && !angular.equals(response.data.requisicion.data, {})) {            
            vm.data = angular.copy(response.data.requisicion);
            //vm.values = response.data.requisicion.data;

            vm.values = vm.mergeObjects(angular.copy(response.data.requisicion.data), vm.oldValues);

            vm.observations = vm.data.observaciones;
            vm.lists = vm.data.listas;
            //vm.fields = vm.data.estructura_campos;
            vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
            vm.extra = vm.data.extra;
            vm.setPageData();
            vm.setValuesWatch();

            ValidationService.generalFunctions($scope, vm);
            ValidationService.watchFunctions($scope, vm);

            vm.change = false;
            vm.setBlocks();
          }

          var response_data = angular.copy(response.data)

					vm.requestTypes = IkanoFactory.convertRequestTypesObjToArrayObjects(response_data.tipos_solicitud);
					vm.listCountry = response_data.paises_procesos;

					if (response_data.tipos_solicitud_extra_ids && response_data.tipos_solicitud_extra_ids.length) {
						vm.modelRequestTypes(vm.requestTypes, response_data.tipos_solicitud_extra_ids);
					}

          vm.loading = false;
				},
				function (response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.loading = false;
				}
			);
		};

		vm.onchange_lists = function(lista){
            $.each(vm.lists,function(key,value){
                if(lista[key]){
                    vm.lists[key] = lista[key];
                }
			});
			for(var c in vm.data.estructura_campos){
                var campo = vm.data.estructura_campos[c];
                if(lista[campo.options]){
                    $scope.$broadcast('changeList'+c,lista[campo.options]);
                }
            }
        }

		vm.modelRequestTypes = function (requests, extras) {
			vm.extraRequests = [];

			for (var index = 0; index < extras.length; index++) {
				var element = extras[index];
				for (var j = 0; j < requests.length; j++) {
					var type = requests[j];

					if (type.id == element) {
						vm.extraRequests.push(type);
					}
				}
			}
		};

		vm.checkEmptyObject = function (obj) {
			if (angular.equals(obj, {})) {
				return true;
			}

			return false;
		}

		vm.setPageData = function () {
			vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
			vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
			if (vm.data.data.no_vacantes) {
				var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
				vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
			}

			vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
			if (vm.data.data.tipo_solicitud_b_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
			}
			if (vm.data.data.tipo_solicitud_c_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
			}
		};

		vm.mergeObjects = function (obj, src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) obj[key] = src[key];
			}
			return obj;
		}

		vm.getRequest();

		vm.first = true;
		vm.setValuesWatch = function () {
			ValidationService.setWarchers($scope, vm);
		}

		vm.setBlocks = function () {
			vm.blocks = $.map(vm.data.bloques, function (value, index) {
				return [vm.getBlock(index, value)];
			});
		};

		vm.getBlock = function (index, data) {
			var block = {
				id: null,
				name: index,
				model: data.model,
				title: (data.name ? data.name.split(" ") : ""),
				type: "two-columns",
				notes: (data.titulo ? data.titulo.edit : null),
				block: data.model.type,
				fields: data.campos
			};

			if (block.name == "info_general") {
				block.type = "one-column";
			} else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
				block.type = "select-current-employee";
			} else if (block.fields.length < 2) {
				block.type = "one-column";
			} else if (data.type == "has_many") {
				block.type = "two-column-multiple-rows";
			}

			return block;
		};

		vm.addModelToBlock = function (block) {
			var model = {};
			for (var index = 0; index < block.fields.length; index++) {
				var element = block.fields[index];
				model[element] = null;
			}
			vm.values[block.model].push(model);
		}

		vm.removeModelToBlock = function (block, index) {
			vm.values[block.model].splice(index, 1);
		}

		vm.getValue = function (field, value) {
			if (field.options) {
				if (vm.lists[field.options][value]) {
					return vm.lists[field.options][value];
				}

				return value;
			}

			return value;
		};

		vm.addObservation = function () {
			vm.obsForm.requisicion_id = vm.id;

			AdminService.saveObservationsRequest(vm.obsForm,  {},
				function (response) {
					if (response.data.requisicion.status) {
						vm.showObsForm = false;
						vm.obsForm.id = null;
						vm.obsForm.comentario = "";
						vm.observations = response.data.requisicion.data.observaciones;
					} else {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}
				},
				function (response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.updateObservation = function (obs) {
			vm.obsForm.id = obs.id;
			vm.obsForm.comentario = obs.comentario;
			vm.showObsForm = true;
		};

		vm.validate = function (ev) {
			vm.saving = true;
			vm.saveButtonTitle = "Guardando...";

			vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values);

			if ((vm.values.no_vacantes * 1) > 1) {
				vm.openDivideRequestDialog();
			} else {
				vm.save();
			}
		};

		vm.getPositionColaborators = function (position) {
			AdminService.getPositionColaborators({ cargo_id: position, proceso_id: vm.id },  {},
				function (response) {
					if (response.data.colaboradores && !angular.equals(response.data.colaboradores, {})) {
						var colaboradores = response.data.colaboradores;
						vm.lists.position_colaborators = IkanoFactory.setPositionsId(response.data.colaboradores, 'estructura_id');

						if (vm.lists.position_colaborators && vm.loadColaborators) {
							vm.values = ValidationService.refreshFieldsValues(vm.values, colaboradores);
						}

						//CAMBIAR ID DE INFO_OCUPANTE_ACTUAL POR ESTRUCTURA_ID
						var newInfo = [];
						for (var i in vm.values.info_ocupante_actual) {
							var ocupante = vm.values.info_ocupante_actual[i];
							if (colaboradores[ocupante]) {
								newInfo.push((colaboradores[ocupante].estructura_id ? colaboradores[ocupante].estructura_id : colaboradores[ocupante].id) + "");
							}
						}
						vm.values.notChangeInfoActual = true;
						vm.values.info_ocupante_actual = newInfo;
						vm.loadColaborators = true;
					}
				},
				function (response) {
					//IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.openUpdateRequestTypeDialog = function () {
			vm.save(false, true);
		};

		vm.save = function (send, requestType) {
			vm.errors = {};
			/*
			if (!vm.values.cargo_ocupar) {
				vm.errors = {cargo_ocupar: "Debes ingresar al menos el nombre del cargo, para poder guardar."};
                vm.saving = false;
                vm.saveButtonTitle = "Guardar";
				IkanoFactory.showAlert("Error", "La requisición se encuentra incompleta, por favor haga clic en modificar y complete la requisición para enviarla a aprobación.");
            } else {
			*/
			var data = {
				id: vm.id,
				data: vm.values
			};

			AdminService.saveRequest(data,  {},
				function (response) {
					if (response.data.result.status) {

						vm.cleanDataTables();
						//IkanoFactory.showAlert("", "La requisición se ha guardado exitosamente.");
						vm.idRequest = response.data.result.data.id;

						if (!send && !requestType) {
							$state.go('app.seleccion_ver_requisicion', { id: response.data.result.data.id });
						}

						vm.change = false;
						if (send) {
							vm.sendRequest();
						}

						if (requestType) {
							vm.updateRequestTypeDialog();
						}

					} else {
						var def_msg = "Ha ocurrido un error, por favor intente de nuevo.";

						if (response.data.result.cust_msg) def_msg = response.data.result.cust_msg;

						IkanoFactory.showAlert("Error", def_msg);
					}

					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				},
				function (response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				}
			);
			/*
			}
			*/
		};

		vm.saveAndSend = function () {
			vm.save(true);
		}

		vm.sendRequest = function () {
			vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values, true);

			if (angular.equals(vm.errors, {})) {
				AdminService.sendRequest({ id: vm.idRequest },  {},
					function (response) {
						if (response.data.result.status) {
							IkanoFactory.showAlert("", "La requisición se ha enviado exitosamente.");
							$state.go('app.seleccion_ver_requisicion', { id: vm.idRequest });
						} else {
							var err_msg = "Ha ocurrido un error, por favor intente de nuevo."
							
							if (response.data.result.custom_msg) {
								err_msg = response.data.result.custom_msg;
							}
							
							IkanoFactory.showAlert("Error", err_msg);
						}

						vm.saving = false;
						vm.saveButtonTitle = "Guardar";
					},
					function (response) {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
						vm.saving = false;
						vm.saveButtonTitle = "Guardar";
					}
				);
			} else {
				IkanoFactory.showAlert("Error", "La requisición se encuentra incompleta, por favor haga clic en modificar y complete la requisición para enviarla a aprobación.");
			}
		};

		vm.getVacants = function () {
			var vacants = [];

			if (vm.values.no_vacantes * 1) {
				for (var index = 0; index < (vm.values.no_vacantes * 1); index++) {
					vacants.push(index);
				}
			}

			if (vm.values.info_ocupante_actual && vm.values.info_ocupante_actual.length) {
				vm.values.info_ocupante_actual.splice(vacants.length, (vm.values.info_ocupante_actual.length - vacants.length));
			}

			return vacants
		};

		vm.openSetEmployeesDialog = function (ev, index, name, field) {
			field.name = name;
			$mdDialog.show({
				controller: 'AddEmployeeController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin/requester/new-request/dialogs/add-employee.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					values: vm.values,
					index: index,
					field: field,
					errors: vm.errors,
					lists: vm.lists,
					event: ev,
				}
			}).then(function(response){
				if(field.name == 'info_ocupante_actual' && response[field.name][0] === null) {
					console.log(response[field.name]);
					vm.values[field.name] = [];
					return false
				}

				vm.values[field.name] = response[field.name];
			});
		};

		vm.openDivideRequestDialog = function (index, name, field) {
			$mdDialog.show({
				controller: 'DivideRequestController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin/requester/update-request/dialogs/divide-request.html',
				parent: angular.element($document.body),
				clickOutsideToClose: true,
				locals: {
					idRequest: vm.id,
					values: vm.values,
				}
			});
		};

		vm.updateRequestTypeDialog = function (ev) {
			$mdDialog.show({
				controller: 'UpdateRequestTypeController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin/approver/show-request/dialogs/update-request-type.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					idRequest: vm.id,
					data: vm.data,
					requestTypes: vm.requestTypes,
					extraRequests: vm.extraRequests,
					getRequest: vm.getRequest,
					listCountry: vm.listCountry,
					newRequest: false,
					event: ev,
				}
			});
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('ShowRequestController', ShowRequestController);

	/** @ngInject */
	function ShowRequestController($mdDialog, $document, $mdSidenav, $state, AdminService, CandidateService, IkanoFactory, ValidationService) {
		var vm = this;

		vm.id = $state.params.id + "";
		vm.data = null;
		vm.values = null;
		vm.blocks = [];
		vm.lists = null;
		vm.fields = null;
		vm.extra = null;
        vm.loading = true;
		vm.sidebar = true;
		vm.observations = [];
		vm.obsForm = {};
		vm.statusColor = {};
		vm.showObsForm = false;
		vm.errors = {};
		vm.validationService = ValidationService;
		vm.showRequest = true;
		vm.requestTypes = [];
		vm.extraRequests = [];
		vm.downloadPDFReportButton = true;

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['VER REQUISICIÓN'],
			title: "",
		};

		vm.getRequest = function() {
			AdminService.getRequest({id: vm.id}, {}, 
				function(response) {
					if (response.data.requisicion && response.data.requisicion.data) {
						vm.data = response.data.requisicion;
						vm.values = vm.data.data;
						vm.lists = vm.data.listas;
						vm.fields = vm.data.estructura_campos;
						vm.extra = vm.data.extra;
						vm.observations = vm.data.observaciones;
						vm.statusColor = {'background-color': vm.data.data.estado_color};
						vm.setPageData();
						vm.setBlocks();
						vm.getPositionColaborators(vm.values.cargo_id, vm.values.id);

						if(vm.data.original_data && vm.data.original_data.subarea_id){
							AdminService.get_onchange_data({values:{'ubicacion_id':vm.data.original_data.ubicacion_id},function:'getSubareas'},function(response){
								vm.data.original_data.subarea_id_lista = response.data.data.lista.list_subareas;
							});
						}
	
						vm.requestTypes = IkanoFactory.convertRequestTypesObjToArrayObjects(response.data.tipos_solicitud);
						vm.listCountry = response.data.paises_procesos;

						if (response.data.tipos_solicitud_extra_ids && response.data.tipos_solicitud_extra_ids.length) {
							vm.modelRequestTypes(vm.requestTypes, response.data.tipos_solicitud_extra_ids);
						}
					}
					vm.loading = false;
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.loading = false;
				}
			);
		};
		vm.getRequest();
		
		vm.modelRequestTypes = function(requests, extras) {
            for (var index = 0; index < extras.length; index++) {
                var element = extras[index];
                for (var j = 0; j < requests.length; j++) {
                    var type = requests[j];

                    if (type.id == element) {
                        vm.extraRequests.push(type);
                    }
                }
            }
        };

		vm.setPageData = function() {
			vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
			vm.pageInfo.title += '<span class="pl-5">' +  IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
			if (vm.data.data.no_vacantes) {
				var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
				vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
			}
			
			vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
			if (vm.data.data.tipo_solicitud_b_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
			}		
			if (vm.data.data.tipo_solicitud_c_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
			}
		};

		vm.getPositionColaborators = function(position, proceso_id) {
			AdminService.getPositionColaborators({proceso_id: proceso_id, cargo_id: position}, {}, 
				function(response) {
					if (response.data.colaboradores) {
						vm.lists.position_colaborators = response.data.colaboradores;
					}
				},
				function(response) {
					//IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
        }

		vm.setBlocks = function() {
			vm.blocks = $.map(vm.data.bloques, function(value, index) {
				return [vm.getBlock(index, value)];
            });
		};

		vm.getBlock = function(index, data) {
			var block = {
				id: null,
				name: index, 
				model: data.model,
				title: (data.name ? data.name.split(" ") : ""),
				type: "two-columns",
				block: data.model.type,
				fields: data.campos
			};

			if (block.fields.length < 2) {
				block.type = "one-column";
			} else if (data.type == "has_many") {
				block.type = "two-column-multiple-rows";
			}

			return block;
		};

		vm.getStatusColor = function(status) {
			if (status == 1) {
				return 'blue-bg';
			} else if (status == 2) {
				return 'green-bg';
			} else if (status == 3) {
				return 'grey-bg';
			} else if (status == 5) {
				return 'red-bg';
			}
		};

		vm.getIndicatorColor = IkanoFactory.getIndicatorColor;
		vm.displayCorrectApprover = IkanoFactory.displayCorrectApprover;

		vm.update = function() {
			$state.go('app.seleccion_update_requisicion', {id: vm.id});
		}

		vm.sendRequest = function() {
			vm.errors = {};
			vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values, true);

            if (angular.equals(vm.errors, {})) {
				AdminService.sendRequest({id: vm.id}, {}, 
					function(response) {
						if (response.data.result.status) {
							IkanoFactory.showAlert("", "La requisición se ha enviado exitosamente.");
							vm.data.options.enviar_aprobacion = false;
							vm.data.options.anular = false;
							vm.data.options.aprobar = false;
							vm.data.options.devolver = false;
							vm.data.options.rechazar = false;
							
							vm.data.aprobadores = response.data.result.data.requisicion.aprobadores;
							vm.data.data.estado = response.data.result.data.requisicion.data.estado;
							vm.data.data.estado_color = response.data.result.data.requisicion.data.estado_color;
							vm.data.data.estado_label = response.data.result.data.requisicion.data.estado_label;
							vm.data.extra = response.data.result.data.requisicion.extra;
						} else {
							var err_msg = "Ha ocurrido un error, por favor intente de nuevo."
							
							if (response.data.result.custom_msg) {
								err_msg = response.data.result.custom_msg;
							}
							
							IkanoFactory.showAlert("Error", err_msg);
						}

						vm.saving = false;
						vm.saveButtonTitle = "Guardar";
					},
					function(response) {
						
						console.log(response)
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
						vm.saving = false;
						vm.saveButtonTitle = "Guardar";
					}
				);
			} else {
				IkanoFactory.showAlert("Error", "La requisición se encuentra incompleta, por favor haga clic en modificar y complete la requisición para enviarla a aprobación.");
			}
		};

		vm.showReasons = function(reason, observations) {
			IkanoFactory.showAlert(reason, observations);
		};

		vm.addObservation = function() {
			vm.obsForm.requisicion_id = vm.id;

			AdminService.saveObservationsRequest(vm.obsForm, {}, 
				function(response) {
                    if (response.data.requisicion.status) {
						vm.showObsForm = false;
						vm.obsForm.id = null;
						vm.obsForm.comentario = "";
                        vm.observations = response.data.requisicion.data.observaciones;
                    } else {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.deleteObservation = function(ev, obs) {
			var data = {
				requisicion_id: vm.id * 1,
				id: obs.id
			}; 

			IkanoFactory.showConfirmAlert(ev, "Eliminar observación", "¿Está seguro que desea eliminar la observación?", data, vm.deleteObservationRequest);
		};

		vm.downloadPDFReport = function() {
			AdminService.getPDFReport(
				{id: vm.id, tipo: 'proceso'},
				{responseType : 'arraybuffer'},
				function(response) {
					if (response.data) {
						//IkanoFactory.downloadExcel(response.data);
						IkanoFactory.downloadFile(response.data, vm.data.data.codigo + '.pdf')
                    } else {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");    
                    }
				},
				function() {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.deleteObservationRequest = function(data) {
			AdminService.deleteObservationsRequest(data, {}, 
				function(response) {
                    if (response.data.requisicion.status) {
						vm.showObsForm = false;
						vm.obsForm.id = null;
						vm.obsForm.comentario = "";
                        vm.observations = response.data.requisicion.data.observaciones;
                    } else {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.updateObservation = function(obs) {
			vm.obsForm.id = obs.id;
			vm.obsForm.comentario = obs.comentario;
			vm.showObsForm = true;
		};

		vm.openCancelRequestDialog = function(ev, index, name, field) {
			$mdDialog.show({
                controller: 'CancelRequestController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/requests/dialogs/cancel-request.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.id,
					data: vm.data,
                    event: ev,
                }
            });
		};
		
		vm.openUpdateRequestTypeDialog = function(ev) {
			$mdDialog.show({
                controller: 'UpdateRequestTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/approver/show-request/dialogs/update-request-type.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.id,
					data: vm.data,
					requestTypes: vm.requestTypes,
					extraRequests: vm.extraRequests,
					getRequest: vm.getRequest,
					listCountry: vm.listCountry,
					newRequest: false,
                    event: ev,
                }
            });
		};

		vm.showReasons = function(reason, observations) {
			IkanoFactory.showAlert(reason, observations);
		};
		
        vm.toggleSidenav = function(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };
    }
})();
(function () {

	'use strict';
	angular
		.module('app.seleccion_admin')
		.controller('show-finalist-candidate', showFinalistCandidate);

	function showFinalistCandidate($mdDialog, $document, $mdSidenav, $state, AdminService, CandidateService, IkanoFactory, ValidationService, analystMisc, analystConstant, $q, $timeout, $scope, $compile, analystService, $mdToast, $mdColors) {
		//contructor
		var vm = this;

		vm.idRequest = $state.params.request_id + "";

		vm.pageInfo = {
			icon: "icon-home",
			parents: ['VER FINALISTAS'],
			title: "",
		};

		console.log("V 1");
		vm.getDiffBetweenTwoDates = IkanoFactory.getDiffBetweenTwoDates;

		vm.validationService = ValidationService;

		vm.misc = {};

		vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

		vm.dataPost = {};

		//COLOR
		vm.getThemeColor = $mdColors.getThemeColor;

		vm.getTerna = function () {
			AdminService.getTerna({ proceso_id: vm.idRequest },
				function (response) {
					vm.estructura_campos = response.data.estructura_campos;
					vm.blocksStage = response.data.bloques_etapa;
					vm.stages = response.data.etapas;
					vm.listsStage = response.data.listas_etapas;
					vm.recomendaciones = {};
					vm.recomendaciones.recomendaciones = response.data.recomendaciones ? response.data.recomendaciones : {};
					vm.recomendaciones.footer = response.data.recomendaciones_footer ? response.data.recomendaciones_footer : '';
					vm.recomendaciones.title = response.data.recomendaciones_title ? response.data.recomendaciones_title : '';
					vm.modelCandidate(response.data.candidatos);
					vm.modelRequest(response.data.proceso);
					vm.loading = false;
				},
				function (response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.loading = false;
				}
			);
		};

		vm.modelRequest = function (request) {
			var baseJson = (analystConstant.DEBUG) ? analystConstant.KEYJSONREQUESTDEBUG : analystConstant.KEYJSONREQUEST;
			analystMisc.modeldata(request, baseJson)
				.then(function (resolve) {
					vm.request = resolve;
					analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
						vm.request.notes = resolve;
					});
				})
				.catch(function (reject) {
					console.error(reject);
				});
		}

		vm.modelCandidate = function (data) {
			vm.candidatesBackup = data;
			vm.blockHojavida = [];
			vm.conceptAnalyst = [];
			vm.blockStages = [];
			vm.blockEvaluation = [];
			vm.blockConcept = [];
			vm.dataStage = [];
			var arrPromise = [];
			for (var i in data) {
				vm.blockHojavida.push(vm.setBlockHojaVida(angular.copy(data[i].hoja_vida.data_bloques), data[i].hoja_vida.listas));


				vm.dataStage.push(data[i].data_etapa);
				//vm.blockStages.push(vm.setBlocksCandidate(data[i].candidato.stage,data[i].data_etapa));

				var jsonCofig = analystConstant.KEYJSONCANDIDATE.PRODUTION;
				jsonCofig.bloques_evaluacion = "bloques_evaluacion";
				jsonCofig.bloques_concepto_analista = "bloques_concepto_analista";

				arrPromise.push(analystMisc.modeldata(data[i].candidato,jsonCofig).then(function (data) { return data; }));
			}
			$q.all(arrPromise).then(function (resolve) {
				vm.candidates = resolve;
				console.log(vm.candidates);
				for (var i = 0; i < vm.candidates.length; i++) {
					vm.blockEvaluation.push(vm.modelBlockEvaluation(data[i].bloques_evaluacion, vm.candidates[i], i));
					vm.conceptAnalyst.push(vm.modelBlockConcept(data[i].bloques_concepto_analista, vm.candidates[i], i));
				}
				vm.classSearch = ["personal-info", "formal-study", "laboral-experience", "concept-analyst"];
				//vm.searchHeigth("personal-info");
				//vm.searchHeigth("laboral-experience");
				vm.searchHeigth("concept-analyst");
			});
		}

		vm.donwloadExcelTerna = function () {
			analystService.downloadTerna({ proceso_id: vm.idRequest }, { responseType: 'arraybuffer' },
				function (response) {
					if (response.data) {
						IkanoFactory.downloadExcel(response.data);
					} else {
						vm.showToast({ class: "error", message: response.data.message, showClose: true });
					}
				},
				function (response) {
					IkanoFactory.showAlert("Error", response.data.message);
				}
			);
		}

		vm.modelDataAnalyst = function (ca) {
			for (var j in ca) {
				var data = ca[j].data;
				for (var i in data) {
					if (data[i].opciones != null && data[i].valor != null) {
						data[i].valor = vm.listsStage[data[i].opciones][data[i].valor];
					}
					if (data[i].tipo == "checkbox") {
						data[i].valor = (data[i].valor ? 'Si' : 'No');
					}
				}
			}
			return ca;
		}

		vm.modelBlockConcept = function (concept, candidate, index) {
			var data = {};
			var values = {};
			candidate.concept = {};

			candidate.concept.data = angular.copy(concept);
			candidate.concept.lists = concept.listas;
			candidate.concept.values = concept.data;
			candidate.concept.fields = vm.getFieldsEtapa(concept.estructura_campos, concept.bloques);
			vm.setBlocksConcept(candidate.concept, index);
		}

		vm.modelBlockEvaluation = function (evaluation, candidate, index) {
			var data = {};
			var values = {};
			candidate.evaluation = {};

			candidate.evaluation.data = angular.copy(evaluation);
			candidate.evaluation.lists = evaluation.listas;
			candidate.evaluation.values = evaluation.data;
			candidate.evaluation.fields = vm.getFieldsEtapa(evaluation.estructura_campos, evaluation.bloques);
			vm.setBlocksEvaluation(candidate.evaluation, index);
		}

		vm.searchHeigth = function (campo) {
			var cl = angular.element(document.getElementsByClassName(campo));
			if (cl.length != vm.candidates.length) {
				$timeout(function () {
					vm.searchHeigth(campo);
				}, 2000);
				return;
			}

			for (var i in vm.classSearch) {
				var classchange = angular.element(document.getElementsByClassName(vm.classSearch[i]));
				var heigthMax = 0;
				classchange.each(function (index, value) {
					var heigthClass = $(value).height();
					if (heigthMax < heigthClass) {
						heigthMax = heigthClass;
					}
				});
				classchange.each(function (index, value) {
					$(value).height(heigthMax);
				});
			}


		}

		vm.setBlockHojaVida = function (hv, listas) {
			return $.map(hv, function (value, index) {

				value.titulo = value.titulo.split(" ");
				value.name = index;
				value.emptyRowsMessage = "Por favor completa todos lo datos solicitados. Esto hará que la calidad de la información de tu hoja de vida mejore y agilize el proceso de selección";
				value.item = (value.data && !value.data.length ? value.data : null);
				value.lists = listas;

				if (value.name == "personales") {
					value.data.foto = value.data.foto + "?v=" + vm.getRandomNumber();
				}

				return [{ name: index, data: value }];
			});
		}

		vm.getRandomNumber = function () {
			return Math.floor((Math.random() * 100) + 1);
		};

		vm.changeStage = function (candidate, index) {
			var values = {};
			if (vm.dataStage[index][candidate.stageSelected.id]) {
				var values = vm.dataStage[index][candidate.stageSelected.id];
			}
			candidate.data = {
				bloques: vm.blocksStage[candidate.stageSelected.etapa],
				data: values,
				estructura_campos: vm.estructura_campos,
				listas: vm.listsStage
			}
			candidate.lists = candidate.data.listas;
			candidate.values = candidate.data.data;
			candidate.fields = vm.getFieldsEtapa(vm.estructura_campos, candidate.data.bloques);
			vm.setBlocksStage(candidate, index);

		}

		vm.getFieldsEtapa = function (fields, bloques) {
			var objReturn = {};
			for (var i in bloques) {
				if (bloques[i].auto_rellenar) {
					vm.blockAutoRellenar.push(bloques[i]);
				}
				for (var j in bloques[i].campos) {
					var keySearch = "";
					if (bloques[i].type == "has_many") {
						keySearch = bloques[i].model;
					} else {
						keySearch = bloques[i].campos[j];
					}

					objReturn[keySearch] = fields[keySearch];
				}
			}
			return objReturn;
		}

		vm.setBlocksStage = function (candidate, index) {
			vm.blockStages[index] = $.map(candidate.data.bloques, function (value, index) {
				return [vm.getBlockStage(index, value)];
			});
		};
		vm.setBlocksEvaluation = function (data, index) {
			vm.blockEvaluation[index] = $.map(data.data.bloques, function (value, index) {
				return [vm.getBlockStage(index, value)];
			});
		}
		vm.setBlocksConcept = function (data, index) {
			vm.blockConcept[index] = $.map(data.data.bloques, function (value, index) {
				return [vm.getBlockStage(index, value)];
			});
		}

		vm.getBlockStage = function (index, data) {
			var block = {
				id: null,
				name: index,
				model: data.model,
				title: data.name,
				type: "one-column",
				block: data.model.type,
				fields: data.campos
			};

			if (block.name == "info_general") {
				block.type = "one-column";
			} else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
				block.type = "select-current-employee";
			} else if (block.fields.length < 2) {
				block.type = "one-column";
			} else if (data.type == "has_many") {
				block.type = "two-column-multiple-rows";
			}
			return block;
		};

		vm.validateDataStage = function (candidate, approve, validation, index) {
			if (!validation) {
				vm.saveStage(candidate, candidate.values, approve, index);
			} else {
				candidate.errors = IkanoFactory.validateFieldsWithObject(candidate.fields, candidate.values, true);
				if (angular.equals(candidate.errors, {})) {
					candidate.errors = {};
					vm.saveStage(candidate, candidate.values, approve, index);
				} else {
					IkanoFactory.showAlert("Error", "La información de la etapa esta incompleta, por favor intente de nuevo.");
				}
			}
		}

		vm.validateDataEvaluation = function (candidate) {
			candidate.evaluation.errors = IkanoFactory.validateFieldsWithObject(candidate.evaluation, candidate.evaluation.values, true);
			if (angular.equals(candidate.evaluation.errors, {})) {
				candidate.errors = {};
				vm.saveEvaluation(candidate, candidate.evaluation.values);
			} else {
				IkanoFactory.showAlert("Error", "La información de la etapa esta incompleta, por favor intente de nuevo.");
			}
		}

		vm.saveEvaluation = function (candidate, values) {
			candidate.loadingEvaluation = true;
			var dataPost = {};
			dataPost.proceso_id = vm.idRequest;
			dataPost.hoja_vida_id = candidate.id;
			dataPost.data = values;
			analystService.saveEvaluation(dataPost, function (response) {
				candidate.showStage = true;
				candidate.loadingEvaluation = false;
			}, function (reject) {
				candidate.loadingEvaluation = false;
				vm.showToast({ class: "error", message: reject.data.message, showClose: true });
			}, {
					hideLoading: true
				});
		}


		vm.saveStage = function (candidate, data, approve, index) {
			candidate.loadingStage = true;
			var dataPost = {};
			dataPost.proceso_id = vm.idRequest;
			dataPost.hv_id = candidate.id;
			dataPost.etapa_id = candidate.stageSelected.id == 7 ? 17 : candidate.stageSelected.id;
			dataPost.aprueba = approve;
			dataPost.data = (!data) ? {} : data;
			analystService.saveStageFinalist(dataPost, function (response) {

				/*candidate.loadingStage = false;
				vm.deleteDataCandidate(index);
				vm.showToast({ class: "success", message: response.data.message, showClose: true });*/
				if (approve && candidate.stageSelected.id == 7) {
					vm.saveStageDefault(candidate, data, index);
				} else {
					candidate.loadingStage = false;
					vm.deleteDataCandidate(index);
					vm.showToast({ class: "success", message: response.data.message, showClose: true });
				}

			}, function (reject) {
				candidate.loadingStage = false;
				vm.showToast({ class: "error", message: reject.data.message, showClose: true });
			}, {
					hideLoading: true
				});
		}

		vm.saveStageDefault = function (candidate, data, index) {
			var dataPost = {};
			dataPost.proceso_id = vm.idRequest;
			dataPost.hv_id = candidate.id;
			dataPost.etapa_id = 7;
			dataPost.aprueba = 1;
			dataPost.data = (!data) ? {} : data;
			analystService.saveStageFinalist(dataPost, function (response) {

				candidate.loadingStage = false;
				vm.deleteDataCandidate(index);
				vm.showToast({ class: "success", message: response.data.message, showClose: true });

			}, function (reject) {
				candidate.loadingStage = false;
				vm.showToast({ class: "error", message: reject.data.message, showClose: true });
			}, {
					hideLoading: true
				});
		}

		vm.deleteDataCandidate = function (index) {
			vm.candidates.splice(index, 1);
			vm.blockHojavida.splice(index, 1);
			vm.conceptAnalyst.splice(index, 1);
			vm.dataStage.splice(index, 1);
			vm.blockStages.splice(index, 1);
			vm.blockEvaluation.splice(index, 1);
		}

		vm.getTerna();

		/**
		 * TOAST
		 */
		vm.showToast = function (data, options) {

			options = (options) ? options : [];

			$mdToast.show({
				hideDelay: 7000,
				position: 'top right',
				controller: 'ToastCrl',
				controllerAs: 'vm',
				templateUrl: 'app/toast/template/toast.default.html',
				locals: {
					options: options,
					config: data,
				},
				toastClass: data.class
			});
		}
		/**
		 * SET DATA OF PAGE
		 */

		vm.setPageData = function () {
			vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
			vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
			if (vm.data.data.no_vacantes) {
				var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
				vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
			}

			vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
			if (vm.data.data.tipo_solicitud_b_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
			}
			if (vm.data.data.tipo_solicitud_c_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
			}
		};

	}
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin')
        .controller('RequestsController', RequestsController);

    /** @ngInject */
    function RequestsController($mdDialog, $state, $document, $mdDateLocale, $scope, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, $compile, paginationService, IkanoFactoryPagination) {
        var vm = this;

        vm.loading = true;
        vm.newRequest = true;
        vm.limit = 15;

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Mis requisiciones'],
            title: "Mis requisiciones",
        };

        $mdDateLocale.formatDate = function (date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        };

        var locale = IkanoFactory.getDateLocaleFormat('es');
        if (locale != false) {
            $mdDateLocale.months = locale.months;
            $mdDateLocale.shortMonths = locale.shortMonths;
            $mdDateLocale.days = locale.days;
            $mdDateLocale.shortDays = locale.shortDays;
        }

        jQuery.extend(jQuery.fn.dataTableExt.oSort, {
            "date-nl-pre": function (date) {
                return moment(date, 'DD/MMMM/YYYY');
            },

            "date-nl-asc": function (a, b) {
                return (a.isBefore(b) ? -1 : (a.isAfter(b) ? 1 : 0));
            },

            "date-nl-desc": function (a, b) {
                return (a.isBefore(b) ? 1 : (a.isAfter(b) ? -1 : 0));
            }
        });

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(2).withOption('type', 'date-nl')
        ];

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            iDisplayLength: 20,
            responsive: true,
            order: [[2, "desc"]],
            searching: false
        };

        vm.filter = $state.params.filter;

        vm.getRequests = AdminService.getAllRequests;
        vm.requests = [];
        vm.allRequests = [];
        vm.extraRequests = [];
        vm.numero_requisicion = "";
        vm.startDate = null;
        vm.endDate = null;

        vm.page = 1;
        vm.pager = {};

        vm.filterValue = {};

        if (vm.filter == "seleccion_requisiciones_todas") {
            vm.pageInfo.parents = ['Todas'];
            vm.pageInfo.title = 'Todas las requisiciones';
            vm.getRequests = AdminService.getAllRequests;

        } else if (vm.filter == "seleccion_requisiciones_noaprobadas") {
            vm.pageInfo.parents = ['No aprobadas'];
            vm.pageInfo.title = 'Requisiciones no aprobadas';
            vm.getRequests = AdminService.getNoApproveRequests;

        } else if (vm.filter == "seleccion_requisiciones_aprobadas") {
            vm.pageInfo.parents = ['Aprobadas'];
            vm.pageInfo.title = 'Requisiciones aprobadas';
            vm.getRequests = AdminService.getApproveRequests;

        } else if (vm.filter == "seleccion_requisiciones_enaprobacion") {
            vm.pageInfo.parents = ['En aprobación'];
            vm.pageInfo.title = 'Requisiciones en aprobación';
            vm.getRequests = AdminService.getInProcessRequests;

        } else if (vm.filter == "seleccion_requisiciones_construccion") {
            vm.pageInfo.parents = ['En construcción'];
            vm.pageInfo.title = 'Requisiciones en construcción';
            vm.getRequests = AdminService.getDraftRequests;

        }

        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.total_results, page, vm.limit);
            console.log(vm.pager);
            if (!noConsult) {
                var filter = serializeData(vm.filterValue);
                if (IkanoFactoryPagination.getDataPage(vm.page)) {
                    var local = IkanoFactoryPagination.getDataPage(vm.page);
                    getResquestSuccess(local, true);
                } else {
                    vm.getRequests(filter, {}, getResquestSuccess, getRequestError);
                }

            }
            setTimeout(function () {
                createPagination();
            }, 1000);
        }

        vm.modelRequestTypes = function (requests, extras) {
            for (var index = 0; index < extras.length; index++) {
                var element = extras[index];
                for (var j = 0; j < requests.length; j++) {
                    var type = requests[j];

                    if (type.id == element) {
                        vm.extraRequests.push(type);
                    }
                }
            }

            vm.requestTypes = requests;
        };

        vm.filterByDate = function () {
            vm.page = 1;
            var filter = serializeData();
            IkanoFactoryPagination.clear();
            vm.getRequests(filter, {}, getResquestSuccess, getRequestError);
        }

        vm.clearFilter = function () {
            IkanoFactoryPagination.clear();
            IkanoFactory.clearValueFilter($state.current.name);
            vm.page = 1;
            var filterSerialize = serializeData(null, 1);
            vm.filterValue = {};
            vm.getRequests(filterSerialize, {}, getResquestSuccess, getRequestError);
        }

        vm.confirmClone = function (ev, id, name) {
            IkanoFactory.showConfirmAlert(ev, "¿Está seguro(a)?", "Ha hecho clic en duplicar la requisición: <strong>" + IkanoFactory.capitalize(name, true) + "</strong>", id, vm.clone);
        };

        vm.clone = function (id) {
            AdminService.cloneRequest({ id: id },  {},
                function (response) {
                    if (response.data.result.status) {
                        //IkanoFactory.showAlert("", "Se ha duplicado la requisición exitosamente.");
                        $state.go('app.seleccion_ver_requisicion', { id: response.data.result.data.id });
                    } else {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };

        vm.openSelectTypeNewRequestDialog = function (ev) {
            $mdDialog.show({
                controller: 'SelectTypeNewRequestController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/requester/requests/dialogs/select-type-new-request.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    requestTypes: vm.requestTypes,
                    extraRequests: vm.extraRequests,
                    listCountry: vm.listPaises,
                    event: ev,
                }
            });
        }

        vm.getStatusColor = IkanoFactory.getStatusColor;

        function serializeData(filter, page) {
            var objReturn = filter ? filter : {};
            var page = page ? page : vm.page;
            objReturn.page_params = { page: page };

            return objReturn;
        }

        function getResquestSuccess(response, cache) {
            if (cache) {
                vm.requests = response.result;
                vm.allRequests = response.result;
                vm.requestTypes = IkanoFactory.convertRequestTypesObjToArrayObjects(response.tipos_solicitud);
                vm.listPaises = response.paises_procesos;
                if (response.tipos_solicitud_extra_ids && response.tipos_solicitud_extra_ids.length) {
                    vm.modelRequestTypes(vm.requestTypes, response.tipos_solicitud_extra_ids);
                }
                vm.filters = response.filters.filters;
                modelPagination(response.total_results);

            } else {
                if (response.data.requisiciones.data.result) {
                    IkanoFactoryPagination.setDataPage(vm.page, response.data.requisiciones.data);
                    vm.requests = response.data.requisiciones.data.result;
                    vm.allRequests = response.data.requisiciones.data.result;
                    vm.requestTypes = IkanoFactory.convertRequestTypesObjToArrayObjects(response.data.requisiciones.data.tipos_solicitud);
                    vm.listPaises = response.data.requisiciones.data.paises_procesos;
                    if (response.data.requisiciones.data.tipos_solicitud_extra_ids && response.data.requisiciones.data.tipos_solicitud_extra_ids.length) {
                        vm.modelRequestTypes(vm.requestTypes, response.data.requisiciones.data.tipos_solicitud_extra_ids);
                    }

                    vm.filters = response.data.requisiciones.data.filters.filters;
                    modelPagination(response.data.requisiciones.data.total_results);
                }
            }

            vm.loading = false;
        }

        function getRequestError(reponse) {
            IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
            vm.loading = false;
        }

        function modelPagination(total_results) {
            vm.total_results = total_results;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        function createPagination() {
            var elemt = $('.right');
            //elemt.appendTo('<div class="paginations"></div>');
            var template = '<div class="info">'
                            + '<div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}} hasta {{vm.pager.totalItems}} Registros</div>'
                            + '</div><div class="pagination"><div class="dataTables_paginate paging_simple">'
                            + '<a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a>'
                            + '<a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a>'
                            + '</div></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        vm.callbackSendData = function (filter) {
            vm.page = 1;
            IkanoFactoryPagination.clear();
            IkanoFactory.saveValueFilterJson($state.current.name, filter);
            var filterSerialize = serializeData(filter);
            vm.filterValue = filter;
            vm.getRequests(filterSerialize, {}, getResquestSuccess, getRequestError);
        }

        IkanoFactoryPagination.setKey($state.current.name);
        //IkanoFactory.setFilters($state.current.name);
        vm.filtersData = vm.filterValue = IkanoFactory.setValuefilterJson($state.current.name);
        if (IkanoFactoryPagination.getDataPage(vm.page)) {
            var local = IkanoFactoryPagination.getDataPage(vm.page);
            getResquestSuccess(local, true);
        } else {
            vm.getRequests({}, {}, getResquestSuccess, getRequestError);
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('NewRequestsController', NewRequestsController);

	/** @ngInject */
	function NewRequestsController($mdDialog, $state, $window, $document, $scope, AdminService, ValidationService, IkanoFactory, IkanoFactoryPagination) {
		var vm = this;

        vm.loading = true;

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['Nueva requisición'],
			title: "Nueva requisición",
		};

		vm.types = IkanoFactory.getRequestTypes();
	

		if (!vm.types) {
			$state.go('app.seleccion_requisiciones_todas', {});
		}

		vm.saveButtonTitle = "Guardar";
		vm.saving = false;
		vm.change = false;
		vm.first = true;

		vm.data = {
			data: {
				tipo_solicitud: vm.types.tipo_solicitud,
				tipo_solicitud_b: vm.types.tipo_solicitud_b,
				tipo_solicitud_c: vm.types.tipo_solicitud_c,
				pais_proceso_id: vm.types.pais_proceso_id
			}
		};

		vm.idRequest = null
		vm.lists = [];
		vm.fields = [];
		vm.blocks = [];
		vm.errors = {};
		vm.values = {};

		vm.oldValues = {};

		vm.observations = [];
		vm.obsForm = {};
		vm.showObsForm = false;
		vm.newReq = true;
		vm.showRequest = true;
		vm.validationService = ValidationService;
		
		vm.getRequest = function() {
			vm.requestTypes = [];
			vm.extraRequests = [];
			
			if (vm.idRequest) {
				vm.types.id = vm.idRequest;
			}
			
			vm.types.tipo_solicitud = vm.data.data.tipo_solicitud;
			vm.types.tipo_solicitud_b = vm.data.data.tipo_solicitud_b;
			vm.types.tipo_solicitud_c = vm.data.data.tipo_solicitud_c;
			vm.types.pais_proceso_id = vm.data.data.pais_proceso_id;
			AdminService.getRequest(
				vm.types, {}, 
				function(response) {
					if (response.data.requisicion) {
						vm.data = response.data.requisicion;
						vm.requestTypes = response.data.tipos_solicitud;
						vm.observations = vm.data.observaciones;
						//vm.values = vm.data.data;
						vm.values = vm.mergeObjects(vm.data.data, vm.oldValues);
						//if (vm.values.cargo_id) {
						//	vm.values.cargo_id = null;
						//}
						vm.values.tipo_solicitud = vm.types.tipo_solicitud;
						vm.values.tipo_solicitud_b = vm.types.tipo_solicitud_b;
						vm.values.tipo_solicitud_c = vm.types.tipo_solicitud_c;
						vm.values.pais_proceso_id = vm.types.pais_proceso_id;
						vm.lists = vm.data.listas;
						//vm.fields = vm.data.estructura_campos;
						vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
						vm.setBlocks();
						vm.change = false;
						if (vm.first) {
							vm.setValuesWatch();
						}
						vm.first = true;
						vm.setPageData();
						vm.data.options = {
							update_tipo_solicitud: true
						};

						ValidationService.generalFunctions($scope, vm);
            			ValidationService.watchFunctions($scope, vm);
						

						vm.requestTypes = IkanoFactory.convertRequestTypesObjToArrayObjects(response.data.tipos_solicitud);
						vm.listPaises = response.data.paises_procesos;

						if (response.data.tipos_solicitud_extra_ids && response.data.tipos_solicitud_extra_ids.length) {
							vm.modelRequestTypes(vm.requestTypes, response.data.tipos_solicitud_extra_ids);
						}
					}
					vm.loading = false;
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.loading = false;
				}
			);
		};

		vm.cleanDataTables = function(){
			IkanoFactoryPagination.setKey('app.seleccion_requisiciones_enaprobacion');
			IkanoFactoryPagination.clear();
			IkanoFactoryPagination.setKey('app.seleccion_requisiciones_todas');
			IkanoFactoryPagination.clear();
			IkanoFactoryPagination.setKey('app.seleccion_requisiciones_construccion');
			IkanoFactoryPagination.clear();
		}

		vm.onchange_lists = function(lista){
            $.each(vm.lists,function(key,value){
                if(lista[key]){
                    vm.lists[key] = lista[key];
                }
			});
			for(var c in vm.data.estructura_campos){
                var campo = vm.data.estructura_campos[c];
                if(lista[campo.options]){
                    $scope.$broadcast('changeList'+c,lista[campo.options]);
                }
            }
        }

		vm.getRequest();

		vm.modelRequestTypes = function(requests, extras) {
			vm.extraRequests = [];

            for (var index = 0; index < extras.length; index++) {
                var element = extras[index];
                for (var j = 0; j < requests.length; j++) {
                    var type = requests[j];

                    if (type.id == element) {
                        vm.extraRequests.push(type);
                    }
                }
            }
        };

		vm.setPageData = function() {
			vm.pageInfo.subtitle = '<div class="h4">' + vm.requestTypes[vm.types.tipo_solicitud].label + '</div>';
			if (vm.types.tipo_solicitud_b != null || vm.types.tipo_solicitud_b != undefined) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.requestTypes[vm.types.tipo_solicitud_b].label + '</div>';
			}		

			if (vm.types.tipo_solicitud_c != null || vm.types.tipo_solicitud_c != undefined) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.requestTypes[vm.types.tipo_solicitud_c].label + '</div>';
			}
		};

		vm.getPositionColaborators = function(position) {
			AdminService.getPositionColaborators({cargo_id: position}, {}, 
				function(response) {
					if (response.data.colaboradores) {
						vm.lists.position_colaborators = IkanoFactory.setPositionsId(response.data.colaboradores,'estructura_id');
					}
				},
				function(response) {
					//IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
        }

		vm.mergeObjects = function(obj, src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) obj[key] = src[key];
			}
			return obj;
		}

		vm.checkEmptyObject = function(obj) {			
			if (angular.equals(obj, {})) {
				return true;
			}

			return false;
		}

		vm.setValuesWatch = function() {			
			ValidationService.setWarchers($scope, vm);
		};

		vm.addObservation = function() {
			vm.validate(true);
		};

		vm.saveObservations = function() {
			vm.obsForm.requisicion_id = vm.idRequest;

			if (vm.obsForm && vm.obsForm.comentario) {
				AdminService.saveObservationsRequest(vm.obsForm, {}, 
					function(response) {
						if (response.data.requisicion.status) {
							vm.showObsForm = false;
							vm.obsForm.id = null;
							vm.obsForm.comentario = "";
							vm.observations = response.data.requisicion.data.observaciones;
						} else {
							IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
						}
					},
					function(response) {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}
				);
			}
		}

		vm.updateObservation = function(obs) {
			vm.obsForm.id = obs.id;
			vm.obsForm.comentario = obs.comentario;
			vm.showObsForm = true;
		};

		vm.setBlocks = function() {
			vm.blocks = $.map(vm.data.bloques, function(value, index) {
				return [vm.getBlock(index, value)];
			});
		};

		vm.getBlock = function(index, data) {
			var block = {
				id: null,
				name: index,
				model: data.model,
				title: (data.name ? data.name.split(" ") : ""),
				type: "two-columns",
				notes: (data.titulo ? data.titulo.edit : null),
				//block: data.model.type,
				fields: data.campos
			};
			

			if (block.name == "info_general") {
				block.type = "one-column-info";
			} else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
				block.type = "select-current-employee";
			} else if (block.fields.length < 2) {
				block.type = "one-column";
			} else if (data.type == "has_many") {
				block.type = "two-column-multiple-rows";
				vm.addModelToBlock(block);
			}
			
			return block;
		};

		vm.addModelToBlock = function(block) {
			if (!vm.values[block.model] || !vm.values[block.model].length) {
				vm.values[block.model] = [];
			}
			
			var model = {};
			for (var index = 0; index < block.fields.length; index++) {
				var element = block.fields[index];
				model[element] = null;
			}
			
			vm.values[block.model].push(model);
			
		}

		vm.removeModelToBlock = function(block, index) {
			vm.values[block.model].splice(index,1);
		}

		vm.validate = function(obs) {
			vm.errors = {};
			vm.saving = true;
            vm.saveButtonTitle = "Guardando...";

            vm.save(false, obs);
		};

		vm.save = function(send, obs, requestType) {
			var data = {
				id: vm.idRequest,
				data: vm.values
			};

			data.data.tipo_proceso = 'proceso_jefe';
			data.data.pais_proceso_id = vm.types.pais_proceso_id;

			AdminService.saveRequest(data, {}, 
				function(response) {
					if (response.data.result.status) {
						vm.idRequest = response.data.result.data.id;
						vm.change = false;
						vm.newReq = false;
						vm.cleanDataTables();

						if (send) {
							vm.sendRequest();
						}

						if (obs) {
							vm.saveObservations();
						}

						if (requestType) {
							vm.updateRequestTypeDialog();
						}
					} else {
						var def_msg = "Ha ocurrido un error, por favor intente de nuevo.";

						if (response.data.result.cust_msg) def_msg = response.data.result.cust_msg;

						IkanoFactory.showAlert("Error", def_msg);
					}

					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				}
			);
		}

		vm.saveAndSend = function() {
			vm.save(true);
		}

		vm.sendRequest = function() {
			vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values, true);
			//console.log(vm.errors,vm.values);
			if (angular.equals(vm.errors, {})) {
				AdminService.sendRequest({id: vm.idRequest}, {}, 
					function(response) {
						if (response.data.result.status) {
							IkanoFactory.showAlert("", "La requisición se ha enviado exitosamente.");
							$state.go('app.seleccion_ver_requisicion', {id: vm.idRequest});
						} else {
							var err_msg = "Ha ocurrido un error, por favor intente de nuevo."
							
							if (response.data.result.custom_msg) {
								err_msg = response.data.result.custom_msg;
							}
							
							IkanoFactory.showAlert("Error", err_msg);
						}

						vm.saving = false;
						vm.saveButtonTitle = "Guardar";
					},
					function(response) {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
						vm.saving = false;
						vm.saveButtonTitle = "Guardar";
					}
				);
			} else {
				IkanoFactory.showAlert("Error", "La requisición se encuentra incompleta, por favor haga clic en modificar y complete la requisición para enviarla a aprobación.");
			}
		};

		vm.getVacants = function() {
			return ValidationService.getVacants($scope, vm);
		};

		vm.openSetEmployeesDialog = function(ev, index, name, field) {
			field.name = name;
      $mdDialog.show({
      	controller: 'AddEmployeeController',
      	controllerAs: 'vm',
      	templateUrl: 'app/main/admin/requester/new-request/dialogs/add-employee.html',
      	parent: angular.element($document.body),
      	targetEvent: ev,
      	clickOutsideToClose: true,
      	locals: {
        	values: vm.values,
					index: index,
					field: field,
					errors: vm.errors,
					lists: vm.lists,
          event: ev
        }
      }).then(function(response){
				if(field.name == 'info_ocupante_actual' && response[field.name][0] === null) {
					console.log(response[field.name]);
					vm.values[field.name] = [];
					return false
				}

				vm.values[field.name] = response[field.name];
			});
		};
		
		vm.openUpdateRequestTypeDialog = function() {
			vm.save(false, true, true);
		};

		vm.updateRequestTypeDialog = function(ev) {

			$mdDialog.show({
                controller: 'UpdateRequestTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/approver/show-request/dialogs/update-request-type.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.idRequest,
					data: vm.data,
					requestTypes: vm.requestTypes,
					extraRequests: vm.extraRequests,
					getRequest: vm.getRequest,
					listCountry: vm.listPaises,
					newRequest: false,
                    event: ev,
                }
            });
		};
    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('DashboardRequesterController', DashboardRequesterController);

	/** @ngInject */
	function DashboardRequesterController($mdDialog, $document, AdminService, CandidateService, IkanoFactory) {
		var vm = this;
        vm.loading = true;
    }
})();
(function(){
    'use strict';

    angular.module('app.seleccion_admin').controller('DashboardFinalistController',DashboardFinalistController);

    function DashboardFinalistController($mdDialog, $document, AdminService, CandidateService, IkanoFactory,$state,$mdColors){
        //contructor

        var vm = this;

        vm.ternas = [];
    
        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;
        
        vm.getDasboard = function(){
            AdminService.getDasboardFinalistCandidate({},
                function(resolve){
                    vm.modelTernas(resolve.data.ternas);
                },function(reject){
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        }

        vm.modelTernas = function(data){
            for(var i in data){
                for(var j in data[i].candidatos){
                    data[i].candidatos[j].procesos_candidato.fecha_enviado_cliente = moment(data[i].candidatos[j].procesos_candidato.fecha_enviado_cliente ).format('MMM D, YYYY hh:mm A');
                }
            }
            vm.ternas = data;
            
        }

        vm.goToFinalist = function(id){
            $state.transitionTo('app.show_finalist_candidate',{request_id:id});
        }

        vm.getDasboard();
    }
})();
(function (){
    'use strict';

    angular.module('app.seleccion_analyst').controller('createdSocietyDialog', createdSocietyDialog);

    function createdSocietyDialog(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, ValidationService, $scope,society,lists){

        //constructor
        var vm = this;

        vm.society = society;
        vm.lists = lists;
        vm.data = society ? society :{};


        vm.validateStage = function(approve){
            if(vm.stageIncomplet.length > 0){
                $mdDialog.cancel();
            }else{
                vm.saveStage(approve);
            }
        }
        vm.saveSociety = function () {
            var dataPost = serializePostData();
            AdminService.save_sociedades_paises(dataPost, function (response) {
                $mdDialog.hide(response);
            }, function (reject) {
                console.log(reject);
                IkanoFactory.showAlert("Error", "");
            });
        }

        function serializePostData (){
            var returnData = {};
            if(vm.society){
                returnData.id = vm.society.id;
            }
            returnData.sociedad_id = angular.copy(vm.data.society_id);
            returnData.sociedad = vm.lists.sociedades[vm.data.society_id];
            returnData.pais_id = angular.copy(vm.data.country_id);
            returnData.pais = vm.lists.paises[vm.data.country_id];
            return returnData;
        }


        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('SettingsController', SettingsController);

	/** @ngInject */
	function SettingsController($mdDialog, $document, $state, $scope, AdminService, IkanoFactory) {
		var vm = this;

		vm.change = false;
		vm.saving = false;
        vm.loading = true;
		
		vm.pageInfo = {
			icon: "icon-home",
			parents: ['Parametrización'],
			title: "Parametrización",
		};
		vm.settings = [];
		vm.data = {};
		vm.errors = {};


		AdminService.getSystemSettings({}, {}, 
            function(response) {
				if (response.data.get_configuracions.data.parametrizacion) {
					vm.settings = response.data.get_configuracions.data.parametrizacion;
				}
                vm.loading = false;
            },
            function(response) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                vm.loading = false;
            }
        );

		$scope.$watch('vm.data',function(newValue, oldValue) {
			if(newValue != oldValue) {
				vm.change = true;
			}
		},true);


		vm.save = function() {
			vm.saving = true;
			AdminService.saveSystemSettings({data: vm.data}, {}, 
				function(response) {
					if (response.data.result.status) {
						vm.change = false;
					}
					
					vm.saving = false;
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.saving = false;
				}
			);
		}
    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('OutboxController', OutboxController);

	/** @ngInject */
	function OutboxController($mdDialog, $document, $state, $mdDateLocale, AdminService, IkanoFactory) {
		var vm = this;

        vm.change = false;
		vm.saving = false;
        vm.loading = true;
        vm.page = 1;
        vm.totalMails = 0;
        vm.pages = 0;
        vm.filter = "";

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['Bandeja de salida'],
			title: "Bandeja de salida",
		};

        var locale = IkanoFactory.getDateLocaleFormat('es');
        if (locale != false) {
          $mdDateLocale.months = locale.months;
          $mdDateLocale.shortMonths = locale.shortMonths;
          $mdDateLocale.days = locale.days;
          $mdDateLocale.shortDays = locale.shortDays;
        }

		vm.views = {
            classic: 'app/main/admin/config/outbox/views/classic/classic-view.html',
            outlook: 'app/main/admin/config/outbox/views/outlook/outlook-view.html'
        };

        vm.defaultView = 'outlook';
        vm.currentView = 'outlook';

		vm.mails = [];
		vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.getData = function() {
            AdminService.getOutboxPaginate({}, {}, vm.page, vm.filter,
                function(response) {
                    if (response.data.get_bandeja_salida.data.bandeja_salida) {
                        vm.mails = response.data.get_bandeja_salida.data.bandeja_salida;
                        vm.totalMails = response.data.get_bandeja_salida.data.total;
                        if (vm.totalMails) {
                            vm.pages = Math.ceil(vm.totalMails/20);
                        }
                    }
                    vm.loading = false;
                },
                function(response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );
        }
        vm.getData();

		vm.openThread = function(thread) {
            // Set the read status on the thread

            // Assign thread as the current thread
            vm.currentThread = thread;
        };

        vm.firstPage = function() {
            if (vm.page != 1) {
                vm.page = 1;
                vm.getData();
            }
        }

        vm.lastPage = function() {
            if (vm.page != vm.pages) {
                vm.page = vm.pages;
                vm.getData();
            }
        }

        vm.backward = function() {
            var newPage = vm.page - 1;

            if (newPage) {
                vm.page = newPage;
                vm.getData();
            }
        };

        vm.forward = function() {
            var newPage = vm.page + 1;

            if (newPage && newPage <= vm.pages) {
                vm.page = newPage;
                vm.getData();
            }
        };

        vm.searchData = function() {
            if (vm.search && vm.search.length > 3) {
                vm.filter = "&filter[key]=" + vm.search;
                vm.page = 1;
                vm.getData();
            } else if (!vm.search) {
                vm.page = 1;
                vm.filter = "";
                vm.getData();
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin')
        .controller('MailTemplatesController', MailTemplatesController);

    /** @ngInject */
    function MailTemplatesController($mdDialog, $document, $state, $rootScope, AdminService, IkanoFactory) {
        var vm = this;

        vm.loading = true;

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Plantillas de correo'],
            title: "Plantillas de correo",
        };

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            iDisplayLength: 20,
            responsive: true,
            searching: false
        };

        vm.templates = [];

        AdminService.getMailTemplates({},  {},
            function (response) {
                if (response.data.get_plantillas.data.plantillas) {
                    vm.templates = response.data.get_plantillas.data.plantillas;
                }
                vm.loading = false;
            },
            function (response) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                vm.loading = false;
            }
        );

        vm.goToTemplate = function (ev, template) {
            $mdDialog.show({
                controller: 'EditMailTemplateDialogController',
                controllerAs: 'vm',
                locals: {
                    template: template
                },
                templateUrl: 'app/main/admin/config/mail-templates/dialogs/edit/edit-mail-template-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        vm.activeAndDesactiveTemplate = function (template, $index) {
            var templateData = angular.copy(template);
            templateData.estado = !templateData.estado;
            vm.loading = true;
            AdminService.updateMailTemplate(templateData,  {},
                function (response) {
                    if (response.data.result.status) {
                        vm.templates[$index] = angular.copy(templateData);
                    }
                    vm.loading = false;
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );
        }

        vm.goProbar = function (ev, template) {
            $mdDialog.show({
                controller: 'ProbarMailTemplateDialogController',
                controllerAs: 'vm',
                locals: {
                    template: template
                },
                templateUrl: 'app/main/admin/config/mail-templates/dialogs/probar/probar.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        // Coloca los filtros
        //IkanoFactory.setFilters();
    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('ApproversController', ApproversController);

	/** @ngInject */
	function ApproversController($mdDialog, $document, $state, $scope, $window, api, AdminService, IkanoFactory) {
		var vm = this;
        
		vm.saving = false;
        vm.loading = true;
		
		vm.pageInfo = {
			icon: "icon-home",
			parents: ['Aprobadores'],
			title: "Aprobadores",
		};
		
		vm.data = null;

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
			language: IkanoFactory.getLanguajeDataTable(),
			autoWidth : false,
            iDisplayLength: 20,
            responsive: true,
            searching: false
        };

        vm.downloadApprover = true;

        vm.dtInstance = {};

        vm.filtersData = {};

		vm.getApprovers = function (filter) {
            AdminService.getApprovers(filter,  {},
                function (response) {
                    if (response.data.requisiciones_aprobadores.data) {
                        vm.data = response.data.requisiciones_aprobadores.data;
                        vm.filters = response.data.requisiciones_aprobadores.data.filtros.filters;
                    }
                    vm.loading = false;
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );
        }

        vm.enableApprover = function($ev, approver) {
            vm.errors = {};
            vm.loading = true;
            AdminService.enableApprover({id: approver.id}, {}, 
                function(response) {
                    if (response.data.result) {
                        vm.data.aprobadores = response.data.aprobadores;
                        approver.estado = true;
                    } else {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
                    vm.loading = false;
                },
                function(response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );
        };

        vm.disableApprover = function($ev, approver) {
            vm.errors = {};
            vm.loading = true;
            AdminService.disableApprover({id: approver.id}, {}, 
                function(response) {
                    if (response.data.result) {
                        vm.data.aprobadores = response.data.aprobadores;
                        approver.estado = false;
                    } else {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
                    vm.loading = false;
                },
                function(response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );
        };

        vm.downloadReport = function() {
            var data_params = {
                clase: "Ikano",
                formato: "excel",
                page: 1,
                per_page: 15,
                report_name_id: "report_approvers",
                type_report: "license"
            };

            AdminService.getServiceReportLevelService(data_params, {}, 
                function (response) {
                    $window.open(api.general.getUrlBase() + '/' + response.data.report_filename, "_blank");
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                },
                false,
                {
                    old: false
                });
        }

        vm.callbackSendData = function (filter) {
            
            /*var filterSerialize = serializeData(filter);
            vm.filterValue = filter;
            vm.getRequests(filterSerialize,{},getRequetsSucess, getRequetsReject);*/
            vm.getApprovers({filtros:filter});
        }

        vm.clearFilter = function () {
            vm.filterValue = {};
            vm.getApprovers({});
        }

		vm.openAddApproverDialog = function(ev) {
			$mdDialog.show({
                controller: 'AddApproverController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/config/approvers/dialogs/add-approver.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev,
					data: vm.data
                }
            });
        };

		vm.openAddSubstituteDialog = function(ev, approver) {
			$mdDialog.show({
                controller: 'AddSubstituteController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/config/approvers/dialogs/add-substitute.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev,
					data: vm.data,
                    approver: approver
                }
            });
        };

		vm.openAddAssistantDialog = function(ev, approver) {
			$mdDialog.show({
                controller: 'AddAssistantController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/config/approvers/dialogs/add-assistant.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev,
                    data: vm.data,
                    approver: approver
                }
            });
        };


        vm.openRemoveDialog = function(ev, item, type) {
			$mdDialog.show({
                controller: 'RemoveColaboratorController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/config/approvers/dialogs/remove-colaborator.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev,
                    data: vm.data,
                    item: item,
                    type: type
                }
            });
        };

        vm.openApproverDetailDialog = function(ev, approver) {
			$mdDialog.show({
                controller: 'ApproverDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/config/approvers/dialogs/approver-detail.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev,
                    data: vm.data,
                    approver: approver
                }
            });
        };

        // Coloca los filtros
        IkanoFactory.setFilters();
        vm.getApprovers({});
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_admin').controller('collaboratorsController', collaboratorsController);

    function collaboratorsController($mdDialog, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, analystService, analystMisc, $mdToast, analystConstant, paginationService, $compile, $scope, $mdColors, $filter) {
        //contrcutor
        var vm = this;

        vm.limit = analystConstant.DEFAULT.DATA.DASHBOARD.LIMITREQUEST;

        vm.pager = {};

        vm.filter = {};

        vm.filter.collaborators = {};

        vm.filter.candidates = {};

        vm.backup = {};

        vm.backup.filter = {};

        vm.search = {};

        vm.misc = {};

        vm.page = {};

        vm.getThemeColor = $mdColors.getThemeColor;

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Colaboradores', 'Lista de colaboradores'],
            title: "Lista colaboradores",
        };

        //DATA TABLE OPTION
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            paging: false,
            language: IkanoFactory.getLanguajeDataTable(),
            pagingType: 'simple',
            autoWidth: false,
            iDisplayLength: 20,
            sorting: false,
            searching: false
        };

        vm.dtColumnDefsCollaborator = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
            DTColumnDefBuilder.newColumnDef(6).notSortable(),
            DTColumnDefBuilder.newColumnDef(7).notSortable(),
            DTColumnDefBuilder.newColumnDef(8).notSortable(),
        ];

        vm.dtColumnDefsCandidate = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
            DTColumnDefBuilder.newColumnDef(6).notSortable(),
        ];
        //INIT LIST COLLABORATOR
        vm.misc.tabSelected = 'collaborators';


        function getCollaborators(data, showLoad) {
            AdminService.getCollaborators(data, function (resolve) {
                vm.backup.filter.collaborators = data.filtros;
                modelCollaborators(resolve.data.data);
                vm.analysts = resolve.data.data.analysts;
                setTimeout(function () {
                    createPaginationCollaborators();
                }, 1000);
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            }, showLoad);
        }

        function searchCandidates(data, showLoad) {
            AdminService.searchCandidate(data, function (resolve) {
                vm.backup.filter.candidates = data.filtros;
                modelCandidates(resolve.data.data);
                setTimeout(function () {
                    createPaginationCandidates();
                }, 1000);
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            }, showLoad);
        }

        function getLists(data, showLoad) {
            vm.lists = JSON.parse(localStorage.getItem('lists'));
            vm.positions = angular.copy(vm.lists.cargos);
            AdminService.getLists(data, function (resolve) {
                vm.sociedades = resolve.data.data.list_sociedad;
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            }, showLoad);
        }

        function modelCollaborators(data) {

            var baseJson = {
                analista: 'analyst',
                cargo: 'position',
                fecha_nacimiento: { key: "birthdate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                fecha_seleccion: { key: "selecteddate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                fecha_ultima_validacion: { key: "lastvalidatedate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                fecha_ingreso: { key: "entrydate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                ultima_fecha_actualizacion: { key: "updatedate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                cedula: 'cedula',
                celular: 'phone',
                edad: 'age',
                estado: 'porc',
                foto: 'photo',
                hoja_vida_id: 'hv_id',
                nombre: 'full_name',
                nombres: 'name',
                primer_apellido: 'firstlastname',
                segundo_apellido: 'secondlastname',
                compania: 'company',
                adjuntos: { key: 'hideAttachments', callback: "compareDate", dataCallback: { data: {} } }
            };

            analystMisc.modeldataarray(data.data, baseJson).then(function (resolve) {
                //vm.collaborators = analystMisc.misc.orderDates(resolve,'entrydateBackup','orderDate','',true);
                vm.collaborators = resolve;
                vm.modelPaginationCollaborators(data.pagination);
            });
        }

        function modelCandidates(data) {
            var baseJson = {
                analista: 'analyst',
                cargo: 'position',
                fecha_nacimiento: { key: "birthdate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                fecha_seleccion: { key: "selecteddate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                fecha_ultima_validacion: { key: "lastvalidatedate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                fecha_ingreso: { key: "entrydate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                fecha_modificacion: { key: "updatedate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                cedula: 'cedula',
                celular: 'phone',
                edad: 'age',
                estado: 'porc',
                foto: 'photo',
                hoja_vida_id: 'hv_id',
                nombre: 'full_name',
                nombres: 'name',
                primer_apellido: 'firstlastname',
                segundo_apellido: 'secondlastname',
                compania: 'company',
                seleccionado: 'isColaborator',
                adjuntos: { key: 'hideAttachments', callback: "compareDate", dataCallback: { data: {} } }
            };
            analystMisc.modeldataarray(data.data, baseJson, { save: true, model: 'candidates', set: { filter: '', positions: [],sociedades: []  } }).then(function (resolve) {
                vm.candidates = resolve;
                vm.misc.candidates = analystMisc.returnVar('candidates');
                vm.modelPaginationCandidates(data.pagination);
            });
        }

        vm.donwloadFile = function (collaborator) {
            AdminService.downloadFileCollaborator({ hoja_vida_id: collaborator.hv_id }, { responseType: 'arraybuffer' }, function (response) {
                IkanoFactory.downloadFile(response.data, collaborator.hv_id + '.zip');

            }, function (reject) {
                IkanoFactory.showAlert("Error", "La hoja de vida no tiene adjuntos, por favor valide la información");
            });
        }

        vm.modelPaginationCollaborators = function (filterPage) {
            vm.paginationCollaborators = filterPage;
            if (!vm.page.collaborators) {
                vm.page.collaborators = 1;
            }
            vm.setPageCollaborator(vm.page.collaborators, true, filterPage);
        }

        vm.modelPaginationCandidates = function (filterPage) {
            vm.paginationCandidates = filterPage;
            if (!vm.page.candidates) {
                vm.page.candidates = 1;
            }
            vm.setPageCandidates(vm.page.candidates, true, filterPage);
        }

        //Inicia el paginador
        vm.setPageCollaborator = function (page, noConsult) {
            vm.page.collaborators = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager.collaborators = paginationService.GetPager(vm.paginationCollaborators.total_rows, page, analystConstant.LIMITROW);
            if (!noConsult) {
                var filter = {
                    filtros: vm.backup.filter.collaborators, pagination: {
                        page: page,
                        limit: analystConstant.LIMITROW
                    }
                };
                getCollaborators(filter);
            }
        }

        vm.setPageCandidates = function (page, noConsult) {
            vm.page.candidates = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager.candidates = paginationService.GetPager(vm.paginationCandidates.total_rows, page, analystConstant.LIMITROW);
            if (!noConsult) {
                var filter = {
                    filtros: vm.backup.filter.candidates, pagination: {
                        page: page,
                        limit: analystConstant.LIMITROW
                    }
                };
                searchCandidates(filter);
            }
        }

        vm.saveSearchCollaborators = function () {
            vm.page.collaborators = 1;
            getCollaborators({
                filtros: vm.filter.collaborators,
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }

        vm.saveSearchCandidates = function () {
            vm.page.candidates = 1;
            searchCandidates({
                filtros: vm.filter.candidates,
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }

        /**
         * change position
         */

        vm.loadData = function (index, filter,lista) {
            if (filter && filter.length >= 3) {
                vm.loadDataFilter(index, filter,lista);
            } else {
                var length = vm.misc.candidates[index][lista].length;
                if (length == vm[lista].length) {
                    return;
                }
                for (var i = 0; i < vm.limit; i++) {
                    var pushIndex = i + length;
                    if(typeof vm[lista][pushIndex] == "undefined"){
                        break;
                    }
                    vm.misc.candidates[index][lista].push(vm[lista][pushIndex]);
                }
            }
        }

        vm.loadDataFilter = function (index, filter,lista) {
            vm.misc.candidates[index][lista] = $filter('filter')(vm[lista], filter);
        }

        vm.saveCollaborator = function (candidate) {

            candidate.loading = true;
            AdminService.addCollaborator({ hoja_vida_id: candidate.hv_id, cargo: candidate.positions.name, sociedad_id: candidate.sociedades.id }, function (response) {
                if (response.data.status) {
                    candidate.selected = false;
                    candidate.es_colaborador = true;
                    modelCollaborators(response.data.data);
                } else {
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }
                candidate.loading = false;
            }, function (reject) {
                candidate.loading = false;
                IkanoFactory.showAlert("Error", reject.data.message);
            }, true);
        }

        vm.removeCollaborator = function (candidate) {
            candidate.loading = true;
            AdminService.removeCollaborator({ hoja_vida_id: candidate.hv_id }, function (response) {
                if (response.data.status) {
                    candidate.es_colaborador = false;
                } else {
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }
                candidate.loading = false;
            }, function (reject) {
                candidate.loading = false;
                IkanoFactory.showAlert("Error", reject.data.message);
            }, true);
        }

        vm.goState = function (route, params) {

            $state.go(route, params);
        }

        vm.createPaginationCollaborators = function (){
            console.log(vm.pager);
            //createPaginationCollaborators();
        }

        vm.createPaginationCandidates = function(){
            console.log(vm.pager);
            //createPaginationCandidates();
        }

        function createPaginationCollaborators() {
            var elemt = $('.right');
            elemt.addClass("right-collaborators");
            elemt.removeClass('right');
            
            //elemt.appendTo('<div class="paginations"></div>');
            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.collaborators.currentPage}} de {{vm.pager.collaborators.totalPages}} hasta {{vm.pager.collaborators.totalItems}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.collaborators.currentPage === 1}" ng-click="vm.setPageCollaborator(vm.pager.collaborators.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.collaborators.currentPage === vm.pager.collaborators.totalPages}" ng-click="vm.setPageCollaborator(vm.pager.collaborators.currentPage + 1)">Siguiente</a></div></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        function createPaginationCandidates() {
            var elemt = $('.right');
            elemt.addClass("right-candidate");
            elemt.removeClass('right');
            //elemt.appendTo('<div class="paginations"></div>');
            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.candidates.currentPage}} de {{vm.pager.candidates.totalPages}} hasta {{vm.pager.candidates.totalItems}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.candidates.currentPage === 1}" ng-click="vm.setPageCandidates(vm.pager.candidates.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.candidates.currentPage === vm.pager.candidates.totalPages}" ng-click="vm.setPageCandidates(vm.pager.candidates.currentPage + 1)">Siguiente</a></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        getCollaborators({
            filtros: {},
            pagination: {
                page: 1,
                limit: vm.limit
            }
        }, false);

        getLists({
            lists: [
                "list_sociedad"
            ]
        }, true);
    }
})();
(function(){
    'use strict';

    angular.module('app.seleccion_admin').controller('collaboratorController',collaboratorController);

    function collaboratorController ($mdDialog, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, analystService, analystMisc,$mdToast,analystConstant,paginationService,$compile,$scope,ValidationService){
        //constructor
        var vm = this;

        vm.idCollaborator = $state.params.id;

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Colaboradores', 'Detalle del colaborador'],
            title: "Detalle del colaborador",
        };

        vm.validationService = ValidationService;

        //PUEDE EDITAR O NO LOS BLOQUES
        vm.analyst = true;

        vm.loading = true;

        vm.data = {};

        vm.filter = {};

        vm.backup = {};

        vm.misc = {};

        function getCollaborator(){

            AdminService.getCollaborator({hoja_vida_id:vm.idCollaborator},function(response){
                if (response.data.status) {
                    vm.resume = response.data.data.data.hoja_vida.data_bloques;
                    vm.attachments = response.data.data.data.hoja_vida.adjuntos;
                    vm.existsAttchments = !angular.equals(vm.attachments,{});
                    vm.hv_license = response.data.data.data.hoja_vida_licencia;
                    vm.porcHv = response.data.data.data.hoja_vida.porcentaje;
                    vm.fields = response.data.data.data.hoja_vida.estructura_campos;
                    vm.setTitles();
                    vm.loading = false;
                    vm.lists = response.data.data.data.hoja_vida.listas;
                    
                }else{
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }
            },function(reject){
                IkanoFactory.showAlert("Error", reject.data.message);
            });

        }

        /**
         * ACCION COLABORADOR
         */

        vm.saveReportForToclientFn = function(){
            AdminService.downloadFileCollaborator({hoja_vida_id:vm.idCollaborator},{responseType : 'arraybuffer'},function(response){
                IkanoFactory.downloadFile(response.data, vm.idCollaborator + '.zip');
            },function(reject){
                IkanoFactory.showAlert("Error", "Ocurrio un error descargando los adjuntos del colaborador.");
            });
        }

        vm.removeCollaborator = function(){
            AdminService.removeCollaborator({hoja_vida_id:vm.idCollaborator},function(response){
                if(response.data.status){
                    vm.hv_license.es_colaborador = false;
                    showToast({ class: "success", message: response.data.message, showClose: true });
                }else{
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }
            },function(reject){
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.selectedCollaborator = function(){
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: 'app/main/admin/collaborators/partial/position/position.html',
                clickOutsideToClose: true,
                controller: 'positionControllerDialog',
                controllerAs: 'vm',
                locals: {
                    positions: vm.backup.positions,
                    sociedades: vm.backup.sociedades
                }
            }).then(function(resolve){
                
                vm.addCollaborator(resolve.positions.name,resolve.sociedades.id);
            });
        }

        vm.addCollaborator = function(position,sociedad_id){
            AdminService.addCollaborator({hoja_vida_id:vm.idCollaborator,cargo:position,sociedad_id:sociedad_id},function(response){
                if(response.data.status){
                    vm.hv_license.es_colaborador = true;
                    showToast({ class: "success", message: response.data.message, showClose: true });
                }else{
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }
            },function(reject){
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }



        vm.saveCenso = function(save){
            AdminService.saveCenso({hoja_vida_id:vm.idCollaborator,cargo:position},function(response){
                if(response.data.status){
                    vm.hv_license.es_colaborador = true;
                    showToast({ class: "success", message: response.data.message, showClose: true });
                }else{
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }
            },function(reject){
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.getProfilePictureSrc = function (picture) {
			return (picture ? CandidateService.getUrlBase() + "/" + picture : "assets/images/avatars/profile.jpg");
		};

        /**
         * BLOQUES
         */
        vm.setTitles = function () {
            vm.blocks = $.map(vm.resume, function (value, index) {
                value.titulo = value.titulo.split(" ");
                value.name = index;
                value.emptyRowsMessage = "Por favor completa todos lo datos solicitados. Esto hará que la calidad de la información de tu hoja de vida mejore y agilize el proceso de selección";
                value.item = (value.data && !value.data.length ? value.data : null);

                if (value.name == "personales") {
                    value.data.foto = value.data.foto + "?v=" + vm.getRandomNumber();
                }

                value.campos = IkanoFactory.getStructureForFields(value.campos,vm.fields);

                return [{ name: index, data: value }];
            });
        };

        vm.getRandomNumber = function () {
            return Math.floor((Math.random() * 100) + 1);
        };

        vm.pageCollaborators = function (){
            $state.go('app.seleccion_get_colaborators');
        }

        function getLists(data,showLoad){
            vm.lists = JSON.parse(localStorage.getItem('lists'));
            vm.backup.positions = angular.copy(vm.lists.cargos);
            AdminService.getLists(data, function (resolve) {
                vm.backup.sociedades = resolve.data.data.list_sociedad;
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            }, showLoad);
            //if(localStorage.getItem('positions') && localStorage.getItem('positions') != 'undefined'){
                //vm.backup.positions = JSON.parse(localStorage.getItem('positions'));
            /*}else{
                
            }*/
            
        }

        vm.getAttachmentUrl = function(attachment) {
            var id = (typeof attachment !== "number") ? attachment.id : attachment;
            analystService.getFile({ id: id }, { responseType: 'arraybuffer' },
                function (response) {
                    IkanoFactory.downloadFile(response.data, attachment.name)
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error descargando el archivo, por favor intente de nuevo.");
                });
        }

        vm.downloadPDF = function () {
            var data = { id: vm.idCollaborator, tipo: "hoja_vida" };
            AdminService.getPDFReport(data, { responseType: 'arraybuffer' }, function (resolve) {
                IkanoFactory.downloadFile(resolve.data, vm.idCollaborator + ".pdf");
            }, function (reject) {
                var data = {};
                data.class = "error";
                data.message = reject.data.message;
                data.showClose = true;
                $rootScope.$broadcast('toast::show', { data: data, options: [] });
            });
        };

        getCollaborator();

        getLists({
            lists:[
                "list_sociedad"
            ]
        },true);

        /**
         * TOAST
         */

        function showToast (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('UdpateApproverRequestController', UdpateApproverRequestController);

	/** @ngInject */
	function UdpateApproverRequestController($mdDialog, $document, $mdSidenav, $state, $scope, ValidationService, AdminService, CandidateService, IkanoFactory) {
		var vm = this;

		vm.id = $state.params.id + "";
		vm.data = null;
		vm.blocks = [];
		vm.lists = null;
		vm.fields = null;
		vm.extra = null;
        vm.loading = true;
		vm.errors = {};
		vm.values = {};
		vm.change = false;
		vm.observations = [];
		vm.obsForm = {};
		vm.showObsForm = false;

		vm.saveButtonTitle = "Guardar";
		vm.saving = false;

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['EDITAR REQUISICIÓN'],
			title: "",
		};

		vm.validationService = ValidationService;

		vm.getRequest = function() {
			AdminService.getRequestApprover({id: vm.id}, {}, 
				function(response) {
					if (response.data.requisicion) {
						vm.data = response.data.requisicion;
						vm.values = response.data.requisicion.data;
						vm.lists = vm.data.listas;
						//vm.fields = vm.data.estructura_campos;
						vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
						vm.extra = vm.data.extra;
						vm.observations = vm.data.observaciones;
						vm.setPageData();
						vm.setValuesWatch();
						vm.change = false;
						vm.setBlocks();
						//vm.getPositionColaborators(vm.values.cargo_id);
						ValidationService.generalFunctions($scope, vm);
						ValidationService.watchFunctions($scope, vm);
					}
					vm.loading = false;
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.loading = false;
				}
			);
		};

		vm.getRequest();

		vm.onchange_lists = function (lista) {
			$.each(vm.lists, function (key, value) {
				if (lista[key]) {
					vm.lists[key] = lista[key];
				}
			});
			for (var c in vm.data.estructura_campos) {
				var campo = vm.data.estructura_campos[c];
				if (lista[campo.options]) {
					$scope.$broadcast('changeList' + c, lista[campo.options]);
				}
			}
		}

		vm.setPageData = function() {
			vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
			vm.pageInfo.title += '<span class="pl-5">' +  IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
			if (vm.data.data.no_vacantes) {
				var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
				vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
			}
			
			vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
			if (vm.data.data.tipo_solicitud_b_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
			}		
			if (vm.data.data.tipo_solicitud_c_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
			}		
		};

		vm.checkEmptyObject = function(obj) {			
			if (angular.equals(obj, {})) {
				return true;
			}

			return false;
		}

		vm.first = true;
		vm.setValuesWatch = function() {
			ValidationService.setWarchers($scope, vm);
		};

		vm.getPositionColaborators = function(position) {
			AdminService.getPositionColaborators({cargo_id: position, proceso_id: vm.id}, {}, 
				function(response) {
					if (response.data.colaboradores) {
						//vm.lists.position_colaborators = response.data.colaboradores;
						var colaboradores = response.data.colaboradores;
						vm.lists.position_colaborators = IkanoFactory.setPositionsId(response.data.colaboradores,'estructura_id');

						//CAMBIAR ID DE INFO_OCUPANTE_ACTUAL POR ESTRUCTURA_ID
						var newInfo = [];
						for (var i in vm.values.info_ocupante_actual) {
							var ocupante = vm.values.info_ocupante_actual[i];
							if (colaboradores[ocupante]) {
								newInfo.push((colaboradores[ocupante].estructura_id ? colaboradores[ocupante].estructura_id : colaboradores[ocupante].id) + "");
							}
						}
						vm.values.notChangeInfoActual = true;
						vm.values.info_ocupante_actual = newInfo;
					}
				},
				function(response) {
					//IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
        };

		vm.setBlocks = function() {
			vm.blocks = $.map(vm.data.bloques, function(value, index) {
				return [vm.getBlock(index, value)];
			});
		};

		vm.getBlock = function(index, data) {
			var block = {
				id: null,
				name: index,
				model: data.model,
				title: (data.name ? data.name.split(" ") : ""),
				type: "two-columns",
				block: data.model.type,
				fields: data.campos
			};

			if (block.name == "info_general") {
				block.type = "one-column";
			} else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
				block.type = "select-current-employee";
			} else if (block.fields.length < 2) {
				block.type = "one-column";
			} else if (data.type == "has_many") {
				block.type = "two-column-multiple-rows";
			}

			return block;
		};

		vm.addModelToBlock = function(block) {
			var model = {};
			for (var index = 0; index < block.fields.length; index++) {
				var element = block.fields[index];
				model[element] = null;
			}
			vm.values[block.model].push(model);
		}

		vm.removeModelToBlock = function(block, index) {
			vm.values[block.model].splice(index,1);
		}

		vm.getValue = function(field, value) {
			if (field.options) {
				if (vm.lists[field.options][value]) {
					return vm.lists[field.options][value];
				}

				return value;
			} 

			return value;
		};

		vm.save = function(approve) {
			vm.errors = {};
			vm.saving = true;
			vm.saveButtonTitle = "Guardando...";
			
			var data = {};
			var fields = {};
			/*for(var b in vm.blocks){
				var element = vm.blocks[b];
				for(var c in element.fields){
					var field = element.fields[c];
					if(vm.values[field]){
						data[field] = angular.copy(vm.values[field]);
						fields[field] = vm.fields[field];
					}
				}
			}*/

			vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values, true);


			//EJEMPLO vm.errors = {numero_caso_service_manager: "Este campo es obligatorio"}

            if (approve && !angular.equals(vm.errors, {})) {
                vm.saving = false;
				vm.saveButtonTitle = "Guardar";
				IkanoFactory.showAlert("Error", "La requisición se encuentra incompleta, por favor complete el formulario para aprobar.");
            } else {
				var data = {
					id: vm.id,
					data: vm.values
				};

				AdminService.saveRequestApprover(data, {}, 
					function(response) {
						if (response.data.result.status) {
							if (!approve) {
								vm.idRequest = response.data.result.data.id;
								$state.go('app.seleccion_ver_approver_requisicion', {id: response.data.result.data.id});
							} else {
								vm.openApproveRequestDialog();
							}

							vm.change = false;
						} else {
							var def_msg = "Ha ocurrido un error, por favor intente de nuevo.";

							if (response.data.result.cust_msg) def_msg = response.data.result.cust_msg;

							IkanoFactory.showAlert("Error", def_msg);
						}

						vm.saving = false;
						vm.saveButtonTitle = "Guardar";
					},
					function(response) {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
						vm.saving = false;
						vm.saveButtonTitle = "Guardar";
					}
				);
			}
		};

		vm.getVacants = function() {
			var vacants = [];

			if (vm.values.no_vacantes * 1) {
				for (var index = 1; index < (vm.values.no_vacantes * 1) + 1; index++) {
					vacants.push(index);
				}
			}

			return vacants
		};

		vm.addObservation = function() {
			vm.obsForm.requisicion_id = vm.id;

			AdminService.saveObservationsRequest(vm.obsForm, {}, 
				function(response) {
                    if (response.data.requisicion.status) {
						vm.showObsForm = false;
						vm.obsForm.id = null;
						vm.obsForm.comentario = "";
                        vm.observations = response.data.requisicion.data.observaciones;
                    } else {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.openDismissRequestDialog = function(ev) {
			$mdDialog.show({
                controller: 'DismissRequestController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/approver/show-request/dialogs/dismiss-request.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.idRequest,
					data: vm.data
                }
            });
		};

		vm.saveAndDismiss = function() {
			vm.errors = {};
			vm.saving = true;
            vm.saveButtonTitle = "Guardando...";

            var data = {
				id: vm.id,
				data: vm.values
			};

			AdminService.saveRequestApprover(data, {}, 
				function(response) {
					if (response.data.result.status) {
						vm.idRequest = response.data.result.data.id;
						vm.openDismissRequestDialog()

						vm.change = false;
					} else {
						var def_msg = "Ha ocurrido un error, por favor intente de nuevo.";

						if (response.data.result.cust_msg) def_msg = response.data.result.cust_msg;

						IkanoFactory.showAlert("Error", def_msg);
					}

					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				}
			);
		};

		vm.updateObservation = function(obs) {
			vm.obsForm.id = obs.id;
			vm.obsForm.comentario = obs.comentario;
			vm.showObsForm = true;
		};

		vm.openSetEmployeesDialog = function(ev, index, name, field) {
			field.name = name;
      $mdDialog.show({
				controller: 'AddEmployeeController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin/requester/new-request/dialogs/add-employee.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					values: vm.values,
					index: index,
					field: field,
					errors: vm.errors,
					lists: vm.lists,
					event: ev,
				}
      }).then(function(response){
				if(field.name == 'info_ocupante_actual' && response[field.name][0] === null) {
					console.log(response[field.name]);
					vm.values[field.name] = [];
					return false
				}

				vm.values[field.name] = response[field.name];
			});
		};
		
		vm.deleteObservation = function(ev, obs) {
			var data = {
				requisicion_id: vm.id * 1,
				id: obs.id
			}; 

			IkanoFactory.showConfirmAlert(ev, "Eliminar observación", "¿Está seguro que desea eliminar la observación?", data, vm.deleteObservationRequest);
		}

		vm.deleteObservationRequest = function(data) {
			AdminService.deleteObservationsRequest  (data, {}, 
				function(response) {
                    if (response.data.requisicion.status) {
						vm.showObsForm = false;
						vm.obsForm.id = null;
						vm.obsForm.comentario = "";
                        vm.observations = response.data.requisicion.data.observaciones;
                    } else {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.openApproveRequestDialog = function(ev) {
			$mdDialog.show({
        controller: 'ApproveRequestController',
        controllerAs: 'vm',
        templateUrl: 'app/main/admin/approver/show-request/dialogs/approve-request.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: { idRequest: vm.id, data: vm.data, update: true, set_storage: true }
      }).then(function(response){
				if(response.requisicion.fields){
					for(var i in response.requisicion.fields){
						vm.errors[response.requisicion.fields[i]] = IkanoFactory.getMessage("required");
					}
				}
			});
		};

		vm.openDivideRequestDialog = function(index, name, field) {
			$mdDialog.show({
                controller: 'DivideRequestController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/requester/update-request/dialogs/divide-request.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.id,
					values: vm.values,
                }
            });
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_admin').controller('approve-understanding-position', approveUnderstandingPosition);

    function approveUnderstandingPosition(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService, $mdSidenav, $rootScope) {
        //definimos el contructor
        var vm = this;

        //PARAMS
        vm.idRequest = $state.params.request_id;
        vm.validationService = ValidationService;

        vm.request = {};

        //MISCELANEOS
        vm.misc = {};
        //MISC texto para reemplazar
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

        vm.pageInfo = analystConstant.PAGESINFO.UNDERSTANDINGPOSITION;

        vm.getUnderstandingCharge = function () {
            AdminService.getUnderstandingPosition(
                { proceso_id: vm.idRequest },
                function (resolve) {
                    vm.modelUnderstanding(resolve.data);
                    vm.modelRequest(resolve.data.proceso);
                },function(reject){
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la informacion solicitada, por favor intente de nuevo.");
                }
            )
        }

        //Modelamos la data de la request   
        vm.modelRequest = function (request) {
            var baseJson = (analystConstant.DEBUG) ? analystConstant.KEYJSONREQUESTDEBUG : analystConstant.KEYJSONREQUEST
            analystMisc.modeldata(request, baseJson)
                .then(function (resolve) {
                    vm.request = resolve;
                    var dateSerializate = IkanoFactory.betweenDatesToReplace(vm.misc.text_date_request, vm.request.date_request);
                    vm.request.date_request_compared_string = analystMisc.misc.setStringDateInMonth(dateSerializate);
                    vm.request.date_request_format = analystMisc.misc.setFormatDate(vm.request.date_request, 'MMM D, YYYY');
                    vm.request.date_publish_start_string = (vm.request.date_publish) ? analystMisc.misc.setFormatDate(vm.request.date_publish, 'MMMM D') : '';
                    vm.request.date_publish_close_string = (vm.request.date_publish_close) ? analystMisc.misc.setFormatDate(vm.request.date_publish_close, 'MMMM D') : '';
                    analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
                        vm.request.notes = resolve;
                    });
                    $rootScope.$broadcast("setRequestSerialize", vm.request);
                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }

        vm.modelUnderstanding = function (data) {
            vm.data = data.requisicion;
            vm.values = data.requisicion.data;
            vm.lists = vm.data.listas;
            //vm.fields = vm.data.estructura_campos;
            vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
            vm.extra = vm.data.extra;
            vm.observations = vm.data.observaciones;
            vm.setPageData();
            vm.setValuesWatch();
            vm.change = false;
            vm.setBlocks();

            if(vm.data.original_data && vm.data.original_data.subarea_id){
                AdminService.get_onchange_data({values:{'ubicacion_id':vm.data.original_data.ubicacion_id},function:'getSubareas'},function(response){
                    vm.data.original_data.subarea_id_lista = response.data.data.lista.list_subareas;
                });
            }
            //vm.getPositionColaborators(vm.values.cargo_id);
            ValidationService.generalFunctions($scope, vm);
        }

  

        vm.setPageData = function () {
            vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
            vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
            if (vm.data.data.no_vacantes) {
                var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
                vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
            }

            vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
            if (vm.data.data.tipo_solicitud_b_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
            }
            if (vm.data.data.tipo_solicitud_c_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
            }
        };

        vm.setValuesWatch = function () {
            ValidationService.setWarchers($scope, vm);
        };

        vm.setBlocks = function () {
            vm.blocks = $.map(vm.data.bloques, function (value, index) {
                return [vm.getBlock(index, value)];
            });
        };

        vm.getBlock = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.campos
            };

            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }

            return block;
        };


        vm.addModelToBlock = function (block) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            vm.values[block.model].push(model);
        }

        vm.removeModelToBlock = function (block, index) {
            vm.values[block.model].splice(index, 1);
        }

        vm.getPositionColaborators = function (position) {
            AdminService.getPositionColaborators({ cargo_id: position,proceso_id:vm.idRequest }, {},
                function (response) {
                    if (response.data.colaboradores) {
                        vm.lists.position_colaborators = response.data.colaboradores;
                    }
                },
                function (response) {
                    //IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };


        vm.getUnderstandingCharge();

        vm.sendApprove = function(approve){
            AdminService.sendApproveUnderstanding(
                { proceso_id: vm.idRequest,
                  aprobacion:approve},
                function (resolve) {
                    $state.transitionTo($state.current, $state.params, {
                        reload: true, inherit: false, notify: true
                    });
                },function(reject){
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error enviando la aprobación, por favor intente de nuevo.");
                }
            )
        }

    }

})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('ShowApproverRequestController', ShowApproverRequestController);

	/** @ngInject */
	function ShowApproverRequestController($mdDialog, $document, $mdSidenav, $state, ValidationService, AdminService, CandidateService, IkanoFactory, $window) {
		var vm = this;

		vm.id = $state.params.id + "";
		vm.data = null;
		vm.blocks = [];
		vm.lists = null;
		vm.fields = null;
		vm.extra = null;
        vm.loading = true;
		vm.sidebar = true;
		vm.observations = [];
		vm.obsForm = {};
		vm.statusColor = {};
		vm.showObsForm = false;
		vm.showRequest = true;
		vm.requestTypes = [];
		vm.extraRequests = [];

		vm.validationService = ValidationService;
		vm.downloadPDFReportButton = true;

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['VER REQUISICIÓN'],
			title: "",
		};

		vm.getRequest = function() {
			AdminService.getRequestApprover({id: vm.id}, {}, 
				function(response) {
					if (response.data.requisicion && response.data.requisicion.data) {
						vm.data = response.data.requisicion;
						vm.backupOptions = angular.copy(vm.data.options);
						vm.lists = vm.data.listas;
						vm.fields = vm.data.estructura_campos;
						vm.extra = vm.data.extra;
						vm.observations = vm.data.observaciones;
						vm.statusColor = {'background-color': vm.data.data.estado_color};
						vm.setPageData();
						vm.setBlocks();
						vm.getPositionColaborators(vm.data.data.cargo_id, vm.data.data.id);

						if(vm.data.original_data && vm.data.original_data.subarea_id){
							AdminService.get_onchange_data({values:{'ubicacion_id':vm.data.original_data.ubicacion_id},function:'getSubareas'},function(response){
								vm.data.original_data.subarea_id_lista = response.data.data.lista.list_subareas;
							});
						}

						if($window.localStorage.getItem('undo_approve') !== null){
							vm.data.options = {
								anular: false, aprobar: false, devolver: false, enviar_aprobacion: false, 
								rechazar: false, update: false, update_tipo_solicitud: false, undoApprove: true
							}

							vm.backupOptions = {
								anular: false, aprobar: true, devolver: true, enviar_aprobacion: false, 
								rechazar: true, update: true, update_tipo_solicitud: false
							};

							localStorage.removeItem('undo_approve');
						}

						vm.requestTypes = IkanoFactory.convertRequestTypesObjToArrayObjects(response.data.tipos_solicitud);
						vm.listCountry = response.data.paises_procesos
						if (response.data.tipos_solicitud_extra_ids && response.data.tipos_solicitud_extra_ids.length) {
							vm.modelRequestTypes(vm.requestTypes, response.data.tipos_solicitud_extra_ids);
						}
					}
					vm.loading = false;
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.loading = false;
				}
			);
		}
		vm.getRequest();

		vm.modelRequestTypes = function(requests, extras) {
            for (var index = 0; index < extras.length; index++) {
                var element = extras[index];
                for (var j = 0; j < requests.length; j++) {
                    var type = requests[j];

                    if (type.id == element) {
                        vm.extraRequests.push(type);
                    }
                }
            }
        };

		vm.setPageData = function() {
			vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
			vm.pageInfo.title += '<span class="pl-5">' +  IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
			if (vm.data.data.no_vacantes) {
				var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
				vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
			}
			
			vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
			if (vm.data.data.tipo_solicitud_b_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
			}		
			if (vm.data.data.tipo_solicitud_c_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
			}		
		};

		vm.setBlocks = function() {
			vm.blocks = $.map(vm.data.bloques, function(value, index) {
				return [vm.getBlock(index, value)];
            });
		};

		vm.getPositionColaborators = function(position, proceso_id) {
			AdminService.getPositionColaborators({proceso_id: proceso_id, cargo_id: position}, {}, 
				function(response) {
					if (response.data.colaboradores) {
						vm.lists.position_colaborators = response.data.colaboradores;
					}
				},
				function(response) {
					//IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
        };

		vm.getBlock = function(index, data) {
			var block = {
				id: null,
				name: index, 
				model: data.model,
				title: (data.name ? data.name.split(" ") : ""),
				type: "two-columns",
				block: data.model.type,
				fields: data.campos
			};

			if (block.fields.length < 2) {
				block.type = "one-column";
			} else if (data.type == "has_many") {
				block.type = "two-column-multiple-rows";
			}

			return block;
		};

		vm.getStatusColor = function(status) {
			if (status == 1) {
				return 'blue-bg';
			} else if (status == 2) {
				return 'green-bg';
			} else if (status == 3) {
				return 'grey-bg';
			} else if (status == 5) {
				return 'red-bg';
			}
		};

		vm.downloadPDFReport = function() {
			AdminService.getPDFReport(
				{id: vm.id, tipo: 'proceso'},
				{responseType : 'arraybuffer'},
				function(response) {
					if (response.data) {
						//IkanoFactory.downloadExcel(response.data);
						IkanoFactory.downloadFile(response.data, vm.data.data.codigo + '.pdf')
                    } else {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");    
                    }
				},
				function() {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.getIndicatorColor = IkanoFactory.getIndicatorColor;
		vm.displayCorrectApprover = IkanoFactory.displayCorrectApprover;

		vm.update = function() {
			/*if (vm.data.campos_duplicar_proceso && vm.data.campos_duplicar_proceso.length && vm.data.data.no_vacantes > 1) {
				vm.openDivideRequestDialog();
			} else {
			}*/
      $state.go('app.seleccion_update_approver_requisicion', {id: vm.id});
		};

		vm.undoApproveRequest = function() {
			AdminService.undoApproveRequest({id: vm.id}, {}, 
				function(response) {
          if (!response.data.requisicion.status) {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
          } else {
						vm.data.options = angular.copy(vm.backupOptions);
						vm.data.aprobadores = response.data.requisicion.data.requisicion.aprobadores;
						
						//vm.data.data = response.data.requisicion.data.requisicion.data;
						vm.data.data.estado = response.data.requisicion.data.requisicion.data.estado;
						vm.data.data.estado_color = response.data.requisicion.data.requisicion.data.estado_color;
						vm.data.data.estado_label = response.data.requisicion.data.requisicion.data.estado_label;

						vm.data.extra = response.data.requisicion.data.requisicion.extra;
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.undoDismissRequest = function() {
			AdminService.undoDismissRequest({id: vm.id}, {}, 
				function(response) {
                    if (!response.data.requisicion.status) {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    } else {
                        /*vm.data.options.aprobar = true;
                        vm.data.options.devolver = true;
                        vm.data.options.rechazar = true;
                        vm.data.options.update = true;
						vm.data.options.undoDismiss = false;*/
						vm.data.options = angular.copy(vm.backupOptions);
						vm.data.aprobadores = response.data.requisicion.data.requisicion.aprobadores;

						//vm.data.data = response.data.requisicion.data.requisicion.data;
						vm.data.data.estado = response.data.requisicion.data.requisicion.data.estado;
						vm.data.data.estado_color = response.data.requisicion.data.requisicion.data.estado_color;
						vm.data.data.estado_label = response.data.requisicion.data.requisicion.data.estado_label;
						
                        vm.data.extra = response.data.requisicion.data.requisicion.extra;
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.showReasons = function(reason, observations) {
			IkanoFactory.showAlert(reason, observations);
		};

		vm.addObservation = function() {
			vm.obsForm.requisicion_id = vm.id;

			AdminService.saveObservationsRequest(vm.obsForm, {}, 
				function(response) {
                    if (response.data.requisicion.status) {
						vm.showObsForm = false;
						vm.obsForm.id = null;
						vm.obsForm.comentario = "";
                        vm.observations = response.data.requisicion.data.observaciones;
                    } else {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.deleteObservation = function(ev, obs) {
			var data = {
				requisicion_id: vm.id * 1,
				id: obs.id
			}; 

			IkanoFactory.showConfirmAlert(ev, "Eliminar observación", "¿Está seguro que desea eliminar la observación?", data, vm.deleteObservationRequest);
		}

		vm.deleteObservationRequest = function(data) {
			AdminService.deleteObservationsRequest  (data, {}, 
				function(response) {
                    if (response.data.requisicion.status) {
						vm.showObsForm = false;
						vm.obsForm.id = null;
						vm.obsForm.comentario = "";
                        vm.observations = response.data.requisicion.data.observaciones;
                    } else {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.openCancelRequestDialog = function(ev, index, name, field) {
			$mdDialog.show({
                controller: 'CancelRequestController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/requests/dialogs/cancel-request.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.id,
					data: vm.data,
                    event: ev,
                }
            });
        };

		vm.updateObservation = function(obs) {
			vm.obsForm.id = obs.id;
			vm.obsForm.comentario = obs.comentario;
			vm.showObsForm = true;
		};

		vm.openApproveRequestDialog = function(ev) {
			var data = {};
			var fields = {};
			/*for(var b in vm.blocks){
				var element = vm.blocks[b];
				for(var c in element.fields){
					var field = element.fields[c];
					if(vm.data.data[field]){
						data[field] = angular.copy(vm.data.data[field]);
						fields[field] = vm.fields[field];
					}
				}
			}
			vm.errors = IkanoFactory.validateFieldsWithObject(fields, data, true);*/
			vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.data.data, true);
			console.log(vm.errors);
			if (angular.equals(vm.errors, {})) {
				$mdDialog.show({
					controller: 'ApproveRequestController',
					controllerAs: 'vm',
					templateUrl: 'app/main/admin/approver/show-request/dialogs/approve-request.html',
					parent: angular.element($document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {
						idRequest: vm.id,
						data: vm.data,
						update: false,
						set_storage: false
					}
				});
			} else {
				IkanoFactory.showAlert("Error", "La requisición se encuentra incompleta, por favor haga clic en modificar y complete la requisición para aprobar.");
			}
		};

		vm.openGiveBackRequestDialog = function(ev) {
			$mdDialog.show({
                controller: 'GivebackRequestController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/approver/show-request/dialogs/giveback-request.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.id,
					data: vm.data
                }
            });
		};

		vm.openDismissRequestDialog = function(ev) {
			$mdDialog.show({
                controller: 'DismissRequestController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/approver/show-request/dialogs/dismiss-request.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.id,
					data: vm.data
                }
            });
		};

		vm.openUpdateRequestTypeDialog = function(ev) {
			$mdDialog.show({
                controller: 'UpdateRequestTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/approver/show-request/dialogs/update-request-type.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.id,
					data: vm.data,
					requestTypes: vm.requestTypes,
					extraRequests: vm.extraRequests,
					getRequest: vm.getRequest,
					listCountry: vm.listCountry,
					newRequest: false,
                    event: ev,
                }
            });
		}

		vm.openDivideRequestDialog = function() {
			$mdDialog.show({
                controller: 'DivideRequestController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/requester/update-request/dialogs/divide-request.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.id,
					values: vm.data.data,
                }
            });
        };
		
        vm.toggleSidenav = function(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin')
        .controller('ApproverRequestsController', ApproverRequestsController);

    /** @ngInject */
    function ApproverRequestsController($mdDialog, $document, $state, $sce, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, paginationService, IkanoFactoryPagination,$compile,$scope) {
        var vm = this;

        vm.loading = true;
        vm.showAprobationTime = false;

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Requisiciones para aprobar'],
            title: "Requisiciones para aprobar",
        };

        var locale = IkanoFactory.getDateLocaleFormat('es');
        if (locale != false) {
            $mdDateLocale.months = locale.months;
            $mdDateLocale.shortMonths = locale.shortMonths;
            $mdDateLocale.days = locale.days;
            $mdDateLocale.shortDays = locale.shortDays;
        }

        jQuery.extend(jQuery.fn.dataTableExt.oSort, {
            "date-nl-pre": function (date) {
                return moment(date, 'DD/MMMM/YYYY');
            },

            "date-nl-asc": function (a, b) {
                return (a.isBefore(b) ? -1 : (a.isAfter(b) ? 1 : 0));
            },

            "date-nl-desc": function (a, b) {
                return (a.isBefore(b) ? 1 : (a.isAfter(b) ? -1 : 0));
            }
        });

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(2).withOption('type', 'date-nl')
        ];

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            responsive: true,
            iDisplayLength: 20,
            searching: false
        };

        vm.filter = $state.params.filter;

        vm.getRequests = AdminService.getForApproveRequestsApprover;

        vm.requests = [];
        vm.allRequests = [];

        vm.page = 1;
        vm.pager = {};

        vm.filterValue = {};

        vm.total_results = 0;

        if (vm.filter == "seleccion_requisiciones_aprobacion") {
            vm.pageInfo.parents = ['Pendientes aprobación'];
            vm.pageInfo.title = 'Requisiciones pendientes de aprobación';
            vm.getRequests = AdminService.getForApproveRequestsApprover;
            vm.showAprobationTime = true;
            vm.dtOptions.order = [];
            vm.dtOptions.pageLength = 200;
            vm.limit = 200;

        } else if (vm.filter == "seleccion_requisiciones_proceso") {
            vm.pageInfo.parents = ['En proceso'];
            vm.pageInfo.title = 'Requisiciones en proceso';
            vm.getRequests = AdminService.getInProcessRequestsApprover;
            vm.showAprobationTime = false;
            vm.dtOptions.order = [[3, "desc"]];
            vm.dtOptions.pageLength = 15;
            vm.limit = 15;

        }

        vm.filterByDate = function () {
            if (vm.startDate && vm.endDate) {
                vm.requests = [];
                for (var index = 0; index < vm.allRequests.length; index++) {
                    var element = vm.allRequests[index];
                    if (element.fecha_solicitud) {
                        var date = moment(element.fecha_solicitud);
                        var sd = moment(vm.startDate);
                        var ed = moment(vm.endDate);
                        if (date.isBetween(sd.subtract(1, "days"), ed.add(1, "days"))) {
                            vm.requests.push(element);
                        }
                    }
                }
            }
        }

        vm.callbackSendData = function (filter) {
            vm.page = 1;
            IkanoFactoryPagination.clear();
            IkanoFactory.saveValueFilterJson($state.current.name, filter);
            var filterSerialize = serializeData(filter);
            vm.filterValue = filter;
            vm.getRequests(filterSerialize, {}, getResquestSuccess, getRequestError);
        }

        vm.clearFilter = function () {
            IkanoFactoryPagination.clear();
            IkanoFactory.clearValueFilter($state.current.name);
            vm.page = 1;
            var filterSerialize = serializeData(null, 1);
            vm.filterValue = {};
            vm.getRequests(filterSerialize, {}, getResquestSuccess, getRequestError);
        }

        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.total_results, page, vm.limit);
            if (!noConsult) {
                var filter = serializeData(vm.filterValue);
                if (IkanoFactoryPagination.getDataPage(vm.page)) {
                    var local = IkanoFactoryPagination.getDataPage(vm.page);
                    getResquestSuccess(local, true);
                } else {
                    vm.getRequests(filter, {}, getResquestSuccess, getRequestError);
                }

            }
            setTimeout(function () {
                createPagination();
            }, 1000);
        }

        IkanoFactoryPagination.setKey($state.current.name);

        // Coloca los filtros
        vm.filtersData = vm.filterValue = IkanoFactory.setValuefilterJson($state.current.name);
        if (IkanoFactoryPagination.getDataPage(vm.page)) {
            var local = IkanoFactoryPagination.getDataPage(vm.page);
            getResquestSuccess(local, true);
        } else {
            vm.getRequests({}, {}, getResquestSuccess, getRequestError);
        }

        function serializeData(filter, page) {
            var objReturn = filter ? filter : {};
            var page = page ? page : vm.page;
            objReturn.page_params = { page: page };

            return objReturn;
        }

        function modelPagination(total_results) {
            vm.total_results = total_results;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        function createPagination() {
            var elemt = $('.right');
            //elemt.appendTo('<div class="paginations"></div>');
            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}} hasta {{vm.pager.totalItems}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        function getResquestSuccess(response, cache) {
            /*if (cache) {
                vm.requests = response.result.procesos;
                vm.allRequests = response.result.procesos;
                vm.filters = response.filters.filters;
                modelPagination(response.total_results);

            } else {*/
                if (response.data.requisiciones.data.result) {
                    //IkanoFactoryPagination.setDataPage(vm.page, response.data.requisiciones.data);
                    vm.requests = response.data.requisiciones.data.result.procesos;
                    vm.allRequests = response.data.requisiciones.data.result.procesos;
                    vm.filters = response.data.requisiciones.data.filters.filters;
                    modelPagination(response.data.requisiciones.data.result.total_results);
                }
            //}

            vm.loading = false;
        }

        function getRequestError(reponse) {
            IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
            vm.loading = false;
        }

        vm.infoTiempo = function (obj_tiempo) {

            if(obj_tiempo == null){
                return $sce.trustAsHtml('')
            }

            var tiempo = ''

            if (obj_tiempo.dias > 0){
                tiempo += obj_tiempo.dias + (obj_tiempo.dias > 1 ? ' días': ' día')

                if (obj_tiempo.horas > 0 && !obj_tiempo.vencida){
                    tiempo += ', ' + obj_tiempo.horas + (obj_tiempo.horas > 1 ? ' horas': ' hora')
                }
            } else if (obj_tiempo.horas > 0){
                tiempo += obj_tiempo.horas + (obj_tiempo.horas > 1 ? ' horas': ' hora')

                if (obj_tiempo.minutos > 0 && !obj_tiempo.vencida){
                    tiempo += ', ' + obj_tiempo.minutos + (obj_tiempo.minutos > 1 ? ' minutos': ' minuto')
                }
            } else {
                if (obj_tiempo.minutos > 0){
                    tiempo += obj_tiempo.minutos + (obj_tiempo.minutos > 1 ? ' minutos': ' minuto')
                }
            }

            //Espacio de boton
            var color = '#008450'

            if(obj_tiempo.vencida) {
                color = '#B81D13'
            } else if(obj_tiempo.porcentaje <= 30){
                color = '#EFB700'
            }

            var circulo = '<span style="visibility: hidden">'
                         + obj_tiempo.tiempo_real 
                         + '</span><span style="height: 20px;width: 20px;background-color: '
                         + color + ';border-radius: 50%;display: inline-block;"></span>&nbsp;&nbsp;'

            var respuesta =  circulo + tiempo + (obj_tiempo.vencida ? ' vencida' : '')

            return $sce.trustAsHtml(respuesta)
        }
    }
})();
(function(){
    'use strict';

    angular.module('app.seleccion_admin').controller('updateAnalyst',updateAnalyst);

    function updateAnalyst($mdDialog, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder,analystService,analystMisc,$mdToast,$filter){
        var vm = this;

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['Analista','Crear analista'],
			title: "Crear analista",
        };

        vm.data = {};

        vm.misc = {};
        
        vm.idAnalyst = $state.params.id;

        function getAnalysts(){
            vm.petition = JSON.parse(localStorage.getItem('analysts'));
            vm.analysts = vm.petition.analyst;
            vm.misc.companies =  IkanoFactory.jsonToArray(vm.petition.companies);
            vm.analystsBoss = getAnalystBoss(vm.analysts);
            vm.analyst = getAnalyst(vm.idAnalyst,vm.analysts);
            setData(vm.analyst);
        }   

        
        function getAnalystBoss(data){
            var arrAnalystsBoss = [];
            
            for(var i in data){
                if(data[i].is_boss){
                    arrAnalystsBoss.push(data[i]);
                }
            }
            arrAnalystsBoss = $filter('orderBy')(arrAnalystsBoss, 'name');
            return arrAnalystsBoss;
        }

        function getAnalyst(id,data){
            for(var i in data){
                if(data[i].id == id){
                    return data[i];
                }
            }
        }

        function setData(analyst){
            vm.data = analyst;
            vm.data.cedula = parseInt(analyst.cedula);
            vm.data.phone = parseInt(analyst.phone);
            vm.data.companies = getCompaniesSelected(vm.data.companies);
            vm.data.parent = analyst.parentBackup;
        }

        function getCompaniesSelected(data){
            return data.map(function(v,k){
                return v.id
            });
        }

        vm.updateAnalyst = function(){
            var data = angular.copy(vm.data);
            var baseJson = {
                id: 'id',
                area:'area',
                cedula:'cedula',
                email:'email',
                parent:'parent_id',
                name:'name',
                lastname:'lastname',
                password:'password',
                phone:'telefono',
                is_boss:'es_jefe',
                companies:'companies'
            }
            if(data.parent == "0"){
                data.parent = null;
            }
            data.id = vm.idAnalyst;
            analystMisc.modeldata(data,baseJson).then(function(resolve){
                analystService.updateAnalyst(resolve,function(response){
                    if(response.data.status){
                        showToast({ class: "success", message: response.data.message, showClose: true }, []);
                        vm.returnDashboard();
                    }else{
                        return showToast({ class: "error", message: response.data.message, showClose: true }, []);
                    }
                },function(reject){
                    IkanoFactory.showAlert("Error", reject.data.message);
                })
            });
        }

        getAnalysts();


        //Return Dashboard
        vm.returnDashboard = function(){
            $state.go('app.seleccion_get_all_analysts');
        }
        //TOAST
        function showToast (data, options) {
            options = (options) ? options : [];
            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }
    }


})();
(function () {
    'use strict';

    angular.module('app.seleccion_admin').controller('dashboardAnalyst', dashboardAnalyst);

    function dashboardAnalyst($mdDialog, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, analystService, analystMisc, $mdToast, $compile, $scope) {
        var vm = this;

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Analista', 'Lista analista'],
            title: "Lista analista",
        };

        vm.data = {};

        vm.misc = {};

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            pagingType: 'simple',
            autoWidth: false,
            iDisplayLength: 20,
            searching: false
        };

        vm.firstLoad = true;

        function getAnalyst(filter) {
            filter = filter ? filter : {};
            analystService.getAllAnalysts(filter, {}, function (resolve) {
                if (resolve.data.status) {
                    vm.misc.companies = resolve.data.data.lists.companies;
                    modelAnalysts(resolve.data.data.analysts);
                    vm.filters = resolve.data.data.filters;
                } else {
                    return showToast({ class: "error", message: resolve.data.message, showClose: true }, []);
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            })
            setTimeout(function () {
                //Se oculta el selector de cuantas
                $('.left').html($compile('<div class="length"></div>')($scope));
            }, 2000);
        }

        function modelAnalysts(data) {

            var baseJson = {
                area: 'area',
                cedula: 'cedula',
                created: { key: "created", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                email: 'email',
                es_jefe: 'is_boss',
                estado: 'status',
                fk_id: 'fk',
                id: 'id',
                info_extra: 'extra',
                licencia_id: 'licencia',
                modified: { key: "modified", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                name: 'name',
                parent_id: { key: 'parent', callback: "mergeArr", dataCallback: { arrMerge: vm.misc.companies, type: 'Json' } },
                telefono: 'phone',
                companies: 'companies',
                jefe: 'boss',
            };
            analystMisc.modeldataarray(data, baseJson).then(function (resolve) {
                vm.analysts = resolve;
                if(vm.firstLoad){
                    localStorage.setItem('analysts', JSON.stringify({ analyst: vm.analysts, companies: vm.misc.companies }));
                    vm.firstLoad = false;
                }
                
            });
        }

        vm.showDialogDelete = function (analyst, index) {
            $mdDialog.show({
                controller: 'deleteDialogAnalyst',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/analyst/dashboard/dialogs/delete/delete.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    analyst: analyst
                }
            }).then(function (resolve) {
                if (resolve.data.status) {
                    showToast({ class: "success", message: resolve.data.message, showClose: true }, []);
                    removerAnalyst(index);
                } else {
                    return showToast({ class: "error", message: resolve.data.message, showClose: true }, []);
                }
            });
        }

        vm.showDialogActive = function (ev, analyst, index) {

            var data = {
                analyst: analyst,
                index: index
            }

            IkanoFactory.showConfirmAlert(ev, "Activar analista", "¿Está seguro que desea activar el analista " + analyst.name + "?", data, activeAnalyst);
        }

        vm.showDialogDeactive = function (ev, analyst, index) {

            var data = {
                analyst: analyst,
                index: index
            }

            IkanoFactory.showConfirmAlert(ev, "Desactivar analista", "¿Está seguro que desea desactivar el analista " + analyst.name + "?", data, desactiveAnalyst);
        }

        function activeAnalyst(data) {
            analystService.activeAnalyst({ analista_id: data.analyst.id }, function (resolve) {
                if (resolve.data.status) {
                    showToast({ class: "success", message: resolve.data.message, showClose: true }, []);
                    vm.analysts[data.index].status = true;
                } else {
                    showToast({ class: "error", message: resolve.data.message, showClose: true }, []);
                }

            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            })
        }

        function desactiveAnalyst(data) {
            analystService.deactiveAnalyst({ analista_id: data.analyst.id }, function (resolve) {
                if (resolve.data.status) {
                    showToast({ class: "success", message: resolve.data.message, showClose: true }, []);
                    vm.analysts[data.index].status = false;
                } else {
                    showToast({ class: "error", message: resolve.data.message, showClose: true }, []);
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            })
        }

        vm.callbackSendData = function (filter) {
            var filterConsult = angular.copy(filter);
            getAnalyst({ filtros: filterConsult });
        }

        vm.clearFilter = function () {
            getAnalyst();
        }

        vm.goState = function (stage, data) {
            $state.go(stage, data);
        }

        function removerAnalyst(index) {
            vm.analysts.splice(index, 1);
        }

        //TOAST
        function showToast(data, options) {
            options = (options) ? options : [];
            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        getAnalyst();
    }

})();
(function () {
    'use strict';

    angular.module('app.seleccion_admin').controller('createAnalyst', createAnalyst);

    function createAnalyst($mdDialog, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, analystService, analystMisc,$mdToast,$filter) {
        var vm = this;

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Analista', 'Crear analista'],
            title: "Crear analista",
        };

        vm.data = {};

        vm.misc = {};

        function getAnalyst() {
            analystService.getAllAnalysts({}, {}, function (resolve) {
                if (resolve.data.status) {
                    modelAnalysts(resolve.data.data.analysts);
                    vm.misc.companies = IkanoFactory.jsonToArray(resolve.data.data.lists.companies);
                } else {
                    return showToast({ class: "error", message: resolve.data.message, showClose: true }, []);
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            })
        }

        function modelAnalysts(data) {

            var baseJson = {
                area: 'area',
                cedula: 'cedula',
                created: { key: "created", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                email: 'email',
                es_jefe: 'is_boss',
                estado: 'status',
                fk_id: 'fk',
                id: 'id',
                info_extra: 'extra',
                licencia_id: 'licencia',
                modified: { key: "modified", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                name: 'name',
                parent_id: 'parent',
                telefono: 'phone',
                companies: 'companies'
            };
            analystMisc.modeldataarray(data, baseJson).then(function (resolve) {
                vm.analysts = resolve;
                vm.analystsBoss = getAnalystBoss(vm.analysts);
            });
        }

        function getAnalystBoss(data) {
            var arrAnalystsBoss = [];
            for (var i in data) {
                if (data[i].is_boss) {
                    arrAnalystsBoss.push(data[i]);
                }
            }
            arrAnalystsBoss = $filter('orderBy')(arrAnalystsBoss, 'name');
            return arrAnalystsBoss;
        }

        vm.createAnalyst = function () {
            var data = angular.copy(vm.data);
            var baseJson = {
                area: 'area',
                cedula: 'cedula',
                email: 'email',
                parent: 'parent_id',
                name: 'name',
                lastname: 'lastname',
                password: 'password',
                phone: 'telefono',
                is_boss: 'es_jefe',
                companies: 'companies'
            }
            if(data.parent == "0"){
                data.parent = null;
            }
            analystMisc.modeldata(data, baseJson).then(function (resolve) {
                analystService.createAnalyst(resolve, function (response) {
                    if (response.data.status) {
                        showToast({ class: "success", message: response.data.message, showClose: true }, []);
                        vm.returnDashboard();
                    } else {
                        return showToast({ class: "error", message: response.data.message, showClose: true }, []);
                    }
                }, function (reject) {
                    IkanoFactory.showAlert("Error", reject.data.message);
                })
            });
        }
 
        getAnalyst();


        //Return Dashboard
        vm.returnDashboard = function () {
            $state.go('app.seleccion_get_all_analysts');
        }
        //TOAST
        function showToast(data, options) {
            options = (options) ? options : [];
            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }
    }


})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin')
        .controller('AdminUploadStructuresController', AdminUploadStructuresController);

    /** @ngInject */
    function AdminUploadStructuresController($mdDialog, api, $scope, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder) {
        var vm = this;

        vm.loading = {};
        vm.path = api.general.getUrlBase();
        vm.file = {};

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Requisiciones'],
            title: "Carga estructura",
        };

        var locale = IkanoFactory.getDateLocaleFormat('es');
        if (locale != false) {
            $mdDateLocale.months = locale.months;
            $mdDateLocale.shortMonths = locale.shortMonths;
            $mdDateLocale.days = locale.days;
            $mdDateLocale.shortDays = locale.shortDays;
        }

        jQuery.extend(jQuery.fn.dataTableExt.oSort, {
            "date-nl-pre": function (date) {
                return moment(date, 'DD/MMMM/YYYY');
            },

            "date-nl-asc": function (a, b) {
                return (a.isBefore(b) ? -1 : (a.isAfter(b) ? 1 : 0));
            },

            "date-nl-desc": function (a, b) {
                return (a.isBefore(b) ? 1 : (a.isAfter(b) ? -1 : 0));
            }
        });

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(3).withOption('type', 'date-nl')
        ];

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            responsive: true,
            iDisplayLength: 20,
            order: [[3, "desc"]],
            searching: false
        };

        vm.allStructures = [];


        vm.downloadFile = function (url) {
            var a = document.createElement('a');
            a.setAttribute('href', this.path + '' + url);
            a.setAttribute('download', '');
            a.click();
        }

        $scope.onFileChange = function (element, key) {
            //console.log(element.files[0],key);
            //vm.file[key] = element.files[0];
            //console.log(vm.file);
            var reader = new FileReader();
            reader.onload = function (event) {
                $scope.$apply(function ($scope) {
                    vm.file[key] = element.files[0];
                    //vm.uploadFile(element.files[0]);
                });
            }
            reader.readAsDataURL(element.files[0]);
        }

        //vm.uploadFile = function(file){
        vm.uploadStructures = function () {
            var fd = new FormData();
            fd.append('file', vm.file.structures);
            var config = {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            };

            vm.loading.structures = true;
            AdminService.uploadStructures(fd, config,
                function (response) {
                    vm.loading.structures = false;
                    if (response.data.status) {
                        //vm.structures.unshift(response.data.data);
                        IkanoFactory.showAlert("Mensaje", response.data.message);
                    } else {
                        IkanoFactory.showAlert("Error", response.data.message);
                    }
                },
                function (response) {
                    vm.loading.structures = false;
                    IkanoFactory.showAlert("Error", response.data.message);
                }, true
            );

        }

        vm.uploadCharge = function () {
            var fd = new FormData();
            fd.append('file', vm.file.charge);
            var config = {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            };
            vm.loading.charge = true;
            AdminService.uploadCharge(fd, config,
                function (response) {
                    vm.loading.charge = false;
                    if (response.data.status) {
                        IkanoFactory.showAlert("Mensaje", response.data.message);
                    } else {
                        IkanoFactory.showAlert("Error", response.data.message);
                    }
                },
                function (response) {
                    vm.loading.charge = false;
                    IkanoFactory.showAlert("Error", response.data.message);
                }, true
            );

        }

        vm.get_base_cargos = function () {
            AdminService.get_base_cargos({}, {responseType: 'arraybuffer'},
                function (response) {
                    vm.loading.structures = false;
                    //IkanoFactory.downloadFile(response.data,'ESTA.xls');
                    vm.downloadFile(response.data.data.file);
                },
                function (response) {
                    vm.loading.structures = false;
                    IkanoFactory.showAlert("Error", response.data.message);
                }, true
            );
        }

    }
})();
(function () {
  'use strict';

  angular
      .module('app.seleccion_admin')
      .controller('AdminUpdateTiemposController', AdminUpdateTiemposController);

  /** @ngInject */
  function AdminUpdateTiemposController($mdDialog, api, $scope, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder) {
      var vm = this;

      vm.pageInfo = {
          icon: "icon-home",
          parents: ['Requisiciones'],
          title: "Actualizar tiempos",
      };

      vm.dtColumnDefs = [
      ];

      vm.dtOptions = {
          dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          language: IkanoFactory.getLanguajeDataTable(),
          autoWidth: false,
          responsive: true,
          iDisplayLength: 20,
          order: [[0, "asc"]],
          searching: false,
          bPaginate: false,
          bInfo: false
      };

    vm.getTiemposRequests = AdminService.get_tiempos_objetivos;

    vm.roles = [];
    vm.showModal = false;
    
    function getRequetsSucessTiempos(response) {

        if (response.data.get_tiempos_objetivos.data.tiempos_objetivos) {
            
            vm.roles = response.data.get_tiempos_objetivos.data.tiempos_objetivos;
        }
    }

    function getRequetsReject(response) {
        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
        vm.loading = false;
    }

    vm.getTiemposRequests({}, getRequetsSucessTiempos, getRequetsReject, {});
    
    vm.update = function(rol){
        $mdDialog.show({
            controller: 'modalTiempos',
            controllerAs: 'vm',
            templateUrl: 'app/main/admin/admin/update-tiempos/modal/modal-tiempos.html',
            parent: angular.element($document.body),
            clickOutsideToClose: true,
            locals: {
                rol: angular.copy(rol)
            }
        }).then(function (resolve) {

            vm.roles.forEach(function(value, key) {

                if(resolve.rol_key == this[key].rol_key)

                this[key].horas = resolve.horas
            }, vm.roles);
        });
    };


  }

})();

(function () {
  'use strict';

  angular
      .module('app.seleccion_admin').controller('AdminUpdateRolesAprobadoresController', AdminUpdateRolesAprobadoresController);

  /** @ngInject */
  function AdminUpdateRolesAprobadoresController($mdDialog, $document, AdminService, IkanoFactory) {
      var vm = this;

      vm.pageInfo = {
          icon: "icon-home",
          parents: ['Requisiciones'],
          title: "Actualizar roles de aprobacón",
      };

      vm.dtColumnDefs = [
      ];

      vm.dtOptions = {
          dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          language: IkanoFactory.getLanguajeDataTable(),
          autoWidth: false,
          responsive: true,
          iDisplayLength: 20,
          order: [[0, "asc"]],
          searching: false,
          bPaginate: false,
          bInfo: false
      };

    vm.getRolAprobadoresRequests = AdminService.get_info_rol_aprobadores;

    vm.roles = [];
    vm.showModal = false;
    
    function getRequetsSucessRolAprobadores(response) {
        vm.roles = response.data.get_info_rol_aprobadores.data;
    }

    function getRequetsReject(response) {
        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
        vm.loading = false;
    }

    vm.getRolAprobadoresRequests({}, getRequetsSucessRolAprobadores, getRequetsReject, {});
    
    vm.update = function(rol){
        $mdDialog.show({
            controller: 'modalRolAprobadores',
            controllerAs: 'vm',
            templateUrl: 'app/main/admin/admin/update-rol-aprobadores/modal/moda-rol-aprobadores.html',
            parent: angular.element($document.body),
            clickOutsideToClose: true,
            locals: {
                rol: angular.copy(rol)
            }
        }).then(function (resolve) {

            vm.roles.forEach(function(value, key) {

                if(resolve.id == this[key].id)

                this[key].label = resolve.label
            }, vm.roles);
        });
    };


  }

})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('UdpateAdminRequestController', UdpateAdminRequestController);

	/** @ngInject */
	function UdpateAdminRequestController($mdDialog, $document, $mdSidenav, $state, $scope, ValidationService, AdminService, CandidateService, IkanoFactory) {
		var vm = this;

		vm.id = $state.params.id + "";
		vm.data = null;
		vm.blocks = [];
		vm.lists = null;
		vm.fields = null;
		vm.extra = null;
		vm.loading = true;
		vm.errors = {};
		vm.values = {};
		vm.first = true;

		vm.saveButtonTitle = "Guardar";
		vm.saving = false;
		vm.observations = [];

		vm.admin = true;

		vm.validationService = ValidationService;

		vm.pageInfo = {
			icon: "icon-home",
			parents: ['EDITAR REQUISICIÓN'],
			title: "",
		};

		AdminService.getRequestAdmin({ id: vm.id }, {},
			function (response) {
				if (response.data.requisicion) {
					vm.data = response.data.requisicion;
					vm.values = response.data.requisicion.data;
					vm.lists = vm.data.listas;
					vm.fields = vm.data.estructura_campos;
					vm.extra = vm.data.extra;
					vm.observations = vm.data.observaciones;
					vm.setPageData();
					vm.setValuesWatch();
					vm.change = false;
					vm.setBlocks();
					//vm.getPositionColaborators(vm.values.cargo_id);
					ValidationService.generalFunctions($scope, vm);
					ValidationService.watchFunctions($scope, vm);
				}
				vm.loading = false;
			},
			function (response) {
				IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				vm.loading = false;
			}
		);

		vm.onchange_lists = function (lista) {
			$.each(vm.lists, function (key, value) {
				if (lista[key]) {
					vm.lists[key] = lista[key];
				}
			});
			for (var c in vm.data.estructura_campos) {
				var campo = vm.data.estructura_campos[c];
				if (lista[campo.options]) {
					$scope.$broadcast('changeList' + c, lista[campo.options]);
				}
			}
		}

		vm.setPageData = function () {
			vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
			vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
			if (vm.data.data.no_vacantes) {
				var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
				vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
			}

			vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
			if (vm.data.data.tipo_solicitud_b_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
			}
			if (vm.data.data.tipo_solicitud_c_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
			}
		};

		vm.checkEmptyObject = function (obj) {
			if (angular.equals(obj, {})) {
				return true;
			}

			return false;
		}

		vm.first = true;
		vm.setValuesWatch = function () {
			ValidationService.setWarchers($scope, vm);
		};

		vm.getPositionColaborators = function (position) {
			AdminService.getPositionColaborators({ cargo_id: position, proceso_id: vm.id }, {},
				function (response) {
					if (response.data.colaboradores) {
						var colaboradores = response.data.colaboradores;
						vm.lists.position_colaborators = IkanoFactory.setPositionsId(colaboradores, 'estructura_id');

						//CAMBIAR ID DE INFO_OCUPANTE_ACTUAL POR ESTRUCTURA_ID
						var newInfo = [];
						for (var i in vm.values.info_ocupante_actual) {
							var ocupante = vm.values.info_ocupante_actual[i];
							if (colaboradores[ocupante]) {
								newInfo.push((colaboradores[ocupante].estructura_id ? colaboradores[ocupante].estructura_id : colaboradores[ocupante].id) + "");
							}
						}
						vm.values.notChangeInfoActual = true;
						vm.values.info_ocupante_actual = newInfo;
					}
				},
				function (response) {
					//IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.setBlocks = function () {
			vm.blocks = $.map(vm.data.bloques, function (value, index) {
				return [vm.getBlock(index, value)];
			});
		};

		vm.getBlock = function (index, data) {
			var block = {
				id: null,
				name: index,
				model: data.model,
				title: (data.name ? data.name.split(" ") : ""),
				type: "two-columns",
				block: data.model.type,
				fields: data.campos
			};

			if (block.name == "info_general") {
				block.type = "one-column";
			} else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
				block.type = "select-current-employee";
			} else if (block.fields.length < 2) {
				block.type = "one-column";
			} else if (data.type == "has_many") {
				block.type = "two-column-multiple-rows";
			}

			return block;
		};

		vm.addModelToBlock = function (block) {
			var model = {};
			for (var index = 0; index < block.fields.length; index++) {
				var element = block.fields[index];
				model[element] = null;
			}
			vm.values[block.model].push(model);
		}

		vm.removeModelToBlock = function (block, index) {
			vm.values[block.model].splice(index, 1);
		}

		vm.getValue = function (field, value) {
			if (field.options) {
				if (vm.lists[field.options][value]) {
					return vm.lists[field.options][value];
				}

				return value;
			}

			return value;
		};

		vm.save = function () {
			vm.saving = true;
			vm.saveButtonTitle = "Guardando...";

			var data = {
				id: vm.id,
				data: vm.values
			};

			AdminService.saveRequestAdmin(data, {},
				function (response) {
					if (response.data.result.status) {
						IkanoFactory.showAlert("", "La requisición se ha guardado exitosamente.");
						//vm.idRequest = response.data.result.data.id;
						vm.change = false;
						$state.go('app.seleccion_ver_admin_requisicion', { id: response.data.result.data.id });
					} else {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}

					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				},
				function (response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.saving = false;
					vm.saveButtonTitle = "Guardar";
				}
			);
			/*
						}
			*/
		};

		vm.getVacants = function () {
			var vacants = [];

			if (vm.values.no_vacantes * 1) {
				for (var index = 1; index < (vm.values.no_vacantes * 1) + 1; index++) {
					vacants.push(index);
				}
			}

			return vacants
		};

		vm.openSetEmployeesDialog = function (ev, index, name, field) {
			field.name = name;
			$mdDialog.show({
				controller: 'AddEmployeeController',
				controllerAs: 'vm',
				templateUrl: 'app/main/admin/requester/new-request/dialogs/add-employee.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					values: vm.values,
					index: index,
					field: field,
					errors: vm.errors,
					lists: vm.lists,
					event: ev,
				}
			}).then(function (response) {
				if(field.name == 'info_ocupante_actual' && response[field.name][0] === null) {
					console.log(response[field.name]);
					vm.values[field.name] = [];
					return false
				}

				vm.values[field.name] = response[field.name];
			});
		};
	}
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('ShowAdminRequestController', ShowAdminRequestController);

	/** @ngInject */
	function ShowAdminRequestController($mdDialog, $document, $mdSidenav, $state, AdminService, ValidationService, CandidateService, IkanoFactory) {
		var vm = this;

		vm.id = $state.params.id + "";
		vm.data = null;
		vm.blocks = [];
		vm.lists = null;
		vm.fields = null;
		vm.extra = null;
        vm.loading = true;
		vm.sidebar = true;
		vm.observations = [];
		vm.obsForm = {};
		vm.statusColor = {};
		vm.showObsForm = false;
		vm.admin = true;
		vm.showRequest = true;
		vm.requestTypes = [];
		vm.extraRequests = [];
		vm.downloadPDFReportButton = true;
		vm.validationService = ValidationService;

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['VER REQUISICIÓN'],
			title: "",
		};

		vm.getRequest = function() {
			AdminService.getRequestAdmin({id: vm.id}, {}, 
				function(response) {
					if (response.data.requisicion) {
						vm.data = response.data.requisicion;
						vm.lists = vm.data.listas;
						vm.fields = vm.data.estructura_campos;
						vm.extra = vm.data.extra;
						vm.observations = vm.data.observaciones;
						vm.statusColor = {'background-color': vm.data.data.estado_color};
						vm.setPageData();
						vm.setBlocks();
						vm.getPositionColaborators(vm.data.data.cargo_id, vm.data.data.id);

						if(vm.data.original_data && vm.data.original_data.subarea_id){
							AdminService.get_onchange_data({values:{'ubicacion_id':vm.data.original_data.ubicacion_id},function:'getSubareas'},function(response){
								vm.data.original_data.subarea_id_lista = response.data.data.lista.list_subareas;
							});
						}

						vm.requestTypes = IkanoFactory.convertRequestTypesObjToArrayObjects(response.data.tipos_solicitud);
						vm.listCountry = response.data.paises_procesos
						
						if (response.data.tipos_solicitud_extra_ids && response.data.tipos_solicitud_extra_ids.length) {
							vm.modelRequestTypes(vm.requestTypes, response.data.tipos_solicitud_extra_ids);
						}
					}
					vm.loading = false;
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					vm.loading = false;
				}
			);
		};
		vm.getRequest();

		vm.modelRequestTypes = function(requests, extras) {
            for (var index = 0; index < extras.length; index++) {
                var element = extras[index];
                for (var j = 0; j < requests.length; j++) {
                    var type = requests[j];

                    if (type.id == element) {
                        vm.extraRequests.push(type);
                    }
                }
            }
        };

		vm.setPageData = function() {
			vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
			vm.pageInfo.title += '<span class="pl-5">' +  IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
			if (vm.data.data.no_vacantes) {
				var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
				vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
			}
			
			vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
			if (vm.data.data.tipo_solicitud_b_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
			}		
			if (vm.data.data.tipo_solicitud_c_label) {
				vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
			}		
		};

		vm.setBlocks = function() {
			vm.blocks = $.map(vm.data.bloques, function(value, index) {
				return [vm.getBlock(index, value)];
            });
		};

		vm.getPositionColaborators = function(position, proceso_id) {
			AdminService.getPositionColaborators({proceso_id: proceso_id, cargo_id: position}, {}, 
				function(response) {
					if (response.data.colaboradores) {
						vm.lists.position_colaborators = response.data.colaboradores;
					}
				},
				function(response) {
					//IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
        };

		vm.getBlock = function(index, data) {
			var block = {
				id: null,
				name: index, 
				model: data.model,
				title: (data.name ? data.name.split(" ") : ""),
				type: "two-columns",
				block: data.model.type,
				fields: data.campos
			};

			if (block.fields.length < 2) {
				block.type = "one-column";
			} else if (data.type == "has_many") {
				block.type = "two-column-multiple-rows";
			}

			return block;
		};

		vm.getStatusColor = function(status) {
			if (status == 1) {
				return 'blue-bg';
			} else if (status == 2) {
				return 'green-bg';
			} else if (status == 3) {
				return 'grey-bg';
			} else if (status == 5) {
				return 'red-bg';
			}
		};

		vm.getIndicatorColor = IkanoFactory.getIndicatorColor;
		vm.displayCorrectApprover = IkanoFactory.displayCorrectApprover;

		vm.addObservation = function() {
			vm.obsForm.requisicion_id = vm.id;

			AdminService.saveObservationsRequest(vm.obsForm, {}, 
				function(response) {
                    if (response.data.requisicion.status) {
						vm.showObsForm = false;
						vm.obsForm.id = null;
						vm.obsForm.comentario = "";
                        vm.observations = response.data.requisicion.data.observaciones;
                    } else {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.deleteObservation = function(ev, obs) {
			var data = {
				requisicion_id: vm.id * 1,
				id: obs.id
			}; 

			IkanoFactory.showConfirmAlert(ev, "Eliminar observación", "¿Está seguro que desea eliminar la observación?", data, vm.deleteObservationRequest);
		}

		vm.deleteObservationRequest = function(data) {
			AdminService.deleteObservationsRequest  (data, {}, 
				function(response) {
                    if (response.data.requisicion.status) {
						vm.showObsForm = false;
						vm.obsForm.id = null;
						vm.obsForm.comentario = "";
                        vm.observations = response.data.requisicion.data.observaciones;
                    } else {
						IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
					}
				},
				function(response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.downloadPDFReport = function() {			
			AdminService.getPDFReport(
				{id: vm.id, tipo: 'proceso'},
				{responseType : 'arraybuffer'},
				function(response) {
					if (response.data) {
						//IkanoFactory.downloadExcel(response.data);
						IkanoFactory.downloadFile(response.data, vm.data.data.codigo + '.pdf')
                    } else {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");    
                    }
				},
				function() {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
				}
			);
		};

		vm.updateObservation = function(obs) {
			vm.obsForm.id = obs.id;
			vm.obsForm.comentario = obs.comentario;
			vm.showObsForm = true;
		}

		vm.update = function() {
			$state.go('app.seleccion_update_admin_requisicion', {id: vm.id});
		};

		vm.showReasons = function(reason, observations) {
			IkanoFactory.showAlert(reason, observations);
		};

		vm.openCancelRequestDialog = function(ev, index, name, field) {
			$mdDialog.show({
                controller: 'CancelRequestController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/requests/dialogs/cancel-request.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.id,
					data: vm.data,
                    event: ev,
                }
            });
        };
		
		vm.openUpdateRequestTypeDialog = function(ev) {
			$mdDialog.show({
                controller: 'UpdateRequestTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/approver/show-request/dialogs/update-request-type.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                	idRequest: vm.id,
					data: vm.data,
					requestTypes: vm.requestTypes,
					extraRequests: vm.extraRequests,
					getRequest: vm.getRequest,
					listCountry: vm.listCountry,
					newRequest: false,
                    event: ev,
                }
            });
		}

        vm.toggleSidenav = function(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin')
        .controller('AdminRequestsController', AdminRequestsController);

    /** @ngInject */
    function AdminRequestsController($mdDialog, $document, $sce, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, $compile, paginationService, $scope, IkanoFactoryPagination) {
        var vm = this;

        vm.loading = true;

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Requisiciones'],
            title: "Requisiciones",
        };


        var locale = IkanoFactory.getDateLocaleFormat('es');
        if (locale != false) {
            $mdDateLocale.months = locale.months;
            $mdDateLocale.shortMonths = locale.shortMonths;
            $mdDateLocale.days = locale.days;
            $mdDateLocale.shortDays = locale.shortDays;
        }

        jQuery.extend(jQuery.fn.dataTableExt.oSort, {
            "date-nl-pre": function (date) {
                return moment(date, 'DD/MMMM/YYYY');
            },

            "date-nl-asc": function (a, b) {
                return (a.isBefore(b) ? -1 : (a.isAfter(b) ? 1 : 0));
            },

            "date-nl-desc": function (a, b) {
                return (a.isBefore(b) ? 1 : (a.isAfter(b) ? -1 : 0));
            }
        });

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(3).withOption('type', 'date-nl')
        ];

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            responsive: true,
            iDisplayLength: 20,
            order: [[3, "desc"]],
            searching: false
        };

        vm.filter = $state.params.filter;

        vm.getRequests = AdminService.getAllRequestsByAdmin;
        vm.requests = [];
        vm.allRequests = [];
        vm.page = 1;
        vm.pager = {};
        vm.limit = 15;
        vm.numero_requisicion = "";
        vm.startDate = null;
        vm.endDate = null;
        vm.filterValue = {};
        vm.backupRequest = {};

        if (vm.filter == "seleccion_requisiciones_admin_proceso") {
            vm.pageInfo.parents = ['En proceso'];
            vm.pageInfo.title = 'Requisiciones en proceso';
            vm.getRequests = AdminService.getInProcessRequestsByAdmin;

        } else if (vm.filter == "seleccion_requisiciones_admin_aprobadas") {
            vm.pageInfo.parents = ['Aprobadas'];
            vm.pageInfo.title = 'Requisiciones aprobadas';
            vm.getRequests = AdminService.getApprovedRequestsByAdmin;

        } else if (vm.filter == "seleccion_requisiciones_admin_noaprobadas") {
            vm.pageInfo.parents = ['No aprobadas'];
            vm.pageInfo.title = 'Requisiciones no aprobadas';
            vm.getRequests = AdminService.getDismissRequestsByAdmin;

        } else if (vm.filter == "seleccion_requisiciones_admin") {
            vm.pageInfo.parents = ['Todas'];
            vm.pageInfo.title = 'Todas las requisiciones';
            vm.getRequests = AdminService.getAllRequestsByAdmin;

        }



        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.total_results, page, vm.limit);
            console.log(vm.pager);
            if (!noConsult) {
                var filter = serializeData(vm.filterValue);
                if (IkanoFactoryPagination.getDataPage(vm.page)) {
                    var local = IkanoFactoryPagination.getDataPage(vm.page);
                    getRequetsSucess(local, true);
                } else {
                    vm.getRequests(filter, {}, getRequetsSucess, getRequetsReject);
                }

            }
            setTimeout(function () {
                createPagination();
            }, 1000);
        }

        vm.clearFilter = function () {
            IkanoFactoryPagination.clear();
            IkanoFactory.clearValueFilter($state.current.name);
            vm.page = 1;
            var filter = serializeData(null,1);
            vm.filterValue = {};
            vm.getRequests(filter, {}, getRequetsSucess, getRequetsReject);
        }

        function serializeData(filter,page) {
            var objReturn = filter ? filter : {};
            var page = page ? page : vm.page;
            objReturn.page_params = {page:page};
            
            return objReturn;
        }

        function getRequetsSucess(response, cache) {
            if (cache) {
                vm.requests = response.result;
                vm.filters = response.filters.filters;
                modelPagination(response.total_results);
            } else {
                if (response.data.requisiciones_admin.data.result) {
                    vm.requests = response.data.requisiciones_admin.data.result;
                    IkanoFactoryPagination.setDataPage(vm.page, response.data.requisiciones_admin.data);
                    //vm.backupRequest[vm.page] = angular.copy(response.data.requisiciones_admin.data.result);
                    vm.filters = response.data.requisiciones_admin.data.filters.filters;
                    modelPagination(response.data.requisiciones_admin.data.total_results);
                }
            }

            vm.loading = false;
        }

        function getRequetsReject(response) {
            IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
            vm.loading = false;
        }

        function modelPagination(total_results) {
            vm.total_results = total_results;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        function createPagination() {
            var elemt = $('.right');
            //elemt.appendTo('<div class="paginations"></div>');
            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}} hasta {{vm.pager.totalItems}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        vm.callbackSendData = function (filter){
            vm.page = 1;
            IkanoFactoryPagination.clear();
            IkanoFactory.saveValueFilterJson($state.current.name,filter);
            var filterSerialize = serializeData(filter);
            vm.filterValue = filter;
            vm.getRequests(filterSerialize,{},getRequetsSucess, getRequetsReject);
        }

        // Coloca los filtros
        IkanoFactoryPagination.setKey($state.current.name);
        //IkanoFactory.setFilters($state.current.name);
        vm.filtersData = vm.filterValue = IkanoFactory.setValuefilterJson($state.current.name);
        if (IkanoFactoryPagination.getDataPage(vm.page)) {
            var local = IkanoFactoryPagination.getDataPage(vm.page);
            getRequetsSucess(local, true);
        } else {
            vm.getRequests({}, {}, getRequetsSucess, getRequetsReject);
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_admin')
		.controller('AdminDashboardController', AdminDashboardController);

	/** @ngInject */
	function AdminDashboardController($mdDialog, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory) {
		var vm = this;
        vm.loading = true;
        vm.report = null;
        vm.adminDashboard = true;

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['Dashboard'],
			title: "Dashboard",
        };

        vm.years = [];

        for (var index = 2016; index < ((moment().format('YYYY') * 1) + 1); index++) {
            vm.years.push(index);
        }
    
        vm.getReport = function(year) {
            vm.year = year;
            AdminService.getRequestsReportByYear({anio: year}, {}, 
                function(response) {
                    if (response.data.data) {
                        vm.report = response.data.data;
                    }
                    //console.log(vm.report);
                    vm.modelDataForChart();
                    vm.loading = false;
                },
                function(response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    vm.loading = false;
                }
            );    
        };
    
        vm.year = moment().format('YYYY');
        vm.getReport(vm.year);

        vm.modelDataForChart = function() {
            vm.barChart = {
                labels: [],
                series: ['Requisiciones creadas', 'Requisiciones aprobadas', 'Tiempo promedio de aprobación'],
                data: [
                    [],
                    [],
                    [],
                ],
                datasetOverride: [
                    {
                        type: 'bar',
                        label: 'Requisiciones creadas',
                        yAxisID: "y-axis-0",
                        backgroundColor: "rgba(0, 153, 255,0.75)",
                    }, 
                    {
                        type: 'bar',
                        label: 'Requisiciones aprobadas',
                        yAxisID: "y-axis-0",
                        backgroundColor: "rgba(0, 204, 102,0.75)",
                    },
                    {
                        type: 'line',
                        label: 'Tiempo promedio de aprobación',
                        yAxisID: "y-axis-1",
                        backgroundColor: "rgba(151,187,205,0.5)",
                    }
                ],
                options: {
                    legend: { 
                        display: true 
                    },
                    title: {
                      display: true,
                      text: ""
                    },
                    tooltips: {
                      mode: 'label'
                    },
                    responsive: true,
                    scales: {
                      xAxes: [{
                        stacked: false
                      }],
                      yAxes: [{
                        display: true,
                        stacked: false,
                        position: "left",
                        id: "y-axis-0",
                        ticks: {
                            beginAtZero: true
                        }
                      }, {
                        display: TextTrackCue,
                        stacked: false,
                        position: "right",
                        id: "y-axis-1",
                        ticks: {
                            beginAtZero: true
                        }
                      }]
                    }
                }
            };

            for (var index = 0; index < vm.report.requisiciones_mes.length; index++) {
                var element = vm.report.requisiciones_mes[index];
                vm.barChart.labels.push(element.mes);
                vm.barChart.data[0].push(element.creadas);
                vm.barChart.data[1].push(element.aprobadas);
                vm.barChart.data[2].push(element.promedio_dias);
            }
        };
    }
})();
    
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
/*
 * Angular Material Time Picker
 * https://github.com/classlinkinc/angular-material-time-picker
 * @license MIT
 * v1.0.1
 */
(function(window, angular, undefined) {
  'use strict';

  function increase(value, min, max, type) {
    var num = parseInt(value);
    if (isNaN(num) || num === max)
      num = min;
    else
      num++;
    if (type === 'MM')
      return format(num);
    return String(num);
  }

  function decrease(value, min, max, type) {
    var num = parseInt(value);
    if (isNaN(num) || num === min)
      num = max;
    else
      num--;
    if (type === 'MM')
      return format(num);
    return String(num);
  }

  function format(num) {
    if (num < 10)
      return '0' + String(num);
    return String(num);
  }

  function handleInput(value, max, blur, type) {
    var num = parseInt(value);
    if (type === 'HH' && num === 0) {
      if (num === 0) {
        return String(num);
      }
      return;
    }
    if (num > max) 
      return String(num)[0];
    else if (!isNaN(num)) {
      if (value.length === 2 || (blur && type === 'MM'))
        return format(num);
      return String(num);
    }
  }

  angular.module('md.time.picker', ['ngMessages'])

    .directive('mdHoursMinutes', function() {

      return {

        restrict: 'E',
        scope: {
          type: '@',
          message: '@',
          ngModel: '=',
          readOnly: '<', // true or false
          mandatory: '<' // true or false
        },
        template: '<md-input-container md-no-float>' +
          '<input ' +
          'ng-required="mandatory" ' +
          'type="text"' +
          'name="time_{{type}}"' +
          'ng-model="time[type]"' +
          'ng-change="handleInput()"' +
          'placeholder="{{type}}"' +
          'maxlength="2"' +
          'ng-blur="handleInput(true)"' +
          'ng-keydown="handleKeypress($event)" ng-disabled="readOnly"/>' +
          '<span class="md-up-arrow" aria-hidden="true" ng-click="!readOnly && increase()"></span>' +
          '<span class="md-down-arrow" aria-hidden="true" ng-click="!readOnly && decrease()"></span>' +
          '<div class="time-error-messages" ng-messages="$parent.timeForm[\'time_\' + type].$error" role="alert">' +
          '<div ng-message="required">{{message}}</div>' +
          '</div>' +
          '</md-input-container>',
        controller: ["$scope", "$rootScope", function($scope, $rootScope) {

          if ($scope.type === "HH") {
            if ($scope.$parent.noMeridiem) {
              $scope.min = 0;
              $scope.max = 23;
            } else {
              $scope.min = 1;
              $scope.max = 12;
            }
          } else {
            $scope.min = 0;
            $scope.max = 59;
          }

          function setTime() {
            if ($scope.type === "HH") {
              var hours = '';
              try {
                hours = $scope.$parent.ngModel.getHours();
              } catch (e) {
                // leave hours empty to allow empty values
              }

              if (!$scope.$parent.noMeridiem) {
                if (hours > 12)
                  hours -= 12;
                else if (hours === 0)
                  hours += 12;
              }
              $scope.time.HH = String(hours);
            } else
              if ($scope.$parent.ngModel) {
                $scope.time.MM = format($scope.$parent.ngModel.getMinutes());
              } else {
                // leave MM empty to allow empty values
                $scope.time.MM = '';
              }
          }

          $scope.time = {};

          // make sure we update our variables if new values
          $scope.$watch("ngModel", function() {
            setTime();
          });

          var removeListener = $scope.$on('mdpTimePickerModalUpdated', setTime);
          $scope.$on('$destroy', removeListener);

          function updateTime(next) {
            // prevent NaN value in input field
            if (isNaN(next))
              return;

            // if $scope.ngModel is undefined, create new date object. else leave as is, which means user has specified date object
            // Set hours, minutes, seconds and milliseconds to 0 in order for the user to be able to set own values
            if (angular.isDate($scope.ngModel)) {
              if (isNaN($scope.ngModel.getTime())) {
                $scope.ngModel = new Date(2017, 0, 0, 0, 0, 0, 0);
              } else {
                // continue
              }
            } else {
              $scope.ngModel = new Date(2017, 0, 0, 0, 0, 0, 0);
            }
            if ($scope.type === 'MM') {
                $scope.ngModel.setMinutes(next);
                return;
            } else if (!$scope.$parent.noMeridiem) {
              var hours = $scope.ngModel.getHours();
              if (hours >= 12 && next != 12)
                next += 12;
              else if (hours < 12 && next == 12)
                next = 0;
            }
              $scope.ngModel.setHours(next);
          }

          $scope.increase = function() {
            var next = increase($scope.time[$scope.type], $scope.min, $scope.max, $scope.type)
            $scope.time[$scope.type] = next;
            updateTime(parseInt(next));
            $rootScope.$emit('mdpTimePickerUpdated');
          }

          $scope.decrease = function() {
            var next = decrease($scope.time[$scope.type], $scope.min, $scope.max, $scope.type);
            $scope.time[$scope.type] = next;
            updateTime(parseInt(next));
            $rootScope.$emit('mdpTimePickerUpdated');
          }

          $scope.handleInput = function(blur) {
            var next = handleInput($scope.time[$scope.type], $scope.max, blur, $scope.type);
            $scope.time[$scope.type] = next;
            updateTime(parseInt(next));
            $rootScope.$emit('mdpTimePickerUpdated');
          }

          $scope.handleKeypress = function(ev) {
            if (ev.keyCode === 38) $scope.increase();
            else if (ev.keyCode === 40) $scope.decrease();
          }

        }]
      }

    })

    .directive('mdMeridiem', function() {

      return {

        restrict: 'E',
        scope: {
          message: '@',
          readOnly: '<', // true or false
          ngModel: '=',
          mandatory: '<' // true or false
        },
        template: '<md-input-container md-no-float>' +
          '<md-select ' +
          'ng-required="mandatory" ' +
          'name="meridiem"' +
          'ng-model="meridiem"' +
          'ng-change="updateTime()"' +
          'placeholder="AM/PM"' +
          'flex-gt-sm>' +
          '<md-option value="AM" ng-disabled="readOnly">AM</md-option>' +
          '<md-option value="PM" ng-disabled="readOnly">PM</md-option>' +
          '</md-select>' +
          '<div class="time-error-messages" ng-messages="$parent.timeForm.meridiem.$error" role="alert">' +
          '<div ng-message="required">{{message}}</div>' +
          '</div>' +
          '</md-input-container>',
        controller: ["$scope", "$rootScope", function($scope, $rootScope) {

          function setMeridiem() {
            var hours = '';
            try {
              hours = $scope.$parent.$parent.ngModel.getHours();
            } catch (e) {
              // leave hours empty
            }
            $scope.meridiem = hours >= 0 && hours < 12 ? 'AM' : 'PM';
          }

          // update meridiem on load of view and when model is changing
          $scope.$watch("ngModel", function() {
            setMeridiem();
          });

          $scope.updateTime = function() {
            var hours = $scope.$parent.$parent.ngModel.getHours();
            if ($scope.meridiem === 'AM') $scope.$parent.$parent.ngModel.setHours(hours-12);
            else $scope.$parent.$parent.ngModel.setHours(hours+12);
            $rootScope.$emit('mdpTimePickerUpdated');
          }

          var removeListener = $scope.$on('mdpTimePickerModalUpdated', setMeridiem);
          $scope.$on('$destroy', removeListener);

        }]

      }

    })

    .directive('mdTimePicker', function() {

      return {

        restrict: 'E',
        scope: {
          message: '<',
          ngModel: '=',
          readOnly: '<', // true or false
          mandatory: '<' // true or false
        },
        template: '<ng-form name="timeForm" >' +
          '<button class="md-icon-button md-button md-ink-ripple" type="button" ng-click="!readOnly && showPicker($event)">' +
          '<md-icon>' +
          '<i class="icon-clock"></i>' +
          '</md-icon>' +
          '<div class="md-ripple-container"></div>' +
          '</button>' +
          '<md-hours-minutes type="HH" ng-model="ngModel" message="{{message.hour}}" read-only="readOnly" mandatory="mandatory"></md-hours-minutes>' +
          '<span class="time-colon">:</span>' +
          '<md-hours-minutes type="MM" ng-model="ngModel" message="{{message.minute}}" read-only="readOnly" mandatory="mandatory"></md-hours-minutes>' +
          '<md-meridiem ng-if="!noMeridiem" ng-model="ngModel" message="{{message.meridiem}}" read-only="readOnly" mandatory="mandatory" hide-xs hide-sm ></md-meridiem>' +
          '</ng-form>',
        controller: ["$scope", "$rootScope", "$mdpTimePicker", "$attrs", function($scope, $rootScope, $mdpTimePicker, $attrs) {

          $scope.showPicker = function(ev) {

            $mdpTimePicker($scope.ngModel, {
              targetEvent: ev,
              noMeridiem: $scope.noMeridiem,
              autoSwitch: !$scope.noAutoSwitch
            }).then(function(time) {
              // if $scope.ngModel is not a valid date, create new date object.
              // Set hours, minutes, seconds and milliseconds to 0 in order for the user to be able to set own values
              if (angular.isDate($scope.ngModel)) {
                if (isNaN($scope.ngModel.getTime())) {
                  $scope.ngModel = new Date(2017, 0, 0, 0, 0, 0, 0);
                }
              } else {
                $scope.ngModel = new Date(2017, 0, 0, 0, 0, 0, 0);
              }
              $scope.ngModel.setHours(time.getHours());
              $scope.ngModel.setMinutes(time.getMinutes());
              $scope.$broadcast('mdpTimePickerModalUpdated');
              $rootScope.$emit('mdpTimePickerUpdated');
            });

          }

        }],
        compile: function(tElement, tAttrs) {
          return {
            pre: function preLink(scope) {
              scope.noMeridiem = tAttrs.noMeridiem === "" ? true : false;
              scope.noAutoSwitch = tAttrs.noAutoSwitch === "" ? true : false;
            }
          }
        }

      }

    })

    .provider("$mdpTimePicker", function() {
      var LABEL_OK = "Aceptar",
        LABEL_CANCEL = "Cancelar";

      this.setOKButtonLabel = function(label) {
        LABEL_OK = label;
      };

      this.setCancelButtonLabel = function(label) {
        LABEL_CANCEL = label;
      };

      this.$get = ["$mdDialog", function($mdDialog) {
        var timePicker = function(time, options) {

          return $mdDialog.show({
            controller: ['$scope', '$mdDialog', '$mdMedia', function ($scope, $mdDialog, $mdMedia) {
              var self = this;

              // check if time is valid date. Create new date object if not.
              if (angular.isDate(time)) {
                if (isNaN(time.getTime())) {
                  time = new Date(2017, 0, 0, 0, 0, 0, 0);
                } else {
                  // continue
                }
              } else {
                time = new Date(2017, 0, 0, 0, 0, 0, 0);
              }

              this.time = new Date(time.getTime());
              this.noMeridiem = options.noMeridiem;
              if (!self.noMeridiem)
                this.meridiem = time.getHours() < 12 ? 'AM' : 'PM';

              this.VIEW_HOURS = 1;
              this.VIEW_MINUTES = 2;
              this.currentView = this.VIEW_HOURS;
              this.autoSwitch = !!options.autoSwitch;

              $scope.$mdMedia = $mdMedia;

              this.switchView = function() {
                self.currentView = self.currentView == self.VIEW_HOURS ? self.VIEW_MINUTES : self.VIEW_HOURS;
              };

              this.hours = function() {
                var hours = self.time.getHours();
                if (self.noMeridiem) return hours;
                if (hours > 12) return hours-12;
                else if (hours === 0) return 12;
                return hours;
              }

              this.minutes = function() {
                return format(self.time.getMinutes());
              }

              this.setAM = function() {
                var hours = self.time.getHours();
                if (hours >= 12) {
                  self.time.setHours(hours - 12);
                  self.meridiem = 'AM';
                }
              };

              this.setPM = function() {
                var hours = self.time.getHours();
                if (hours < 12) {
                  self.time.setHours(hours + 12);
                  self.meridiem = 'PM';
                }
              };

              this.cancel = function() {
                $mdDialog.cancel();
              };

              this.confirm = function() {
                $mdDialog.hide(this.time);
              };
            }],
            controllerAs: 'timepicker',
            clickOutsideToClose: true,
            template: '<md-dialog aria-label="" class="mdp-timepicker" ng-class="{ \'portrait\': !$mdMedia(\'gt-xs\') }" >' +
              '<md-dialog-content layout-gt-xs="row" layout-wrap class="no-padding">' +
              '<md-toolbar layout-gt-xs="column" layout-xs="row" layout-align="center center" flex class="mdp-timepicker-time md-hue-1 md-primary">' +
              '<div class="mdp-timepicker-selected-time">' +
              '<span ng-class="{ \'white-fg\': timepicker.currentView == timepicker.VIEW_HOURS }" ng-click="timepicker.currentView = timepicker.VIEW_HOURS">{{ timepicker.hours() }}</span>:' +
              '<span ng-class="{ \'white-fg\': timepicker.currentView == timepicker.VIEW_MINUTES }" ng-click="timepicker.currentView = timepicker.VIEW_MINUTES">{{ timepicker.minutes() }}</span>' +
              '</div>' +
              '<div layout="column" class="mdp-timepicker-selected-ampm">' +
              '<span ng-if="timepicker.meridiem" ng-click="timepicker.setAM()" ng-class="{ \'white-fg\': timepicker.meridiem === \'AM\' }">AM</span>' +
              '<span ng-if="timepicker.meridiem" ng-click="timepicker.setPM()" ng-class="{ \'white-fg\': timepicker.meridiem === \'PM\' }">PM</span>' +
              '</div>' +
              '</md-toolbar>' +
              '<div>' +
              '<div class="mdp-clock-switch-container" ng-switch="timepicker.currentView" layout layout-align="center center">' +
              '<mdp-clock class="mdp-animation-zoom" auto-switch="timepicker.autoSwitch" time="timepicker.time" no-meridiem="noMeridiem" type="hours" ng-switch-when="1"></mdp-clock>' +
              '<mdp-clock class="mdp-animation-zoom" auto-switch="timepicker.autoSwitch" time="timepicker.time" type="minutes" ng-switch-when="2"></mdp-clock>' +
              '</div>' +

              '<md-dialog-actions layout="row">' +
              '<span flex></span>' +
              '<md-button ng-click="timepicker.cancel()" aria-label="' + LABEL_CANCEL + '">' + LABEL_CANCEL + '</md-button>' +
              '<md-button ng-click="timepicker.confirm()" class="md-primary" aria-label="' + LABEL_OK + '">' + LABEL_OK + '</md-button>' +
              '</md-dialog-actions>' +
              '</div>' +
              '</md-dialog-content>' +
              '</md-dialog>',
            targetEvent: options.targetEvent,
            locals: {
              time: time,
              noMeridiem: options.noMeridiem,
              autoSwitch: options.autoSwitch
            },
            skipHide: true,
            multiple: true
          });
        };

        return timePicker;
      }];
    })

    .directive("mdpClock", ["$animate", "$timeout", function($animate, $timeout) {
      return {
        restrict: 'E',
        bindToController: {
          'type': '@?',
          'time': '=',
          'autoSwitch': '=?'
        },
        replace: true,
        template: '<div class="mdp-clock">' +
          '<div class="mdp-clock-container">' +
          '<md-toolbar class="mdp-clock-center md-primary"></md-toolbar>' +
          '<md-toolbar ng-style="clock.getPointerStyle()" class="mdp-pointer md-primary">' +
          '<span class="mdp-clock-selected md-button md-raised md-primary"></span>' +
          '</md-toolbar>' +
          '<md-button ng-if="clock.type === \'minutes\'" ng-class="{ \'md-primary\': clock.selected == step }" class="md-icon-button md-raised mdp-clock-deg{{ ::(clock.STEP_DEG_MINUTES * ($index + 1)) }}" ng-repeat="step in clock.steps">{{ step }}</md-button>' +
          '<md-button ng-if="clock.type !== \'minutes\'" ng-class="{ \'md-primary\': clock.selected == step }" class="md-icon-button md-raised mdp-clock-deg{{ ::(clock.STEP_DEG * ($index + 1)) }}" ng-repeat="step in clock.steps">{{ step }}</md-button>' +
          '</div>' +
          '</div>',
        controller: ["$scope", function ($scope) {
          var TYPE_HOURS = "hours";
          var TYPE_MINUTES = "minutes";
          var self = this;

          this.noMeridiem = $scope.$parent.timepicker.noMeridiem;

          this.STEP_DEG = this.noMeridiem ? 360/24 : 360/12;
          this.STEP_DEG_MINUTES = 360/12;
          this.steps = [];

          this.CLOCK_TYPES = {
            "hours": {
              range: this.noMeridiem ? 24 : 12,
            },
            "minutes": {
              range: 60,
            }
          }

          this.getPointerStyle = function() {
            var divider = 1;
            switch (self.type) {
              case TYPE_HOURS:
                divider = self.noMeridiem ? 24 : 12;
                break;
              case TYPE_MINUTES:
                divider = 60;
                break;
            }
            var degrees = Math.round(self.selected * (360 / divider)) - 180;
            return {
              "-webkit-transform": "rotate(" + degrees + "deg)",
              "-ms-transform": "rotate(" + degrees + "deg)",
              "transform": "rotate(" + degrees + "deg)"
            }
          };

          this.setTimeByDeg = function(deg) {

            var divider = 0;
            switch (self.type) {
              case TYPE_HOURS:
                divider = self.noMeridiem ? 24 : 12;
                break;
              case TYPE_MINUTES:
                divider = 60;
                break;
            }

            var time = Math.round(divider / 360 * deg);
            if (!self.noMeridiem && self.type === "hours" && time === 0)
              time = 12;
            else if (self.type === "minutes" && time === 60)
              time = 0;
            self.setTime(time);
          };

          this.setTime = function(time) {

            this.selected = time;

            switch (self.type) {
              case TYPE_HOURS:
                if (!self.noMeridiem) {
                  var PM = this.time.getHours() >= 12 ? true : false;
                  if (PM && time != 12)
                    time += 12;
                  else if (!PM && time === 12)
                    time = 0;
                }
                this.time.setHours(time);
                break;
              case TYPE_MINUTES:
                this.time.setMinutes(time);
                break;
            }

          };

          this.$onInit = function() {

            self.type = self.type || "hours";

            switch (self.type) {
              case TYPE_HOURS:
                if (self.noMeridiem) {
                  for (var i = 1; i <= 23; i++)
                    self.steps.push(i);
                  self.steps.push(0);
                  self.selected = self.time.getHours() || 0;
                }
                else {
                  for (var i = 1; i <= 12; i++)
                    self.steps.push(i);
                    self.selected = self.time.getHours() || 0;
                    if (self.selected > 12) self.selected -= 12;
                }

                break;
              case TYPE_MINUTES:
                for (var i = 5; i <= 55; i += 5)
                  self.steps.push(i);
                self.steps.push(0);

                self.selected = self.time.getMinutes() || 0;

                break;
            }
          };
           // Prior to v1.5, we need to call `$onInit()` manually.
           // (Bindings will always be pre-assigned in these versions.)
          if (angular.version.major === 1 && angular.version.minor < 5) {
            this.$onInit();
          }
        }],
        controllerAs: "clock",
        link: function(scope, element, attrs, ctrl) {
          var pointer = angular.element(element[0].querySelector(".mdp-pointer")),
            timepickerCtrl = scope.$parent.timepicker;

          var onEvent = function(event) {
            var containerCoords = event.currentTarget.getClientRects()[0];
            var x = ((event.currentTarget.offsetWidth / 2) - (event.pageX - containerCoords.left)),
              y = ((event.pageY - containerCoords.top) - (event.currentTarget.offsetHeight / 2));

            var deg = Math.round((Math.atan2(x, y) * (180 / Math.PI)));
            $timeout(function() {
              ctrl.setTimeByDeg(deg + 180);
              if (ctrl.type === 'hours' && ctrl.autoSwitch) timepickerCtrl.switchView();
            });
          };

          element.on("click", onEvent);
          scope.$on("$destroy", function() {
              element.off("click", onEvent);
          });

        }
      }
    }]);

})(window, angular);

(function () {
    'use strict';

    angular
        .module('app.auth.social-network-signin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-social-network-signin', {
            url      : '/data_registro_redes/:id',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-social-network-signin': {
                    templateUrl: 'app/main/auth/social-network-signin/social-network-signin.html',
                    controller : 'SocialNetworkSigninController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.social-network-signin')
        .controller('SocialNetworkSigninController', SocialNetworkSigninController);

    /** @ngInject */
    function SocialNetworkSigninController($state, AuthService, IkanoFactory) {
        // Data
        var vm = this;

        // Remove local storage data
		AuthService.removeJwt();
		AuthService.removeUserData();

        vm.theme = IkanoFactory.getThemeData();
        
        vm.data = {
            cedula: $state.params.id + ""
        };

		// Methods
		vm.signin = function() {
            AuthService.socialNetworkSignin(vm.data, {}, 
                function(response) {
                    if (response.data.result.status) {
                        AuthService.createLogin(response.data.result.auth.token, response.data.result.auth.menu);
                        if (response.data.result.texto_as) {
                            AuthService.setServiceAgreement(response.data.result.texto_as);
                        }
                    } else {
                        IkanoFactory.showAlert("Error", "La documento de identidad enviada es inválida, por favor valida la información.");
                    }
                },
                function(response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
		};

        vm.signin();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.social-network-response', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-social-network-response', {
            url      : '/data_redes/:id/:network/:uid',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-social-network-response': {
                    templateUrl: 'app/main/auth/social-network-response/social-network-response.html',
                    controller : 'SocialNetworkResponseController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.social-network-response')
        .controller('SocialNetworkResponseController', SocialNetworkResponseController);

    /** @ngInject */
    function SocialNetworkResponseController($state, AuthService, IkanoFactory) {
        // Data
        var vm = this;

        // Remove local storage data
		AuthService.removeJwt();
		AuthService.removeUserData();

        vm.theme = IkanoFactory.getThemeData();
        
        vm.data = {
            username: $state.params.id,
            provider: $state.params.network,
            uid: $state.params.uid
        };
        
		// Methods
		vm.login = function() {
            AuthService.socialNetworkLogin(vm.data, {}, 
                function(response){
                    AuthService.createLogin(response.data.token, response.data.menu);
                },
                function(response){
                    if (response.status == 401) {
                        IkanoFactory.showAlert("Error", "Usuario inválido, por favor intente de nuevo.");
                    } else if (response.status == 500) {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
                }
            );
		};

        vm.login();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.social-network-error', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-social-network-error', {
            url      : '/error_redes',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-social-network-error': {
                    templateUrl: 'app/main/auth/social-network-error/social-network-error.html',
                    controller : 'SocialNetworkErrorController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.social-network-error')
        .controller('SocialNetworkErrorController', SocialNetworkErrorController);

    /** @ngInject */
    function SocialNetworkErrorController($state, AuthService, IkanoFactory) {
        // Data
        var vm = this;

        // Remove local storage data
		AuthService.removeJwt();
		AuthService.removeUserData();

        vm.theme = IkanoFactory.getThemeData();
        
        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.signin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-signin', {
            url      : '/signin',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-signin': {
                    templateUrl: 'app/main/auth/signin/signin.html',
                    controller : 'SigninController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.signin')
        .controller('SigninController', SigninController);

    /** @ngInject */
    function SigninController($state, CandidateService, AuthService, IkanoFactory, vcRecaptchaService) {
        // Data
        var vm = this;
        vm.errors = {};
        vm.theme = IkanoFactory.getThemeData();

        AuthService.save_lists_login();

        vm.loadingLists = true;
        //PUBLIC KEY
        vm.publicKey = "6LeO3lcUAAAAAJtEwON0WPcuuSzljBMFOdHsESoV";

        // Remove local storage data
        AuthService.removeJwt();
        AuthService.removeUserData();

        vm.urlBase = CandidateService.getUrlBase();
        vm.id = null;
        vm.sn = false;

        // Methods
        vm.signin = function () {
            /*if (vcRecaptchaService.getResponse() === "") {
               vm.errorCaptcha = true;
            } else {*/
            //vm.errorCaptcha = false;
            vm.errors = {};
            var source = localStorage.getItem('SOURCE');

            vm.form.origen = (source) ? source : 0;
            vm.form.environment = 'CANDIDATO_HV';

            var data = angular.copy(vm.form);
            data.ciudad_id = vm.form.ciudad_id.id;

            AuthService.signin(data, {}, function (response) {
                if (!response.data.result.status) {
                    if (response.data.result.errors) {
                        vm.errors = IkanoFactory.getFormErrors(response.data.result.errors);
                    } else {
                        IkanoFactory.showAlert("Error", IkanoFactory.capitalize(response.data.result.msg));
                    }
                } else {
                    if (response.data.result.texto_as) {
                        AuthService.setServiceAgreement(response.data.result.texto_as);
                    }
                    AuthService.createLogin(response.data.result.auth.token, response.data.result.auth.menu);
                    AuthService.save_lists_login();
                }
            });
            //}

        };

        vm.next = function (index, msWizard, action) {
            //vm.sn = false;
            if (msWizard.selectedIndex == 0) {
                vm.validate(msWizard, action);
            } else if (msWizard.selectedIndex == 1) {
                vm.sendData(msWizard, action);
                //vm.sn = true;
            }
        };

        vm.validate = function (msWizard, action) {
            vm.errors = {};

            vm.id = vm.form.cedula;

            var data = {
                cedula: "" + vm.form.cedula,
                cedula_confirm: "" + vm.form.cedula_confirm
            };

            AuthService.validateSignup(data, {},
                function (response) {
                    if (response.data.result.status) {
                        vm.updateSelectedStep(msWizard, action);
                    } else {
                        if (response.data.result.errors) {
                            vm.errors = IkanoFactory.getFormErrors(response.data.result.errors);
                        } else if (response.data.result.msg && response.data.result.msg == "cedula existente") {
                            IkanoFactory.showAlert("Error", "El documento de identidad ingresado ya se encuentra registrada. Por favor recupera la contraseña.");
                            AuthService.setIdExists(vm.form.cedula);
                            $state.transitionTo('app.auth-recover-password');
                        } else if (response.data.result.msg && !response.data.result.status) {
                            IkanoFactory.showAlert("Error", "El documento de identidad ingresado ya se encuentra registrada. Por favor recupera la contraseña.");
                            AuthService.setIdExists(vm.form.cedula);
                            $state.transitionTo('app.auth-recover-password');
                        }
                    }
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };

        vm.changePasswordConfirm = function () {
            if (vm.form.password_confirm != vm.form.password) {
                vm.errors.passwordConfirm = true;
            } else {
                vm.errors.passwordConfirm = false;
            }
        }

        vm.sendData = function (msWizard, action) {
            vm.errors = {};
            vm.id = vm.form.cedula;

            var data = {
                cedula: "" + vm.form.cedula,
                cedula_confirm: "" + vm.form.cedula_confirm,
                nombres: vm.form.nombres,
                apellidos: vm.form.apellidos,
                correo: vm.form.correo,
                ciudad_id: vm.form.ciudad_id.id
            };

            AuthService.validateSignup(data, {},
                function (response) {
                    if (response.data.result.status) {
                        vm.updateSelectedStep(msWizard, action);
                    } else {
                        if (response.data.result.errors) {
                            vm.errors = IkanoFactory.getFormErrors(response.data.result.errors);
                        } else if (response.data.result.msg && !response.data.result.status) {
                            IkanoFactory.showAlert("Error", "El correo ingresado ya se encuentra registrado. Por favor validar de nuevo.");
                        }
                    }
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };

        vm.updateSelectedStep = function (msWizard, action) {
            if (action == 1) {
                msWizard.nextStep();
            } else if (action == -1) {
                msWizard.previousStep();
            }
        };

        vm.querySearch = function (query) {

            var results = query && query.length >= 3 ? vm.ciudadesBackup.filter(createFilterFor(query)) : vm.ciudades;
            return results;

        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(ciudad) {
                var res = angular.lowercase(ciudad.name);
                //return (res.indexOf(lowercaseQuery) === 0);
                return res.indexOf(lowercaseQuery.toLowerCase()) != -1;
            };

        }

        function validateCitys() {
            if (localStorage.getItem('lists')) {
                vm.loadingLists = false;
                vm.lists = JSON.parse(localStorage.getItem('lists'));
                vm.ciudadesBackup = vm.lists.ciudades;
                vm.ciudades = vm.ciudadesBackup.slice(0, 15);
            } else {
                setTimeout(validateCitys, 1000);
            }
        }

        validateCitys();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.recover-password-admin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.auth-recover-password-admin', {
                url: '/recover-password-admin',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.auth-recover-password-admin': {
                        templateUrl: 'app/main/auth/recover-password-admin/recover-password.html',
                        controller: 'recoverPasswordAdmin as vm'
                    }
                },
                bodyClass: 'login'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();
(function () {
    'use strict';

    angular.module('app.auth.recover-password-admin').controller('recoverPasswordAdmin',recoverPasswordAdmin);

    function recoverPasswordAdmin($state, AuthService, IkanoFactory, $mdDialog, $document) {
        // Data
        var vm = this;
        vm.theme = IkanoFactory.getThemeData();

        // Remove local storage data
        AuthService.removeJwt();
        AuthService.removeUserData();

        vm.environment = localStorage.getItem('environment');

        vm.regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        vm.recoverPassword = function(){
            AuthService.recoverPasswordByEmail({usuario_o_correo: vm.correo, environment:vm.environment});
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.recover-password')
        .controller('RecoverPasswordController', RecoverPasswordController);

    /** @ngInject */
    function RecoverPasswordController($state, AuthService, IkanoFactory, $mdDialog, $document) {
        // Data
        var vm = this;
        vm.theme = IkanoFactory.getThemeData();
        
        // Remove local storage data
		AuthService.removeJwt();
        AuthService.removeUserData();
        
        vm.environment = localStorage.getItem('environment');

        vm.recoverReady = false;
        vm.questions = {};
        vm.formValidateId = {};

        if (AuthService.getIdExists()) {
            vm.formValidateId.cedula = AuthService.getIdExists() * 1;
            AuthService.removeIdExists();
        }

		// Methods
        vm.validateId = function() {
            var data = {
                cedula: vm.formValidateId.cedula + ""
            };

            AuthService.getInforecoverPassword(data, {}, 
                function(response){
                    if (response.data.status) {
                        vm.data = response.data;
                        vm.recoverReady = true;
                    }else{
                        IkanoFactory.showAlert("Error", response.data.message);
                    }
                },
                function(response){
                        IkanoFactory.showAlert("Error", response.data.message);
                }
            );
        };

		vm.recoverPassword = function() {
            AuthService.recoverPasswordByEmail({usuario_o_correo: vm.formValidateId.cedula,environment:vm.environment});
		};

        vm.openSecurityQuestionsDialog = function(ev) {
			$mdDialog.show({
				controller: 'SecurityQuestionsController',
				controllerAs: 'vm',
				templateUrl: 'app/main/auth/recover-password/dialogs/security-questions.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					event: ev,
					questions: vm.data.preguntas,
                    id: vm.formValidateId.cedula
				}
			});	
		};
    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.new-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-new-password', {
            url      : '/recover_password/:id/:token',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-new-password': {
                    templateUrl: 'app/main/auth/new-password/new-password.html',
                    controller : 'NewPasswordController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.new-password')
        .controller('NewPasswordController', NewPasswordController);

    /** @ngInject */
    function NewPasswordController($state, AuthService, IkanoFactory) {
        // Data
        var vm = this;
        vm.theme = IkanoFactory.getThemeData();
        var id = $state.params.id;
        var token = $state.params.token;
        
        // Remove local storage data
		AuthService.removeJwt();
		AuthService.removeUserData();

		// Methods
		vm.recoverPassword = function() {
            var data = {
                token: token, 
                usuario: id,
                password: vm.form.password,
                password_confirm: vm.form.password_confirm
            }

            AuthService.recoverPassword(data);
		};
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginTokenController', LoginTokenController);

    /** @ngInject */
    function LoginTokenController($state, AuthService, IkanoFactory, CandidateService) {
        // Data
        var vm = this;
        vm.theme = IkanoFactory.getThemeData();

        var username = $state.params.username;
        var token = $state.params.token;
        
        // Remove local storage data
		AuthService.removeJwt();
		AuthService.removeUserData();

        vm.urlBase = CandidateService.getUrlBase();

		// Methods
		AuthService.loginToken({
            user: username,
            token : token
        });
     }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.login-dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-login-dashboard', {
            url      : '/dashboard/:idOffer?source',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-login-dashboard': {
                    templateUrl: 'app/main/auth/login-dashboard/login-dashboard.html',
                    controller : 'LoginDashboardController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth.login-dashboard')
        .controller('LoginDashboardController', LoginDashboardController);

    /** @ngInject */
    function LoginDashboardController($state, $rootScope, AuthService, IkanoFactory) {
        // Data
        var vm = this;
		vm.theme = IkanoFactory.getThemeData();
		vm.offers = [];
		vm.data = null;
		vm.loading = true;
		vm.maxDate = new Date();
        // Remove local storage data
		//AuthService.removeJwt();
		//AuthService.removeUserData();
		AuthService.redirectDashboard();

		vm.cities = [];
		vm.city = null;
		vm.areas = [];
		vm.paises = {};
		vm.area = null;
		vm.date = null;

		vm.page = 0;
		vm.position = 0;
		vm.offsetSearch = 0;
		vm.filters = [];
		vm.source = ($state.params.source) ? parseInt($state.params.source) : 0;
		localStorage.setItem('SOURCE',vm.source);

		AuthService.getLoginDashboardOffers({}, {}, function(response){
			if (response.data.ofertas) {
				vm.data = response.data.ofertas;
				vm.filtersData = response.data.filtros;
				vm.resetSearch();
				vm.setCities();
				vm.setAreas();
				vm.setPais();
				vm.loading = false;
				if($state.params.idOffer && $state.params.idOffer != 0){
					vm.showDetails($state.params.idOffer);
				}

			}
		});

        vm.showOffer = [];

		vm.setCities = function() {
			vm.cities = vm.filtersData.ciudads;
		};

		vm.setAreas = function() {
			vm.areas = vm.filtersData.areas;
		};
		vm.setPais = function (){
			vm.paises = vm.filtersData.paises_procesos;
		};

		vm.setPaisSelected = function (pais){
			vm.filters[3] = pais;
			vm.resetSearch();
		}

		// Methods
		vm.resetSearch = function() {
			//Cada vez que hay un cambio en los filtros, se empieza a buscar desde el inicio del array principal de las ofertas,
			//por ello se resetea la página el offset y se vacían las coincidencias.
			vm.page = 0;
            vm.offsetSearch = 0;
			vm.offers = [];
			vm.loadMore();
		};

		vm.resetFilters = function() {
			vm.filters = [];
			vm.city = null;
			vm.area = null;
			vm.date = null;
			vm.resetSearch();
		};

		//Está función se activa cuando el usuario hace scroll hacia abajo.
		//Cada vez que hace scroll se debe cargar más contenido.
		vm.loadMore = function() {
			$rootScope.$broadcast("loader_show");

			//Se pone el puntero de la página en la siguiente página.
			vm.page = vm.page + 1;

			//Se valida que hayan datos
			if (vm.data) {
				//Se validan que hayan filtros seleccionados, y no es así se cargan todos los resultados
				if (!vm.filtersSelected()) {
					vm.withoutFilters();
				} 
				//En caso contrario se empiezan a buscar las coincidencias.
				else {
					vm.withFilters();
				}
			}

			$rootScope.$broadcast("loader_hide");
		};

		//Esta función valida si hay algún filtro seleccionado, de ser así retorna true.
		vm.filtersSelected = function() {
			if (!vm.filters.length) {
				vm.position = 0;
				return false;
			} else {
				var empty = 1;
				for (var i = 0; i < vm.filters.length; i++) {
					var filter = vm.filters[i];
					if (filter) {
						empty = empty * 0;
					} else {
						empty = empty * 1;
					}
				}

				if (!empty) {
					return true;
				} else {
					vm.position = 0;
					return false;
				}
			}
		};

		vm.withoutFilters = function() {
			//Se fija el limite de elementos por "Página".
            var l = 6;
			//Se calcula el limite de la ventana. suponiendo que la página se 1, el límite sería 20.
			//Esto quiere decir que se tomaran los elementos hasta la posición 20, si la página es 2 sería hasta la posición 40.
            var limit = vm.page * l;
			//El offset es proporcional al limit en este caso si la página es 1 el offset es 0 y el limite 20. Con
			//esto se toman los elementos del 0 al 20, en caso de que la pàgina sea 2 se toman los elementos de la posición 20 a la 40.
            var offset = (vm.page > 1 ? ((limit - l) + 1) : 0);

			//Se iteran las ofertas para ser agregadas al array.
            for (var i = offset; i <= limit; i++) {
				//Por seguridad en caso de que ya no existan más elementos se hace un break para parar la iteración.
                if (!vm.data[i]) {
                    break;
                }
				//se agregan ofertas al arreglo.
                vm.setOffer(vm.data[i]);
            }
        };

		vm.withFilters = function() {
			//Se fija el limite de elementos por página
			var l = 5;
			//Se calcula el limite de la ventana.
			var limit = vm.page * l;
			//Se calcula el offset de la ventana. Esto depende de la página y el tamaño del arreglo principal de ofertas.
			var offset = (vm.page == 1 ? (!vm.offers.length ? 0 : vm.offers.length - 1) : vm.offsetSearch);

			//Se itera el arreglo de ofertas para buscar coincidencias con los filtros
			for (var index = offset; vm.offers.length <= limit; index++) {
				if (!vm.data[index]) {
					break;
				}

				var element = vm.data[index];

				//Se fija una bandera. Si está bandera termina siendo 1 quiere decir que la oferta cumple con todos los filtros
				var match = 1;
				for (var i = 0; i < vm.filters.length; i++) {
					//Se itera el arreglo de filtros para buscar cuales fueron seleccionados.
					var filter = vm.filters[i];
					if (filter) {
						//Dependiendo del filtro se hace la busqueda y se multiplica el resultado con match.
						//Si la oferta no cumple con algún filtro, el match se multiplicará por 0 haciendo que sea cero al final de la iteración.
						//Si cumple con todos los filtros la variable deberá quedar en 1 porque no se multiplicaría por ningún cero.
						if (i == 0) {
							match = vm.searchByCity(element) * match;
						} else if (i == 1) {
							match = vm.searchByArea(element) * match;
						} else if (i == 2) {
							match = vm.searchByDate(element) * match;
						} else if (i == 3){
							match = vm.seatchPais(element) * match;
						}
					}
				}

				//Si la oferta cumple con los filtros la bandera será 1, por ello se agrega al arreglo de ofertas.
				if (match == 1) {
					vm.setOffer(element);
				}

				//Se fija el offsearch para mover la ventaana en la siguiente iteración.
				vm.offsetSearch = index + 1;
			}
		};

		vm.searchByCity = function(offer) {
			if (offer.ciudad.id == vm.city) {
				return 1;
			}

			return 0;
		};

		vm.searchByArea = function(offer) {
			var areas = vm.getAreas(offer.procesos_areas);
			if (areas.ids.indexOf(vm.area) !== -1) {
				return 1;
			}

			return 0;
		};

		vm.searchByDate = function(offer) {
			var date = moment(offer.fecha_inicial);
			var filter = moment(vm.filters[2]);

			if (date >= filter) {
				return 1;
			} 
			return 0;
		};

		vm.seatchPais = function(offer){
			return (offer.pais_proceso_id == vm.filters[3]) ? 1 : 0;
		}

		//Cities
		vm.queryCitySearch = function(query) {
            var results = query ? vm.cities.filter( vm.createFilterForCity(query) ) : vm.cities;
            return results;
        };

        vm.selectedCityChange = function(item) {
            if (item != null) {
				vm.city = item.id;
            } else {
				vm.city = null;
			}

			vm.filters[0] = vm.city;
			vm.resetSearch();
        };
       
        vm.createFilterForCity = function(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(res) {
                res = angular.lowercase(res.name);
				//return (res.indexOf(lowercaseQuery) === 0);
				return res.indexOf(lowercaseQuery.toLowerCase())!=-1;
            };
        };

		//Areas
		vm.queryAreaSearch = function(query) {
            var results = query ? vm.areas.filter( vm.createFilterForArea(query) ) : vm.areas;
            return results;
        };

        vm.selectedAreaChange = function(item) {
            if (item != null) {
				vm.area = item.id;
            } else {
				vm.area = null;
			}

			vm.filters[1] = vm.area;
			vm.resetSearch();
        };
       
        vm.createFilterForArea = function(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(res) {
                res = angular.lowercase(res.name);
				//return (res.indexOf(lowercaseQuery) === 0);
				return res.indexOf(lowercaseQuery.toLowerCase())!=-1;
            };
        };

		vm.setOffer = function(data) {
			var offer = {
				id: data.id,
				name: data.cargo_ocupar, 
				city: data.ciudad.name, 
				publish_salary : data.publish_salary,
				salary: data.salario_oferta_id ? vm.getSalary(data.salario_oferta_id) : {},
				areas: vm.getAreas(data.procesos_areas), 
				publicationDate: data.fecha_inicial, 
				finishDate: data.fecha_final, 
				vacants: data.no_vacantes,
				status: data.label_oferta,

				//appliedDate: 'Jul 10, 2017 (Hace 20 días)',
				//requeriments: data.campos.requirements.value,
				//details: data.campos.descripcion_cargo.value
			};
			offer.custom = {};
			angular.forEach(data.campos,function(v,k){
				offer.custom[k] = v;
			});


			vm.offers.push(offer);
		};

		vm.getSalary = function(salaryId){
			var returnArr = vm.filtersData.rangos_salario.filter(function(element){
				return element.id == salaryId;
			});

			return returnArr[0] ? returnArr[0] : {};
		}

		vm.getAreas = function(areas) {
			var array = [];
			var ids = [];

			for (var index = 0; index < areas.length; index++) {
				var element = areas[index];
				array.push(element.area.name);
				ids.push(element.area.id);
			}

			return {areas: array.join(", "), ids: ids};
		};

        vm.showDetails = function(idOffer) {
            vm.showOffer[idOffer] = true;
        };

        vm.closeDetails = function(idOffer) {
            vm.showOffer[idOffer] = false;
        };
     }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.login-analyst', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-login-analyst', {
            url      : '/analista',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-login-analyst': {
                    templateUrl: 'app/main/auth/login-analyst/login_analyst.html',
                    controller : 'LoginAnalystController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();

(function () {
    'use strict';

    angular.module('app.auth.login-analyst').controller('LoginAnalystController', LoginAnalystController);

    function LoginAnalystController($state, AuthService, IkanoFactory, CandidateService, msNavigationService) {
        // Data
        var vm = this;
        vm.theme = IkanoFactory.getThemeData();
        //msNavigationService.clearNavigation();

        // Remove local storage data
        //AuthService.removeJwt();
        //AuthService.removeUserData();
        AuthService.redirectDashboard();

        vm.urlBase = CandidateService.getUrlBase();
        vm.loginType = {
            auth_type: "credentials"
        };

        vm.form = {};

        // se setea el campo del label
        vm.label_user = 'Correo';
        if (localStorage.getItem('DOMAIN_SELECTION') == 'riopaila'){
            vm.label_user = 'Ficha';
        }
            

        vm.getLoginType = function () {
            AuthService.getLoginType({}, {},
                function (response) {
                    if (response.data) {
                        vm.loginType = response.data;
                    }
                },
                function (response) {
                    console.log("Err ", response);
                }
            );
        }

        vm.getLoginType();

        localStorage.setItem('environment','ANALISTA_HV');

        vm.login = function () {
            var data = {
                username: vm.form.user,
                password: vm.form.password,
                environment: 'ANALISTA_HV'
            };

            AuthService.loginAdmin(data);
            AuthService.save_lists_login();
        };

    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginAdminController', LoginAdminController);

    /** @ngInject */
    function LoginAdminController($state, AuthService, IkanoFactory, CandidateService, msNavigationService,AdminService) {
        // Data
        var vm = this;
        vm.theme = IkanoFactory.getThemeData();
        //msNavigationService.clearNavigation();
        
        // Remove local storage data
		//AuthService.removeJwt();
		//AuthService.removeUserData();
        AuthService.redirectDashboard();

        vm.urlBase = CandidateService.getUrlBase();
        vm.loginType = {
            auth_type: "credentials"
        };

        vm.form = {};

        // se setea el campo del label
        vm.label_user = 'Documento de identidad';
        if( localStorage.getItem('DOMAIN_SELECTION') == 'riopaila' )
            vm.label_user = 'Ficha';

        vm.getLoginType = function() {
            AuthService.getLoginType({}, {}, 
                function(response) {
                    if (response.data) {
                        vm.loginType = response.data;
                    }
                },
                function(response) {
                    console.log("Err " , response);
                }
            );
        }

        vm.getLoginType();

		vm.login = function() {
			var data = {
				username : vm.form.user,
                password : vm.form.password,
                environment: vm.environment
			};

			AuthService.loginAdmin(data);
        };
        
        vm.loginCustom = function() {
            vm.form.environment = vm.environment;
            AuthService.licenseLogin(vm.form, {}, 
                function(response) {
                    AuthService.createLoginAdmin(response.data.token, response.data.menu, response.data.user);
                    AuthService.save_lists_login();
                },
                function(response) {
                    if (response.status == 401) {
                        IkanoFactory.showAlert("Error", "Usuario o contraseña incorrecta, por favor intente de nuevo.");
                    } if (response.status == 404) {
                        IkanoFactory.showAlert("Error", "Usuario o contraseña incorrecta, por favor intente de nuevo.");
                    } else if (response.status == 500) {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
                }
            );
        }

        if($state.current.name == 'app.auth-login-admin'){
            vm.environment = 'ADMIN_HV'
        } else {
            vm.environment = 'REQUISICION'
        }

        localStorage.setItem('environment',vm.environment);
     }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($state, AuthService, IkanoFactory, CandidateService) {
        // Data
        var vm = this;
        vm.theme = IkanoFactory.getThemeData();
        
        // Remove local storage data
		//AuthService.removeJwt();
		//AuthService.removeUserData();
        AuthService.redirectDashboard();
        vm.urlBase = CandidateService.getUrlBase();

        localStorage.setItem('environment','CANDIDATO_HV');

		// Methods
		vm.login = function() {
			var data = {
				username : vm.form.user,
                password : vm.form.password,
                environment : 'CANDIDATO_HV'
			};

            AuthService.login(data);
            AuthService.save_lists_login();
		};
     }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.login')
        .controller('AcuerdoServicio', AcuerdoServicio);

    /** @ngInject */
    function AcuerdoServicio($state, AuthService, IkanoFactory, CandidateService) {
        // Data
        var vm = this;
        vm.theme = IkanoFactory.getThemeData();

        vm.approve = $state.params.approve;
        vm.proceso = $state.params.proceso;
        vm.token = $state.params.token;

        AuthService.removeJwt();
		AuthService.removeUserData();

        function initialize() {
            if (vm.approve instanceof String) {
                vm.approve = parseInt(vm.approve);
            }

            if (vm.approve == 1) {
                vm.save();
            }


        }

        vm.save = function () {
            var data = {
                proceso_id: vm.proceso,
                token: vm.token,
                respuesta: vm.approve,
                comentario: vm.acuerdoform ? vm.acuerdoform.comment : ''
            }

            AuthService.save_respuesta_acuerdo_servicio(data, function (resolve) {
                if (vm.approve == 0) {
                    IkanoFactory.showAlert("", resolve.data.message);
                }
                if (resolve.data.status) {
                    vm.approve = 1;
                }

            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });

        }


        initialize();
    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_candidate')
		.controller('ServiceAgreementController', ServiceAgreementController);

	/** @ngInject */
	function ServiceAgreementController($mdDialog, $document, $state, CandidateService, AuthService, IkanoFactory) {
		var vm = this;

		vm.saving = false;
        vm.data = null;

        vm.pageInfo = {
			icon: "",
			parents: [''],
			title: "ACUERDO DE SERVICIO",
		};

		vm.agreement = AuthService.getServiceAgreement();

		if (!vm.agreement) {
			$state.go('app.seleccion_dashboard', {}, {reload: true});
		};

        vm.acceptService = function() {
			vm.saving = true;
            CandidateService.acceptAgreement({}, {}, function(response){
                if (response.data.result) {
					AuthService.removeServiceAgreement();
                    vm.saving = false;
					IkanoFactory.createMenu();
					$state.go('app.seleccion_dashboard', {}, {reload: true});
                }
            });
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_candidate')
		.controller('ResumeController', ResumeController);

	/** @ngInject */
	function ResumeController($scope, $mdDialog, $document, CandidateService, IkanoFactory, ValidationService, AdminService, ValidationFactory) {
		var vm = this;

		vm.loading = true;
		vm.resume = null;
		vm.blocks = [];
		vm.lists = null;
		vm.attachments = null;
		vm.companies = [];
		vm.validationService = ValidationService;
		vm.indicators = {
			percentage: 0
		};
		vm.validations = {};

		vm.pageInfo = {
			icon: "icon-home",
			parents: ['MI HOJA DE VIDA'],
			title: "MI HOJA DE VIDA",
		};

		vm.values = {};

		vm.messages = [];

		CandidateService.getResumeData({}, {}, function (response) {
			if (response.data.ver_hoja_vida.data.hoja_vida) {
				
				vm.resume = response.data.ver_hoja_vida.data.hoja_vida.data_bloques;
				vm.indicators.percentage = response.data.ver_hoja_vida.data.hoja_vida.porcentaje;
				vm.lists = response.data.ver_hoja_vida.data.hoja_vida.listas;
				vm.attachments = response.data.ver_hoja_vida.data.hoja_vida.adjuntos;
				vm.validations = response.data.ver_hoja_vida.data.hoja_vida.inconsistencias;
				vm.hv_id = response.data.ver_hoja_vida.data.hoja_vida.hoja_vida_id;
				vm.fields = response.data.ver_hoja_vida.data.hoja_vida.estructura_campos;

				vm.setTitles();

				vm.getLists();

			}
			vm.loading = false;
		});

		vm.getLists = function () {
			CandidateService.getLists({ listas: null, hv_id: vm.hv_id }, function (response) {
				if (response.data.listas) {
					vm.lists = response.data.listas;
				}
			});
		}

		vm.setTitles = function () {
			vm.blocks = $.map(vm.resume, function (value, index) {
				value.titulo = value.titulo.split(" ");
				value.name = index;
				if (index == 'personales') {
					value.type = "personal-info";
				} else if (index == 'perfil') {
					value.type = "one-column-one-row";
				} else if (index == 'experiencia') {
					value.type = "laboral-experience";
				} else if (index == 'estudios_formales') {
					value.type = "formal-study";
				} else if (index == 'estudios_no_formales') {
					value.type = "non-formal-study";
				} else if (index == 'laboral') {
					value.type = "one-column-one-row";
				} else if (index == 'idiomas') {
					value.type = "languages";
				} else if (index == 'hijos') {
					value.type = "childrens";
				} else if (index == 'viven_usted') {
					value.type = "two-columns";
				} else if (value.block_type == "has_many") {
					value.type = "two-columns";
				} else {
					value.type = "two-columns-one-row";
				}

				value.emptyRowsMessage = "Por favor completa todos lo datos solicitados. Esto hará que la calidad de la información de tu hoja de vida mejore y agilize el proceso de selección";
				value.item = (value.data && !value.data.length ? value.data : null);

				if (value.name == "personales") {
					value.data.foto = value.data.foto + "?v=" + vm.getRandomNumber();
				}

				value.campos = IkanoFactory.getStructureForFields(value.campos, vm.fields);

				vm.values = Object.assign(vm.values, value.data);

				return [{ name: index, data: value }];
			});
			setValueWatch();
		};

		function setValueWatch() {
			$scope.$watch('vm.blocks', function (newValue, oldValue) {
				if (!newValue) {
					return;
				}

				var personales = newValue.filter(function (element) {
					return element.name == "personales";
				});

				var fecha_nacimiento = moment(personales[0].data.data.fecha_nacimiento);

				var showConyugue = personales[0].data.data.estado_civil == 2 || personales[0].data.data.estado_civil == 3;

				var isAdult = ValidationFactory.personales.isAdult(moment(), fecha_nacimiento);

				var hideBlockHijos = newValue.filter(function (element) {
					return (element.name == 'grupo_familiar' && element.data.data) && element.data.data.tiene_hijos == "0";
				});

				for (var i in vm.blocks) {

					if (vm.blocks[i].name == 'hijos') {
						if (hideBlockHijos.length && !isAdult) {
							vm.blocks[i].hide = true;
							vm.blocks[i].data.data = [];
						} else {
							if (isAdult) {
								vm.blocks[i].hide = false;
							} else {
								vm.blocks[i].hide = true;
							}
						}
					} else {
						if (vm.blocks[i].name == 'personales') {
							continue;
						}
						if (isAdult) {
							vm.blocks[i].hide = false;
						} else {
							vm.blocks[i].hide = true;
						}
					}
					if (vm.blocks[i].name == 'conyuge') {
						if (isAdult && showConyugue) {
							vm.blocks[i].hide = false;
						} else {
							vm.blocks[i].hide = true;
							/*if(vm.blocks[i].data.data){
								vm.blocks[i].data.data.delete = true;
								deleteBlock(vm.blocks[i].name,vm.blocks[i].data.data);
							}*/

						}
					}
				}


			}, true);
		}

		function deleteBlock(block_id, data) {

			var dataJson = {
				bloque: block_id,
				data: data
			}

			CandidateService.saveResumeBlock(dataJson, {}, function (response) {
				if (response.data.result.status) {
					data = null;
				} else {
					//vm.errors = IkanoFactory.getFormErrors(response.data.result.errors);
				}

				//vm.saving = false;
				//vm.saveButtonTitle = "Guardar";
			});
		}

		vm.urlBase = CandidateService.getUrlBase();

		vm.getAttachmentUrl = function (attachment) {
			var id = (typeof attachment !== "number") ? attachment.id : attachment;
			CandidateService.getFile({ id: id }, { responseType: 'arraybuffer' },
				function (response) {
					IkanoFactory.downloadFile(response.data, attachment.name)
				},
				function (response) {
					IkanoFactory.showAlert("Error", "Ha ocurrido un error descargando el archivo, por favor intente de nuevo.");
				});
			//return CandidateService.getFileUrl() + id;
		}

		vm.getProfilePictureSrc = function (picture) {
			return (picture ? CandidateService.getUrlBase() + "/" + picture : "assets/images/avatars/profile.jpg");
		};

		vm.getBlockData = function (block, data) {
			block.item = data;
			return block;
		};

		vm.validateParentsFields = function (parent, field) {
			if (parent == "mom" &&
				(field.field == "madre_nombre" ||
					field.field == "madre_primer_apellido" ||
					field.field == "madre_segundo_apellido" ||
					field.field == "padre_nombre" ||
					field.field == "padre_primer_apellido" ||
					field.field == "padre_segundo_apellido" ||
					field.field == "padre_parentesco" ||
					field.field == "padre_vive" ||
					field.field == "padre_documento" ||
					field.field == "madre_tipo_documento" ||
					field.field == "padre_ciudad_expedicion_id" ||
					field.field == "padre_fecha_nacimiento" ||
					field.field == "padre_ciudad_nacimiento_id" ||
					field.field == "padre_genero" ||
					field.field == "padre_nivel_estudio" ||
					field.field == "padre_estado_estudio" ||
					field.field == "padre_ocupacion" ||
					field.field == "padre_telefono_fijo" ||
					field.field == "padre_telefono_movil" ||
					field.field == "padre_correo" ||
					field.field == "padre_depende_usted" ||
					field.field == "padre_vive_usted" ||
					field.field == "padre_tiene_discapacidad")) {
				return false;
			} else if (parent == "dad" &&
				(field.field == "padre_nombre" ||
					field.field == "padre_primer_apellido" ||
					field.field == "padre_segundo_apellido" ||
					field.field == "madre_nombre" ||
					field.field == "madre_primer_apellido" ||
					field.field == "madre_segundo_apellido" ||
					field.field == "madre_parentesco" ||
					field.field == "madre_vive" ||
					field.field == "madre_tipo_documento" ||
					field.field == "madre_documento" ||
					field.field == "madre_ciudad_expedicion_id" ||
					field.field == "madre_fecha_nacimiento" ||
					field.field == "madre_ciudad_nacimiento_id" ||
					field.field == "madre_genero" ||
					field.field == "madre_nivel_estudio" ||
					field.field == "madre_estado_estudio" ||
					field.field == "madre_ocupacion" ||
					field.field == "madre_telefono_fijo" ||
					field.field == "madre_telefono_movil" ||
					field.field == "madre_correo" ||
					field.field == "madre_depende_usted" ||
					field.field == "madre_vive_usted" ||
					field.field == "madre_tiene_discapacidad")) {
				return false;
			}

			return true;
		};

		vm.addCompany = function (data) {
			vm.companies.push({ idBlock: data._id, name: data.empresa });
		};

		vm.getDiffBetweenTwoDates = IkanoFactory.getDiffBetweenTwoDates;

		vm.getColorBlockIndicator = function (state) {
			if (state) {
				return "green-500-bg";
			} else {
				return "orange-500-bg";
			}
		};

		vm.getIconBlockIndicator = function (state) {
			if (state) {
				return "icon-checkbox-marked";
			} else {
				return "icon-information-outline";
			}
		};

		vm.getOrdinalNumber = IkanoFactory.getOrdinalNumber;

		vm.validateAttachment = function (mod) {
			if (mod && !vm.attachments[mod]) {
				vm.attachments[mod] = [];
			}
		};

		vm.validateMultipleAttachment = function (mod, id) {
			if (mod && !vm.attachments[mod]) {
				vm.attachments[mod] = {};
				vm.attachments[mod][id] = [];
			}
		};

		vm.getRandomNumber = function () {
			return Math.floor((Math.random() * 100) + 1);
		}

		vm.downloadPDF = function () {
			var data = { id: vm.hv_id, tipo: "hoja_vida" };
			AdminService.getPDFReport(data, { responseType: 'arraybuffer' }, function (resolve) {
				IkanoFactory.downloadFile(resolve.data, vm.hv_id + ".pdf");
			}, function (reject) {
				var data = {};
				data.class = "error";
				data.message = reject.data.message;
				data.showClose = true;
				$rootScope.$broadcast('toast::show', { data: data, options: [] });
			});
		};

		vm.openEditDialog = function (ev, fields) {
			$mdDialog.show({
				controller: 'EditController',
				controllerAs: 'vm',
				templateUrl: 'app/main/templates/resume/dialogs/edit.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					event: ev,
					fields: fields,
					lists: vm.lists,
					attachments: vm.attachments,
					indicators: vm.indicators,
					validations: vm.validations,
					structure: vm.fields
				}
			}).then(function (response) {
				if (response && fields.name == "personales") {
					vm.getLists();
					vm.serializeStructureFields(response.result.data.estructura_campos);
					if(response.objExtra.data){
						vm.serializeDataFields(response.objExtra.data,response.result.data.estructura_campos);
					}
				}
			});
		};

		vm.serializeStructureFields = function (structureFields) {
			for (var i in vm.blocks) {
				var campos = vm.blocks[i].data.campos;
				for (var c in campos) {
					var field = campos[c].field;
					if (structureFields[field]) {
						vm.blocks[i].data.campos[c] = structureFields[field];
					}

				}
			}
		}

		vm.serializeDataFields = function (data,structureFields) {
			var keys = Object.keys(data);
			for (var i in vm.blocks) {
				var dataField = vm.blocks[i].data.data;

				if (dataField instanceof Array) {
					for(var c in dataField){
						for (var f in dataField[c]) {
							if (keys.indexOf(f) !== -1) {
								vm.blocks[i].data.data[c][f] = data[f];
								if(structureFields[f].field_extra){
									vm.blocks[i].data.data[c][structureFields[f].field_extra] = null;
								}
							}
						}
					}
				} else {
					for (var c in dataField) {

						if (keys.indexOf(c) !== -1) {
							vm.blocks[i].data.data[c] = data[c];
							if(structureFields[c].field_extra){
								vm.blocks[i].data.data[structureFields[c].field_extra] = null;
							}
						}

					}
				}
			}
		}

		vm.openAddDialog = function (ev, fields) {
			$mdDialog.show({
				controller: 'AddController',
				controllerAs: 'vm',
				templateUrl: 'app/main/templates/resume/dialogs/add.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					event: ev,
					fields: fields,
					lists: vm.lists,
					attachments: vm.attachments,
					indicators: vm.indicators,
					validations: vm.validations
				}
			});
		};

		vm.openAddExperienceDialog = function (ev, fields) {
			fields.companies = vm.companies;

			$mdDialog.show({
				controller: 'AddExperienceController',
				controllerAs: 'vm',
				templateUrl: 'app/main/templates/resume/dialogs/add-experience.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					event: ev,
					fields: fields,
					lists: vm.lists,
					attachments: vm.attachments,
					indicators: vm.indicators,
					validations: vm.validations
				}
			});
		};

		vm.openDeleteDialog = function (ev, block, item) {
			$mdDialog.show({
				controller: 'DeleteController',
				controllerAs: 'vm',
				templateUrl: 'app/main/templates/resume/dialogs/delete.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					event: ev,
					block: block,
					item: item,
					indicators: vm.indicators,
					validations: vm.validations
				}
			});
		};

		vm.openUploadProfilePictureDialog = function (ev, item) {
			$mdDialog.show({
				controller: 'UploadProfilePictureController',
				controllerAs: 'vm',
				templateUrl: 'app/main/templates/resume/dialogs/upload-profile-picture.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					event: ev,
					item: item,
				}
			});
		};
	}
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_candidate')
		.controller('OffersAvailableController', OffersAvailableController);

	/** @ngInject */
	function OffersAvailableController($mdDialog, $document, $rootScope, CandidateService, IkanoFactory) {
		var vm = this;

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['OFERTAS DISPONIBLES'],
			title: "OFERTAS DISPONIBLES",
		};

		vm.factory = IkanoFactory;
		vm.loading = true;
		vm.isDisabled = false;
        vm.noCache = true;

		vm.messages = [];
		vm.cities = [];
		vm.salaries = [];
		vm.countries = {};

		vm.offersSuggested = [];

		vm.page = 0;
		vm.position = 0;
		vm.offsetSearch = 0;
		vm.filters = [];

		if (localStorage.getItem('NEW_OFFERS_AVAILABLES_FILTER')) {
			vm.filters[4] = 1;
			localStorage.removeItem('NEW_OFFERS_AVAILABLES_FILTER');
		};

		CandidateService.getOffersSuggested(function(response){
			if (response.data.ofertas_disponibles.data) {
				vm.offersData = response.data.ofertas_disponibles.data;
				vm.listas = response.data.ofertas_disponibles.data.listas;
				vm.setMessages();
				vm.setCities();
				vm.setAreas();
				vm.setSalaries();
				vm.setCountries();
				vm.setTimes();
				vm.resetSearch();
				vm.loading = false;
			}
		});

		vm.refreshOffers = function (){
			CandidateService.getOffersSuggested(function(response){
				if (response.data.ofertas_disponibles.data) {
					vm.offersData = response.data.ofertas_disponibles.data;
					vm.listas = response.data.ofertas_disponibles.data.listas;
					//vm.setMessages();
					vm.setCities();
					//vm.setAreas();
					vm.setSalaries();
					//vm.setCountries();
					vm.setTimes();
					vm.resetSearch();
					vm.loading = false;
					//vm.withoutFilters();
				}
			},{pais_id : vm.paisSelected});
		}

		vm.setMessages = function() {
			if (vm.offersData.porcentaje_hv < 100) {
				vm.messages.push({
					message: '<strong>Tu hoja de vida aún no se encuentra completamente diligenciada (' + vm.offersData.porcentaje_hv + '%).</strong> Por favor completa la información para poder aplicar a las ofertas disponibles <a href="/resume" class="red-200-bg font-weight-200 white-fg cursor-pointer text-boxed m-0"><strong>Completar hoja de vida</strong></a>',
					background_color: 'red-100-bg', text_color: 'red-900-fg', icon: 'icon-alert'
				});
			}
		};

		vm.setCities = function() {
			vm.cities = vm.offersData.filtros.ciudads;
		};

		vm.setAreas = function() {
			vm.areas = vm.offersData.filtros.areas;
		};

		vm.setSalaries = function() {
			vm.salaries = vm.offersData.filtros.rangos_salario;
			//vm.salaries.push({id: 0, name: 'Salario no definido'});
		};

		vm.setCountries = function() {
			vm.countries = vm.offersData.filtros.pais_procesos;
		}

		vm.setTimes = function() {
			vm.times = vm.offersData.filtros.fechas_publicacion;
			vm.times[1] = 'Ofertas nuevas';
		};

		vm.setOffer = function(element) {
			var offer = IkanoFactory.createOffer(element,vm.listas.rangos_salario);

			offer.applied = vm.offersData.ofertas_aplico_ids.indexOf(element.id) !== -1;
			offer.new = vm.offersData.ofertas_nuevas_ids.indexOf(element.id) !== -1;
			offer.status = 'Aplicar a esta oferta';
			offer.canApplied = vm.offersData.puede_aplicar;
			offer.offersLimit = vm.offersData.limite_ofertas_mes;
			offer.offersApplied = vm.offersData.cant_ofertas_aplico_hv_mes;
			offer.arguments = vm.offersData.proceso_argumentos;
			offer.requeriments = element.procesos_requisitos;
			offer.resumeStatus = vm.offersData.porcentaje_hv;
			
			vm.offersSuggested.push(offer);

		};

		vm.resetSearch = function() {
			//Cada vez que hay un cambio en los filtros, se empieza a buscar desde el inicio del array principal de las ofertas,
			//por ello se resetea la página el offset y se vacían las coincidencias.
			vm.page = 0;
            vm.offsetSearch = 0;
			vm.offersSuggested = [];
			vm.loadMore();
		};

		vm.resetFilters = function() {
			vm.filters = [];
			vm.city = null;
			vm.selectedCity = null;
			vm.area = null;
			vm.selectedArea = null;
			vm.resetSearch();
		};

		//Está función se activa cuando el usuario hace scroll hacia abajo.
		//Cada vez que hace scroll se debe cargar más contenido.
		vm.loadMore = function() {
			$rootScope.$broadcast("loader_show");

			//Se pone el puntero de la página en la siguiente página.
			vm.page = vm.page + 1;

			//Se valida que hayan datos
			if (vm.offersData) {
				//Se validan que hayan filtros seleccionados, y no es así se cargan todos los resultados
				if (!vm.filtersSelected()) {
					vm.withoutFilters();
				} 
				//En caso contrario se empiezan a buscar las coincidencias.
				else {
					vm.withFilters();
				}
			}

			$rootScope.$broadcast("loader_hide");
		};

		//Esta función valida si hay algún filtro seleccionado, de ser así retorna true.
		vm.filtersSelected = function() {
			if (!vm.filters.length) {
				vm.position = 0;
				return false;
			} else {
				var empty = 1;
				for (var i = 0; i < vm.filters.length; i++) {
					var filter = vm.filters[i];
					if (filter) {
						empty = empty * 0;
					} else {
						empty = empty * 1;
					}
				}

				if (!empty) {
					return true;
				} else {
					vm.position = 0;
					return false;
				}
			}
		};

		vm.withoutFilters = function() {
			//Se fija el limite de elementos por "Página".
            var l = 6;
			//Se calcula el limite de la ventana. suponiendo que la página se 1, el límite sería 20.
			//Esto quiere decir que se tomaran los elementos hasta la posición 20, si la página es 2 sería hasta la posición 40.
            var limit = vm.page * l;
			//El offset es proporcional al limit en este caso si la página es 1 el offset es 0 y el limite 20. Con
			//esto se toman los elementos del 0 al 20, en caso de que la pàgina sea 2 se toman los elementos de la posición 20 a la 40.
            var offset = (vm.page > 1 ? ((limit - l) + 1) : 0);

			//Se iteran las ofertas para ser agregadas al array.
            for (var i = offset; i <= limit; i++) {
				//Por seguridad en caso de que ya no existan más elementos se hace un break para parar la iteración.
                if (!vm.offersData.ofertas_disponibles[i]) {
                    break;
                }
				//se agregan ofertas al arreglo.
                vm.setOffer(vm.offersData.ofertas_disponibles[i]);
			}
			
        };

		vm.withFilters = function() {
			//Se fija el limite de elementos por página
			var l = 5;
			//Se calcula el limite de la ventana.
			var limit = vm.page * l;
			//Se calcula el offset de la ventana. Esto depende de la página y el tamaño del arreglo principal de ofertas.
			var offset = (vm.page == 1 ? (!vm.offersSuggested.length ? 0 : vm.offersSuggested.length - 1) : vm.offsetSearch);

			
			//Se itera el arreglo de ofertas para buscar coincidencias con los filtros
			for (var index = offset; vm.offersSuggested.length <= limit; index++) {
				if (!vm.offersData.ofertas_disponibles[index]) {
					break;
				}

				var element = vm.offersData.ofertas_disponibles[index];

				//Se fija una bandera. Si está bandera termina siendo 1 quiere decir que la oferta cumple con todos los filtros
				var match = 1;
				for (var i = 0; i < vm.filters.length; i++) {
					//Se itera el arreglo de filtros para buscar cuales fueron seleccionados.
					var filter = vm.filters[i];
					if (filter) {
						//Dependiendo del filtro se hace la busqueda y se multiplica el resultado con match.
						//Si la oferta no cumple con algún filtro, el match se multiplicará por 0 haciendo que sea cero al final de la iteración.
						//Si cumple con todos los filtros la variable deberá quedar en 1 porque no se multiplicaría por ningún cero.
						if (i == 0) {
							match = vm.searchByQuery(element) * match;
						} else if (i == 1) {
							match = vm.searchByCity(element) * match;
						} else if (i == 2) {
							match = vm.searchByArea(element) * match;
						} else if (i == 3) {
							match = vm.searchBySalary(element) * match;
						} else if (i == 4) {
							match = vm.searchByTime(element) * match;
						} 
					}
				}

				//Si la oferta cumple con los filtros la bandera será 1, por ello se agrega al arreglo de ofertas.
				if (match == 1) {
					vm.setOffer(element);
				}

				//Se fija el offsearch para mover la ventaana en la siguiente iteración.
				vm.offsetSearch = index + 1;
			}
		};

		vm.searchByQuery = function(offer) {
			var lowercaseQuery = angular.lowercase(vm.filters[0]);
			var res = angular.lowercase(offer.cargo_ocupar);
			return res.indexOf(lowercaseQuery.toLowerCase())!=-1;
		};

		vm.searchByCity = function(offer) {
			if (offer.ciudad.id == vm.city) {
				return 1;
			}

			return 0;
		};

		vm.searchByArea = function(offer) {
			var offer = IkanoFactory.createOffer(offer);
			if (offer.area.ids.indexOf(vm.area) !== -1) {
				return 1;
			}

			return 0;
		};

		vm.searchBySalary = function(offer) {
			if (offer.salario_oferta_id == vm.filters[3]) {
				return 1;
			}

			return 0;
		};

		vm.searchByTime = function(offer) {
			if (vm.filters[4] == 1) {
				if (vm.offersData.ofertas_nuevas_ids.indexOf(offer.id) !== -1) {
					return 1;
				}
				return 0;
			} else {
				var date = moment(offer.fecha_inicial);
				var filter = moment(vm.filters[4]);

				if (date >= filter) {
					return 1;
				} 
				return 0;
			}
		};

		//Cities
		vm.queryCitySearch = function(query) {
            var results = query ? vm.cities.filter( vm.createFilterForCity(query) ) : vm.cities;
            return results;
        };

        vm.selectedCityChange = function(item) {
            if (item != null) {
				vm.city = item.id;
            } else {
				vm.city = null;
			}

			vm.filters[1] = vm.city;
			vm.resetSearch();
        };
       
        vm.createFilterForCity = function(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(res) {
                res = angular.lowercase(res.name);
				//return (res.indexOf(lowercaseQuery) === 0);
				return res.indexOf(lowercaseQuery.toLowerCase())!=-1;
            };
        };

		//Areas
		vm.queryAreaSearch = function(query) {
            var results = query ? vm.areas.filter( vm.createFilterForArea(query) ) : vm.areas;
            return results;
        };

        vm.selectedAreaChange = function(item) {
            if (item != null) {
				vm.area = item.id;
            } else {
				vm.area = null;
			}

			vm.filters[2] = vm.area;
			vm.resetSearch();
        };
       
        vm.createFilterForArea = function(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(res) {
                res = angular.lowercase(res.name);
				//return (res.indexOf(lowercaseQuery) === 0);
				return res.indexOf(lowercaseQuery.toLowerCase())!=-1;
            };
        };

		vm.openNoticeDialog = function(ev, offer) {
			$mdDialog.show({
				controller: 'ApplyDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/candidate/dashboard/dialogs/apply/apply.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					event: ev,
                    offer: offer
				}
			});
		};
    }
})();
(function () {
	'use strict';

	angular.module('app.seleccion_candidate').controller('DashboardController', DashboardController);

	/** @ngInject */
	function DashboardController($mdDialog, $document, CandidateService, $state, IkanoFactory) {
		var vm = this;

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['INICIO'],
			title: "Resumen",
		};

		vm.factory = IkanoFactory;

		vm.messages = [];
		vm.indicators = [];
		vm.offersSuggested = [];
		vm.dashboardData = null;

		CandidateService.getDataDashboard(function(response){
			if (response.data.dashboard.data) {
				vm.dashboardData = response.data.dashboard.data;
				vm.origen = response.data.dashboard.data.origen;
				vm.setIndicators();
				//vm.setMessages();
				vm.setOffersSuggested();
				//vm.setOrigen();
			}
		});

		vm.setOrigen = function(){
			localStorage.setItem('ORIGEN',vm.origen);
		}

		vm.setMessages = function() {
			vm.messages = IkanoFactory.createMessages(vm.dashboardData);
		};

		vm.setIndicators = function() {
			vm.indicators.push({name:'Años de experiencia laboral', value: (vm.dashboardData.anios_experiencia_laboral ? vm.dashboardData.anios_experiencia_laboral : 0)});
			vm.indicators.push({name:'Número de empresas registradas', value: (vm.dashboardData.numero_empresas_registradas ? vm.dashboardData.numero_empresas_registradas : 0)});
			vm.indicators.push({name:'Número de cargos registrados', value: (vm.dashboardData.numero_cargos_registrados ? vm.dashboardData.numero_cargos_registrados : 0)});
			vm.indicators.push({name:'Número de estudios formales registrados', value: (vm.dashboardData.numero_estudios_formales_realizados ? vm.dashboardData.numero_estudios_formales_realizados : 0)});
			vm.indicators.push({name:'Mayor título finalizado', value: IkanoFactory.capitalize(vm.dashboardData.mayor_titulo_registrado, true)});
			vm.indicators.push({name:'Fecha de finalización del último estudio', value: vm.dashboardData.fecha_finalizacion_ultimo_estudio});
		};

		vm.setOffersSuggested = function() {
			for (var index = 0; index < vm.dashboardData.ofertas_perfil.length; index++) {
				var element = vm.dashboardData.ofertas_perfil[index];
				var offer = IkanoFactory.createOffer(element);

				offer.applied = vm.dashboardData.ofertas_aplico_ids.indexOf(element.id) !== -1;
				offer.status = 'Aplicar a esta oferta';
				offer.canApplied = vm.dashboardData.puede_aplicar;
				offer.offersLimit = vm.dashboardData.limite_ofertas_mes;
				offer.offersApplied = vm.dashboardData.cant_ofertas_aplico_hv_mes;
				offer.arguments = vm.dashboardData.proceso_argumentos;
				offer.requeriments = element.procesos_requisitos;
				offer.resumeStatus = vm.dashboardData.porcentaje_hv;

				vm.offersSuggested.push(offer);
			}
		};

		vm.openNoticeDialog = function(ev, offer) {
			$mdDialog.show({
				controller: 'ApplyDialogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/candidate/dashboard/dialogs/apply/apply.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					event: ev,
                    offer: offer
				}
			});	 

            vm.closeDialog();
		};

	
        vm.goToOffersAVailables = function() {
			localStorage.setItem('NEW_OFFERS_AVAILABLES_FILTER', true);
			$state.go('app.seleccion_ofertas_disponibles', {});
		};
    }
})();
(function () {
	'use strict';

	angular
		.module('app.seleccion_candidate')
		.controller('AppliedOffersController', AppliedOffersController);

	/** @ngInject */
	function AppliedOffersController($mdDialog, $document, CandidateService, IkanoFactory) {
		var vm = this;

        vm.applied = true;
		vm.factory = IkanoFactory;

		vm.loading = true;

        vm.pageInfo = {
			icon: "icon-home",
			parents: ['VACANTES APLICADAS'],
			title: "OFERTAS A LAS QUE HE APLICADO",
		};

		vm.offersSuggested = [];

		CandidateService.getAppliedOffers(function(response){
			if (response.data.ofertas_aplico.data.ofertas_aplico) {
				vm.offers = response.data.ofertas_aplico.data.ofertas_aplico;
				vm.setOffers();
				vm.loading = false;
			}
		});

		vm.setOffers = function() {
			for (var index = 0; index < vm.offers.length; index++) {
				var element = vm.offers[index];
				var offer = IkanoFactory.createOffer(element);
				offer.status = element.label_oferta;
				offer.applied = true;
				offer.resumeStatus = 100;
				vm.offersSuggested.push(offer);
			}
		};
    }
})();
(function () {
    'use strict';
    angular.module('app.seleccion_analyst').controller('understanding-charge', understandingCharge);
    angular.module('app.seleccion_analyst').controller('understanding-charge-primary', understandingChargePrimary);
    angular.module('app.seleccion_analyst').controller('understanding-charge-autocomplete', understandingChargeAutocomplete);

    function understandingCharge(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService, $mdSidenav, $rootScope, $mdToast, $mdColors) {
        //definimos el contructor
        var vm = this;

        //PARAMS
        vm.idRequest = $state.params.request_id;

        vm.projectName = analystConstant.DEFAULT.DATA.HEADER.KEYSDETAILREQUEST.UNDERSTANDING;
        //Informacion de la pagina
        vm.project = vm.selectedProject = analystMisc.header.getProject(vm.projectName);

        //projects
        vm.projects = analystMisc.header.getHeaderProjects();

        //MISCELANEOS
        vm.misc = {};


        //MISC texto para reemplazar
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

        vm.pageInfo = analystConstant.PAGESINFO.UNDERSTANDINGPOSITION;

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        vm.showButton = false;

        //HEADER
        vm.showModalEditOffer = function () {
            $mdDialog.show({
                controller: 'changeDatePublicController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/change_date_public_request/change_date_public_request.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            });
        }

        vm.openShowRequestNotesDialog = function () {
            $mdDialog.show({
                controller: 'ShowRequestNotesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-request-notes.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request,
                    callbackSuccess: vm.addNoteRequest
                }
            });
        }


        vm.addNoteRequest = function (data) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.observacion = data.note;
            data.note = '';
            analystService.addNoteRequest(dataPost, function (response) {
                var newNota = {};
                newNota.name = AuthService.getUserData().name;
                newNota.id = response.data.result.id;
                newNota.date_create_note = analystMisc.misc.setFormatDate(response.data.result.created_at, { format: 'MMM D, YYYY H:mm ' });
                newNota.note = response.data.result.descripcion;
                newNota.newNote = true;
                vm.request.notes.unshift(newNota);
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error creando la nota del proceso, por favor intente de nuevo.");
            });
        }

        vm.selectProject = function (project) {
            $state.go(project.url, { request_id: vm.idRequest });
        }

        vm.showFinishProcess = function () {
            $mdDialog.show({
                controller: 'finishRequestDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/finish_process/finish_process.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            }).then(function (resolve) {
                vm.modelRequest(resolve.data.data.proceso);
                vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
            });
        }

        vm.publishRequest = function () {
            $state.go('app.publish_request', { request_id: vm.idRequest });
        }
        //SIDENAV
        vm.toggleSidenav = function (sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };

        //SOCKET ANGULAR
        $rootScope.$on('understanding-charge-set-request', function (evt, arg) {
            vm.modelRequest(arg);
        });

        $rootScope.$on('toast::show', function (evt, arg) {
            vm.showToast(arg.data, arg.options);
        });

        $rootScope.$on('button::show', function (evt, arg) {
            vm.showButton = arg;
        });

        vm.saveTemporaly = function () {
            $rootScope.$broadcast('understanding::save', {});
        }

        //Modelamos la data de la request   
        vm.modelRequest = function (request) {
            var baseJson = analystConstant.KEYJSONREQUEST;
            analystMisc.modeldata(request, baseJson, { createIfNotExist: true })
                .then(function (resolve) {

                    vm.request = resolve;
                    analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
                        vm.request.notes = resolve;
                        $rootScope.$broadcast('setRequestSerialize', vm.request);
                    });
                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }

        vm.showToast = function (data, options) {
            options = (options) ? options : [];
            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }
    }

    function understandingChargePrimary(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService, $mdSidenav, $rootScope, $mdColors) {
        //definimos el contructor
        var vm = this;

        //PARAMS
        vm.idRequest = $state.params.request_id;
        vm.validationService = ValidationService;

        vm.request = {};

        $rootScope.$on("setRequestSerialize", function (evt, arg) {
            vm.request = angular.copy(arg);
        });

        $rootScope.$on("understanding::save", function (evt, arg) {
            vm.validateUnderstandingBlock();
        });
        //MISCELANEOS
        vm.misc = {};
        vm.misc.tabSelected = 'rq';
        //MISC texto para reemplazar
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        vm.pageInfo = analystConstant.PAGESINFO.UNDERSTANDINGPOSITION;

        vm.getUnderstandingCharge = function () {
            analystService.getUnderstandingCharge(
                { proceso_id: vm.idRequest },
                function (resolve) {
                    if (resolve.status == analystConstant.CODEPETITION.OK) {
                        vm.understandingBlocks = resolve.data.data.understanding;
                        vm.requestBlocks = resolve.data.data.requisition;
                        vm.modelRequestBlock();
                        vm.modelUnderstanding();
                        $rootScope.$broadcast('understanding-charge-set-request', resolve.data.data.process);
                    } else {
                        //AQUI VA EL TOAST
                    }
                }, function (reject) {
                    IkanoFactory.showAlert("Error", reject.message);
                }
            )

        };


        vm.modelUnderstanding = function () {
            vm.understanding = {};
            vm.setModelFrom = 1;
            vm.understanding.data = vm.understandingBlocks;
            vm.understanding.values = vm.understanding.data.data;
            vm.understanding.lists = vm.understanding.data.listas;
            vm.understanding.fields = ValidationService.disableField(vm.understanding.data.estructura_campos, vm.understanding.values);
            vm.understanding.extra = vm.understanding.data.extra;
            vm.understanding.observations = vm.understanding.data.observaciones;

            if (vm.understanding.data.original_data && vm.understanding.data.original_data.subarea_id) {
                AdminService.get_onchange_data({ values: { 'ubicacion_id': vm.understanding.data.original_data.ubicacion_id }, function: 'getSubareas' }, function (response) {
                    vm.understanding.data.original_data.subarea_id_lista = response.data.data.lista.list_subareas;
                });
            }
            vm.setValuesWatch();
            vm.understanding.change = false;
            vm.blocksUnderstanding = vm.setBlocksUnderstanding(vm.understanding.data.bloques);
            setdateCreatedAndUpdate(vm.blocksUnderstanding, vm.understandingBlocks.fecha_creacion_bloques, vm.understandingBlocks.fecha_actualizacion_bloques);
            vm.understanding.getPositionColaborators = vm.getPositionColaborators;
            ValidationService.generalFunctions($scope, vm.understanding);
            //ValidationService.watchFunctions($scope, vm.understanding, 'understanding');
            vm.searchLocalstorage();
        };

        vm.modelRequestBlock = function () {
            vm.proccess = {};
            vm.setModelFrom = 2;
            vm.proccess.data = vm.requestBlocks;
            vm.proccess.values = vm.proccess.data.data;
            vm.proccess.lists = vm.proccess.data.listas;
            //vm.fields = vm.data.estructura_campos;
            vm.proccess.fields = ValidationService.disableField(vm.proccess.data.estructura_campos, vm.proccess.values);
            vm.proccess.extra = vm.proccess.data.extra;
            vm.proccess.observations = vm.proccess.data.observaciones;

            if (vm.proccess.data.original_data && vm.proccess.data.original_data.subarea_id) {
                AdminService.get_onchange_data({ values: { 'ubicacion_id': vm.proccess.data.original_data.ubicacion_id }, function: 'getSubareas' }, function (response) {
                    vm.proccess.data.original_data.subarea_id_lista = response.data.data.lista.list_subareas;
                });
            }
            //vm.setPageData();
            vm.setValuesWatch();
            vm.proccess.change = false;
            //vm.setBlocksRequest();
            vm.blocksRequests = vm.setBlocks(vm.proccess.data.bloques);

            vm.proccess.getPositionColaborators = vm.getPositionColaborators;
            ValidationService.generalFunctions($scope, vm.proccess);
        };

        vm.searchLocalstorage = function () {
            var newValues = JSON.parse(localStorage.getItem('updateUnderstanding'));
            vm.understanding.values = Object.assign(vm.understanding.values, newValues);
            localStorage.removeItem('updateUnderstanding')
        };

        vm.setPageData = function () {
            vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
            vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
            if (vm.data.data.no_vacantes) {
                var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
                vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
            }

            vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
            if (vm.data.data.tipo_solicitud_b_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
            }
            if (vm.data.data.tipo_solicitud_c_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
            }
        };



        vm.setBlocksUnderstanding = function (bloques) {
            return $.map(bloques, function (value, index) {
                return [vm.getBlockUnderstanding(index, value)];
            });
        };

        vm.setBlocks = function (bloques) {
            return $.map(bloques, function (value, index) {
                return [vm.getBlock(index, value)];
            });
        };

        vm.getBlock = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.type == "has_many" ? IkanoFactory.getStructureForFieldsHasMany(data.campos, vm.proccess.fields, data.model) : IkanoFactory.getStructureForFields(data.campos, vm.proccess.fields)
            };

            if (vm.setModelFrom == 1) {
                if (block.name == "info_general") {
                    block.type = "one-column";
                } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                    block.type = "select-current-employee";
                } else if (block.fields.length < 2) {
                    block.type = "one-column";
                } else if (data.type == "has_many") {
                    block.type = "two-column-multiple-rows";
                }

            } else {
                if (block.fields.length < 2) {
                    block.type = "one-column";
                } else if (data.type == "has_many") {
                    block.type = "two-column-multiple-rows";
                }
            }

            return block;
        };

        vm.getBlockUnderstanding = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.type == "has_many" ? IkanoFactory.getStructureForFieldsHasMany(data.campos, vm.understanding.fields, data.model) : IkanoFactory.getStructureForFields(data.campos, vm.understanding.fields),
                popupEdit: vm.showModalEdit
            };

            if (vm.setModelFrom == 1) {
                if (block.name == "info_general") {
                    block.type = "one-column";
                } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                    block.type = "select-current-employee";
                } else if (block.fields.length < 2) {
                    block.type = "one-column";
                } else if (data.type == "has_many") {
                    block.type = "two-column-multiple-rows";
                }

            } else {
                if (block.fields.length < 2) {
                    block.type = "one-column";
                } else if (data.type == "has_many") {
                    block.type = "two-column-multiple-rows";
                }
            }

            return block;
        };



        function setdateCreatedAndUpdate(understanding, created, updated) {
            var createdTMP = [];
            var updatedTMP = [];
            if (created instanceof Array) {
                createdTMP = angular.copy(created);
            }

            if (updated instanceof Array) {
                updatedTMP = angular.copy(updated);
            }

            var createdObj = {};
            var updatedObj = {};

            for (var i in createdTMP) {
                createdObj[createdTMP[i][2]] = moment(createdTMP[i][3]).format('YYYY-MM-DD');
            }

            for (var i in updatedTMP) {
                updatedObj[updatedTMP[i][2]] = moment(updatedTMP[i][3]).format('YYYY-MM-DD');
            }

            for (var i in understanding) {

                if (createdObj[understanding[i].name]) {
                    understanding[i].date_created = createdObj[understanding[i].name];
                }

                if (updatedObj[understanding[i].name]) {
                    understanding[i].date_updated = updatedObj[understanding[i].name];
                }

            }

        }

        vm.showModalEdit = function (dataBlock, rootBlock) {
            var data = {
                bloques: {},
                data: angular.copy(rootBlock.data.data),
                estructura_campos: angular.copy(rootBlock.data.estructura_campos),
                listas: angular.copy(rootBlock.data.listas)
            }
            data.bloques[dataBlock.name] = rootBlock.data.bloques[dataBlock.name];

            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: 'app/main/analyst/understanding-charge/dialog/block.html',
                controller: 'BlockPopUp',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    data: data,
                    idRequest: vm.idRequest,
                }
            }).then(function (resolve) {
                if (resolve.status == 200) {
                    var data = {};
                    data.class = (resolve.data.status) ? "success" : "error";
                    data.message = resolve.data.message;
                    data.showClose = true;
                    vm.understanding.data.data = resolve.data.values;
                    if (!dataBlock.date_created) {
                        dataBlock.date_created = moment().format('YYYY-MM-DD');
                    } else {
                        dataBlock.date_updated = moment().format('YYYY-MM-DD');
                    }
                    $rootScope.$broadcast('toast::show', { data: data, options: [] });
                } else {
                    var data = {};
                    data.class = "error";
                    data.message = resolve.data.message;
                    data.showClose = true;
                    $rootScope.$broadcast('toast::show', { data: data, options: [] });
                }
            });
        }


        vm.addModelToBlock = function (block, root) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            root.values[block.model].push(model);
        };

        vm.removeModelToBlock = function (block, index, root) {
            root.values[block.model].splice(index, 1);
        };

        vm.getPositionColaborators = function (position, root) {
            AdminService.getPositionColaborators({ cargo_id: position, proceso_id: vm.idRequest }, {},
                function (response) {
                    if (response.data.colaboradores) {
                        var colaboradores = response.data.colaboradores;
                        root.lists.position_colaborators = IkanoFactory.setPositionsId(colaboradores, 'estructura_id');

                        //CAMBIAR ID DE INFO_OCUPANTE_ACTUAL POR ESTRUCTURA_ID
                        var newInfo = [];
                        for (var i in root.values.info_ocupante_actual) {
                            var ocupante = root.values.info_ocupante_actual[i];
                            if (colaboradores[ocupante]) {
                                newInfo.push((colaboradores[ocupante].estructura_id ? colaboradores[ocupante].estructura_id : colaboradores[ocupante].id) + "");
                            }
                        }
                        root.values.notChangeInfoActual = true;
                        root.values.info_ocupante_actual = newInfo;
                        console.log(root.values);
                    }
                },
                function (response) {
                    //IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };


        vm.getUnderstandingCharge();

        vm.setValuesWatch = function () {
            ValidationService.setWarchers($scope, vm);
        };


        vm.save = function (send, type, value) {
            //console.log(vm.values);return;
            var data = {
                id: vm.idRequest,
                data: (value ? value : vm.understanding.values)
            };
            /*vm.understanding.change = false;
            vm.understanding.saving = true;*/

            if (!data.data.tipo_proceso) {
                data.data.tipo_proceso = 'proceso_analista';
            }


            analystService.saveRequestAnalyst(data,
                function (response) {

                    vm.understanding.saving = false;
                    vm.understanding.change = true;
                    if (type == 2) {
                        vm.saveandapprove();
                    } else {
                        var data = {};
                        data.class = (response.data.status) ? "success" : "error";
                        data.message = response.data.message;
                        data.showClose = true;
                        $rootScope.$broadcast('toast::show', { data: data, options: [] });
                    }
                },
                function (reject) {
                    var data = {};
                    data.class = "error";
                    data.message = reject.data.message;
                    data.showClose = true;
                    $rootScope.$broadcast('toast::show', { data: data, options: [] });
                    vm.understanding.saving = false;
                    vm.understanding.change = true;
                }
            );

        };

        vm.validateUnderstanding = function (send, type) {
            vm.understanding.errors = IkanoFactory.validateFieldsWithObject(vm.understanding.fields, vm.understanding.values, true);
            if (angular.equals(vm.understanding.errors, {})) {
                vm.save(send, type);
            } else {
                IkanoFactory.showAlert("Error", "La información del entendimiento esta incompleta, por favor intente de nuevo.");
            }
        }

        vm.validateUnderstandingBlock = function () {
            var value = angular.copy(vm.understanding.values);
            vm.save(true, 1, value);
            /*var fields = IkanoFactory.getFieldsArray(block.fields,vm.understanding.fields);
            vm.understanding.errors = IkanoFactory.validateFieldsWithObject(fields, vm.understanding.values, true);
            if (angular.equals(vm.understanding.errors, {})) {
                var value = IkanoFactory.getValueWithFields(block.fields, vm.understanding.values);
                vm.save(true, 1,value);
            }else{
                IkanoFactory.showAlert("Error", "La información del bloque esta incompleta, por favor intente de nuevo.");
            }*/
        }

        vm.saveandapprove = function () {
            var data = {
                proceso_id: vm.request.id
            };
            vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values, true);
            if (angular.equals(vm.errors, {})) {
                analystService.approveRequestAnalyst(data,
                    function (response) {
                        var data = {};
                        data.class = (response.data.result.status) ? "success" : "error";
                        data.message = response.data.result.message;
                        data.showClose = true;
                        $rootScope.$broadcast('toast::show', { data: data, options: [] });
                        vm.saving = false;
                        vm.change = true;
                        $state.transitionTo($state.current, $state.params, {
                            reload: true, inherit: false, notify: true
                        });
                    },
                    function (response) {
                        var data = {};
                        data.class = (response.data.status) ? "success" : "error";
                        data.message = response.data.message;
                        data.showClose = true;
                        $rootScope.$broadcast('toast::show', { data: data, options: [] });
                        vm.saving = false;
                        vm.change = true;
                    }
                );
            } else {
                IkanoFactory.showAlert("Error", "El entendimiento se encuentra incompleto, por favor complete los campos antes de enviar aprobación.");
            }
        };

        vm.downloadPDF = function () {
            var data = { proceso_id: vm.idRequest };
            analystService.downloadUnderstandingPdf(data, { responseType: 'arraybuffer' }, function (resolve) {
                IkanoFactory.downloadFile(resolve.data, vm.request.cod + ".pdf");
            }, function (reject) {
                var data = {};
                data.class = "error";
                data.message = reject.data.message;
                data.showClose = true;
                $rootScope.$broadcast('toast::show', { data: data, options: [] });
            });
        };

        vm.downloadRequestPDF = function () {
            var data = { id: vm.idRequest, tipo: "proceso" };
            AdminService.getPDFReport(data, { responseType: 'arraybuffer' }, function (resolve) {
                IkanoFactory.downloadFile(resolve.data, vm.request.cod + ".pdf");
            }, function (reject) {
                var data = {};
                data.class = "error";
                data.message = reject.data.message;
                data.showClose = true;
                $rootScope.$broadcast('toast::show', { data: data, options: [] });
            });
        };

        vm.stateGo = function (state) {
            $state.go(state, { request_id: vm.idRequest });
        };

        vm.showModalApprovedEmails = function (from) {
            $mdDialog.show({
                controller: 'approveEmailsDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/approve_emails/approveEmailsDialog.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    email: vm.request.applicant_email,
                    title: (from == 1) ? 'Enviar entendimiento del cargo' : 'Enviar requisición'
                }
            }).then(function (resolve) {
                if (from == 1) {
                    vm.sendApproveEmails(resolve);
                } else {
                    vm.sendRequestEmails(resolve);
                }

            });
        };

        vm.sendApproveEmails = function (emails) {
            analystService.sendApproveUnderstanding(
                {
                    proceso_id: vm.idRequest,
                    correos: emails
                },
                function (resolve) {
                    var data = {};
                    data.class = (resolve.data.status) ? "success" : "error";
                    data.message = resolve.data.message;
                    data.showClose = true;
                    $rootScope.$broadcast('toast::show', { data: data, options: [] });
                }, function (reject) {
                    var data = {};
                    data.class = "error";
                    data.message = reject.data.message;
                    data.showClose = true;
                    $rootScope.$broadcast('toast::show', { data: data, options: [] });
                }
            )
        };

        vm.sendRequestEmails = function (emails) {
            AdminService.sendEmailsRequest(
                {
                    proceso_id: vm.idRequest,
                    correos: emails
                },
                function (resolve) {
                    var data = {};
                    data.class = (resolve.data.status) ? "success" : "error";
                    data.message = resolve.data.message;
                    data.showClose = true;
                    $rootScope.$broadcast('toast::show', { data: data, options: [] });
                }, function (reject) {
                    var data = {};
                    data.class = "error";
                    data.message = reject.data.message;
                    data.showClose = true;
                    $rootScope.$broadcast('toast::show', { data: data, options: [] });
                }
            )
        };

        vm.selectedTab = function (tab) {
            vm.misc.tabSelected = tab;
            if (tab == 'ec') {
                $rootScope.$broadcast('button::show', true);
            } else {
                $rootScope.$broadcast('button::show', false);
            }
        }

    };

    function understandingChargeAutocomplete(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService, $mdSidenav, $rootScope, FileSaver, $mdColors) {
        //definimos el contructor
        var vm = this;

        //PARAMS
        vm.idRequest = $state.params.request_id;
        vm.validationService = ValidationService;

        //SET REQUEST
        vm.request = {};

        $rootScope.$on("setRequestSerialize", function (evt, arg) {
            vm.request = angular.copy(arg);
            vm.getProcess(vm.idRequest);
        });

        vm.checkBlock = [];

        //MISCELANEOS
        vm.misc = {};
        //MISC texto para reemplazar
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

        vm.pageInfo = analystConstant.PAGESINFO.UNDERSTANDINGPOSITION;

        vm.misc.showPage = false;

        vm.errorSearch = {};

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        vm.initGetUnderstandingCharge = function () {
            analystService.getUnderstandingCharge(
                { proceso_id: vm.idRequest, not_requisition: true },
                function (resolve) {
                    $rootScope.$broadcast('understanding-charge-set-request', resolve.data.data.process);

                    vm.setProcesos(resolve.data.procesos);

                    //vm.modelUnderstanding(resolve.data);
                },
                function (reject) {
                    IkanoFactory.showAlert("Error", reject.data.message);
                }
            )
        }

        vm.getUnderstandingCharge = function (data) {
            vm.misc.showPage = true;
            analystService.getUnderstandingCharge(
                { proceso_id: data.id, not_requisition: true },
                function (resolve) {
                    if (resolve.data.status) {
                        vm.fieldsInvalid = resolve.data.data.keys_invalids;
                        vm.modelUnderstanding(resolve.data.data.understanding);
                    } else {
                        var data = {};
                        data.class = "error";
                        data.message = resolve.data.message;
                        data.showClose = true;
                        $rootScope.$broadcast('toast::show', { data: data, options: [] });
                    }

                }, function (reject) {
                    IkanoFactory.showAlert("Error", reject.data.message);
                }
            )
        }

        vm.getProcess = function (idRequest, query) {
            vm.loadingProcess = true;
            var data = {
                proceso_id: idRequest,
            }
            if (query) {
                if (query.length >= 3) {
                    data.query = query;
                    delete (data.proceso_id);
                } else {
                    return;
                }

            }
            analystService.searchProcess(data, function (resolve) {
                vm.loadingProcess = false;
                if (resolve.data.data.length <= 0) {
                    /*var data = {};
                    data.class = "error";
                    data.message = resolve.data.message;
                    data.showClose = true;
                    $rootScope.$broadcast('toast::show', { data: data, options: [] });*/
                    vm.errorSearch.valid = false;
                    vm.errorSearch.message = resolve.data.message;
                } else {
                    vm.errorSearch.valid = true;
                }
                vm.process = resolve.data.data;
            }, function (reject) {
                vm.loadingProcess = false;
                IkanoFactory.showAlert("Error", reject.data.message);
            }, true);
        };
        vm.setProcesos = function (data) {
            vm.procesos = data;
        }

        vm.modelUnderstanding = function (data) {
            vm.data = data;
            vm.values = data.data;
            vm.lists = vm.data.listas;
            //vm.fields = vm.data.estructura_campos;
            vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
            vm.extra = vm.data.extra;
            vm.observations = vm.data.observaciones;
            vm.setPageData();
            vm.setValuesWatch();
            vm.change = false;
            vm.setBlocks();

            //vm.getPositionColaborators(vm.values.cargo_id);
            ValidationService.generalFunctions($scope, vm);
        }

        vm.setPageData = function () {
            vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
            vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
            if (vm.data.data.no_vacantes) {
                var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
                vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
            }

            vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
            if (vm.data.data.tipo_solicitud_b_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
            }
            if (vm.data.data.tipo_solicitud_c_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
            }
        };

        vm.setValuesWatch = function () {
            ValidationService.setWarchers($scope, vm);
        };

        vm.setBlocks = function () {
            vm.blocks = $.map(vm.data.bloques, function (value, index) {
                return [vm.getBlock(index, value)];
            });
        };


        vm.getBlock = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.campos,
                blockType: data.type
            };

            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }

            return block;
        };


        vm.addModelToBlock = function (block) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            vm.values[block.model].push(model);
        }

        vm.removeModelToBlock = function (block, index) {
            vm.values[block.model].splice(index, 1);
        }

        vm.getPositionColaborators = function (position) {
            AdminService.getPositionColaborators({ cargo_id: position, proceso_id: vm.idRequest }, {},
                function (response) {
                    if (response.data.colaboradores) {
                        vm.lists.position_colaborators = response.data.colaboradores;
                    }
                }
            );
        };




        vm.saveAutocomplete = function (send, requestType) {
            var fieldsSelected = [];
            var newValues = {};
            for (var i in vm.checkBlock) {
                if (vm.blocks[vm.checkBlock[i]].blockType == "has_many") {
                    fieldsSelected.push(vm.blocks[vm.checkBlock[i]].model);
                    continue;
                }
                fieldsSelected = fieldsSelected.concat(vm.blocks[vm.checkBlock[i]].fields);
            };

            fieldsSelected.map(function (currentValue, index, arr) {
                if (vm.fieldsInvalid.indexOf(currentValue) == -1) {
                    newValues[currentValue] = vm.values[currentValue];
                }
            });

            localStorage.setItem("updateUnderstanding", JSON.stringify(newValues));

            vm.stateGo('app.entendimiento_cargo.index');
        }


        vm.blockSelected = function (index) {
            var indexBlock = vm.checkBlock.indexOf(index);

            if (indexBlock == -1) {
                vm.checkBlock.push(index);
            } else {
                vm.checkBlock.splice(indexBlock, 1);
            }
        }

        vm.downloadPDF = function () {
            var data = { proceso_id: vm.idRequest };
            analystService.downloadUnderstandingPdf(data, { responseType: 'arraybuffer' }, function (resolve) {
                IkanoFactory.downloadFile(resolve.data, "Entendimiento del cargo.pdf");
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            })
        }

        vm.stateGo = function (state) {
            $state.go(state, { request_id: vm.idRequest });
        }

        vm.initGetUnderstandingCharge();

    }

})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('teamProcesses', teamProcesses);

    function teamProcesses($mdDialog,AuthService, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, analystService, analystMisc, $mdToast, analystConstant, paginationService, $compile, $scope, $mdColors, $filter) {
        //constructor
        var vm = this;

        vm.limit = analystConstant.LIMITROW;
        vm.countConsult = 0;

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Colaboradores', 'Proceso de selección de mi equipo'],
            title: "Proceso de selección de mi equipo",
        };

        //DATA TABLE OPTION
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            paging: false,
            language: IkanoFactory.getLanguajeDataTable(),
            pagingType: 'simple',
            autoWidth: false,
            iDisplayLength: 20,
            order: [1, 'asc'],
            searching: false
        };

        //FILTER
        vm.filter = {};
        vm.filter.startDate = null;
        vm.filter.endDate = null;

        //MISC
        vm.misc = {};

        vm.misc.arrApplicant = [];
        vm.misc.arrStatusRequest = [];

        vm.misc.arrAnalysts = [];

        vm.misc.arrRegionalRequest = [];

        vm.misc.filter = {};

        // se setea un valor por defecto que va a valer 0 en los filtro por select
        vm.misc.filter.defaultApplicant = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.APPLICANT;
        vm.misc.filter.defaultStatusRequest = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.STATUSREQUEST;
        vm.misc.filter.defaultRegionalRequest = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.REGIONALREQUEST;
        vm.misc.filter.defaultAnalystRequest = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.ANALYSTREQUEST;
        vm.misc.filterCopy = {};

        //PAGER
        vm.pager = {};

        //BACKUP
        vm.backup = {};
        vm.backup.filter = {};

        vm.user = AuthService.getUserData();

        vm.updateAnalyst = function (data, request) {
            request.loading = true;

            analystService.setAnalystProcess({ analista_id: data.id, proceso_id: request.id }, function (response) {
                if (response.data.status) {
                    request.analyst.name = data.name;
                    request.analyst.id = data.id;
                    request.selected = false;
                    showToast({ class: "success", message: response.data.message, showClose: true });
                } else {
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }
                request.loading = false;
            },
                function (reject) {
                    request.loading = false;
                    request.selected = false;
                    IkanoFactory.showAlert("Error", reject.data.message);
                }, true);
        }

        vm.publishRequest = function (id) {
            $state.go('app.publish_request', { request_id: id });
        }

        vm.search = function () {
            var filter = angular.copy(vm.filter);
            if (filter.estado_proceso == -1) {
                delete (filter.estado_proceso);
            }
            if (vm.filter.solicitante_id == -1) {
                delete (filter.solicitante_id);
            }
            if (filter.regional_id == -1) {
                delete (filter.regional_id);
            }
            if (filter.analista_id == -1) {
                delete (filter.analista_id);
            }
            if (filter.startDate && filter.endDate) {
                filter.fecha_creacion = [filter.startDate, filter.endDate];
                delete (filter.startDate);
                delete (filter.endDate);
            }
            vm.backup.filter = filter;
            vm.page = 1;
            getTeamProcesses({
                filtros: filter,
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }

        //PAGINATION
        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.pagination.total_rows, page, vm.limit);
            if (!noConsult) {
                var consult = {
                    filtros: vm.backup.filter, pagination: {
                        page: page,
                        limit: vm.limit
                    }
                };
                getTeamProcesses(consult);
            }
            setTimeout(function () {
                createPagination();
            }, 1000);

        }

        //GO DETAIL
        vm.goDetail = function (idRequest) {
            $state.go('app.detail_seleccion_analyst.index', { request_id: idRequest });
        }

        vm.callbackSendData = function (filter) {
            var filterConsult = angular.copy(filter);

            if (filterConsult.fecha_creacion && filterConsult.fecha_creacion_fin) {
                filterConsult.fecha_creacion = [filterConsult.fecha_creacion, filterConsult.fecha_creacion_fin];
                delete (filterConsult.fecha_creacion_fin);
            }

            vm.backup.filter = filterConsult;
            getTeamProcesses({
                filtros: filterConsult,
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }

        vm.clearFilter = function () {
            vm.backup.filter = {};
            vm.filter.query = null;
            vm.filter.solicitante_id = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.APPLICANT;
            vm.filter.estado_aprobacion = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.STATUSREQUEST;
            vm.filter.regional_id = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.REGIONALREQUEST;
            vm.filter.analista_id = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.ANALYSTREQUEST;
            vm.filter.startDate = null;
            vm.filter.endDate = null;
            vm.page = 1;
            getTeamProcesses({
                filtros: {},
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }


        //CONSULTA PROCESO DEL EQUIPO
        function getTeamProcesses(data) {
            if (vm.user.group_id == 1) {
                AdminService.get_team_processes_admin(data, function (response) {
                    if (response.data.status) {
                        vm.filters = response.data.filters;
                        modelRequest(response.data.data);
                        //if(vm.countConsult == 0){
                        modelFilter(response.data.listas);
                        //}

                        modelPagination(response.data.pagination);
                        vm.countConsult += 1;
                    } else {
                        showToast({ class: "error", message: response.data.message, showClose: true });
                    }
                },
                    function (reject) {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la informacion de los candidatos, por favor intente de nuevo.");
                    });
            } else {
                analystService.getTeamProcesses(data, function (response) {
                    if (response.data.status) {
                        vm.filters = response.data.filters;
                        modelRequest(response.data.data);
                        //if(vm.countConsult == 0){
                        modelFilter(response.data.listas);
                        //}

                        modelPagination(response.data.pagination);
                        vm.countConsult += 1;
                    } else {
                        showToast({ class: "error", message: response.data.message, showClose: true });
                    }
                },
                    function (reject) {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la informacion de los candidatos, por favor intente de nuevo.");
                    });
            }

        }

        //Modelar las requisiones
        function modelRequest(data) {
            var baseJson = {
                "id": "id",
                "codigo": "cod",
                "estado_label": "status",
                "estado_aprobacion_color": "colorStatus",
                "cargo_ocupar": "name",
                "ciudad": "state",
                "solicitante": "applicant",
                "solicitante_id": "applicant_id",
                "correo_solicitante": "applicant_email",
                "empresa_solicitante": "applicant_from",
                "fecha_solicitud": "date_request",
                "estado_publicacion_color": "color_status_publish",
                "estado_publicacion": "status_publish",
                "fecha_publicacion": { key: "date_publish", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                "fecha_cierre_publicacion": { key: "date_publish_close", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                "no_vacantes": "count_vacant",
                "seleccionados": "selected",
                "pre_seleccionados": "preSelected",
                "no_leidos": "unread",
                "finalistas": "finalist",
                "total": "candidates",
                "custom_data": "custom_data",
                "candidatos": {
                    key: "candidate_info", callback: "setCandidateInfo", dataCallback: {
                        baseJson: {
                            "seleccionados": "selected",
                            "pre_seleccionados": "preSelected",
                            "no_leidos": "unread",
                            "total": "candidates",
                            "aplicantes": "applicants",
                            "base_de_datos": "db",
                            "descartados": "discards",
                            "finalistas": "finalysts",
                            "en_proceso": "in_process",
                            "recomendados": "recommends",
                            "solicitantes": "solicitantes",
                            "aprobados": "approved"
                        }
                    }
                },
                "aprobacion_entendimiento_cargo": "approve_understanding",
                "estado_oferta": "status_offer",
                "estado_proceso": "status_process",
                "estado_requisicion": "status_request",
                "analista": "analyst",
                "fecha_creacion": { key: "createdDate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } }

            };
            analystMisc.modeldataarray(data, baseJson).then(function (resolve) {
                vm.requests = resolve;
                vm.backupRequest = angular.copy(vm.requests);
            });
        }

        function modelFilter(data) {
            var analysts = data.analistas;
            var applicant = data.solicitantes;
            var statusRequest = data.estados_proceso;
            var regionalRequest = data.empresas;
            var analystsArr = [];
            var applicantArr = [];
            var statusRequestArr = [];
            var regionalArr = [];
            var applicantBackUp = angular.copy(vm.filter.solicitante_id);
            var statusBackUp = angular.copy(vm.filter.estado_aprobacion);
            var regionalBackUp = angular.copy(vm.filter.regional_id);
            var analystBackUp = angular.copy(vm.filter.analista_id);
            vm.filter.solicitante_id = null;
            vm.filter.estado_aprobacion = null;
            vm.filter.regional_id = null;
            vm.filter.analista_id = null;

            if (!angular.equals(applicant, {})) {
                angular.forEach(applicant, function (v, k) {
                    k = parseInt(k);
                    applicantArr.push({ id: k, name: v });
                });
                applicantArr.sort(function (a, b) {
                    if (a.name < b.name) { return -1; }
                    if (a.name > b.name) { return 1; }
                    return 0;
                });
            }

            console.log(statusRequest)

            if (!angular.equals(statusRequest, {})) {
                angular.forEach(statusRequest, function (v, k) {
                    statusRequestArr.push({ id: k, name: v });
                });
            }

            if (!angular.equals(regionalRequest, {})) {
                angular.forEach(regionalRequest, function (v, k) {
                    k = parseInt(k);
                    regionalArr.push({ id: k, name: v });
                });
            }


            if (!angular.equals(analysts, {})) {
                angular.forEach(analysts, function (v, k) {
                    k = parseInt(k);
                    analystsArr.push({ id: k, name: v });
                });
            }

            vm.misc.arrApplicant = arrUnique(applicantArr);
            vm.misc.arrStatusRequest = arrUnique(statusRequestArr);
            vm.misc.arrRegionalRequest = arrUnique(regionalArr);
            vm.misc.arrAnalysts = arrUnique(analystsArr);

            vm.filter.solicitante_id = applicantBackUp;
            vm.filter.estado_aprobacion = statusBackUp;
            vm.filter.regional_id = regionalBackUp;
            vm.filter.analista_id = analystBackUp;

        }

        function arrUnique(arr) {
            var cleaned = [];
            var arrReturn = [];
            arr.forEach(function (item) {
                if (cleaned.indexOf(item.id) == -1) {
                    cleaned.push(item.id);
                    arrReturn.push(item);
                }
            });
            return arrReturn;
        }



        function modelPagination(filterPage) {

            vm.pagination = filterPage;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        function createPagination() {
            var elemt = $('.right');
            //elemt.appendTo('<div class="paginations"></div>');

            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}}, {{vm.pagination.total_rows}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        function showToast(data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }


        getTeamProcesses({
            filtros: {},
            pagination: {
                page: 1,
                limit: vm.limit
            }
        });
    }
})();
(function () {
    'use strict';



    jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "date-nl-pre": function (date) {
            return moment(date, 'MMM D, YYYY hh:mm A');
        },

        "date-nl-asc": function (a, b) {
            return (a.isBefore(b) ? -1 : (a.isAfter(b) ? 1 : 0));
        },

        "date-nl-desc": function (a, b) {
            return (a.isBefore(b) ? 1 : (a.isAfter(b) ? -1 : 0));
        }
    });

    angular.module('app.seleccion_analyst').controller('suspensionRequest', suspensionRequest);

    function suspensionRequest(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService, $mdSidenav, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $q, $mdToast) {

        //contoller
        var vm = this;

        //PARAMS
        vm.idRequest = $state.params.request_id;

        vm.request = {};

        vm.projectName = analystConstant.DEFAULT.DATA.HEADER.KEYSDETAILREQUEST.SUSPENSION;

        //Informacion de la pagina
        vm.project = vm.selectedProject = analystMisc.header.getProject(vm.projectName);

        //CONTANTES
        vm.statusOffer = analystConstant.OFFERSTATUS;

        //projects
        vm.projects = analystMisc.header.getHeaderProjects();
        //MISCELANEOS
        vm.misc = {};
        //MISC texto para reemplazar
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

        vm.pageInfo = analystConstant.PAGESINFO.SENDCANDIDATE;

        vm.status_process_status = analystConstant.STATUSPROCESS;

        vm.misc.arrCrSuspension = [];

        vm.misc.arrSupension = [];

        vm.dtOptions = {
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            iDisplayLength: 20,
            responsive: true,
            order: [0, "desc"],
            paging: false,
            searching: false,
            info: false
        };

        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).withOption('type', 'date-nl'),
            DTColumnDefBuilder.newColumnDef(4).withOption('type', 'date-nl')
        ];

        vm.data = {};

        vm.validation = {};

        vm.user = AuthService.getUserData();

        vm.getSuspensionRequest = function () {
            if (vm.user.group_id == 1) {
                AdminService.getRequestAdminSeleccion({ proceso_id: vm.idRequest }, function (response) {
                    vm.loading = false;
                    switch (response.status) {
                        case analystConstant.CODEPETITION.OK:
                            vm.modelListSuspensiones(response.data.proceso.listas.criterios_suspension);
                            vm.modelsuspensiones(response.data.proceso.suspensiones);
                            vm.modelRequest(response.data.proceso);
                            break;

                        case analystConstant.CODEPETITION.NOTFOUND:
                            IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada. por favor intente de nuevo.");
                            break;
                    }
                }, function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada. por favor intente de nuevo.");
                });
            } else {
                analystService.getCandidate({ proceso_id: vm.idRequest }, function (response) {
                    vm.loading = false;
                    switch (response.status) {
                        case analystConstant.CODEPETITION.OK:
                            vm.modelListSuspensiones(response.data.get_proceso_analista.data.proceso.listas.criterios_suspension);
                            vm.modelsuspensiones(response.data.get_proceso_analista.data.proceso.suspensiones);
                            vm.modelRequest(response.data.get_proceso_analista.data.proceso);
                            break;

                        case analystConstant.CODEPETITION.NOTFOUND:
                            IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada. por favor intente de nuevo.");
                            break;
                    }
                }, function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada. por favor intente de nuevo.");
                });
            }

        }

        vm.modelsuspensiones = function (data) {
            var baseJson = {
                id: "id",
                analista: { key: "name", callback: "getOneKey", dataCallback: { getKey: "name" } },
                fecha_suspension: { key: "date_suspension", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY hh:mm A' } }, otherParams: "fecha_activacion" },
                descripcion: "reason_suspension",
                fecha_activacion: { key: "date_restart", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY hh:mm A' } } },
                criterio: "criterio"
            };
            analystMisc.modeldataarray(data, baseJson)
                .then(function (resolve) {
                    vm.misc.arrSupension = vm.mergeSuspensionToReason(resolve, vm.objSuspension);
                    vm.loadTable = true;
                });

        }

        vm.mergeSuspensionToReason = function (data, obj) {
            for (var i in data) {
                if (obj[data[i].criterio]) {
                    data[i].criterioString = obj[data[i].criterio];
                }
            }
            return data;
        }

        vm.modelListSuspensiones = function (data) {
            vm.objSuspension = data;
            angular.forEach(data, function (value, key) {
                vm.misc.arrCrSuspension.push({ id: key, name: value });
            });
            //vm.misc.arrCrSuspension = Object.values(data);
        }

        vm.modelRequest = function (request) {
            var baseJson = analystConstant.KEYJSONREQUEST;
            analystMisc.modeldata(request, baseJson, { createIfNotExist: true })
                .then(function (resolve) {
                    vm.request = resolve;
                    analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
                        vm.request.notes = resolve;
                    });
                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }

        vm.showModalSuspension = function () {
            $mdDialog.show({
                controller: 'suspensionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/suspension-request/dialog/suspension-dialog.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    criterio: vm.misc.arrCrSuspension,
                    idRequest: vm.idRequest,
                    request: vm.request,
                    data: vm.data
                }
            }).then(function (resolve) {
                vm.data = resolve;
                vm.saveSuspensionRequest(1);
            });
        }


        vm.saveSuspensionRequest = function (isModal) {
            var error = false;
            var msg = "";
            if (!vm.data.suspension) {
                error = true;
                msg = "Es requerido un criterio para la suspension del proceso.";
            }

            if (!vm.data.observation) {
                error = true;
                msg = "Es requerido un criterio para la suspension del proceso.";
            }


            if (!vm.data.observation.length > 200) {
                error = true;
                msg = "La observacion no puede tener mas de 200 caracteres";
            }

            if (error) {
                var optionsToast = [
                    {
                        title: "Ver formulario",
                        callback: vm.closeOffer
                    }
                ];
                vm.showToast({ class: "warning", message: "Es requerido un criterio para la suspensión del proceso.", showClose: true }, optionsToast);
                return;
            }


            var objPost = {
                proceso_id: vm.idRequest,
                criterio_suspension_id: vm.data.suspension.id,
                observaciones: vm.data.observation,
                publicado: vm.data.publicado ? vm.data.publicado.id : 0
            }

            analystService.saveSuspensionRequest(objPost, function (resolve) {
                if (resolve.data.status) {
                    vm.modelRequest(resolve.data.data.proceso);
                    vm.modelsuspensiones(resolve.data.data.supensiones);
                    var optionsToast = [
                        /*{
                            title: "Deshacer",
                            callback: vm.activarRequest
                        }*/
                    ];
                    vm.showToast({ class: "success", message: "El proceso se ha suspendido exitosamente.", showClose: true }, optionsToast);
                    vm.data = {};
                } else {
                    var optionsToast = [];
                    vm.showToast({ class: "error", message: resolve.data.message, showClose: true }, optionsToast);
                }

            }, function (reject) {
                var optionsToast = [
                    {
                        title: "Volver a intentar",
                        callback: vm.showModalSuspension
                    }
                ];
                vm.showToast({ class: "error", message: reject.data.message, showClose: true }, optionsToast);
            });
        }


        vm.activarRequest = function () {
            var objPost = {
                proceso_id: vm.idRequest
            }
            var functionActivar = (vm.user.group_id == 1) ? AdminService.activarRequest : analystService.activarRequest;
            functionActivar(objPost, function (resolve) {
                if (resolve.data.status) {
                    vm.modelsuspensiones(resolve.data.data.supensiones);
                    vm.modelRequest(resolve.data.data.proceso);
                    var optionsToast = [
                        /*{
                            title: "Deshacer",
                            callback: vm.showModalSuspension
                        }*/
                    ];
                    vm.showToast({ class: "success", message: "El proceso se ha activado exitosamente.", showClose: true }, optionsToast);
                } else {
                    var optionsToast = [];
                    vm.showToast({ class: "error", message: resolve.data.message, showClose: true }, optionsToast);
                }

            }, function (reject) {

                var optionsToast = [];
                vm.showToast({ class: "error", message: reject.data.message, showClose: true }, optionsToast);
            });
        }

        vm.showToast = function (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        vm.getSuspensionRequest();

        /*****************************
         ***        HEADER         ***   
         *****************************/

        vm.openShowRequestNotesDialog = function () {
            $mdDialog.show({
                controller: 'ShowRequestNotesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-request-notes.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request,
                    callbackSuccess: vm.addNoteRequest
                }
            });
        }

        vm.addNoteRequest = function (data) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.observacion = data.note;
            data.note = '';
            analystService.addNoteRequest(dataPost, function (response) {
                var newNota = {};
                newNota.name = AuthService.getUserData().name;
                newNota.id = response.data.result.id;
                newNota.date_create_note = analystMisc.misc.setFormatDate(response.data.result.created_at, { format: 'MMM D, YYYY H:mm ' });
                newNota.note = response.data.result.descripcion;
                newNota.newNote = true;
                vm.request.notes.unshift(newNota);
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error creando la nota del proceso, por favor intente de nuevo.");
            });
        }

        vm.showModalEditOffer = function () {
            $mdDialog.show({
                controller: 'changeDatePublicController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/change_date_public_request/change_date_public_request.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            });
        }

        vm.showFinishProcess = function () {
            $mdDialog.show({
                controller: 'finishRequestDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/finish_process/finish_process.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            }).then(function (resolve) {
                vm.modelRequest(resolve.data.data.proceso);
                vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
            });
        }

        vm.selectProject = function (project) {
            $state.go(project.url, { request_id: vm.idRequest });
        }

        vm.publishRequest = function () {
            $state.go('app.publish_request', { request_id: vm.idRequest });
        }
        //SIDENAV
        vm.toggleSidenav = function (sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };
    }
})();
(function () {
  'use strict';
  angular.module('app.seleccion_analyst').controller('shareRequest', shareRequest);

  function shareRequest(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService, $mdSidenav, DTColumnDefBuilder, $filter, $mdToast) {
    //contoller
    var vm = this;

    vm.loading = true;

    //PARAMS
    vm.idRequest = $state.params.request_id;

    vm.request = {};

    vm.projectName = analystConstant.DEFAULT.DATA.HEADER.KEYSDETAILREQUEST.SHARE;

    //Informacion de la pagina
    vm.project = vm.selectedProject = analystMisc.header.getProject(vm.projectName);

    //projects
    vm.projects = analystMisc.header.getHeaderProjects();
    //MISCELANEOS
    vm.misc = {};
    //MISC texto para reemplazar
    vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

    vm.pageInfo = analystConstant.PAGESINFO.SHAREREQUEST;

    //ARRAY EXAMPLE PARA PRUEBAS
    vm.misc.analysts = [];

    vm.dtOptions = {
      dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
      language: IkanoFactory.getLanguajeDataTable(),
      autoWidth: false,
      iDisplayLength: 20,
      responsive: true,
      searching: false
    };

    vm.dtColumnDefs = [
      DTColumnDefBuilder.newColumnDef(3).notSortable(),
      DTColumnDefBuilder.newColumnDef(4).notSortable(),
      DTColumnDefBuilder.newColumnDef(5).notSortable(),
    ];

    vm.getShareRequest = function () {
      analystService.getShareRequest({ proceso_id: vm.idRequest }, function (response) {
        vm.loading = false;
        switch (response.status) {
          case analystConstant.CODEPETITION.OK:
            vm.mergeAnalystPermission(response.data.data);
            vm.modelRequest(response.data.proceso);
            break;

          case analystConstant.CODEPETITION.NOTFOUND:
            IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la informacion solicitada, por favor intente de nuevo.");
            break;
        }
      }, function (reject) {
        IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la informacion solicitada, por favor intente de nuevo.");
      });
    };

    vm.postShareRequest = function (arrAnalystPermission) {
      vm.loading = true;
      var objPost = { "proceso_id": vm.idRequest, "data": arrAnalystPermission };
      analystService.postShareRequest(objPost, function (response) {
        vm.loading = false;
      }, function (reject) {
        IkanoFactory.showAlert("Error", "Ha ocurrido un error compartiendo el proceso, por favor intente de nuevo.");
      });
    }

    vm.modelRequest = function (request) {
      var baseJson = analystConstant.KEYJSONREQUEST;
      analystMisc.modeldata(request, baseJson, { createIfNotExist: true })
        .then(function (resolve) {
          vm.request = resolve;
          analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
            vm.request.notes = resolve;
          });
        })
        .catch(function (reject) {
          console.error(reject);
        });
    }

    vm.mergeAnalystPermission = function (data) {
      var arrAnalyst = data.analistas;
      var arrPermissions = Object.values(data.permisos);
      var arrReturn = [];
      for (var i in arrAnalyst) {
        arrReturn.push(Object.assign(arrAnalyst[i], vm.assingPermission(arrAnalyst[i].id, arrPermissions)));
      }
      vm.misc.analysts = $filter('orderBy')(arrReturn, 'name');
      vm.loading = false;
    }

    vm.assingPermission = function (idSearch, arrPermissions) {
      var baseJson = {
        analista_id: null,
        prm_aprobar: null,
        prm_enviar_cliente: null,
        prm_suspender: null,
        proceso_id: vm.idRequest
      }
      if (arrPermissions.length > 0) {
        for (var j in arrPermissions) {
          if (idSearch == arrPermissions[j].analista_id) {
            delete (arrPermissions[j].id);
            baseJson = arrPermissions[j];
            continue;
          }
        }
      }
      return baseJson;
    }

    vm.dataSerielizate = function () {
      var arrAnalystPermission = [];
      var baseJson = { analista_id: "analista_id", prm_aprobar: "prm_aprobar", prm_enviar_cliente: "prm_enviar_cliente", prm_suspender: "prm_suspender", proceso_id: "proceso_id" };
      for (var i in vm.misc.analysts) {
        if (vm.misc.analysts[i].prm_suspender || vm.misc.analysts[i].prm_aprobar || vm.misc.analysts[i].prm_enviar_cliente) {
          vm.misc.analysts[i].analista_id = vm.misc.analysts[i].id;
          arrAnalystPermission.push(vm.misc.analysts[i]);
        }
      }
      analystMisc.modeldataarray(arrAnalystPermission, baseJson).then(function (resolve) {
        vm.postShareRequest(resolve);
      });
    }

    vm.getShareRequest();

    //HEADER
    vm.openShowRequestNotesDialog = function () {
      $mdDialog.show({
        controller: 'ShowRequestNotesController',
        controllerAs: 'vm',
        templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-request-notes.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: {
          request: vm.request,
          callbackSuccess: vm.addNoteRequest
        }
      });
    }

    vm.addNoteRequest = function (data) {
      var dataPost = {};
      dataPost.proceso_id = vm.idRequest;
      dataPost.observacion = data.note;
      data.note = '';
      analystService.addNoteRequest(dataPost, function (response) {
        var newNota = {};
        newNota.name = AuthService.getUserData().name;
        newNota.id = response.data.result.id;
        newNota.date_create_note = analystMisc.misc.setFormatDate(response.data.result.created_at, { format: 'MMM D, YYYY H:mm ' });
        newNota.note = response.data.result.descripcion;
        newNota.newNote = true;
        vm.request.notes.unshift(newNota);
      }, function (reject) {
        IkanoFactory.showAlert("Error", "Ha ocurrido un error creando la nota del proceso, por favor intente de nuevo.");
      });
    }

    vm.showModalEditOffer = function () {
      $mdDialog.show({
        controller: 'changeDatePublicController',
        controllerAs: 'vm',
        templateUrl: 'app/main/analyst/partials/change_date_public_request/change_date_public_request.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: {
          request: vm.request
        }
      });
    }
    vm.showFinishProcess = function () {
      $mdDialog.show({
        controller: 'finishRequestDialog',
        controllerAs: 'vm',
        templateUrl: 'app/main/analyst/partials/finish_process/finish_process.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: {
          request: vm.request
        }
      }).then(function (resolve) {
        vm.modelRequest(resolve.data.data.proceso);
        vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
      });
    }

    vm.showToast = function (data, options) {

      options = (options) ? options : [];

      $mdToast.show({
        hideDelay: 7000,
        position: 'top right',
        controller: 'ToastCrl',
        controllerAs: 'vm',
        templateUrl: 'app/toast/template/toast.default.html',
        locals: {
          options: options,
          config: data,
        },
        toastClass: data.class
      });
    }

    vm.selectProject = function (project) {
      $state.go(project.url, { request_id: vm.idRequest });
    }

    vm.publishRequest = function () {
      $state.go('app.publish_request', { request_id: vm.idRequest });
    }
    //SIDENAV
    vm.toggleSidenav = function (sidenavId) {
      $mdSidenav(sidenavId).toggle();
    };

  }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('sendCandidateApplicant', sendCandidateApplicant);

    function sendCandidateApplicant(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService,$mdSidenav,$filter,$mdToast) {

        //contoller
        var vm = this;

        //PARAMS
        vm.idRequest = $state.params.request_id;

        vm.request = {};

        vm.projectName = analystConstant.DEFAULT.DATA.HEADER.KEYSDETAILREQUEST.SENDCANDIDATE;

        vm.loading = true;
        //Informacion de la pagina
        vm.project = vm.selectedProject = analystMisc.header.getProject(vm.projectName);

        //projects
        vm.projects = analystMisc.header.getHeaderProjects();
        //MISCELANEOS
        vm.misc = {};
        //MISC texto para reemplazar
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

        vm.pageInfo = analystConstant.PAGESINFO.SENDCANDIDATE;

        vm.misc.candidate = [];

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            pagingType: 'simple',
            autoWidth: false, 
            iDisplayLength: 20,
            searching: false
        };

        vm.candidateBaseJson = {
            id: "id",
            name: "name",
            city: "city",
            edad: "age",
            last_send: { key: "last_send", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
            stage: "stage",
            stateReview: "stateReview",
            colorStateReview: "colorStateReview"
        };

        //CANDIDATE SELECTED

        vm.getCandidateApplicant = function () {
            analystService.getCandidateRevision({ proceso_id: vm.idRequest }, function (response) {
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        vm.modelCandidate(response.data.candidatos);
                        vm.modelRequest(response.data.proceso);
                        break;
                }
            },
            function(reject){
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la informacion de los candidatos, por favor intente de nuevo.");
            });
        };

        vm.modelCandidate = function (candidates) {
            var misc = [];
            for(var i in candidates){
                candidates[i].candidato.idCandidato = candidates[i].candidato.id;
                candidates[i].proceso_candidato.idProcesoCandidato = candidates[i].proceso_candidato.id;
                delete(candidates[i].candidato.id);
                delete(candidates[i].proceso_candidato.id);
                misc.push(Object.assign(candidates[i].candidato,candidates[i].proceso_candidato));
            }         
            var data = angular.copy(misc);
            var baseJson = {
                idCandidato:"idCandidato",
                idProcesoCandidato:"idProcesoCandidato",
                nombre:"name",
                ciudad:"city",
                edad:"age",
                etapa:{key:"stage",callback:"getOneKey",dataCallback:{getKey:"name"}},
                correo:"stateReview",
                fecha_enviado_cliente : { key: "last_send", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                send_cliente:"send_cliente"
            };
            analystMisc.modeldataarray(data, baseJson)
                .then(function (resolve) {
                    vm.loading = false;
                    vm.misc.candidate = $filter('orderBy')(resolve,'name');
                });
        }

        vm.modelRequest = function (data) {
            var baseJson = analystConstant.KEYJSONREQUEST;
            analystMisc.modeldata(data, baseJson,{createIfNotExist:true})
                .then(function (resolve) {
                    vm.request = resolve;
                    analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
                        vm.request.notes = resolve;
                    });
                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }

        vm.sendCandidateSelecteds = function (){
            var objPost = {};
            objPost.proceso_id = vm.idRequest;
            objPost.candidatos = [];
            for(var i in vm.misc.candidate){
                if(vm.misc.candidate[i].isSelected){
                    objPost.candidatos.push({proceso_candidato_id:vm.misc.candidate[i].idProcesoCandidato,hoja_vida_id:vm.misc.candidate[i].idCandidato});
                }
            }
            analystService.sendCandidateApplicant(objPost,function(resolve){
                vm.modelCandidate(resolve.data.candidatos);
            },function(reject){
                IkanoFactory.showAlert("Error", "Ha ocurrido un error enviando los candidatos al solicitante, por favor intente de nuevo.");
            });
        }

        vm.sendCandidateSelected = function (candidate){
            var objPost = {};
            objPost.proceso_id = vm.idRequest;
            objPost.candidatos = [{proceso_candidato_id:candidate.idProcesoCandidato,hoja_vida_id:candidate.idCandidato}];
            analystService.sendCandidateApplicant(objPost,function(resolve){
                vm.modelCandidate(resolve.data.candidatos);
            },function(reject){
                IkanoFactory.showAlert("Error", "Ha ocurrido un error enviando los candidatos al solicitante, por favor intente de nuevo.");
            });
        }

        vm.getCandidateApplicant();

        //HEADER
        vm.openShowRequestNotesDialog = function () {
            $mdDialog.show({
                controller: 'ShowRequestNotesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-request-notes.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request,
                    callbackSuccess: vm.addNoteRequest
                }
            });
        }

        vm.addNoteRequest = function (data) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.observacion = data.note;
            data.note = '';
            analystService.addNoteRequest(dataPost, function (response) {
                var newNota = {};
                newNota.name = AuthService.getUserData().name;
                newNota.id = response.data.result.id;
                newNota.date_create_note = analystMisc.misc.setFormatDate(response.data.result.created_at, { format: 'MMM D, YYYY H:mm ' });
                newNota.note = response.data.result.descripcion;
                newNota.newNote = true;
                vm.request.notes.unshift(newNota);
            },function(reject){
                IkanoFactory.showAlert("Error", "Ha ocurrido un error creando la nota del proceso, por favor intente de nuevo.");
            });
        }

        vm.selectProject = function (project) {
            $state.go(project.url, { request_id: vm.idRequest });
        }
        vm.publishRequest = function (){
            $state.go('app.publish_request',{ request_id: vm.idRequest });
        }
        vm.showModalEditOffer = function () {
            $mdDialog.show({
                controller: 'changeDatePublicController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/change_date_public_request/change_date_public_request.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            });
        }

        vm.showFinishProcess = function(){
            $mdDialog.show({
                controller: 'finishRequestDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/finish_process/finish_process.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            }).then(function(resolve){
                vm.modelRequest(resolve.data.data.proceso);
                vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
            });
        }

        vm.showToast = function (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        //SIDENAV
        vm.toggleSidenav = function (sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('reportsAnalyst', reportsAnalyst);

    function reportsAnalyst($mdDialog, AdminService, IkanoFactory, analystConstant, analystService, $q, $filter, $state, $scope, paginationService, analystMisc, $compile) {
        //Le asignamos un alias al controlador
        var vm = this;

        // informacion que aparece en el Header
        vm.reports = analystMisc.header.getHeaderReports();

        vm.reportName = analystConstant.REPORTS.HEADER.KEYSREPORTS.REQUEST;
        vm.report = vm.selectedReport = analystMisc.header.getReport(vm.reportName);

        // informacion que aparece en el Header
        vm.pageInfo = {
            icon: "icon-home",
            parents: ['REPORTES'],
            title: "REPORTE",
        };

        vm.filter = {};

        vm.filter.fecha_creacion = [null, null];

        vm.pager = {};

        vm.limit = 12;

        //DATATABLE
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            iDisplayLength: 20,
            responsive: true,
            paging: false,
            info: false,
            sorting: false,
            searching: false
        };

        //BACKUP
        vm.backup = {};

        //CONTROLLER - VIEW
        vm.clearFilter = function () {
            vm.filter = {};
            vm.filter.fecha_creacion = [null, null];
        }

        vm.search = function () {
            var filter = angular.copy(vm.filter);
            if (filter.fecha_creacion[0] == null) {
                delete (filter.fecha_creacion);
            }
            getReport({
                filtros: filter,
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            });
        }

        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.pagination.total_rows, page, vm.limit);
            if (!noConsult) {
                var filter = {
                    filtros: vm.backup.filtros, pagination: {
                        page: page,
                        limit: vm.limit
                    }
                };
                getReport(filter);
            }
            setTimeout(function () {
                createPagination();
            }, 1000);
        }

        //ONLY CONTROLLER
        function getReport(data) {
            analystService.getReport('getRequestReport', data, function (response) {
                vm.backup.filtros = data.filtros;
                if (response.data.status) {
                    modelRows(response.data.data.data.data);
                    modelFilter(response.data.data.filters);
                    modelHeader(response.data.data.data.headers);
                    modelPagination(response.data.pagination);
                } else {
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }
            },
                function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la informacion de los candidatos, por favor intente de nuevo.");
                });
        }

        function modelRows(data) {
            /*var baseJson = {
                "fecha_creacion": { key: "fecha_creacion", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } }
            };
            analystMisc.modeldataarray(data, baseJson, { createIfNotExist: true }).then(function (resolve) {
                vm.rows = resolve;
            });*/
            vm.rows = data;
        }

        function modelFilter(data) {
            for (var i in data) {
                if (!angular.isArray(data[i].list)) {
                    var arr = [];
                    angular.forEach(data[i].list, function (v, index) {
                        arr.push({ id: index, name: v });
                    });
                    data[i].list = arr;
                }
            }
            vm.filters = data;
        }

        function modelHeader(header) {
            vm.header = header;
        }
        
        function modelPagination(filterPage) {
            vm.pagination = filterPage;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        function createPagination() {
            var elemt = $('.right');
            var template = '';
            //elemt.appendTo('<div class="paginations"></div>');
            if (vm.pagination.total_rows) {
                template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}}, {{vm.pagination.total_rows}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div></div>';
            }

            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        function setJsonToArray(list) {
            return angular.forEach(list, function (index, v) {
                return [{ id: index, value: v }];
            });
        }

        getReport({
            filtros: {},
            pagination: {
                page: 1,
                limit: vm.limit
            }
        });

    }
})();
(function () {

    'use strict';

    angular.module('app.seleccion_analyst').controller('publishRequest', publishRequest);

    function publishRequest(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService, $mdSidenav, $filter, $mdToast, $mdColors) {
        //contoller
        var vm = this;

        //PARAMS
        vm.idRequest = $state.params.request_id;

        vm.request = {};

        vm.projectName = analystConstant.DEFAULT.DATA.HEADER.KEYSDETAILREQUEST.PUBLISH;

        vm.loading = true;
        //Informacion de la pagina
        vm.project = vm.selectedProject = analystMisc.header.getProject(vm.projectName);

        //projects
        vm.projects = analystMisc.header.getHeaderProjects();
        //MISCELANEOS
        vm.misc = {};
        //MISC texto para reemplazar
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;


        vm.misc.tomorrow = new Date(moment().add(1, 'days'));

        vm.pageInfo = analystConstant.PAGESINFO.PUBLISHREQUEST;

        vm.validationService = ValidationService;

        //DATA
        vm.dataPost = {};
        vm.dataPost.share = false;
        vm.dataPost.public_empleo = false;

        //ERROR
        vm.misc.error = {};
        vm.misc.error.dataEnd = false;

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        //TABLE
        vm.dtOptions = {
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            iDisplayLength: 20,
            responsive: true,
            order: [0, "desc"],
            paging: false,
            searching: false,
            info: false
        };

        //LABEL
        vm.blockGrid = {
            model: 'procesos_conocimientos_experiencias'
        }

        //THEME
        vm.theme = IkanoFactory.getThemeData();

        vm.getPublicRequest = function () {
            analystService.getPublicRequest({ proceso_id: vm.idRequest }, function (response) {
                vm.loading = false;
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:

                        vm.modelUnderstanding(response.data.requisicion);
                        vm.modelRequest(response.data.proceso);
                        vm.modelLinkShare(response.data.links_compartir);
                        vm.modelCommunities(response.data.communities);
                        vm.hide_bloque_other_medios = response.data.ocultar_bloque_otros_medios;
                        //vm.modelOptions(response.data.opciones);
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información de la oferta, por favor intente de nuevo.");
            });
        }
        //MODELS
        vm.modelUnderstanding = function (data, bloque_send) {
            vm.data = angular.copy(data);
            var bloque = bloque_send || null;

            vm.copyDataByBlock(vm.data.data, bloque)

            vm.lists = vm.data.listas;
            //vm.fields = vm.data.estructura_campos;
            vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
            vm.extra = vm.data.extra;
            vm.observations = vm.data.observaciones;
            vm.setPageData();
            vm.setValuesWatch();
            vm.change = false;
            vm.setBlocks();
            //vm.getPositionColaborators(vm.values.cargo_id);
            ValidationService.generalFunctions($scope, vm);
        }

        vm.copyDataByBlock = function(data, bloque_send){
            var bloque = bloque_send || null;

            if (bloque === null){
                vm.values = data;
                return true;
            }
            
            var campos_copiar = []
            $.map(vm.data.bloques, function (value, index) {
                if(index == bloque) {campos_copiar = value.campos }
            });

            $.map(campos_copiar, function (value) {
                vm.values[value] = data[value]
            });

            return true;
        }

        vm.modelRequest = function (request) {
            var baseJson = analystConstant.KEYJSONREQUEST;
            analystMisc.modeldata(request, baseJson, { createIfNotExist: true })
                .then(function (resolve) {
                    vm.request = resolve;
                    if (vm.request.date_publish_close) {
                        vm.dataPost.dateEnd = moment(vm.request.date_publish_closeBackup).toDate();
                    } else {
                        vm.dataPost.dateEnd = null;
                    }
                    analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
                        vm.request.notes = resolve;
                    });
                });

        }

        vm.modelLinkShare = function (links) {
            vm.links = angular.copy(links);
            vm.linkPublish = vm.sanetizeUrl(vm.links.facebook);
        }

        vm.modelCommunities = function (communities) {
            vm.communities = angular.copy(communities);
        }

        //BLOQUES
        vm.setPageData = function () {
            vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
            vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
            if (vm.data.data.no_vacantes) {
                var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
                vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
            }

            vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
            if (vm.data.data.tipo_solicitud_b_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
            }
            if (vm.data.data.tipo_solicitud_c_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
            }
        };

        vm.setValuesWatch = function () {
            ValidationService.setWarchers($scope, vm);
        };

        vm.setBlocks = function () {
            vm.blocks = $.map(vm.data.bloques, function (value, index) {
                return [vm.getBlock(index, value)];
            });
        };

        vm.getBlock = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.campos
            };

            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }

            return block;
        };


        vm.addModelToBlock = function (block) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            vm.values[block.model].push(model);
        }

        vm.removeModelToBlock = function (block, index) {
            vm.values[block.model].splice(index, 1);
        }

        vm.getPositionColaborators = function (position) {
            AdminService.getPositionColaborators({ cargo_id: position,proceso_id:vm.idRequest }, {},
                function (response) {
                    if (response.data.colaboradores) {
                        var colaboradores = response.data.colaboradores;
                        vm.lists.position_colaborators = IkanoFactory.setPositionsId(colaboradores, 'estructura_id');

                        //CAMBIAR ID DE INFO_OCUPANTE_ACTUAL POR ESTRUCTURA_ID
						var newInfo = [];
						for (var i in vm.values.info_ocupante_actual) {
							var ocupante = vm.values.info_ocupante_actual[i];
							if (colaboradores[ocupante]) {
								newInfo.push((colaboradores[ocupante].estructura_id ? colaboradores[ocupante].estructura_id : colaboradores[ocupante].id) + "");
							}
						}
                        vm.values.notChangeInfoActual = true;
                        vm.values.info_ocupante_actual = newInfo;
                        console.log(vm.values);
						vm.loadColaborators = true;
                    }
                },
                function (response) {
                    //IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };

        //SEARCH OFFER
        vm.searchOffer = function () {
            $mdDialog.show({
                controller: 'searchOfferDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/search_offer/search_offer.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    idRequest: vm.idRequest
                }
            }).then(function (resolve) {
                vm.modelUnderstanding(resolve, 'informacion_oferta');
            });
        }

        //SANETIZE URL
        vm.sanetizeUrl = function (url) {
            url = url.split("//");
            var host = url[1].split("/");
            return host[0];
        }

        //funcion para traer los candidatos

        /*vm.getRequest = function () {
            analystService.getCandidate({ proceso_id: vm.idRequest }, function (response) {
                vm.loading = false;
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        vm.modelRequest(response.data.get_proceso_analista.data.proceso);
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo los datos de los candidatos, por favor intente de nuevo.");
            });
        }*/

        //FUNCIONES DEL SISTEMA
        vm.toPostRequest = function () {
            var baseDataPost = {
                "dateEnd": "fecha_final",
                "share": "compartir",
                "public_empleo": "publicar_elempleo"
            };

            if (vm.request.approve_understanding.enviar_entendimiento_aprobacion == 1 && vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion != 'Aprobado') {
                //IkanoFactory.showAlert("Error", "El entendimiento del cargo debe estar aprobado para poder publicar la oferta, por favor intente de nuevo.");
                vm.showToast({ class: "error", message: "El entendimiento del cargo debe estar aprobado para poder publicar la oferta, por favor intente de nuevo.", showClose: true });
                return;
            }
            if (!vm.dataPost.dateEnd) {
                vm.misc.error.dataEnd = true;
                //IkanoFactory.showAlert("Error", "La oferta debe tener una fecha de finalización, por favor intente de nuevo.");
                vm.showToast({ class: "error", message: "La oferta debe tener una fecha de finalización, por favor intente de nuevo.", showClose: true });
                return;
            }

            var data = {};
            data.dateEnd = (vm.dataPost.dateEnd) ? moment(vm.dataPost.dateEnd).format('YYYY-MM-DD') : null;
            data.share = (vm.dataPost.share) ? 0 : 1;
            data.public_empleo = (vm.dataPost.public_empleo) ? 1 : 0;

            analystMisc.modeldata(data, baseDataPost)
                .then(function (resolve) {
                    analystService.postPublicRequest({ proceso_id: vm.idRequest, data: resolve }, function (response) {
                        if (response.data.status) {
                            var optionsToast = [
                                {
                                    title: "Retirar publicación",
                                    callback: vm.closeOffer
                                }
                            ];
                            //IkanoFactory.showAlert("Correcto", "La oferta se ha publicado correctamente.");
                            vm.showToast({ class: "success", message: response.data.message, showClose: true }, optionsToast);
                            vm.modelRequest(response.data.data.proceso);
                            /*vm.request.status_publish = response.data.data.proceso.estado_publicacion;
                            vm.request.color_status_publish = response.data.data.proceso.estado_publicacion_color;*/
                        } else {
                            vm.showToast({ class: "error", message: response.data.message, showClose: true }, optionsToast);
                        }

                    }, function (reject) {
                        IkanoFactory.showAlert("Error", reject.data.message);
                    });
                });


        }

        vm.save = function (type) {
            vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values, true);
            if (angular.equals(vm.errors, {})) {
                vm.errors = {};
                var data = {
                    id: vm.idRequest,
                    data: vm.values,
                    oferta: 1
                };
                vm.change = false;
                vm.saving = true;
                analystService.saveRequestAnalyst(data,
                    function (response) {
                        vm.saving = false;
                        vm.change = true;
                        if (response.data.status) {
                            if (type == 2) {
                                vm.toPostRequest();
                            } else {
                                //IkanoFactory.showAlert("Correcto", "La información diligenciada se guardo de manera exitosa.");
                                vm.showToast({ class: "success", message: response.data.message, showClose: true });
                            }
                        } else {
                            vm.showToast({ class: "error", message: response.data.message, showClose: true });
                        }

                    },
                    function (reject) {
                        IkanoFactory.showAlert("Error", reject.data.message);
                        vm.saving = false;
                        vm.change = true;
                    }
                );
            } else {
                IkanoFactory.showAlert("Error", "La información de la oferta se encuentra incompleta, por favor intente de nuevo.");
            }
        };

        vm.saveBlock = function (block) {
            vm.errors = IkanoFactory.validateFieldsWithObject(block.fields, vm.values, true);
            if (angular.equals(vm.errors, {})) {
                var value = IkanoFactory.getValueWithFields(block.fields, vm.values);
                vm.errors = {};
                var data = {
                    id: vm.idRequest,
                    data: value,
                    oferta: 1
                };
                vm.change = false;
                vm.saving = true;
                analystService.saveRequestAnalyst(data,
                    function (response) {
                        vm.saving = false;
                        vm.change = true;
                        if (response.data.status) {
                            vm.showToast({ class: "success", message: response.data.message, showClose: true });
                        } else {
                            vm.showToast({ class: "error", message: response.data.message, showClose: true });
                        }

                    },
                    function (reject) {
                        IkanoFactory.showAlert("Error", reject.data.message);
                        vm.saving = false;
                        vm.change = true;
                    }
                );
            } else {
                IkanoFactory.showAlert("Error", "La información del bloque esta incompleta, por favor intente de nuevo.");
            }
        }

        vm.showToast = function (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        vm.closeOffer = function () {
            analystService.closeOffer({ proceso_id: vm.idRequest }, function (response) {
                if (response.data.status) {
                    var optionsToast = [
                        /* {
                             title:"Volver a publicar",
                             callback:vm.toPostRequest
                         }*/
                    ];
                    //IkanoFactory.showAlert("Correcto", "La oferta se ha publicado correctamente.");
                    vm.showToast({ class: "success", message: response.data.message, showClose: true }, optionsToast);
                    vm.modelRequest(response.data.data.proceso);
                    /*vm.request.status_publish = response.data.data.proceso.estado_publicacion;
                    vm.request.color_status_publish = response.data.data.proceso.estado_publicacion_color;*/
                } else {
                    vm.showToast({ class: "error", message: response.data.message, showClose: true }, optionsToast);
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.changeDateOffer = function () {
            var data = {};

            data.proceso_id = vm.idRequest;

            if (vm.dataPost.dateEnd) {
                data.fecha_final = moment(vm.dataPost.dateEnd).format('YYYY-MM-DD');;
            } else {
                vm.misc.error.dataEnd = true;
                return;
            }

            analystService.changeDateEndOffer(data,
                function (response) {
                    if (response.data.status) {
                        var dateNewTales = analystMisc.misc.serializeDate(vm.dataPost.dateEnd,{ serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } });
                        vm.request.date_publish_close = dateNewTales;
                        vm.showToast({ class: "success", message: response.data.message, showClose: true }, []);
                    } else {
                        vm.showToast({ class: "error", message: response.data.message, showClose: true }, []);
                    }
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error enviando la información de cierre de publicación, por favor intente de nuevo.");
                }
            );
        }

        vm.getPublicRequest();

        //HEADER
        vm.showModalEditOffer = function () {
            $mdDialog.show({
                controller: 'changeDatePublicController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/change_date_public_request/change_date_public_request.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            });
        }
        vm.openShowRequestNotesDialog = function () {
            $mdDialog.show({
                controller: 'ShowRequestNotesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-request-notes.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request,
                    callbackSuccess: vm.addNoteRequest
                }
            });
        }

        vm.showFinishProcess = function () {
            $mdDialog.show({
                controller: 'finishRequestDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/finish_process/finish_process.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            }).then(function (resolve) {
                vm.modelRequest(resolve.data.data.proceso);
                vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
            });
        }

        vm.addNoteRequest = function (data) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.observacion = data.note;
            data.note = '';
            analystService.addNoteRequest(dataPost, function (response) {
                var newNota = {};
                newNota.name = AuthService.getUserData().name;
                newNota.id = response.data.result.id;
                newNota.date_create_note = analystMisc.misc.setFormatDate(response.data.result.created_at, { format: 'MMM D, YYYY H:mm ' });
                newNota.note = response.data.result.descripcion;
                newNota.newNote = true;
                vm.request.notes.unshift(newNota);
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error creando la nota del proceso, por favor intente de nuevo.");
            });
        }

        vm.selectProject = function (project) {
            $state.go(project.url, { request_id: vm.idRequest });
        }

        //SIDENAV
        vm.toggleSidenav = function (sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };

    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('historyRequest', historyRequest);

    function historyRequest(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService, $mdSidenav, $filter, $mdToast, $mdColors) {

        //constructor
        var vm = this;

        //VARAIBLES CONTROLLER
        vm.idRequest = $state.params.request_id;

        vm.projectName = analystConstant.DEFAULT.DATA.HEADER.KEYSDETAILREQUEST.HISTORY;
        vm.project = vm.selectedProject = analystMisc.header.getProject(vm.projectName);

        vm.misc = {};
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;
 
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            language: IkanoFactory.getLanguajeDataTable(),
            autoWidth: false,
            iDisplayLength: 20,
            responsive: true,
            paging: false,
            info: false,
            sorting: false,
            searching: false
        };

        vm.user = AuthService.getUserData();

        //FUNCIONES VIEW - CONTROLLER

        vm.showDetail = function (history) {
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: 'app/main/analyst/partials/history-request/history-request.html',
                controller: 'historyRequestDialog',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    history: history
                }
            });
        }

        //FUNCIONES CONTROLLER

        function getRequest() {
            if (vm.user.group_id == 1) {
                AdminService.getRequestAdminSeleccion({ proceso_id: vm.idRequest }, function (response) {

                    switch (response.status) {
                        case analystConstant.CODEPETITION.OK:
                            modelRequest(response.data.proceso);
                            getHistory(vm.idRequest);
                            break;

                        case analystConstant.CODEPETITION.NOTFOUND:
                            IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada. por favor intente de nuevo.");
                            break;
                    }
                }, function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada. por favor intente de nuevo.");
                });
            } else {
                analystService.getRequest({ proceso_id: vm.idRequest }, function (response) {
                    if (response.data.get_proceso_analista.data.proceso) {
                        modelRequest(response.data.get_proceso_analista.data.proceso);
                        getHistory(vm.idRequest);
                    } else {
                        showToast({ class: "error", message: response.data.message, showClose: true });
                    }

                }, function (reject) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información de la oferta, por favor intente de nuevo.");
                });
            }
        }

        function getHistory(idRequest) {
            analystService.getHistoryRequest({ proceso_id: vm.idRequest }, function (response) {
                if (response.data.status) {
                    modelHistory(response.data.data);
                } else {
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }

            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información de la oferta, por favor intente de nuevo.");
            });
        }

        function modelRequest(request) {
            var baseJson = analystConstant.KEYJSONREQUEST;
            analystMisc.modeldata(request, baseJson)
                .then(function (resolve) {
                    vm.request = resolve;
                    analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
                        vm.request.notes = resolve;
                    });
                });
        }

        function modelHistory(request) {
            var baseJson = {
                created_at: { key: "date", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY  hh:mm A' } } },
                detail: { key: "detail", callback: "parsejson" },
                action: { key: "action", callback: "replacestr", dataCallback: { search: '_', replace: ' ' } },
            }
            analystMisc.modeldataarray(request, baseJson, { createIfNotExist: true })
                .then(function (resolve) {
                    vm.historys = resolve.sort(function (a, b) {
                        var momentDateA = moment(a.date.formatDate)
                        var momentDateB = moment(b.date.formatDate)

                        if (a.name > b.name) {
                            return 1;
                        }
                        if (a.name < b.name) {
                            return -1;
                        }
                        return 0;
                    });
                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }

        function showToast(data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        //INITIAL CALLBACK
        getRequest();
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('historyRequestCandidate', historyRequestCandidate);

    function historyRequestCandidate(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService, $mdSidenav, $filter, $mdToast, $mdColors) {

        //constructor
        var vm = this;

        //VARAIBLES CONTROLLER
        vm.idRequest = $state.params.request_id;
        vm.idCandidate = $state.params.hv;

        //FUNCTION VIEW - CONTROLLER

        vm.selectBlock = function(stage){
            var valueStage = (vm.historial_participacion.data[stage.id]) ? vm.historial_participacion.data[stage.id] : {};
            vm.blockAutoRellenar = [];
            vm.stageData = {};
            vm.stageData.data = {
                bloques: vm.historial_participacion.bloques[stage.etapa],
                data: valueStage,
                estructura_campos: vm.historial_participacion.estructura_campos,
                listas: vm.lists
            }

            vm.stageData.attachments = vm.blockStage.adjuntos;

            vm.stageData.extra = {
                etapa_id: stage.id,
                proceso_id: vm.idRequest,
                hv_id: vm.idCandidate
            }

            vm.stageData.getAttachmentUrl = vm.getAttachmentUrl;

            vm.stageData.values = vm.stageData.data.data;
            if (!angular.equals(vm.stageData.values, {})) {
                vm.misc.values = {};
                vm.misc.values.created_at = moment(vm.stageData.values.created_at).format('MMM D, YYYY hh:mm a');
                vm.misc.values.updated_at = moment(vm.stageData.values.updated_at).format('MMM D, YYYY hh:mm a');
                vm.misc.values.analista = angular.copy(vm.stageData.values.analista);
            } else {
                vm.misc.values = false;
            }


            vm.stageData.lists = vm.stageData.data.listas;

            vm.stageData.fields = vm.getFieldsEtapa(vm.stageData.data.estructura_campos, vm.stageData.data.bloques);
            if (vm.blockAutoRellenar.length > 0) {
                vm.stageData.values = vm.autoRellenarBloque(vm.stageData.data, vm.stageData.lists);
            }
            vm.backupValues = angular.copy(vm.stageData.values);
            vm.setBlocksStage(bloques);
            vm.setValuesWatch(vm.stageData);
        }

        //FUNCIONES CONTROLLER
        function getRequest() {
            analystService.getHistoryProcessCandidate({ proceso_id: vm.idRequest,hv_id:vm.idHv }, function (response) {

                if(!response.data.status){
                    IkanoFactory.showAlert("Error", response.data.message);
                }else{
                    //vm.stages = serializeBlockName(Object.keys(response.data.data.historial_participacion.bloques));
                    vm.historial_participacion = response.data.data.historial_participacion;
                    
                    getConfiguration();
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada. por favor intente de nuevo.");
            });
        }

        function getConfiguration () {
            analystService.getConfigurationCandidate({}, function (response) {
            
                var listLocalStorage = JSON.parse(localStorage.getItem('lists'));
                var lists = response.data.data;
                var listStage = lists.listas;
                delete (lists.listas);
                var listFisrt = analystMisc.misc.mergeJson(lists, listStage);
                vm.lists = analystMisc.misc.mergeJson(listFisrt, listLocalStorage);
                vm.stages = lists.etapas;
            }, function (reject) {
                console.log(reject);
            });
        }

        function setBlocksStage(bloques) {
            vm.blocks = $.map(bloques, function (value, index) {
                return [getBlockStage(index, value)];
            });
        };

        function getBlockStage(index, data) {
            var block = {
                id: null,
                name: index,
                model: (data.etapa == "informacion_seleccion" ? data.etapa : data.model),
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.campos,
                collapse: (data.etapa == 'pruebas'),
                hideCollapse: (data.etapa == 'pruebas'),
            };
            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }

            return block;
        };

        /*function serializeBlockName(stages){
            return stages.map(function(element){
                return {
                    id: element,
                    name: getNameSplit(element.split('_'))
                }
            });
        }

        function getNameSplit(arrName){
            var textReturn = "";
            for(var i in arrName){
                textReturn += (arrName[i] + ' ');
            }
            return textReturn;
        }*/


        //INITIAL CALLBACK
        getRequest();
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('candidateSimilar', candidateSimilar);

    function candidateSimilar(AuthService, AdminService, analystService, IkanoFactory, $mdDialog, $state, analystConstant, analystMisc, paginationService, $mdColors,$document,$mdToast,$rootScope) {
        var vm = this;

        // set ID de la request
        vm.idRequest = $state.params.request_id;

        vm.misc = {};

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        //objeto para el paginador
        vm.pager = {};

        //INIT
        $rootScope.$on('candidate::initProcessSimilar',function(evt,arg){
            vm.getCandidateSimilar({
                "page": 1,
                "limit": analystConstant.LIMITROW
            });
        });

        vm.getCandidateSimilar = function (pagination) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.pagination = pagination;

            analystService.getCandidateSimilar(dataPost, function (response) {
                vm.modelCandidate(response.data);
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.modelCandidate = function (data) {
            vm.candidates = [];
            vm.misc.candidates = [];
            var model = analystConstant.KEYJSONCANDIDATE.PRODUTION;
            model.modified = { key: "last_update", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } };
            model.updated_at = { key: "updated_at", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } };
            analystMisc.modeldataarray(data.candidates, model)
                .then(function (resolve) {
                    vm.candidates = resolve;
                    vm.modelPagination(data.pagination);
                    vm.misc.candidates = angular.copy(vm.candidates);
                });
        }

        vm.modelPagination = function (filterPage) {
            vm.pagination = filterPage;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }


        //Inicia el paginador
        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || page > vm.pager.totalPages) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.pagination.total_rows, page, analystConstant.LIMITROW);
            if (!noConsult) {

                vm.getCandidateSimilar({
                    page: page,
                    limit: analystConstant.LIMITROW
                });
            }
        }


        vm.showHV = function (candidate) {
            vm.candidateSelected = candidate;
            $mdDialog.show({
                controller: 'showHv',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/show_hv/show_hv.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    candidate: vm.candidateSelected,
                }
            });
        }

        
        vm.showToast = function (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        /**
         * CAMBIAR ESTADO PRESELECCIONADO
         */


        vm.preseleccionar = function (candidate) {
            var dataPost = {
                proceso_id: vm.idRequest,
                hoja_vida_id: candidate.id
            };

            analystService.preseleccionar(dataPost, function (response) {
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        if (response.data.status) {
                            candidate.stage = { id: 2 };
                            vm.showToast({ class: "success", message: response.data.message, showClose: true }, []);
                            $rootScope.$broadcast('update-count-candidate',{sum:true,count:1});
                            $rootScope.$broadcast('candidate::addCandidate',{candidate:candidate});
                            $rootScope.$broadcast('request::updateStatitics',{sum:true,candidate:1,noleido:candidate.view});
                        } else {
                            vm.showToast({ class: "error", message: response.data.message, showClose: true }, []);
                        }
                        break;
                    case analystConstant.CODEPETITION.NOTFOUND:
                        IkanoFactory.showAlert("Error", response.data.message);
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.retirarPreseleccionar = function (candidate) {
            var dataPost = {
                proceso_id: vm.request.id,
                hoja_vida_id: candidate.id
            };
            analystService.retirarPreseleccionar(dataPost, function (response) {
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        if (response.data.status) {
                            candidate.stage = {};
                            vm.showToast({ class: "success", message: response.data.message, showClose: true }, []);
                            $rootScope.$broadcast('update-count-candidate',{rest:true,count:1});
                            $rootScope.$broadcast('candidate::removeCandidate',{candidate:candidate});
                            $rootScope.$broadcast('request::updateStatitics',{rest:true,candidate:1,noleido:candidate.view});
                        } else {
                            vm.showToast({ class: "error", message: response.data.message, showClose: true }, []);
                        }
                        break;
                    case analystConstant.CODEPETITION.NOTFOUND:
                        IkanoFactory.showAlert("Error", response.data.message);
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('DetailAnalystIndexController', DetailAnalystIndexController);


    function DetailAnalystIndexController($mdDialog, AdminService, IkanoFactory, analystConstant, analystService, $q, $filter, $state, $mdSidenav, paginationService, $scope, api, $mdpTimePicker, $mdDateLocale, AuthService, analystMisc, $document, $rootScope, $mdColors, $mdToast, ListFilter) {
        //constructor 
        var vm = this;

        //se guardan todos los registro que llegaron de la base de datos se utiliza al momento que se limpian filtros
        vm.candidatesBackup = [];

        //en esta variable se guarda todos los candidatos que se utilizan actualmente (es posible que cambie constantemente ya sea por paginación o por filtros)
        vm.candidates = [];

        // set ID de la request
        vm.idRequest = $state.params.request_id;

        //SOCKET ANGULAR
        $rootScope.$on('setRequest', function (evt, arg) {
            vm.request = arg;
            if (typeof vm.request.lists != "undefined") {
                vm.request.lists.cargos_recomendados = vm.request.charges;
                vm.setMiscSelect(vm.request.lists);
            }
        });

        $rootScope.$on('candidate::changePagination', function (evt, arg) {
            vm.setPage(arg);
        });

        $rootScope.$on('candidate::addCandidate', function (evt, arg) {
            vm.candidates.unshift(arg.candidate);
            vm.candidatesBackup.unshift(arg.backup);
            vm.showListsCandidate();
        });

        $rootScope.$on('candidate::removeCandidate', function (evt, arg) {
            for (var i in vm.candidates) {
                if (arg.candidate.id == vm.candidates[i].id) {
                    vm.candidates.splice(i, 1);
                    vm.candidatesBackup.splice(i, 1);
                }
            }
            vm.showListsCandidate();
        });

        $rootScope.$on('candidate::changeStage', function (evt, arg) {
            vm.candidates[vm.indexSelected].stage = arg.stage;
        });

        $rootScope.$on('candidate::changeValueBlock', function (evt, arg) {
            vm.candidatesBackup[vm.indexSelected].bloques_etapas_candidato.data[arg.stage] = arg.data;
        });

        $rootScope.$on('candidate::recommend', function (evt, arg) {
            vm.candidates[vm.indexSelected].recomendaciones = arg;
            vm.candidatesBackup[vm.indexSelected].candidato.recomendaciones = arg;
            vm.candidates[vm.indexSelected].recommended = true;
            vm.candidatesBackup[vm.indexSelected].candidato.recommended = true;
        });

        $rootScope.$on('candidate-mark-view', function (evt, arg) {
            if (vm.candidates[vm.indexSelected].id == arg.candidate.id) {
                vm.candidates[vm.indexSelected].view = moment();

                $rootScope.$broadcast('request::updateStatitics', { rest: true, noleido: true });
            }
        });

        $rootScope.$on('candidate::updateCandidate', function (evt, arg) {
            angular.forEach(arg, function (key, val) {
                vm.candidates[vm.indexSelected][key] = val;
            });
        });

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        //MISCELANEOS
        vm.misc = {};

        //Backup
        vm.backup = {};

        vm.backup.filter = {};

        vm.modalFilterData = {};
        //LISTAS DE LUGARES DE CITA
        vm.misc.lists = {};
        //en esta variable se muestra en el paginador  (los datos que aparezcan en esta variable se toman de vm.candidates)
        vm.misc.candidates = [];

        //Pagination
        vm.pagination = {};
        vm.misc.loadPagination = false;

        //objeto para el paginador
        vm.pager = {};

        //Cantidad de registros
        vm.misc.countRow = null;

        //Hover del paginador
        vm.misc.hover = {};
        vm.misc.hover.backflash = false;
        vm.misc.hover.back = false;
        vm.misc.hover.afterflash = false;
        vm.misc.hover.after = false;

        //SE CREA UNA VARIABLE PARA SETEAR EL CANDIDATO QUE SE VA A AGREGAR UNA NOTA O AGREGAR UNA FECHA EN LA AGENDA
        vm.candidateSelected = {};

        vm.configCandidate = {
            showStage: true,
            showReportClient: true,
            showNote: true,
            showFavorite: true,
            showMarker: true,
            showCite: true,
            setView: true,
            getOtherProcess: true,
            importStage: true,
            showRecommendCandidate: true,
            showHistory: true,
        };


        //IMPORTAR CONTACTOS DEL EMPLEO
        vm.importCandidateElempleo = function () {
            analystService.importCandidateElempleo({ proceso_id: vm.idRequest }, function (resolve) {
                if (resolve.data.status) {
                    vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
                } else {
                    vm.showToast({ class: "error", message: resolve.data.message, showClose: true });
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            })
        }

        //SAVE MARKER
        vm.saveMarker = function (candidate) {
            candidate.loadingMarker = true;
            analystService.saveMarker({ mark: candidate.markerSelected, hoja_vida_id: candidate.id }, function (resolve) {
                candidate.loadingMarker = false;
                if (resolve.data.status) {
                    candidate.showMarker = false;
                    candidate.marker = resolve.data.mark ? 0 : angular.copy(candidate.markerSelected);
                    vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
                } else {
                    vm.showToast({ class: "error", message: resolve.data.message, showClose: true });
                }
            }, function (reject) {
                candidate.loadingMarker = false;
                IkanoFactory.showAlert("Error", reject.data.message);
            }, true);
        }

        //funcion para traer los candidatos
        vm.getCandidate = function () {
            analystService.getCandidate({ proceso_id: vm.idRequest }, function (response) {
                vm.loading = false;
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        $rootScope.$broadcast('setModelRequest', response.data.get_proceso_analista.data.proceso);
                        vm.getConfiguration();
                        vm.saveSearch({},
                            {
                                page: 1,
                                limit: analystConstant.LIMITROW
                            });
                        break;

                    case analystConstant.CODEPETITION.NOTFOUND:
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.getConfiguration = function () {
            analystService.getConfigurationCandidate({}, function (response) {
                vm.configuration = response.data;
                var listLocalStorage = JSON.parse(localStorage.getItem('lists'));
                var lists = response.data.data;
                var listStage = lists.listas;
                delete (lists.listas);
                var listFisrt = analystMisc.misc.mergeJson(lists, listStage);
                vm.lists = analystMisc.misc.mergeJson(listFisrt, listLocalStorage);
                $rootScope.$broadcast('listas', vm.lists);

            }, function (reject) {
                console.log(reject);
            });
        }

        vm.setMiscSelect = function (data, config) {
            vm.misc.lists.placeCita = data.lugares;
            vm.misc.lists.typeCita = data.tipos_cita;
            ListFilter.setLists(vm.request.lists);
        }

        //Inicia el paginador
        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.pagination.total_rows, page, analystConstant.LIMITROW);
            $rootScope.$broadcast('candidate::getPagination', vm.pager);
            if (!noConsult) {

                vm.saveSearch(vm.backup.filter, {
                    page: page,
                    limit: analystConstant.LIMITROW
                });
            }
        }

        //Modelamos la data de los candidatos
        vm.modelCandidate = function (data) {
            vm.showListsCandidate();
            vm.candidates = [];
            vm.misc.candidates = [];
            var modelCandidate = [];
            var model = analystConstant.KEYJSONCANDIDATE.PRODUTION;
            model.modified = { key: "last_update", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } };
            model.updated_at = { key: "updated_at", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } };
            vm.candidatesBackup = data.candidates;
            for (var i in data.candidates) {
                modelCandidate.push(data.candidates[i].candidato);
            }

            analystMisc.modeldataarray(modelCandidate, model, { save: true, model: 'candidates', key: 'id' })
                .then(function (resolve) {
                    vm.candidates = resolve;
                    $rootScope.$broadcast('candidatesFilter', true);
                    for (var i in vm.candidates) {
                        vm.candidates[i].cita = vm.setCita(vm.candidates[i].citaBackup);
                    }
                    $rootScope.$broadcast('candidate::getCandidates', vm.candidates);
                    vm.modelPagination(data.pagination);
                    vm.misc.candidates = angular.copy(vm.candidates);
                });

            $rootScope.$broadcast('set-candidate', { candidateCount: data.pagination.total_rows });
        }

        vm.modelPagination = function (filterPage) {
            vm.pagination = filterPage;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        vm.setModelNote = function (value) {
            value = (value) ? value : vm.misc.notesExample;
            var arrayReturn = [];
            if (!value.length) {
                return arrayReturn;
            }

            var baseJson = analystConstant.KEYJSONNOTE;
            value.map(function (va, ke) {
                var jsonInsert = {};
                angular.forEach(va, function (v, k) {
                    switch (typeof baseJson[k]) {
                        case "string":
                            jsonInsert[baseJson[k]] = v;
                            break;
                        case "object":
                            var config = baseJson[k];
                            jsonInsert[config.key] = vm[config.callback](v, config.dataCallback);
                            jsonInsert[config.key + 'Backup'] = v;
                            break;
                    }
                });
                arrayReturn.push(jsonInsert);
            });
            return arrayReturn;
        }

        //MODELAMOS LA DATA DE LA EXPERIENCIA POR CANDIDATO
        vm.getOneKey = function (data, config) {
            if (data == null || typeof data == "undefined") {
                return;
            }
            return data[config.getKey];
        }

        //Al momento que el puntero del mouse pase por encima del paginador se hace llamado a este metodo
        vm.setHover = function (key) {
            if (vm.misc.hover[key]) {
                vm.misc.hover[key] = false;
            } else {
                vm.misc.hover[key] = true;
            }
        }

        vm.sendNotificacion = function (candidate, index) {
            var data = {
                proceso_id: vm.idRequest,
                hoja_vida_id: candidate.id,
                proceso_candidato_id: vm.candidatesBackup[index].bloques_etapas_candidato.data[10].proceso_candidato_id
            }

            analystService.sendNotificacionDiscard(data, function (response) {
                if(response.data.status){
                    vm.candidatesBackup[index].bloques_etapas_candidato.data[10].fecha_envio_notificacion = response.data.data;
                }else{
                    IkanoFactory.showAlert("Error", response.data.message);
                }
                
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });

        }

        vm.addFavorite = function (candidate) {
            analystService.setFavorite({ hv_id: candidate.id }, function (response) {
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        if (candidate.favorite) {
                            candidate.favorite = false;
                        } else {
                            candidate.favorite = true;
                        }
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error marcando la hoja de vida como favorita, por favor intente de nuevo.");
            });
        }

        vm.addHvSpecial = function (candidate) {
            analystService.setSpecial({ hv_id: candidate.id }, function (response) {
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        if (candidate.special) {
                            candidate.special = false;
                        } else {
                            candidate.special = true;
                        }
                        break;
                    case analystConstant.CODEPETITION.NOTFOUND:
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, guardando la hoja de vida como especial por favor intente de nuevo.");
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error, guardando la hoja de vida como especial por favor intente de nuevo.");
            });
        }

        vm.setCita = function (value) {
            var objReturn = {};

            if (value.length == 0) {
                return objReturn;
            }

            objReturn.citas = analystMisc.misc.orderDates(value, 'fecha_hora', 'nameShow', 'MMM D, YYYY hh:mm A');
            objReturn.cita = analystMisc.misc.nextCita(objReturn.citas);
            return objReturn;
        }

        vm.addScheduleCandidate = function (data) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.hoja_vida_id = vm.candidateSelectedSchedule.id;
            var dateFinal = moment(data.dateSelected).format('YYYY-MM-DD');
            var hourFinal = moment(data.timeSelected).format('HH:mm:ss');
            dataPost.fecha_hora = moment(dateFinal + ' ' + hourFinal).format('YYYY-MM-DD HH:mm:ss');
            dataPost.lugar = data.placeSelected;
            dataPost.tipo_cita = data.typecitaSelected;
            analystService.addScheduleCandidate(dataPost, function (response) {
                vm.candidateSelectedSchedule.citaBackup.push(response.data.result);
                vm.candidateSelectedSchedule.cita = vm.setCita(vm.candidateSelectedSchedule.citaBackup);
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error agendando el candidato, por favor intente de nuevo.");
            });
        }


        vm.showModal = function (configModal) {
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: configModal.templateUrl,
                locals: {
                    config: configModal
                },
                controller: ControllerDialog
            });
        }

        function ControllerDialog($scope, $mdDialog, config) {
            $scope.data = config.data;
            $scope.showForm = false;
            $scope.config = config;
            $scope.candidate = config.dataCandidate;


            $scope.changeForm = function () {
                if ($scope.showForm) {
                    $scope.showForm = false;
                } else {
                    $scope.showForm = true;
                }
            }

            $scope.closeDialog = function () {
                $mdDialog.hide();
            }

        }

        $mdDateLocale.formatDate = function (date) {
            return date ? moment(date).format('MMM D, YYYY') : '';
        };


        vm.setScheduleCandidate = function (candidate) {
            var configModal = {};
            configModal.toolbar = {};
            configModal.toolbar.name = 'Agendar cita con el candidato';
            configModal.toolbar.class = {};
            configModal.data = candidate.cita.cita;
            configModal.citas = candidate.cita.citas;
            configModal.dataCandidate = candidate;
            configModal.lists = vm.misc.lists;
            vm.candidateSelectedSchedule = candidate;
            configModal.callbackSuccess = vm.addScheduleCandidate;

            configModal.templateUrl = 'app/main/analyst/partials/scheduled_citation/scheduled_citationDialog.html';

            vm.showModalScheduleCandidate(configModal);
        }

        vm.showModalScheduleCandidate = function (configModal) {
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: configModal.templateUrl,
                clickOutsideToClose: true,
                controller: 'scheduledCitationCandidateDialog',
                controllerAs: 'vm',
                locals: {
                    config: configModal
                }
            });
        }

        //CANITDAD DE CANDIDATOS
        vm.getCandidatesCount = function () {
            return vm.candidates.length;
        }

        vm.setCandidateInfo = function (value, config) {
            var jsonReturn = {};
            var baseJson = (analystConstant.DEBUG) ? analystConstant.KEYJSONREQUESTDEBUG : analystConstant.KEYJSONREQUEST;
            angular.forEach(value, function (vv, vk) {
                jsonReturn[baseJson[vk]] = vv;
            });
            return jsonReturn;
        }

        //Referido Candidate
        vm.setReferido = function (candidate) {
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: 'app/main/analyst/partials/referred_candidate/referred_candidate.html',
                clickOutsideToClose: true,
                controller: 'referredCandidateDialog',
                controllerAs: 'vm',
                locals: {
                    request: vm.request,
                    candidate: candidate
                }
            }).then(function (response) {
                if (response.data.status) {
                    candidate.referred = 1;
                    if (candidate.referredBy) {
                        candidate.referredBy.push(response.data.data);
                    } else {
                        candidate.referredBy = [];
                        candidate.referredBy.push(response.data.data);
                    }
                    vm.showToast({ class: "success", message: response.data.message, showClose: true }, []);
                } else {
                    vm.showToast({ class: "error", message: response.data.message, showClose: true }, []);
                }
            });
        }

        //Delete Referido Candidate
        vm.showDialogRemoveReferred = function (ev, candidate) {
            IkanoFactory.showConfirmAlert(ev, "¿Está seguro(a)?", "¿Desea remove el referido a  <strong>" + IkanoFactory.capitalize(candidate.name, true) + "</strong>?", candidate, vm.removeReferred);
        }

        vm.removeReferred = function (candidate) {
            var dataPost = {
                referido_id: candidate.referredBy[0].id,
            };

            analystService.removeReferredCandidate(dataPost, function (response) {
                if (response.data.status) {
                    candidate.referredBy = [];
                    candidate.referred = false;
                    vm.showToast({ class: "success", message: response.data.message, showClose: true }, []);
                } else {
                    vm.showToast({ class: "error", message: response.data.message, showClose: true }, []);
                }

            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            });
        }

        vm.deleteFilter = function (filter, indexFilter, indexChild) {

            ListFilter.deleteFilter(filter, indexFilter, indexChild, vm.misc.filter, vm.modalFilterData);
            vm.updateFilter();
        }

        vm.updateFilter = function () {
            var filter = {};
            var data = angular.copy(vm.misc.filter);
            for (var i in data) {
                filter[data[i].key] = data[i].value;
            }
            vm.page = 1;
            vm.saveSearch(filter, {
                page: 1,
                limit: analystConstant.LIMITROW
            });
        }

        vm.setFilter = function (filter) {
            vm.backup.filter = angular.copy(filter);
            vm.misc.filter = ListFilter.setFilter(filter);
        }

        vm.saveSearch = function (filter, pagination) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.filtros = filter;
            dataPost.pagination = pagination;

            analystService.searchCandidate(dataPost, function (response) {
                // vm.positions = response.data.cargos;
                // vm.stages = response.data.etapas;
                vm.configCandidate.stage_structure_fields = response.data.estructura_campos;
                vm.configCandidate.info_client_structure_fields = response.data.estructura_campos_informe_cliente;
                vm.modelCandidate(response.data);
                vm.backup.filter = filter;
                // vm.recomendaciones = {};
                // vm.recomendaciones.recomendaciones = response.data.recomendaciones ? response.data.recomendaciones : {};
                // vm.recomendaciones.footer = response.data.recomendaciones_footer ? response.data.recomendaciones_footer : '';
                // vm.recomendaciones.title = response.data.recomendaciones_title ? response.data.recomendaciones_title : '';

            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            });
        }

        //valido que me traiga un request de prueba siempre y cuando sea en DEBUG la contante
        //vm.getRequest();

        //ejecutamos la funcion que nos trae la informacion de los candidatos
        vm.getCandidate();

        vm.showToast = function (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        vm.goToCandidateDetail = function (candidate_id, index) {
            //$state.go('app.detail_seleccion_analyst.detail', { request_id: vm.idRequest, candidate_id: candidate_id });
            vm.candidateSelected = angular.copy(vm.candidates[index]);
            vm.candidateSelectedAll = vm.candidatesBackup[index];
            vm.candidateChanges = {};
            vm.indexSelected = index;
            vm.showDetailCandidate = true;
        };

        vm.showListsCandidate = function () {
            vm.indexSelected = null;
            vm.candidateSelected = null;
            vm.candidateSelectedAll = null;
            vm.showDetailCandidate = false;
            vm.candidateChanges = {};
        }

        vm.backCandidate = function () {
            vm.indexSelected = vm.indexSelected - 1;
            vm.candidateSelected = angular.copy(vm.candidates[vm.indexSelected]);
            vm.candidateSelectedAll = vm.candidatesBackup[vm.indexSelected];
            vm.candidateChanges = {};
        }

        vm.nextCandidate = function () {
            vm.indexSelected = vm.indexSelected + 1;
            vm.candidateSelected = angular.copy(vm.candidates[vm.indexSelected]);
            vm.candidateSelectedAll = vm.candidatesBackup[vm.indexSelected];
            vm.candidateChanges = {};
        }

        $scope.$watch('vm.candidateChanges', function (data) {
            if (data && data.id) {
                vm.candidates[vm.indexSelected] = data;
            }
        }, true);

        vm.openShowCandidateNotesDialog = function (data, indexCandidate) {
            if (data.notes.length > 0 && !data.notes[0].name) {
                vm.modelNotes(data.notes)
                    .then(function (resolve) {
                        data.notes = resolve;
                        $mdDialog.show({
                            controller: 'ShowCandidateNotesController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-candidate-notes.html',
                            parent: angular.element($document.body),
                            clickOutsideToClose: true,
                            locals: {
                                candidate: data,
                                request: vm.request,
                                title: "Notas " + data.name
                            }
                        });
                    });
            } else {
                $mdDialog.show({
                    controller: 'ShowCandidateNotesController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-candidate-notes.html',
                    parent: angular.element($document.body),
                    clickOutsideToClose: true,
                    locals: {
                        candidate: data,
                        request: vm.request,
                        title: "Notas " + data.name
                    }
                });
            }


        }

        //Retorna las notas serializadas
        vm.modelNotes = function (data) {
            var baseJson = analystConstant.KEYJSONNOTE;
            baseJson.analista.callback = "getOneKey";
            baseJson.fecha.callback = "setFormatDate";
            return analystMisc.modeldataarray(data, baseJson);
        }

        vm.showfilterCandidate = function () {
            $mdDialog.show({
                controller: 'FilterHv',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/filter_hv/filter_hv.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    lists: vm.request.lists,
                    request: vm.request,
                    form: vm.modalFilterData,
                    candidate: true,
                }
            })
                .then(function (resolve) {

                    vm.page = 1;
                    vm.modelCandidate(resolve.candidate);
                    vm.setFilter(resolve.filter);
                    vm.modalFilterData = resolve.data;
                });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('SearchcandidateController', SearchcandidateController);

    function SearchcandidateController($mdDialog, AdminService, IkanoFactory, analystConstant, analystService, $q, $filter, $state, $mdSidenav, paginationService, $scope, api, $mdpTimePicker, $mdDateLocale, AuthService, analystMisc, $document, $rootScope, $mdColors, $mdToast, ListFilter, $debounce) {

        //constructor
        var vm = this;
        vm.misc = {};
        vm.misc.lists = {};

        vm.candidateSelected = {};

        vm.modalFilterData = {};

        //COUNT ORIGENES
        vm.countOrigen = {};

        // set ID de la request
        vm.idRequest = $state.params.request_id;

        //Backup
        vm.backup = {};

        vm.backup.filter = {};

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        //objeto para el paginador
        vm.pager = {};

        vm.candidatesBackup = [];

        vm.pagesBackup = {}

        vm.misc.filter = [];

        //SOCKET ANGULAR
        var setRequest = $rootScope.$on('setRequest', function (evt, arg) {
            vm.request = arg;
            if (typeof vm.request.lists != "undefined") {
                vm.request.lists.cargos_recomendados = vm.request.charges;
                vm.setMiscSelect(vm.request.lists);
            }
        });

        var change_listRequest = $rootScope.$on('change::listRequest', function (evt, arg) {
            vm.setMiscSelect(arg);
        });

        var update_hv = $rootScope.$on('update-hv', function (evt, arg) {
            if (arg.fn == 'preseleccionar') {
                vm.candidates[vm.indexSelected].view = moment();
                vm.candidates[vm.indexSelected].cita = {};
                vm.candidates[vm.indexSelected].citaBackup = [];
                vm.candidates[vm.indexSelected].stage = arg.candidate.stage;
                vm.candidatesBackup[vm.indexSelected].bloques_etapas_candidato = arg.bloques_etapas_candidato;
                vm.candidatesBackup[vm.indexSelected].bloques_informe_cliente = arg.bloques_informe_cliente;
                $rootScope.$broadcast('update-count-candidate', { sum: true, count: 1 });
                $rootScope.$broadcast('candidate::addCandidate', { candidate: vm.candidates[vm.indexSelected], backup: vm.candidatesBackup[vm.indexSelected] });
                $rootScope.$broadcast('request::updateStatitics', { sum: true, candidate: 1, preseleccionar: true });
            } else if (arg.fn == 'retirarPreseleccionar') {
                vm.candidates[vm.indexSelected].stage = {};
                $rootScope.$broadcast('update-count-candidate', { rest: true, count: 1 });
                $rootScope.$broadcast('candidate::removeCandidate', { candidate: vm.candidates[vm.indexSelected], backup: vm.candidatesBackup[vm.indexSelected] });
                $rootScope.$broadcast('request::updateStatitics', { rest: true, candidate: 1, preseleccionar: true });
            }
        });

        var listas = $rootScope.$on('listas',function(evt,arg){
            vm.lists = arg;
            vm.stages = angular.copy(vm.lists.etapas);
        });




        vm.configCandidate = {
            showPreseleccion: true,
        };

        vm.setMiscSelect = function (data) {
            vm.misc.lists = data;
            //console.log(vm.misc.lists);
            //vm.setFilter({areas_trabajo: ["2","3"], query: "asda"});
        }

        vm.showfilterCandidate = function () {
            $mdDialog.show({
                controller: 'FilterHv',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/filter_hv/filter_hv.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    lists: vm.misc.lists,
                    request: vm.request,
                    form: vm.modalFilterData,
                    candidate: false
                }
            })
                .then(function (resolve) {
                    if (resolve.origenes) {
                        vm.countOrigen = resolve.origenes;
                    } else {
                        vm.countOrigen = {};
                    }
                    console.log(resolve);
                    vm.page = 1;
                    vm.modelCandidate(resolve.candidates);
                    vm.setFilter(resolve.filter);
                    
                    vm.modalFilterData = resolve.data;
                });
        }

        vm.modelCandidate = function (data, config) {
            config = (config ? config : {});
            vm.showListsCandidate();
            vm.candidates = [];
            vm.misc.candidates = [];
            var modelCandidate = [];
            var model = analystConstant.KEYJSONCANDIDATE.PRODUTION;
            var idsCandidate = [];

            model.modified = { key: "last_update", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } };
            model.updated_at = { key: "updated_at", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } };
            vm.candidatesBackup = [];
            for (var i in data.candidates) {
                modelCandidate.push(data.candidates[i]);
                idsCandidate.push(data.candidates[i].id);
                vm.candidatesBackup.push({ candidato: data.candidates[i] });
            }

            analystMisc.modeldataarray(modelCandidate, model)
                .then(function (resolve) {
                    vm.candidates = resolve;
                    if (!config.notPagination) {
                        vm.modelPagination(data.pagination);
                    }
                    //vm.misc.candidates = angular.copy(vm.candidates);
                    saveCandidate(resolve, 'candidates');
                    getHojaVida(idsCandidate);
                    //getCandidateNext();
                });

        }

        function getHojaVida(ids) {
            var dataPost =
                {
                    "proceso_id": vm.idRequest,
                    "hv_ids": ids
                };
            analystService.getHojaVidas(dataPost, function (response) {
                mergeHojaVida(ids, response.data.data);
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            }, true);
        }

        function mergeHojaVida(ids, hojavidas, current) {
            for (var i in ids) {
                vm.candidatesBackup[i] = analystMisc.misc.mergeJson(vm.candidatesBackup[i], hojavidas[i]);
            }
        }

        function getCandidateNext() {
            if (vm.page == 1 && !vm.searchasdsw) {
                vm.searchasdsw = true;
                vm.saveSearch(vm.backup.filter, {
                    page: vm.page + 1,
                    limit: analystConstant.LIMITROW
                }, {
                        notPagination: true
                    });
            }
        }

        function saveCandidate(data, key) {
            var pageNext = vm.page + 1;
            if (vm.pagesBackup[vm.page]) {
                vm.pagesBackup[pageNext] = {};
            } else {
                vm.pagesBackup[vm.page] = {};
            }

            if (vm.pagesBackup[vm.page][key]) {
                vm.pagesBackup[pageNext][key] = data;
            } else {
                vm.pagesBackup[vm.page][key] = data;
            }
        }

        vm.modelPagination = function (filterPage) {
            vm.pagination = filterPage;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        //Inicia el paginador
        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || page > vm.pager.totalPages) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.pagination.total_rows, page, analystConstant.LIMITROW);
            if (!noConsult) {

                vm.saveSearch(vm.backup.filter, {
                    page: page,
                    limit: analystConstant.LIMITROW
                });
            }
        }

        vm.showHV = function (candidate, index) {
            if (!vm.candidatesBackup[index].hoja_vida) {
                return;
            }
            vm.candidateSelected = angular.copy(vm.candidates[index]);
            vm.candidateSelectedAll = angular.copy(vm.candidatesBackup[index]);
            vm.indexSelected = index;
            vm.showDetailCandidate = true;
        }

        vm.showListsCandidate = function () {
            vm.indexSelected = null;
            vm.candidateSelected = null;
            vm.candidateSelectedAll = null;
            vm.showDetailCandidate = false;
        }

        vm.backCandidate = function () {
            vm.indexSelected = vm.indexSelected - 1;
            vm.candidateSelected = angular.copy(vm.candidates[vm.indexSelected]);
            vm.candidateSelectedAll = angular.copy(vm.candidatesBackup[vm.indexSelected]);
        }

        vm.nextCandidate = function () {
            vm.indexSelected = vm.indexSelected + 1;
            vm.candidateSelected = angular.copy(vm.candidates[vm.indexSelected]);
            vm.candidateSelectedAll = angular.copy(vm.candidatesBackup[vm.indexSelected]);
        }

        vm.deleteFilter = function (filter, indexFilter, indexChild) {
            vm.loading = true;
            ListFilter.deleteFilter(filter, indexFilter, indexChild, vm.misc.filter, vm.modalFilterData);
            $debounce(vm.updateFilter, 2000);
        }

        vm.updateFilter = function () {
            var filter = {};
            var data = angular.copy(vm.misc.filter);
            for (var i in data) {
                filter[data[i].key] = data[i].value;
            }
            vm.pager = {};
            vm.page = 1;
            if (data.length) {
                vm.saveSearch(filter, {
                    page: 1,
                    limit: analystConstant.LIMITROW
                });
            }else{
                vm.loading = false;
                vm.candidates = [];
                vm.candidatesBackup = [];
            }

        }

        vm.setFilter = function (filter) {
            vm.backup.filter = angular.copy(filter);
            vm.misc.filter = ListFilter.setFilter(filter,1);
        }

        vm.saveSearch = function (filter, pagination, configModelCandidate) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.filtros = filter;
            dataPost.pagination = pagination;
            vm.loading = true;
            analystService.filterAllCandidate(dataPost, function (response) {
                vm.modelCandidate(response.data, configModelCandidate);
                vm.backup.filter = filter;
                vm.loading = false;
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            },true);
        }

        vm.getFilter = function () {
            analystService.filterAllCandidate({}, function (response) {
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        break;
                    case analystConstant.CODEPETITION.NOTFOUND:
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            });
        }

        vm.showToast = function (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        /**
         * CAMBIAR ESTADO PRESELECCIONADO
         */

        vm.preseleccionar = function (candidate, index) {
            
            var dataPost = {
                proceso_id: vm.request.id,
                hoja_vida_id: candidate.id
            };

            analystService.preseleccionar(dataPost, function (response) {
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        if (response.data.status) {
                            for (var i in vm.stages) {
                                var stage = vm.stages[i];
                                if (stage.id == 2) {
                                    candidate.stage = stage;
                                }
                            }
                            vm.candidates[index].view = moment();
                            vm.candidates[index].cita = {};
                            vm.candidates[index].citaBackup = [];
                            vm.candidatesBackup[index].bloques_etapas_candidato = response.data.bloques_etapas_candidato;
                            vm.candidatesBackup[index].bloques_informe_cliente = response.data.bloques_informe_cliente;
                            vm.showToast({ class: "success", message: response.data.message, showClose: true }, []);
                            $rootScope.$broadcast('update-count-candidate', { sum: true, count: 1, preseleccionar: true });
                            $rootScope.$broadcast('candidate::addCandidate', { candidate: candidate, backup: vm.candidatesBackup[index] });
                            $rootScope.$broadcast('request::updateStatitics', { sum: true, candidate: 1, preseleccionar: true });
                        } else {
                            vm.showToast({ class: "error", message: response.data.message, showClose: true }, []);
                        }
                        break;
                    case analystConstant.CODEPETITION.NOTFOUND:
                        IkanoFactory.showAlert("Error", response.data.message);
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.retirarPreseleccionar = function (candidate) {
            var dataPost = {
                proceso_id: vm.request.id,
                hoja_vida_id: candidate.id
            };
            analystService.retirarPreseleccionar(dataPost, function (response) {
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        if (response.data.status) {
                            candidate.stage = {};
                            vm.showToast({ class: "success", message: response.data.message, showClose: true }, []);
                            $rootScope.$broadcast('update-count-candidate', { rest: true, count: 1 });
                            $rootScope.$broadcast('candidate::removeCandidate', { candidate: candidate });
                            $rootScope.$broadcast('request::updateStatitics', { rest: true, candidate: 1, preseleccionar: true });
                        } else {
                            vm.showToast({ class: "error", message: response.data.message, showClose: true }, []);
                        }
                        break;
                    case analystConstant.CODEPETITION.NOTFOUND:
                        IkanoFactory.showAlert("Error", response.data.message);
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        $scope.$on('$destroy', function() {
            setRequest();
            change_listRequest();
            update_hv();
            listas();
        });
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('DetailAnalystController', DetailAnalystController);



    function DetailAnalystController($mdDialog, IkanoFactory, analystConstant, $q, $state, $scope, $mdSidenav, api, analystMisc, $document, $rootScope, $mdColors, $mdToast) {
        //Le asignamos un alias al controlador
        var vm = this;

        // Muestra por defecto el loading
        vm.loading = true;

        //miscelaneos
        vm.misc = {};

        //URL BASE
        vm.misc.urlBase = api.general.getUrlBase();

        // informacion que aparece en el Header
        vm.pageInfo = analystConstant.PAGESINFO.DETAIL;

        // set ID de la request
        vm.idRequest = $state.params.request_id;

        // set variable request
        vm.request = {};

        //set TABS
        vm.tabbes = [
            {
                "name": "Candidatos que están participando",
                "template": "app/main/analyst/detail/tabs/candidates_participating.html",
                "count": "0",
                "classbadge": { 'tab-badge': true, 'blue-300-bg': true }
            },
            {
                "name": "Candidatos que te pueden interesar",
                "template": "app/main/analyst/detail/tabs/candidate_similar.html",
                "count": "",
                "callEvents": "candidate::initProcessSimilar"
            },
            {
                "name": "Análisis de candidatos",
                "template": "app/main/analyst/detail/tabs/analyst_candidate.html",
                "count": "",
            },
            {
                "name": "Buscar hoja de vida",
                "template": "app/main/analyst/detail/tabs/searchcandidate.html",
                "count": "",
                "callEvents": "candidate::initSearchHv"
            }
        ];


        //MISC texto para reemplazar
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

        //SELECT PARA AGENDAR CITA
        vm.misc.lists = {};

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        vm.projectName = analystConstant.DEFAULT.DATA.HEADER.KEYSDETAILREQUEST.CANDIDATE;

        //Informacion de la pagina
        vm.project = vm.selectedProject = analystMisc.header.getProject(vm.projectName);

        //projects
        vm.projects = analystMisc.header.getHeaderProjects();

        //Actualizar el contador de los tabs
        var update_count_candidate = $rootScope.$on('update-count-candidate', function (evt, arg) {
            if (arg.sum || arg.rest) {
                if (arg.sum) {
                    vm.tabbes[0].count += arg.count;
                }
                if (arg.rest) {
                    vm.tabbes[0].count -= arg.count;
                }

            } else {
                vm.tabbes[0].count = arg.count;
            }
        });

        var request_updateStatitics = $rootScope.$on('request::updateStatitics', function (evt, arg) {
            if (arg.sum) {
                if (arg.candidate) {
                    vm.request.candidate_info.candidates += arg.candidate;
                }

                if (arg.noleido) {
                    vm.request.candidate_info.unread += 1;
                }

                if (arg.preseleccionar) {
                    vm.request.candidate_info.preSelected += 1;
                }

            }
            if (arg.rest) {
                if (arg.candidate) {
                    vm.request.candidate_info.candidates -= arg.candidate;
                }

                if (arg.noleido) {
                    vm.request.candidate_info.unread -= 1;
                }

                if (arg.preseleccionar) {
                    vm.request.candidate_info.preSelected -= 1;
                }

            }
        });

        var set_candidate = $rootScope.$on('set-candidate', function (evt, arg) {
            /*localStorage.setItem('candidate-request-' + vm.idRequest, JSON.stringify(arg.candidate));
            vm.candidates = arg.candidate;
            vm.tabbes[0].count = vm.candidates.length;*/
            vm.tabbes[0].count = arg.candidateCount;
        });

        var setModelRequest = $rootScope.$on('setModelRequest', function (evt, arg) {
            if (localStorage.getItem('candidate-request-' + vm.idRequest)) {
                vm.candidates = JSON.parse(localStorage.getItem('candidate-request-' + vm.idRequest));
            }
            vm.modelRequest(arg);
        });

        var header_changeData = $rootScope.$on('header::changeData', function (evt, arg) {
            angular.forEach(vm.request, function (v, k) {
                if (typeof v == 'object') {
                    angular.forEach(v, function (value, key) {
                        if (arg[key] != null && typeof arg[key] != 'undefined') {
                            vm.request[k][key] = arg[key];
                        }
                    });
                }
                if (arg[k]) {
                    vm.request[k] = arg[k];
                }
            });
        });

        vm.callEvents = function (tab) {
            if (tab.callEvents) {
                $rootScope.$broadcast(tab.callEvents, {});
            }
        }
        //Modelamos la data de la request   
        vm.modelRequest = function (data) {
            var baseJson = analystConstant.KEYJSONREQUEST;
            analystMisc.modeldata(data, baseJson, { createIfNotExist: true })
                .then(function (resolve) {
                    vm.request = resolve;
                    analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
                        vm.request.notes = resolve;
                    });

                    $rootScope.$broadcast('setRequest', vm.request);
                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }

        //SIDENAV
        vm.toggleSidenav = function (sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };

        vm.setRecommendCandidate = function (candidate) {
            var configModal = {};
            configModal.misc = {};
            //TOOLBAR
            configModal.toolbar = {};
            configModal.toolbar.name = 'Recomendar ' + candidate.name;
            configModal.toolbar.class = {};

            //DATA
            configModal.misc.charge = vm.request.charges;
            vm.candidateSelected = candidate;
            configModal.callbackSuccess = vm.setRecommendCandidateApi;
            configModal.functions = {
                querySearch: querySearch
            };
            configModal.historyRecommend = vm.misc.recommendCandidate;

            //TEMPLATE
            configModal.templateUrl = 'app/main/analyst/partials/recommend_candidate/recommend_candidate.html';

            vm.showModal(configModal);
        }

        function querySearch(query) {
            var results = query ? vm.request.charges.filter(createFilterFor(query)) : vm.request.charges, deferred;
            if (self.simulateQuery) {
                deferred = $q.defer();

                $timeout(function () {
                    deferred.resolve(results);
                },
                    Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        //filter function for search query
        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(charge) {
                var value = angular.lowercase(charge.name);
                return (value.indexOf(lowercaseQuery) === 0);
            };
        }

        /*******************************
        **  TAB ANALISTA DE CANDIDATO **
        ********************************/
        //HEADER

        vm.openShowRequestNotesDialog = function () {
            $mdDialog.show({
                controller: 'ShowRequestNotesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-request-notes.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request,
                }
            });
        }

        vm.showModalEditOffer = function () {
            $mdDialog.show({
                controller: 'changeDatePublicController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/change_date_public_request/change_date_public_request.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            });
        }

        vm.showToast = function (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        vm.selectProject = function (project) {
            $state.go(project.url, { request_id: vm.idRequest });
        }

        vm.publishRequest = function () {
            $state.go('app.publish_request', { request_id: vm.idRequest });
        }

        vm.showFinishProcess = function () {
            $mdDialog.show({
                controller: 'finishRequestDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/finish_process/finish_process.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            }).then(function (resolve) {
                if (resolve.data.status) {
                    vm.modelRequest(resolve.data.data.proceso);
                    vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
                } else {
                    IkanoFactory.showAlert("Error", resolve.data.message);
                }

            });
        }

        $scope.$on('$destroy', function() {
            update_count_candidate();
            request_updateStatitics();
            set_candidate();
            setModelRequest();
            header_changeData();
        });
    }


})();
(function(){
    'use strict';

    angular.module('app.seleccion_analyst').controller('analystCandidate',analystCandidate);

    function analystCandidate($mdDialog, AdminService, IkanoFactory, analystConstant, analystService, $q, $filter, $state, $mdSidenav, paginationService, $scope, api, $mdpTimePicker, $mdDateLocale, AuthService, analystMisc, $document, $rootScope, $mdColors, $mdToast,$compile){
        //constructor
        var vm = this;
        vm.misc = {};
        vm.misc.lists = {};
        vm.paginationLoad = false;
        //DATA TABLE OPTION
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            paging: false, 
            language: IkanoFactory.getLanguajeDataTable(),
            pagingType: 'simple',
            autoWidth: false,
            iDisplayLength: 20,
            order: [1, 'asc'],
            searching: false
        };

        $rootScope.$on('candidate::getCandidates',function(evt,arg){
            vm.candidates = arg;
        });

        $rootScope.$on('candidate::getPagination',function(evt,arg){
            vm.pager = arg;
            //if(!vm.paginationLoad){
                setTimeout(function(){
                    vm.createPagination();
                },1000);
            //}
        });

        vm.createPagination = function(){
            var elemt = $('.pagination');
            //elemt.appendTo('<div class="paginations"></div>');
            var template = '<div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        vm.setPage = function(page){
            $rootScope.$broadcast('candidate::changePagination',page);
        }
        
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('DashboardAnalystController', DashboardAnalystController);

    function DashboardAnalystController($mdDialog, AdminService, IkanoFactory, analystConstant, analystService, $q, $filter, $state, $scope, paginationService, analystMisc) {
        //Le asignamos un alias al controlador
        var vm = this;

        // Muestra por defecto el loading
        vm.loading = true;

        // seteamos el objetos de filtros
        vm.filter = {};

        vm.filter.startDate = null;
        vm.filter.endDate = null;

        // seteamos MISC (misc es un objeto que nos ayuda con la data que se va a mostrar en la vista)
        vm.misc = {};
        vm.misc.arrApplicant = [];
        vm.misc.arrStatusRequest = [];
        vm.misc.arrRegionalRequest = [];
        vm.misc.filter = {};

        // se setea un valor por defecto que va a valer 0 en los filtro por select
        vm.misc.filter.defaultApplicant = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.APPLICANT;
        vm.misc.filter.defaultStatusRequest = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.STATUSREQUEST;
        vm.misc.filter.defaultRegionalRequest = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.REGIONALREQUEST;
        vm.misc.filterCopy = {};

        // informacion que aparece en el Header
        vm.pageInfo = analystConstant.PAGESINFO.DASHBOARD;

        // seteamos la data de los filtros 

        //definimos la variable request Que es un array
        vm.request = [];
        //El backup de request es la constante que solo se setea una vez y es la data que trae de la base de datos
        vm.backupRequest = [];
        //El misc es la data que se muestra en la vista
        vm.misc.request = [];

        //STRING DATE REPLACE
        vm.misc.date_request_string = '(Hace %months% meses y %days% días)';

        //LIMIT
        vm.limit = analystConstant.LIMITROW;

        //PAGER
        vm.pager = {};

        vm.backup = {};



        vm.goToNewRequest = function () {
            $state.go('app.seleccion_create_request_analyst');
        }
        //Arranca apenas se haya terminar de cargar el controlador
        vm.getRequest = function (params) {
            analystService.getRequests(params, function (response) {
                vm.backup.filter = params.filtros;
                vm.loading = false;
                if (response.data.status) {
                    vm.filters = response.data.filters;
                    localStorage.setItem('filterSearchHv',JSON.stringify(vm.serializeFilter(response.data.filters_buscar_hv)));
                    localStorage.setItem('filterSearchCandidate',JSON.stringify(vm.serializeFilter(response.data.filters_buscar_candidatos)));
                    vm.modelRequest(response.data.data);
                    //vm.modelFilter(response.data.listas);
                    modelPagination(response.data.pagination);
                } else {
                    IkanoFactory.showAlert("Error", response.data.message);
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        };

        vm.serializeFilter = function (data){
            for(var i in data){
                for(var j in data[i]){
                    var filtroNow = angular.copy(data[i][j]);
                    if(!Array.isArray(filtroNow.options)){
                        data[i][j].options = [];
                        for(var f in filtroNow.options){
                            if(filtroNow.options[f] instanceof Object){
                                data[i][j].options.push({id:f , name: filtroNow.options[f].name})
                            }else{
                                data[i][j].options.push({id:f , name: filtroNow.options[f]})
                            }
                            
                        }
                    }
                    data[i][j].optionsshow = data[i][j].options.slice(0, vm.limit);
                }
            }
            return data;
        }

        vm.callbackSendData = function (filter){
            var filterConsult = angular.copy(filter);
           
            if (filterConsult.fecha_creacion && filterConsult.fecha_creacion_fin) {
                filterConsult.fecha_creacion = [filterConsult.fecha_creacion, filterConsult.fecha_creacion_fin];
                delete(filterConsult.fecha_creacion_fin);
            }
            vm.getRequest({
                filtros: filterConsult,
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }

        vm.search = function () {
            var filter = angular.copy(vm.filter);
            if (filter.estado_aprobacion == -1) {
                delete (filter.estado_aprobacion);
            }
            if (filter.solicitante_id == -1) {
                delete (filter.solicitante_id);
            }
            if (filter.regional_id == -1) {
                delete (filter.regional_id);
            }
            if (filter.startDate && filter.endDate) {
                filter.fecha_creacion = [filter.startDate, filter.endDate];
                delete (filter.startDate);
                delete (filter.endDate);
            }
            vm.getRequest({
                filtros: filter,
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }

        vm.clearFilter = function () {
            vm.getRequest({
                filtros: {},
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }

        vm.setModelNote = function (value) {
            value = (value) ? value : vm.misc.notesExample;
            var arrayReturn = [];
            if (!value.length) {
                return arrayReturn;
            }

            var baseJson = analystConstant.KEYJSONNOTE;
            value.map(function (va, ke) {
                var jsonInsert = {};
                angular.forEach(va, function (v, k) {
                    switch (typeof baseJson[k]) {
                        case "string":
                            jsonInsert[baseJson[k]] = v;
                            break;
                        case "object":
                            var config = baseJson[k];
                            jsonInsert[config.key] = vm[config.callback](v, config.dataCallback);
                            jsonInsert[config.key + 'Backup'] = v;
                            break;
                    }
                });
                arrayReturn.push(jsonInsert);
            });
            return arrayReturn;
        }
        //Modelar las requisiones
        vm.modelRequest = function (data) {
            var baseJson = analystConstant.KEYJSONREQUEST;
            vm.misc.request = [];
            analystMisc.modeldataarray(data, baseJson, { createIfNotExist: true })
                .then(function (resolve) {
                    vm.misc.request = resolve;
                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }



        function modelPagination(filterPage) {

            vm.pagination = filterPage;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        //PAGINATION
        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.pagination.total_rows, page, vm.limit);
            if (!noConsult) {
                var filter = {
                    filtros: vm.backup.filter, pagination: {
                        page: page,
                        limit: vm.limit
                    }
                };
                vm.getRequest(filter);
            }
        }

        vm.setCandidateInfo = function (value, config) {
            var jsonReturn = {};
            var baseJson = (analystConstant.DEBUG) ? analystConstant.KEYJSONREQUESTDEBUG : analystConstant.KEYJSONREQUEST;
            angular.forEach(value, function (vv, vk) {
                jsonReturn[baseJson[vk]] = vv;
            });
            return jsonReturn;
        }

        vm.modelFilter = function (data) {
            var applicant = data.solicitantes;
            var statusRequest = data.estados_proceso;
            var regionalRequest = data.empresas;

            if (!angular.equals(applicant, {}) && vm.misc.arrApplicant.length < 1) {
                angular.forEach(applicant, function (v, k) {
                    k = parseInt(k);
                    vm.misc.arrApplicant.push({ id: k, name: v });
                });
                vm.misc.arrApplicant.sort(function (a, b) {
                    if (a.name < b.name) { return -1; }
                    if (a.name > b.name) { return 1; }
                    return 0;
                });
            }

            if (!angular.equals(statusRequest, {}) && vm.misc.arrStatusRequest.length < 1) {
                angular.forEach(statusRequest, function (v, k) {
                    k = parseInt(k);
                    vm.misc.arrStatusRequest.push({ id: k, name: v.label });
                });
            }

            if (!angular.equals(regionalRequest, {}) && vm.misc.arrRegionalRequest.length < 1) {
                angular.forEach(regionalRequest, function (v, k) {
                    k = parseInt(k);
                    vm.misc.arrRegionalRequest.push({ id: k, name: v });
                });
            }

        }

        vm.setStringDateRequest = function (obj) {
            var stringReturn = "";
            //SI ES HOY
            if (obj.isToday) {
                return stringReturn = "Hoy";
            }
            //SI TIENE AÑOS
            if (obj.months > 0) {
                stringReturn += "Hace " + obj.textSuggested.months;
            }
            //SI TIENE AÑOS Y MESES
            if (obj.days > 0 && obj.months > 0) {
                stringReturn += " y " + obj.textSuggested.days;
            } else if (obj.days > 0 && obj.months == 0) { //si tiene años pero no tiene meses
                stringReturn += "Hace " + obj.textSuggested.days;
            }

            return stringReturn;
        }
        //Cambiar de color segun el stado ESTO ES PARA DEBUG
        vm.searchColorStatus = function (request) {
            request.colorStatus = 'brown-300-bg';
            switch (Math.floor((Math.random() * 4) + 1)) {
                case 1:
                    request.colorStatus = 'red-300-bg';
                    break;
                case 2:
                    request.colorStatus = 'purple-300-bg';
                    break;
                case 3:
                    request.colorStatus = 'green-300-bg';
                    break;
                case 4:
                    request.colorStatus = 'light-blue-300-bg';
                    break;
            }
        }

        vm.setDateRequest = function (v, format) {
            return moment(v).format(format);
        }

        vm.setBetweenDate = function (stringReplace, datePast, dateCompare) {
            var dateCompare = (!dateCompare) ? moment() : moment(dateCompare);
            var datePast = moment(datePast);
            var years = dateCompare.diff(datePast, 'years');
            datePast.add(years, 'years');
            var months = dateCompare.diff(datePast, 'months');
            datePast.add(months, 'months');
            var days = dateCompare.diff(datePast, 'days');
            datePast.add(days, 'days');
            var hours = dateCompare.diff(datePast, 'hours');
            datePast.add(hours, 'hours');
            var minutes = dateCompare.diff(datePast, 'minutes');
            datePast.add(minutes, 'minutes');
            var seconds = dateCompare.diff(datePast, 'seconds');
            datePast.add(seconds, 'seconds');
            var milliseconds = dateCompare.diff(datePast, 'milliseconds');
            //return "Hola";
            return stringReplace.replace(/%year%/g, years)
                .replace(/%months%/g, months)
                .replace(/%days%/g, days)
                .replace(/%hours%/g, hours)
                .replace(/%minutes%/g, minutes)
                .replace(/%seconds%/g, seconds)
                .replace(/%milliseconds%/g, milliseconds);
        }

        //SIEMPRE QUE HAYA UN CAMBIO EN LAS BUSQUEDAS INGRESA AQUI
        vm.changeFilter = function () {
            var boolExecuteFilter = false;
            vm.misc.filterCopy = {};
            vm.misc.filterCopy.and = {};
            if (vm.filter.search) {
                vm.misc.filterCopy.or = {};
                vm.misc.filterCopy.or.name = angular.copy(vm.filter.search);
                vm.misc.filterCopy.or.cod = angular.copy(vm.filter.search);
                vm.misc.filterCopy.or.state = angular.copy(vm.filter.search);
                vm.misc.filterCopy.or.custom_data = angular.copy(vm.filter.search);
                boolExecuteFilter = true;
            }
            if (vm.filter.applicant && vm.filter.applicant.id && vm.filter.applicant.id !== vm.misc.filter.defaultApplicant) {
                vm.misc.filterCopy.and.applicant = angular.copy(vm.filter.applicant.name);
                boolExecuteFilter = true;
            }
            if (vm.filter.statusRequest && vm.filter.statusRequest.id && vm.filter.statusRequest.id !== vm.misc.filter.defaultStatusRequest) {
                vm.misc.filterCopy.and.status = angular.copy(vm.filter.statusRequest.name);
                boolExecuteFilter = true;
            }
            if (boolExecuteFilter) {
                vm.executeFilter();
            } else {
                vm.request = angular.copy(vm.backupRequest);
                vm.misc.request = vm.request.slice(0, analystConstant.DEFAULT.DATA.DASHBOARD.LIMITREQUEST);
            }

        }

        //EJECUTAMOS EL FILTRO  
        vm.executeFilter = function () {
            vm.request = vm.backupRequest;
            if (vm.misc.filterCopy.and) {
                vm.request = $filter('customField')(vm.request, vm.executeFilterPrimary);
            }

            if (vm.misc.filterCopy.or) {
                vm.request = $filter('customField')(vm.request, vm.executeFilterSecundary);
            }
            vm.misc.request = vm.request.slice(0, analystConstant.DEFAULT.DATA.DASHBOARD.LIMITREQUEST);
        }

        //Ejecuta primero los filtros primarios los que tienen que cumplir si o si
        vm.executeFilterPrimary = function (item) {
            var arrReturn = [];
            var countObject = Object.keys(vm.misc.filterCopy.and).length;
            angular.forEach(vm.misc.filterCopy.and, function (value, key) {
                if (item[key]) {
                    if (item[key].toLowerCase().indexOf(value.toLowerCase()) > -1) {
                        arrReturn.push(true);
                    }
                }
            });
            return arrReturn.length == countObject;
        }

        //Ejecuta el segundo filtro es un filtro que puede varias on un or.
        vm.executeFilterSecundary = function (item) {
            var arrReturn = [];
            angular.forEach(vm.misc.filterCopy.or, function (value, key) {
                switch (typeof item[key]) {
                    case "string":
                        if (item[key].toLowerCase().indexOf(value.toLowerCase()) > -1) {
                            arrReturn.push(true);
                        }
                        break;
                    case "object":
                        var data = item[key];
                        if (data) {
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].value && data[i].value.toLowerCase().indexOf(value.toLowerCase()) > -1) {
                                    arrReturn.push(true);
                                }
                            }
                        }

                        break;
                }
            });
            return (arrReturn.length > 0) ? true : false;
        }

        //DATA QUE SE CARGA POR EL SCROLL INFINITO
        vm.loadMore = function () {
            var last = vm.misc.request.length - 1;
            var limit;
            if (vm.misc.request.length < vm.request.length) {
                limit = (vm.request.length - vm.misc.request.length < analystConstant.DEFAULT.DATA.DASHBOARD.LIMITREQUEST) ? vm.request.length - vm.misc.request.length : analystConstant.DEFAULT.DATA.DASHBOARD.LIMITREQUEST;

                for (var i = 1; i <= limit; i++) {
                    vm.misc.request.push(vm.request[last + i]);
                }
            }
        }

        vm.goDetail = function (idRequest) {
            $state.go('app.detail_seleccion_analyst.index', { request_id: idRequest });
        }

        //MODELAMOS LA DATA DE LA EXPERIENCIA POR CANDIDATO
        vm.getOneKey = function (data, config) {
            if (data == null || typeof data == "undefined") {
                return;
            }
            return data[config.getKey];
        }

        //setea una fecha con un formato expecifico
        vm.setFormatDate = function (v, config) {
            return moment(v).format(config.format);
        }

        vm.publishRequest = function (id) {
            $state.go('app.publish_request', { request_id: id });
        }

        //FILTROS
        if ($state.params.filter) {
            switch ($state.params.filter) {
                case 'seleccion_get_procesos_analista_nuevos':
                    vm.getRequest({
                        filtros: {
                            nuevos: 1
                        }, pagination: {
                            page: 1,
                            limit: vm.limit
                        }
                    });
                    break;
                case 'seleccion_get_procesos_analista_encurso':
                    vm.getRequest({
                        filtros: {
                            estado_proceso: 'APROBADO'
                        }, pagination: {
                            page: 1,
                            limit: vm.limit
                        }
                    });
                    break;

                case 'seleccion_get_procesos_analista_compartidos':
                    vm.getRequest({
                        filtros: {
                            compartido: 1
                        }, pagination: {
                            page: 1,
                            limit: vm.limit
                        }
                    });
                    break;
                case 'seleccion_get_procesos_analista_suspendidos':
                    vm.getRequest({
                        filtros: {
                            estado_proceso: 'SUSPENDIDO'
                        }, pagination: {
                            page: 1,
                            limit: vm.limit
                        }
                    });
                    break;
                case 'seleccion_get_procesos_analista_finalizados':
                    vm.getRequest({
                        filtros: {
                            estado_proceso: 'FINALIZADO'
                        }, pagination: {
                            page: 1,
                            limit: vm.limit
                        }
                    });
                    break;

            }
        } else {
            vm.getRequest({
                filtros: {}, pagination: {
                    page: 1,
                    limit: vm.limit
                }
            });
        }
    }
})();

(function () {

    'use strict';

    angular.module('app.seleccion_analyst').controller('createRequestAnalyst', createRequestAnalyst);

    function createRequestAnalyst($mdDialog, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, analystService, analystMisc, $mdToast, analystConstant, paginationService, $compile, $scope, $mdColors, $filter, ValidationService) {
        //Constructor
        var vm = this;

        vm.idRequest = ($state.params.idRequest) ? $state.params.idRequest : false;

        vm.validationService = ValidationService;

        vm.pageInfo = (vm.idRequest) ? analystConstant.PAGESINFO.UPDATEREQUEST : analystConstant.PAGESINFO.NEWREQUEST;

        vm.showLoadingBlock = false;

        //FUNCIONS VIEW - CONTROLLER

        vm.goToDashboard = function () {
            $state.go('app.seleccion_get_procesos_analista');
        }

        vm.saveRequest = function () {
            vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values, true);
            if (angular.equals(vm.errors, {})) {
                vm.save();
            } else {
                IkanoFactory.showAlert("Error", "La información de la requisición esta incompleta, por favor intente de nuevo.");
            }
        }

        vm.onchange_lists = function(lista){
            $.each(vm.lists,function(key,value){
                if(lista[key]){
                    vm.lists[key] = lista[key];
                }
            });
            for(var c in vm.data.estructura_campos){
                var campo = vm.data.estructura_campos[c];
                if(lista[campo.options]){
                    $scope.$broadcast('changeList'+c,lista[campo.options]);
                }
            }
        }

        vm.save = function () {
            var data = {
                data: vm.values
            };
            if (vm.idRequest) {
                data.proceso_id = vm.idRequest;
            }
            data.data.tipo_proceso = 'proceso_analista';
            vm.change = false;
            vm.saving = true;

            analystService.saveNewRequest(data,
                function (response) {
                    
                    vm.saving = false;
                    vm.change = true;
                    var data = {};
                    data.class = (response.data.status) ? "success" : "error";
                    data.message = response.data.message;
                    data.showClose = true;
                    showToast(data);
                    vm.goToDashboard();
                },
                function (reject) {
                    var data = {};
                    data.class = "error";
                    data.message = reject.data.message;
                    data.showClose = true;
                    showToast(data);
                    vm.saving = false;
                    vm.change = true;
                }
            );

        }

        //BLOCKS
        vm.setValuesWatch = function () {
            ValidationService.setWarchers($scope, vm);
        };

        vm.setBlocks = function () {
            vm.blocks = $.map(vm.data.bloques, function (value, index) {
                return [vm.getBlock(index, value)];
            });
            console.log(vm.blocks);
            
        };

        vm.getBlock = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.campos,
                blockType: data.type
            };

            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }

            return block;
        };


        vm.addModelToBlock = function (block) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            vm.values[block.model].push(model);
        }

        vm.removeModelToBlock = function (block, index) {
            vm.values[block.model].splice(index, 1);
        }

        vm.getPositionColaborators = function (position) {
            AdminService.getPositionColaborators({ cargo_id: position }, {},
                function (response) {
                    if (response.data.colaboradores) {
                        vm.lists.position_colaborators = response.data.colaboradores;
                    }
                }
            );
        };
        //FUNCTION CONTROLLER

        function getDataRequestAnalyst() {
            vm.showLoadingBlock = true;
            var data = {};
            if (vm.idRequest) {
                data.proceso_id = vm.idRequest;
            }

            analystService.getDataRequestAnalyst(data, function (resolve) {
                setModelRequest(resolve.data.requisicion);
                vm.showLoadingBlock = false;
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
                vm.showLoadingBlock = false;
            });

        }

        function setModelRequest(data) {
            vm.data = data;
            vm.values = data.data;
            vm.lists = vm.data.listas;
            vm.fields = ValidationService.disableField(vm.data.estructura_campos, vm.values);
            vm.extra = vm.data.extra;
            vm.observations = vm.data.observaciones;
            vm.setValuesWatch();
            vm.change = false;
            vm.setBlocks();
            //vm.getPositionColaborators(vm.values.cargo_id);
            ValidationService.generalFunctions($scope, vm);
            ValidationService.watchFunctions($scope, vm);
        }

        function showToast(data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }


        getDataRequestAnalyst();
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').controller('CandidateDetailController', CandidateDetailController);

    function CandidateDetailController(AdminService, AuthService, CandidateService, ValidationService, IkanoFactory, analystConstant, analystService, $state, $scope, $mdDialog, $document, analystMisc, $mdSidenav, $mdDateLocale, $rootScope, $q, $mdToast, $window, $filter) {
        //Le asignamos un alias al controlador
        var vm = this;

        vm.idRequest = $state.params.request_id;
        vm.idCandidate = $state.params.candidate_id;

        vm.loading = true;
        vm.resume = null;
        vm.blocks = [];
        vm.attachments = null;
        vm.candidate = null;
        vm.history = null;
        vm.request = null;
        vm.analyst = true;
        vm.positions = null;
        //miscelaneos
        vm.misc = {};
        vm.misc.hover = {};
        vm.misc.lists = {};
        vm.validationService = ValidationService;
        vm.messages = [];

        vm.pageInfo = analystConstant.PAGESINFO.DETAILCANDIDATE;
        //MISC texto para reemplazar
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

        vm.projectName = analystConstant.DEFAULT.DATA.HEADER.KEYSDETAILREQUEST.CANDIDATE;

        //Informacion de la pagina
        vm.project = vm.selectedProject = analystMisc.header.getProject(vm.projectName);

        //projects
        vm.projects = analystMisc.header.getHeaderProjects();

        //GET CANDIDATE
        vm.idCandidates = analystMisc.returnVar('candidates');

        //ROOTSCOPE
        $rootScope.$on('candidatesFilter', function (evt, arg) {
            vm.idCandidates = analystMisc.returnVar('candidates');
        });

        //CandidatesInfo
        vm.candidatesRequest = [];
        vm.positionCandidate = {};
        vm.onlyCandidateNotView = (localStorage.onlyCandidateNotView == "true") ? true : false;

        //INFORME PARA EL CLIENTE
        vm.reporrForTheClient;
        vm.showReporrForTheClient = false;
        vm.fields = [];

        $rootScope.$on('setRequest', function (evt, arg) {
            vm.request = arg;
        });



        vm.getCandidateRequest = function () {
            analystService.getCandidateDetail(
                { hv_id: vm.idCandidate, proceso_id: vm.idRequest },
                function (response) {
                    if (response.data.hoja_vida.data_bloques) {
                        vm.resume = response.data.hoja_vida.data_bloques;
                        vm.lists = response.data.hoja_vida.listas;
                        vm.attachments = response.data.hoja_vida.adjuntos;
                        vm.positions = response.data.cargos;
                        vm.candidate = response.data.candidato;
                        vm.stageSelected = vm.candidate.etapa;
                        vm.candidates = response.data.candidatos;
                        vm.blockStage = response.data.bloques_etapas_candidato;
                        vm.stages = vm.mergeStage(response.data.etapas, vm.blockStage);
                        vm.modelNotes(vm.candidate.notas)
                            .then(function (resolve) {
                                vm.candidate.notes = resolve;
                            });
                        vm.candidate.cita = vm.setCita(vm.candidate.citas);
                        vm.history = response.data.historial;
                        vm.candidatesRequest = $filter('orderBy')(response.data.candidatos, 'hoja_vida_id');
                        vm.countCandidatesInRequest();
                        vm.setMiscSelect(response.data.listas);
                        vm.setTitles();
                        //SON PARA BUSCAR CANDIDATOS NO TOCAR
                        response.data.proceso.cargos = response.data.cargos;
                        response.data.proceso.listas = response.data.listas;
                        // END SON PARA BUSCAR CANDIDATOS NO TOCAR
                        $rootScope.$broadcast('setModelRequest', response.data.proceso);
                        $rootScope.$broadcast('change::listRequest', response.data.listas);
                        $rootScope.$broadcast('set-candidate', { candidateCount: vm.candidatesRequest.length });
                        vm.infoBlockReportClient = response.data.bloques_informe_cliente;

                        //vm.setBlockReportForClient(response.data.bloques_informe_cliente);
                    }
                    vm.loading = false;
                },
                function (response) {
                    vm.loading = false;
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };

        vm.getCandidateRequest();

        vm.urlBase = CandidateService.getUrlBase();

        vm.setTitles = function () {
            vm.blocks = $.map(vm.resume, function (value, index) {
                value.titulo = value.titulo.split(" ");
                value.name = index;
                value.emptyRowsMessage = "Por favor completa todos lo datos solicitados. Esto hará que la calidad de la información de tu hoja de vida mejore y agilize el proceso de selección";
                value.item = (value.data && !value.data.length ? value.data : null);

                if (value.name == "personales") {
                    value.data.foto = value.data.foto + "?v=" + vm.getRandomNumber();
                }

                return [{ name: index, data: value }];
            });
        };

        vm.setBlockReportForClient = function () {
            vm.reportClientData = {};
            vm.reportClientData.data = {
                bloques: vm.infoBlockReportClient.bloques,
                data: vm.infoBlockReportClient.data,
                estructura_campos: vm.infoBlockReportClient.estructura_campos,
                listas: vm.infoBlockReportClient.listas
            }
            vm.reportClientData.values = vm.reportClientData.data.data;
            vm.reportClientData.lists = vm.reportClientData.data.listas;
            //vm.fields = vm.data.estructura_campos;

            vm.reportClientData.fields = ValidationService.disableField(vm.reportClientData.data.estructura_campos, vm.reportClientData.values);

            vm.reportClientData.extra = vm.reportClientData.data.extra;

            vm.reportClientData.observations = vm.reportClientData.data.observaciones;
            //vm.setPageData();

            vm.setValuesWatch(vm.reportClientData);
            vm.change = false;
            vm.setBlocks();
            ValidationService.generalFunctions($scope, vm.reportClientData);
        }

        /**
         * SET HOVER
         */
        vm.setHover = function (key) {
            if (vm.misc.hover[key]) {
                vm.misc.hover[key] = false;
            } else {
                vm.misc.hover[key] = true;
            }
        }

        //SAVE MARKER
        vm.saveMarker = function () {
            analystService.saveMarker({ mark: vm.markerSelected, hoja_vida_id: vm.idCandidate }, function (resolve) {
                if (resolve.data.status) {
                    vm.showMarker = false;
                    vm.candidate.origen_custom = angular.copy(vm.markerSelected);
                    vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
                } else {
                    vm.showToast({ class: "error", message: resolve.data.message, showClose: true });
                }
            }, function (reject) {
                candidate.loadingMarker = false;
                IkanoFactory.showAlert("Error", reject.data.message);
            })
        }

        /**
         * INFORME PARA EL CLIENTE
         */

        vm.setPageData = function () {
            vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
            vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
            if (vm.data.data.no_vacantes) {
                var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
                vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
            }

            vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
            if (vm.data.data.tipo_solicitud_b_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
            }
            if (vm.data.data.tipo_solicitud_c_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
            }
        };

        vm.setValuesWatch = function (root) {
            ValidationService.setWarchers($scope, root);
        };

        vm.setBlocks = function () {
            vm.blocksReportForClient = $.map(vm.reportClientData.data.bloques, function (value, index) {
                return [vm.getBlock(index, value)];
            });
        };

        vm.getBlock = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.campos
            };

            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }

            return block;
        };

        /*vm.addModelToBlock = function (block) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            vm.values[block.model].push(model);
        }*/

        vm.removeModelToBlock = function (block, index) {
            vm.values[block.model].splice(index, 1);
        }

        vm.getPositionColaborators = function (position) {
            AdminService.getPositionColaborators({ cargo_id: position,proceso_id:vm.idRequest }, {},
                function (response) {
                    if (response.data.colaboradores) {
                        vm.lists.position_colaborators = response.data.colaboradores;
                    }
                },
                function (response) {
                    //IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };

        vm.saveReportForToclientFn = function () {
            var dataPost = {
                proceso_id: vm.idRequest,
                hv_id: vm.idCandidate,
            }
            vm.reportClientData.errors = IkanoFactory.validateFieldsWithObject(vm.reportClientData.fields, vm.reportClientData.values, true);
            if (angular.equals(vm.reportClientData.errors, {})) {
                dataPost.data = vm.reportClientData.values;
                analystService.saveReportForToclient(dataPost,
                    function (response) {
                        if (response.data.status) {
                            vm.showToast({ class: "success", message: response.data.message, showClose: true });
                        } else {
                            vm.showToast({ class: "error", message: response.data.message, showClose: true });
                        }
                    },
                    function (response) {
                        IkanoFactory.showAlert("Error", response.data.message);
                        vm.saving = false;
                        vm.change = true;
                    }
                );
            } else {
                IkanoFactory.showAlert("Error", "El entendimiento se encuentra incompleto, por favor complete los campos antes de enviar aprobación.");
            }
        }

        /***
         * END INFORME PARA EL CLIENTE
         */

        //Retorna las notas serializadas
        vm.modelNotes = function (data) {
            var baseJson = analystConstant.KEYJSONNOTE;
            baseJson.analista.callback = "getOneKey";
            baseJson.fecha.callback = "setFormatDate";
            return analystMisc.modeldataarray(data, baseJson);
        }

        //Modelamos la data de la request   
        vm.modelRequest = function (request) {
            var baseJson = (analystConstant.DEBUG) ? analystConstant.KEYJSONREQUESTDEBUG : analystConstant.KEYJSONREQUEST;
            analystMisc.modeldata(request, baseJson)
                .then(function (resolve) {
                    vm.request = resolve;
                    var dateSerializate = IkanoFactory.betweenDatesToReplace(vm.misc.text_date_request, vm.request.date_request);
                    vm.request.date_request_compared_string = analystMisc.misc.setStringDateInMonth(dateSerializate);
                    vm.request.date_request_format = analystMisc.misc.setFormatDate(vm.request.date_request, 'MMM D, YYYY');
                    vm.request.date_publish_start_string = (vm.request.date_publish) ? analystMisc.misc.setFormatDate(vm.request.date_publish, 'MMMM D') : '';
                    vm.request.date_publish_close_string = (vm.request.date_publish_close) ? analystMisc.misc.setFormatDate(vm.request.date_publish_close, 'MMMM D') : '';

                    vm.modelNotes(vm.request.notes).then(function (resolve) {
                        vm.request.notes = resolve;
                    });

                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }

        vm.setMiscSelect = function (data, config) {
            vm.misc.lists.placeCita = data.lugares;
            vm.misc.lists.typeCita = data.tipos_cita;
            vm.misc.lists.tipos_marca_hv = data.tipos_marca_hv;
        }


        vm.setCita = function (value) {
            var objReturn = {};

            if (value.length == 0) {
                return objReturn;
            }
            objReturn.citas = analystMisc.misc.orderDates(value, 'fecha_hora', 'nameShow', 'MMM D, YYYY hh:mm A');
            objReturn.cita = analystMisc.misc.nextCita(objReturn.citas);
            return objReturn;
        }

        vm.changeOnlyCandidateNotView = function () {
            localStorage.onlyCandidateNotView = vm.onlyCandidateNotView;
            vm.countCandidatesInRequest();
        }
        //RECORRER DE CANDIDATO EN CANDIDATO
        vm.countCandidatesInRequest = function () {
            if (vm.onlyCandidateNotView) {
                vm.misc.candidatesRequest = analystMisc.misc.searchDataInArrayObject(vm.candidatesRequest, 'vista', null);
            } else {
                vm.misc.candidatesRequest = angular.copy(vm.candidatesRequest);
            }
            vm.positionCandidate = vm.getPositionCandidate(vm.idCandidate);
        }

        vm.getPositionCandidate = function (idCandidate) {
            var returnPositionCandidate = {};
            for (var i in vm.misc.candidatesRequest) {
                if (vm.misc.candidatesRequest[i].hoja_vida_id == idCandidate) {
                    returnPositionCandidate.positionReal = parseInt(i);
                    returnPositionCandidate.positionShow = parseInt(i) + 1;
                    break;
                }
            }
            return returnPositionCandidate;
        }

        vm.backCandidate = function () {

            $state.transitionTo($state.current, {
                request_id: vm.idRequest,
                candidate_id: vm.misc.candidatesRequest[vm.positionCandidate.positionReal - 1].hoja_vida_id
            }, {
                    reload: true, inherit: false, notify: true
                });
        }

        vm.nextCandidate = function () {
            $state.transitionTo($state.current, {
                request_id: vm.idRequest,
                candidate_id: vm.misc.candidatesRequest[vm.positionCandidate.positionReal + 1].hoja_vida_id
            }, {
                    reload: true, inherit: false, notify: true
                });
        }

        //setea una fecha con un formato expecifico
        vm.setFormatDate = function (v, config) {
            return moment(v).format(config.format);
        }

        vm.getAttachmentUrl = function (attachment) {
            var id = (typeof attachment !== "number") ? attachment.id : attachment;
            analystService.getFile({ id: id }, { responseType: 'arraybuffer' },
                function (response) {
                    IkanoFactory.downloadFile(response.data, attachment.name)
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error descargando el archivo, por favor intente de nuevo.");
                });
        }

        vm.getProfilePictureSrc = function (picture) {
            return (picture ? CandidateService.getUrlBase() + "/" + picture : "assets/images/avatars/profile.jpg");
        };

        vm.getBlockData = function (block, data) {
            block.item = data;
            return block;
        };

        vm.getDiffBetweenTwoDates = IkanoFactory.getDiffBetweenTwoDates;

        vm.getColorBlockIndicator = function (state) {
            if (state) {
                return "green-500-bg";
            } else {
                return "orange-500-bg";
            }
        };

        vm.getIconBlockIndicator = function (state) {
            if (state) {
                return "icon-checkbox-marked";
            } else {
                return "icon-information-outline";
            }
        };

        vm.getOrdinalNumber = IkanoFactory.getOrdinalNumber;

        vm.validateAttachment = function (mod) {
            if (mod && !vm.attachments[mod]) {
                vm.attachments[mod] = [];
            }
        };

        vm.validateMultipleAttachment = function (mod, id) {
            if (mod && !vm.attachments[mod]) {
                vm.attachments[mod] = {};
                vm.attachments[mod][id] = [];
            }
        };

        vm.getRandomNumber = function () {
            return Math.floor((Math.random() * 100) + 1);
        };

        vm.markAsFavorite = function () {
            //vm.loading = true;
            analystService.setFavorite({ hv_id: vm.candidate.id },
                function (response) {
                    if (response.data && response.data.status) {
                        vm.candidate.favorita = (vm.candidate.favorita ? 0 : 1);
                    }
                    vm.loading = false;
                },
                function (response) {
                    vm.loading = false;
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };

        vm.addNoteRequest = function (data) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.observacion = data.note;
            data.note = '';
            analystService.addNoteRequest(dataPost, function (response) {
                var newNota = {};
                newNota.name = AuthService.getUserData().name;
                newNota.id = response.data.result.id;
                newNota.date_create_note = vm.setFormatDate(response.data.result.created_at, { format: 'MMM D, YYYY H:mm ' });
                newNota.note = response.data.result.descripcion;
                newNota.newNote = true;
                vm.request.notes.unshift(newNota);
                newNota = {};
            }, function (reject) {
                vm.loading = false;
                IkanoFactory.showAlert("Error", "Ha ocurrido un error creando la nota del proceso, por favor intente de nuevo.");
            });
        }


        vm.setNoteRequest = function () {
            var configModal = {};
            configModal.data = {};
            configModal.toolbar = {};
            configModal.toolbar.name = 'Notas: ' + vm.request.name;
            configModal.hideVisibility = true;
            configModal.toolbar.class = { 'green-300-bg': true };
            configModal.notes = vm.request.notes;
            configModal.callbackSuccess = vm.addNoteRequest;
            configModal.templateUrl = 'app/main/analyst/partials/notes/noteDialog.html';
            vm.showModal(configModal);
        }

        vm.addNoteCandidate = function (data) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.hoja_vida_id = vm.candidate.id;
            dataPost.nota = data.note;
            dataPost.visibilidad = data.visualize;
            data.note = '';
            analystService.addNote(dataPost, function (response) {
                var newNota = {};
                newNota.name = AuthService.getUserData().name;
                newNota.id = response.data.result.id;
                newNota.date_create_note = vm.setFormatDate(response.data.result.created_at, { format: 'MMM D, YYYY hh:mm a' });
                newNota.note = response.data.result.nota;
                newNota.visibility = response.data.result.visibilidad;
                newNota.newNote = true;
                vm.candidate.notas.unshift(newNota);
                newNota = {};

            }, function (reject) {
                vm.loading = false;
                IkanoFactory.showAlert("Error", "Ha ocurrido un error creando la nota del candidato, por favor intente de nuevo.");
            });

        }

        vm.setNoteCandidate = function (candidate) {
            var configModal = {};
            configModal.data = {};
            configModal.toolbar = {};
            configModal.toolbar.name = "Notas: " + candidate.nombre;
            configModal.toolbar.class = {};
            configModal.notes = candidate.notas;
            configModal.data.visualize = 1;
            configModal.dataCandidate = candidate;
            configModal.callbackSuccess = vm.addNoteCandidate;
            configModal.templateUrl = 'app/main/analyst/partials/notes/noteDialog.html';
            vm.showModal(configModal);
        }

        vm.setScheduleCandidate = function () {
            var configModal = {};
            configModal.toolbar = {};
            configModal.toolbar.name = 'Agendar cita con el candidato';
            configModal.toolbar.class = {};
            configModal.data = vm.candidate.cita.cita;
            configModal.citas = vm.candidate.cita.citas;
            configModal.dataCandidate = {
                name: vm.candidate.nombre,
                email: vm.candidate.correo,
                email_alternative: vm.candidate.correo_alternativo,
                cell_phone: vm.candidate.celular,
                phone: vm.candidate.telefono
            };
            configModal.lists = vm.misc.lists;
            vm.candidateSelected = vm.candidate;
            configModal.callbackSuccess = vm.addScheduleCandidate;

            configModal.templateUrl = 'app/main/analyst/partials/scheduled_citation/scheduled_citationDialog.html';

            vm.showModalScheduleCandidate(configModal);
        }

        vm.addScheduleCandidate = function (data) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.hoja_vida_id = vm.candidateSelected.id;
            var dateFinal = moment(data.dateSelected).format('YYYY-MM-DD');
            var hourFinal = moment(data.timeSelected).format('HH:mm:ss');
            dataPost.fecha_hora = moment(dateFinal + ' ' + hourFinal).utc().format('YYYY-MM-DD HH:mm:ss');
            dataPost.lugar = data.placeSelected;
            dataPost.tipo_cita = data.typecitaSelected;
            analystService.addScheduleCandidate(dataPost, function (response) {
                response.data.result.fecha = response.data.result.fecha_hora;
                vm.candidate.citas.push(response.data.result);
                vm.candidate.cita = vm.setCita(vm.candidate.citas);
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error agendando el candidato, por favor intente de nuevo.");
            });
        }

        vm.showModalScheduleCandidate = function (configModal) {
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: configModal.templateUrl,
                clickOutsideToClose: true,
                controller: 'scheduledCitationCandidateDialog',
                controllerAs: 'vm',
                locals: {
                    config: configModal
                }
            });
        }


        vm.showModal = function (configModal) {
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: configModal.templateUrl,
                locals: {
                    config: configModal
                },
                controller: ControllerDialog
            });
        }

        function ControllerDialog($scope, $mdDialog, config) {
            $scope.data = config.data;
            $scope.showForm = false;
            $scope.config = config;
            $scope.candidate = config.dataCandidate;


            $scope.changeForm = function () {
                if ($scope.showForm) {
                    $scope.showForm = false;
                } else {
                    $scope.showForm = true;
                }
            }

            $scope.closeDialog = function () {
                $mdDialog.hide();
            }
        }

        vm.openRecommendCandidateDialog = function () {
            $mdDialog.show({
                controller: 'RecommendCandidateController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/recommend-candidate.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    positions: vm.positions,
                    candidate: vm.candidate,
                }
            });
        };

        vm.openShowCandidateNotesDialog = function () {
            $mdDialog.show({
                controller: 'ShowCandidateNotesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-candidate-notes.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    candidate: vm.candidate,
                    request: vm.request,
                    title: "Notas"
                }
            });
        }

        vm.openShowCandidateHistoryDialog = function () {
            $mdDialog.show({
                controller: 'ShowCandidateHistoryController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-candidate-history.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    candidate: vm.candidate,
                    history: vm.history,
                    blockStage: vm.blockStage,
                    
                }
            });
        }

        vm.openShowRequestNotesDialog = function () {
            $mdDialog.show({
                controller: 'ShowRequestNotesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-request-notes.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request,
                    callbackSuccess: vm.addNoteRequest
                }
            });
        }

        vm.showModalEditOffer = function () {
            $mdDialog.show({
                controller: 'changeDatePublicController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/change_date_public_request/change_date_public_request.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            });
        }

        vm.showModalInfoToClient = function () {
            $mdDialog.show({
                controller: 'ReportForTheClient',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/report-for-the-client.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    blocks: vm.reporrForTheClient
                }
            });
        }

        vm.showReportForToclientFn = function () {
            vm.showStageSelected = false;
            if (vm.showReporrForTheClient) {
                vm.showReporrForTheClient = false;
            } else {
                vm.setBlockReportForClient();
                vm.showReporrForTheClient = true;
            }
        }

        vm.showHV = function () {
            vm.showStageSelected = false;
            vm.showReporrForTheClient = false;
        }

        /**
         * ETAPAS
         */

        /**
          *  ACCIONES PRINCIPALES
          */
        vm.downloadPdfStage = function () {
            analystService.downloadStage({ proceso_id: vm.idRequest, hoja_vida_id: vm.idCandidate, etapa_id: vm.stage.id }, { responseType: 'arraybuffer' },
                function (response) {
                    IkanoFactory.downloadFile(response.data, vm.stage.etapa + '.pdf')
                },
                function (response) {
                    IkanoFactory.showAlert("Error", "Ha ocurrido un error descargando el archivo, por favor intente de nuevo.");
                })
        }

        vm.updateStage = function () {
            vm.editStage = true;
            vm.modifiStage = true;
            vm.setHover('updateStage');
        }

        vm.assignStage = function () {
            vm.editStage = true;
            vm.approbeStage = true;
            vm.goToStage(vm.stage, {}, 0, true);
            vm.setHover('assignStage');
        }


        vm.mergeStage = function (etapa, bloque) {
            var data = bloque.data;
            for (var i in etapa) {
                if (data[etapa[i].id]) {
                    etapa[i].aprueba = angular.copy(data[etapa[i].id].aprueba);
                } else {
                    etapa[i].aprueba = 0;
                }

                if (etapa[i].id == 10) {
                    vm.stageDiscard = etapa[i];
                }
            }
            return etapa;
        }

        vm.changeStage = function (stage, saveStage) {
            vm.data = {};
            if (stage.confirmar) {
                vm.stage = angular.copy(stage);
            } else {
                vm.stageSelected = stage;
                vm.stage = angular.copy(vm.stageSelected);
            }
            vm.showReporrForTheClient = false;
            vm.editStage = false;
            vm.modifiStage = false;
            vm.approbeStage = false;
            vm.validateStage(stage);
            if (saveStage && !stage.confirmar) {
                vm.assignStage();
            }
        }

        vm.validateStage = function (stage) {
            var keys = [];
            var jsonReturn = {};

            if (stage.confirmar && !stage.descartar && !stage.etapa) {
                var stageNoApprove = vm.searchStageApprove();
                vm.showModalStageConfirm(stageNoApprove.arrStageIncompletTerna);
                vm.goNextStage = (stage.req_aprobacion) ? true : false;
                return;
            }

            if (stage.confirmar && stage.descartar) {
                vm.showModalStageDiscard();
                vm.goNextStage = false;
                return;
            }

            if (stage.confirmar && stage.etapa) {
                var stageNoApprove = vm.searchStageApprove();
                vm.showModalStageBlock(stage, stageNoApprove.arrStageIncomplet);
                vm.goNextStage = false;
                return;
            }
            if (typeof stage.etapa != "undefined" && stage.etapa != null) {
                vm.showStageSelected = true;
                vm.searchBlockStage(stage);
                return;
            }

            if (!stage.confirmar && !stage.descartar && !stage.req_aprobacion && !stage.etapa) {
                vm.showStageSelected = false;
                vm.goNextStage = false;
                vm.saveStage(stage, false, 1, true);
                return;
            }

        }

        vm.searchStageApprove = function () {
            var arrStageIncomplet = [];
            var arrStageIncompletTerna = [];
            for (var i in vm.stages) {
                if (vm.stages[i].etapa_requerida) {
                    if (vm.stages[i].aprueba != 1) {
                        arrStageIncomplet.push(vm.stages[i]);
                    }
                }
                if (vm.stages[i].etapa_requerida_terna) {
                    if (vm.stages[i].aprueba != 1) {
                        arrStageIncompletTerna.push(vm.stages[i]);
                    }
                }
            }
            return { arrStageIncomplet: arrStageIncomplet, arrStageIncompletTerna: arrStageIncompletTerna };
        }

        vm.searchBlockStage = function (stage) {

            var valueStage = (vm.blockStage.data[stage.id]) ? vm.blockStage.data[stage.id] : {};
            vm.blockAutoRellenar = [];
            vm.stageData = {};
            vm.stageData.data = {
                bloques: vm.blockStage.bloques[stage.etapa],
                data: valueStage,
                estructura_campos: vm.blockStage.estructura_campos,
                listas: vm.blockStage.listas
            }

            vm.stageData.attachments = vm.blockStage.adjuntos;

            vm.stageData.extra = {
                etapa_id: stage.id,
                proceso_id: vm.idRequest,
                hv_id: vm.idCandidate
            }

            vm.stageData.getAttachmentUrl = vm.getAttachmentUrl;

            vm.stageData.values = vm.stageData.data.data;
            if (!angular.equals(vm.stageData.values, {})) {
                vm.misc.values = {};
                vm.misc.values.created_at = moment(vm.stageData.values.created_at).format('MMM D, YYYY hh:mm a');
                vm.misc.values.updated_at = moment(vm.stageData.values.updated_at).format('MMM D, YYYY hh:mm a');
                vm.misc.values.analista = angular.copy(vm.stageData.values.analista);
            } else {
                vm.misc.values = false;
            }


            vm.stageData.lists = vm.stageData.data.listas;

            vm.stageData.fields = vm.getFieldsEtapa(vm.stageData.data.estructura_campos, vm.stageData.data.bloques);
            if (vm.blockAutoRellenar.length > 0) {
                vm.stageData.values = vm.autoRellenarBloque(vm.stageData.data, vm.stageData.lists);
            }

            vm.backupValues = angular.copy(vm.stageData.values);

            vm.setBlocksStage();
            vm.setValuesWatch(vm.stageData);
        }

        vm.autoRellenarBloque = function (data, lists) {
            var campos = [];
            var jsonReturn = {};
            //BLOQUES QUE TIENEN AUTORELLENAR
            for (var i in vm.blockAutoRellenar) {
                //VALIDO SI EL BLOQUE ES HAS MANY
                if (vm.blockAutoRellenar[i].type == "has_many") {
                    //CAMPOS POR MODEL
                    campos = data.estructura_campos[vm.blockAutoRellenar[i].model];
                    jsonReturn[vm.blockAutoRellenar[i].model] = [];
                    //FOR CAMPOS
                    for (var c in campos) {
                        if (campos[c].auto_rellenar) {
                            jsonReturn[vm.blockAutoRellenar[i].model] = vm.mergeDataLists(campos[c].options, campos, lists);
                            break;
                        }
                    }
                }
            }
            return jsonReturn;
        }

        vm.mergeDataLists = function (campo_autorellenar, campos, lists) {
            var data = Object.keys(lists[campo_autorellenar]);
            var dataReturn = [];
            for (var i in data) {
                var dataJsonReturn = {};

                for (var c in campos) {
                    if (campos[c].auto_rellenar) {
                        dataJsonReturn[c] = data[i];
                    } else {
                        dataJsonReturn[c] = "";
                    }
                };

                dataReturn.push(dataJsonReturn);
            }
            return dataReturn;
        }

        /**
         * BLOQUES ETAPA
         */


        /**
         *  Return fields in block and set vm.blockHasMany
         */
        vm.getFieldsEtapa = function (fields, bloques) {
            var objReturn = {};
            for (var i in bloques) {
                if (bloques[i].auto_rellenar) {
                    vm.blockAutoRellenar.push(bloques[i]);
                }
                for (var j in bloques[i].campos) {
                    var keySearch = "";
                    if (bloques[i].type == "has_many") {
                        keySearch = bloques[i].model;
                    } else {
                        keySearch = bloques[i].campos[j];
                    }

                    objReturn[keySearch] = fields[keySearch];
                }
            }
            return objReturn;
        }

        vm.setBlocksStage = function () {
            vm.blocksStage = $.map(vm.stageData.data.bloques, function (value, index) {
                return [vm.getBlockStage(index, value)];
            });
        };


        vm.getBlockStage = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: (data.etapa == "informacion_seleccion" ? data.etapa : data.model),
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.campos,
                collapse: (data.etapa == 'pruebas'),
                hideCollapse: (data.etapa == 'pruebas'),
            };
            if (block.name == "info_general") {
                block.type = "one-column";
            } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                block.type = "select-current-employee";
            } else if (block.fields.length < 2) {
                block.type = "one-column";
            } else if (data.type == "has_many") {
                block.type = "two-column-multiple-rows";
            }

            return block;
        };

        vm.addModelToBlock = function (block, root) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            if (!root) {
                if (vm.values[block.model] == "undefined" || vm.values[block.model] == null) {
                    vm.values[block.model] = [];
                }
                vm.values[block.model].push(model);
            } else {
                if (root.values[block.model] == "undefined" || root.values[block.model] == null) {
                    root.values[block.model] = [];
                }
                root.values[block.model].push(model);
            }



        }

        vm.removeModelToBlock = function (block, index, root) {
            if (root) {
                root.values[block.model].splice(index, 1);
            } else {
                vm.values[block.model].splice(index, 1);
            }

        }
        vm.serializeField = function (fields, blocks) {
            var jsonReturn = {};
            var block = {};
            var campo = {};
            for (var i in blocks) {
                block = blocks[i]
                for (var f in block.campos) {
                    campo = block.campos[f];
                    if (fields[campo]) {
                        jsonReturn[campo] = fields[campo];
                    }
                }
            }
            return jsonReturn;
        }

        vm.setNewStage = function (stage, showStage, approve) {
            $("#content").animate({ scrollTop: 0 }, "slow");
            vm.stageSelected.aprueba = approve;
            //vm.candidate.etapa = angular.copy(vm.stageSelected);
            vm.showStageSelected = showStage;
            for (var i in vm.stages) {
                if (vm.stages[i].id == stage.id) {
                    vm.stages[i].aprueba = approve;
                    if (vm.goNextStage) {
                        var indexStage = parseInt(i) + 1;
                        if (vm.stages[indexStage].id == 9) {
                            return;
                        }
                        vm.changeStage(vm.stages[indexStage], true);
                    }
                }
            }
        }

        /**
         * END BLOQUES ETAPA
         */

        /**
         * SAVE UPDATE
         */
        vm.cancelUpdate = function () {
            vm.editStage = false;
            vm.modifiStage = false;
            vm.data.data = angular.copy(vm.backupValues);
            vm.setHover('updateStage');
        }

        vm.validateUpdate = function () {

            vm.stageData.errors = IkanoFactory.validateFieldsWithObject(vm.stageData.fields, vm.stageData.values, true);
            if (angular.equals(vm.stageData.errors, {})) {
                // vm.errors = IkanoFactory.validateFieldsWithObject(vm.stageData.fields, vm.stageData.values, true);
                // console.log(vm.fields, vm);
                // if (angular.equals(vm.errors, {})) {
                vm.errors = {};
                vm.saveUpdate(vm.stage, vm.stageData.values);
            } else {
                IkanoFactory.showAlert("Error", "La información de la etapa esta incompleta, por favor intente de nuevo.");
            }
        }

        /**
         * SAVE CHANGE IN STAGE
         */
        vm.saveChangeStage = function (stage, data) {
            vm.blockStage.data[stage.id] = data;
        }

        /**
         * GUARDAR ETAPA
         */

        vm.saveUpdate = function (stage, data) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.hv_id = vm.idCandidate;
            dataPost.etapa_id = stage.id;
            dataPost.data = (!data) ? {} : data;
            analystService.saveStage(dataPost, function (response) {
                if (response.data.status) {
                    vm.backupValues = angular.copy(data);
                    vm.editStage = false;
                    vm.modifiStage = false;
                    vm.saveChangeStage(vm.stage, angular.copy(data));
                    vm.showToast({ class: "success", message: response.data.message, showClose: true });
                    vm.setHover('updateStage');
                } else {
                    IkanoFactory.showAlert("Error", response.data.message);
                }

            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        /**
         * PASAR ETAPA
         */
        vm.goToStage = function (stage) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.hv_id = vm.idCandidate;
            dataPost.etapa_id = stage.id;
            dataPost.pasar_etapa = 1;
            dataPost.data = (!vm.blockStage.data[stage.id]) ? {} : vm.blockStage.data[stage.id];

            analystService.saveStage(dataPost, function (response) {
                if (response.data.status) {
                    vm.backupValues = angular.copy(dataPost.data);
                    vm.editStage = true;
                    vm.approbeStage = true;
                    vm.candidate.etapa = angular.copy(stage);
                } else {
                    IkanoFactory.showAlert("Error", response.data.message);
                }

            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }
        /**
         * GUARDAR ETAPA
         */
        vm.saveStage = function (stage, data, approve, shownextStage) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.hv_id = vm.idCandidate;
            dataPost.etapa_id = stage.id;
            dataPost.aprueba = approve;
            dataPost.data = (!data) ? {} : data;

            analystService.saveStage(dataPost, function (response) {
                if (response.data.status) {
                    vm.backupValues = angular.copy(data);
                    vm.editStage = false;
                    vm.approbeStage = false;
                    vm.candidate.etapa = angular.copy(stage);
                    vm.saveChangeStage(stage, data);
                    vm.setNewStage(stage, !shownextStage, approve, true);
                    vm.showToast({ class: "success", message: response.data.message, showClose: true });

                } else {
                    vm.showToast({ class: "error", message: response.data.message, showClose: true });
                }

            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.validateDataStage = function (approve, goNextStage) {
            vm.goNextStage = goNextStage;
            if (!approve) {
                if (vm.stage.descartar) {
                    vm.showModalStageDiscard();
                } else {
                    vm.saveStage(vm.stage, {}, approve);
                }
            } else {
                vm.stageData.errors = IkanoFactory.validateFieldsWithObject(vm.stageData.fields, vm.stageData.values, true);
                if (angular.equals(vm.stageData.errors, {})) {
                    vm.stageData.errors = {};
                    vm.saveStage(vm.stage, vm.stageData.values, approve);
                } else {
                    IkanoFactory.showAlert("Error", "La información de la etapa esta incompleta, por favor intente de nuevo.");
                }
            }
        }

        vm.showModalStageDiscard = function () {
            var data = {
                bloques: vm.blockStage.bloques.candidato_descartado,
                data: {},
                estructura_campos: vm.serializeField(vm.blockStage.estructura_campos, vm.blockStage.bloques.candidato_descartado),
                listas: vm.blockStage.listas
            }

            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/discardStage.html',
                controller: 'DiscardStage',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    data: data,
                    stage: vm.stageDiscard,
                    idRequest: vm.idRequest,
                    idCandidate: vm.idCandidate,
                    title: 'Descartar candidato',
                    incompletStage: []
                }
            }).then(function (resolve) {
                if (resolve.data.status) {
                    vm.goNextStage = false;
                    vm.stageSelected = angular.copy(vm.stageDiscard);
                    vm.stage = angular.copy(vm.stageSelected);
                    vm.setNewStage(vm.stageDiscard, false, 0);
                    vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
                } else {
                    vm.showToast({ class: "error", message: resolve.data.message, showClose: true });
                }

            });
        }

        vm.showModalStageBlock = function (stage, incompletStage) {
            var data = {
                bloques: vm.blockStage.bloques[stage.etapa],
                data: (!vm.blockStage.data[stage.id] ? {} : vm.blockStage.data[stage.id]),
                estructura_campos: vm.serializeField(vm.blockStage.estructura_campos, vm.blockStage.bloques[stage.etapa]),
                listas: vm.blockStage.listas
            }

            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/discardStage.html',
                controller: 'DiscardStage',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    data: data,
                    stage: stage,
                    idRequest: vm.idRequest,
                    idCandidate: vm.idCandidate,
                    title: stage.name_corto,
                    incompletStage: incompletStage
                }
            }).then(function (resolve) {
                if (resolve.data.status) {
                    vm.goNextStage = false;
                    vm.stageSelected = angular.copy(stage);
                    vm.stage = angular.copy(vm.stageSelected);
                    vm.setNewStage(stage, false, 0);
                    vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
                } else {
                    vm.showToast({ class: "error", message: resolve.data.message, showClose: true });
                }

            });
        }

        vm.showModalStageConfirm = function (stageIncomplet) {

            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/confirmStage.html',
                controller: 'ConfirmStage',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    stageIncomplet: stageIncomplet,
                    stage: vm.stage,
                    idRequest: vm.idRequest,
                    candidate: vm.candidate
                }
            })
                .then(function (resolve) {
                    vm.goNextStage = false;
                    vm.stageSelected = angular.copy(vm.stage);
                    vm.stage = angular.copy(vm.stageSelected);
                    vm.setNewStage(vm.stage, false, 1);
                });
        }
        /**
         * FIN DE ETAPAS
         */


        /**
         * SHOW TOAST
         */

        vm.showToast = function (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        vm.pageCandidate = function () {
            $state.go('app.detail_seleccion_analyst.index', { request_id: vm.idRequest });
        }
        //SIDENAV
        vm.toggleSidenav = function (sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };

        vm.selectProject = function (project) {
            $state.go(project.url, { request_id: vm.idRequest, candidate_id: vm.idCandidate });
        }

        vm.publishRequest = function () {
            $state.go('app.publish_request', { request_id: vm.idRequest });
        }

        $mdDateLocale.formatDate = function (date) {
            return date ? moment(date).format('MMM D, YYYY') : '';
        };
    }
})();
(function () {
    'use strict';
    angular.module('app.seleccion_admin').controller('understandingChargeAdmin', understandingChargePrimary);

    function understandingChargePrimary(analystMisc, analystConstant, $state, analystService, ValidationService, IkanoFactory, $scope, AdminService, $mdDialog, $document, AuthService, $mdSidenav, $rootScope, $mdColors) {
        //definimos el contructor
        var vm = this;

        //PARAMS
        vm.idRequest = $state.params.request_id;
        vm.validationService = ValidationService;

        vm.request = {};


        // $rootScope.$on("understanding::save", function (evt, arg) {
        //     vm.validateUnderstandingBlock();
        // });

        //MISCELANEOS
        vm.misc = {};
        vm.misc.tabSelected = 'rq';

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;


        vm.projectName = analystConstant.DEFAULT.DATA.HEADER.KEYSDETAILREQUESTADMIN.UNDERSTANDING;
        //Informacion de la pagina
        vm.project = vm.selectedProject = analystMisc.header.getProject(vm.projectName);

        //MISC texto para reemplazar
        vm.misc.text_date_request = analystConstant.DEFAULT.DATA.DETAIL.TEXT_DATE_REQUEST;

        vm.pageInfo = analystConstant.PAGESINFO.UNDERSTANDINGPOSITION;

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        vm.showButton = false;

        //HEADER
        vm.showModalEditOffer = function () {
            $mdDialog.show({
                controller: 'changeDatePublicController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/change_date_public_request/change_date_public_request.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request
                }
            });
        }

        vm.openShowRequestNotesDialog = function () {
            $mdDialog.show({
                controller: 'ShowRequestNotesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-request-notes.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    request: vm.request,
                    callbackSuccess: vm.addNoteRequest
                }
            });
        }


        vm.selectProject = function (project) {
            $state.go(project.url, { request_id: vm.idRequest });
        }


        //SIDENAV
        vm.toggleSidenav = function (sidenavId) {
            $mdSidenav(sidenavId).toggle();
        };

        //SOCKET ANGULAR


        //Modelamos la data de la request   
        vm.modelRequest = function (request) {
            var baseJson = analystConstant.KEYJSONREQUEST;
            analystMisc.modeldata(request, baseJson, { createIfNotExist: true })
                .then(function (resolve) {
                    vm.request = resolve;
                    analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
                        vm.request.notes = resolve;
                    });
                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }

        vm.showToast = function (data, options) {
            options = (options) ? options : [];
            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        /***
         * HAAAAA
         */

        vm.getUnderstandingCharge = function () {
            AdminService.getUnderstandingCharge(
                { proceso_id: vm.idRequest },
                function (resolve) {
                    if (resolve.status == analystConstant.CODEPETITION.OK) {
                        vm.understandingBlocks = resolve.data.data.understanding;
                        vm.requestBlocks = resolve.data.data.requisition;
                        vm.modelRequestBlock();
                        vm.modelUnderstanding();
                        vm.modelRequest(resolve.data.data.process);
                    } else {
                        //AQUI VA EL TOAST
                    }
                }, function (reject) {
                    IkanoFactory.showAlert("Error", reject.message);
                }
            )

        };


        vm.modelUnderstanding = function () {
            vm.understanding = {};
            vm.setModelFrom = 1;
            vm.understanding.data = vm.understandingBlocks;
            vm.understanding.values = vm.understanding.data.data;
            vm.understanding.lists = vm.understanding.data.listas;
            vm.understanding.fields = ValidationService.disableField(vm.understanding.data.estructura_campos, vm.understanding.values);
            vm.understanding.extra = vm.understanding.data.extra;
            vm.understanding.observations = vm.understanding.data.observaciones;
            vm.setValuesWatch();
            vm.understanding.change = false;
            vm.blocksUnderstanding = vm.setBlocksUnderstanding(vm.understanding.data.bloques);
            setdateCreatedAndUpdate(vm.blocksUnderstanding, vm.understandingBlocks.fecha_creacion_bloques, vm.understandingBlocks.fecha_actualizacion_bloques);
            vm.understanding.getPositionColaborators = vm.getPositionColaborators;
            ValidationService.generalFunctions($scope, vm.understanding);
            //ValidationService.watchFunctions($scope, vm.understanding, 'understanding');
        };

        vm.modelRequestBlock = function () {
            vm.proccess = {};
            vm.setModelFrom = 2;
            vm.proccess.data = vm.requestBlocks;
            vm.proccess.values = vm.proccess.data.data;
            vm.proccess.lists = vm.proccess.data.listas;
            //vm.fields = vm.data.estructura_campos;
            vm.proccess.fields = ValidationService.disableField(vm.proccess.data.estructura_campos, vm.proccess.values);
            vm.proccess.extra = vm.proccess.data.extra;
            vm.proccess.observations = vm.proccess.data.observaciones;
            //vm.setPageData();
            vm.setValuesWatch();
            vm.proccess.change = false;
            //vm.setBlocksRequest();
            vm.blocksRequests = vm.setBlocks(vm.proccess.data.bloques);

            vm.proccess.getPositionColaborators = vm.getPositionColaborators;
            ValidationService.generalFunctions($scope, vm.proccess);
        };

        vm.setPageData = function () {
            vm.pageInfo.title = '<span class="blue-500-fg">' + vm.data.data.codigo + ' | </span>';
            vm.pageInfo.title += '<span class="pl-5">' + IkanoFactory.capitalize(vm.data.data.cargo_ocupar, true) + '</span>';
            if (vm.data.data.no_vacantes) {
                var v = " VACANTE" + (vm.data.data.no_vacantes > 1 ? "S" : "");
                vm.pageInfo.title += '<span class="text-boxed white-fg h7 brad-10 orange-bg">' + vm.data.data.no_vacantes + v + '</span>';
            }

            vm.pageInfo.subtitle = '<div class="h4">' + vm.data.data.tipo_solicitud_label + '</div>';
            if (vm.data.data.tipo_solicitud_b_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_b_label + '</div>';
            }
            if (vm.data.data.tipo_solicitud_c_label) {
                vm.pageInfo.subtitle += '<div class="grey-fg h6">' + vm.data.data.tipo_solicitud_c_label + '</div>';
            }
        };

        vm.setValuesWatch = function () {
            ValidationService.setWarchers($scope, vm);
        };

        vm.setBlocksUnderstanding = function (bloques) {
            return $.map(bloques, function (value, index) {
                return [vm.getBlockUnderstanding(index, value)];
            });
        };

        vm.setBlocks = function (bloques) {
            return $.map(bloques, function (value, index) {
                return [vm.getBlock(index, value)];
            });
        };

        vm.getBlock = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.type == "has_many" ? IkanoFactory.getStructureForFieldsHasMany(data.campos,vm.proccess.fields,data.model) : IkanoFactory.getStructureForFields(data.campos,vm.proccess.fields)
            };

            if (vm.setModelFrom == 1) {
                if (block.name == "info_general") {
                    block.type = "one-column";
                } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                    block.type = "select-current-employee";
                } else if (block.fields.length < 2) {
                    block.type = "one-column";
                } else if (data.type == "has_many") {
                    block.type = "two-column-multiple-rows";
                }

            } else {
                if (block.fields.length < 2) {
                    block.type = "one-column";
                } else if (data.type == "has_many") {
                    block.type = "two-column-multiple-rows";
                }
            }

            return block;
        };

        vm.getBlockUnderstanding = function (index, data) {
            var block = {
                id: null,
                name: index,
                model: data.model,
                title: (data.name ? data.name.split(" ") : ""),
                type: "two-columns",
                block: data.model.type,
                fields: data.type == "has_many" ? IkanoFactory.getStructureForFieldsHasMany(data.campos,vm.understanding.fields,data.model) : IkanoFactory.getStructureForFields(data.campos,vm.understanding.fields),
            };

            if (vm.setModelFrom == 1) {
                if (block.name == "info_general") {
                    block.type = "one-column";
                } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                    block.type = "select-current-employee";
                } else if (block.fields.length < 2) {
                    block.type = "one-column";
                } else if (data.type == "has_many") {
                    block.type = "two-column-multiple-rows";
                }

            } else {
                if (block.fields.length < 2) {
                    block.type = "one-column";
                } else if (data.type == "has_many") {
                    block.type = "two-column-multiple-rows";
                }
            }

            return block;
        };

        function setdateCreatedAndUpdate(understanding, created, updated) {
            var createdTMP = [];
            var updatedTMP = [];
            if (created instanceof Array) {
                createdTMP = angular.copy(created);
            }

            if (updated instanceof Array) {
                updatedTMP = angular.copy(updated);
            }

            var createdObj = {};
            var updatedObj = {};

            for (var i in createdTMP) {
                createdObj[createdTMP[i][2]] = moment(createdTMP[i][3]).format('YYYY-MM-DD');
            }

            for (var i in updatedTMP) {
                updatedObj[updatedTMP[i][2]] = moment(updatedTMP[i][3]).format('YYYY-MM-DD');
            }

            for (var i in understanding) {

                if (createdObj[understanding[i].name]) {
                    understanding[i].date_created = createdObj[understanding[i].name];
                }

                if (updatedObj[understanding[i].name]) {
                    understanding[i].date_updated = updatedObj[understanding[i].name];
                }

            }

        }

        vm.showModalEdit = function (dataBlock, rootBlock) {
            var data = {
                bloques: {},
                data: angular.copy(rootBlock.data.data),
                estructura_campos: angular.copy(rootBlock.data.estructura_campos),
                listas: angular.copy(rootBlock.data.listas)
            }
            data.bloques[dataBlock.name] = rootBlock.data.bloques[dataBlock.name];

            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                templateUrl: 'app/main/analyst/understanding-charge/dialog/block.html',
                controller: 'BlockPopUp',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                locals: {
                    data: data,
                    idRequest: vm.idRequest,
                }
            }).then(function (resolve) {
                if (resolve.status == 200) {
                    var data = {};
                    data.class = (resolve.data.status) ? "success" : "error";
                    data.message = resolve.data.message;
                    data.showClose = true;
                    vm.understanding.data.data = resolve.data.values;
                    if (!dataBlock.date_created) {
                        dataBlock.date_created = moment().format('YYYY-MM-DD');
                    } else {
                        dataBlock.date_updated = moment().format('YYYY-MM-DD');
                    }
                    vm.showToast(data,[]);
                } else {
                    var data = {};
                    data.class = "error";
                    data.message = resolve.data.message;
                    data.showClose = true;
                    vm.showToast(data,[]);
                }
            });
        }


        vm.addModelToBlock = function (block, root) {
            var model = {};
            for (var index = 0; index < block.fields.length; index++) {
                var element = block.fields[index];
                model[element] = null;
            }
            root.values[block.model].push(model);
        };

        vm.removeModelToBlock = function (block, index, root) {
            root.values[block.model].splice(index, 1);
        };

        vm.getPositionColaborators = function (position, root) {
            AdminService.getPositionColaborators({ cargo_id: position,proceso_id:vm.idRequest }, {},
                function (response) {
                    if (response.data.colaboradores) {
                        var colaboradores = response.data.colaboradores;
                        root.lists.position_colaborators = IkanoFactory.setPositionsId(colaboradores,'estructura_id');

                        //CAMBIAR ID DE INFO_OCUPANTE_ACTUAL POR ESTRUCTURA_ID
						var newInfo = [];
						for (var i in root.values.info_ocupante_actual) {
							var ocupante = root.values.info_ocupante_actual[i];
							if (colaboradores[ocupante]) {
								newInfo.push((colaboradores[ocupante].estructura_id ? colaboradores[ocupante].estructura_id : colaboradores[ocupante].id) + "");
							}
						}

                        root.values.info_ocupante_actual = newInfo;
                    }
                },
                function (response) {
                    //IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                }
            );
        };


        vm.getUnderstandingCharge();


        vm.save = function (send, type, value) {
            //console.log(vm.values);return;
            var data = {
                id: vm.idRequest,
                data: (value ? value : vm.understanding.values)
            };
            /*vm.understanding.change = false;
            vm.understanding.saving = true;*/

            if (!data.data.tipo_proceso) {
                data.data.tipo_proceso = 'proceso_analista';
            }


            analystService.saveRequestAnalyst(data,
                function (response) {

                    vm.understanding.saving = false;
                    vm.understanding.change = true;
                    if (type == 2) {
                        vm.saveandapprove();
                    } else {
                        var data = {};
                        data.class = (response.data.status) ? "success" : "error";
                        data.message = response.data.message;
                        data.showClose = true;
                        vm.showToast(data,[]);
                    }
                },
                function (reject) {
                    var data = {};
                    data.class = "error";
                    data.message = reject.data.message;
                    data.showClose = true;
                    vm.showToast(data,[]);
                    vm.understanding.saving = false;
                    vm.understanding.change = true;
                }
            );

        };

        vm.validateUnderstanding = function (send, type) {
            vm.understanding.errors = IkanoFactory.validateFieldsWithObject(vm.understanding.fields, vm.understanding.values, true);
            if (angular.equals(vm.understanding.errors, {})) {
                vm.save(send, type);
            } else {
                IkanoFactory.showAlert("Error", "La información del entendimiento esta incompleta, por favor intente de nuevo.");
            }
        }

        vm.validateUnderstandingBlock = function () {
            var value = angular.copy(vm.understanding.values);
            vm.save(true, 1, value);
            /*var fields = IkanoFactory.getFieldsArray(block.fields,vm.understanding.fields);
            vm.understanding.errors = IkanoFactory.validateFieldsWithObject(fields, vm.understanding.values, true);
            if (angular.equals(vm.understanding.errors, {})) {
                var value = IkanoFactory.getValueWithFields(block.fields, vm.understanding.values);
                vm.save(true, 1,value);
            }else{
                IkanoFactory.showAlert("Error", "La información del bloque esta incompleta, por favor intente de nuevo.");
            }*/
        }

        vm.saveandapprove = function () {
            var data = {
                proceso_id: vm.request.id
            };
            vm.errors = IkanoFactory.validateFieldsWithObject(vm.fields, vm.values, true);
            if (angular.equals(vm.errors, {})) {
                analystService.approveRequestAnalyst(data,
                    function (response) {
                        var data = {};
                        data.class = (response.data.result.status) ? "success" : "error";
                        data.message = response.data.result.message;
                        data.showClose = true;
                        vm.showToast(data,[]);
                        vm.saving = false;
                        vm.change = true;
                        $state.transitionTo($state.current, $state.params, {
                            reload: true, inherit: false, notify: true
                        });
                    },
                    function (response) {
                        var data = {};
                        data.class = (response.data.status) ? "success" : "error";
                        data.message = response.data.message;
                        data.showClose = true;
                        vm.showToast(data,[]);
                        vm.saving = false;
                        vm.change = true;
                    }
                );
            } else {
                IkanoFactory.showAlert("Error", "El entendimiento se encuentra incompleto, por favor complete los campos antes de enviar aprobación.");
            }
        };

        vm.downloadPDF = function () {
            var data = { proceso_id: vm.idRequest };
            AdminService.downloadUnderstandingPdf(data, { responseType: 'arraybuffer' }, function (resolve) {
                IkanoFactory.downloadFile(resolve.data, vm.request.cod + ".pdf");
            }, function (reject) {
                var data = {};
                data.class = "error";
                data.message = reject.data.message;
                data.showClose = true;
                vm.showToast(data, options);
            });
        };

        vm.downloadRequestPDF = function () {
            var data = { id: vm.idRequest, tipo: "proceso" };
            AdminService.getPDFReport(data, { responseType: 'arraybuffer' }, function (resolve) {
                IkanoFactory.downloadFile(resolve.data, vm.request.cod + ".pdf");
            }, function (reject) {
                var data = {};
                data.class = "error";
                data.message = reject.data.message;
                data.showClose = true;
                vm.showToast(data, options);
            });
        };

        vm.stateGo = function (state) {
            $state.go(state, { request_id: vm.idRequest });
        };

        vm.showModalApprovedEmails = function (from) {
            $mdDialog.show({
                controller: 'approveEmailsDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/approve_emails/approveEmailsDialog.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    email: vm.request.applicant_email,
                    title: (from == 1) ? 'Enviar entendimiento del cargo' : 'Enviar requisición'
                }
            }).then(function (resolve) {
                if (from == 1) {
                    vm.sendApproveEmails(resolve);
                } else {
                    vm.sendRequestEmails(resolve);
                }

            });
        };

        vm.sendApproveEmails = function (emails) {
            analystService.sendApproveUnderstanding(
                {
                    proceso_id: vm.idRequest,
                    correos: emails
                },
                function (resolve) {
                    var data = {};
                    data.class = (resolve.data.status) ? "success" : "error";
                    data.message = resolve.data.message;
                    data.showClose = true;
                    vm.showToast(data,[]);
                }, function (reject) {
                    var data = {};
                    data.class = "error";
                    data.message = reject.data.message;
                    data.showClose = true;
                    vm.showToast(data,[]);
                }
            )
        };

        vm.sendRequestEmails = function (emails) {
            AdminService.sendEmailsRequest(
                {
                    proceso_id: vm.idRequest,
                    correos: emails
                },
                function (resolve) {
                    var data = {};
                    data.class = (resolve.data.status) ? "success" : "error";
                    data.message = resolve.data.message;
                    data.showClose = true;
                    vm.showToast(data, []);
                }, function (reject) {
                    var data = {};
                    data.class = "error";
                    data.message = reject.data.message;
                    data.showClose = true;
                    vm.showToast(data, []);
                }
            )
        };

        vm.selectedTab = function (tab) {
            vm.misc.tabSelected = tab;
            if (tab == 'ec') {
                vm.showButton = true;
            } else {
                vm.showButton = false;
            }
        }

    };
})();
(function () {
    'use strict';

    angular.module('app.seleccion_admin').controller('SearchcandidateControllerAdmin', SearchcandidateControllerAdmin);

    function SearchcandidateControllerAdmin($mdDialog, $compile, AdminService, IkanoFactory, analystConstant, analystService, $q, $filter, $state, $mdSidenav, paginationService, $scope, api, $mdpTimePicker, $mdDateLocale, AuthService, analystMisc, $document, $rootScope, $mdColors, $mdToast, ListFilter, $debounce) {

        //constructor
        var vm = this;
        vm.misc = {};
        vm.misc.lists = {};

        vm.candidateSelected = {};

        vm.modalFilterData = {};

        //COUNT ORIGENES
        vm.countOrigen = {};

        // set ID de la request
        vm.idRequest = $state.params.request_id;

        //Backup
        vm.backup = {};

        vm.backup.filter = {};

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        //objeto para el paginador
        vm.pager = {};

        vm.candidatesBackup = [];

        vm.user = AuthService.getUserData();

        vm.pagesBackup = {}

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['PROCESOS DE SELECCIÓN', 'BUSCAR HOJA DE VIDA'],
            title: "BUSCAR HOJA DE VIDA",
        };

        vm.configCandidate = {};

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            paging: false,
            language: IkanoFactory.getLanguajeDataTable(),
            pagingType: 'simple',
            autoWidth: false,
            iDisplayLength: 20,
            sort: false,
            searching: false
        };

        vm.misc.filter = [];

        vm.setMiscSelect = function (data) {
            vm.misc.lists = data;
        }

        vm.showfilterCandidate = function () {
            $mdDialog.show({
                controller: 'FilterHv',
                controllerAs: 'vm',
                templateUrl: 'app/main/analyst/partials/filter_hv/filter_hv.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    lists: vm.misc.lists,
                    request: vm.request,
                    form: vm.modalFilterData,
                    candidate: false
                }
            })
                .then(function (resolve) {
                    if (resolve.origenes) {
                        vm.countOrigen = resolve.origenes;
                    } else {
                        vm.countOrigen = {};
                    }
                    console.log(resolve);
                    vm.lists = resolve.candidates.listas;
                    vm.stages = resolve.candidates.etapas;
                    vm.positions = resolve.candidates.cargos;
                    vm.page = 1;
                    vm.modelCandidate(resolve.candidates);
                    vm.setFilter(resolve.filter);
                    vm.modalFilterData = resolve.data;
                });
        }

        vm.modelCandidate = function (data, config) {
            config = (config ? config : {});
            vm.showListsCandidate();
            vm.candidates = [];
            vm.misc.candidates = [];
            var modelCandidate = [];
            var model = analystConstant.KEYJSONCANDIDATE.PRODUTION;
            var idsCandidate = [];

            model.modified = { key: "last_update", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } };
            model.updated_at = { key: "updated_at", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } };
            vm.candidatesBackup = [];
            for (var i in data.candidates) {
                modelCandidate.push(data.candidates[i]);
                idsCandidate.push(data.candidates[i].id);
                vm.candidatesBackup.push({ candidato: data.candidates[i] });
            }

            analystMisc.modeldataarray(modelCandidate, model)
                .then(function (resolve) {
                    vm.candidates = resolve;
                    if (!config.notPagination) {
                        vm.modelPagination(data.pagination);
                    }
                    //vm.misc.candidates = angular.copy(vm.candidates);
                    saveCandidate(resolve, 'candidates');
                    getHojaVida(idsCandidate);
                    //getCandidateNext();
                });

        }

        vm.serializeFilter = function (data){
            for(var i in data){
                for(var j in data[i]){
                    var filtroNow = angular.copy(data[i][j]);
                    if(!Array.isArray(filtroNow.options)){
                        data[i][j].options = [];
                        for(var f in filtroNow.options){
                            if(filtroNow.options[f] instanceof Object){
                                data[i][j].options.push({id:f , name: filtroNow.options[f].name})
                            }else{
                                data[i][j].options.push({id:f , name: filtroNow.options[f]})
                            }
                            
                        }
                    }
                    data[i][j].optionsshow = data[i][j].options.slice(0, vm.limit);
                }
            }
            return data;
        }

        function getFilterHv() {
            var dataPost = {};
            analystService.getFilterHv(dataPost, function (response) {
                localStorage.setItem('filterSearchHv',JSON.stringify(vm.serializeFilter(response.data)));
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            }, true);
        }

        function getHojaVida(ids) {
            var dataPost =
                {
                    "proceso_id": vm.idRequest,
                    "hv_ids": ids
                };
            analystService.getHojaVidas(dataPost, function (response) {
                mergeHojaVida(ids, response.data.data);
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            }, true);
        }

        function mergeHojaVida(ids, hojavidas, current) {
            for (var i in ids) {
                vm.candidatesBackup[i] = analystMisc.misc.mergeJson(vm.candidatesBackup[i], hojavidas[i]);
            }
        }

        function getCandidateNext() {
            if (vm.page == 1 && !vm.searchasdsw) {
                vm.searchasdsw = true;
                vm.saveSearch(vm.backup.filter, {
                    page: vm.page + 1,
                    limit: analystConstant.LIMITROW
                }, {
                        notPagination: true
                    });
            }
        }

        function saveCandidate(data, key) {
            var pageNext = vm.page + 1;
            if (vm.pagesBackup[vm.page]) {
                vm.pagesBackup[pageNext] = {};
            } else {
                vm.pagesBackup[vm.page] = {};
            }

            if (vm.pagesBackup[vm.page][key]) {
                vm.pagesBackup[pageNext][key] = data;
            } else {
                vm.pagesBackup[vm.page][key] = data;
            }
        }

        vm.modelPagination = function (filterPage) {
            vm.pagination = filterPage;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        //Inicia el paginador
        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || page > vm.pager.totalPages) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.pagination.total_rows, page, analystConstant.LIMITROW);
            if (!noConsult) {

                vm.saveSearch(vm.backup.filter, {
                    page: page,
                    limit: analystConstant.LIMITROW
                });
            }
            setTimeout(function () {
                createPagination();
            }, 1000);
        }

        function createPagination() {
            var elemt = $('.right');
            //elemt.appendTo('<div class="paginations"></div>');
            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}} hasta {{vm.pager.totalItems}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        vm.showHV = function (candidate, index) {
            if (!vm.candidatesBackup[index].hoja_vida) {
                return;
            }
            vm.candidateSelected = angular.copy(vm.candidates[index]);
            vm.candidateSelectedAll = angular.copy(vm.candidatesBackup[index]);
            vm.indexSelected = index;
            vm.showDetailCandidate = true;
        }

        vm.showListsCandidate = function () {
            vm.indexSelected = null;
            vm.candidateSelected = null;
            vm.candidateSelectedAll = null;
            vm.showDetailCandidate = false;
        }

        vm.backCandidate = function () {
            vm.indexSelected = vm.indexSelected - 1;
            vm.candidateSelected = angular.copy(vm.candidates[vm.indexSelected]);
            vm.candidateSelectedAll = angular.copy(vm.candidatesBackup[vm.indexSelected]);
        }

        vm.nextCandidate = function () {
            vm.indexSelected = vm.indexSelected + 1;
            vm.candidateSelected = angular.copy(vm.candidates[vm.indexSelected]);
            vm.candidateSelectedAll = angular.copy(vm.candidatesBackup[vm.indexSelected]);
        }

        vm.deleteFilter = function (filter, indexFilter, indexChild) {
            vm.loading = true;
            ListFilter.deleteFilter(filter, indexFilter, indexChild, vm.misc.filter, vm.modalFilterData);
            $debounce(vm.updateFilter, 2000);
        }

        vm.updateFilter = function () {
            var filter = {};
            var data = angular.copy(vm.misc.filter);
            for (var i in data) {
                filter[data[i].key] = data[i].value;
            }
            vm.pager = {};
            vm.page = 1;
            if (data.length) {
                vm.saveSearch(filter, {
                    page: 1,
                    limit: analystConstant.LIMITROW
                });
            } else {
                vm.loading = false;
                vm.candidates = [];
                vm.candidatesBackup = [];
            }

        }

        vm.setFilter = function (filter) {
            vm.backup.filter = angular.copy(filter);
            vm.misc.filter = ListFilter.setFilter(filter, 1);
            
        }

        vm.saveSearch = function (filter, pagination, configModelCandidate) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.filtros = filter;
            dataPost.pagination = pagination;
            vm.loading = true;

            if (vm.user.group_id == 1) {
              AdminService.filterAllCandidateHv(dataPost, function (response) {
                vm.modelCandidate(response.data, configModelCandidate);
                vm.backup.filter = filter;
                vm.loading = false;
              }, function (reject) {
                  IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
              }, true);
            } else {
              analystService.filterAllCandidate(dataPost, function (response) {
                  vm.modelCandidate(response.data, configModelCandidate);
                  vm.backup.filter = filter;
                  vm.loading = false;
              }, function (reject) {
                  IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
              }, true);
            }
        }

        vm.getFilter = function () {
            analystService.filterAllCandidate({}, function (response) {
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        break;
                    case analystConstant.CODEPETITION.NOTFOUND:
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            });
        }

        vm.showToast = function (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        getFilterHv();

    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_admin').controller('DetailRequestAdmin', DetailRequestAdmin);


    function DetailRequestAdmin($mdDialog, AdminService, IkanoFactory, analystConstant, analystService, $q, $filter, $state, $mdSidenav, paginationService, $scope, api, $mdpTimePicker, $mdDateLocale, AuthService, analystMisc, $document, $rootScope, $mdColors, $mdToast, ListFilter,$compile) {
        //constructor 
        var vm = this;

        //se guardan todos los registro que llegaron de la base de datos se utiliza al momento que se limpian filtros
        vm.candidatesBackup = [];

        //en esta variable se guarda todos los candidatos que se utilizan actualmente (es posible que cambie constantemente ya sea por paginación o por filtros)
        vm.candidates = [];

        // set ID de la request
        vm.idRequest = $state.params.request_id;

        //SOCKET ANGULAR
        $rootScope.$on('setRequest', function (evt, arg) {
            vm.request = arg;
            if (typeof vm.request.lists != "undefined") {
                vm.request.lists.cargos_recomendados = vm.request.charges;
                vm.setMiscSelect(vm.request.lists);
            }
        });

        //COLOR
        vm.getThemeColor = $mdColors.getThemeColor;

        //MISCELANEOS
        vm.misc = {};

        //Backup
        vm.backup = {};

        vm.backup.filter = {};

        vm.modalFilterData = {};
        //LISTAS DE LUGARES DE CITA
        vm.misc.lists = {};
        //en esta variable se muestra en el paginador  (los datos que aparezcan en esta variable se toman de vm.candidates)
        vm.misc.candidates = [];

        //Pagination
        vm.pagination = {};
        vm.misc.loadPagination = false;

        //objeto para el paginador
        vm.pager = {};

        //Cantidad de registros
        vm.misc.countRow = null;

        //Hover del paginador
        vm.misc.hover = {};
        vm.misc.hover.backflash = false;
        vm.misc.hover.back = false;
        vm.misc.hover.afterflash = false;
        vm.misc.hover.after = false;

        //SE CREA UNA VARIABLE PARA SETEAR EL CANDIDATO QUE SE VA A AGREGAR UNA NOTA O AGREGAR UNA FECHA EN LA AGENDA
        vm.candidateSelected = {};

        vm.configCandidate = {
            onlyViewStages: true,
            showStageFake: true,
            showNote: true,
            showHistory: true,
        };

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            paging: false,
            language: IkanoFactory.getLanguajeDataTable(),
            pagingType: 'simple',
            autoWidth: false,
            iDisplayLength: 20,
            sort: false,
            searching: false
        };

        vm.projectName = analystConstant.DEFAULT.DATA.HEADER.KEYSDETAILREQUESTADMIN.CANDIDATE;
        vm.project = vm.selectedProject = analystMisc.header.getProject(vm.projectName);

        //funcion para traer los candidatos
        vm.getRequestAdminSeleccion = function () {
            AdminService.getRequestAdminSeleccion({ proceso_id: vm.idRequest }, function (response) {
                vm.loading = false;
                switch (response.status) {
                    case analystConstant.CODEPETITION.OK:
                        vm.modelRequest(response.data.proceso);
                        vm.getConfiguration();
                        vm.saveSearch({},
                            {
                                page: 1,
                                limit: analystConstant.LIMITROW
                            });
                            
                        break;

                    case analystConstant.CODEPETITION.NOTFOUND:
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                        break;
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        vm.getConfiguration = function(){
            analystService.getConfigurationCandidate({},function(response){
                vm.configuration = response.data;
                var listLocalStorage = JSON.parse(localStorage.getItem('lists'));
                var lists = response.data.data;
                var listStage = lists.listas;
                delete(lists.listas);
                var listFisrt = analystMisc.misc.mergeJson(lists,listStage);
                vm.lists = analystMisc.misc.mergeJson(listFisrt,listLocalStorage);
                
            },function(reject){
                console.log(reject);
            });
        }

        vm.setMiscSelect = function (data, config) {
            vm.misc.lists.placeCita = data.lugares;
            vm.misc.lists.typeCita = data.tipos_cita;
            ListFilter.setLists(vm.request.lists);
        }

        //Inicia el paginador
        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.pagination.total_rows, page, analystConstant.LIMITROW);
            $rootScope.$broadcast('candidate::getPagination', vm.pager);
            if (!noConsult) {

                vm.saveSearch(vm.backup.filter, {
                    page: page,
                    limit: analystConstant.LIMITROW
                });
            }

            
            
        }

        function createPagination() {
            var elemt = $('.right');
            //elemt.appendTo('<div class="paginations"></div>');
            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}} hasta {{vm.pager.totalItems}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        //Modelamos la data de los candidatos
        vm.modelCandidate = function (data) {
            vm.showListsCandidate();
            vm.candidates = [];
            vm.misc.candidates = [];
            var modelCandidate = [];
            var model = analystConstant.KEYJSONCANDIDATE.PRODUTION;
            model.modified = { key: "last_update", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } };
            model.updated_at = { key: "updated_at", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } };
            vm.candidatesBackup = data.candidates;
            for (var i in data.candidates) {
                modelCandidate.push(data.candidates[i].candidato);
            }

            analystMisc.modeldataarray(modelCandidate, model, { save: true, model: 'candidates', key: 'id' })
                .then(function (resolve) {
                    vm.candidates = resolve;
                    vm.modelPagination(data.pagination);
                    vm.misc.candidates = angular.copy(vm.candidates);
                });
            
        }

        vm.modelPagination = function (filterPage) {
            vm.pagination = filterPage;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);

            setTimeout(function () {
                createPagination();
            }, 1000);
        }

        $mdDateLocale.formatDate = function (date) {
            return date ? moment(date).format('MMM D, YYYY') : '';
        };

        vm.saveSearch = function (filter, pagination) {
            var dataPost = {};
            dataPost.proceso_id = vm.idRequest;
            dataPost.filtros = filter;
            dataPost.pagination = pagination;

            AdminService.searchCandidateSeleccion(dataPost, function (response) {
                vm.configCandidate.stage_structure_fields = response.data.estructura_campos;
                vm.configCandidate.info_client_structure_fields = response.data.estructura_campos_informe_cliente;
                vm.modelCandidate(response.data);
                vm.backup.filter = filter;
            }, function (reject) {
                IkanoFactory.showAlert("Error", "Ha ocurrido un error obteniendo la información solicitada, por favor intente de nuevo.");
            });
        }

        //Modelamos la data de la request   
        vm.modelRequest = function (data) {
            var baseJson = analystConstant.KEYJSONREQUEST;
            analystMisc.modeldata(data, baseJson, { createIfNotExist: true })
                .then(function (resolve) {
                    vm.request = resolve;
                    analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
                        vm.request.notes = resolve;
                    });

                    $rootScope.$broadcast('setRequest', vm.request);
                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }

        vm.goToCandidateDetail = function (candidate_id, index) {
            //$state.go('app.detail_seleccion_analyst.detail', { request_id: vm.idRequest, candidate_id: candidate_id });
            vm.candidateSelected = angular.copy(vm.candidates[index]);
            vm.candidateSelectedAll = vm.candidatesBackup[index];
            vm.candidateChanges = {};
            vm.indexSelected = index;
            vm.showDetailCandidate = true;
        };

        vm.showListsCandidate = function () {
            vm.indexSelected = null;
            vm.candidateSelected = null;
            vm.candidateSelectedAll = null;
            vm.showDetailCandidate = false;
            vm.candidateChanges = {};
        }

        vm.backCandidate = function () {
            vm.indexSelected = vm.indexSelected - 1;
            vm.candidateSelected = angular.copy(vm.candidates[vm.indexSelected]);
            vm.candidateSelectedAll = vm.candidatesBackup[vm.indexSelected];
            vm.candidateChanges = {};
        }

        vm.nextCandidate = function () {
            vm.indexSelected = vm.indexSelected + 1;
            vm.candidateSelected = angular.copy(vm.candidates[vm.indexSelected]);
            vm.candidateSelectedAll = vm.candidatesBackup[vm.indexSelected];
            vm.candidateChanges = {};
        }


        //valido que me traiga un request de prueba siempre y cuando sea en DEBUG la contante
        //vm.getRequest();

        //ejecutamos la funcion que nos trae la informacion de los candidatos
        vm.getRequestAdminSeleccion();

        vm.showToast = function (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }

        vm.showListsCandidate = function () {
            vm.indexSelected = null;
            vm.candidateSelected = null;
            vm.candidateSelectedAll = null;
            vm.showDetailCandidate = false;
            vm.candidateChanges = {};
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_admin').controller('ListsRequestsAdmin', ListsRequestsAdmin);

    function ListsRequestsAdmin($mdDialog, AdminService, IkanoFactory, analystConstant, analystService, $q, $filter, $state, $scope, paginationService, analystMisc,$compile,$mdToast) {
        //Le asignamos un alias al controlador
        var vm = this;

        // Muestra por defecto el loading
        vm.loading = true;

        // seteamos el objetos de filtros
        vm.filter = {};

        vm.filter.startDate = null;
        vm.filter.endDate = null;

        // seteamos MISC (misc es un objeto que nos ayuda con la data que se va a mostrar en la vista)
        vm.misc = {};
        vm.misc.arrApplicant = [];
        vm.misc.arrStatusRequest = [];
        vm.misc.arrRegionalRequest = [];
        vm.misc.filter = {};

        // se setea un valor por defecto que va a valer 0 en los filtro por select
        vm.misc.filter.defaultApplicant = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.APPLICANT;
        vm.misc.filter.defaultStatusRequest = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.STATUSREQUEST;
        vm.misc.filter.defaultRegionalRequest = analystConstant.DEFAULT.DATA.DASHBOARD.SELECTED.REGIONALREQUEST;
        vm.misc.filterCopy = {};

        vm.status_process_status = analystConstant.STATUSPROCESS;

        // informacion que aparece en el Header
        vm.pageInfo = {
            icon: "icon-home",
            parents: ['PROCESOS', 'TODOS LOS PROCESOS'],
            title: "PROCESOS",
        };

        // seteamos la data de los filtros 

        //definimos la variable request Que es un array
        vm.request = [];
        //El backup de request es la constante que solo se setea una vez y es la data que trae de la base de datos
        vm.backupRequest = [];
        //El misc es la data que se muestra en la vista
        vm.misc.request = [];

        //STRING DATE REPLACE
        vm.misc.date_request_string = '(Hace %months% meses y %days% días)';

        //LIMIT
        vm.limit = analystConstant.LIMITROW;

        //PAGER
        vm.pager = {};

        vm.backup = {};

        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            paging: false,
            language: IkanoFactory.getLanguajeDataTable(),
            pagingType: 'simple',
            autoWidth: false,
            iDisplayLength: 20,
            sort: false,
            searching: false
        };



        vm.goToNewRequest = function () {
            $state.go('app.seleccion_create_request_analyst');
        }
        //Arranca apenas se haya terminar de cargar el controlador
        vm.getRequest = function (params) {
            AdminService.requestAdmin(params, function (response) {
                vm.backup.filter = params.filtros;
                vm.loading = false;
                if (response.data.status) {
                    vm.filters = response.data.filters;
                    vm.modelRequest(response.data.data);
                    //vm.modelFilter(response.data.listas);
                    modelPagination(response.data.pagination);
                    var filtersAnalys = vm.filters.filter(function(element){
                        return element.id == 'analista_id';
                    });
                    vm.listAnalyst = IkanoFactory.jsonToArray(filtersAnalys[0].options);
                } else {
                    IkanoFactory.showAlert("Error", response.data.message);
                }
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        };

        vm.updateAnalyst = function (data, request) {
            request.loading = true;

            AdminService.setAnalystProcess({ analista_id: data.id, proceso_id: request.id }, function (response) {
                if (response.data.status) {
                    if(!request.analyst){
                        request.analyst = {};
                    }
                    request.analyst.name = data.name;
                    request.analyst.id = data.id;
                    request.selected = false;
                    vm.data[request.id] = null;
                    showToast({ class: "success", message: response.data.message, showClose: true });
                } else {
                    showToast({ class: "error", message: response.data.message, showClose: true });
                }
                request.loading = false;
            },
                function (reject) {
                    request.loading = false;
                    request.selected = false;
                    IkanoFactory.showAlert("Error", reject.data.message);
                }, true);
        }

        function createPagination() {
            var elemt = $('.right');
            //elemt.appendTo('<div class="paginations"></div>');
            var template = '<div class="info"><div class="dataTables_info">Pagina {{vm.pager.currentPage}} de {{vm.pager.totalPages}} hasta {{vm.pager.totalItems}} Registros</div></div><div class="pagination"><div class="dataTables_paginate paging_simple"><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage <= 1}" ng-click="vm.setPage(vm.pager.currentPage - 1)">Anterior</a><a class="paginate_button" ng-class="{disabled:vm.pager.currentPage === vm.pager.totalPages}" ng-click="vm.setPage(vm.pager.currentPage + 1)">Siguiente</a></div>';
            elemt.html($compile(template)($scope));
            
            //Se oculta el selector de cuantas
            $('.left').html($compile('<div class="length"></div>')($scope));
            vm.paginationLoad = true;
        }

        vm.callbackSendData = function (filter) {
            var filterConsult = angular.copy(filter);

            if (filterConsult.fecha_creacion && filterConsult.fecha_creacion_fin) {
                filterConsult.fecha_creacion = [filterConsult.fecha_creacion, filterConsult.fecha_creacion_fin];
                delete (filterConsult.fecha_creacion_fin);
            }
            vm.page = 1;
            vm.getRequest({
                filtros: filterConsult,
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }

        vm.search = function () {
            var filter = angular.copy(vm.filter);
            if (filter.estado_aprobacion == -1) {
                delete (filter.estado_aprobacion);
            }
            if (filter.solicitante_id == -1) {
                delete (filter.solicitante_id);
            }
            if (filter.regional_id == -1) {
                delete (filter.regional_id);
            }
            if (filter.startDate && filter.endDate) {
                filter.fecha_creacion = [filter.startDate, filter.endDate];
                delete (filter.startDate);
                delete (filter.endDate);
            }
            vm.getRequest({
                filtros: filter,
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }

        vm.clearFilter = function () {
            vm.getRequest({
                filtros: {},
                pagination: {
                    page: 1,
                    limit: vm.limit
                }
            }, false);
        }

        vm.setModelNote = function (value) {
            value = (value) ? value : vm.misc.notesExample;
            var arrayReturn = [];
            if (!value.length) {
                return arrayReturn;
            }

            var baseJson = analystConstant.KEYJSONNOTE;
            value.map(function (va, ke) {
                var jsonInsert = {};
                angular.forEach(va, function (v, k) {
                    switch (typeof baseJson[k]) {
                        case "string":
                            jsonInsert[baseJson[k]] = v;
                            break;
                        case "object":
                            var config = baseJson[k];
                            jsonInsert[config.key] = vm[config.callback](v, config.dataCallback);
                            jsonInsert[config.key + 'Backup'] = v;
                            break;
                    }
                });
                arrayReturn.push(jsonInsert);
            });
            return arrayReturn;
        }
        //Modelar las requisiones
        vm.modelRequest = function (data) {
            var baseJson = {
                "id": "id",
                "codigo": "cod",
                "estado_label": "status",
                "estado_aprobacion_color": "colorStatus",
                "cargo_ocupar": "name",
                "ciudad": "state",
                "solicitante": "applicant",
                "solicitante_id": "applicant_id",
                "correo_solicitante": "applicant_email",
                "empresa_solicitante": "applicant_from",
                "fecha_solicitud": "date_request",
                "estado_publicacion_color": "color_status_publish",
                "estado_publicacion": "status_publish",
                "fecha_publicacion": { key: "date_publish", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                "fecha_cierre_publicacion": { key: "date_publish_close", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                "no_vacantes": "count_vacant",
                "seleccionados": "selected",
                "pre_seleccionados": "preSelected",
                "no_leidos": "unread",
                "finalistas": "finalist",
                "total": "candidates",
                "custom_data": "custom_data",
                "candidatos": {
                    key: "candidate_info", callback: "setCandidateInfo", dataCallback: {
                        baseJson: {
                            "seleccionados": "selected",
                            "pre_seleccionados": "preSelected",
                            "no_leidos": "unread",
                            "total": "candidates",
                            "aplicantes": "applicants",
                            "base_de_datos": "db",
                            "descartados": "discards",
                            "finalistas": "finalysts",
                            "en_proceso": "in_process",
                            "recomendados": "recommends",
                            "solicitantes": "solicitantes",
                            "aprobados": "approved"
                        }
                    }
                },
                "aprobacion_entendimiento_cargo": "approve_understanding",
                "estado_oferta": "status_offer",
                "estado_proceso": "status_process",
                "estado_requisicion": "status_request",
                "analista": "analyst",
                "fecha_creacion": { key: "createdDate", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
                "estado_aprobacion_id": "status_approve_id"

            };
            vm.misc.request = [];
            analystMisc.modeldataarray(data, baseJson, { createIfNotExist: true })
                .then(function (resolve) {
                    vm.misc.request = resolve;
                })
                .catch(function (reject) {
                    console.error(reject);
                });
        }

        function modelPagination(filterPage) {

            vm.pagination = filterPage;
            if (!vm.page) {
                vm.page = 1;
            }
            vm.setPage(vm.page, true);
        }

        //PAGINATION
        vm.setPage = function (page, noConsult) {
            vm.page = page;
            if (page < 1 || (page > vm.pager.totalPages && page != 1)) {
                return;
            }
            // acomoda la paginacion de la vista
            vm.pager = paginationService.GetPager(vm.pagination.total_rows, page, vm.limit);
            if (!noConsult) {
                var filter = {
                    filtros: vm.backup.filter, pagination: {
                        page: page,
                        limit: vm.limit
                    }
                };
                vm.getRequest(filter);
            }
            setTimeout(function () {
                createPagination();
            }, 1000);
        }

        vm.setCandidateInfo = function (value, config) {
            var jsonReturn = {};
            var baseJson = (analystConstant.DEBUG) ? analystConstant.KEYJSONREQUESTDEBUG : analystConstant.KEYJSONREQUEST;
            angular.forEach(value, function (vv, vk) {
                jsonReturn[baseJson[vk]] = vv;
            });
            return jsonReturn;
        }

        vm.modelFilter = function (data) {
            var applicant = data.solicitantes;
            var statusRequest = data.estados_proceso;
            var regionalRequest = data.empresas;

            if (!angular.equals(applicant, {}) && vm.misc.arrApplicant.length < 1) {
                angular.forEach(applicant, function (v, k) {
                    k = parseInt(k);
                    vm.misc.arrApplicant.push({ id: k, name: v });
                });
                vm.misc.arrApplicant.sort(function (a, b) {
                    if (a.name < b.name) { return -1; }
                    if (a.name > b.name) { return 1; }
                    return 0;
                });
            }

            if (!angular.equals(statusRequest, {}) && vm.misc.arrStatusRequest.length < 1) {
                angular.forEach(statusRequest, function (v, k) {
                    k = parseInt(k);
                    vm.misc.arrStatusRequest.push({ id: k, name: v.label });
                });
            }

            if (!angular.equals(regionalRequest, {}) && vm.misc.arrRegionalRequest.length < 1) {
                angular.forEach(regionalRequest, function (v, k) {
                    k = parseInt(k);
                    vm.misc.arrRegionalRequest.push({ id: k, name: v });
                });
            }

        }

        vm.setStringDateRequest = function (obj) {
            var stringReturn = "";
            //SI ES HOY
            if (obj.isToday) {
                return stringReturn = "Hoy";
            }
            //SI TIENE AÑOS
            if (obj.months > 0) {
                stringReturn += "Hace " + obj.textSuggested.months;
            }
            //SI TIENE AÑOS Y MESES
            if (obj.days > 0 && obj.months > 0) {
                stringReturn += " y " + obj.textSuggested.days;
            } else if (obj.days > 0 && obj.months == 0) { //si tiene años pero no tiene meses
                stringReturn += "Hace " + obj.textSuggested.days;
            }

            return stringReturn;
        }
        //Cambiar de color segun el stado ESTO ES PARA DEBUG
        vm.searchColorStatus = function (request) {
            request.colorStatus = 'brown-300-bg';
            switch (Math.floor((Math.random() * 4) + 1)) {
                case 1:
                    request.colorStatus = 'red-300-bg';
                    break;
                case 2:
                    request.colorStatus = 'purple-300-bg';
                    break;
                case 3:
                    request.colorStatus = 'green-300-bg';
                    break;
                case 4:
                    request.colorStatus = 'light-blue-300-bg';
                    break;
            }
        }

        vm.setDateRequest = function (v, format) {
            return moment(v).format(format);
        }

        vm.setBetweenDate = function (stringReplace, datePast, dateCompare) {
            var dateCompare = (!dateCompare) ? moment() : moment(dateCompare);
            var datePast = moment(datePast);
            var years = dateCompare.diff(datePast, 'years');
            datePast.add(years, 'years');
            var months = dateCompare.diff(datePast, 'months');
            datePast.add(months, 'months');
            var days = dateCompare.diff(datePast, 'days');
            datePast.add(days, 'days');
            var hours = dateCompare.diff(datePast, 'hours');
            datePast.add(hours, 'hours');
            var minutes = dateCompare.diff(datePast, 'minutes');
            datePast.add(minutes, 'minutes');
            var seconds = dateCompare.diff(datePast, 'seconds');
            datePast.add(seconds, 'seconds');
            var milliseconds = dateCompare.diff(datePast, 'milliseconds');
            //return "Hola";
            return stringReplace.replace(/%year%/g, years)
                .replace(/%months%/g, months)
                .replace(/%days%/g, days)
                .replace(/%hours%/g, hours)
                .replace(/%minutes%/g, minutes)
                .replace(/%seconds%/g, seconds)
                .replace(/%milliseconds%/g, milliseconds);
        }

        //SIEMPRE QUE HAYA UN CAMBIO EN LAS BUSQUEDAS INGRESA AQUI
        vm.changeFilter = function () {
            var boolExecuteFilter = false;
            vm.misc.filterCopy = {};
            vm.misc.filterCopy.and = {};
            if (vm.filter.search) {
                vm.misc.filterCopy.or = {};
                vm.misc.filterCopy.or.name = angular.copy(vm.filter.search);
                vm.misc.filterCopy.or.cod = angular.copy(vm.filter.search);
                vm.misc.filterCopy.or.state = angular.copy(vm.filter.search);
                vm.misc.filterCopy.or.custom_data = angular.copy(vm.filter.search);
                boolExecuteFilter = true;
            }
            if (vm.filter.applicant && vm.filter.applicant.id && vm.filter.applicant.id !== vm.misc.filter.defaultApplicant) {
                vm.misc.filterCopy.and.applicant = angular.copy(vm.filter.applicant.name);
                boolExecuteFilter = true;
            }
            if (vm.filter.statusRequest && vm.filter.statusRequest.id && vm.filter.statusRequest.id !== vm.misc.filter.defaultStatusRequest) {
                vm.misc.filterCopy.and.status = angular.copy(vm.filter.statusRequest.name);
                boolExecuteFilter = true;
            }
            if (boolExecuteFilter) {
                vm.executeFilter();
            } else {
                vm.request = angular.copy(vm.backupRequest);
                vm.misc.request = vm.request.slice(0, analystConstant.DEFAULT.DATA.DASHBOARD.LIMITREQUEST);
            }

        }

        //EJECUTAMOS EL FILTRO  
        vm.executeFilter = function () {
            vm.request = vm.backupRequest;
            if (vm.misc.filterCopy.and) {
                vm.request = $filter('customField')(vm.request, vm.executeFilterPrimary);
            }

            if (vm.misc.filterCopy.or) {
                vm.request = $filter('customField')(vm.request, vm.executeFilterSecundary);
            }
            vm.misc.request = vm.request.slice(0, analystConstant.DEFAULT.DATA.DASHBOARD.LIMITREQUEST);
        }

        //Ejecuta primero los filtros primarios los que tienen que cumplir si o si
        vm.executeFilterPrimary = function (item) {
            var arrReturn = [];
            var countObject = Object.keys(vm.misc.filterCopy.and).length;
            angular.forEach(vm.misc.filterCopy.and, function (value, key) {
                if (item[key]) {
                    if (item[key].toLowerCase().indexOf(value.toLowerCase()) > -1) {
                        arrReturn.push(true);
                    }
                }
            });
            return arrReturn.length == countObject;
        }

        //Ejecuta el segundo filtro es un filtro que puede varias on un or.
        vm.executeFilterSecundary = function (item) {
            var arrReturn = [];
            angular.forEach(vm.misc.filterCopy.or, function (value, key) {
                switch (typeof item[key]) {
                    case "string":
                        if (item[key].toLowerCase().indexOf(value.toLowerCase()) > -1) {
                            arrReturn.push(true);
                        }
                        break;
                    case "object":
                        var data = item[key];
                        if (data) {
                            for (var i = 0; i < data.length; i++) {
                                if (data[i].value && data[i].value.toLowerCase().indexOf(value.toLowerCase()) > -1) {
                                    arrReturn.push(true);
                                }
                            }
                        }

                        break;
                }
            });
            return (arrReturn.length > 0) ? true : false;
        }

        //DATA QUE SE CARGA POR EL SCROLL INFINITO
        vm.loadMore = function () {
            var last = vm.misc.request.length - 1;
            var limit;
            if (vm.misc.request.length < vm.request.length) {
                limit = (vm.request.length - vm.misc.request.length < analystConstant.DEFAULT.DATA.DASHBOARD.LIMITREQUEST) ? vm.request.length - vm.misc.request.length : analystConstant.DEFAULT.DATA.DASHBOARD.LIMITREQUEST;

                for (var i = 1; i <= limit; i++) {
                    vm.misc.request.push(vm.request[last + i]);
                }
            }
        }

        vm.goDetail = function (idRequest) {
            $state.go('app.seleccion_proceso_admin', { request_id: idRequest });
        }

        //MODELAMOS LA DATA DE LA EXPERIENCIA POR CANDIDATO
        vm.getOneKey = function (data, config) {
            if (data == null || typeof data == "undefined") {
                return;
            }
            return data[config.getKey];
        }

        //setea una fecha con un formato expecifico
        vm.setFormatDate = function (v, config) {
            return moment(v).format(config.format);
        }

        vm.publishRequest = function (id) {
            $state.go('app.publish_request', { request_id: id });
        }

        vm.search = function (arr, filter) {
            var arrReturn = [];
            if (filter && filter.length >= 3) {
                return $filter('filter')(arr, filter);
            } else {
                for (var i = 0; i < vm.limit; i++) {
                    var pushIndex = i + length;
                    arrReturn.push(arr[pushIndex]);
                }
            }
            return arrReturn;
        }

        vm.deleteProcess = function (request){
            request.loading = true;
            var data = {
                proceso_id: request.id
            }
            AdminService.delete_process(data, function (response) {
                if (response.data.status) {
                    request.status_process = response.data.data;
                    showToast({ class: "success", message: response.data.message, showClose: true });
                } else {
                    IkanoFactory.showAlert("Error", response.data.message);
                }
                request.loading = false;
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            },true);
        }

        vm.activate_process = function (request){
            request.loading = true;
            var data = {
                proceso_id: request.id
            }
            AdminService.activate_process(data, function (response) {
                if (response.data.status) {
                    request.status_process = response.data.data;
                    showToast({ class: "success", message: response.data.message, showClose: true });
                } else {
                    IkanoFactory.showAlert("Error", response.data.message);
                }
                request.loading = false;
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            },true);
        }

        vm.showAlertConfirm = function(ev,action,request){
            if(action == 1){
                IkanoFactory.showConfirmAlert(ev, "Eliminar proceso", "¿Está seguro que desea eliminar el proceso?", request, vm.deleteProcess);
            }else{
                IkanoFactory.showConfirmAlert(ev, "Activar proceso", "¿Está seguro que desea activar el proceso?", request, vm.activate_process);
            }
        }

        //FILTROS

        vm.getRequest({
            filtros: {}, pagination: {
                page: 1,
                limit: vm.limit
            }
        });

        function showToast(data, options) {
            options = (options) ? options : [];
            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.seleccion_admin').controller('societyController', societyController);

    function societyController($mdDialog, $document, $state, $mdDateLocale, AdminService, CandidateService, IkanoFactory, DTColumnDefBuilder, analystService, analystMisc, $mdToast, analystConstant, paginationService, $compile, $scope, $mdColors, $filter) {
        //contrcutor
        var vm = this;

        vm.limit = analystConstant.DEFAULT.DATA.DASHBOARD.LIMITREQUEST;

        vm.pager = {};

        vm.filter = {};

        vm.filter.collaborators = {};

        vm.filter.candidates = {};

        vm.backup = {};

        vm.backup.filter = {};

        vm.search = {};

        vm.misc = {};

        vm.page = {};

        vm.getThemeColor = $mdColors.getThemeColor;

        vm.pageInfo = {
            icon: "icon-home",
            parents: ['Sociedades', 'Administración de sociedades'],
            title: "Administración de sociedades",
        };

        //DATA TABLE OPTION
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            paging: false,
            language: IkanoFactory.getLanguajeDataTable(),
            pagingType: 'simple',
            autoWidth: false,
            iDisplayLength: 20,
            sorting: false,
            searching: false
        };

        vm.dtColumnSociety = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
        ];


        //INIT LIST COLLABORATOR
        vm.misc.tabSelected = 'collaborators';


        function get_sociedades_paises() {
            AdminService.get_sociedades_paises({}, function (resolve) {
                vm.lists = resolve.data.data.lists;
                modelPaises(resolve.data.data.sociedades_paises);
            }, function (reject) {
                IkanoFactory.showAlert("Error", reject.data.message);
            });
        }

        function modelPaises(data) {

            var baseJson = {
                id: 'id',
                pais: 'country',
                pais_id: 'country_id',
                sociedad: 'society',
                sociedad_id: 'society_id'
            };

            analystMisc.modeldataarray(data, baseJson).then(function (resolve) {
                vm.societys = resolve;
            });
        }

        function modelPais(data){
            var baseJson = {
                id: 'id',
                pais: 'country',
                pais_id: 'country_id',
                sociedad: 'society',
                sociedad_id: 'society_id'
            };

            analystMisc.modeldata(data, baseJson).then(function(resolve){
                var exists = vm.societys.filter(function(element){
                    return element.id == resolve.id;
                });
                if(exists.length > 0){
                    for(var i in vm.societys){
                        if(vm.societys[i].id == resolve.id){
                            vm.societys[i] = resolve;
                        }
                    }
                }else{
                    vm.societys.unshift(resolve);
                }
                
            });
        }


        vm.createSociety = function(society){
            $mdDialog.show({
                controller: 'createdSocietyDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/admin/crud-society/created-society/created-society.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    society: society ? society : null,
                    lists: vm.lists
                }
            }).then(function (resolve) {
                if (resolve.data.status) {
                    modelPais(resolve.data.data);
                    showToast({ class: "success", message: resolve.data.message, showClose: true });
                } else {
                    IkanoFactory.showAlert("Error", resolve.data.message);
                }
            });
        }

        function showToast (data, options) {

            options = (options) ? options : [];

            $mdToast.show({
                hideDelay: 7000,
                position: 'top right',
                controller: 'ToastCrl',
                controllerAs: 'vm',
                templateUrl: 'app/toast/template/toast.default.html',
                locals: {
                    options: options,
                    config: data,
                },
                toastClass: data.class
            });
        }



        get_sociedades_paises();

        /*getLists({
            lists: [
                "cargos"
            ]
        }, true);*/
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /**
         * Delete all navigation item
         * 
         */

         function deleteAllItems(){
            navigation = [];
         }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                deleteAllItems    : deleteAllItems,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
/**
 * angular-recaptcha build:2015-04-28 
 * https://github.com/vividcortex/angular-recaptcha 
 * Copyright (c) 2015 VividCortex 
**/

!function(a){"use strict";a.module("vcRecaptcha",[])}(angular),function(a){"use strict";var b=a.module("vcRecaptcha");b.service("vcRecaptchaService",["$window","$q",function(b,c){function d(){return f?c.when(f):h}function e(){if(!f)throw new Error("reCaptcha has not been loaded yet.")}var f,g=c.defer(),h=g.promise;return b.vcRecaptchaApiLoaded=function(){f=b.grecaptcha,g.resolve(f)},a.isDefined(b.grecaptcha)&&b.vcRecaptchaApiLoaded(),{create:function(a,b,c,e){return e.callback=c,e.sitekey=b,d().then(function(b){return b.render(a,e)})},reload:function(a){e(),f.reset(a)},getResponse:function(a){return e(),f.getResponse(a)}}}])}(angular),function(a){"use strict";function b(){throw new Error('You need to set the "key" attribute to your public reCaptcha key. If you don\'t have a key, please get one from https://www.google.com/recaptcha/admin/create')}var c=a.module("vcRecaptcha");c.directive("vcRecaptcha",["$document","$timeout","vcRecaptchaService",function(a,c,d){return{restrict:"A",require:"?^^form",scope:{response:"=?ngModel",key:"=",theme:"=?",tabindex:"=?",onCreate:"&",onSuccess:"&",onExpire:"&"},link:function(e,f,g,h){function i(){angular.element(a[0].querySelectorAll(".pls-container")).parent().remove()}g.hasOwnProperty("key")||b(),e.widgetId=null;var j=e.$watch("key",function(a){if(a){40!==a.length&&b();var k=function(a){c(function(){h&&h.$setValidity("recaptcha",!0),e.response=a,e.onSuccess({response:a,widgetId:e.widgetId})}),c(function(){h&&h.$setValidity("recaptcha",!1),e.response="",e.onExpire({widgetId:e.widgetId})},12e4)};d.create(f[0],a,k,{theme:e.theme||g.theme||null,tabindex:e.tabindex||g.tabindex||null}).then(function(a){h&&h.$setValidity("recaptcha",!1),e.widgetId=a,e.onCreate({widgetId:a}),e.$on("$destroy",i)}),j()}})}}}])}(angular);
(function() {
    'use strict';

    angular
        .module('app.auth', [
            'app.auth.login',
            'app.auth.login-admin',
            'app.auth.login-token',
            'app.auth.signin',
            'app.auth.login-dashboard',
            'app.auth.recover-password',
            'app.auth.new-password',
            'app.auth.social-network-response',
            'app.auth.social-network-signin',
            'app.auth.social-network-error',
            'app.auth.login-analyst',
            'app.auth.recover-password-admin',
            'app.auth.acuerdo-servicio'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider) {

    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('AuthService', AuthService);

    /** @ngInject */
    function AuthService($http, api, $mdDialog, $state, $location, IkanoFactory, CandidateService, msNavigationService, globalConstant,IkanoFactoryPagination) {
        //Administración del token
        var getJwt = function () {
            return localStorage.getItem('JWT_SELECTION');
        };

        var setJwt = function (jwt) {
            $http.defaults.headers.common['X-Auth-Token'] = jwt;
            localStorage.setItem('JWT_SELECTION', jwt);
        };

        var removeJwt = function (jwt) {
            localStorage.removeItem('JWT_SELECTION');
        };

        var setServiceAgreement = function (text) {
            localStorage.setItem('SERVICE_AGREEMENT_SELECTION', text);
        };

        var getServiceAgreement = function () {
            return localStorage.getItem('SERVICE_AGREEMENT_SELECTION');
        };

        var removeServiceAgreement = function () {
            localStorage.removeItem('SERVICE_AGREEMENT_SELECTION');
        };

        var setIdExists = function (id) {
            localStorage.setItem('ID_SELECTION_EXISTS', id);
        }

        var getIdExists = function () {
            return localStorage.getItem('ID_SELECTION_EXISTS');
        };

        var removeIdExists = function () {
            localStorage.removeItem('ID_SELECTION_EXISTS');
        };

        //Administración del menú lateral principal
        var getMenu = function () {
            return JSON.parse(localStorage.getItem('MENU_SELECTION'));
        };

        var setMenu = function (menu) {
            localStorage.setItem('MENU_SELECTION', JSON.stringify(menu));
            if (!getServiceAgreement()) {
                IkanoFactory.createMenu();
            }
        };

        var setMenuAdmin = function (menu) {
            localStorage.setItem('MENU_SELECTION', JSON.stringify(menu));
            IkanoFactory.createMenuForAdmin();
        };

        var removeMenu = function (menu) {
            localStorage.removeItem('MENU_SELECTION');
        };

        var removeFilters = function () {
            for (var i = 0; i < localStorage.length; i++) {
                var name = localStorage.key(i);
                if (name.indexOf('filter_') !== -1) {
                    localStorage.removeItem(name);
                }
            }
        }

        //Administración de los datos del usuario
        var getUserData = function () {
            return JSON.parse(localStorage.getItem('USER_DATA_SELECTION'));
        };

        var getHelpCode = function () {
            return localStorage.getItem('HELP_URL');
        };

        var setUserData = function (userData) {
            localStorage.setItem('USER_DATA_SELECTION', JSON.stringify(userData));
        };

        var removeUserData = function () {
            localStorage.removeItem('USER_DATA_SELECTION');
        };

        var logout = function () {
            /*
            location.href = "/";
            */
            var user = getUserData();


            $http.defaults.headers.common['X-Auth-Token'] = null;
            removeJwt();
            removeUserData();
            removeMenu();
            removeFilters();
            IkanoFactoryPagination.clearAll();

            msNavigationService.deleteAllItems();

            if (user && (user.group_id == 1 )) {
                $state.transitionTo('app.auth-login-admin');
            } else if (user && (user.group_id == 5)) {
                $state.transitionTo('app.auth-login-analyst');
            } else if(user.group_id == 8 || user.group_id == 7){
                $state.transitionTo('app.auth-login-requisicion');
            } else {
                $state.transitionTo('app.auth-login');
            }
            //$location.path("/");
        };

        var login = function (data) {
            api.authentication.login(data, {},
                function (response) {
                    createLogin(response.data.token, response.data.menu);
                },
                function (response) {
                    if (response.status == 401) {
                        IkanoFactory.showAlert("Error", "Usuario o contraseña incorrecta, por favor intente de nuevo.");
                    } if (response.status == 404) {
                        IkanoFactory.showAlert("Error", "Usuario o contraseña incorrecta, por favor intente de nuevo.");
                    } else if (response.status == 500) {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
                });
        };

        var signin = function (data, config, callback) {
            api.authentication.signin(data, config,
                function (response) {
                    callback(response);
                }
            );
        };

        var createLogin = function (token, menu) {
            //Se guarda el token
            setJwt(token);
            //Se guarda el menu
            setMenu(menu);

            CandidateService.getUserData({}, {}, function (response) {
                if (response.data) {
                    setUserData(response.data.data);
                    redirectDashboard();
                }
            });
        };

        var loginAdmin = function (data) {
            api.authentication.login(data, {},
                function (response) {
                    createLoginAdmin(response.data.token, response.data.menu, response.data.user);
                },
                function (response) {
                    if (response.status == 401) {
                        IkanoFactory.showAlert("Error", "Usuario o contraseña incorrecta, por favor intente de nuevo.");
                    } if (response.status == 404) {
                        IkanoFactory.showAlert("Error", "Usuario o contraseña incorrecta, por favor intente de nuevo.");
                    } else if (response.status == 500) {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                    }
                }
            );
        };

        var loginToken = function (data) {
            api.authentication.loginToken(data, {},
                function (response) {
                    createLoginToken(response.data.token, response.data.menu, response.data.user);
                },
                function (response) {
                    var funcion = function () {
                        location.href = "";
                    };
                    IkanoFactory.showAlertFunction("Advertencia", "El enlace al que está intentando ingresar ya está vencido o es invalido. Por favor ingrese con su usuario y contraseña.", funcion);
                }
            );
        };

        var createLoginToken = function (token, menu, user) {
            //Se guarda el token
            setJwt(token);
            //Se guarda el menu
            setMenuAdmin(menu);

            setUserData(user);

            location.href = "" + user.url;

        };

        var createLoginAdmin = function (token, menu, user) {
            //Se guarda el token
            setJwt(token);
            //Se guarda el menu
            setMenuAdmin(menu);

            setUserData(user);

            //ADMIN
            /*if (user.group_id == 1) {
                $state.go('app.seleccion_get_procesos_admin', {}, { reload: true });
            } else if (user.group_id == 8) { //ADMIN REQUISICIONES
                $state.go('app.seleccion_requisiciones_admin_proceso', { filter: 'seleccion_requisiciones_admin_proceso' }, { reload: true });
            } else if (user.group_id == 5) { //CONSULTORA DE SELECCION
                $state.go('app.seleccion_get_procesos_analista', {}, { reload: true });
            } else {
                $state.go('app.seleccion_requisiciones_todas', { filter: 'seleccion_requisiciones_todas' }, { reload: true });
            }*/
            redirectDashboard();
        };

        var redirectDashboard = function () {

            var user = getUserData();
            if (!user || user == 'null' || user == null || user == undefined) {
                return;
                //$state.transitionTo('app.auth-login');
            } else {
                if (user.group_id) {
                    //ADMIN
                    if (user.group_id == 1 ) {
                        $state.go('app.seleccion_get_procesos_admin', {}, { reload: true });
                    } else if (user.group_id == 8 ) { //ADMIN REQUISICIONES
                        $state.go('app.seleccion_requisiciones_admin_proceso', { filter: 'seleccion_requisiciones_admin_proceso' }, { reload: true });
                    } else if (user.group_id == 5) { //CONSULTORA DE SELECCION
                        $state.go('app.seleccion_get_procesos_analista', {}, { reload: true });
                    } else { // || user.group_id == 7
                        $state.go('app.seleccion_requisiciones_todas', { filter: 'seleccion_requisiciones_todas' }, { reload: true });
                    }
                } else {
                    if (getServiceAgreement()) {
                        $state.go('app.seleccion_acuerdo_servicio', {}, { reload: true });
                    } else {
                        $state.go('app.seleccion_dashboard', {}, { reload: true });
                    }

                }
            }

        }

        var getInforecoverPassword = function (data, config, success, error) {
            api.authentication.getInforecoverPassword(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var recoverPasswordByEmail = function (data) {
            api.authentication.recoverPasswordByEmail(data, {},
                function (response) {
                    if (!response.data.status) {
                        IkanoFactory.showFormErrors(response.data.msg);
                    } else {
                        IkanoFactory.showAlert("", "Se ha enviado un correo a " + response.data.data.email + " con instrucciones para recuperar la contraseña");
                        //$state.transitionTo('app.auth-login');
                        $location.path("/");
                    }
                },
                function (response) {
                    if (response.status == 404) {
                        IkanoFactory.showAlert("Error", "Documento de identidad o dirección de correo electrónica incorrecta.");
                    }
                }
            );
        };

        var recoverPasswordByQuestions = function (data, config, success, error) {
            api.authentication.recoverPasswordByQuestions(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var validateSignup = function (data, config, success, error) {
            api.authentication.validateSignup(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var socialNetworkLogin = function (data, config, success, error) {
            api.authentication.socialNetworkLogin(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var recoverPassword = function (data) {
            api.authentication.recoverPassword(data, {},
                function (response) {
                    if (response.data.status) {
                        IkanoFactory.showAlert("", response.data.message);
                        //$state.transitionTo('app.auth-login');
                        $location.path("/");
                    } else {
                        IkanoFactory.showAlert("", response.data.message);
                    }
                },
                function (response) {
                    if (response.status == 404) {
                        IkanoFactory.showAlert("Error", response.data.message);
                    }
                }
            );
        };

        var getQuestionsForRecoverPassword = function (data) {
            api.authentication.getQuestionsForRecoverPassword(data, {},
                function (response) {
                    console.log(response);
                },
                function (response) {
                    console.log(response);
                }
            );
        };

        var socialNetworkSignin = function (data, config, success, error) {
            api.authentication.socialNetworkSignin(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getLoginDashboardOffers = function (data, config, callback) {
            api.authentication.getLoginDashboardOffers(data, config,
                function (response) {
                    callback(response);
                }
            );
        };

        var getLoginType = function (data, config, success, error) {
            api.authentication.getLoginType(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var licenseLogin = function (data, config, success, error) {
            api.authentication.licenseLogin(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var refreshProfilePicture = function (url) {
            var user = getUserData();
            user.foto = url;
            setUserData(user);
        };

        var save_respuesta_acuerdo_servicio = function (data, success, error) {
            api.authentication.save_respuesta_acuerdo_servicio(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        }

        var save_lists_login = function () {
            api.admin.getLists({
                lists: globalConstant.LISTSLOGIN
            }, {},
                function (response) {

                    localStorage.setItem('lists', JSON.stringify(response.data.data));
                },
                function (response) {
                    if (response.status == 404) {
                        IkanoFactory.showAlert("Error", response.data.message);
                    }
                }
            );
            
        }

        return {
            logout: logout,
            login: login,
            loginAdmin: loginAdmin,
            loginToken: loginToken,
            socialNetworkLogin: socialNetworkLogin,
            signin: signin,
            getJwt: getJwt,
            setJwt: setJwt,
            removeJwt: removeJwt,
            getMenu: getMenu,
            setMenu: setMenu,
            setMenuAdmin: setMenuAdmin,
            removeMenu: removeMenu,
            getUserData: getUserData,
            getHelpCode: getHelpCode,
            setUserData: setUserData,
            removeUserData: removeUserData,
            getLoginDashboardOffers: getLoginDashboardOffers,
            createLogin: createLogin,
            createLoginAdmin: createLoginAdmin,
            setServiceAgreement: setServiceAgreement,
            getServiceAgreement: getServiceAgreement,
            removeServiceAgreement: removeServiceAgreement,
            setIdExists: setIdExists,
            getIdExists: getIdExists,
            removeIdExists: removeIdExists,
            getInforecoverPassword: getInforecoverPassword,
            recoverPasswordByEmail: recoverPasswordByEmail,
            recoverPasswordByQuestions: recoverPasswordByQuestions,
            recoverPassword: recoverPassword,
            getQuestionsForRecoverPassword: getQuestionsForRecoverPassword,
            validateSignup: validateSignup,
            socialNetworkSignin: socialNetworkSignin,
            refreshProfilePicture: refreshProfilePicture,
            getLoginType: getLoginType,
            licenseLogin: licenseLogin,
            save_respuesta_acuerdo_servicio: save_respuesta_acuerdo_servicio,
            save_lists_login: save_lists_login,
            redirectDashboard: redirectDashboard
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .service('CandidateService', CandidateService);

    /** @ngInject */
    function CandidateService($http, api, $mdDialog, $state, IkanoFactory) {

        function getDataDashboard(callback) {
            api.candidate.getDashboard({}, {},
                function (response) {
                    callback(response);
                }
            );
        }

        function getAppliedOffers(callback) {
            api.candidate.getAppliedOffers({}, {},
                function (response) {
                    callback(response);
                }
            );
        }

        function getOffersSuggested(callback,data) {
            data = data ? data : {};
            api.candidate.getOffersSuggested(data, {},
                function (response) {
                    callback(response);
                }
            );
        }

        function getApplyOfferInfo(data, config, callback) {
            api.candidate.getApplyOfferInfo(data, config,
                function (response) {
                    callback(response);
                }
            );
        }

        function applyOffer(data, config, callback) {
            api.candidate.applyOffer(data, config,
                function (response) {
                    callback(response);
                }
            );
        }

        function getResumeData(data, config, callback) {
            api.candidate.getResumeData(data, config,
                function (response) {
                    callback(response);
                }
            );
        }

        function saveResumeBlock(data, config, success, error) {
            api.candidate.saveResumeBlock(data, config,
                function (response) {
                    success(response);
                }
            );
        }

        function getLists(data, callback) {
            api.candidate.getLists(data, {},
                function (response) {
                    callback(response);
                }
            );
        }

        function deleteBlock(data, config, callback) {
            api.candidate.deleteBlock(data, config,
                function (response) {
                    callback(response);
                }
            );
        }

        function getUserData(data, config, callback) {
            api.authentication.getUserData(data, config,
                function (response) {
                    callback(response);
                }
            );
        }

        function changePassword(data, config, callback) {
            api.candidate.changePassword(data, config,
                function (response) {
                    callback(response);
                }
            );
        }

        function saveFile(data, config, success, error) {
            api.candidate.saveFile(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        }

        function saveResumePhoto(data, config, success, error) {
            api.candidate.saveResumePhoto(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        }

        function getFileUrl() {
            return api.candidate.getFileUrl();
        }

        function getFile(data, config, success, error) {
            api.candidate.getFile(
                data,
                config,
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        function removeFile(id, data, config, callback) {
            api.candidate.deleteFile(id, data, config,
                function (response) {
                    callback(response);
                }
            );
        }

        function getUrlBase() {
            return api.baseUrl;
        }

        function acceptAgreement(data, config, callback) {
            api.candidate.acceptAgreement(data, config,
                function (response) {
                    callback(response);
                }
            );
        }

        function savefileanalista(data, config, success, error) {
            api.candidate.savefileanalista(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        }

        function deletefileanalista(data, config, success, error) {
            api.candidate.deletefileanalista(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        }

        return {
            getDataDashboard: getDataDashboard,
            getAppliedOffers: getAppliedOffers,
            getOffersSuggested: getOffersSuggested,
            getApplyOfferInfo: getApplyOfferInfo,
            applyOffer: applyOffer,
            getResumeData: getResumeData,
            saveResumeBlock: saveResumeBlock,
            getLists: getLists,
            deleteBlock: deleteBlock,
            getUserData: getUserData,
            changePassword: changePassword,
            saveFile: saveFile,
            savefileanalista: savefileanalista,
            deletefileanalista: deletefileanalista,
            getFileUrl: getFileUrl,
            getFile: getFile,
            removeFile: removeFile,
            saveResumePhoto: saveResumePhoto,
            getUrlBase: getUrlBase,
            acceptAgreement: acceptAgreement
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').service('analystService', analystService);

    angular.module('app.seleccion_analyst').service('paginationService', PagerService);

    function PagerService() {
        // service definition
        var service = {};

        service.GetPager = GetPager;

        return service;

        // service implementation
        function GetPager(totalItems, currentPage, pageSize) {

            totalItems = totalItems || 0;

            // default to first page
            currentPage = currentPage || 1;

            currentPage = totalItems == 0 ? 0 : currentPage;

            // default page size is 10
            pageSize = pageSize || 10;

            // calculate total pages
            var totalPages = Math.ceil(totalItems / pageSize);

            var startPage, endPage;
            if (totalPages <= 10) {
                // less than 10 total pages so show all
                startPage = 1;
                endPage = totalPages;
            } else {
                // more than 10 total pages so calculate start and end pages

                if (currentPage <= 4) {
                    startPage = 1;
                    endPage = 6;
                } else if (currentPage + 1 >= totalPages) {
                    startPage = totalPages - 4;
                    endPage = totalPages;
                } else {
                    startPage = currentPage - 4;
                    endPage = currentPage + 1;
                }
            }

            // calculate start and end item indexes
            var startIndex = (currentPage - 1) * pageSize;
            var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

            // create an array of pages to ng-repeat in the pager control
            var pages = _.range(startPage, endPage + 1);

            // return object with all pager properties required by the view
            return {
                totalItems: totalItems,
                currentPage: currentPage,
                pageSize: pageSize,
                totalPages: totalPages,
                startPage: startPage,
                endPage: endPage,
                startIndex: startIndex,
                endIndex: endIndex,
                pages: pages
            };
        }
    }

    function analystService($http, api, $mdDialog, $state, IkanoFactory) {

        //Traae la requisiciones
        this.getRequests = function (data, callbackSuccess, callbackError) {
            api.analyst.getRequests(
                data,
                {},
                function (response) { callbackSuccess(response); },
                function (error) { callbackError(error); }
            );
        }

        //traer los candidatos por id de request
        this.getCandidate = function (data, callbackSuccess, callbackError) {
            api.analyst.getCandidate(
                data,
                {},
                function (response) { callbackSuccess(response); },
                function (error) { callbackError(error); }
            );
        }
        this.setFavorite = function (data, callbackSuccess, callbackError) {
            api.analyst.setFavorite(
                data,
                {},
                function (response) { callbackSuccess(response); },
                function (error) { callbackError(error); }
            );
        }

        this.setSpecial = function (data, callbackSuccess, callbackError) {
            api.analyst.setSpecial(
                data,
                {},
                function (response) { callbackSuccess(response); },
                function (error) { callbackError(error); }
            );
        }
        this.addNote = function (data, callbackSuccess, callbackError) {
            api.analyst.addNote(
                data,
                {},
                function (response) { callbackSuccess(response); },
                function (error) { callbackError(error); }
            );
        }
        this.addNoteRequest = function (data, callbackSuccess, callbackError) {
            api.analyst.addNoteRequest(
                data,
                {},
                function (response) { callbackSuccess(response); },
                function (error) { callbackError(error); }
            );
        }
        this.addScheduleCandidate = function (data, callbackSuccess, callbackError) {
            api.analyst.addScheduleCandidate(
                data,
                {},
                function (response) { callbackSuccess(response); },
                function (error) { callbackError(error); }
            );
        }
        this.addRecommendCandidate = function (data, callbackSuccess, callbackError) {
            api.analyst.addRecommendCandidate(
                data,
                {},
                function (response) { callbackSuccess(response); },
                function (error) { callbackError(error); }
            );
        }

        this.getCandidateDetail = function (data, success, error) {
            api.analyst.getCandidateDetail(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.getCandidateHistory = function (data, success, error) {
            api.analyst.getCandidateHistory(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.getUnderstandingCharge = function (data, success, error) {
            api.analyst.getUnderstandingCharge(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.getShareRequest = function (data, success, error) {
            api.analyst.getShareRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.postShareRequest = function (data, success, error) {
            api.analyst.postShareRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.saveSuspensionRequest = function (data, success, error) {
            api.analyst.saveSuspensionRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.activarRequest = function (data, success, error) {
            api.analyst.activarRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.getCandidateRevision = function (data, success, error) {
            api.analyst.getCandidateRevision(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.sendCandidateApplicant = function (data, success, error) {
            api.analyst.sendCandidateApplicant(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.saveRequestAnalyst = function (data, success, error) {
            api.analyst.saveRequestAnalyst(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.downloadUnderstandingPdf = function (data, config, success, error) {
            api.analyst.downloadUnderstandingPdf(
                data,
                config,
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.deleteNote = function (data, success, error) {
            api.analyst.deleteNote(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.deleteObservacion = function (data, success, error) {
            api.analyst.deleteObservacion(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.approveRequestAnalyst = function (data, success, error) {
            api.analyst.approveRequestAnalyst(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }


        this.sendApproveUnderstanding = function (data, success, error) {
            api.analyst.sendApproveUnderstanding(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.postPublicRequest = function (data, success, error) {
            api.analyst.postPublicRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.getPublicRequest = function (data, success, error) {
            api.analyst.getPublicRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        };

        this.changeDateEndOffer = function (data, success, error) {
            api.analyst.changeDateEndOffer(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        };

        this.saveReportForToclient = function (data, success, error) {
            api.analyst.saveReportForToclient(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        };

        this.saveStage = function (data, success, error) {
            api.analyst.saveStage(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        };

        this.filterAllCandidate = function (data, success, error,configLoad) {
            api.analyst.filterAllCandidate(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        };

        this.getHojaVidas = function (data, success, error,configLoad){
            api.analyst.getHojaVidas(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.searchCandidate = function (data, success, error) {
            api.analyst.searchCandidate(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        };

        this.getFilterCandidate = function (data, success, error) {
            api.analyst.getFilterCandidate(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.getHojaVida = function (data, success, error) {
            api.analyst.getHojaVida(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.preseleccionar = function (data, success, error) {
            api.analyst.preseleccionar(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.retirarPreseleccionar = function (data, success, error) {
            api.analyst.retirarPreseleccionar(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.getFile = function (data, config, success, error) {
            api.analyst.getFile(
                data,
                config,
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.closeOffer = function (data, success, error) {
            api.analyst.closeOffer(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.searchProcess = function (data, success, error,configload) {
            api.analyst.searchProcess(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configload
            );
        }

        this.referredCandidate = function (data, success, error) {
            api.analyst.referredCandidate(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }

        this.getCandidateSimilar = function (data, success, error) {
            api.analyst.getCandidateSimilar(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); }
            );
        }
        this.saveEvaluation = function (data, success, error,configLoad){
            api.analyst.saveEvaluation(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }
        this.saveStageFinalist = function (data, success, error,configLoad){
            api.analyst.saveStageFinalist(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }
        this.downloadStage = function (data,config, success, error,configLoad) {
            api.analyst.downloadStage(
                data,
                config,
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }
        this.downloadTerna = function (data,config, success, error,configLoad) {
            api.analyst.downloadTerna(
                data,
                config,
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.getAllAnalysts = function (data,config, success, error,configLoad) {
            api.analyst.getAllAnalysts(
                data,
                config,
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.createAnalyst = function (data, success, error,configLoad){
            api.analyst.createAnalyst(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.updateAnalyst = function (data, success, error,configLoad){
            api.analyst.updateAnalyst(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.getDataRequestAnalyst = function (data, success, error,configLoad){
            api.analyst.getDataRequestAnalyst(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.saveNewRequest = function (data, success, error,configLoad){
            api.analyst.saveNewRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.deleteAnalyst = function (data, success, error,configLoad){
            api.analyst.deleteAnalyst(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.activeAnalyst = function (data, success, error,configLoad){
            api.analyst.activeAnalyst(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }
        this.deactiveAnalyst = function (data, success, error,configLoad){
            api.analyst.deactiveAnalyst(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.getTeamProcesses = function (data, success, error,configLoad){
            api.analyst.getTeamProcesses(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.setAnalystProcess =  function (data, success, error,configLoad){
            api.analyst.setAnalystProcess(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.finishRequest = function (data, success, error,configLoad){
            api.analyst.finishRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }
        this.reOpenRequest = function (data, success, error,configLoad){
            api.analyst.reOpenRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.saveMarker = function (data, success, error,configLoad){
            api.analyst.saveMarker(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }
        this.getHistoryRequest = function (data, success, error,configLoad){
            api.analyst.getHistoryRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.getRequest = function (data, success, error,configLoad){
            api.analyst.getRequest(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.getReport = function (report,data, success, error,configLoad){
            api.analyst[report](
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.importCandidateElempleo = function (data, success, error,configLoad){
            api.analyst.importCandidateElempleo(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.importStages = function (data, success, error,configLoad){
            api.analyst.importStages(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.set_candidate_as_visto = function (data, success, error,configLoad){
            api.analyst.set_candidate_as_visto(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.removeReferredCandidate = function (data, success, error,configLoad){
            api.analyst.removeReferredCandidate(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.getOtherProcess = function (data,success,error,configload){
            api.analyst.getOtherProcess(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configload
            );
        }

        this.getFilterHv = function (data,success,error,configload){
            api.analyst.getFilterHv(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configload
            );
        }

        this.updateProcessData = function (data,success,error,configload){
            api.admin.updateProcessData(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configload
            );
        }

        this.getConfigurationCandidate = function (data,success,error,configload){
            api.global.getConfigurationCandidate(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configload
            );
        }

        this.sendNotificacionDiscard = function (data,success,error,configLoad){
            api.analyst.sendNotificacionDiscard(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

        this.getHistoryProcessCandidate = function (data,success,error,configLoad){
            api.analyst.getHistoryProcessCandidate(
                data,
                {},
                function (response) { success(response); },
                function (response) { error(response); },
                configLoad
            );
        }

    }
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst')
        .filter('customField', function () {
            // Just add arguments to your HTML separated by :
            // And add them as parameters here, for example:
            // return function(dataArray, searchTerm, argumentTwo, argumentThree) {
            return function (dataArray, callback) {
                // If no array is given, exit.
                if (!dataArray) {
                    return;
                }
                // If no search term exists, return the array unfiltered.
                else if (!callback) {
                    return dataArray;
                }
                // Otherwise, continue.
                else {
                    // Convert filter text to lower case.
                    //var term = searchTerm.toLowerCase();
                    // Return the array and filter it by looking for any occurrences of the search term in each items id or name. 
                    return dataArray.filter(function (item) {
                        return callback(item);
                    });
                }
            }
        })
        .filter('highlight', function ($sce) {
            return function (text, phrase) {
                if (phrase && text) text = text.replace(new RegExp('(' + phrase + ')', 'gi'), '<span class="highlighted">$1</span>')
                return $sce.trustAsHtml(text)
            }
        })
        .filter('safehtml', function ($sce) {
            return function (input) {
                return $sce.trustAsHtml(input);
            };
        })
        .filter('moment', function () {
            return function (input, momentFn /*, param1, param2, ...param n */) {
                var args = Array.prototype.slice.call(arguments, 2),
                    momentObj = moment(input);
                return momentObj[momentFn].apply(momentObj, args);
            };
        })
        .filter('titlecollapse', function () {
            return function (input, momentFn /*, param1, param2, ...param n */) {
                var reg = /([^A-zÀ-ú]?)([A-zÀ-ú]+)/g;
                var f = true;
                return (!!input) ? input.replace(reg, function (txt) {
                    if (f) {
                        var string = txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                        f = false;
                    } else {
                        var string = txt.charAt(0).toLowerCase() + txt.substr(1).toLowerCase();
                    }

                    string = string.replace('_', ' ');

                    return string;
                }) : '';
            };
        })
        .filter('parseJson', function ($sce) {
            return function (input,$compile) {
                try {
                    if (!isNaN(input)) {
                        return input;
                    }
                    var jsonInput = JSON.parse(input);
                    var textReturn = "";
                    for(var i in jsonInput){
                        textReturn +=  i + " : " + jsonInput[i] + ", ";
                    }

                    return textReturn;

                } catch (error) {
                    return input;
                }

            }
        });
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').service('analystMisc', analystFavory);

    function analystFavory($q, analystConstant, IkanoFactory) {

        var vm = this;

        //PROJECTS HEADER REQUEST
        vm.projectRequest = analystConstant.DEFAULT.DATA.HEADER.DETAILREQUEST;
        vm.projectRequestAdmin = analystConstant.DEFAULT.DATA.HEADER.DETAILREQUESTADMIN;
        vm.reportsHeader = analystConstant.REPORTS.HEADER.REPORTS;

        /**
         * @param data:Aray
         * @param baseJson:Json
         * @param config:Json
         * @return arr:Array
         */

        function modeldataarray(data, baseJson, config) {
            var defer = $q.defer();
            var promise = defer.promise;
            var returnSerialize = [];
            if (config && config.model) {
                vm[config.model] = [];
            }

            try {
                data.map(function (va, ke) {
                    var jsonInsert = {};
                    if (config && config.save) {
                        if (config.set) {
                            vm[config.model].push(config.set);
                        } else {
                            var insert = (config.key) ? va[config.key] : va;
                            vm[config.model].push(insert);
                        }

                    }

                    angular.forEach(va, function (v, k) {
                        switch (typeof baseJson[k]) {
                            case "string":
                                jsonInsert[baseJson[k]] = v;
                                break;
                            case "object":
                                var configBase = baseJson[k];
                                if (v == null || typeof v == "undefined") {
                                    jsonInsert[configBase.key] = v;
                                    jsonInsert[configBase.key + 'Backup'] = v;
                                    break;
                                }
                                if (typeof vm[configBase.callback] !== 'function') {
                                    jsonInsert[configBase.key] = v;
                                    jsonInsert[configBase.key + 'Backup'] = v;
                                    break;
                                }
                                if (typeof configBase.otherParams != "undefined") {
                                    var otherParams = (va[configBase.otherParams]) ? va[configBase.otherParams] : null;
                                    jsonInsert[configBase.key] = vm[configBase.callback](v, configBase.dataCallback, otherParams);
                                    jsonInsert[configBase.key + 'Backup'] = v;
                                    break;
                                }
                                jsonInsert[configBase.key] = vm[configBase.callback](v, configBase.dataCallback);
                                jsonInsert[configBase.key + 'Backup'] = v;
                                break;
                            case "undefined":
                                if (config && config.createIfNotExist) {
                                    jsonInsert[k] = v;
                                }
                                break;
                        }
                    });
                    returnSerialize.push(jsonInsert);
                });
                defer.resolve(returnSerialize);
            } catch (e) {
                defer.resolve(e);
            }
            return promise;
        }

        /**
        * @param data:Aray
        * @param baseJson:Json
        * @return arr:json
        */

        function modeldata(data, baseJson, config) {
            var defer = $q.defer();
            var promise = defer.promise;
            var jsonInsert = {};
            try {
                angular.forEach(data, function (v, k) {
                    switch (typeof baseJson[k]) {
                        case "string":
                            jsonInsert[baseJson[k]] = v;
                            break;
                        case "object":
                            var configBase = baseJson[k];
                            if (v == null || typeof v == "undefined") {
                                jsonInsert[configBase.key] = v;
                                jsonInsert[configBase.key + 'Backup'] = v;
                                break;
                            }
                            if (typeof vm[configBase.callback] !== "function") {
                                jsonInsert[configBase.key] = v;
                                jsonInsert[configBase.key + 'Backup'] = v;
                                break;
                            }
                            jsonInsert[configBase.key] = vm[configBase.callback](v, configBase.dataCallback);
                            jsonInsert[configBase.key + 'Backup'] = v;
                            break;
                        case "undefined":
                            if (config && config.createIfNotExist) {
                                jsonInsert[k] = v;
                            }
                            break;
                    }
                });
                defer.resolve(jsonInsert);
            } catch (e) {
                defer.resolve(e);
            }
            return promise;
        }

        //RETORNA UN VALOR EXPUESTO
        function returnVar(key) {
            return vm[key];
        }
        //ELIMINA UN VALOR EXPUESTO
        function deleteVar(key) {
            delete (vm[key]);
        }

        /** ============================== *
         *              MISC               *
         ** ============================== */

        //setea una fecha con un formato expecifico
        vm.setFormatDate = function (v, format) {
            format = (typeof format === "object") ? format.format : format;
            return moment(v).format(format);
        }

        //MODELAMOS LA DATA DE LA EXPERIENCIA POR CANDIDATO
        vm.getOneKey = function (data, config) {
            if (data == null || typeof data == "undefined") {
                return;
            }
            return data[config.getKey];
        }

        //Texto de una fecha ej: "Hace 2 meses y 3 dias"
        vm.setStringDateRequest = function (obj) {
            var stringReturn = "";
            //SI ES HOY
            if (obj.isToday) {
                return stringReturn = "Hoy";
            }
            //SI TIENE meses
            if (obj.months > 0) {
                stringReturn += "Hace " + obj.textSuggested.months;
            }
            //SI TIENE meses Y dias
            if (obj.days > 0 && obj.months > 0) {
                stringReturn += " y " + obj.textSuggested.days;
            } else if (obj.days > 0 && obj.months == 0) { //si tiene dias pero no meses
                stringReturn += "Hace " + obj.textSuggested.days;
            }

            return stringReturn;
        }

        vm.searchDataInArrayObject = function (data, key, valueSearch) {
            var arrReturn = [];
            for (var i in data) {
                if (typeof data[i][key] != "undefined") {
                    var dataReturn = {};
                    if (valueSearch || valueSearch == null) {
                        if (data[i][key] == valueSearch) {
                            arrReturn.push(data[i]);
                        }
                    } else {
                        arrReturn.push(data[i]);
                    }
                }
            }
            return arrReturn;
        }

        //se realiza esta funcion para formatear una fecha en una manera escrita 
        vm.serializeDate = function (value, config, otherParams) {
            var returnObj = {}

            returnObj.serializeDate = IkanoFactory.betweenDatesToReplace(config.textReplace, value, otherParams);
            if (config.serializeMoth) {
                returnObj.stringDateInMonth = vm.setStringDateInMonth(returnObj.serializeDate);
            }
            if (config.serializeFormatDate) {
                returnObj.formatDate = vm.setFormatDate(value, config.serializeFormatDate.format);
            }
            return returnObj;
        }

        //Texto de una fecha ej: "Hace 2 años y 3 meses"
        vm.setStringDateInMonth = function (obj) {
            var stringReturn = "";
            //SI ES HOY
            if (obj.isToday) {
                return stringReturn = "Hoy";
            }
            //SI TIENE AÑOS
            if (obj.months > 0) {
                stringReturn += "Hace " + obj.textSuggested.months;
            }
            //SI TIENE AÑOS Y MESES
            if (obj.days > 0 && obj.months > 0) {
                stringReturn += " y " + obj.textSuggested.days;
            } else if (obj.days > 0 && obj.months == 0) { //si tiene años pero no tiene meses
                stringReturn += "Hace " + obj.textSuggested.days;
            }

            return stringReturn;
        }

        /**
         * @param {ArrayObject} value 
         * @param {String} key 
         * @description recorre el array y compara con la key, retorna un array de fechas de menor a mayor
         */
        vm.orderDates = function (value, keySearch, keyRemplace, format,reverse) {

            var returnDates = [];
            value.map(function (v, k) {
                if (v[keySearch] != null && v[keySearch] != "" && typeof v[keySearch] != "undefined") {
                    var objs = angular.copy(v);
                    objs[keyRemplace] = moment(v[keySearch]);
                    objs[keyRemplace + 'Format'] = (format) ? objs[keyRemplace].format(format) : '';
                    returnDates.push(objs);
                }
            });

            if(reverse){
                return _.sortBy(returnDates, function (date) {
                    return date[keyRemplace].toDate().getTime();
                }).reverse();
            }else{
                return _.sortBy(returnDates, function (date) {
                    return date[keyRemplace].toDate().getTime();
                });
            }
            
        }

        /**
         * @param value Array(Date)
         * @return returObject 
         * @description se envia un array de DATES ORGANIZADO DE MENOR A MAYO *vm.orderDates* y devuelve el primer dia que sea mayor al dia actual
         */

        vm.nextCita = function (value) {
            var today = moment(new Date());
            var retunrObject = {};
            for (var i = 0; i < value.length; i++) {
                if (today < value[i].nameShow) {
                    retunrObject = value[i];
                    retunrObject.dateSelected = retunrObject.timeSelected = new Date(retunrObject.fecha_hora);
                    retunrObject.placeSelected = retunrObject.lugar;
                    retunrObject.typecitaSelected = retunrObject.tipo_cita;
                    retunrObject.keyArray = i;
                    break;
                }
            }

            //return (angular.equals(retunrObject,{}))?null:retunrObject ;
            return retunrObject;
        }

        /**
         * SETEA LAS CITAS PARA LOS CANDIDATOS
         */
        vm.setCita = function (data, config) {
            var objReturn = {};
            if (data.length == 0) {
                return objReturn;
            }
            objReturn.citas = vm.orderDates(data, 'fecha_hora', 'nameShow', 'MMM D, YYYY hh:mm A');
            objReturn.cita = vm.nextCita(objReturn.citas);
            return objReturn;
        }

        /**
         * 
         */

        vm.setCandidateInfo = function (value, config) {
            var jsonReturn = {};
            var baseJson = config.baseJson;
            angular.forEach(value, function (vv, vk) {
                jsonReturn[baseJson[vk]] = vv;
            });
            return jsonReturn;
        }

        /**
         * @param valor Int
         * @param config obj
         * @return string
         * 
         * @description "Se ingresa un numero ya sea entero o doble y retorna un string por ej: Ingresa 5.8 con la configuracion en años y este retorna 5 años y 10 meses "
         */

        vm.duration = function (value, config) {

            var returnText = '';

            switch (config.type) {
                case 'years':
                    var duration = moment.duration(value, 'years');
                    var years = duration.years();
                    var months = Math.round(duration.months());

                    returnText += (years > 0) ? (years > 1) ? years + ' años' : years + ' año' : '';
                    if (months > 0) {
                        returnText += (returnText != '') ? ' y ' : '';
                        returnText += (months > 1) ? months + ' meses' : months + ' mes';
                    }
                    break;
            }

            return returnText;
        }

        /**
         * 
         * @param valor Array 
         * @returns tamaño Int
         */
        vm.countArray = function (value) {
            return value.length;
        }

        /**
         * 
         */
        vm.mergeArr = function (value, config) {
            switch (config.type) {
                case 'Json':
                    return config.arrMerge[value];
                    break;
            }
        }

        /**
         * 
         */
        vm.parsejson = function (value, config) {
            return JSON.parse(value);
        }

        /**
         * 
         */
        vm.replacestr = function (value, config) {
            return value.replace(config.search, config.replace);
        }

        /**
         * 
         */
        vm.compareDate = function (value, config) {
            return angular.equals(value, config.data);
        }

        vm.getRandomNumber = function () {
            return Math.floor((Math.random() * 100) + 1);
        };

        /**
         * MERGE JSON
         *
         */
        
        vm.mergeJson = function(primary,second) {
            var returnJson = angular.copy(primary);
            angular.forEach(second,function(value,key){
                if(!returnJson[key]){
                    returnJson[key] = value;
                }   
            });     
            return returnJson;
        }


        /** ===================================*
         *              HEADER                 *
         * ====================================*/
        vm.getHeaderProjects = function () {
            return vm.projectRequest;
        }
        vm.getHeaderProjectsAdmin = function () {
            return vm.projectRequestAdmin;
        }

        vm.getProject = function (key) {
            for (i in vm.projectRequest) {
                if (vm.projectRequest[i].key == key) {
                    return vm.projectRequest[i];
                }
            }
        }

        vm.getHeaderReports = function () {
            return vm.reportsHeader;
        }

        vm.getReport = function (key) {
            for (i in vm.reportsHeader) {
                if (vm.reportsHeader[i].key == key) {
                    return vm.reportsHeader[i];
                }
            }
        }
        return {
            modeldataarray: modeldataarray,
            modeldata: modeldata,
            returnVar: returnVar,
            deleteVar: deleteVar,
            misc: {
                setFormatDate: vm.setFormatDate,
                getOneKey: vm.getOneKey,
                setStringDate: vm.setStringDate,
                formatDate: vm.formatDate,
                orderDates: vm.orderDates,
                setCita: vm.setCita,
                nextCita: vm.nextCita,
                searchDataInArrayObject: vm.searchDataInArrayObject,
                serializeDate: vm.serializeDate,
                setStringDateInMonth: vm.setStringDateInMonth,
                parsejson: vm.parsejson,
                replacestr: vm.replacestr,
                compareDate: vm.compareDate,
                getRandomNumber:vm.getRandomNumber,
                mergeJson:vm.mergeJson
            },
            header: {
                getHeaderProjects: vm.getHeaderProjects,
                getProject: vm.getProject,
                getHeaderReports: vm.getHeaderReports,
                getReport: vm.getReport,
                getHeaderProjectsAdmin: vm.getHeaderProjectsAdmin
            }
        }
    }

})();
(function () {
    'use strict';
    angular.module('app.seleccion_analyst')
        .directive('notes', function () {
            return {
                restrict: 'E',
                templateUrl: 'app/main/analyst/partials/notes/note.html',
                scope: {
                    notes: '=',
                    callbackAddNote: '&',
                    classHeader: '=',
                    classBody: '=',
                    indexCandidate: '='
                },
                link: function (scope, elem, attrs) {
                    scope.data = {};
                    scope.data.visualize = 1;
                    scope.showForm = false;

                    scope.changeForm = function () {
                        if (scope.showForm) {
                            scope.showForm = false;
                        } else {
                            scope.showForm = true;
                        }
                    }

                }
            };
        })
        .directive('headerRequest', function () {
            return {
                restrict: 'E',
                templateUrl: 'app/main/templates/header/request.html',
                scope: {
                    request: "=",
                    project: "=",

                },
                controllerAs: 'vm',
                bindToController: true,
                controller: function ($scope, analystMisc, $mdDialog, analystService, $document, $state, IkanoFactory, AuthService, analystConstant, $rootScope, $mdToast) {

                    //contructor
                    var vm = this;
                    vm.request = $scope.request;

                    vm.projectName = $scope.project;
                    vm.project = vm.selectedProject = vm.project;

                    vm.user = AuthService.getUserData();

                    vm.projects = (vm.user.group_id == 1) ? analystMisc.header.getHeaderProjectsAdmin() : analystMisc.header.getHeaderProjects();

                    vm.status_process_status = analystConstant.STATUSPROCESS;

                    vm.openShowRequestNotesDialog = function () {
                        $mdDialog.show({
                            controller: 'ShowRequestNotesController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-request-notes.html',
                            parent: angular.element($document.body),
                            clickOutsideToClose: true,
                            locals: {
                                request: vm.request,
                                callbackSuccess: vm.addNoteRequest
                            }
                        });
                    }

                    vm.addNoteRequest = function (data) {
                        var dataPost = {};
                        dataPost.proceso_id = vm.idRequest;
                        dataPost.observacion = data.note;
                        data.note = '';
                        analystService.addNoteRequest(dataPost, function (response) {
                            var newNota = {};
                            newNota.name = AuthService.getUserData().name;
                            newNota.id = response.data.result.id;
                            newNota.date_create_note = analystMisc.misc.setFormatDate(response.data.result.created_at, { format: 'MMM D, YYYY H:mm ' });
                            newNota.note = response.data.result.descripcion;
                            newNota.newNote = true;
                            vm.request.notes.unshift(newNota);
                        }, function (reject) {
                            IkanoFactory.showAlert("Error", "Ha ocurrido un error creando la nota del proceso, por favor intente de nuevo.");
                        });
                    }

                    vm.publishRequest = function () {
                        $state.go('app.publish_request', { request_id: vm.request.id });
                    }

                    vm.showFinishProcess = function () {
                        $mdDialog.show({
                            controller: 'finishRequestDialog',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/analyst/partials/finish_process/finish_process.html',
                            parent: angular.element($document.body),
                            clickOutsideToClose: true,
                            locals: {
                                request: vm.request
                            }
                        }).then(function (resolve) {
                            if (resolve.data.status) {
                                vm.modelRequest(resolve.data.data.proceso);
                                vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
                            } else {
                                IkanoFactory.showAlert("Error", resolve.data.message);
                            }
                        });
                    }

                    vm.selectProject = function (project) {
                        if (project.function) {
                            vm[project.function]();
                        } else {
                            $state.go(project.url, { request_id: vm.request.id });
                        }

                    }

                    vm.showUpdateRequest = function () {
                        $mdDialog.show({
                            controller: 'updateRequestDialog',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/analyst/partials/update-request/update.html',
                            parent: angular.element($document.body),
                            clickOutsideToClose: true,
                            locals: {
                                request: vm.request
                            }
                        }).then(function (resolve) {
                            if (resolve.data.status) {
                                //vm.modelRequest(resolve.data.data.proceso);
                                vm.showToast({ class: "success", message: resolve.data.message, showClose: true });
                            } else {
                                IkanoFactory.showAlert("Error", resolve.data.message);
                            }
                        });
                    }

                    //Modelamos la data de la request   
                    vm.modelRequest = function (data) {

                        $rootScope.$broadcast('setModelRequest', data);

                        var baseJson = analystConstant.KEYJSONREQUEST;
                        analystMisc.modeldata(data, baseJson, { createIfNotExist: true })
                            .then(function (resolve) {
                                vm.request = resolve;
                                analystMisc.modeldataarray(vm.request.notes, analystConstant.KEYJSONNOTE).then(function (resolve) {
                                    vm.request.notes = resolve;
                                });
                            })
                            .catch(function (reject) {
                                console.error(reject);
                            });
                    }

                    vm.showToast = function (data, options) {

                        options = (options) ? options : [];

                        $mdToast.show({
                            hideDelay: 7000,
                            position: 'top right',
                            controller: 'ToastCrl',
                            controllerAs: 'vm',
                            templateUrl: 'app/toast/template/toast.default.html',
                            locals: {
                                options: options,
                                config: data,
                            },
                            toastClass: data.class
                        });
                    }
                }
            }
        })
        .directive('cellReport', function () {
            return {
                restrict: 'E',
                template: '<span>{{showValue}}</span>',
                scope: {
                    value: "=",
                },
                link: function (scope, element, attrs) {
                    function validateValue() {
                        switch (typeof scope.value) {
                            case "string":
                                validateString();
                                break;
                            case "number":
                                scope.showValue = angular.copy(scope.value);
                                element.parent().addClass("text-center");
                                break;
                            case "undefined":
                                scope.showValue = '-';
                                element.parent().addClass("text-center");
                                break;
                            case "object":
                                validateObject();
                                break;
                        }
                    }

                    function validateObject() {
                        if (scope.showValue == null || scope.showValue == "null" || scope.showValue == "") {
                            scope.showValue = '-';
                            element.parent().addClass("text-center");
                        }

                    }

                    function validateString() {
                        var dateValidate = moment(scope.value);
                        if (dateValidate.isValid()) {
                            scope.showValue = dateValidate.format('MMM D, YYYY');
                        } else if (scope.value == "" || scope.value == null || scope.value == "null") {
                            element.parent().addClass("text-center");
                            scope.showValue = "-";
                        } else {
                            scope.showValue = angular.copy(scope.value);
                        }
                    }

                    validateValue();
                }
            }
        });
})();
(function () {
    'use strict';
    angular.module('app.seleccion_analyst').directive('candidatedetail', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/main/analyst/partials/candidate-detail/candidate-detail.html',
            scope: {
                selected: '=',
                data: '=',
                config: '=',
                backup: '=',
                listas: '=',
                proceso: '=',
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: function (AdminService, AuthService, CandidateService, ValidationService, IkanoFactory, analystConstant, analystService, $state, $scope, $mdDialog, $document, analystMisc, $mdSidenav, $mdDateLocale, $rootScope, $q, $mdToast, $window, $filter) {
                var vm = this;

                vm.loading = true;
                vm.resume = null;
                vm.blocks = [];
                vm.attachments = null;
                vm.candidate = null;
                vm.history = null;
                vm.request = null;
                vm.analyst = true;

                //miscelaneos
                vm.misc = {};
                vm.misc.hover = {};
                vm.misc.lists = {};
                vm.validationService = ValidationService;
                vm.messages = [];

                //CandidatesInfo
                vm.positionCandidate = {};
                vm.onlyCandidateNotView = (localStorage.onlyCandidateNotView == "true") ? true : false;

                //INFORME PARA EL CLIENTE
                vm.reporrForTheClient;
                vm.showReporrForTheClient = false;
                vm.fields = [];

                vm.urlBase = CandidateService.getUrlBase();

                vm.stageData = {};

                vm.getAttachmentUrl = getAttachmentUrl;

                /**
                 * HOJA DE VIDA
                 */

                vm.showHV = function () {
                    vm.showStageSelected = false;
                    vm.showReporrForTheClient = false;
                }

                function setHojaVida() {
                    vm.showAlertHojaVida = false;
                    vm.showReporrForTheClient = false;
                    vm.showStageSelected = false;
                    vm.resume = vm.data.hoja_vida.data_bloques;
                    vm.fieldsResume = vm.data.hoja_vida.estructura_campos;
                    vm.lists = angular.copy(vm.listas);
                    vm.recomendaciones = {
                        title:vm.listas.recomendaciones_title,
                        footer:vm.listas.recomendaciones_footer,
                        recomendaciones: vm.listas.recomendaciones
                    };
                    vm.attachments = vm.data.hoja_vida.adjuntos;
                    vm.getDiffBetweenTwoDates = IkanoFactory.getDiffBetweenTwoDates;

                    vm.candidate = angular.copy(vm.selected);
                    if (!vm.recomendaciones) {
                        vm.recomendaciones = {};
                    }
                    if (vm.backup) {
                        vm.backup = vm.candidate;
                    }
                    vm.stageSelected = vm.candidate.stage;
                    vm.history = vm.data.historial;
                    if (vm.data.bloques_etapas_candidato) {
                        vm.blockStage = vm.data.bloques_etapas_candidato;
                        if(!vm.blockStage.estructura_campos && vm.config.stage_structure_fields){
                            vm.blockStage.estructura_campos = angular.copy(vm.config.stage_structure_fields);
                        }
                        vm.stages = mergeStage(vm.listas.etapas, vm.blockStage);
                    }

                    if (vm.data.bloques_informe_cliente) {
                        vm.infoBlockReportClient = vm.data.bloques_informe_cliente;
                        if(!vm.infoBlockReportClient.estructura_campos && vm.config.info_client_structure_fields){
                            vm.infoBlockReportClient.estructura_campos = angular.copy(vm.config.info_client_structure_fields);
                        }
                    }

                    if (vm.config.getOtherProcess) {
                        if (!vm.data.otros_procesos) {
                            getOtherProcess();
                        }
                    }

                    if (!vm.candidate.view && vm.config.setView) {
                        var datapost = {
                            proceso_id: vm.proceso.id,
                            hv_id: vm.selected.id,
                        }

                        analystService.set_candidate_as_visto(datapost, function (response) {
                            if (response.data.status) {
                                $rootScope.$broadcast('candidate-mark-view', { response: response, candidate: vm.selected });
                            }

                        }, function (response) {
                            IkanoFactory.showAlert("Error", "Ha ocurrido un error marcando como visto la hoja de vida, por favor intente de nuevo.");
                        }, true);
                    }

                    vm.modelNotes(vm.candidate.notes).then(function (resolve) {
                        vm.candidate.notes = resolve;
                    });

                    setTitles();
                }

                function setTitles() {
                    vm.blocks = $.map(vm.resume, function (value, index) {
                        if (value.titulo instanceof Array) { } else {
                            value.titulo = value.titulo.split(" ");
                        }
                        value.name = index;
                        value.emptyRowsMessage = "Por favor completa todos lo datos solicitados. Esto hará que la calidad de la información de tu hoja de vida mejore y agilize el proceso de selección";
                        value.item = (value.data && !value.data.length ? value.data : null);

                        if (value.name == "personales") {
                            value.data.foto = value.data.foto + "?v=" + analystMisc.misc.getRandomNumber();
                        }

                        value.campos = IkanoFactory.getStructureForFields(value.campos,vm.fieldsResume);

                        return [{ name: index, data: value }];
                    });
                }

                function mergeStage(etapa, bloque) {
                    var data = bloque.data;
                    for (var i in etapa) {
                        if (data[etapa[i].id]) {
                            etapa[i].aprueba = angular.copy(data[etapa[i].id].aprueba);
                        } else {
                            etapa[i].aprueba = 0;
                        }

                        if (etapa[i].id == 10) {
                            vm.stageDiscard = etapa[i];
                        }
                    }
                    return etapa;
                }

                /**
                 *  ACCIONES PRINCIPALES
                 */
                vm.downloadPdfStage = function () {
                    analystService.downloadStage({ proceso_id: vm.proceso.id, hoja_vida_id: vm.selected.id, etapa_id: vm.stage.id }, { responseType: 'arraybuffer' },
                        function (response) {
                            IkanoFactory.downloadFile(response.data, vm.stage.etapa + '.pdf')
                        },
                        function (response) {
                            IkanoFactory.showAlert("Error", "Ha ocurrido un error descargando el archivo, por favor intente de nuevo.");
                        })
                }

                vm.setValuesWatch = function (root) {
                    ValidationService.setWarchers($scope, root);
                };

                vm.setHover = function (key) {
                    if (vm.misc.hover[key]) {
                        vm.misc.hover[key] = false;
                    } else {
                        vm.misc.hover[key] = true;
                    }
                }

                /**
                 * Citas
                 */

                vm.setScheduleCandidate = function () {
                    var configModal = {};
                    configModal.toolbar = {};
                    configModal.toolbar.name = 'Agendar cita con el candidato';
                    configModal.toolbar.class = {};
                    configModal.data = vm.candidate.cita.cita;
                    configModal.citas = vm.candidate.cita.citas;
                    configModal.dataCandidate = vm.candidate;
                    configModal.lists = angular.copy(vm.listas);
                    vm.candidateSelected = vm.candidate;
                    configModal.callbackSuccess = vm.addScheduleCandidate;

                    configModal.templateUrl = 'app/main/analyst/partials/scheduled_citation/scheduled_citationDialog.html';

                    vm.showModalScheduleCandidate(configModal);
                }

                vm.addScheduleCandidate = function (data) {
                    var dataPost = {};
                    dataPost.proceso_id = vm.proceso.id;
                    dataPost.hoja_vida_id = vm.candidateSelected.id;
                    var dateFinal = moment(data.dateSelected).format('YYYY-MM-DD');
                    var hourFinal = moment(data.timeSelected).format('HH:mm:ss');
                    dataPost.fecha_hora = moment(dateFinal + ' ' + hourFinal).format('YYYY-MM-DD HH:mm:ss');
                    dataPost.lugar = data.placeSelected;
                    dataPost.tipo_cita = data.typecitaSelected;
                    analystService.addScheduleCandidate(dataPost, function (response) {
                        response.data.result.fecha = response.data.result.fecha_hora;
                        vm.candidate.citaBackup.push(response.data.result);
                        vm.candidate.cita = vm.setCita(vm.candidate.citaBackup);
                    }, function (reject) {
                        IkanoFactory.showAlert("Error", "Ha ocurrido un error agendando el candidato, por favor intente de nuevo.");
                    });
                }

                vm.showModalScheduleCandidate = function (configModal) {
                    var parentEl = angular.element(document.body);
                    $mdDialog.show({
                        parent: parentEl,
                        templateUrl: configModal.templateUrl,
                        clickOutsideToClose: true,
                        controller: 'scheduledCitationCandidateDialog',
                        controllerAs: 'vm',
                        locals: {
                            config: configModal
                        }
                    });
                }

                vm.setCita = function (value) {
                    var objReturn = {};

                    if (value.length == 0) {
                        return objReturn;
                    }

                    objReturn.citas = analystMisc.misc.orderDates(value, 'fecha_hora', 'nameShow', 'MMM D, YYYY hh:mm A');
                    objReturn.cita = analystMisc.misc.nextCita(objReturn.citas);
                    return objReturn;
                }

                /**
                 * MARCAR FAVORITO
                 */
                vm.markAsFavorite = function () {
                    //vm.loading = true;
                    analystService.setFavorite({ hv_id: vm.candidate.id },
                        function (response) {
                            if (response.data && response.data.status) {
                                vm.candidate.favorite = (vm.candidate.favorite ? 0 : 1);
                            }
                            vm.loading = false;
                        },
                        function (response) {
                            vm.loading = false;
                            IkanoFactory.showAlert("Error", "Ha ocurrido un error, por favor intente de nuevo.");
                        }
                    );
                };

                /**
                 * MARCAR CANDIDATO
                 */

                vm.saveMarker = function () {
                    analystService.saveMarker({ mark: vm.markerSelected, hoja_vida_id: vm.selected.id }, function (resolve) {
                        if (resolve.data.status) {
                            vm.showMarker = false;
                            vm.candidate.marker = resolve.data.mark ? 0 : angular.copy(vm.markerSelected);
                            showToast({ class: "success", message: resolve.data.message, showClose: true });
                            updateDataCandidate({marker:vm.candidate.marker});
                        } else {
                            showToast({ class: "error", message: resolve.data.message, showClose: true });
                        }
                    }, function (reject) {
                        candidate.loadingMarker = false;
                        IkanoFactory.showAlert("Error", reject.data.message);
                    })
                }

                /**
                 * VER NOTAS
                 */
                vm.openShowCandidateNotesDialog = function () {
                    $mdDialog.show({
                        controller: 'ShowCandidateNotesController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-candidate-notes.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose: true,
                        locals: {
                            candidate: vm.candidate,
                            request: vm.proceso,
                            title: "Notas"
                        }
                    });

                }
                //Retorna las notas serializadas
                vm.modelNotes = function (data) {
                    var baseJson = analystConstant.KEYJSONNOTE;
                    baseJson.analista.callback = "getOneKey";
                    baseJson.fecha.callback = "setFormatDate";
                    return analystMisc.modeldataarray(data, baseJson);
                }

                /**
                 * HISTORIAL
                 */

                vm.openShowCandidateHistoryDialog = function () {
                    $mdDialog.show({
                        controller: 'ShowCandidateHistoryController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/analyst/candidate-detail/dialogs/show-candidate-history.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose: true,
                        locals: {
                            candidate: vm.candidate,
                            history: vm.history,
                            stages: angular.copy(vm.stages),
                            lists: angular.copy(vm.listas),
                            request: angular.copy(vm.proceso),
                        }
                    });
                }

                /**
                 * RECOMENDAR CANDIDATO
                 */

                vm.openRecommendCandidateDialog = function () {
                    $mdDialog.show({
                        controller: 'RecommendCandidateController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/analyst/candidate-detail/dialogs/recommend-candidate.html',
                        parent: angular.element($document.body),
                        clickOutsideToClose: true,
                        locals: {
                            positions: vm.listas.cargos,
                            candidate: vm.candidate,
                        }
                    }).then(function (resolve) {
                        $rootScope.$broadcast('candidate::recommend', vm.candidate.recomendaciones);
                    });

                    $mdDialog.close
                };

                /**
                 * INFORME PARA EL CLIENTE
                 */

                vm.showReportForToclientFn = function () {
                    vm.showStageSelected = false;
                    if (vm.showReporrForTheClient) {
                        vm.showReporrForTheClient = false;
                    } else {
                        setBlockReportForClient();
                        vm.showReporrForTheClient = true;
                    }
                }

                vm.saveReportForToclientFn = function () {
                    var dataPost = {
                        proceso_id: vm.proceso.id,
                        hv_id: vm.selected.id,
                    }
                    vm.reportClientData.errors = IkanoFactory.validateFieldsWithObject(vm.reportClientData.fields, vm.reportClientData.values, true);
                    if (angular.equals(vm.reportClientData.errors, {})) {
                        dataPost.data = vm.reportClientData.values;
                        analystService.saveReportForToclient(dataPost,
                            function (response) {
                                if (response.data.status) {
                                    showToast({ class: "success", message: response.data.message, showClose: true });
                                } else {
                                    showToast({ class: "error", message: response.data.message, showClose: true });
                                }
                            },
                            function (response) {
                                IkanoFactory.showAlert("Error", response.data.message);
                                vm.saving = false;
                                vm.change = true;
                            }
                        );
                    } else {
                        IkanoFactory.showAlert("Error", "El entendimiento se encuentra incompleto, por favor complete los campos antes de enviar aprobación.");
                    }
                }

                function setBlockReportForClient() {
                    vm.reportClientData = {};
                    vm.reportClientData.data = {
                        bloques: vm.infoBlockReportClient.bloques,
                        data: vm.infoBlockReportClient.data,
                        estructura_campos: vm.infoBlockReportClient.estructura_campos,
                        listas: vm.infoBlockReportClient.listas
                    }
                    vm.reportClientData.values = vm.reportClientData.data.data;
                    vm.reportClientData.lists = angular.copy(vm.listas);
                    //vm.fields = vm.data.estructura_campos;

                    vm.reportClientData.fields = ValidationService.disableField(vm.reportClientData.data.estructura_campos, vm.reportClientData.values);

                    vm.reportClientData.extra = vm.reportClientData.data.extra;

                    vm.reportClientData.observations = vm.reportClientData.data.observaciones;
                    //vm.setPageData();
                    
                    vm.setValuesWatch(vm.reportClientData);
                    vm.change = false;
                    setBlocksReportForClient();
                    ValidationService.generalFunctions($scope, vm.reportClientData);
                }

                function setBlocksReportForClient() {
                    vm.blocksReportForClient = $.map(vm.reportClientData.data.bloques, function (value, index) {
                        return [getBlockReportForClient(index, value)];
                    });
                };

                function getBlockReportForClient(index, data) {
                    var block = {
                        id: null,
                        name: index,
                        model: data.model,
                        title: (data.name ? data.name.split(" ") : ""),
                        type: "two-columns",
                        block: data.model.type,
                        fields: IkanoFactory.getStructureForFields(data.campos,vm.reportClientData.fields)
                    };

                    if (block.name == "info_general") {
                        block.type = "one-column";
                    } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                        block.type = "select-current-employee";
                    } else if (block.fields.length < 2) {
                        block.type = "one-column";
                    } else if (data.type == "has_many") {
                        block.type = "two-column-multiple-rows";
                    }

                    return block;
                };

                /**
                 * ETAPAS
                 */

                vm.changeStage = function (stage, saveStage) {
                    vm.stageSelectedBack = angular.copy(vm.stageSelected);
                    if (stage.confirmar) {
                        vm.stage = angular.copy(stage);
                    } else {
                        vm.stageSelected = stage;
                        vm.stage = angular.copy(vm.stageSelected);
                    }
                    vm.showReporrForTheClient = false;
                    vm.editStage = false;
                    vm.modifiStage = false;
                    vm.approbeStage = false;
                    validateStage(stage);
                    
                    if (saveStage && !stage.confirmar) {
                        vm.assignStage();
                    }
                }

                vm.updateStage = function () {
                    vm.editStage = true;
                    vm.modifiStage = true;
                    vm.setHover('updateStage');
                }

                function validateStage(stage) {
                    var keys = [];
                    var jsonReturn = {};

                    if ((stage.confirmar || stage.req_aprobacion) && !stage.descartar && !stage.etapa) {
                        var stageNoApprove = searchStageApprove(stage);
                        vm.showModalStageConfirm(stageNoApprove.arrStageIncompletTerna);
                        vm.goNextStage = (stage.req_aprobacion) ? true : false;
                        return;
                    }

                    if (stage.confirmar && stage.descartar) {
                        vm.showModalStageDiscard();
                        vm.goNextStage = false;
                        return;
                    }

                    if (stage.confirmar && stage.etapa) {
                        var stageNoApprove = searchStageApprove(stage);
                        vm.showModalStageBlock(stage, stageNoApprove.arrStageIncomplet);
                        vm.goNextStage = false;
                        return;
                    }
                    if (typeof stage.etapa != "undefined" && stage.etapa != null) {
                        vm.showStageSelected = true;
                        searchBlockStage(stage);
                        return;
                    }

                    if (!stage.confirmar && !stage.descartar && !stage.req_aprobacion && !stage.etapa && !vm.config.onlyViewStages) {
                        vm.showStageSelected = false;
                        vm.goNextStage = false;
                        vm.saveStage(stage, false, 1, true);
                        return;
                    }

                }

                vm.assignStage = function () {
                    vm.editStage = true;
                    vm.approbeStage = true;
                    goToStage(vm.stage, {}, 0, true);
                    vm.setHover('assignStage');
                }

                function goToStage(stage) {
                    var dataPost = {};
                    dataPost.proceso_id = vm.proceso.id;
                    dataPost.hv_id = vm.selected.id;
                    dataPost.etapa_id = stage.id;
                    dataPost.pasar_etapa = 1;
                    dataPost.data = (!vm.blockStage.data[stage.id]) ? {} : vm.blockStage.data[stage.id];

                    analystService.saveStage(dataPost, function (response) {
                        if (response.data.status) {
                            vm.backupValues = angular.copy(dataPost.data);
                            vm.editStage = true;
                            vm.approbeStage = true;
                            vm.candidate.etapa = angular.copy(stage);
                            vm.history = response.data.historial.historial;
                            sendNewStageCandidate(stage);
                            updateDataHeader({ selected: response.data.cant_seleccionado, finalist: response.data.cant_finalista, preSelected: response.data.cant_preseleccionado });
                            //updateDataCandidate({historial: response.data.historial.historial});
                            updateDataBloques(response.data.data, stage.id);
                        } else {
                            IkanoFactory.showAlert("Error", response.data.message);
                        }

                    }, function (reject) {
                        IkanoFactory.showAlert("Error", reject.data.message);
                    });
                }

                function searchStageApprove(stage) {
                    var arrStageIncomplet = [];
                    var arrStageIncompletTerna = [];
                    for (var i in stage.etapas) {
                        for (var s in vm.stages) {
                            if (stage.etapas[i] == vm.stages[s].id) {
                                if (vm.stages[s].aprueba != 1) {
                                    arrStageIncomplet.push(vm.stages[s]);
                                    arrStageIncompletTerna.push(vm.stages[s]);
                                } else {
                                    break;
                                }
                            } else {
                                continue;
                            }
                        }
                        /*if (vm.stages[i].etapa_requerida) {
                            if (vm.stages[i].aprueba != 1) {
                                arrStageIncomplet.push(vm.stages[i]);
                            }
                        }
                        if (vm.stages[i].etapa_requerida_terna) {
                            if (vm.stages[i].aprueba != 1) {
                                arrStageIncompletTerna.push(vm.stages[i]);
                            }
                        }*/

                    }
                    return { arrStageIncomplet: arrStageIncomplet, arrStageIncompletTerna: arrStageIncompletTerna };
                }

                function searchBlockStage(stage) {
                    var valueStage = (vm.blockStage.data[stage.id]) ? vm.blockStage.data[stage.id] : {};
                    vm.blockAutoRellenar = [];
                    
                    vm.stageData.data = {
                        bloques: vm.blockStage.bloques[stage.etapa],
                        data: valueStage,
                        estructura_campos: vm.blockStage.estructura_campos,
                        listas: vm.blockStage.listas
                    }

                    vm.stageData.attachments = vm.blockStage.adjuntos;

                    vm.stageData.extra = {
                        etapa_id: stage.id,
                        proceso_id: vm.proceso.id,
                        hv_id: vm.selected.id
                    }

                    vm.stageData.getAttachmentUrl = getAttachmentUrl;
                    vm.stageData.deleteAttachtment = deleteAttachtment;

                    vm.stageData.values = angular.copy(vm.stageData.data.data);
                    if (!angular.equals(vm.stageData.values, {})) {
                        vm.misc.values = {};
                        vm.misc.values.created_at = moment(vm.stageData.values.created_at).format('MMM D, YYYY hh:mm a');
                        vm.misc.values.updated_at = moment(vm.stageData.values.updated_at).format('MMM D, YYYY hh:mm a');
                        vm.misc.values.analista = angular.copy(vm.stageData.values.analista);
                    } else {
                        vm.misc.values = false;
                    }


                    vm.stageData.lists = angular.copy(vm.listas);

                    vm.stageData.fields = getFieldsEtapa(vm.stageData.data.estructura_campos, vm.stageData.data.bloques);

                    vm.backupValues = angular.copy(vm.stageData.values);
                    setBlocksStage();

                    vm.setValuesWatch(vm.stageData);
                }

                function getFieldsEtapa(fields, bloques) {
                    var objReturn = {};
                    for (var i in bloques) {
                        if (bloques[i].auto_rellenar) {
                            vm.blockAutoRellenar.push(bloques[i]);
                        }
                        for (var j in bloques[i].campos) {
                            var keySearch = "";
                            if (bloques[i].type == "has_many") {
                                keySearch = bloques[i].model;
                            } else {
                                keySearch = bloques[i].campos[j];
                            }

                            objReturn[keySearch] = fields[keySearch];
                        }
                    }
                    return objReturn;
                }

                function autoRellenarBloque(data, lists) {
                    var campos = [];
                    var jsonReturn = {};
                    //BLOQUES QUE TIENEN AUTORELLENAR
                    for (var i in vm.blockAutoRellenar) {
                        //VALIDO SI EL BLOQUE ES HAS MANY
                        if (vm.blockAutoRellenar[i].type == "has_many") {
                            //CAMPOS POR MODEL
                            campos = data.estructura_campos[vm.blockAutoRellenar[i].model];
                            jsonReturn[vm.blockAutoRellenar[i].model] = [];
                            //FOR CAMPOS
                            for (var c in campos) {
                                if (campos[c].auto_rellenar) {
                                    jsonReturn[vm.blockAutoRellenar[i].model] = mergeDataLists(campos[c].options, campos, lists);
                                    break;
                                }
                            }
                        }
                    }
                    return jsonReturn;
                }

                function mergeDataLists(campo_autorellenar, campos, lists) {
                    var data = Object.keys(lists[campo_autorellenar]);
                    var dataReturn = [];
                    for (var i in data) {
                        var dataJsonReturn = {};

                        for (var c in campos) {
                            if (campos[c].auto_rellenar) {
                                dataJsonReturn[c] = data[i];
                            } else {
                                dataJsonReturn[c] = "";
                            }
                        };

                        dataReturn.push(dataJsonReturn);
                    }
                    return dataReturn;
                }

                function setBlocksStage() {
                    vm.blocksStage = $.map(vm.stageData.data.bloques, function (value, index) {
                        return [getBlockStage(index, value)];
                    });
                };

                function getBlockStage(index, data) {
                    var block = {
                        id: null,
                        name: index,
                        model: (data.etapa == "informacion_seleccion" ? data.etapa : data.model),
                        title: (data.name ? data.name.split(" ") : ""),
                        type: "two-columns",
                        block: data.model.type,
                        fields: data.type == "has_many" ? IkanoFactory.getStructureForFieldsHasMany(data.campos,vm.stageData.fields,data.model) : IkanoFactory.getStructureForFields(data.campos,vm.stageData.fields),
                        collapse: (data.etapa == 'pruebas'),
                        hideCollapse: (data.etapa == 'pruebas'),
                        subtitle: data.subtitle
                    };
                    if (block.name == "info_general") {
                        block.type = "one-column";
                    } else if (block.name == "info_ocupante_actual" || block.name == "persona_reemplazar") {
                        block.type = "select-current-employee";
                    } else if (block.fields.length < 2) {
                        block.type = "one-column";
                    } else if (data.type == "has_many") {
                        block.type = "two-column-multiple-rows";
                    } else if (block.model == 'kbit_pruebas' || block.model == 'waiss4_pruebas' || block.model == 'btsa_pruebas' || block.model == 'pruebas_16pf' || block.model == 'mips_pruebas') {
                        block.type = "one-column";
                    }

                    return block;
                };

                function getAttachmentUrl(attachment) {
                    var id = (typeof attachment !== "number") ? attachment.id : attachment;
                    analystService.getFile({ id: id }, { responseType: 'arraybuffer' },
                        function (response) {
                            IkanoFactory.downloadFile(response.data, attachment.name)
                        },
                        function (response) {
                            IkanoFactory.showAlert("Error", "Ha ocurrido un error descargando el archivo, por favor intente de nuevo.");
                        });
                }

                function deleteAttachtment(root, field, item, attachment) {
                    var data = {
                        id: attachment.id
                    }
                    CandidateService.deletefileanalista(data, {},
                        function (response) {
                            if (response.data.status) {
                                if (root.attachments[field] && root.attachments[field][item.id]) {
                                    searchAndDeleteFile(root.attachments[field][item.id], attachment);
                                } else if (root.attachments[field] && root.attachments[field] instanceof Array) {
                                    searchAndDeleteFile(root.attachments[field], attachment);
                                } else {
                                    searchAndDeleteFile(root.attachments[field][idblock], attachment);
                                }

                            } else {
                                root.error = response.data.message;
                            }
                        },
                        function (response) {
                            root.error = response.data.message;
                        }
                    );
                }

                function searchAndDeleteFile(array, attachment) {
                    for (var i in array) {
                        if (array[i].id == attachment.id) {
                            array.splice(i, 1);
                            break;
                        }
                    }
                }

                vm.addModelToBlock = function (block, root) {
                    var model = {};
                    for (var index = 0; index < block.fields.length; index++) {
                        var element = block.fields[index];
                        model[element] = null;
                    }
                    if (!root) {
                        if (vm.values[block.model] == "undefined" || vm.values[block.model] == null) {
                            vm.values[block.model] = [];
                        }
                        vm.values[block.model].push(model);
                    } else {
                        if (root.values[block.model] == "undefined" || root.values[block.model] == null) {
                            root.values[block.model] = [];
                        }
                        root.values[block.model].push(model);
                    }



                }

                vm.removeModelToBlock = function (block, index, root) {
                    if (root) {
                        root.values[block.model].splice(index, 1);
                    } else {
                        vm.values[block.model].splice(index, 1);
                    }

                }

                vm.serializeField = function (fields, blocks) {
                    var jsonReturn = {};
                    var block = {};
                    var campo = {};
                    for (var i in blocks) {
                        block = blocks[i]
                        for (var f in block.campos) {
                            campo = block.campos[f];
                            if (fields[campo]) {
                                jsonReturn[campo] = fields[campo];
                            }
                        }
                    }
                    return jsonReturn;
                }

                function setNewStage(stage, showStage, approve) {
                    $("#content").animate({ scrollTop: 0 }, "slow");
                    vm.stageSelected.aprueba = approve;
                    sendNewStageCandidate(stage);
                    vm.showStageSelected = showStage;
                    for (var i in vm.stages) {
                        if (vm.stages[i].id == stage.id) {
                            vm.stages[i].aprueba = approve;
                            if (vm.goNextStage) {
                                var indexStage = parseInt(i) + 1;
                                if (vm.stages[indexStage].id == 9) {
                                    return;
                                }
                                vm.changeStage(vm.stages[indexStage], true);
                            }
                        }
                    }
                }

                vm.saveStage = function (stage, data, approve, shownextStage) {
                    var dataPost = {};
                    dataPost.proceso_id = vm.proceso.id;
                    dataPost.hv_id = vm.selected.id;
                    dataPost.etapa_id = stage.id;
                    dataPost.aprueba = approve;
                    dataPost.data = (!data) ? {} : data;

                    analystService.saveStage(dataPost, function (response) {
                        if (response.data.status) {

                            vm.backupValues = angular.copy(data);
                            vm.editStage = false;
                            vm.approbeStage = false;
                            vm.candidate.etapa = angular.copy(stage);
                            vm.history = response.data.historial.historial;
                            saveChangeStage(stage, response.data.data);
                            setNewStage(stage, !shownextStage, approve, true);
                            showToast({ class: "success", message: response.data.message, showClose: true });
                            updateDataHeader({ selected: response.data.cant_seleccionado, finalist: response.data.cant_finalista, preSelected: response.data.cant_preseleccionado });
                            //updateDataCandidate({historial: response.data.historial.historial});
                            updateDataBloques(response.data.data, stage.id);
                        } else {
                            showToast({ class: "error", message: response.data.message, showClose: true });
                        }

                    }, function (reject) {
                        IkanoFactory.showAlert("Error", reject.data.message);
                    });
                }

                vm.validateDataStage = function (approve, goNextStage) {
                    vm.goNextStage = goNextStage;
                    if (!approve) {

                        var dataPost = {};
                        dataPost.proceso_id = vm.proceso.id;
                        dataPost.hv_id = vm.selected.id;
                        dataPost.etapa_id = vm.stage.id;
                        dataPost.aprueba = approve;
                        dataPost.data = (!vm.stageData.values) ? {} : vm.stageData.values;

                        analystService.saveStage(dataPost, function (response) {
                            if (response.data.status) {
                                vm.backupValues = response.data.data;
                                vm.editStage = false;
                                vm.approbeStage = false;
                                vm.candidate.etapa = angular.copy(vm.stage);
                                saveChangeStage(vm.stage, response.data.data);
                                vm.showModalStageDiscard();
                            } else {
                                showToast({ class: "error", message: response.data.message, showClose: true });
                            }

                        }, function (reject) {
                            IkanoFactory.showAlert("Error", reject.data.message);
                        });

                    } else {
                        vm.stageData.errors = IkanoFactory.validateFieldsWithObject(vm.stageData.fields, vm.stageData.values, true);
                        if (angular.equals(vm.stageData.errors, {})) {
                            vm.stageData.errors = {};
                            vm.saveStage(vm.stage, vm.stageData.values, approve);

                        } else {
                            IkanoFactory.showAlert("Error", "La información de la etapa esta incompleta, por favor intente de nuevo.");
                        }
                    }
                }

                vm.showModalStageDiscard = function () {
                    var data = {
                        bloques: vm.blockStage.bloques.candidato_descartado,
                        data: {},
                        estructura_campos: vm.serializeField(vm.blockStage.estructura_campos, vm.blockStage.bloques.candidato_descartado),
                        listas: angular.copy(vm.listas)
                    }

                    var parentEl = angular.element(document.body);
                    $mdDialog.show({
                        parent: parentEl,
                        templateUrl: 'app/main/analyst/candidate-detail/dialogs/discardStage.html',
                        controller: 'DiscardStage',
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: {
                            data: data,
                            stage: vm.stageDiscard,
                            idRequest: vm.proceso.id,
                            idCandidate: vm.selected.id,
                            title: 'Descartar candidato',
                            incompletStage: [],
                            candidate: angular.copy(vm.data),
                            config: vm.config
                        }
                    }).then(function (resolve) {
                        if (resolve.data.status) {
                            vm.goNextStage = false;
                            vm.stageSelected = angular.copy(vm.stageDiscard);
                            vm.stage = angular.copy(vm.stageSelected);
                            vm.history = resolve.data.historial.historial;
                            saveChangeStage(vm.stageDiscard, response.data.data);
                            setNewStage(vm.stageDiscard, false, 0);
                            showToast({ class: "success", message: resolve.data.message, showClose: true });
                            updateDataHeader({ selected: resolve.data.cant_seleccionado, finalist: resolve.data.cant_finalista, preSelected: resolve.data.cant_preseleccionado });
                            //updateDataCandidate({historial: resolve.data.historial.historial});
                            updateDataBloques(resolve.data.data, vm.stageDiscard);
                        } else {
                            showToast({ class: "error", message: resolve.data.message, showClose: true });
                        }

                    });
                }

                vm.showModalStageBlock = function (stage, incompletStage) {

                    var data = {
                        bloques: vm.blockStage.bloques[stage.etapa],
                        data: (!vm.blockStage.data[stage.id] ? {} : vm.blockStage.data[stage.id]),
                        estructura_campos: vm.serializeField(vm.blockStage.estructura_campos, vm.blockStage.bloques[stage.etapa]),
                        listas: angular.copy(vm.listas)
                    }
                    if (stage.etapa_tipo_candidato) {
                        var datacandidato = vm.blockStage.data[stage.etapa_tipo_candidato];
                        if (datacandidato && datacandidato.tipo_candidato) {
                            data.data.tipo_candidato = datacandidato.tipo_candidato;
                        }

                    }
                    var parentEl = angular.element(document.body);
                    $mdDialog.show({
                        parent: parentEl,
                        templateUrl: 'app/main/analyst/candidate-detail/dialogs/discardStage.html',
                        controller: 'DiscardStage',
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: {
                            data: data,
                            stage: stage,
                            idRequest: vm.proceso.id,
                            idCandidate: vm.selected.id,
                            title: stage.name_corto,
                            incompletStage: incompletStage,
                            candidate: angular.copy(vm.data),
                            config: vm.config
                        }
                    }).then(function (resolve) {
                        if (resolve.data.status) {
                            vm.goNextStage = false;
                            vm.stageSelected = angular.copy(stage);
                            vm.stage = angular.copy(vm.stageSelected);
                            vm.history = resolve.data.historial.historial;
                            saveChangeStage(stage, resolve.data.data);
                            setNewStage(stage, false, 0);
                            showToast({ class: "success", message: resolve.data.message, showClose: true });
                            updateDataHeader({ selected: resolve.data.cant_seleccionado, finalist: resolve.data.cant_finalista, preSelected: resolve.data.cant_preseleccionado });
                            //updateDataCandidate({historial: resolve.data.historial.historial});
                            updateDataBloques(resolve.data.data, stage);
                        } else {
                            showToast({ class: "error", message: resolve.data.message, showClose: true });
                        }

                    });
                }

                vm.showModalStageConfirm = function (stageIncomplet) {

                    var parentEl = angular.element(document.body);
                    $mdDialog.show({
                        parent: parentEl,
                        templateUrl: 'app/main/analyst/candidate-detail/dialogs/confirmStage.html',
                        controller: 'ConfirmStage',
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: {
                            stageIncomplet: stageIncomplet,
                            stage: vm.stage,
                            idRequest: vm.proceso.id,
                            candidate: vm.candidate
                        }
                    })
                        .then(function (resolve) {
                            vm.goNextStage = false;
                            vm.stageSelected = angular.copy(vm.stage);
                            vm.stage = angular.copy(vm.stageSelected);
                            vm.history = resolve.data.historial.historial;
                            setNewStage(vm.stage, false, 1);
                            updateDataHeader({ selected: resolve.data.cant_seleccionado, finalist: resolve.data.cant_finalista, preSelected: resolve.data.cant_preseleccionado });
                            //updateDataCandidate({historial: resolve.data.historial.historial});
                            updateDataBloques(resolve.data.data, vm.stage);
                        },function(reject){
                            vm.stageSelected = angular.copy(vm.stageSelectedBack);
                        });
                }

                vm.cancelUpdate = function () {
                    vm.editStage = false;
                    vm.modifiStage = false;
                    vm.stageData.data.data = angular.copy(vm.backupValues);
                    vm.stageData.values = angular.copy(vm.backupValues);
                    //vm.setHover('updateStage');
                }

                vm.validateUpdate = function () {

                    vm.stageData.errors = IkanoFactory.validateFieldsWithObject(vm.stageData.fields, vm.stageData.values, true);
                    if (angular.equals(vm.stageData.errors, {})) {
                        // vm.errors = IkanoFactory.validateFieldsWithObject(vm.stageData.fields, vm.stageData.values, true);
                        // if (angular.equals(vm.errors, {})) {
                        vm.errors = {};
                        saveUpdate(vm.stage, vm.stageData.values);
                    } else {
                        IkanoFactory.showAlert("Error", "La información de la etapa esta incompleta, por favor intente de nuevo.");
                    }
                }

                function getOtherProcess() {
                    var dataPost = {
                        proceso_id: vm.proceso.id,
                        hoja_vida_id: vm.selected.id
                    };

                    analystService.getOtherProcess(dataPost, function (response) {
                        if (response.data.status) {
                            vm.data.otros_procesos = response.data.otros_procesos;
                        } else {
                            IkanoFactory.showAlert("Error", response.data.message);
                        }
                    }, function (reject) {
                        IkanoFactory.showAlert("Error", reject.data.message);
                    });
                }

                vm.importStages = function () {
                    var parentEl = angular.element(document.body);
                    $mdDialog.show({
                        parent: parentEl,
                        templateUrl: 'app/main/analyst/candidate-detail/dialogs/importStage.html',
                        controller: 'ImportStage',
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: {
                            idRequest: vm.proceso.id,
                            candidate: angular.copy(vm.data),
                            stages: angular.copy(vm.stages)
                        }
                    }).then(function (resolve) {
                        angular.forEach(resolve, function (v, k) {
                            
                            if (!vm.data.bloques_etapas_candidato.data[k]) {
                                vm.data.bloques_etapas_candidato.data[k] = resolve[k];
                                if(vm.stageData && vm.stageData.extra && vm.stageData.extra.etapa_id == k){
                                    vm.stageData.values = resolve[k];
                                    vm.stageData.data.data = resolve[k];
                                }
                                
                            }else{
                                angular.forEach(resolve[k], function (value, key) { 
                                    vm.data.bloques_etapas_candidato.data[k][key] = resolve[k][key];
                                });
                            }

                        });
                    });
                }

                function saveUpdate(stage, data) {
                    var dataPost = {};
                    dataPost.proceso_id = vm.proceso.id;
                    dataPost.hv_id = vm.selected.id;
                    dataPost.etapa_id = stage.id;
                    dataPost.data = (!data) ? {} : data;
                    analystService.saveStage(dataPost, function (response) {
                        if (response.data.status) {
                            vm.backupValues = response.data.data;
                            vm.stageData.values = response.data.data;
                            vm.stageData.data.data = response.data.data;
                            vm.editStage = false;
                            vm.modifiStage = false;
                            vm.history = response.data.historial.historial;
                            saveChangeStage(vm.stage, response.data.data);
                            showToast({ class: "success", message: response.data.message, showClose: true });
                            vm.setHover('updateStage');
                            updateDataHeader({ selected: response.data.cant_seleccionado, finalist: response.data.cant_finalista, preSelected: response.data.cant_preseleccionado });
                            //updateDataCandidate({historial: response.data.historial.historial});
                            updateDataBloques(response.data.data, stage.id);
                        } else {
                            IkanoFactory.showAlert("Error", response.data.message);
                        }

                    }, function (reject) {
                        IkanoFactory.showAlert("Error", reject.data.message);
                    });
                }

                function saveChangeStage(stage, data) {
                    
                    searchBlockStage(stage);
                    vm.blockStage.data[stage.id] = data;
                    vm.misc.values = {};
                    vm.misc.values.created_at = moment(data.created_at).format('MMM D, YYYY hh:mm a');
                    vm.misc.values.updated_at = moment(data.updated_at).format('MMM D, YYYY hh:mm a');
                    vm.misc.values.analista = angular.copy(data.analista);
                }

                function sendNewStageCandidate(stage) {
                    $rootScope.$broadcast('candidate::changeStage', { stage: stage });
                }

                function updateDataHeader(data) {
                    $rootScope.$broadcast('header::changeData', data);
                }

                function updateDataBloques(data, stage) {
                    $rootScope.$broadcast('candidate::changeValueBlock', { data: data, stage: stage });
                }

                function updateDataCandidate(data){
                    $rootScope.$broadcast('candidate::updateCandidate', data);
                }

                /**
                 * PRESELECCIONAR Y RETIRAR PRESELECCION
                 */

                vm.preseleccionar = function () {
                    var dataPost = {
                        proceso_id: vm.proceso.id,
                        hoja_vida_id: vm.selected.id
                    };

                    analystService.preseleccionar(dataPost, function (response) {
                        switch (response.status) {
                            case analystConstant.CODEPETITION.OK:
                                if (response.data.status) {
                                    for (var i in vm.lists.etapas) {
                                        var stage = vm.lists.etapas[i];
                                        if (stage.id == 2) {
                                            vm.selected.stage = stage;
                                        }
                                    }

                                    showToast({ class: "success", message: response.data.message, showClose: true }, []);
                                    $rootScope.$broadcast('update-hv', { fn: 'preseleccionar', candidate: angular.copy(vm.selected), bloques_etapas_candidato: response.data.bloques_etapas_candidato, bloques_informe_cliente: response.data.bloques_informe_cliente });

                                } else {
                                    showToast({ class: "error", message: response.data.message, showClose: true }, []);
                                }
                                break;
                            case analystConstant.CODEPETITION.NOTFOUND:
                                IkanoFactory.showAlert("Error", response.data.message);
                                break;
                        }
                    }, function (reject) {
                        IkanoFactory.showAlert("Error", reject.data.message);
                    });
                }

                vm.retirarPreseleccionar = function () {
                    var dataPost = {
                        proceso_id: vm.proceso.id,
                        hoja_vida_id: vm.selected.id
                    };
                    analystService.retirarPreseleccionar(dataPost, function (response) {
                        switch (response.status) {
                            case analystConstant.CODEPETITION.OK:
                                if (response.data.status) {
                                    vm.selected.stage = {};
                                    showToast({ class: "success", message: response.data.message, showClose: true }, []);
                                    $rootScope.$broadcast('update-hv', { fn: 'retirarPreseleccionar', candidate: angular.copy(vm.selected) });
                                } else {
                                    showToast({ class: "error", message: response.data.message, showClose: true }, []);
                                }
                                break;
                            case analystConstant.CODEPETITION.NOTFOUND:
                                IkanoFactory.showAlert("Error", response.data.message);
                                break;
                        }
                    }, function (reject) {
                        IkanoFactory.showAlert("Error", reject.data.message);
                    });
                }

                vm.downloadPDF = function () {
                    var data = { id: vm.selected.id, tipo: "hoja_vida" };
                    AdminService.getPDFReport(data, { responseType: 'arraybuffer' }, function (resolve) {
                        IkanoFactory.downloadFile(resolve.data, vm.selected.id + ".pdf");
                    }, function (reject) {
                        var data = {};
                        data.class = "error";
                        data.message = reject.data.message;
                        data.showClose = true;
                        $rootScope.$broadcast('toast::show', { data: data, options: [] });
                    });
                };

                vm.getProfilePictureSrc = function (picture) {
                    return (picture ? CandidateService.getUrlBase() + "/" + picture : "assets/images/avatars/profile.jpg");
                };

                function showToast(data, options) {
                    options = (options) ? options : [];
                    $mdToast.show({
                        hideDelay: 7000,
                        position: 'top right',
                        controller: 'ToastCrl',
                        controllerAs: 'vm',
                        templateUrl: 'app/toast/template/toast.default.html',
                        locals: {
                            options: options,
                            config: data,
                        },
                        toastClass: data.class
                    });
                }

                $scope.$watch('vm.selected', function (newValue, oldValue) {
                    if (newValue && newValue.id) {
                        setHojaVida();
                    }
                    /*if (!oldValue && newValue) {
                        setHojaVida();
                    } else if (newValue && oldValue) {
                        if (!_.isEqual(newValue, oldValue)) {
                            setHojaVida();
                        }
                    }*/
                }, true);
            }

        }
    });
})();
(function () {
    'use strict';

    angular.module('app.seleccion_analyst').constant('analystConstant', {
        "DEBUG": false,
        "LIMITROW": 15,
        "URL": {
            "API": {
                "REQUEST": '/api/ikano/seleccion/get_procesos_analista',
                "CANDIDATE": '/api/ikano/seleccion_get_proceso_analista',
                "SETFAVORITE": '/api/ikano/seleccion/save_hv_como_favorita',
                "SETSPECIAL": '/api/ikano/seleccion/save_hv_como_especial',
                "ADDNOTE": '/api/ikano/seleccion/save_nota_candidato',
                "ADDNOTEREQUEST": "/api/ikano/seleccion/save_observacion_proceso",
                "ADDSCHEDULEDATECANDIDATE": "/api/ikano/seleccion/agendar_cita_candidato",
                "ADDRECOMMENDCANDIDATE": "/api/ikano/seleccion/save_recomendacion_candidato",
                "GETCANDIDATEDETAIL": "/api/ikano/seleccion/get_detalle_hoja_vida",
                "GETCANDIDATEHISTORY": "/api/ikano/seleccion/get_historial_procesos_candidato",
                "GETUNDERSRANDINGCHARGE": "/api/ikano/seleccion/get_entendimiento_cargo",
                "GETSHAREREQUEST": "/api/ikano/seleccion/get_analistas_proceso_compartido",
                "POSTSHAREREQUEST": "/api/ikano/seleccion/save_compartir_proceso_analista",
                "POSTSUSPENSIONREQUEST": "/api/ikano/seleccion/save_suspender_proceso",
                "POSTACTIVARREQUEST": "/api/ikano/seleccion/save_reactivar_proceso",
                "GETCANDIDATEREVISION": "/api/ikano/seleccion/get_candidatos_listos_revision",
                "POSTSENDCANDIDATEAPPLICANT": "/api/ikano/seleccion/enviar_candidatos_listos_revision",
                "SAVEREQUESTANALYST": "/api/ikano/seleccion/save_requisicion_analista",
                "DOWNLOADUNDERSTANDINGPDF": "/api/ikano/seleccion/get_entendimiento_cargo_pdf",
                "DELETENOTE": "/api/ikano/seleccion/eliminar_nota_candidato",
                "DELETEOBSERVACION": "/api/ikano/seleccion/eliminar_observacion_proceso",
                "APPROVEREQUESTANALYST": "/api/ikano/seleccion/enviar_aprobacion_entendimiento_cargo",
                "SENDAPPROVEDUNDERSTANDING": "/api/ikano/seleccion/enviar_entendimiento_cargo",
                "TOPOSTREQUEST": "/api/ikano/seleccion/publicar_oferta",
                "GETPUBLICREQUEST": "/api/ikano/seleccion/get_publicar_oferta",
                "CHANGEDATEENDOFFER": "/api/ikano/seleccion/cambiar_fecha_final_publicacion",
                "SAVEREPORTFORTOCLIENT": "/api/ikano/seleccion/save_candidato_informe_cliente",
                "SAVESTAGE": "/api/ikano/seleccion/save_etapa",
                "SAVESTAGEFINALIST": "/api/ikano/seleccion/save_etapa_solicitante",
                "SEARCHCANDIDATE": "/api/ikano/seleccion/buscar_candidatos",
                "FILTERALLCANDIDATE": "/api/ikano/seleccion/buscar_hv",
                "GETHOJAVIDA": "/api/ikano/seleccion/get_hoja_vida_analista",
                "PRESELECCIONAR": "/api/ikano/seleccion/preseleccionar_candidato",
                "RETIRARPRESELECCIONAR": "/api/ikano/seleccion/retirar_preseleccion_candidato",
                "CLOSEOFFER": "/api/ikano/seleccion/retirar_oferta",
                "SEARCHPROCESS": "/api/ikano/seleccion/search_process",
                "REFERREDCANDIDATE": "/api/ikano/seleccion/refer_candidate",
                "CANDIDATESIMILAR": "/api/ikano/seleccion/get_candidates_in_similar_processes",
                "DOWNLOADSTAGE": "/api/ikano/seleccion/download_pdf_stage",
                "SAVEEVALUATION": "/api/ikano/seleccion/save_evaluation",
                "DOWNLOADTERNA": "/api/ikano/seleccion/descargar_comparacion_terna",
                "GETALLANALYSTS": "/api/ikano/seleccion/get_all_analysts",
                "CREATEANALYST": "/api/ikano/seleccion/create_analyst",
                "UPDATEANALYST": "/api/ikano/seleccion/update_analyst",
                "DELETEANALYST": "/api/ikano/seleccion/delete_analyst",
                "ACTIVATEANALYST": "/api/ikano/seleccion/activate_analyst",
                "INACTIVATEANALYST": "/api/ikano/seleccion/inactivate_analyst",
                "GETTEAMPROCESSES": "/api/ikano/seleccion/get_team_processes",
                "SETANALYSTPROCESS": "/api/ikano/seleccion/set_analyst_to_process",
                "FINISHREQUEST": "/api/ikano/seleccion/finish_process",
                "REOPENREQUEST": "/api/ikano/seleccion/reopen_process",
                "SAVEMARKER": "/api/ikano/seleccion/mark_resume",
                "GETHISTORYREQUEST": "/api/ikano/seleccion/get_process_history",
                "GETREQUESTREPORT": "/api/ikano/seleccion/get_processes_report",
                "GETDATAREQUESTANALYST": "/api/ikano/seleccion/get_requisicion_analista",
                "SAVEDATAREQUESTANALYST": "/api/ikano/seleccion/save_process_analyst",
                "IMPORTCANDIDATEELEMPLEO": "/api/ikano/seleccion/import_candidates_elempleo",
                "IMPORTSTAGES": '/api/ikano/seleccion/importar_etapas_candidatos',
                'GETHOJADEVIDAS': '/api/ikano/seleccion/get_hvs',
                "SETCANDIDATEASVIEW": '/api/ikano/seleccion/set_candidate_as_visto',
                "REMOVEREFERREDCANDIDATE": '/api/ikano/seleccion/remove_candidate_reference',
            },
            "DATA": {
                "REQUEST": "app/main/analyst/data/request.json",
                "CANDIDATE": "app/main/analyst/data/detail_request.json"
            }
        },
        "CODEPETITION": {
            "OK": 200,
            "NOTFOUND": 404,
            "SERVICEUNAVAILABLE": 503
        },
        "OFFERSTATUS": {
            "PUBLICADO": 2
        },
        //BUSCA LA KEY EN LA INFORMACION QUE LLEGA DE LA PETICION Y SE LA ASIGNA A UNA VARIABLE CON EL VALOR
        "KEYJSONREQUESTDEBUG": {
            "cod": "cod",
            "status": "status",
            "name": "name",
            "state": "state",
            "applicant": "applicant",
            "applicant_from": "applicant_from",
            "date_request": "date_request",
            "status_publish": "status_publish",
            "count_vacant": "count_vacant",
            "selected": "selected",
            "candidates": "candidates",
            "pre-selected": "preSelected",
            "unread": "unread",
            "finalist": "finalist",
            "custom_data": "custom_data"
        },
        "KEYJSONREQUEST": {
            "id": "id",
            "codigo": "cod",
            "estado_label": "status",
            "estado_aprobacion_color": "colorStatus",
            "cargo_ocupar": "name",
            "ciudad": "state",
            "solicitante": "applicant",
            "solicitante_id": "applicant_id",
            "correo_solicitante": "applicant_email",
            "empresa_solicitante": "applicant_from",
            "fecha_solicitud": { key: "date_request", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
            "estado_publicacion_color": "color_status_publish",
            "estado_publicacion": "status_publish",
            "fecha_publicacion": { key: "date_publish", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
            "fecha_aprobacion": { key: "date_approve", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
            "fecha_cierre_publicacion": { key: "date_publish_close", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
            "no_vacantes": "count_vacant",
            "seleccionados": "selected",
            "pre_seleccionados": "preSelected",
            "no_leidos": "unread",
            "finalistas": "finalist",
            "total": "candidates",
            "custom_data": "custom_data",
            "notas": { key: "notes", callback: "setModelNote" },
            "candidatos": {
                key: "candidate_info", callback: "setCandidateInfo", dataCallback: {
                    baseJson: {
                        "seleccionados": "selected",
                        "pre_seleccionados": "preSelected",
                        "no_leidos": "unread",
                        "finalistas": "finalist",
                        "total": "candidates",
                    }
                }
            },
            "listas": "lists",
            "cargos": "charges",
            "aprobacion_entendimiento_cargo": "approve_understanding",
            "estado_oferta": "status_offer",
            "estado_proceso": "status_process",
            "estado_requisicion": "status_request",
            "el_empleo_id": "el_empleo_id",
            "fecha_publicacion_elempleo": { key: "date_publish_elempleo", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
            "fecha_creacion": { key: "date_created", callback: "serializeDate", dataCallback: { serializeMoth: true, serializeFormatDate: { format: 'MMM D, YYYY' } } },
            "pais_proceso_name" : "country",
        },
        "KEYJSONCANDIDATE": {
            "DEBUG": {
                "age": "age",
                "business": "business",
                "charges": "charges",
                "cita": "cita",
                "duration_in_charge": "duration_in_charge",
                "duration_per_company": "duration_per_company",
                "experience": { key: "experience", callback: "duration" },
                "id": "id",
                "image": "image",
                "last_update": { key: "last_update", callback: "duration" },
                "name": "name",
                "note": "note",
                "profession": "profession",
                "text": "text"
            },
            "PRODUTION": {
                "id": "id",
                "edad": "age",
                "empresas_registradas": { key: "business", callback: "countArray" },
                "cargos_registrados": { key: "charges", callback: "countArray" },
                "cita": "cita",
                "duracion_por_cargo": "duration_in_charge",
                "duracion_por_empresa": "duration_per_company",
                "anios_experiencia": { key: "experience", callback: "getOneKey", dataCallback: { getKey: 'anios_experiencia' } },
                "foto": "image",
                "modified": { key: "last_update", callback: "formateDate" },
                "updated_at": { key: "updated_at", callback: "formateDate" },
                "nombre": "name",
                "profesion": { key: "profession", callback: "getOneKey", dataCallback: { getKey: 'name' } },
                "estudio_mas_avanzado": { key: "advanced_study", callback: "getOneKey", dataCallback: { getKey: 'profesion_name_rep' } },
                "cantidad_otras_profesiones": "count_other_profession",
                "cantidad_otros_estudios": "count_other_study",
                "procesos_totales": "all_process",
                "procesos_totales_ultimos_6_meses": "process_before",
                "notas": { key: "notes", callback: "setModelNote" },
                "favorita": "favorite",
                "correo": "email",
                "correo_alternativo": "email_alternative",
                "maxima_etapa_alcanzada": "max_stage",
                "etapa": "stage",
                "citas": { key: "cita", callback: "setCita" },
                "candidato_visto": "view",
                "especial": "special",
                "recomendada": "recommended",
                "recomendaciones": "recomendaciones",
                "telefono": "phone",
                "celular": "cell_phone",
                "referido": "referred",
                "referido_por": "referredBy",
                "tipo_especial_id": "marker",
                "cedula": "key",
                "salario": "salary",
                "ciudad": "city"
            }
        },
        "KEYJSONNOTE": {
            "id": "id",
            "analista": { key: "name", callback: "getOneKey", dataCallback: { getKey: 'name' } },
            "fecha": { key: "date_create_note", callback: "setFormatDate", dataCallback: { format: 'MMM D, YYYY hh:mm a' } },
            "nota": "note",
            "descripcion": "note",
            "image": "image",
            "visibilidad": "visibility",
            "propietario": "owner"
        },

        "PAGESINFO": {
            "DASHBOARD": {
                icon: "icon-home",
                parents: ['PROCESOS DE SELECCIÓN', 'TODOS LOS PROCESOS'],
                title: "PROCESOS DE SELECCIÓN",
            },
            "DETAIL": {
                icon: "icon-home",
                parents: ['PROCESOS DE SELECCIÓN', 'TODOS LOS PROCESOS'],
            },
            "DETAILCANDIDATE": {
                icon: "icon-home",
                parents: ['PROCESOS DE SELECCIÓN', 'CANDIDATO'],
            },
            "UNDERSTANDINGPOSITION": {
                icon: "icon-home",
                parents: ['PROCESOS DE SELECCIÓN', 'ENTENDIMIENTO DEL CARGO'],
            },
            "SHAREREQUEST": {
                icon: "icon-home",
                parents: ['PROCESOS DE SELECCIÓN', 'COMPARTIR PROCESO'],
            },
            "SENDCANDIDATE": {
                icon: "icon-home",
                parents: ['PROCESOS DE SELECCIÓN', 'ENVIAR CANDIDATOS AL SOLICITANTE'],
            },
            "PUBLISHREQUEST": {
                icon: "icon-home",
                parents: ['PROCESOS DE SELECCIÓN', 'PUBLICAR PROCESO DE SELECCIÓN'],
            },
            "HISTORYREQUEST": {
                icon: "icon-home",
                parents: ['PROCESOS DE SELECCIÓN', 'HISTORIAL PROCESO DE SELECCIÓN'],
            },
            "NEWREQUEST": {
                icon: "icon-home",
                parents: ['PROCESOS DE SELECCIÓN', 'CREAR NUEVO PROCESO'],
                title: "NUEVO PROCESO",
            },
            "UPDATEREQUEST": {
                icon: "icon-home",
                parents: ['PROCESOS DE SELECCIÓN', 'ACTUALIZAR PROCESO DE SELECCIÓN'],
                title: "ACTUALIZAR PROCESO DE SELECCION",
            },
        },
        "DEFAULT": {
            "DATA": {
                "DASHBOARD": {
                    "SELECTED": {
                        "APPLICANT": -1,
                        "STATUSREQUEST": -1,
                        "REGIONALREQUEST": -1,
                        "ANALYSTREQUEST": -1,
                    },
                    "FILTER": {
                        "APPLICANT": [{
                            id: -1,
                            name: "Todos los solicitantes"
                        }],
                        "STATUSREQUEST": [{
                            id: -1,
                            name: "Todos los estados"
                        }]
                    },
                    "LIMITREQUEST": 15,
                    "TEXT_DATE_REQUEST": "Hace %months% meses y %days% días"
                },
                "DETAIL": {
                    "TEXT_DATE_REQUEST": "Hace %months% meses y %days% días"
                },
                "HEADER": {
                    "DETAILREQUEST": [
                        {
                            key: "candidate",
                            name: "Candidatos",
                            url: "app.detail_seleccion_analyst.index",
                        },
                        {
                            key: "share",
                            name: "Compartir proceso",
                            url: "app.share_request",
                        },
                        {
                            key: "understanding",
                            name: "Entendimiento del cargo",
                            url: "app.entendimiento_cargo.index",
                        },
                        {
                            key: "sendcandidate",
                            name: "Enviar candidatos al solicitante",
                            url: "app.send_candidate_applicant",
                        },
                        {
                            key: "suspension",
                            name: "Suspensión y activación del proceso",
                            url: "app.suspension_request",
                        },
                        {
                            key: "publish",
                            name: "Publicación del proceso de selección",
                            url: "app.publish_request",
                        },
                        {
                            key: "history",
                            name: "Historial del proceso de selección",
                            url: "app.seleccion-history-request",
                        }
                    ],
                    "KEYSDETAILREQUEST": {
                        "UNDERSTANDING": "understanding",
                        "CANDIDATE": "candidate",
                        "SHARE": "share",
                        "SENDCANDIDATE": "sendcandidate",
                        "SUSPENSION": "suspension",
                        "PUBLISH": "publish",
                        "HISTORY": "history"
                    },
                    "DETAILREQUESTADMIN": [
                        {
                            key: "candidate",
                            name: "Candidatos",
                            url: "app.seleccion_proceso_admin",
                        },
                        {
                            key: "understanding",
                            name: "Entendimiento del cargo",
                            url: "app.understanding_charge_admin",
                        },

                        {
                            key: "suspension",
                            name: "Suspensión y activación del proceso",
                            url: "app.suspension_request_admin",
                        },

                        {
                            key: "history",
                            name: "Historial del proceso de selección",
                            url: "app.seleccion_history_request_admin",
                        },
                        {
                            key: "update_request",
                            name: 'Actualizar información del proceso',
                            function: 'showUpdateRequest'
                        }
                    ],
                    "KEYSDETAILREQUESTADMIN": {
                        "UNDERSTANDING": "understanding",
                        "CANDIDATE": "candidate",
                        "SHARE": "share",
                        "SENDCANDIDATE": "sendcandidate",
                        "SUSPENSION": "suspension",
                        "PUBLISH": "publish",
                        "HISTORY": "history"
                    }
                }
            }
        },
        "REPORTS": {
            "HEADER": {
                "REPORTS": [
                    {
                        key: "request",
                        name: "Proceso",
                        url: "app.seleccion_reporte_procesos_admin.index",
                    }
                ],
                "KEYSREPORTS": {
                    "REQUEST": "request",
                }
            }
        },

        "STATUSPROCESS": {
            PROCESO_ENAPROBACION: 'ENAPROBACION',
            PROCESO_APROBADO: 'APROBADO',
            PROCESO_NOAPROBADO: 'NOAPROBADO',
            PROCESO_FINALIZADO: 'FINALIZADO',
            PROCESO_SUSPENDIDO: 'SUSPENDIDO',
            PROCESO_ELIMINADO: 'ELIMINADO',
            PROCESO_INACTIVO: 'INACTIVO'
        }



    });

})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_admin')
        .service('AdminService', AdminService);

    /** @ngInject */
    function AdminService($http, api, $mdDialog, $state, IkanoFactory, AuthService) {

        var getRequests = function (data, config, success, error) {
            api.requester.getRequests(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getRequestsByApprover = function (data, config, success, error) {
            api.requester.getRequestsByApprover(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getRequestsByAdmin = function (data, config, success, error) {
            api.requester.getRequestsByAdmin(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getRequest = function (data, config, success, error) {
            api.requester.getRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getRequestApprover = function (data, config, success, error) {
            api.requester.getRequestApprover(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getRequestAdmin = function (data, config, success, error) {
            api.requester.getRequestAdmin(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var saveRequest = function (data, config, success, error) {
            api.requester.saveRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var saveRequestAdmin = function (data, config, success, error) {
            api.requester.saveRequestAdmin(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var saveRequestApprover = function (data, config, success, error) {
            api.requester.saveRequestApprover(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var sendRequest = function (data, config, success, error) {
            api.requester.sendRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var cloneRequest = function (data, config, success, error) {
            api.requester.cloneRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var cancelRequest = function (data, config, success, error) {
            api.requester.cancelRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var divideRequest = function (data, config, success, error) {
            api.requester.divideRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var approveRequest = function (data, config, success, error) {
            api.requester.approveRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var undoApproveRequest = function (data, config, success, error) {
            api.requester.undoApproveRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var saveObservationsRequest = function (data, config, success, error) {
            api.requester.saveObservationsRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var deleteObservationsRequest = function (data, config, success, error) {
            api.requester.deleteObservationsRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var dismissRequest = function (data, config, success, error) {
            api.requester.dismissRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var undoDismissRequest = function (data, config, success, error) {
            api.requester.undoDismissRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var giveBackRequest = function (data, config, success, error) {
            api.requester.giveBackRequest(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        //Requester
        var getDraftRequests = function (data, config, success, error) {
            api.requester.getDraftRequests(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getInProcessRequests = function (data, config, success, error) {
            api.requester.getInProcessRequests(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getApproveRequests = function (data, config, success, error) {
            api.requester.getApproveRequests(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getNoApproveRequests = function (data, config, success, error) {
            api.requester.getNoApproveRequests(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getAllRequests = function (data, config, success, error) {
            api.requester.getAllRequests(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        //Approver
        var getForApproveRequestsApprover = function (data, config, success, error) {
            api.requester.getForApproveRequestsApprover(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getInProcessRequestsApprover = function (data, config, success, error) {
            api.requester.getInProcessRequestsApprover(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        //Admin
        var getInProcessRequestsByAdmin = function (data, config, success, error) {
            api.requester.getInProcessRequestsByAdmin(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getApprovedRequestsByAdmin = function (data, config, success, error) {
            api.requester.getApprovedRequestsByAdmin(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getDismissRequestsByAdmin = function (data, config, success, error) {
            api.requester.getDismissRequestsByAdmin(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getAllRequestsByAdmin = function (data, config, success, error) {
            api.requester.getAllRequestsByAdmin(data, config,
                function (response) {
                    success(response);
                    getNot();
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getPositionColaborators = function (data, config, success, error) {
            api.requester.getPositionColaborators(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        //Notifications
        var getNotifications = function (data, config, success, error) {
            api.requester.getNotifications(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getNot = function () {
            getNotifications({}, {},
                function (response) {
                    if (response.data.notifications.seleccion) {
                        var notifications = response.data.notifications.seleccion;
                        var menu = AuthService.getMenu();
                        for (var index = 0; index < menu.length; index++) {
                            var element = menu[index];
                            for (var j = 0; j < element.childrens.length; j++) {
                                menu[index].childrens[j].badge = 0;
                                var elm = element.childrens[j];
                                if (notifications[elm.name]) {
                                    menu[index].childrens[j].badge = notifications[elm.name];
                                }
                            }
                        }

                        AuthService.setMenuAdmin(menu);
                    }
                },
                function (response) {

                }
            );
        }

        var getSystemSettings = function (data, config, success, error) {
            api.admin.getSystemSettings(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var saveSystemSettings = function (data, config, success, error) {
            api.admin.saveSystemSettings(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getOutbox = function (data, config, success, error) {
            api.admin.getOutbox(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getOutboxPaginate = function (data, config, page, filter, success, error) {
            api.admin.getOutboxPaginate(data, config, page, filter,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };


        var getMailTemplates = function (data, config, success, error) {
            api.admin.getMailTemplates(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var updateMailTemplate = function (data, config, success, error) {
            api.admin.updateMailTemplate(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getVarMailTemplate = function (data, config, success, error) {
            api.admin.getVarMailTemplate(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var probarTemplate = function (data, config, success, error) {
            api.admin.probarTemplate(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getApprovers = function (data, config, success, error) {
            api.admin.getApprovers(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var addApprover = function (data, config, success, error) {
            api.admin.addApprover(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var enableApprover = function (data, config, success, error) {
            api.admin.enableApprover(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var disableApprover = function (data, config, success, error) {
            api.admin.disableApprover(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var updateRequestType = function (data, config, success, error) {
            api.requester.updateRequestType(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var addSubstitute = function (data, config, success, error) {
            api.admin.addSubstitute(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var removeSubstitute = function (data, config, success, error) {
            api.admin.removeSubstitute(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var addAssistant = function (data, config, success, error) {
            api.admin.addAssistant(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var removeAssistant = function (data, config, success, error) {
            api.admin.removeAssistant(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getRequestsReportByYear = function (data, config, success, error) {
            api.requester.getRequestsReportByYear(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getServicePerformanceReport = function (data, config, success, error) {
            api.requester.getServicePerformanceReport(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var downloadReport = function (data, config, success, error) {
            api.admin.downloadReport(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var downloadFileCollaborator = function (data, config, success, error) {
            api.admin.downloadFileCollaborator(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getPDFReport = function (data, config, success, error) {
            api.requester.getPDFReport(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getUnderstandingPosition = function (data, success, error) {
            api.requester.getUnderstandingPosition(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getServiceReportAdmin = function (data, config, success, error) {
            api.requester.getServiceReportAdmin(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var sendApproveUnderstanding = function (data, success, error) {
            api.requester.sendApproveUnderstanding(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getServiceReportLevelService = function (data, config, success, error, configload, extra) {
            api.requester.getServiceReportLevelService(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                },
                configload,
                extra
            );
        };

        var getServiceLists = function (data, config, success, error) {
            api.requester.getServiceLists(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var downloadReport = function (data, config, success, error) {
            api.admin.downloadReport(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getTerna = function (data, success, error) {
            api.requester.getTerna(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var getDasboardFinalistCandidate = function (data, success, error) {
            api.requester.getDasboardFinalistCandidate(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        };

        var sendEmailsRequest = function (data, success, error) {
            api.requester.sendEmailsRequest(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }
            );
        }

        var getCollaborators = function (data, success, error, load) {
            api.admin.getCollaborators(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var getCollaborator = function (data, success, error, load) {
            api.admin.getCollaborator(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var getHojasVida = function (data, success, error, load) {
            api.admin.getHojasVida(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var saveCenso = function (data, success, error, load) {
            api.admin.saveCenso(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var removeCollaborator = function (data, success, error, load) {
            api.admin.removeCollaborator(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var addCollaborator = function (data, success, error, load) {
            api.admin.addCollaborator(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var searchCandidate = function (data, success, error, load) {
            api.admin.searchCandidate(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var requestAdmin = function (data, success, error, load) {
            api.admin.requestAdmin(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var getRequestAdminSeleccion = function (data, success, error, load) {
            api.admin.getRequestAdminSeleccion(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }
        var searchCandidateSeleccion = function (data, success, error, load) {
            api.admin.searchCandidateSeleccion(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var getUnderstandingCharge = function (data, success, error, load) {
            api.admin.getUnderstandingCharge(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var downloadUnderstandingPdf = function (data, config, success, error, load) {
            api.admin.downloadUnderstandingPdf(data, config,
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var activarRequest = function (data, success, error, load) {
            api.admin.activarRequest(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }



        var get_onchange_data = function (data, success, error, load) {
            api.admin.get_onchange_data(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var get_team_processes_admin = function (data, success, error, load) {
            api.admin.get_team_processes_admin(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var filterAllCandidateHv = function (data, success, error, load) {
            api.admin.filterAllCandidateHv(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var setAnalystProcess = function (data, success, error, load) {
            api.admin.setAnalystProcess(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var restablecer_colaborador_enviado = function (data, success, error, load) {
            api.admin.restablecer_colaborador_enviado(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var get_sociedades_paises = function (data, success, error, load) {
            api.admin.get_sociedades_paises(data, {}, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }

        var save_sociedades_paises = function (data, success, error, load) {
            api.admin.save_sociedades_paises(data, {}, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }

        var delete_process = function (data, success, error, load) {
            api.admin.delete_process(data, {}, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }

        var activate_process = function (data, success, error, load) {
            api.admin.activate_process(data, {}, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }

        var uploadCharge = function (data,config, success, error, load) {
            api.admin.uploadCharge(data, config, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }

        var uploadStructures = function (data,config, success, error, load) {
            api.admin.uploadStructures(data, config, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }

        var get_base_cargos = function (data,config, success, error, load) {
            api.admin.get_base_cargos(data, config, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }


        var setMailTemplate = function (data) {
            localStorage.setItem('MAIL_TEMPLATE_SELECTION', JSON.stringify(data));
        };

        var getMailTemplate = function () {
            return JSON.parse(localStorage.getItem('MAIL_TEMPLATE_SELECTION'));
        };

        var removeMailTemplate = function () {
            localStorage.removeItem('MAIL_TEMPLATE_SELECTION');
        };

        var getLists = function (data, success, error, load) {
            api.admin.getLists(data, {},
                function (response) {
                    success(response);
                },
                function (response) {
                    error(response);
                }, load
            );
        }

        var get_tiempos_objetivos = function (data, success, error, load) {
            api.admin.get_tiempos_objetivos(data, {}, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }

        var update_tiempo_objetivo = function (data, success, error, load) {
            api.admin.update_tiempo_objetivo(data, {}, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }

        var get_info_rol_aprobadores = function (data, success, error, load) {
            api.admin.get_info_rol_aprobadores(data, {}, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }

        var update_rol_aprobadores = function (data, success, error, load) {
            api.admin.update_rol_aprobadores(data, {}, function (response) {
                success(response);
            }, function (response) {
                error(response);
            }, load)
        }

        return {
            getRequests: getRequests,
            getRequestsByAdmin: getRequestsByAdmin,
            getRequestsByApprover: getRequestsByApprover,
            getRequest: getRequest,
            getRequestApprover: getRequestApprover,
            getRequestAdmin: getRequestAdmin,
            saveRequest: saveRequest,
            saveRequestAdmin: saveRequestAdmin,
            saveRequestApprover: saveRequestApprover,
            sendRequest: sendRequest,
            cloneRequest: cloneRequest,
            cancelRequest: cancelRequest,
            divideRequest: divideRequest,
            approveRequest: approveRequest,
            undoApproveRequest: undoApproveRequest,
            saveObservationsRequest: saveObservationsRequest,
            deleteObservationsRequest: deleteObservationsRequest,
            dismissRequest: dismissRequest,
            undoDismissRequest: undoDismissRequest,
            giveBackRequest: giveBackRequest,
            getNotifications: getNotifications,
            getPDFReport: getPDFReport,
            //Requester
            getDraftRequests: getDraftRequests,
            getInProcessRequests: getInProcessRequests,
            getApproveRequests: getApproveRequests,
            getNoApproveRequests: getNoApproveRequests,
            getAllRequests: getAllRequests,
            getPositionColaborators: getPositionColaborators,
            updateRequestType: updateRequestType,
            getUnderstandingPosition: getUnderstandingPosition,
            sendApproveUnderstanding: sendApproveUnderstanding,
            getTerna: getTerna,
            getDasboardFinalistCandidate: getDasboardFinalistCandidate,
            sendEmailsRequest: sendEmailsRequest,
            //Approver
            getForApproveRequestsApprover: getForApproveRequestsApprover,
            getInProcessRequestsApprover: getInProcessRequestsApprover,
            //Admin
            getInProcessRequestsByAdmin: getInProcessRequestsByAdmin,
            getApprovedRequestsByAdmin: getApprovedRequestsByAdmin,
            getDismissRequestsByAdmin: getDismissRequestsByAdmin,
            getAllRequestsByAdmin: getAllRequestsByAdmin,
            getSystemSettings: getSystemSettings,
            saveSystemSettings: saveSystemSettings,
            getOutbox: getOutbox,
            getOutboxPaginate: getOutboxPaginate,
            getMailTemplates: getMailTemplates,
            updateMailTemplate: updateMailTemplate,
            getVarMailTemplate: getVarMailTemplate,
            probarTemplate: probarTemplate,
            setMailTemplate: setMailTemplate,
            getMailTemplate: getMailTemplate,
            removeMailTemplate: removeMailTemplate,
            getApprovers: getApprovers,
            addApprover: addApprover,
            enableApprover: enableApprover,
            disableApprover: disableApprover,
            addSubstitute: addSubstitute,
            removeSubstitute: removeSubstitute,
            addAssistant: addAssistant,
            removeAssistant: removeAssistant,
            downloadReport: downloadReport,
            getRequestsReportByYear: getRequestsReportByYear,
            getServicePerformanceReport: getServicePerformanceReport,
            getCollaborators: getCollaborators,
            getCollaborator: getCollaborator,
            getHojasVida: getHojasVida,
            saveCenso: saveCenso,
            addCollaborator: addCollaborator,
            removeCollaborator: removeCollaborator,
            searchCandidate: searchCandidate,
            downloadFileCollaborator: downloadFileCollaborator,
            get_onchange_data: get_onchange_data,
            get_sociedades_paises: get_sociedades_paises,
            save_sociedades_paises: save_sociedades_paises,
            uploadCharge: uploadCharge,
            uploadStructures: uploadStructures,
            get_base_cargos: get_base_cargos,
            //LISTS
            getLists: getLists,
            getServiceReportAdmin: getServiceReportAdmin,
            getServiceReportLevelService: getServiceReportLevelService,
            getServiceLists: getServiceLists,
            //SELECCION
            requestAdmin: requestAdmin,
            getRequestAdminSeleccion: getRequestAdminSeleccion,
            searchCandidateSeleccion: searchCandidateSeleccion,
            getUnderstandingCharge: getUnderstandingCharge,
            downloadUnderstandingPdf: downloadUnderstandingPdf,
            activarRequest: activarRequest,
            get_team_processes_admin: get_team_processes_admin,
            filterAllCandidateHv: filterAllCandidateHv,
            setAnalystProcess: setAnalystProcess,
            restablecer_colaborador_enviado: restablecer_colaborador_enviado,
            delete_process: delete_process,
            activate_process: activate_process,
            //TIEMPOS APROBACION
            get_tiempos_objetivos: get_tiempos_objetivos,
            update_tiempo_objetivo: update_tiempo_objetivo,
            get_info_rol_aprobadores: get_info_rol_aprobadores,
            update_rol_aprobadores: update_rol_aprobadores
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $mdDialog, $document, $translate, $mdToast, $location, msNavigationService, CandidateService, AuthService, IkanoFactory, AdminService, api)
    {
        var vm = this;
        vm.theme = IkanoFactory.getThemeData();
        vm.user = AuthService.getUserData();
        vm.helpCode = AuthService.getHelpCode();
        vm.urlBase = CandidateService.getUrlBase();

        vm.urlHelp = api.general.urlHelp + vm.helpCode + vm.user.group_id;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.openChangePasswordDialog = openChangePasswordDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.goToHelp = goToHelp;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        function openChangePasswordDialog(ev) {
			$mdDialog.show({
				controller: 'ChangePasswordController',
				controllerAs: 'vm',
				templateUrl: 'app/main/templates/header/dialogs/change-password.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {
					event: ev,
				}
			});	
		};

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            api.authentication.logout({},{},
            function(resolve){
                AuthService.logout();
            },function(error){
                IkanoFactory.showAlert("Error", "Ha ocurrido un error cerrando la sesión, por favor intente luego.");
            })
            
        }

        function goToHelp() {
            $location.url(api.general.urlHelp + vm.helpCode + vm.user.group_id, '_blank');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app.toast', ['ngMaterial','ngAnimate']);
})();
(function () {
    'use strict';

    /**
    * Main module of the Fuse
    */
    angular
        .module('app.toast').controller('ToastCrl', toasCtrl);

    function toasCtrl($mdToast, $mdDialog, options, config) {
        //Constructor
        var vm = this;

        //Config
        vm.config = config;

        //Options
        vm.options = options;

        switch (vm.config.class) {
            case "success":
                vm.config.icon = "fa fa-check";
                break;
            case "error":
                vm.config.icon = "fa fa-times";
                break;
            case "info":
                vm.config.icon = "fa fa-info";
                break;
            case "warning":
                vm.config.icon = "fa fa-exclamation";
                break;
        }

        //Close
        vm.closeToast = function () {
            $mdToast
                .hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, IkanoFactory, AuthService, CandidateService)
    {
        var vm = this;

        vm.theme = IkanoFactory.getThemeData();
        vm.user = AuthService.getUserData();
        vm.urlBase = CandidateService.getUrlBase();

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .service('ValidationService', ValidationService);

    /** @ngInject */
    function ValidationService($state, AdminService, IkanoFactory, ValidationFactory) {

        /** Validaciones de los formularios */

        function validateForm(block, $scope, field) {



            var domain = localStorage.getItem('DOMAIN_SELECTION');
            if (domain == "tecnoquimicas") {
                if (block == "salud") {
                    tqSaludBlockForm($scope, field);
                } else if (block == "vivienda") {
                    tqViviendaBlockForm($scope, field);
                } else if (block == "adicional") {
                    tqAdicionalBlockForm($scope, field);
                } else if (block == "viven_usted") {
                    tqVivenUstedBlockForm($scope, field);
                } else if (block == "conyuge") {
                    tqConyugeBlockForm($scope, field);
                } else if (block == "padre" || block == "madre") {
                    tqPadresBlockForm($scope, field);
                } else if (block == "grupo_familiar") {
                    tqGrupoFamiliarBlockForm($scope, field);
                } else if (block == "estudios_formales") {
                    tqEstudiosFormalesBlockForm($scope, field);
                } else if (block == "estudios_no_formales") {
                    tqEstudiosNoFormalesBlockForm($scope, field);
                } else if (block == "experiencia") {
                    tqExperienciaBlockForm($scope, field);
                } else if (block == "personales") {
                    tqPersonalesBlockForm($scope, field);
                } else if (block == "hijos") {
                    tqHijosBlockForm($scope, field);
                } else if (block == "requisicion" || block == "proceso") {
                    tqRequisicionBlockForm($scope, field);
                } else if (block == "informacion_seleccion") {
                    tqInformacionSeleccion($scope, field);
                } else if (block == "etapas_candidatos") {
                    tqEtapasCandidatos($scope, field);
                }

            } else if (domain == "colombina") {
                if (block == "requisicion" || block == "proceso") {
                    colombinaRequisicionBlockForm($scope, field);
                }
            }
            if (field.showif) {

                if (field.showif.field && !field.showif.field_extra) {
                    validateShowIf($scope, field);
                } else if (field.showif.data) {
                    validateShowIfData($scope, field);
                } else if (field.showif.field && field.showif.field_extra) {
                    validateShowIfExtra($scope, field);
                }

            }
        }

        function tqSaludBlockForm($scope, field) {
            //tiene_pos, pos_cual
            $scope.$watch("options.ngModel['tiene_pos']", function (newVal, oldVal) {
                var val = $scope.options.ngModel["tiene_pos"] * 1;

                if (val) {
                    showElement('pos_cual');
                } else {
                    hideElement($scope, 'pos_cual');
                }
            });
        }

        function tqViviendaBlockForm($scope, field) {
            if (field.field == "tipo") {
                $scope.$watch("options.ngModel['tipo']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["tipo"] * 1;

                    if (val == 3) {
                        showElement('tipo_otro');
                    } else {
                        hideElement($scope, 'tipo_otro');
                    }
                });
            } else if (field.field == "subsidio_vivienda") {
                $scope.$watch("options.ngModel['subsidio_vivienda']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["subsidio_vivienda"] * 1;

                    if (val) {
                        showElement('entidad_subsidio');
                    } else {
                        hideElement($scope, 'entidad_subsidio');
                    }
                });
            }
        }

        function tqAdicionalBlockForm($scope, field) {
            if (field.field == "tenido_personal_cargo") {
                $scope.$watch("options.ngModel['tenido_personal_cargo']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["tenido_personal_cargo"] * 1;

                    if (val) {
                        showElement('tipo_cargos_su_personal');
                    } else {
                        hideElement($scope, 'tipo_cargos_su_personal');
                    }
                });
            } else if (field.field == "liderado_proyectos_organizacion") {
                $scope.$watch("options.ngModel['liderado_proyectos_organizacion']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["liderado_proyectos_organizacion"] * 1;

                    if (val) {
                        showElement('proyectos_liderados');
                    } else {
                        hideElement($scope, 'proyectos_liderados');
                    }
                });
            }
        }

        function tqVivenUstedBlockForm($scope, field) {
            if (field.field == "parentesco") {
                $scope.$watch("options.ngModel['parentesco']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["parentesco"] * 1;

                    if (val == 9) {
                        showElement('parentesco_otro');
                    } else {
                        hideElement($scope, 'parentesco_otro');
                    }
                });
            }
        }

        function tqConyugeBlockForm($scope, field) {
            if (field.field == "ocupacion") {
                $scope.$watch("options.ngModel['ocupacion']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["ocupacion"] * 1;

                    if (val == 2 || val == 3) {
                        showElement('empresa');
                        //hideElement($scope, 'actividad_economica');
                    } else if (val == 6 || val == 7) {
                        //showElement('actividad_economica');
                        hideElement($scope, 'empresa');
                    } else {
                        //hideElement($scope, 'actividad_economica');
                        hideElement($scope, 'empresa');
                    }
                });
            }
        }

        function tqPadresBlockForm($scope, field) {
            var mom = [
                'madre_tipo_documento',
                'madre_documento',
                'madre_ciudad_expedicion_id',
                'madre_fecha_nacimiento',
                'madre_ciudad_nacimiento_id',
                'madre_genero',
                'madre_nivel_estudio',
                'madre_estado_estudio',
                'madre_ocupacion',
                'madre_telefono_fijo',
                'madre_telefono_movil',
                'madre_correo',
                'madre_depende_usted',
                'madre_vive_usted',
                'madre_tiene_discapacidad'
            ];
            var dad = [
                'padre_tipo_documento', //REQ
                'padre_documento', //REQ
                'padre_ciudad_expedicion_id',
                'padre_fecha_nacimiento',  //REQ
                'padre_ciudad_nacimiento_id',  //REQ
                'padre_genero', //REQ
                'padre_nivel_estudio', //REQ
                'padre_estado_estudio',
                'padre_ocupacion', //REQ
                'padre_telefono_fijo',
                'padre_telefono_movil',
                'padre_correo',
                'padre_depende_usted', //RQE
                'padre_vive_usted', //RQE
                'padre_tiene_discapacidad' //RQE
            ];

            var arrReqDad = [
                'padre_tipo_documento', //REQ
                'padre_documento', //REQ
                'padre_fecha_nacimiento',  //REQ
                'padre_ciudad_nacimiento_id',  //REQ
                'padre_genero', //REQ
                'padre_nivel_estudio', //REQ
                'padre_ocupacion', //REQ
                'padre_depende_usted', //RQE
                'padre_vive_usted', //RQE
                'padre_tiene_discapacidad' //RQE
            ]

            var arrReqMom = [
                'madre_tipo_documento', //REQ
                'madre_documento', //REQ
                'madre_fecha_nacimiento',  //REQ
                'madre_ciudad_nacimiento_id',  //REQ
                'madre_genero', //REQ
                'madre_nivel_estudio', //REQ
                'madre_ocupacion', //REQ
                'madre_depende_usted', //RQE
                'madre_vive_usted', //RQE
                'madre_tiene_discapacidad' //RQE
            ];


            /*if (field.field == "padre_vive") {
                $scope.$watch("options.ngModel['padre_vive']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["padre_vive"] * 1;
                    if (val) {
                        validationsElements(arrReqDad);
                        showElements(dad);
                    } else {
                        validationsElementsNot(arrReqDad);
                        hideElements($scope, dad);
                    }
                    $scope.options.ngModel["padre_genero"] = 1;
                });
            } else if (field.field == "madre_tipo_documento") {
                $scope.$watch("options.ngModel['madre_vive']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["madre_vive"] * 1;

                    if (val) {
                        validationsElements(arrReqMom);
                        showElements(mom);
                    } else {
                        validationsElementsNot(arrReqMom);
                        hideElements($scope, mom);
                    }

                    $scope.options.ngModel["madre_genero"] = 2;
                });
            }*/
        }

        function tqGrupoFamiliarBlockForm($scope, field) {
            if (field.field == "tiene_hijos") {
                $scope.$watch("options.ngModel['tiene_hijos']", function (newVal, oldVal) {
                    /*var val = $scope.options.ngModel["tiene_hijos"] * 1;

                    if (val) {
                        showElement('cantidad_hijos');

                    } else {
                        hideElement($scope, 'cantidad_hijos');
                    }*/
                });
            }
        }

        function tqEstudiosFormalesBlockForm($scope, field) {
            var filedReq = [
                'semestre_inicio',
                'semestre_egreso',
                'semestre_grado',
                'tiene_tarjeta_profesional',
                'anio',
                'anio_grado'
            ];

            if (field.field == "tiene_tarjeta_profesional") {
                $scope.$watch("options.ngModel['tiene_tarjeta_profesional']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["tiene_tarjeta_profesional"] * 1;
                    var tarjetaReq = [
                        'numero_tarjeta_profesional',
                        'fecha_expedicion_tarjeta_profesional',
                    ];
                    if (val == 1) {
                        showElement('numero_tarjeta_profesional');
                        showElement('fecha_expedicion_tarjeta_profesional');
                        showElement('adjuntos_tarjetaprofesional');
                        validationsElements(tarjetaReq);
                    } else if (val == 2) {
                        showElement('numero_tarjeta_profesional');
                        showElement('fecha_expedicion_tarjeta_profesional');
                        showElement('adjuntos_tarjetaprofesional');
                        validationsElements(tarjetaReq);
                    } else {
                        hideElement($scope, 'numero_tarjeta_profesional');
                        hideElement($scope, 'fecha_expedicion_tarjeta_profesional');
                        hideElement($scope, 'adjuntos_tarjetaprofesional');
                        validationsElementsNot(tarjetaReq);
                    }
                });
            }

            if (field.field == "estado_estudio") {
                $scope.$watch("options.ngModel['estado_estudio']", function (newVal, oldVal) {
                    var nivels_educativo_id = $scope.options.ngModel["nivels_educativo_id"] * 1;
                    var estado_estudio = $scope.options.ngModel["estado_estudio"] * 1;
                    var result = ValidationFactory.estudioFormales.getFieldsConditionNivelEducativo(nivels_educativo_id, estado_estudio);
                    hideElements($scope, result.hide);
                    showElements(result.show);
                    var arrValidation = result.show.filter(function (element) {
                        return filedReq.indexOf(element) >= 0
                    });
                    var arrValidationNot = result.hide.filter(function (element) {
                        return filedReq.indexOf(element) >= 0
                    });

                    validationsElements(arrValidation);
                    validationsElementsNot(arrValidationNot);
                });
            }

            if (field.field == "nivels_educativo_id") {
                $scope.$watch("options.ngModel['nivels_educativo_id']", function (newVal, oldVal) {
                    var nivels_educativo_id = $scope.options.ngModel["nivels_educativo_id"] * 1;
                    var estado_estudio = $scope.options.ngModel["estado_estudio"] * 1;
                    var result = ValidationFactory.estudioFormales.getFieldsConditionNivelEducativo(nivels_educativo_id, estado_estudio);
                    hideElements($scope, result.hide);
                    showElements(result.show);

                    var arrValidation = result.show.filter(function (element) {
                        return filedReq.indexOf(element) >= 0
                    });
                    var arrValidationNot = result.hide.filter(function (element) {
                        return filedReq.indexOf(element) >= 0
                    });

                    validationsElements(arrValidation);
                    validationsElementsNot(arrValidationNot);
                });
            }
            if (field.field == "anio_inicio") {
                $scope.$watch("options.ngModel['anio_inicio']", function (newVal, oldVal) {
                    var anio_inicio = $scope.options.ngModel["anio_inicio"] * 1;
                    var anio_finalizacion = $scope.options.ngModel["anio"] * 1;
                    var anio_grado = $scope.options.ngModel["anio_grado"] * 1;

                    if ($scope.options.ngModel["estado_estudio"] == 4) {
                        if (anio_finalizacion < anio_inicio && anio_finalizacion != 0) {
                            $scope.options.ngModel["anio"] = anio_inicio;
                        } else if (anio_finalizacion == 0) {
                            $scope.options.ngModel["anio"] = anio_inicio;
                        }

                        if (anio_grado < anio_inicio && anio_grado != 0) {
                            $scope.options.ngModel["anio_grado"] = anio_inicio;
                        } else if (anio_grado == 0) {
                            $scope.options.ngModel["anio_grado"] = anio_inicio;
                        }
                    }
                });
            }

            if (field.field == 'anio') {
                $scope.$watch("options.ngModel['anio']", function (newVal, oldVal) {
                    var anio_finalizacion = $scope.options.ngModel["anio"] * 1;
                    var anio_inicio = $scope.options.ngModel["anio_inicio"] * 1;

                    if ($scope.options.ngModel["estado_estudio"] == 4) {
                        if (anio_finalizacion < anio_inicio) {
                            $scope.options.ngModel["anio"] = anio_inicio;
                        }
                    }
                });
            }

            if (field.field == 'anio_grado') {
                $scope.$watch("options.ngModel['anio_grado']", function (newVal, oldVal) {
                    var anio_grado = $scope.options.ngModel["anio_grado"] * 1;
                    var anio_inicio = $scope.options.ngModel["anio_inicio"] * 1;

                    if ($scope.options.ngModel["estado_estudio"] == 4) {
                        if (anio_grado < anio_inicio) {
                            $scope.options.ngModel["anio_grado"] = anio_inicio;
                        }
                    }
                });
            }
        }

        function tqEstudiosNoFormalesBlockForm($scope, field) {
            if (field.field == "en_curso") {
                $scope.$watch("options.ngModel['en_curso']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["en_curso"];

                    if (!val) {
                        showElement('anio');
                    } else {
                        hideElement($scope, 'anio');
                    }
                });
            }

            if (field.field == "estado_estudio") {
                $scope.$watch("options.ngModel['estado_estudio']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["estado_estudio"];
                    if (val == 1) {
                        showElement('en_curso');
                    } else {
                        hideElement($scope, 'en_curso');
                    }

                });
            }

        }

        function tqExperienciaBlockForm($scope, field) {
            if (field.field == "trabajando") {
                $scope.$watch("options.ngModel['trabajando']", function (newVal, oldVal) {
                    var val = JSON.parse($scope.options.ngModel["trabajando"]);

                    if (!val) {
                        showElement('fecha_retiro');
                        showElement('motivo_retiro');
                    } else {
                        hideElement($scope, 'fecha_retiro');
                        hideElement($scope, 'motivo_retiro');
                    }
                });
            } else if (field.field == "industria_id") {
                $scope.$watch("options.ngModel['industria_id']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["industria_id"] * 1;

                    if (val) {
                        showElement('sector_id');
                    } else {
                        cleanElement($scope, 'sector_id');
                        //hideElement($scope, 'sector_id');
                    }
                });
            } else if (field.field == "fecha_retiro") {
                $scope.$watch("options.ngModel['fecha_retiro']", function (newVal, oldVal) {
                    var fecharetiro = $scope.options.ngModel["fecha_retiro"];
                    var fechaingreso = $scope.options.ngModel["fecha_ingreso"];

                    if (fecharetiro != "" && fechaingreso == "") {
                        $scope.options.ngModel["fecha_retiro"] = "";
                    } else if (fecharetiro != "" && fechaingreso != "") {
                        var fechaRMoment = moment(fecharetiro);
                        var fechaIMoment = moment(fechaingreso);
                        if (fechaRMoment < fechaIMoment) {
                            $scope.options.ngModel["fecha_retiro"] = "";
                        }
                    }
                });
            }


        }

        function tqPersonalesBlockForm($scope, field) {
            if (field.field == "genero") {
                $scope.$watch("options.ngModel['genero']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["genero"] * 1;
                    if (val == 1) {
                        showElement('tiene_libreta');
                    } else {
                        hideElement($scope, 'tiene_libreta');
                    }
                });
            }

            if (field.field == "tiene_libreta") {
                $scope.$watch("options.ngModel['tiene_libreta']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["tiene_libreta"] * 1;

                    if (val) {
                        showElement('numero_libreta');
                        showElement('clase_libreta');
                        showElement('distrito_libreta');
                    } else {
                        hideElement($scope, 'numero_libreta');
                        hideElement($scope, 'clase_libreta');
                        hideElement($scope, 'distrito_libreta');
                    }
                });
            }
        }

        function tqHijosBlockForm($scope, field) {
            var def = [
                "ocupacion",
                //"estudio_nivel",
            ];

            var basic = [
                "estudio_ciudad_id",
                "estudio_basico_estado",
                "estudio_institucion",
                "estudio_tipo_institucion",
                "estudio_calendario",
                //"estudio_grado_actual",
                "estudio_valor_matricula",
                "estudio_valor_mensualidad"
            ];

            var ifces = [
                "resultado_icfes",
                "puesto_icfes",
                "tipo_icfes"
            ]

            var pro = [
                "estudio_profesional_estado",
                "estudio_profesional_ciudad_id",
                "estudio_profesional_carrera",
                "estudio_profesional_institucion",
                "estudio_profesional_anio_ingreso",
                "estudio_profesional_semestre_ingreso",
                "estudio_profesional_anio_grado",
                "estudio_profesional_semestre_grado"
            ];

            if (field.field == "fecha_nacimiento") {
                $scope.$watch("options.ngModel['fecha_nacimiento']", function (newVal, oldVal) {
                    var date = $scope.options.ngModel["fecha_nacimiento"];
                    var age = (date ? moment().diff(date, 'years', false) : 0);
                    var days = (date ? moment().diff(date, 'days', false) : 0);

                    /*if (age < 25 && (age > 0 || days != 0)) {
                        showElement('adjuntos_hijo');
                    } else {
                        hideElement($scope, 'adjuntos_hijo');
                    }*/

                    if (age > 4) {
                        showElements(def);
                    } else {
                        hideElements($scope, def);
                        //hideElements($scope, ifces);
                        hideElements($scope, pro);
                        //hideElements($scope, basic);
                    }

                    /*if (age >= 16 && age <= 25) {
                        showElements(ifces);
                    } else {
                        hideElements($scope, ifces);
                    }*/
                });
            } else if (field.field == "estudio_nivel") {
                $scope.$watch("options.ngModel['estudio_nivel']", function (newVal, oldVal) {
                    /*var val = $scope.options.ngModel["estudio_nivel"];
                    if (val && val <= 3) {
                        showElements(basic);
                        hideElements($scope, pro);
                    } else if (val > 3) {
                        showElements(pro);
                        hideElements($scope, basic);
                    }*/

                    /**
                     * else if (val == 3) {
                        //showElements(basic);
                        hideElements($scope, pro);
                       // showElements(ifces);
                    }
                     */
                });
            }

            /**
             * else if (field.field == "ocupacion") {
                $scope.$watch("options.ngModel['ocupacion']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["ocupacion"];
                    if ((val * 1) == 1 || (val * 1) == 2) {
                        //showElement('estudio_nivel');
                    } else {
                        hideElement($scope, 'estudio_nivel');
                        hideElements($scope, ifces);
                        hideElements($scope, pro);
                        hideElements($scope, basic);
                    }
                });
            }
             */
        }

        function tqRequisicionBlockForm($scope, field) {
            if (field.field == "tipo_solicitud") {
                $scope.$watch("options.ngModel['tipo_solicitud']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["tipo_solicitud"] * 1;

                    if (val == 1 || val == 4 || val == 5 || val == 6) {
                        showElement('select_current_employee');
                        showElement('info_ocupante_actual');
                    } else if (val == 2) {
                        hideElement($scope, 'select_current_employee');
                        hideElement($scope, 'info_ocupante_actual');
                    }
                });
            } else if (field.field == "administrativo") {
                $scope.$watch("options.ngModel['administrativo'].length", function (newVal, oldVal) {
                    var values = $scope.options.ngModel["administrativo"];

                    var i = values.indexOf("2");

                    if (i > -1) {
                        showElement('responsable_desarrollo_humano');
                    } else {
                        hideElement($scope, 'responsable_desarrollo_humano');
                    }
                });
            } else if (field.field == "motivo_reemplazo") {
                $scope.$watch("options.ngModel['motivo_reemplazo']", function (newVal, oldVal) {
                    var value = $scope.options.ngModel["motivo_reemplazo"] * 1;
                    if (value == 1) {
                        showElement('traslado_cargo_area');
                        hideElement($scope, 'fecha_retiro');
                    } else if (value == 2) {
                        showElement('fecha_retiro');
                        hideElement($scope, 'traslado_cargo_area');
                    } else {
                        onlyHideElement('traslado_cargo_area');
                        onlyHideElement('fecha_retiro');
                    }
                });
            } else if (field.field == "cargo_tipo_contrato") {
                $scope.$watch("options.ngModel['cargo_tipo_contrato']", function (newVal, oldVal) {
                    var value = $scope.options.ngModel["cargo_tipo_contrato"] * 1;
                    if (value == 4) {
                        showElement('duracion_contrato');
                    } else {
                        hideElement($scope, 'duracion_contrato');
                    }
                });
            } else if (field.field == "tipo_prorroga") {
                $scope.$watch("options.ngModel['tipo_prorroga']", function (newVal, oldVal) {
                    var value = $scope.options.ngModel["tipo_prorroga"] * 1;

                    if (value == 2) {
                        showElement('numero_meses_prorroga');
                    } else {
                        hideElement($scope, 'numero_meses_prorroga');
                    }
                });
            } else if (field.field == "salario_basico" || field.field == "salario_variable") {
                $scope.$watch("options.ngModel['salario_basico']", function (newVal, oldVal) {
                    var basic = $scope.options.ngModel["salario_basico"] * 1;
                    var variable = $scope.options.ngModel["salario_variable"] * 1;

                    var standar = Math.round(((basic + variable) + Number.EPSILON) * 100) /100
                    $scope.options.ngModel["salario_estandar"] = standar;
                });

                $scope.$watch("options.ngModel['salario_variable']", function (newVal, oldVal) {
                    var basic = $scope.options.ngModel["salario_basico"] * 1;
                    var variable = $scope.options.ngModel["salario_variable"] * 1;

                    var standar = Math.round(((basic + variable) + Number.EPSILON) * 100) /100
                    $scope.options.ngModel["salario_estandar"] = standar;
                });
            } else if (field.field == "salario_basico_sugerida" || field.field == "salario_variable_sugerida") {
                $scope.$watch("options.ngModel['salario_basico_sugerida']", function (newVal, oldVal) {
                    var basic = $scope.options.ngModel["salario_basico_sugerida"] * 1;
                    var variable = $scope.options.ngModel["salario_variable_sugerida"] * 1;

                    var standar = Math.round(((basic + variable) + Number.EPSILON) * 100) /100
                    $scope.options.ngModel["salario_estandar_sugerida"] = standar;
                });

                $scope.$watch("options.ngModel['salario_variable_sugerida']", function (newVal, oldVal) {
                    var basic = $scope.options.ngModel["salario_basico_sugerida"] * 1;
                    var variable = $scope.options.ngModel["salario_variable_sugerida"] * 1;

                    var standar = Math.round(((basic + variable) + Number.EPSILON) * 100) /100
                    $scope.options.ngModel["salario_estandar_sugerida"] = standar;
                });
            } else if (field.field == "salario_basico_contratacion" || field.field == "salario_variable_contratacion") {
                $scope.$watch("options.ngModel['salario_basico_contratacion']", function (newVal, oldVal) {
                    var basic = $scope.options.ngModel["salario_basico_contratacion"] * 1;
                    var variable = $scope.options.ngModel["salario_variable_contratacion"] * 1;

                    var standar = Math.round(((basic + variable) + Number.EPSILON) * 100) /100
                    $scope.options.ngModel["salario_estandar_contratacion"] = standar;
                });

                $scope.$watch("options.ngModel['salario_variable_contratacion']", function (newVal, oldVal) {
                    var basic = $scope.options.ngModel["salario_basico_contratacion"] * 1;
                    var variable = $scope.options.ngModel["salario_variable_contratacion"] * 1;

                    var standar = Math.round(((basic + variable) + Number.EPSILON) * 100) /100
                    $scope.options.ngModel["salario_estandar_contratacion"] = standar;
                });
            } else if (field.field == "cambio_nomenclatura") {
                $scope.$watch("options.ngModel['cambio_nomenclatura']", function (newVal, oldVal) {
                    var value = $scope.options.ngModel["cambio_nomenclatura"] * 1;

                    if (value) {
                        showElement('nomenclatura_propuesta');
                    } else {
                        hideElement($scope, 'nomenclatura_propuesta');
                    }
                });
            } else if (field.field == "nomenclatura_propuesta") {
                $scope.$watch("options.ngModel['nomenclatura_propuesta']", function (newVal, oldVal) {
                    var value = $scope.options.ngModel["nomenclatura_propuesta"];

                    if (value && value.length > 50) {
                        $scope.options.ngModel["nomenclatura_propuesta"] = value.substring(0, 50);
                    }
                });
            } else if (field.field == 'division_id' || field.field == 'grupo_id' || field.field == 'area_funcional_id' || field.field == 'ubicacion_id' || field.field == 'label_estructura_nucleo_origen') {
                $scope.$watch("options.ngModel['tipo_candidato']", function (newVal, oldVal) {
                    var value = $scope.options.ngModel["tipo_candidato"] * 1;

                    /*if (value == 1) {
                        showElement('division_id');
                        showElement('grupo_id');
                        showElement('area_funcional_id');
                        showElement('ubicacion_id');
                        showElement('label_estructura_nucleo_origen');
                    } else {
                        hideElement($scope, 'division_id');
                        hideElement($scope, 'grupo_id');
                        hideElement($scope, 'area_funcional_id');
                        hideElement($scope, 'ubicacion_id');
                        hideElement($scope, 'label_estructura_nucleo_origen');
                    }*/
                });
            }
        }

        function tqInformacionSeleccion($scope, field) {
            if (field.field == "tipo_candidato") {
                $scope.$watch("options.ngModel['tipo_candidato']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["tipo_candidato"] * 1;
                    if (val == 2) {
                        showElement('incumplimiento_movilidad');
                    } else {
                        hideElement($scope, 'incumplimiento_movilidad');
                    }
                });
            }
        }

        function tqEtapasCandidatos($scope, field) {
            var conditionalFieldFamiliaresInternos = [
                'familiares_internos_nombre',
                'familiares_internos_territorio',
                'familiares_internos_area',
                'familiares_internos_cargo'
            ]

            var conditionalEstudiandoActualmente = [
                'estudiando_actualmente_donde',
                'estudiando_actualmente_horario'
            ]


            if (field.field == "familiares_internos") {
                $scope.$watch("options.ngModel['familiares_internos']", function (newVal, oldVal) {
                    if (typeof $scope.options.ngModel["familiares_internos"] == "undefined") {
                        return;
                    }
                    var val = $scope.options.ngModel["familiares_internos"] * 1;
                    if (val == 1) {
                        showElements(conditionalFieldFamiliaresInternos);
                    } else {
                        hideElements($scope, conditionalFieldFamiliaresInternos);
                    }
                });
            }
            if (field.field == "estudiando_actualmente") {
                $scope.$watch("options.ngModel['estudiando_actualmente']", function (newVal, oldVal) {
                    if (typeof $scope.options.ngModel["estudiando_actualmente"] == "undefined") {
                        return;
                    }
                    var val = $scope.options.ngModel["estudiando_actualmente"] * 1;
                    if (val == 1) {
                        showElements(conditionalEstudiandoActualmente);
                    } else {
                        hideElements($scope, conditionalEstudiandoActualmente);
                    }
                });
            }
            if (field.field == "estudiando_actualmente_planes_estudiar") {
                $scope.$watch("options.ngModel['estudiando_actualmente_planes_estudiar']", function (newVal, oldVal) {
                    if (typeof $scope.options.ngModel["estudiando_actualmente_planes_estudiar"] == "undefined") {
                        return;
                    }
                    var val = $scope.options.ngModel["estudiando_actualmente_planes_estudiar"] * 1;
                    if (val == 1) {
                        showElement("estudiando_actualmente_cuando");
                    } else {
                        hideElement($scope, "estudiando_actualmente_cuando");
                    }
                });
            }



            /**
             * Información laboral
             */
            var conditionalTrabajaActualmente = [
                "trabaja_actualmente_empresa",
                "trabaja_actualmente_salario",
                "trabaja_actualmente_cargo",
                "trabaja_actualmente_responsabilidades"
            ];

            if (field.field == 'trabaja_actualmente') {
                $scope.$watch("options.ngModel['trabaja_actualmente']", function (newVal, oldVal) {
                    if (typeof $scope.options.ngModel["trabaja_actualmente"] == "undefined") {
                        return;
                    }
                    var val = $scope.options.ngModel["trabaja_actualmente"] * 1;
                    if (val == 1) {
                        showElements(conditionalTrabajaActualmente);
                    } else {
                        hideElements($scope, conditionalTrabajaActualmente);
                    }
                });
            }


            var conditionalInteresaProceso = [
                'no_interesa_continuar_proceso_razones',
                "razones_descarte_filtro_telefonico",
                "detalle_descarte"
            ];
            if (field.field == 'interesa_continuar_proceso') {
                $scope.$watch("options.ngModel['interesa_continuar_proceso']", function (newVal, oldVal) {
                    if (typeof $scope.options.ngModel["interesa_continuar_proceso"] == "undefined") {
                        return;
                    }
                    var val = $scope.options.ngModel["interesa_continuar_proceso"] * 1;
                    if (val == 0) {
                        showElements(conditionalInteresaProceso);
                    } else {
                        hideElements($scope, conditionalInteresaProceso);
                    }
                });
            }

        }

        function validateShowIf($scope, field) {
            var keys = Object.keys($scope.options.ngModel);
            if (keys.indexOf(field.showif.field) == -1) {
                return;
            }
            $scope.$watch("options.ngModel['" + field.showif.field + "']", function (newVal, oldVal) {

                var val = $scope.options.ngModel[field.showif.field];
                var value = field.showif.value ? field.showif.value.split(',') : null;
                conditionsShowIf($scope, field, val, value);
            }, true);

        }

        function validateShowIfRead(data, field) {
            var keys = Object.keys(data);
            if (keys.indexOf(field.showif.field) == -1) {
                return;
            }
            var val = data[field.showif.field];
            var value = field.showif.value ? field.showif.value.split(',') : null;
            return conditionsShowIfReturn(false, field.showif, val, value);
        }

        function validateShowIfExtra($scope, field) {
            var keys = Object.keys($scope.options.ngModel);
            if (keys.indexOf(field.showif.field) == -1) {
                return;
            }
            $scope.$watch("options.ngModel['" + field.showif.field + "']", function (newVal, oldVal) {

                var val = $scope.options.ngModel[field.showif.field];
                var value = field.showif.value ? field.showif.value.split(',') : null;
                var condition = conditionsShowIfReturn($scope, field.showif, val, value);

                var valExtra = $scope.options.ngModel[field.showif.field_extra.field];
                var valueExtra = field.showif.field_extra.value ? field.showif.field_extra.value.split(',') : null;
                var conditionExtra = conditionsShowIfReturn($scope, field.showif.field_extra, valExtra, valueExtra);
                validateShowAndHideElement($scope, field, (condition && conditionExtra));

            }, true);

            $scope.$watch("options.ngModel['" + field.showif.field_extra.field + "']", function (newVal, oldVal) {

                var val = $scope.options.ngModel[field.showif.field];
                var value = field.showif.value ? field.showif.value.split(',') : null;
                var condition = conditionsShowIfReturn($scope, field.showif, val, value);

                var valExtra = $scope.options.ngModel[field.showif.field_extra.field];
                var valueExtra = field.showif.field_extra.value ? field.showif.field_extra.value.split(',') : null;
                var conditionExtra = conditionsShowIfReturn($scope, field.showif.field_extra, valExtra, valueExtra);
                validateShowAndHideElement($scope, field, (condition && conditionExtra));
            }, true);
        }

        function validateShowIfExtraRead(data, field) {
            var keys = Object.keys(data);
            if (keys.indexOf(field.showif.field) == -1) {
                return;
            }

            var val = data[field.showif.field];
            var value = field.showif.value ? field.showif.value.split(',') : null;
            var condition = conditionsShowIfReturn(false, field.showif, val, value);

            var valExtra = data[field.showif.field_extra.field];
            var valueExtra = field.showif.field_extra.value ? field.showif.field_extra.value.split(',') : null;
            var conditionExtra = conditionsShowIfReturn(false, field.showif.field_extra, valExtra, valueExtra);
            //validateShowAndHideElement($scope, field, (condition && conditionExtra));
            return (condition && conditionExtra);
        }

        function validateShowIfData($scope, field) {
            if (!$scope.options.ngModel[field.showif.data]) {
                return;
            }
            var val = $scope.options.ngModel[field.showif.data];
            var value = field.showif.value ? field.showif.value.split(',') : null;

            conditionsShowIf($scope, field, val, value);
        }

        function conditionsShowIf($scope, field, val, value) {

            switch (field.showif.condition) {
                case '==':
                    if (value instanceof Array) {
                        if (val != null && typeof val != 'undefined') {
                            val = val.toString();
                        }
                        if (value.indexOf(val) != -1) {
                            showElement(field.field);
                            validationsElement(field.field);
                        } else {
                            hideElement($scope, field.field);
                            validationsElementNot(field.field);

                        }
                    }
                    break;

                case '<':
                    if (field.showif.type == 'date') {
                        var momentSelected = moment(val);
                        var momentToday = moment();
                        var diff = momentToday.diff(momentSelected, field.showif.diff);

                        if (diff < parseInt(value[0]) || diff == 0) {
                            showElement(field.field);
                            validationsElement(field.field);
                        } else {
                            hideElement($scope, field.field);
                            validationsElementNot(field.field);
                        }
                    }
                    break;
                case '>=':
                    if (field.showif.type == 'date') {
                        var momentSelected = moment(val);
                        var momentToday = moment();
                        var diff = momentToday.diff(momentSelected, field.showif.diff);

                        if (diff >= parseInt(value[0])) {
                            showElement(field.field);
                            validationsElement(field.field);
                        } else {
                            hideElement($scope, field.field);
                            validationsElementNot(field.field);
                        }
                    }
                    break;

                case 'between':
                    if (field.showif.type == 'date') {
                        var momentSelected = moment(val);
                        var momentToday = moment();
                        var diff = momentToday.diff(momentSelected, field.showif.diff);
                        if (parseInt(field.showif.min) <= diff && diff <= parseInt(field.showif.max)) {
                            showElement(field.field);
                            validationsElement(field.field);
                        } else {
                            hideElement($scope, field.field);
                            validationsElementNot(field.field);
                        }
                    }
                    break;
            }
        }

        function conditionsShowIfReturn($scope, field, val, value) {
            switch (field.condition) {
                case '==':
                    if (value instanceof Array) {
                        if (val != null && typeof val != 'undefined') {
                            val = val.toString();
                        }
                        if (value.indexOf(val) != -1) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    break;

                case '<':
                    if (field.type == 'date') {
                        var momentSelected = moment(val);
                        var momentToday = moment();
                        var diff = momentToday.diff(momentSelected, field.diff);

                        if (diff < parseInt(value[0]) || diff == 0) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    break;

                case '>=':
                    if (field.type == 'date') {
                        var momentSelected = moment(val);
                        var momentToday = moment();
                        var diff = momentToday.diff(momentSelected, field.diff);

                        if (diff >= parseInt(value[0])) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    break;

                case 'between':
                    if (field.type == 'date') {
                        var momentSelected = moment(val);
                        var momentToday = moment();
                        var diff = momentToday.diff(momentSelected, field.diff);
                        if (parseInt(field.min) <= diff && diff <= parseInt(field.max)) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    break;
            }
        }

        function validateShowAndHideElement($scope, field, show) {
            if (show) {
                showElement(field.field);
                validationsElement(field.field);
            } else {
                hideElement($scope, field.field);
                validationsElementNot(field.field);
            }
        }

        function colombinaRequisicionBlockForm($scope, field) {
            if (field.field == "tipo_contrato") {
                $scope.$watch("options.ngModel['tipo_contrato']", function (newVal, oldVal) {
                    var val = $scope.options.ngModel["tipo_contrato"] * 1;

                    if (val == 3 || !val) {
                        hideElement($scope, 'tiempo_vinculacion');
                    } else {
                        showElement('tiempo_vinculacion');
                    }
                });
            }
        }

        function validationsElements(array) {
            for (var i in array) {

                var element = document.getElementById('' + array[i]);
                if (!element) {
                    return;
                }

                var elementParent = angular.element(document.getElementById('' + array[i])).scope();

                var fieldParent = elementParent.$parent;
                if (fieldParent.field.validations) {
                    fieldParent.field.validations.push('required');
                } else {
                    fieldParent.field.validations = ['required'];
                }

                var element = angular.element(document.getElementById('' + array[i])).children().children().scope();
                if (element.data) {
                    element.data.required = true;
                }
            }
        }

        function validationsElementsNot(array) {
            for (var i in array) {
                var element = document.getElementById('' + array[i]);
                if (!element) {
                    return;
                }

                var elementParent = angular.element(document.getElementById('' + array[i])).scope();

                var fieldParent = elementParent.$parent;

                if (fieldParent.field.validations) {
                    for (var v in fieldParent.field.validations) {
                        if (fieldParent.field.validations[v] == 'required') {
                            fieldParent.field.validations.splice(v, 1);
                            break;
                        }
                    }
                } else {
                    fieldParent.field.validations = [];
                }

                var element = angular.element(document.getElementById('' + array[i])).children().children().scope();
                if (element.data) {
                    element.data.required = false;
                }

            }
        }

        function validationsElement(field) {
            var element = document.getElementById('' + field);
            if (!element) {
                return;
            }

            var elementParent = angular.element(document.getElementById('' + field)).scope();
            var fieldParent = elementParent.field ? elementParent : elementParent.$parent;
            if(typeof fieldParent.field != 'object'){
                return;
            }
            if (!fieldParent.field.validationsBackup) {
                fieldParent.field.validationsBackup = fieldParent.field.validations ? fieldParent.field.validations : [];
            }

            fieldParent.field.validations = angular.copy(fieldParent.field.validationsBackup);

            var required = fieldParent.field.validations.filter(function (element) {
                return element == 'required';
            });

            var element = angular.element(document.getElementById('' + field)).children().children().scope();
            if (element.data && required.length > 0) {
                element.data.required = true;
            }
        }

        function validationsElementNot(field) {
            var element = document.getElementById('' + field);
            if (!element) {
                return;
            }

            var elementParent = angular.element(document.getElementById('' + field)).scope();
            var fieldParent = elementParent.field ? elementParent : elementParent.$parent;
            if (!fieldParent.field.validationsBackup) {
                fieldParent.field.validationsBackup = fieldParent.field.validations ? fieldParent.field.validations : [];
            }

            fieldParent.field.validations = [];

            var element = angular.element(document.getElementById('' + field)).children().children().scope();
            if (element.data) {
                element.data.required = false;
            }
        }

        function hideElements($scope, array) {
            for (var index = 0; index < array.length; index++) {
                var field = array[index];
                var element = document.getElementById('' + field);
                if (element) {
                    document.getElementById('' + field).style.display = 'none';
                    $scope.options.ngModel[field] = null;
                }

            }
        }

        function showElements(array) {

            for (var index = 0; index < array.length; index++) {
                var field = array[index];
                var element = document.getElementById('' + field);
                if (element) {
                    document.getElementById('' + field).style.display = 'block';
                }
            }
        }

        function hideElement($scope, field) {
            var element = document.getElementById('' + field);
            if (element) {
                document.getElementById('' + field).style.display = 'none';
                $scope.options.ngModel[field] = null;
            }
        }

        function onlyHideElement(field) {
            var element = document.getElementById('' + field);
            if (element) {
                document.getElementById('' + field).style.display = 'none';
            }
        }

        function showElement(field) {
            var element = document.getElementById('' + field);
            if (element) {
                document.getElementById('' + field).style.display = 'block';
            }
        }

        function cleanElement($scope, field) {
            $scope.options.ngModel[field] = null;
        }

        /** ******************************************************************* */
        /** ******************************************************************* */
        /** ******************************************************************* */
        /** ******************************************************************* */

        /** Validaciones de la vista */

        function validate(block, data, field) {
            field.showif = angular.copy(field.show_if);
            if (field.showif) {
                if (field.showif.field && !field.showif.field_extra) {
                    return validateShowIfRead(data, field);
                } else if (field.showif.data) {
                    //validateShowIfDataRead(data, field);
                } else if (field.showif.field && field.showif.field_extra) {
                    return validateShowIfExtraRead(data, field);
                }
            }

            var domain = localStorage.getItem('DOMAIN_SELECTION');
            if (domain == "tecnoquimicas") {
                if (block == "salud") {
                    return tqSaludBlock(data, field);
                } else if (block == "vivienda") {
                    return tqViviendaBlock(data, field);
                } else if (block == "adicional") {
                    return tqAdicionalBlock(data, field);
                } else if (block == "viven_usted") {
                    return tqVivenUstedBlock(data, field);
                } else if (block == "conyuge") {
                    return tqConyugeBlock(data, field);
                } else if (block == "padre" || block == "madre") {
                    return tqPadresBlock(data, field);
                } else if (block == "grupo_familiar") {
                    return tqGrupoFamiliarBlock(data, field);
                } else if (block == "estudios_formales") {
                    return tqEstudiosFormalesBlock(data, field);
                } else if (block == "estudios_no_formales") {
                    return tqEstudiosNoFormalesBlock(data, field);
                } else if (block == "experiencia") {
                    return tqExperienciaBlock(data, field);
                } else if (block == "personales") {
                    return tqPersonalesBlock(data, field);
                } else if (block == "hijos") {
                    return tqHijosBlock(data, field);
                } else if (block == "informacion_seleccion") {
                    return tqInformacionSeleccionBlock(data, field);
                }
            }

            return true;
        }

        function tqSaludBlock(data, field) {
            //tiene_pos, pos_cual
            if (field.field == "pos_cual") {
                if (data.tiene_pos * 1) {
                    return true;
                }

                return false;
            }

            return true;
        }

        function tqViviendaBlock(data, field) {
            //tipo, tipo_otro, subsidio_vivienda, entidad_subsidio
            if (field.field == "tipo_otro") {
                if ((data.tipo * 1) == 3) {
                    return true;
                }

                return false;
            } else if (field.field == "entidad_subsidio") {
                if ((data.subsidio_vivienda * 1)) {
                    return true;
                }

                return false;
            }

            return true;
        }

        function tqAdicionalBlock(data, field) {
            //tipo, tipo_otro, subsidio_vivienda, entidad_subsidio
            if (field.field == "tipo_cargos_su_personal") {
                if ((data.tenido_personal_cargo * 1)) {
                    return true;
                }

                return false;
            } else if (field.field == "proyectos_liderados") {
                if ((data.liderado_proyectos_organizacion * 1)) {
                    return true;
                }

                return false;
            }

            return true;
        }

        function tqVivenUstedBlock(data, field) {
            if (field.field == "parentesco_otro") {
                if ((data.parentesco * 1) == 9) {
                    return true;
                }

                return false;
            }

            return true;
        }

        function tqConyugeBlock(data, field) {
            if (field.field == "empresa") {
                if ((data.ocupacion * 1) == 2 || (data.ocupacion * 1) == 3) {
                    return true;
                }

                return false;
            } else if (field.field == "actividad_economica") {
                if ((data.ocupacion * 1) == 6 || (data.ocupacion * 1) == 7) {
                    return true;
                }

                return false;
            }

            return true;
        }

        function tqPadresBlock(data, field) {
            if (field.field == "padre_tipo_documento" ||
                field.field == "padre_documento" ||
                field.field == "padre_ciudad_expedicion_id" ||
                field.field == "padre_fecha_nacimiento" ||
                field.field == "padre_ciudad_nacimiento_id" ||
                field.field == "padre_genero" ||
                field.field == "padre_nivel_estudio" ||
                field.field == "padre_estado_estudio" ||
                field.field == "padre_ocupacion" ||
                field.field == "padre_telefono_fijo" ||
                field.field == "padre_telefono_movil" ||
                field.field == "padre_correo" ||
                field.field == "padre_depende_usted" ||
                field.field == "padre_vive_usted" ||
                field.field == "padre_tiene_discapacidad") {

                if ((data.padre_vive * 1)) {
                    return true;
                }

                return false;
            } else if (field.field == "madre_tipo_documento" ||
                field.field == "madre_documento" ||
                field.field == "madre_ciudad_expedicion_id" ||
                field.field == "madre_fecha_nacimiento" ||
                field.field == "madre_ciudad_nacimiento_id" ||
                field.field == "madre_genero" ||
                field.field == "madre_nivel_estudio" ||
                field.field == "madre_estado_estudio" ||
                field.field == "madre_ocupacion" ||
                field.field == "madre_telefono_fijo" ||
                field.field == "madre_telefono_movil" ||
                field.field == "madre_correo" ||
                field.field == "madre_depende_usted" ||
                field.field == "madre_vive_usted" ||
                field.field == "madre_tiene_discapacidad") {

                if ((data.madre_vive * 1)) {
                    return true;
                }

                return false;
            }

            return true;
        }

        function tqGrupoFamiliarBlock(data, field) {
            if (field.field == "cantidad_hijos") {
                if ((data.tiene_hijos * 1)) {
                    return true;
                }

                return false;
            }

            return true;
        }

        function tqEstudiosFormalesBlock(data, field) {
            if (field.field == "numero_tarjeta_profesional") {
                if ((data.tiene_tarjeta_profesional * 1) == 1 || (data.tiene_tarjeta_profesional * 1) == 2) {
                    return true;
                }
                return false;
            } else if (field.field == "fecha_expedicion_tarjeta_profesional") {
                if ((data.tiene_tarjeta_profesional * 1) == 1 || (data.tiene_tarjeta_profesional * 1) == 2) {
                    return true;
                }
                return false;
            } else if (field.field == "adjuntos_tarjetaprofesional") {
                if ((data.tiene_tarjeta_profesional * 1) == 2) {
                    return true;
                }
                return false;
            } else if (field.field == "semestre_actual") {
                if ((data.estado_estudio * 1) == 1 || (data.estado_estudio * 1) == 2 || (data.estado_estudio * 1) == 3) {
                    return true;
                }
                return false;
            } else if (field.field == "anio" || field.field == "semestre_egreso" || field.field == "anio_grado" || field.field == "semestre_grado") {
                if ((data.estado_estudio * 1) == 4) {
                    return true;
                }
                return false;
            }
            /*if (field.field == "nivels_educativo_id") {
                var nivels_educativo_id = $scope.options.ngModel["nivels_educativo_id"] * 1;
                var estado_estudio = $scope.options.ngModel["estado_estudio"] * 1;
                var result = ValidationFactory.estudioFormales.getFieldsConditionNivelEducativo(nivels_educativo_id, estado_estudio);
                hideElements($scope, result.hide);
                showElements(result.show);
            }*/

            return true;
        }

        function tqEstudiosNoFormalesBlock(data, field) {
            if (field.field == "anio") {
                if (!data.en_curso) {
                    return true;
                }
                return false;
            }

            return true;
        }

        function tqExperienciaBlock(data, field) {
            if (field.field == "fecha_retiro") {
                if (!(data.trabajando * 1)) {
                    return true;
                }
                return false;
            } else if (field.field == "motivo_retiro") {
                if (!(data.trabajando * 1)) {
                    return true;
                }
                return false;
            }

            return true;
        }

        function tqPersonalesBlock(data, field) {

            if (field.field == "tiene_libreta") {
                if ((data.genero * 1) == 1) {
                    return true;
                }
                return false;
            }

            if (field.field == "numero_libreta") {
                if ((data.tiene_libreta * 1) == 1) {
                    return true;
                }
                return false;
            } else if (field.field == "clase_libreta") {
                if ((data.tiene_libreta * 1) == 1) {
                    return true;
                }
                return false;
            } else if (field.field == "distrito_libreta") {
                if ((data.tiene_libreta * 1) == 1) {
                    return true;
                }
                return false;
            }

            return true;
        }

        function tqHijosBlock(data, field) {
            //fecha_nacimiento, ocupacion, estudio_nivel, estudio_profesional_estado, estudio_ciudad_id
            var age = (data.fecha_nacimiento ? moment().diff(data.fecha_nacimiento, 'years', false) : 0);
            if (field.field == "ocupacion") {
                if (age >= 3) {
                    return true;
                }
                return false;
            } else if (field.field == "estudio_nivel") {
                if ((data.ocupacion * 1) == 1 || (data.ocupacion * 1) == 2) {
                    return true;
                }
                return false;
            } else if (field.field == "estudio_ciudad_id" ||
                field.field == "estudio_basico_estado" ||
                field.field == "estudio_institucion" ||
                field.field == "estudio_tipo_institucion" ||
                field.field == "estudio_calendario" ||
                field.field == "estudio_grado_actual" ||
                field.field == "estudio_valor_matricula" ||
                field.field == "estudio_valor_mensualidad") {

                if ((data.estudio_nivel * 1) <= 3) {
                    return true;
                }

                return false;

            } else if (field.field == "estudio_profesional_estado" ||
                field.field == "estudio_profesional_ciudad_id" ||
                field.field == "estudio_profesional_carrera" ||
                field.field == "estudio_profesional_institucion" ||
                field.field == "estudio_profesional_anio_ingreso" ||
                field.field == "estudio_profesional_semestre_ingreso" ||
                field.field == "estudio_profesional_anio_grado" ||
                field.field == "estudio_profesional_semestre_grado") {

                if ((data.estudio_nivel * 1) > 3) {
                    return true;
                }
                return false;

            } else if (field.field == "resultado_icfes" ||
                field.field == "puesto_icfes" ||
                field.field == "tipo_icfes") {

                if ((data.estudio_nivel * 1) > 2 && age >= 17 && age <= 25) {
                    return true;
                }
                return false;
            }

            return true;
        }

        function tqInformacionSeleccionBlock(data, field) {
            if (field.field == "incumplimiento_movilidad") {
                if (data.tipo_candidato == 2) {
                    return true;
                }
                return false;
            }
            return true;
        }

        /** ***************************************************************************** */
        /** ***************************************************************************** */


        function refreshFieldsValues(values, list) {
            var domain = localStorage.getItem('DOMAIN_SELECTION');
            if (domain == "tecnoquimicas") {
                if (!angular.equals(list, {})) {

                    /*if(values.notChangeInfoActual){
                        values.notChangeInfoActual = false;
                        return values;
                    }*/
                    console.log(values)
                    if (values.info_ocupante_actual && values.info_ocupante_actual.length && values.info_ocupante_actual[0] && list[values.info_ocupante_actual[0]]) {
                        
                        var value = list[values.info_ocupante_actual[0]];

                        values.sociedad_id = value.cod_sociedad;
                        values.area_funcional_id = value.cod_area_funcional;
                        values.regional_id = value.cod_empresa;
                        values.division_id = value.cod_division;
                        values.grupo_id = value.cod_grupo_act_negoc;
                        values.centro_gasto = value.centro_gasto;
                        values.ubicacion_id = value.cod_ubicacion1;
                        values.subarea_id = value.cod_subarea;
                    } else {
                        values.sociedad_id = null;
                        values.area_funcional_id = null;
                        values.regional_id = null;
                        values.division_id = null;
                        values.grupo_id = null;
                        values.centro_gasto = null;
                        values.ubicacion_id = null;
                        values.subarea_id = null;
                    }
                }
            } else if (domain == "riopaila") {
                if (!angular.equals(list, {})) {
                    if (values.info_ocupante_actual.length && values.info_ocupante_actual[0] && list[values.info_ocupante_actual[0]]) {
                        var value = list[values.info_ocupante_actual[0]];

                        values.empresa_id = value.empresa_id;
                        values.area_id = value.area_id;
                        values.gerencia_id = value.gerencia_id;
                        values.vicepresidencia_id = value.vicepresidencia_id;
                        values.centro_costo = value.centro_costo;
                    } else {
                        values.empresa_id = null;
                        values.area_id = null;
                        values.gerencia_id = null;
                        values.vicepresidencia_id = null;
                        values.centro_costo = null;
                    }
                }
            }

            return values;
        }

        function disableField(fields, values) {
            var domain = localStorage.getItem('DOMAIN_SELECTION');
            if (domain == "riopaila") {
                if (values.tipo_solicitud == 1 || values.tipo_solicitud == 2 || values.tipo_solicitud == 3) {
                    if (fields.empresa_id) {
                        fields.empresa_id.permiso = 0;
                    }

                    if (fields.area_id) {
                        fields.area_id.permiso = 0;
                    }

                    if (fields.gerencia_id) {
                        fields.gerencia_id.permiso = 0;
                    }

                    if (fields.vicepresidencia_id) {
                        fields.vicepresidencia_id.permiso = 0;
                    }

                    if (fields.centro_costo) {
                        fields.centro_costo.permiso = 0;
                    }
                }
            }

            return fields;
        }

        function validateShowRequestFields(field, values) {
            var domain = localStorage.getItem('DOMAIN_SELECTION');
            if (domain == "tecnoquimicas") {

                if (field == "duracion_contrato") {
                    if (values.cargo_tipo_contrato == 4) {
                        return true;
                    } else {
                        return false;
                    }
                }
                /*
                else if (field == "fecha_ingreso_tentativa") {
                    if (values.cargo_tipo_contrato == 4) {
                        return true;
                    } else {
                        return false;
                    }
                } 
                */
                else if (field == "traslado_cargo_area") {
                    if (values.motivo_reemplazo == 1) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (field == "fecha_retiro") {
                    if (values.motivo_reemplazo == 2) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (field == "numero_meses_prorroga") {
                    if (values.tipo_prorroga == 2) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (field == "incumplimiento_movilidad") {
                    if (values.tipo_candidato == 2) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else if (domain == "riopaila") {
                if (field == "vigencia_contrato") {
                    if (values.tipo_contrato == 1) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (field == "experiencia_requerida") {
                    if (values.requiere_experiencia == 1) {
                        return true;
                    } else {
                        return false;
                    }
                }
                else if (field == "tipo_computador") {
                    if (values.necesita_computador == 1) {
                        return true;
                    } else {
                        return false;
                    }
                }
                else if (field == "conocimientos_especificos") {
                    if (values.requiere_conocimientos_especificos == 1) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }

            return true;
        }

        function setWarchers($scope, vm) {
            var domain = localStorage.getItem('DOMAIN_SELECTION');
            $scope.$watch('vm.values', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    if (vm.first) {
                        vm.change = false;
                        vm.first = false;
                    } else {
                        vm.change = true;
                    }
                }
            }, true);

            if (domain == "tecnoquimicas") {
                $scope.$watch('vm.values.cargo_ocupar', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        vm.pageInfo.title = (vm.values.cargo_ocupar ? vm.values.cargo_ocupar : "Nueva requisición");
                    }
                }, true);

                $scope.$watch('vm.values.tipo_solicitud', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (vm.first) {
                            vm.first = false;
                        } else {
                            vm.oldValues = vm.values;
                            vm.type = vm.values.tipo_solicitud;
                            vm.getRequest();
                        }
                    }
                }, true);

                $scope.$watch('vm.values.tipo_solicitud_b', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (vm.first) {
                            vm.first = false;
                        } else {
                            vm.oldValues = vm.values;
                            vm.type = vm.values.tipo_solicitud;
                            vm.getRequest();
                        }
                    }
                }, true);

                $scope.$watch('vm.values.tipo_solicitud_c', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (vm.first) {
                            vm.first = false;
                        } else {
                            vm.oldValues = vm.values;
                            vm.type = vm.values.tipo_solicitud;
                            vm.getRequest();
                        }
                    }
                }, true);

                $scope.$watch('vm.values.cargo_id', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        vm.getPositionColaborators(newValue);
                        vm.values.info_ocupante_actual = [];
                    }
                }, true);

                $scope.$watch('vm.values.info_ocupante_actual', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (vm.lists.position_colaborators) {
                            if (vm.lists.position_colaborators && (newValue.length === 0 || newValue[0] === null || vm.lists.position_colaborators[newValue[0]].id != oldValue[0])) {
                                vm.values = refreshFieldsValues(vm.values, vm.lists.position_colaborators);
                            }
                        }
                    }
                }, true);

            } else if (domain == "colombina") {
                if (vm.data.estructura_campos['info_ocupante_actual'] && vm.data.listas[vm.data.estructura_campos['info_ocupante_actual'].options]) {
                    vm.lists.position_colaborators = vm.data.listas[vm.data.estructura_campos['info_ocupante_actual'].options];
                }
            } else if (domain == "riopaila") {
                $scope.$watch('vm.values.tipo_solicitud', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (vm.first) {
                            vm.first = false;
                        } else {
                            vm.oldValues = vm.values;
                            vm.type = vm.values.tipo_solicitud;
                            vm.getRequest();
                        }
                    }
                }, true);

                $scope.$watch('vm.values.cargo_id', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        vm.getPositionColaborators(newValue);
                        vm.values.info_ocupante_actual = [];
                    }
                }, true);

                $scope.$watch('vm.values.info_ocupante_actual', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (vm.lists.position_colaborators) {
                            vm.values = refreshFieldsValues(vm.values, vm.lists.position_colaborators);
                        }
                    }
                }, true);
            }
        }

        function getVacants($scope, vm) {
            var domain = localStorage.getItem('DOMAIN_SELECTION');

            var vacants = [];
            if (domain == "tecnoquimicas" || domain == "colombina" || domain == "riopaila") {
                if (vm.values.no_vacantes * 1) {
                    for (var index = 0; index < (vm.values.no_vacantes * 1); index++) {
                        vacants.push(index);
                    }
                }

                if (vm.values.info_ocupante_actual && vm.values.info_ocupante_actual.length) {
                    vm.values.info_ocupante_actual.splice(vacants.length, (vm.values.info_ocupante_actual.length - vacants.length));
                }
            }

            return vacants;
        }

        function generalFunctions($scope, vm) {
            var domain = localStorage.getItem('DOMAIN_SELECTION');
            if (domain == "tecnoquimicas" || domain == "riopaila") {
                if (vm.values.cargo_id) {
                    vm.getPositionColaborators(vm.values.cargo_id, vm);
                }
            }
        }

        function watchFunctions($scope, vm, keyRoot) {
            var structure = vm.fields;
            var rootKey = null;
            var aliasKey = "values"
            if (typeof keyRoot == 'object') {
                if (keyRoot.fields) {
                    structure = vm[keyRoot.fields];
                }
                if (keyRoot.keyRoot) {
                    rootKey = keyRoot.keyRoot;
                }
                if (keyRoot.aliaskey) {
                    aliasKey = keyRoot.aliaskey
                }

            } else {
                rootKey = keyRoot;
            }
            var backupOnChange = {};
            $.each(structure, function (key, value) {
                if (value.onchange) {
                    backupOnChange[key] = value;
                    $scope.$watch('vm.' + (rootKey ? rootKey + '.' : '') + aliasKey + '.' + key, function (newValue, oldValue, scope) {
                        if (newValue != oldValue && newValue) {
                            var scopeValue = rootKey ? scope.vm[rootKey][aliasKey] : scope.vm[aliasKey];
                            onChange(scope, backupOnChange[key].onchange, scopeValue, rootKey);
                        }
                        //
                    }, true);
                }
            });
        }

        function onChange(scope, params, scopeValue, rootKey) {

            var data = {
                function: params.function,
                values: {}
            };

            //var scopeRoot = scopeValue; //keyRoot ? scope.vm[keyRoot].values : scope.vm.values;
            for (var i in params.fields) {
                var valueFiels = scopeValue[params.fields[i]];
                if (valueFiels) {
                    data.values[params.fields[i]] = valueFiels;
                }
            }
            if (scopeValue._id) {
                data.values.hoja_vida_id = scopeValue._id;
            }

            AdminService.get_onchange_data(data, function (response) {
                var reponseRoot = response.data;
                if (reponseRoot.data.data) {
                    setDataScope(scope, scopeValue, reponseRoot.data.data);
                    if (eval("typeof scope.vm" + (rootKey ? rootKey + '.' : '.') + "onchange_data == 'function'")) {
                        eval("scope.vm" + (rootKey ? rootKey + '.' : '.') + "onchange_data(reponseRoot.data.data)");
                    }

                }
                if (reponseRoot.data.estructura_campos) {
                    if (eval("typeof scope.vm" + (rootKey ? rootKey + '.' : '.') + "onchange_structureFields == 'function'")) {
                        eval("scope.vm" + (rootKey ? rootKey + '.' : '.') + "onchange_structureFields(reponseRoot.data.estructura_campos)");
                    }

                }

                if (reponseRoot.data.lista) {
                    if (eval("typeof scope.vm" + (rootKey ? rootKey + '.' : '.') + "onchange_lists == 'function'")) {
                        eval("scope.vm" + (rootKey ? rootKey + '.' : '.') + "onchange_lists(reponseRoot.data.lista)");
                    }

                }

            }, function (reject) {
                console.log(reject);
            });
        }

        function setDataScope(scope, scopeValue, data) {

            //var scopeRoot = scopeValue;//keyRoot ? scope.vm[keyRoot].values : scope.vm.values;
            /*$.each(data, function (key, value) {
                console.log(key,value);
                scopeValue[key] = value;
            });*/
            for (var f in data) {
                if (typeof scopeValue[f] != "undefined") {
                    scopeValue[f] = data[f];
                }
            }
        }


        return {
            validateForm: validateForm,
            validate: validate,
            refreshFieldsValues: refreshFieldsValues,
            disableField: disableField,
            validateShowRequestFields: validateShowRequestFields,
            setWarchers: setWarchers,
            getVacants: getVacants,
            generalFunctions: generalFunctions,
            watchFunctions: watchFunctions
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.seleccion_candidate')
        .service('ValidationFactory', ValidationFactory);

    function ValidationFactory() {

        function getFieldsConditionNivelEducativo(nivels_educativo_id, estado_estudio) {

            //          {id: 7, name: "Bachiller"}
            //          {id: 4, name: "Técnico"}
            //          {id: 13, name: "Tecnológico"}
            //          {id: 11, name: "Pregrado"}
            //          {id: 1, name: "Especialización"}
            //          {id: 2, name: "Maestría"}
            //          {id: 18, name: "Doctorado"}

            //          1: "En curso"
            //          2: "Suspendido"
            //          3: "Aplazado"
            //          4: "Terminado"

            var fields = [
                'nivels_educativo_id',
                'profesion_id',
                'instituto_id',
                'ciudad_id',
                'estado_estudio',
                'adjuntos_academica',
                'tiene_tarjeta_profesional',
                //'numero_tarjeta_profesional',
                //'fecha_expedicion_tarjeta_profesional',
                'adjuntos_tarjetaprofesional',
                'anio_inicio',
                'semestre_inicio',
                'semestre_actual',
                'anio',
                'semestre_egreso',
                'anio_grado',
                'semestre_grado',
                'duracion_programa',
                'promedio_acumulado',
                'reconocimientos'
            ];
            var show = [];
            if (nivels_educativo_id == 7) {
                //BACHILLER
                if (estado_estudio == 4) {
                    //FINALIZADO
                    show = ['nivels_educativo_id', 'profesion_id', 'instituto_id', 'ciudad_id', 'estado_estudio', 'anio_inicio', 'anio', 'semestre_egreso', 'anio_grado', 'semestre_grado', 'promedio_acumulado', 'duracion_programa', 'adjuntos_academica'];
                } else {
                    show = ['nivels_educativo_id', 'profesion_id', 'instituto_id', 'ciudad_id', 'estado_estudio', 'anio_inicio', 'promedio_acumulado', 'duracion_programa', 'adjuntos_academica'];
                }
            } else {
                if (estado_estudio == 4) {
                    //FINALIZADO
                    show = ['nivels_educativo_id', 'profesion_id', 'instituto_id', 'ciudad_id', 'estado_estudio', 'anio_inicio', 'semestre_inicio', 'anio', 'semestre_egreso', 'anio_grado', 'semestre_grado', 'reconocimientos', 'promedio_acumulado', 'duracion_programa', 'adjuntos_academica', 'tiene_tarjeta_profesional'];
                } else if (estado_estudio == 1) {
                    //EN CURSO
                    show = ['nivels_educativo_id', 'profesion_id', 'instituto_id', 'ciudad_id', 'estado_estudio', 'anio_inicio', 'semestre_inicio', 'semestre_actual', 'reconocimientos', 'promedio_acumulado', 'duracion_programa', 'adjuntos_academica'];
                } else if (estado_estudio == 2 || estado_estudio == 3) {
                    //SUSPENDIDO O TERMINADO
                    show = ['nivels_educativo_id', 'profesion_id', 'instituto_id', 'ciudad_id', 'estado_estudio', 'anio_inicio', 'semestre_inicio', 'reconocimientos', 'promedio_acumulado', 'duracion_programa', 'adjuntos_academica'];
                }
            }
            if (show.length == 0) {
                show = ['nivels_educativo_id', 'profesion_id', 'instituto_id', 'ciudad_id', 'estado_estudio', 'anio_inicio', 'promedio_acumulado', 'duracion_programa', 'adjuntos_academica'];
            }

            var hide = removeInArray(fields, show);
            return { show: show, hide: hide };
        }

        function getFieldsConditionHijos() {
        }

        function removeInArray(root, item) {
            return root.filter(function (el) {
                return item.indexOf(el) == -1;
            });
        }

        function isAdult(date1,date2){
            var mayor = (date1 > date2) ? date1 : date2;
            var menor = (date1 > date2) ? date2 : date1;
            return mayor.diff(menor,'years') >= 18
        }

        return {
            estudioFormales: {
                getFieldsConditionNivelEducativo: getFieldsConditionNivelEducativo
            },
            personales:{
                isAdult: isAdult
            }

        }
    }
})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            // Auth
            'app.auth',

            //TOAST
            'app.toast',

            //RECAPTCHA
            'vcRecaptcha',
            
            // Candidate
            'app.seleccion_candidate',

            // Admin
            'app.seleccion_admin',

            // analyst
            'app.seleccion_analyst',

        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function () {
	'use strict';

	angular
		.module('app.auth')
		.filter('nl2br', nl2br)
		.filter('fecha', fecha)
		.filter('hora', hora)
		.filter('fechaMes', fechaMes)
		.filter('dateRangeFilter', dateRangeFilter)
		.filter('floor', floor)
		.filter('capitalize', capitalize)
		.filter('capitalizeFirstLetter', capitalizeFirstLetter)
		.filter('round', round)
		.filter('formatValue', formatValue)
		.filter('getSubarea', getSubarea)
		.filter('join', join)
		.filter('momentFormat',momentFormat);

	nl2br.$inject = ['$filter', '$sce'];

	/** @ngInject */
	function nl2br($filter, $sce) {
		return function (data) {
			if (!data)
				return data;
			var msg = data.replace(/\n\r?/g, '<br />');
			return $sce.trustAsHtml(msg);
		};
	}

	/** @ngInject */
	function fecha() {
		return function (date, format) {
			return date ? moment(date).format(format) : '';
		};
	}

	/** @ngInject */
	function hora() {
		return function (hora_time) {
			return moment(hora_time).format('h:mm a');
		};
	}

	/** @ngInject */
	function fechaMes() {
		return function (fecha_time) {
			return moment(fecha_time).format('MMM');
			//return string.charAt(0).toUpperCase() + string.slice(1);
		};
	}

	/** @ngInject */
	function dateRangeFilter() {
		return function (input, field, startDate, endDate) {
			var retArray = [];
			//console.log(input);
			angular.forEach(input, function (obj) {
				var myDate = new moment(obj[field].toString().substr(0, 10));
				var mayorFechaIni = (startDate != null ? myDate >= new moment(startDate) : true);
				var mayorFechaFin = (endDate != null ? myDate <= new moment(endDate) : true);
				if (mayorFechaIni && mayorFechaFin) {
					retArray.push(obj);
				}
			});

			return retArray;
		};
	}

	/** @ngInject */
	function floor() {
		return function (number) {
			return Math.ceil(number);
		};
	}

	/** @ngInject */
	function capitalize() {
		return function (input, all) {
			if (angular.isObject(input)) {
				return false;
			}
			var reg = (all) ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
			
			if(!input){
				return '';
			}
			if(angular.isNumber(input)){
				return '';
			}
			return (!!input)  ? input.replace(reg, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			}) : '';
		}
	}

	/** @ngInject */
	function capitalizeFirstLetter() {
		return function (input, all) {
			var reg = /([^A-zÀ-ú]?)([A-zÀ-ú]+)/g;
			var f = true;
			return (!!input) ? input.replace(reg, function (txt) {
				if (f) {
					var string = txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
					f = false;
				} else {
					var string = txt.charAt(0).toLowerCase() + txt.substr(1).toLowerCase();
				}

				return string;
			}) : '';
		}
	}

	/** @ngInject */
	function round() {
		return function (number) {
			return Math.round(number);
		};
	}

	/** @ngInject */
	function formatValue($filter) {
		return function (value, type, list, prueba, attach,field_extra,use_same_value) {
			if(use_same_value || field_extra){
				return value;
			}
			if (type == "date") {
				return (value ? moment(value).utc().format('MMMM D, YYYY') : '');
			} else if (type == "select") {
				if(field_extra){
					return field_extra;
				}
				return getSelectValue(value, list);
			} else if (type == "selectarray") {
				for (var i in list) {
					if (list[i].id == value) {
						return list[i].name;
					}
				}
			} else if (type == "autocomplete") {
				var textReturn = (list ? (list[value]) ? list[value] : (value) ? value : "" : value);
				return textReturn;
			} else if (type == "autocompletesearch") {
				var textReturn = (list ? (list[value]) ? list[value] : (value) ? value : "" : value);
				return textReturn;
			} else if(type == "autocompletedepend"){
				var textReturn = (list ? (list[value]) ? list[value] : (value) ? value : "" : value);
				return textReturn;
			} else if (type == "select_desc") {
				return (list && value ? list[value].label : "");
			} else if (type == "select_multiple") {
				var res = [];
				value.forEach(function (element) {
					if (list[element]) {
						res.push(list[element].name);
					}
				});
				return res.join(', ');
			} else if (type == "autocompletespecial") {
				var res = [];
				if (list && value && value.length) {
					value.forEach(function (element) {
						if (list[element]) {
							var code = (list[element].cod_empleado ? list[element].cod_empleado + " - " : "");
							var cargo = (list[element].cargo ? '<div>' + list[element].cargo + '</div>' : "");

							var val = '<div class="">' + code + list[element].name + '</div>' + cargo;
							res.push(val);
						}
					});
				}

				return (res.length > 1 ? '<ul><li>' + res.join('</li><li>') + '</li></ul>' : res.join(', '));
			} else if (type == "radio") {
				return (list ? list[value] : "");
			} else if (type == "checkbox" && !list) {
				return (value ? "Si" : "No");
			} else if (type == "checkboxmultiple" && list) {
				return getCheckboxList(value, list);
			} else if (type == "view") {
				return (list ? (value && list[value].label ? list[value].label : list[value]) : (value != "" ? value : ""));
			} else if (type == "currency") {
				return $filter('currency')((value ? value : 0), '' , 2);
			} else if (type == "textarea") {
				return value;

			} else if (type == "autocompletechip") {
				var res = [];
				if (list && value && value.length) {
					value.forEach(function (element) {
						if (list[element]) {
							res.push(list[element]);
						}
					});
					return res.join(', ');
				}

				return "";
				
			} else if (type == "text") {
        return (value == null) ? value : value.toString()

			} else {
				if (validateEmail(value) || !isNaN(value)) {
					return value;
				}
				return cap(value, false);
			}
		}
	}

	function getSubarea(){
		console.log("HOLAAAAAA");
		return 'HOLA';
	}

	function join() {
		return function (input, join) {
			if (input.length) {
				return input.join(join);
			}
		};
	}

	function validateEmail(mail) {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
			return (true)
		}
		return (false)
	}

	function cap(input, all) {
		if (!input || typeof all !== 'string') {
			return input;
		}
		var reg = (all) ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
		return (!!input) ? input.replace(reg, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }) : '';
	}

	function getCheckboxList(value, list) {
		var items = [];
		if (value) {
			for (var index = 0; index < value.length; index++) {
				var element = value[index];
				if (list[element]) {
					items.push(list[element]);
				}
			}
		}

		return items.join(", ");
	}

  function getSelectValue(value, list){
    if(!list){
      return ""
    }

    if(list[0] instanceof Object){
      for (var i=0; i < list.length; i++) {
        if (list[i].id == value) {
            return list[i].name;
        }
      }
    }

    return list[value] ? list[value] : '';
  }

	function momentFormat() {
		return function (input,format) {
			return moment(input).format(format);
		};
	}

})();
(function () {
	'use strict';

	angular.module('app.auth').factory('IkanoFactory', IkanoFactory);
	angular.module('app.auth').factory('$debounce', debounce);
	angular.module('app.auth').factory('ListFilter', ListFilter);
	angular.module('app.auth').factory('IkanoFactoryPagination', IkanoFactoryPagination);

	/** @ngInject */
	function IkanoFactory(api, $http, $mdDialog, $rootScope, $state, msNavigationService, FileSaver, $mdToast) {
		$rootScope.urlImages = api.urlBackEnd + "/img/";

		/** GENERAL */
		function getUrlHost() {
			return api.urlBackEnd;
		}

		function showErrors(error_response) {
			var error_msj = '';

			angular.forEach(error_response.data.data, function (info) {
				error_msj += info + ". \n ";//TODO
			});

			$mdDialog.show(
				$mdDialog.alert()
					.parent(angular.element(document.querySelector('#popupContainer')))
					.clickOutsideToClose(true)
					.parent(angular.element(document.body))
					.title(error_response.data.message)
					.textContent(error_msj)
					.ok('Aceptar')
			);
		}

		function showAlert(title, msj) {
			$mdDialog.show(
				$mdDialog.alert()
					.parent(angular.element(document.querySelector('#popupContainer')))
					.clickOutsideToClose(true)
					.parent(angular.element(document.body))
					.title(title)
					.textContent(msj)
					.ok('Aceptar')
			);
		}

		function showAlertFunction(title, msj, callback) {
			$mdDialog.show(
				$mdDialog.alert()
					.parent(angular.element(document.querySelector('#popupContainer')))
					.clickOutsideToClose(true)
					.parent(angular.element(document.body))
					.title(title)
					.textContent(msj)
					.ok('Aceptar')
			)
				.finally(function () {
					callback();
				});
		}

		function showConfirmAlert(ev, title, message, id, confir, dismiss) {
			var confirm = $mdDialog.confirm()
				.title(title)
				.htmlContent(message)
				.clickOutsideToClose(true)
				.parent(angular.element(document.body))
				.ariaLabel('Lucky day')
				.targetEvent(ev)
				.ok('Aceptar')
				.cancel('Cancelar');

			$mdDialog.show(confirm).then(function () {
				confir(id);
			}, function () {
				if (dismiss) {
					dismiss();
				}
			});
		}

		function showFormErrors(errors) {
			var msg = "";
			var err = convertObjToArrayObjects(errors);
			for (var index = 0; index < err.length; index++) {
				var element = err[index];
				if (element.name[0] == "min_caracteres") {
					msg = msg + " El campo " + element.id + " debe contener al menos 3 caracteres";
				} else if (element.name[0] == "password_secure") {
					msg = msg + " El campo " + element.id + " debe contener al menos una letra mayuscula, un simbolo ($%), un número y al menos 6 caracteres";
				} else if (element.name[0] == "equal_to") {
					msg = msg + " El campo " + element.id + " debe ser idéntico al anterior";
				}
			}

			showAlert("Error", msg);
		}

		function getFormErrors(errors) {
			var msg = {};
			var err = convertObjToArrayObjects(errors);
			for (var index = 0; index < err.length; index++) {
				var element = err[index];
				msg[element.id] = getMessage(element.name);
			}

			return msg;
		}

		function showToast(data, options) {
			options = (options) ? options : [];
			$mdToast.show({
				hideDelay: 7000,
				position: 'top right',
				controller: 'ToastCrl',
				controllerAs: 'vm',
				templateUrl: 'app/toast/template/toast.default.html',
				locals: {
					options: options,
					config: data,
				},
				toastClass: data.class
			});
		}

		function getMessage(type) {
			var message = "Valor inválido";

			if (type == "min_caracteres") {
				message = "Este campo debe contener al menos 3 caracteres";
			} else if (type == "password_secure") {
				message = "Este campo debe contener al menos una letra mayuscula, un simbolo ($%), un número y al menos 6 caracteres";
			} else if (type == "equal_to") {
				message = "El valor de este campo debe ser igual al valor del campo anterior";
			} else if (type == "different_to") {
				message = "El valor de este campo debe ser diferente al valor del campo anterior";
			} else if (type == "required") {
				message = "Este campo es obligatorio";
			} else if (type == "only_letters") {
				message = "Este campo sólo debe contener letras";
			} else if (type == "date") {
				message = "Este campo debe contener una fecha valida";
			} else if (type == "email") {
				message = "Este campo debe contener una dirección de correo electrónica valida";
			}

			return message
		}

		function capitalize(input, all) {
			var reg = (all) ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
			return (!!input) ? input.replace(reg, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }) : '';
		}

		function validateEmail(email) {
			if (!email) {
				return true;
			} else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
				return true;
			}

			return false;
		}

		function createMenu() {
			// Navigation
			var menu = JSON.parse(localStorage.getItem('MENU_SELECTION'));

			angular.forEach(menu, function (data_menu) {
				msNavigationService.saveItem(data_menu.name, {
					title: capitalize(data_menu.label, true),
					icon: data_menu.icon,
					weight: 4
				});

				angular.forEach(data_menu.childrens, function (data_menu_children) {
					msNavigationService.saveItem(data_menu.name + '.' + data_menu_children.name, {
						title: capitalize(data_menu_children.label, false),
						state: 'app.' + data_menu_children.url,
						icon: data_menu_children.icon,
						weight: 3
					});
				});
			});
		}

		function createMenuForAdmin() {
			// Navigation
			var menu = JSON.parse(localStorage.getItem('MENU_SELECTION'));

			angular.forEach(menu, function (data_menu) {
				msNavigationService.saveItem(data_menu.name, {
					title: data_menu.label,
					group: true,
					icon: "",
					weight: 2
				});

				angular.forEach(data_menu.childrens, function (data_menu_children) {
					msNavigationService.saveItem(data_menu.name + '.' + data_menu_children.name, {
						title: data_menu_children.label,
						state: 'app.' + data_menu_children.url,
						icon: data_menu_children.icon,
						weight: 3,
						stateParams: { filter: data_menu_children.url },
						badge: (data_menu_children.badge ? { content: data_menu_children.badge, color: 'orange' } : ""),
					});
				});
			});
		}

		function offerStatusBarColor(status) {
			if (status == 'Proceso' || status == 'En Proceso' || status == 'Aplicar a esta oferta') {
				return 'bt-green green-500-bg';
			} else if (status == 'Finalizada' || status == 'Finalizado') {
				return 'bt-red red-500-bg';
			} else {
				return 'bt-green green-500-bg';
			}
		}

		function offerStatusColor(status) {
			if (status == 'Aplicar a esta oferta') {
				return 'grey-300-bg grey-600-fg';
			} else if (status == 'Proceso' || status == 'En Proceso') {
				return 'green-500-bg white-fg';
			} else if (status == 'Finalizada' || status == 'Finalizado') {
				return 'red-500-bg white-fg';
			} else {
				return 'green-500-bg white-fg';
			}
		}

		function getThemeData() {
			var theme = {
				principalLogo: '/assets/images/logos/logo.png',
				loginLogo: '/assets/images/logos/login-logo.png',
				loginBackground: {
					"background": "url('/assets/images/backgrounds/login.jpg') no-repeat",
					"background-size": "cover",
				}
			};

			var domain = localStorage.getItem('DOMAIN_SELECTION');

			if (domain) {
				theme = {
					principalLogo: '/assets/licenses/' + domain + '/images/logos/logo.png',
					loginLogo: '/assets/licenses/' + domain + '/images/logos/login-logo.png',
					loginBackground: {
						"background": "url('/assets/licenses/" + domain + "/images/backgrounds/login.jpg') no-repeat",
						"background-size": "cover",
					},
					media: {
						shared: '/assets/licenses/' + domain + '/images/media/shared-social.png'
					}
				};

				setThemeColors(domain);
			}

			return theme;
		}

		function setThemeColors(domain) {
			localStorage.removeItem('THEME_SELECTION');

			var themes = {
				tecnoquimicas: {
					primary: {
						name: 'primaryTecnoquimicas',
						palette: {
							'50': 'E0E8F4',
							'100': 'B3C5E4',
							'200': '809ED3',
							'300': '4D77C1',
							'400': '265AB3',
							'500': '003DA6',
							'600': '00379E',
							'700': '002F95',
							'800': '00278B',
							'900': '001A7B',
							'A100': 'A8B4FF',
							'A200': '7587FF',
							'A400': '425BFF',
							'A700': '2945FF',
							'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
							// on this palette should be dark or light

							'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined    // could also specify this if default was 'dark'
						}
					},
					accent: {
						name: 'accentTecnoquimicas',
						palette: {
							'50': 'E0F3FC',
							'100': 'B3E2F7',
							'200': '80CFF1',
							'300': '4DBCEB',
							'400': '26ADE7',
							'500': '009fe3',
							'600': '0097E0',
							'700': '008DDC',
							'800': '0083D8',
							'900': '0072D0',
							'A100': 'F8FCFF',
							'A200': '009fe3',
							'A400': '92C8FF',
							'A700': '009fe3',
							'contrastDefaultColor': 'light',
							'contrastDarkColors': ['50', '100',
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined
						}
					},
					warn: {
						name: 'warnTecnoquimicas',
						palette: {
							'50': 'FEF1E0',
							'100': 'FBDCB3',
							'200': 'F9C580',
							'300': 'F7AE4D',
							'400': 'F59C26',
							'500': 'F38B00',
							'600': 'F18300',
							'700': 'EF7800',
							'800': 'ED6E00',
							'900': 'EA5B00',
							'A100': 'FFFFFF',
							'A200': 'FFE9DE',
							'A400': 'FFC6AB',
							'A700': 'FFB591',
							'contrastDefaultColor': 'light',
							'contrastDarkColors': ['50', '100',
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined
						}
					}
				},
				colombina: {
					primary: {
						name: 'primaryTecnoquimicas',
						palette: {
							'50': '0F238C',
							'100': '0F238C',
							'200': '0F238C',
							'300': '0F238C',
							'400': '0F238C',
							'500': '0F238C',
							'600': '0F238C',
							'700': '0F238C',
							'800': '0F238C',
							'900': '0F238C',
							'A100': '0F238C',
							'A200': '0F238C',
							'A400': '0F238C',
							'A700': '0F238C',
							'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
							// on this palette should be dark or light

							'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined    // could also specify this if default was 'dark'
						}
					},
					accent: {
						name: 'accentTecnoquimicas',
						palette: {
							'50': '5DA9E9',
							'100': '5DA9E9',
							'200': '5DA9E9',
							'300': '5DA9E9',
							'400': '5DA9E9',
							'500': '5DA9E9',
							'600': '5DA9E9',
							'700': '5DA9E9',
							'800': '5DA9E9',
							'900': '5DA9E9',
							'A100': '5DA9E9',
							'A200': '5DA9E9',
							'A400': '5DA9E9',
							'A700': '5DA9E9',
							'contrastDefaultColor': 'light',
							'contrastDarkColors': ['50', '100',
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined
						}
					},
					warn: {
						name: 'warnTecnoquimicas',
						palette: {
							'50': 'F9A344',
							'100': 'F9A344',
							'200': 'F9A344',
							'300': 'F9A344',
							'400': 'F9A344',
							'500': 'F9A344',
							'600': 'F9A344',
							'700': 'F9A344',
							'800': 'F9A344',
							'900': 'F9A344',
							'A100': 'F9A344',
							'A200': 'F9A344',
							'A400': 'F9A344',
							'A700': 'F9A344',
							'contrastDefaultColor': 'light',
							'contrastDarkColors': ['50', '100',
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined
						}
					}
				},
				riopaila: {
					primary: {
						name: 'primaryRiopaila',
						palette: {
							'50': '414141',
							'100': '414141',
							'200': '414141',
							'300': '414141',
							'400': '414141',
							'500': '414141',
							'600': '414141',
							'700': '414141',
							'800': '414141',
							'900': '414141',
							'A100': '414141',
							'A200': '414141',
							'A400': '414141',
							'A700': '414141',
							'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
							// on this palette should be dark or light

							'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined    // could also specify this if default was 'dark'
						}
					},
					accent: {
						name: 'accentRiopaila',
						palette: {
							'50': 'EF4240',
							'100': 'EF4240',
							'200': 'EF4240',
							'300': 'EF4240',
							'400': 'EF4240',
							'500': 'EF4240',
							'600': 'EF4240',
							'700': 'EF4240',
							'800': 'EF4240',
							'900': 'EF4240',
							'A100': 'EF4240',
							'A200': 'EF4240',
							'A400': 'EF4240',
							'A700': 'EF4240',
							'contrastDefaultColor': 'light',
							'contrastDarkColors': ['50', '100',
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined
						}
					},
					warn: {
						name: 'warnRiopaila',
						palette: {
							'50': 'F4845F',
							'100': 'F4845F',
							'200': 'F4845F',
							'300': 'F4845F',
							'400': 'F4845F',
							'500': 'F4845F',
							'600': 'F4845F',
							'700': 'F4845F',
							'800': 'F4845F',
							'900': 'F4845F',
							'A100': 'F4845F',
							'A200': 'F4845F',
							'A400': 'F4845F',
							'A700': 'F4845F',
							'contrastDefaultColor': 'light',
							'contrastDarkColors': ['50', '100',
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined
						}
					}
				},
				demoikanosmart: {
					primary: {
						name: 'primaryDemoikanosmart',
						palette: {
							'50': 'E0E8F4',
							'100': 'B3C5E4',
							'200': '809ED3',
							'300': '4D77C1',
							'400': '265AB3',
							'500': '003DA6',
							'600': '00379E',
							'700': '002F95',
							'800': '00278B',
							'900': '001A7B',
							'A100': 'A8B4FF',
							'A200': '7587FF',
							'A400': '425BFF',
							'A700': '2945FF',
							'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
							// on this palette should be dark or light

							'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined    // could also specify this if default was 'dark'
						}
					},
					accent: {
						name: 'accentDemoikanosmart',
						palette: {
							'50': 'E0F3FC',
							'100': 'B3E2F7',
							'200': '80CFF1',
							'300': '4DBCEB',
							'400': '26ADE7',
							'500': '009fe3',
							'600': '0097E0',
							'700': '008DDC',
							'800': '0083D8',
							'900': '0072D0',
							'A100': 'F8FCFF',
							'A200': '009fe3',
							'A400': '92C8FF',
							'A700': '009fe3',
							'contrastDefaultColor': 'light',
							'contrastDarkColors': ['50', '100',
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined
						}
					},
					warn: {
						name: 'warnDemoikanosmart',
						palette: {
							'50': 'FEF1E0',
							'100': 'FBDCB3',
							'200': 'F9C580',
							'300': 'F7AE4D',
							'400': 'F59C26',
							'500': 'F38B00',
							'600': 'F18300',
							'700': 'EF7800',
							'800': 'ED6E00',
							'900': 'EA5B00',
							'A100': 'FFFFFF',
							'A200': 'FFE9DE',
							'A400': 'FFC6AB',
							'A700': 'FFB591',
							'contrastDefaultColor': 'light',
							'contrastDarkColors': ['50', '100',
								'200', '300', '400', 'A100'],
							'contrastLightColors': undefined
						}
					}
				},
			};

			if (themes[domain]) {
				localStorage.setItem('THEME_SELECTION', JSON.stringify(themes[domain]));
			}
		}

		function createOffer(offer, listas) {
			var areas = { ids: [], areas: [] };
			if (offer.procesos_areas && offer.procesos_areas.length) {
				for (var index = 0; index < offer.procesos_areas.length; index++) {
					var element = offer.procesos_areas[index];
					areas.ids.push(element.area.id);
					areas.areas.push(element.area.name);
				}
			}

			areas.areas = areas.areas.join(', ');

			return {
				id: offer.id,
				name: offer.cargo_ocupar,
				city: offer.ciudad.name,
				salary: (offer.rangos_salario ? offer.rangos_salario.name : (offer.salario_oferta_id && listas) ? getDataList(listas, offer.salario_oferta_id, 'id', 'name') : 'Salario confidencial'),
				area: areas,
				date: offer.fecha_inicial,
				vacants: offer.no_vacantes,
				appliedDate: offer.fecha_aplicacion,
				appliedDays: offer.dias_desde_aplicacion,
				details: {
					description: {
						title: offer.campos.descripcion_cargo.label,
						text: offer.campos.descripcion_cargo.value,
					},
					requeriments: {
						title: offer.campos.requirements.label,
						text: offer.campos.requirements.value,
					}
				},
			};
		}

		function getDataList(lista, data, key, value) {
			var lists = lista.filter(function (element) {
				return element[key] == data;
			});
			if (lists.length) {
				return lists[0][value];
			} else {
				return false
			}

		}

		function createMessages(data) {
			var messages = [];
			if (data.cargo_seleccionado) {
				messages.push({
					message: '<strong>Felicitaciones, fuiste seleccionado para el cargo ' + data.cargo_seleccionado + '.</strong> Por favor <a href="/resume" class="green-900-fg"><strong>Ingresa aquí</strong></a> para completar la información de tu hoja de vida y los requisitos del proceso de contratación',
					background_color: 'green-100-bg', text_color: 'green-900-fg', icon: 'icon-briefcase-checked'
				});
			}

			// if (data.nuevas_ofertas_ultima_visita) {
			// 	var mes = data.nuevas_ofertas_ultima_visita + (data.nuevas_ofertas_ultima_visita > 1 ? ' ofertas laborales nuevas publicadas ' : ' oferta laboral nueva publicada ');
			// 	messages.push({
			// 		message: '<strong>Hay ' + mes + '</strong> desde la última vez que ingresaste al portal <span ng-click="vm.goToOffersAVailables()" class="orange-200-bg font-weight-200 white-fg cursor-pointer text-boxed m-0"><strong>Haz clic para verlas</strong></span>',
			// 		background_color: 'orange-100-bg', text_color: 'orange-900-fg', icon: 'icon-briefcase-checked'
			// 	});
			// }

			if (data.porcentaje_hv < 100) {
				messages.push({
					message: '<strong>Tu hoja de vida aún no se encuentra completamente diligenciada.</strong> En este momento no puedes aplicar a ofertas laborales ni podrás ser tenido en cuenta para posibles vacantes. Por favor completa la información de tu <a href="/resume" class="red-900-fg"><strong>hoja de vida</strong></a>',
					background_color: 'red-100-bg', text_color: 'red-900-fg', icon: 'icon-alert'
				});
			}

			if (data.resumePercent < 100) {
				messages.push({
					message: '<strong>Tu hoja de vida aún no se encuentra completamente diligenciada.</strong> En este momento no puedes aplicar a ofertas laborales ni podrás ser tenido en cuenta para posibles vacantes. Por favor completa la información de tu <span class="red-900-fg"><strong>hoja de vida</strong></span>',
					background_color: 'red-100-bg', text_color: 'red-900-fg', icon: 'icon-alert'
				});
			}

			return messages;
		}

		function convertObjToArrayObjects(obj) {
			if (obj instanceof Array) {
				return obj;
			}

			var array = $.map(obj, function (value, index) {
				return [{ id: index, name: value }];
			});

			return array;
		}

    function filterObjectSelectByState(obj_select, value) {

      if (!(obj_select instanceof Array)) {
				return obj_select;
			}

      for (var i = obj_select.length - 1; i >= 0; i--) {
        if(obj_select[i].id == value || !obj_select[i].hasOwnProperty('estado')) continue;

        if ((!obj_select[i].estado || obj_select[i].estado + "" ==  '0')) {
          obj_select.splice(i, 1);
        }
      }

			return obj_select;
		}

		function convertRequestTypesObjToArrayObjects(obj) {
			var array = $.map(obj, function (value, index) {
				return [{ id: index, name: value.label, description: value.desc }];
			});

			return array;
		}

		function getDiffBetweenTwoDates(date1, date2) {
			date1 = (date1 ? new Date(date1) : new Date());
			date2 = (date2 ? new Date(date2) : new Date());


			var b = moment(date1);
			var a = moment(date2);

			var years = a.diff(b, 'year');
			b.add(years, 'years');

			var months = a.diff(b, 'months');
			b.add(months, 'months');

			var days = a.diff(b, 'days');

			var time = "";

			if (!isNaN(years)) {
				if (years >= 1) {
					time += years + (years > 1 || years == 0 ? ' años y ' : ' año y ');
				}

				time += months + (months > 1 || months == 0 ? ' meses' : ' mes');

				if (years == 0) {
					time += ' y '
					time += days + (days > 1 || days == 0 ? ' días' : ' día');
				}

				//time = years + (years > 1 || years == 0 ? ' años y ' : ' año y ') + months + (months > 1 || months == 0 ? ' meses' : ' mes');
			}

			return time;
		}

		function downloadExcel(data) {
			var blob = new Blob([data], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			FileSaver.saveAs(blob, 'reporte' + '.xls');
		}

		function downloadFile(data, name) {
			var blob = new Blob([data]);
			FileSaver.saveAs(blob, name);
		}

		function downloadPhoto(data) {
			var a = document.createElement("a");
			a.href = data.url;
			a.target = "_black"
			a.click();
		}

		function getOrdinalNumber(num) {
			var numbers = [];
			numbers[1] = "Primer";
			numbers[2] = "Segundo";
			numbers[3] = "Tercero";
			numbers[4] = "Cuarto";
			numbers[5] = "Quinto";
			numbers[6] = "Sexto";
			numbers[7] = "Séptimo";
			numbers[8] = "Octavo";
			numbers[9] = "Noveno";
			numbers[10] = "Decimo";
			numbers[11] = "Decimo primer";
			numbers[12] = "Decimo segundo";
			numbers[13] = "Decimo tercer";
			numbers[14] = "Decimo cuarto";
			numbers[15] = "Decimo quinto";
			numbers[16] = "Decimo sexto";
			numbers[17] = "Decimo séptimo";
			numbers[18] = "Decimo octavo";
			numbers[19] = "Decimo noveno";
			numbers[20] = "Vigésimo";
			numbers[21] = "Vigésimo primer";
			numbers[22] = "Vigésimo segundo";
			numbers[23] = "Vigésimo tercer";
			numbers[24] = "Vigésimo cuarto";
			numbers[25] = "Vigésimo quinto";
			numbers[26] = "Vigésimo sexto";
			numbers[27] = "Vigésimo séptimo";
			numbers[28] = "Vigésimo octavo";
			numbers[29] = "Vigésimo noveno";
			numbers[30] = "Trigésimo";

			return numbers[num];
		}

		function validateFields(fields, data) {
			var messages = {};

			for (var index = 0; index < fields.length; index++) {
				var element = fields[index];
				var field = element.field;
				var validations = element.validations;

				if (validations && validations.length) {
					for (var j = 0; j < validations.length; j++) {
						var validation = validations[j];
						if (!validateField(validation, data[field])) {
							messages[field] = getMessage(validation);
						}
					}
				}
			}

			return messages;
		}

		function validateFieldsWithObject(fields, data, permission, returnEdidJson) {
			var messages = {};
			data = angular.copy(data);
			delete (data[""]);
			$.map(fields, function (value, index) {
				var validations = (value ? value.validations : null);
				if (permission) {
					if (validations && validations.length && (value.permiso || value.permisos)) {
						for (var j = 0; j < validations.length; j++) {
							var validation = validations[j];

							if (!validateField(validation, data[index])) {
								messages[index] = getMessage(validation);
							}
						}
					}
				} else {
					if (validations && validations.length) {
						for (var j = 0; j < validations.length; j++) {
							var validation = validations[j];
							if (!validateField(validation, data[index])) {
								messages[index] = getMessage(validation);
							}
						}
					}
				}
				if (returnEdidJson) {
					data[index] = validateData(data[index], value);
				}

			});
			if (returnEdidJson) {
				return { messages: messages, data: data };
			} else {
				return messages;
			}

		}

		function validateData(data, structure) {
			if (structure.type == "date") {
				if (data != "") {
					data = moment(data).utc().format('YYYY-MM-DD');
				}
			}
			return data;
		}

		function getValueWithFields(fields, data) {
			var objReturn = {};
			$.map(fields, function (value, index) {
				objReturn[value] = data[value];
			});
			return objReturn;
		}

		function validateField(validation, value) {
			if (validation == "required") {
				if (value === null || value === "" || value == undefined) {
					return false;
				} else if (Array.isArray(value) && !value.length) {
					return false;
				}
			} else if (validation == "only_letters") {
				var regex = /\d/g;
				if (regex.test(value)) {
					return false;
				}
			}
			//			else if (validation == "date") {
			//				var date = moment(value);
			//				if (!date.isValid()) {
			//					return false;
			//				}
			//			} 
			else if (validation == "email") {
				if (!validateEmail(value)) {
					return false;
				}
			}

			return true;
		}

		function getLanguajeDataTable() {
			return {
				"sEmptyTable": "No se encontraron resultados",
				"sInfo": "Mostrando _START_ de _END_ hasta _TOTAL_ registros",
				"sInfoEmpty": "Mostrando 0 de 0 de 0 registros",
				"sInfoFiltered": "(Filtrado de _MAX_ registros totales)",
				"sInfoPostFix": "",
				"sInfoThousands": ",",
				"sLengthMenu": "Mostrar _MENU_ entradas",
				"sLoadingRecords": "Cargando...",
				"sProcessing": "Procesando...",
				"sSearch": "Buscar:",
				"sZeroRecords": "No se encontraron coincidencias",
				"oPaginate": {
					"sFirst": "Primera",
					"sLast": "Última",
					"sNext": "Siguiente",
					"sPrevious": "Anterior"
				},
				"oAria": {
					"sSortAscending": ": Activar para ordenar la columna ascendente",
					"sSortDescending": ": Activar para ordenar la columna descendente"
				}
			};
		}

		function getStatusColor(status) {
			if (status == 1) {
				return 'blue-bg';
			} else if (status == 2) {
				return 'green-bg';
			} else if (status == 3) {
				return 'grey-bg';
			}
		}

		function getIndicatorColor(status) {
			if (status == 1) {
				return 'grey-bg';
			} else if (status == 2) {
				return 'orange-bg';
			} else if (status == 3) {
				return 'green-bg';
			} else if (status == 4) {
				return 'red-bg';
			}
		}

    function displayCorrectApprover(approver){
      if(approver.ejecutor_id == null || approver.colaborador_id == approver.ejecutor_id){
        return approver.colaborador
      }

      return approver.ejecutor 
    }

		function getDateLocaleFormat(lang) {
			var locale = false;
			if (lang == "es") {
				locale = {
					'months': [
						'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
					],
					'shortMonths': [
						'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
					],
					'days': [
						'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'
					],
					'shortDays': [
						'Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'
					]
				};
			}

			return locale;
		}

		function setRequestTypes(types) {
			localStorage.setItem('REQUEST_TYPES_SELECTION', JSON.stringify(types));
		}

		function getRequestTypes() {
			return JSON.parse(localStorage.getItem('REQUEST_TYPES_SELECTION'));
		};

		function removeRequestTypes() {
			localStorage.removeItem('REQUEST_TYPES_SELECTION');
		};

		/*
         * 
         * @param {String to null} stringReplace 
         * @param {String} datePast 
         * @param {String to null} dateCompare 
         * @returns {Object} 
         * Si dateCompare es null toma la fecha actual
         */
		function betweenDatesToReplace(stringReplace, datePast, dateCompare) {
			var objReturn = {};
			objReturn.textSuggested = {};
			var dateCompare = (!dateCompare) ? moment() : moment(dateCompare);
			var datePast = moment(datePast);
			//YEARS
			var years = dateCompare.diff(datePast, 'years');
			objReturn.years = years;
			datePast.add(years, 'years');
			//MONTHS
			var months = dateCompare.diff(datePast, 'months');
			objReturn.months = months;
			datePast.add(months, 'months');
			//DAY
			var days = dateCompare.diff(datePast, 'days');
			objReturn.days = days;
			datePast.add(days, 'days');
			//HOURS
			var hours = dateCompare.diff(datePast, 'hours');
			objReturn.hours = hours;
			datePast.add(hours, 'hours');
			//MINUTES
			var minutes = dateCompare.diff(datePast, 'minutes');
			objReturn.minutes = minutes;
			datePast.add(minutes, 'minutes');
			//SECONDS
			var seconds = dateCompare.diff(datePast, 'seconds');
			objReturn.seconds = seconds;
			datePast.add(seconds, 'seconds');
			//MILLISECOND
			var milliseconds = dateCompare.diff(datePast, 'milliseconds');
			objReturn.milliseconds = milliseconds;

			if (years > 0) {
				objReturn.textSuggested.years = years + ((years > 1) ? ' años' : ' año');
			} else {
				objReturn.textSuggested.years = "";
			}
			if (months > 0) {
				objReturn.textSuggested.months = months + ((months > 1) ? ' meses' : ' mes');
			} else {
				objReturn.textSuggested.months = "";
			}
			if (days > 0) {
				objReturn.textSuggested.days = days + ((days > 1) ? ' días' : ' día');
			} else {
				objReturn.textSuggested.days = "";
			}
			if (hours > 0) {
				objReturn.textSuggested.hours = hours + ((hours > 1) ? ' horas' : ' hora');
			} else {
				objReturn.textSuggested.hours = "";
			}
			if (minutes > 0) {
				objReturn.textSuggested.minutes = minutes + ((minutes > 1) ? ' minutos' : ' minuto');
			} else {
				objReturn.textSuggested.minutes = "";
			}
			if (seconds > 0) {
				objReturn.textSuggested.seconds = seconds + ((seconds > 1) ? ' segundos' : ' segundo');
			} else {
				objReturn.textSuggested.seconds = "";
			}

			objReturn.isToday = (years == 0 && months == 0 && days == 0) ? true : false;


			objReturn.justNow = (years == 0 && months == 0 && days == 0 && minutes == 0) ? true : false;


			if (stringReplace) {
				stringReplace = stringReplace.replace(/%year%/g, years)
					.replace(/%months%/g, months)
					.replace(/%days%/g, days)
					.replace(/%hours%/g, hours)
					.replace(/%minutes%/g, minutes)
					.replace(/%seconds%/g, seconds)
					.replace(/%milliseconds%/g, milliseconds);
			}

			objReturn.stringReplace = stringReplace;

			return objReturn;
		}

		function setFilters(key) {
			//var page = $state.current.url.toString().slice(1);
			var page = 'filter_';
			page += key ? key : $state.current.name;
			// filtros
			setTimeout(function () {
				setValueFilter(page);
			}, 2000);

			setTimeout(function () {
				setValueFilter(page);
			}, 5000);
		}

		function setValueFilter(page) {
			var elem = document.querySelector('.dataTables_filter input[type="search"]');
			var fechas = document.querySelectorAll(".filtro_fechas input");

			if (fechas.length > 0 && fechas.length == 2) {
				fechas[0].addEventListener('blur', function (val) {
					var datatmp = JSON.parse(localStorage.getItem(page));
					datatmp = (datatmp == null ? {} : datatmp);
					datatmp['fi'] = val.target.value;
					localStorage.setItem(page, JSON.stringify(datatmp));
				});
				fechas[1].addEventListener('blur', function (val) {
					var datatmp = JSON.parse(localStorage.getItem(page));
					datatmp = (datatmp == null ? {} : datatmp);
					datatmp['ff'] = val.target.value;
					localStorage.setItem(page, JSON.stringify(datatmp));
				});
			} else if (fechas.length > 0 && fechas.length == 3) {
				fechas[0].addEventListener('blur', function (val) {
					var datatmp = JSON.parse(localStorage.getItem(page));
					datatmp = (datatmp == null ? {} : datatmp);
					datatmp['nr'] = val.target.value;
					localStorage.setItem(page, JSON.stringify(datatmp));
				});
				fechas[1].addEventListener('blur', function (val) {
					var datatmp = JSON.parse(localStorage.getItem(page));
					datatmp = (datatmp == null ? {} : datatmp);
					datatmp['fi'] = val.target.value;
					localStorage.setItem(page, JSON.stringify(datatmp));
				});
				fechas[2].addEventListener('blur', function (val) {
					var datatmp = JSON.parse(localStorage.getItem(page));
					datatmp = (datatmp == null ? {} : datatmp);
					datatmp['ff'] = val.target.value;
					localStorage.setItem(page, JSON.stringify(datatmp));
				});
			}

			if (elem != null) {
				elem.addEventListener('keyup', function (val) {
					var datatmp = JSON.parse(localStorage.getItem(page));
					datatmp = (datatmp == null ? {} : datatmp);
					datatmp['search'] = val.target.value;
					localStorage.setItem(page, JSON.stringify(datatmp));
				});
			}
			var dat = JSON.parse(localStorage.getItem(page));
			//angular.element(document).ready(function () { });
			if (!dat) {
				return;
			}
			if (fechas.length > 0 && fechas.length == 2) {
				angular.element(fechas[0]).val(dat['fi']).triggerHandler('input');
				angular.element(fechas[1]).val(dat['ff']).triggerHandler('input');
			} else if (fechas.length > 0 && fechas.length == 3) {

				angular.element(fechas[0]).val(dat['nr']).triggerHandler('input');
				angular.element(fechas[1]).val(dat['fi']).triggerHandler('input');
				angular.element(fechas[2]).val(dat['ff']).triggerHandler('input');
			}
			if (elem != null) {
				angular.element(elem).val(dat['search']).triggerHandler('input');
			}
		}

		function setValuefilterJson(key) {
			var page = 'filter_' + key;
			return JSON.parse(localStorage.getItem(page)) ? JSON.parse(localStorage.getItem(page)) : null;
		}

		function clearValueFilter(key) {
			var page = 'filter_' + key;
			localStorage.removeItem(page);
		}

		function saveValueFilterJson(key, value) {
			var page = 'filter_' + key;
			localStorage.setItem(page, JSON.stringify(value));
		}

		function getFieldsArray(arrField, rootField) {
			var objReturn = {};
			for (var i in arrField) {
				var field = arrField[i];
				if (rootField[field]) {
					objReturn[field] = angular.copy(rootField[field]);
				}
			}
			return objReturn;
		}

		function jsonToArray(data) {
			var arrReturn = [];
			if (!angular.equals(data, {}) && data instanceof Object) {
				angular.forEach(data, function (v, k) {
					k = parseInt(k);
					arrReturn.push({ id: k, name: v });
				});
				arrReturn.sort(function (a, b) {
					if (a.name < b.name) { return -1; }
					if (a.name > b.name) { return 1; }
					return 0;
				});
			}
			return arrReturn;
		}

		function getStructureForFields(campos, structure) {
			return campos.map(function (element) {
				if (typeof element == 'object' && element.field) {
					return element;
				}
				if (!structure[element].field) {
					structure[element].field = element;
				}
				return structure[element];
			});
		}

		function getStructureForFieldsHasMany(campos, structure, model) {
			return campos.map(function (element) {

				if (!structure[model][element].field) {
					structure[model][element].field = element;
				}
				return structure[model][element];
			});
		}

		function validJson(text) {
			try {
				JSON.parse(text);
			} catch (error) {
				return false;
			}
			return true;
		}

		function setPositionsId(obj, key) {
			var newObj = {};
			for (var i in obj) {
				if (obj[i][key]) {
					newObj[obj[i][key]] = obj[i];
				} else {
					newObj[obj[i]['id']] = obj[i];
				}
			}
			return newObj;
		}

		return {
			getUrlHost: getUrlHost,
			showErrors: showErrors,
			showAlert: showAlert,
			showAlertFunction: showAlertFunction,
			showFormErrors: showFormErrors,
			getFormErrors: getFormErrors,
			getMessage: getMessage,
			showToast: showToast,
			capitalize: capitalize,
			createMenu: createMenu,
			createMenuForAdmin: createMenuForAdmin,
			offerStatusBarColor: offerStatusBarColor,
			offerStatusColor: offerStatusColor,
			getThemeData: getThemeData,
			createOffer: createOffer,
			createMessages: createMessages,
			convertObjToArrayObjects: convertObjToArrayObjects,
			filterObjectSelectByState: filterObjectSelectByState,
			convertRequestTypesObjToArrayObjects: convertRequestTypesObjToArrayObjects,
			getDiffBetweenTwoDates: getDiffBetweenTwoDates,
			downloadExcel: downloadExcel,
			downloadFile: downloadFile,
			downloadPhoto: downloadPhoto,
			getOrdinalNumber: getOrdinalNumber,
			validateFields: validateFields,
			validateFieldsWithObject: validateFieldsWithObject,
			getFieldsArray: getFieldsArray,
			getLanguajeDataTable: getLanguajeDataTable,
			getStatusColor: getStatusColor,
			showConfirmAlert: showConfirmAlert,
			getIndicatorColor: getIndicatorColor,
			displayCorrectApprover: displayCorrectApprover,
			getDateLocaleFormat: getDateLocaleFormat,
			setRequestTypes: setRequestTypes,
			getRequestTypes: getRequestTypes,
			removeRequestTypes: removeRequestTypes,
			betweenDatesToReplace: betweenDatesToReplace,
			validateEmail: validateEmail,
			setFilters: setFilters,
			saveValueFilterJson: saveValueFilterJson,
			setValuefilterJson: setValuefilterJson,
			clearValueFilter: clearValueFilter,
			getValueWithFields: getValueWithFields,
			jsonToArray: jsonToArray,
			getStructureForFields: getStructureForFields,
			getStructureForFieldsHasMany: getStructureForFieldsHasMany,
			setPositionsId: setPositionsId
		};
	}

	function ListFilter() {

		var vm = this;

		function setLists(lists) {
			vm.lists = angular.copy(lists);
		}

		function getDataList(list, data, searchOfValue) {
			var dataReturn = [];
			for (var i in data) {
				if (searchOfValue) {
					for (var item in vm.lists[list]) {
						if (vm.lists[list][item] == data[i]) {
							dataReturn.push(vm.lists[list][item]);
							break;
						}
					}
				} else {
					dataReturn.push(vm.lists[list][data[i]]);
				}

			}
			return dataReturn;
		}

		function getDataComplete(list, data, filter) {
			if (!list.length) {
				if (vm.list[filter]) {
					list = vm.list[filter];
				}
			}
			var dataReturn = [];
			for (var i in data) {
				for (var item in list) {
					if (list[item].id == data[i] || list[item].name == data[i]) {
						dataReturn.push(list[item].name);
						break;
					}
				}
			}
			return dataReturn;
		}

		function getDataListJson(list, data, keyValidate, keyInfo) {
			var dataReturn = [];
			var lista = vm.lists[list];
			for (var i in data) {
				for (var l in lista) {
					if (data[i] == lista[l][keyValidate]) {
						dataReturn.push(lista[l][keyInfo]);
						break;
					}
				}
			}
			return dataReturn;
		}

		function getDataOneList(list, data, keyInfo) {
			if (keyInfo) {
				return vm.lists[list][data][keyInfo];
			} else {
				return vm.lists[list][data];
			}
		}

		function deleteFilter(filter, indexFilter, indexChild, filters, modalFilterData) {

			if (typeof indexChild != "undefined") {
				filters[indexFilter].value.splice(indexChild, 1);
				filters[indexFilter].valuesShow.splice(indexChild, 1);
				//SE ELIMINA DE LA DATA QUE VA PARA EL MODAL
				if (modalFilterData) {
					modalFilterData[filters[indexFilter].key].splice(indexChild, 1);
				}

				if (filters[indexFilter].value.length == 0) {
					filters.splice(indexFilter, 1);
				}

			} else {
				//SE ELIMINA DE LA DATA QUE VA AL MODAL
				if (filters[indexFilter].key == "hayan_participado_cualquier" || filters[indexFilter].key == "hayan_participado_proceso") {
					if (modalFilterData) {
						delete (modalFilterData.candidate_process);
					}

				} else {
					if (modalFilterData) {
						delete (modalFilterData[filters[indexFilter].key]);
					}
				}

				filters.splice(indexFilter, 1);
			}
		}

		function setFilter(filter, origin) {

			var returnArr = [];
			var filters = [];
			var filterLocalStorage = [];

			if (origin == 1) {
				filterLocalStorage = JSON.parse(localStorage.getItem('filterSearchHv'));
			} else {
				filterLocalStorage = JSON.parse(localStorage.getItem('filterSearchCandidate'));
			}

			for (var i in filterLocalStorage) {
				filters = filters.concat(filterLocalStorage[i]);
			}

			returnArr = filters.map(function (element, index) {
				if (filter[element.id]) {
					if (element.type == "TEXT") {
						var data = {
							order: index,
							label: element.name,
							key: element.id,
							value: filter[element.id],
							valuesShow: filter[element.id],
							notArray: true
						};
						return data;
					} else if (element.type == "SELECT" || element.type == "RADIO") {
						var value = [];
						if (!element.options.length) {
							if (vm.list[element.id]) {
								value = vm.list[element.id].filter(function (eln) {
									return eln.id == filter[element.id];
								});
							}
						} else {
							value = element.options.filter(function (eln) {
								return eln.id == filter[element.id];
							});
						}


						var data = {
							order: index,
							label: element.name,
							key: element.id,
							value: filter[element.id],
							notArray: true,
							valuesShow: ((element.type == "RADIO") ? element.name + ': ' : '') + value[0].name
						};
						return data;
					} else if (element.type == "AUTOCOMPLETE") {
						var value = getDataComplete(element.options, filter[element.id], element.id);
						var data = {
							order: index,
							label: element.name,
							key: element.id,
							value: filter[element.id],
							valuesShow: value
						};
						return data;
					}
				}

			});
			return returnArr.filter(function (element) {
				return element != undefined;
			});
		}

		function setList(filter, list) {
			if (!vm.list) {
				vm.list = {};
			}
			if (!vm.list[filter]) {
				vm.list[filter] = [];
			}
			vm.list[filter] = vm.list[filter].concat(list);
		}

		return {
			setLists: setLists,
			setList: setList,
			getDataList: getDataList,
			deleteFilter: deleteFilter,
			setFilter: setFilter,

		}
	}

	function debounce($rootScope, $browser, $q, $exceptionHandler) {
		var deferreds = {},
			methods = {},
			uuid = 0;

		function fnDebounce(fn, delay, invokeApply) {
			var deferred = $q.defer(),
				promise = deferred.promise,
				skipApply = (angular.isDefined(invokeApply) && !invokeApply),
				timeoutId, cleanup,
				methodId, bouncing = false;

			// check we dont have this method already registered
			angular.forEach(methods, function (value, key) {
				if (angular.equals(methods[key].fn, fn)) {
					bouncing = true;
					methodId = key;
				}
			});

			// not bouncing, then register new instance
			if (!bouncing) {
				methodId = uuid++;
				methods[methodId] = { fn: fn };
			} else {
				// clear the old timeout
				deferreds[methods[methodId].timeoutId].reject('bounced');
				$browser.defer.cancel(methods[methodId].timeoutId);
			}
			var debounced = function () {
				// actually executing? clean method bank
				delete methods[methodId];

				try {
					deferred.resolve(fn());
				} catch (e) {
					deferred.reject(e);
					$exceptionHandler(e);
				}

				if (!skipApply) $rootScope.$apply();
			};
			timeoutId = $browser.defer(debounced, delay);
			// track id with method
			methods[methodId].timeoutId = timeoutId;
			cleanup = function (reason) {
				delete deferreds[promise.$$timeoutId];
			};
			promise.$$timeoutId = timeoutId;
			deferreds[timeoutId] = deferred;
			promise.then(cleanup, cleanup);
			return promise;
		}
		// similar to angular's $timeout cancel
		fnDebounce.cancel = function (promise) {
			if (promise && promise.$$timeoutId in deferreds) {
				deferreds[promise.$$timeoutId].reject('canceled');
				return $browser.defer.cancel(promise.$$timeoutId);
			}
			return false;
		};

		return fnDebounce;
	};

	function IkanoFactoryPagination($state) {

		function setKey(key) {
			this.key = 'filter_' + key + 'Data';
			if (!this.data) {
				this.data = {};
			}
		}

		function setDataPage(page, data) {
			if (this.data[this.key]) {
				this.data[this.key][page] = data;
			} else {
				this.data[this.key] = {};
				this.data[this.key][page] = data;
			}
			localStorage.setItem(this.key, JSON.stringify(this.data[this.key]));
		}

		function getDataPage(page) {
			var localstorage = localStorage.getItem(this.key);
			if (this.data[this.key]) {
				return this.data[this.key][page];
			} else if (localstorage) {
				var localstorageJson = JSON.parse(localstorage);
				return localstorageJson[page];
			}

			return null;
		}

		function clear() {
			delete (this.data[this.key]);
			localStorage.removeItem(this.key);
		}

		function clearAll() {
			this.data = {};
		}



		return {
			setKey: setKey,
			setDataPage: setDataPage,
			getDataPage: getDataPage,
			clear: clear,
			clearAll: clearAll
		}
	}


})();

(function () {
  'use strict'

  angular.module('app.auth')
    .directive('waitingSpinner', waitingSpinnerDirective)
    .directive('sameAs', sameAs)
    .directive('diferenteDe', diferenteDe)
    .directive('checkIfProfileImageExists', checkIfProfileImageExists)
    .directive('compile', ['$compile', compile])
    .directive('inputGenerator', ['$compile', inputGenerator])
    .directive('inputText', inputText)
    .directive('inputNumber', inputNumber)
    .directive('inputDecimal', inputDecimal)
    .directive('inputEmail', inputEmail)
    .directive('inputSelect', inputSelect)
    .directive('inputSelectmultiple', inputSelectMultiple)
    .directive('inputSelectDesc', inputSelectDesc)
    .directive('inputSelectarray', inputSelectarray)
    .directive('inputTextarea', inputTextarea)
    .directive('inputTextangular', inputTextangular)
    .directive('inputCkeditor', inputCkeditor)
    .directive('inputDate', inputDate)
    .directive('inputAutocomplete', inputAutocomplete)
    .directive('inputAutocompletespecial', inputAutocompletespecial)
    .directive('inputAutocompletedepend', inputAutocompletedepend)
    .directive('inputAutocompletesearch', inputAutocompletesearch)
    .directive('inputAutocompletechip', inputAutocompletechip)
    .directive('inputRadio', inputRadio)
    .directive('inputCheckbox', inputCheckbox)
    .directive('inputCheckboxmultiple', inputCheckboxmultiple)
    .directive('inputFile', inputFile)
    .directive('inputFileanalista', inputFileanalista)
    .directive('fileModel', fileModel)
    .directive('inputView', inputView)
    .directive('inputCurrency', inputCurrency)
    .directive('inputMatriz', inputMatriz)
    .directive('inputLabel', inputLabel)
    .directive('mdxPaintFg', mdxPaintFg)
    .directive('mdxPaintBg', mdxPaintBg)
    .directive('inputTblcumplimiento', inputTblcumplimiento)
    .directive('whenscrollends', whenscrollends)
    .provider('mdx', mdx);


  /* START = Directiva para el Spinner que se muestra cuando se ejecuta un Request al Backend */
  function waitingSpinnerDirective($rootScope) {
    return function ($scope, element, attrs) {
      $scope.$on('loader_show', function () {
        return element.show()
      })
      return $scope.$on('loader_hide', function () {
        return element.hide()
      })
    }
  }

  function sameAs() {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ngModel) {
        ngModel.$parsers.unshift(validate)

        // Force-trigger the parsing pipeline.
        scope.$watch(attrs.sameAs, function () {
          // ngModel.$setViewValue(ngModel.$viewValue)
          ngModel.$setValidity('same-as', false)
          // ngModel.$validate()
        })
        /*
        attrs.$observe('ngModel', function(value) {
            			// observes changes to this ngModel
            			ngModel.$validate()
          			})
				*/
        function validate(value) {
          var isValid = scope.$eval(attrs.sameAs) == value
          ngModel.$setValidity('same-as', isValid)
          return isValid ? value : undefined
        }
      }
    }
  }

  function diferenteDe() {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ngModel) {
        ngModel.$parsers.unshift(validate)

        scope.$watch(attrs.diferenteDe, function () {
          ngModel.$setValidity('diferente-de', false)
        })

        function validate(value) {
          var isValid = scope.$eval(attrs.diferenteDe) != value
          ngModel.$setValidity('diferente-de', isValid)
          return isValid ? value : undefined
        }
      }
    }
  }

  // If the user profile image do not exists, this directive load default avart image.
  function checkIfProfileImageExists() {
    return {
      link: function (scope, element, attrs) {
        element.bind('error', function () {
          element.attr('src', 'assets/images/avatars/profile.jpg') // set default image
        })
      }
    }
  }

  function compile($compile) {
    return function (scope, element, attrs) {
      scope.$watch(
        function (scope) {
          // watch the 'compile' expression for changes
          return scope.$eval(attrs.compile);
        },
        function (value) {
          // when the 'compile' expression changes
          // assign it into the current DOM
          element.html(value);

          // compile the new DOM and link it to the current
          // scope.
          // NOTE: we only compile .childNodes so that
          // we don't get into infinite loop compiling ourselves
          $compile(element.contents())(scope);
        }
      );
    };
  }

  function inputGenerator($compile) {
    return {
      scope: {
        field: '=',
        value: '=',
        model: '=',
        attachments: '=',
        hvalue: '=',
        index: '=',
        block: '=',
        idblock: '=',
        options: '=',
        fieldname: '=',
        extra: '=',
        showif: '=',
        disabled: '@',
        readonly: '@'
      },
      replace: true,
      transclude: true,
      link: function (scope, element) {
        var field = "";
        if (scope.field) {
          if (scope.field.field) {
            field = scope.field.field;
          } else if (scope.field.id) {
            field = scope.field.id;
          } else if (scope.fieldname) {
            field = scope.fieldname;
          }
        }
        var data = {
          options: (scope.options ? scope.options : ""),
          validations: (scope.field && scope.field.validations && scope.field.validations.length ? scope.field.validations : []),
          ngModel: scope.model,
          model: (scope.field && scope.field.model ? scope.field.model : ""),
          attachments: (scope.attachments ? scope.attachments : []),
          help: (scope.field && scope.field.label_help ? scope.field.label_help : ""),
          field: field,
          fieldText: (scope.field && scope.field.field_text ? scope.field.field_text : ""),
          dateType: (scope.field && scope.field.type_date ? scope.field.type_date : ""),
          fieldExtra: (scope.field && scope.field.field_extra ? scope.field.field_extra : ""),
          fieldModule: (scope.field && scope.field.module ? scope.field.module : ""),
          hidden: scope.hvalue,
          permission: (scope.field && scope.field.permiso != null && scope.field.permiso != undefined ? scope.field.permiso : ""),
          index: (scope.index != null || scope.index != undefined ? scope.index : ""),
          block: scope.block,
          idblock: scope.idblock,
          required: false,
          default: scope.field.default,
          patterns: "",
          depend: (scope.field && scope.field.depend_field ? scope.field.depend_field : ""),
          extra: (scope.extra) ? scope.extra : {},
          not_order: (scope.field.not_order ? scope.field.not_order : 0),
          order: (scope.field.order ? scope.field.order : 0),
          rows: (scope.field.rows ? scope.field.rows : []),
          cols: (scope.field.cols ? scope.field.cols : []),
          disabled: (scope.disabled ? true : false),
          readonly: (scope.readonly ? true : false),
          showif: (scope.showif ? scope.showif : null)
        };
        if (scope.field && scope.field.validations) {
          for (var index = 0; index < scope.field.validations.length; index++) {
            var e = scope.field.validations[index];
            if (e == "required") {
              data.required = true;
            } else if (e == "only_letters") {
              //data.patterns = "/^[a-zA-Z\d\-\_]+$/";
            } else if (e == "is_adult") {
              data.is_adult = true;
            }
          }
        }

        var newScope = scope.$new(true);
        newScope.data = data;

        var label = (scope.field ? (scope.field.label ? scope.field.label : scope.field.name) : "");

        var value = (scope.value != undefined && scope.value != null && scope.field.type != 'ckeditor' ? scope.value : "");


        var generatedTemplate = '<input-' + (scope.field ? (scope.field.type ? scope.field.type : scope.field.tipo) : "") + ' '
          + 'label="' + label + '" '
          + 'value="' + value + '" '
          + 'options="data"> '
          + '</input-' + (scope.field ? scope.field.type : "") + '>';

        element.append($compile(generatedTemplate)(newScope));
      }
    };
  }

  function inputTblcumplimiento() {
    return {
      restrict: 'E',
      scope: {
        options: '='
      },
      template: '<md-input-container class="ms-responsive-table-wrapper mb-0 all-width">'
        + '<table class="dataTable compact row-border">'
        + '<thead>'
        + '<tr>'
        + '<th></th>'
        + '<th md-colors="{background: \'accent\'}" class="secondary-text br dt-center">'
        + '<div class="table-header">'
        + '<span class="column-title white-fg">Objetivo</span>'
        + '</div>'
        + '</th>'
        + '<th md-colors="{background: \'accent\'}" class="secondary-text br dt-center">'
        + '<div class="table-header">'
        + '<span class="column-title white-fg">Real</span>'
        + '</div>'
        + '</th>'
        + '</tr>'
        + '</thead>'
        + '<tbody>'
        + '<tr>'
        + '<td md-colors="{background: \'accent\'}" class="secondary-text br">'
        + '<div class="table-header">'
        + '<span class="column-title white-fg">RQ - AS</span>'
        + '</div>'
        + '</td>'
        + '<td class="dt-center">{{ options.ngModel.objetivo_cumpliento.objetivo_rq_as || 0 }}</td>'
        + '<td class="dt-center">{{ real_rq_as || 0 }}</td>'
        + '</tr>'
        + '<tr>'
        + '<td md-colors="{background: \'accent\'}" class="secondary-text br">'
        + '<div class="table-header">'
        + '<span class="column-title white-fg">AS - Aceptación</span>'
        + '</div>'
        + '</td>'
        + '<td class="dt-center">{{ options.ngModel.objetivo_cumpliento.objetivo_as_aceptacion || 0 }}</td>'
        + '<td class="dt-center">{{ real_as_aceptacion || 0 }}</td>'
        + '</tr>'
        + '<tr>'
        + '<td md-colors="{background: \'accent\'}" class="secondary-text br">'
        + '<div class="table-header">'
        + '<span class="column-title white-fg">Aceptación - Ingreso</span>'
        + '</div>'
        + '</td>'
        + '<td class="dt-center">{{ options.ngModel.objetivo_cumpliento.objetivo_aceptacion_ingreso || 0 }}</td>'
        + '<td class="dt-center">{{ real_aceptacion_ingreso || 0 }}</td>'
        + '</tr>'
        + '</tbody>'
        + '</table>'
        + '<div ng-if="has_negative_values" class="red-100-bg red-900-fg p-10 mt-10 mb-10 text-center center">'
        + 'El cálculo de los días es negativo, por favor validar las fechas del proceso para poder continuar.'
        + '</div>'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs) {
        var ngModel = null;
        var objetivoCumplimiento = null;

        $scope.real_rq_as = '';
        $scope.real_as_aceptacion = '';
        $scope.real_aceptacion_ingreso = '';

        $scope.has_negative_values = false; // Flag para mostrar mensaje de error

        function diffDatesByDays(date1, date2) {
          var d1 = moment(date1);
          var d2 = moment(date2);

          return d1.diff(d2, 'days');
        }

        function formatDate(date, utc) {
          var _date = moment(date);

          if (utc) {
            _date = _date.utc();
          }

          return _date.format('YYYYMMDD');
        }

        function onChangeDates() {
          ngModel = $scope.options.ngModel;
          objetivoCumplimiento = ngModel.objetivo_cumpliento;

          $scope.has_negative_values = false;
          $scope.options.ngModel.validacionFechasIncumplimiento = false; // Flag declarado en discardStage.controller para mostrar el botón de aceptar

          if(!objetivoCumplimiento){
            return null;
          }

          var fecha_ac = formatDate(objetivoCumplimiento.fecha_ac, true);
          var fecha_as = formatDate(objetivoCumplimiento.fecha_as);
          var fecha_ingreso = formatDate(ngModel.fecha_ingreso, true);
          var fecha_requisicion = formatDate(ngModel.fecha_requisicion);

          // RQ - AS
          $scope.real_rq_as = diffDatesByDays(fecha_as, fecha_requisicion);
          
          // AS - Aceptación
          var diffDates = diffDatesByDays(fecha_ac, fecha_as);

          $scope.real_as_aceptacion = diffDates - objetivoCumplimiento.dias_suspension
          
          // Aceptación - Ingreso
          $scope.real_aceptacion_ingreso = diffDatesByDays(fecha_ingreso, fecha_ac);

          if ($scope.real_rq_as >= 0 && $scope.real_as_aceptacion >= 0 && $scope.real_aceptacion_ingreso >= 0) {
            $scope.options.ngModel.validacionFechasIncumplimiento = true;
          } else {
            $scope.has_negative_values = true;
          }
        }

        // Se ejecuta cuando ocurre un cambio desde discardStage.controller en get_onchange_data
        $scope.$watch("options.ngModel.objetivo_cumpliento", onChangeDates);
      }
    }
  }

  function inputText(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-0 mt-0 all-width hide-validation-error">'
        + '<div class="h4 grey-fg font-weight-300">'
        + '{{label}}<span class="" ng-if="options.required">* </span>'
        + '<span ng-if="options.help" class="icon-question-mark-circle cursor-pointer ml-5">'
        + '<md-tooltip md-direction="top">{{options.help}}</md-tooltip>'
        + '</span>'
        + '</div>'
        + '<input type="text" ng-disabled="disabled" class="custom-form" ng-required="options.required" name="{{options.field}}" ng-model="options.ngModel[options.field]" aria-label="{{label}}">'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs) {

        $scope.disabled = false;

        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.options.ngModel[$scope.options.field] = $scope.value;
        
        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputNumber(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-0 mt-0 all-width hide-validation-error">'
        + '<div class="h4 grey-fg font-weight-300">{{label}}<span class="" ng-if="options.required">*</span></div>'
        + '<input type="number" class="custom-form" ng-disabled="disabled" min="0" ng-required="options.required" name="{{options.field}}" ng-keydown="keydown($event)" ng-model="options.ngModel[options.field]">'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs) {
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }
        $scope.options.ngModel[$scope.options.field] = $scope.value * 1;

        var invalidChars = [
          "-",
          "+",
          "e",
        ];

        $scope.keydown = function (e) {
          if (invalidChars.includes(e.key)) {
            e.preventDefault();
          }
        }


        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputDecimal(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-0 mt-0 all-width hide-validation-error">'
        + '<div class="h4 grey-fg font-weight-300">{{label}}<span class="" ng-if="options.required">*</span></div>'
        + '<input type="number" class="custom-form" ng-disabled="disabled" min="0" ng-required="options.required" name="{{options.field}}" ng-keydown="keydown($event)" ng-model="options.ngModel[options.field]" >'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs) {

        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }
        $scope.options.ngModel[$scope.options.field] = $scope.value * 1;

        var invalidChars = [
          "-",
          "+",
          "e",
        ];


        $scope.keydown = function (e) {
          if (invalidChars.includes(e.key)) {
            e.preventDefault();
          }
        }

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputCurrency(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-0 mt-0 all-width hide-validation-error">'
        + '<div class="h4 grey-fg font-weight-300">'
        + '{{label}} <span class="" ng-if="options.required">*</span>'
        + '<span ng-if="options.help" class="icon-question-mark-circle cursor-pointer ml-5">'
        + '<md-tooltip md-direction="top">{{options.help}}</md-tooltip>'
        + '</span>'
        + '</div>'
        + '<input type="text" class="custom-form" aria-label="{{label}}" ng-disabled="disabled" min="0" ng-currency fraction="2" currency-symbol="" ng-required="options.required" name="{{options.field}}" ng-model="options.ngModel[options.field]">'
        + '<div ng-if="options.ngModel[options.field] > limit" class="red-fg">El valor supera el máximo permitido ({{limit | currency: $ : 2}})</div>'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs) {
        $scope.limit = 100000000;
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.options.ngModel[$scope.options.field] = $scope.value * 1;

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputView() {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-0 all-width">'
        + '<label>{{label}}</label>'
        + '<input type="text" class="custom-form" disabled value="{{desc}}" />'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs) {
        $scope.options.ngModel[$scope.options.field] = ($scope.options.default ? $scope.options.default : $scope.value);
        $scope.desc = "";

        if ($scope.options.default) {
          $scope.desc = ($scope.options.options[$scope.options.default] ? $scope.options.options[$scope.options.default] : $scope.options.default);
        } else if ($scope.options.ngModel[$scope.options.field + '_label']) {
          $scope.desc = $scope.options.ngModel[$scope.options.field + '_label'];
        } else {
          $scope.desc = angular.copy($scope.value);
        }
      }
    };
  }

  function inputEmail(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-0 mt-0 all-width hide-validation-error">'
        + '<div class="h4 grey-fg font-weight-300">{{label}} <span class="" ng-if="options.required">*</span></div>'
        + '<input type="email" class="custom-form" ng-disabled="disabled" ng-required="options.required" name="{{options.field}}" ng-change="emailChange()" ng-model="options.ngModel[options.field]">'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs) {
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }
        $scope.options.ngModel[$scope.options.field] = $scope.value;

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            // Finally, directives are evaluated
            // and templates are renderer here
            //var children = $element.children();
            //console.log(children);
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputSelect(ValidationService, IkanoFactory) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-15 all-width">'
        + '<md-tooltip ng-if="options.help" md-direction="top">{{options.help}}</md-tooltip>'
        + '<div layout="row" >'
        + '<label>{{label}}'
        + '</label>'
        + '</div>'
        + '<md-select class="custom-select-form" ng-disabled="disabled" ng-required="options.required" class="simplified2 h6" ng-model="options.ngModel[options.field]" aria-label="{{label}}">'
        + '<md-select-header class="demo-select-header">'
        + '<input ng-model="filter_text" type="search" placeholder="Escribe para buscar" class="demo-header-searchbox md-text" ng-keydown="$event.stopPropagation()">'
        + '</md-select-header>'
        + '<md-option ng-repeat="(key, value) in options.options | filter:filter_text  "  ng-value="value.id">'
        + '{{value.name}}'
        + '</md-option>'
        + '</md-select>'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs, $filter) {
        //| orderBy : ' + "'name'" + '
        $scope.filter_text = '';
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        if ($scope.options.field == 'padre_parentesco' || $scope.options.field == 'madre_parentesco') {
          $scope.disabled = true;
        }

        $scope.options.options = IkanoFactory.convertObjToArrayObjects($scope.options.options);

        if (!$scope.options.not_order) {
          var key = $scope.options.order ? $scope.options.order : 'name';
          $scope.options.options = $filter('orderBy')($scope.options.options, key);
        }

        //console.log($scope.options.options);
        $scope.value = ($scope.value == null || $scope.value == undefined || $scope.value == "" ? null : $scope.value);

        $scope.options.options = IkanoFactory.filterObjectSelectByState($scope.options.options, $scope.value );

        if(!$scope.value && $scope.options.default){
          $scope.options.ngModel[$scope.options.field] = $scope.options.default;
        } else if($scope.value){
          $scope.options.ngModel[$scope.options.field] = $scope.value;
        }

        $scope.$on('changeList' + $scope.options.field, function (evt, data) {
          $scope.options.options = IkanoFactory.convertObjToArrayObjects(data);
          $scope.options.options = IkanoFactory.filterObjectSelectByState($scope.options.options, null );
        });

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            // Finally, directives are evaluated
            // and templates are renderer here
            //var children = $element.children();
            //console.log(children);
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function whenscrollends() {
    return {
      restrict: "A",
      link: function (scope, element, attrs) {
        var container = element.find('md-content');
        container.css('height', '300px');
        var visibleHeight = 300;
        var threshold = 100;

        container.on('scroll', function (e) {
          var scrollableHeight = container.prop('scrollHeight');
          var hiddenContentHeight = scrollableHeight - visibleHeight;
          if (hiddenContentHeight - container[0].scrollTop <= threshold) {
            scope.$apply(attrs.whenscrollends);
          }
        });

      }
    }
  }

  function inputSelectMultiple(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-0 all-width">'
        + '<label>{{label}}</label>'
        + '<md-select class="custom-select-form" ng-disabled="disabled" ng-model="options.ngModel[options.field]" '
        + 'ng-required="options.required" '
        + 'class="simplified2 h6" '
        + 'aria-label="{{label}}" '
        + 'md-on-close="clearSearchTerm()" '
        + 'data-md-container-class="selectdemoSelectHeader" '
        //+ 'whenscrollends="loadMore()"'
        + 'multiple>'
        + '<md-select-header class="demo-select-header">'
        + '<input ng-model="searchTerm" '
        + 'ng-change="changeSearch()"'
        + 'type="search" '
        + 'placeholder="Escribe para buscar" '
        + 'class="demo-header-searchbox md-text"> '
        + '</md-select-header>'
        + '<md-optgroup label="{{label}}"> '
        //+ '<md-option ng-value="d" ng-repeat="(k,d) in data  track by $index">'
        + '<md-option ng-value="keys[k]" ng-repeat="(k,d) in data  track by $index">'
        + '{{d | capitalize: true}}'
        + '</md-option>'
        + '</md-optgroup>'
        + '</md-select>'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs, $filter) {
        $scope.disabled = false;

        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.selected = [];
        $scope.data = [];
        $scope.oldData = [];
        $scope.dataBackup = [];
        $scope.keys = [];

        $.map($scope.options.options, function (value, index) {
          if (value.name) {
            $scope.data.push(value.name);
            $scope.keys.push(index);
          } else {
            $scope.data.push(value);
            $scope.keys.push(index);
          }
        });


        $scope.value = ($scope.value == null || $scope.value == undefined || $scope.value == "" ? null : $scope.value);
        $scope.options.ngModel[$scope.options.field] = (!$scope.value ? null : $scope.value.split(","));

        $scope.searchTerm;
        $scope.clearSearchTerm = function () {
          $scope.searchTerm = '';
        };
        // The md-select directive eats keydown events for some quick select
        // logic. Since we have a search input here, we don't need that logic.
        $element.find('input').on('keydown', function (ev) {
          ev.stopPropagation();
        });

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputSelectarray(ValidationService, IkanoFactory, $filter) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-15 all-width">'
        + '<md-tooltip ng-if="options.help" md-direction="top">{{options.help}}</md-tooltip>'
        + '<div layout="row" >'
        + '<label>{{label}}'
        + '</label>'
        + '</div>'
        + '<md-select class="custom-select-form" ng-disabled="disabled" ng-required="options.required" class="simplified2 h6" ng-model="options.ngModel[options.field]" aria-label="{{label}}">'

        + '<md-option ng-repeat="value in options.options  track by $index " ng-value="value.id">'
        + '{{value.name}}'
        + '</md-option>'
        + '</md-select>'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs) {
        //| orderBy : ' + "'name'" + '
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.value = ($scope.value == null || $scope.value == undefined || $scope.value == "" ? null : $scope.value);

        $scope.options.ngModel[$scope.options.field] = $scope.value;

        if (!$scope.options.not_order) {
          var key = $scope.options.order ? $scope.options.order : 'name';
          $scope.options.options = $filter('orderBy')($scope.options.options, key);
        }

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            // Finally, directives are evaluated
            // and templates are renderer here
            //var children = $element.children();
            //console.log(children);
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputSelectDesc(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-15 all-width">'
        + '<label>{{label}}</label>'
        + '<md-select class="custom-select-form" ng-disabled="disabled" ng-change="refreshDescription()" ng-required="options.required" class="simplified2 h6" ng-model="options.ngModel[options.field]" aria-label="{{label}}">'
        + '<md-option ng-repeat="(key, value) in options.options track by $index" ng-value="key">'
        + '{{value.label}}'
        + '</md-option>'
        + '</md-select>'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs) {
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.value = ($scope.value == null || $scope.value == undefined || $scope.value == "" ? null : $scope.value);
        $scope.options.ngModel[$scope.options.field] = $scope.value;

        $scope.refreshDescription = function () {
          var it = $scope.options.options[$scope.options.ngModel[$scope.options.field]];
          $scope.options.ngModel.title = it.label;
          $scope.options.ngModel.desc = it.desc;
        }

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputTextarea(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container ng-init="val = value" class="mb-0 mt-0 all-width">'
        + '<div class="h4 grey-fg font-weight-300">{{label}}<span class="" ng-if="options.required">*</span> </div>'
        + '<textarea class="custom-form no-margin" ng-disabled="disabled" ng-required="options.required" ng-pattern="options.patterns" md-maxlength="textLength" maxlength="{{textLength}}" rows="3" ng-model="options.ngModel[options.field]" aria-label="{{label}}"></textarea>'
        + '<div ng-if="options.ngModel[options.field].length >= textLength" class="red-fg pt-8 pb-8">'
        + 'Este campo no debe sobre pasar los {{textLength}} caracteres, por favor valide la información.'
        + '</div>'
        + '</md-input-container>',
      controller: function ($scope, $element, $attrs) {
        $scope.textLength = 4000;
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }
        $scope.options.ngModel[$scope.options.field] = $scope.value;

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {

            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputTextangular() {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<div class="mb-0 all-width">'
        + '<div class="h4 grey-fg font-weight-300">{{label}}</div>'
        + '<text-angular ng-required="options.required" ta-toolbar="taToolbar" ng-model="options.ngModel[options.field]" aria-label="{{label}}"></text-angular>'
        + '</div>',
      controller: function ($scope, $element, $attrs) {
        $scope.taToolbar = [
          ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo']
        ];

        $scope.disabled = false;
        if ($scope.options && $scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }
        $scope.options.ngModel[$scope.options.field] = $scope.value;
      }
    };
  }

  function inputCkeditor() {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '=',
        options: '='
      },
      template: '<div class="mb-0 all-width">'
        + '<div class="h4 grey-fg font-weight-300">{{label}}</div>'
        + '<div ckeditor="chkoptions" ng-required="options.required" ng-model="options.ngModel[options.field]" aria-label="{{label}}" ready="onReady()"></div>'
        + '</div>',
      controller: function ($scope, $element, $attrs) {
        // Editor options.
        $scope.chkoptions = {
          language: 'es',
          allowedContent: true,
          entities: false
        };

        // Called when the editor is completely ready.
        $scope.onReady = function () {

        };

        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }
        //$scope.options.ngModel[$scope.options.field] = $scope.value;

      }
    };
  }

  function inputDate(ValidationService, IkanoFactory, $mdDateLocale, ValidationFactory) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<div class="pl-5 pr-5 pt-5 pb-5 mb-0 all-width">'
        + '<div class="grey-700-fg h5 font-weight-300">{{label}}<span class="" ng-if="options.required">*</span></div>'
        + '<md-datepicker class="custom-date-form" ng-disabled="disabled" ng-required="options.required" md-min-date="minDate" '
        + 'md-max-date="maxDate" md-placeholder="" md-open-on-focus ng-model="options.ngModel[options.field]" '
        + 'ng-change="ValidateDate(options.ngModel[options.field])" ng-model-options="{timezone: \'utc\'}"></md-datepicker>'
        + '</div>'
        + '<div ng-if="validation.isAdult" class="p-5 h6 red-500-fg">'
        + 'El candidato debe ser mayor de edad.'
        + '</div>',
      controller: function ($scope, $element, $attrs) {
        //md-current-view="year"
        $scope.validation = {};
        var locale = IkanoFactory.getDateLocaleFormat('es');
        if (locale != false) {
          $mdDateLocale.months = locale.months;
          $mdDateLocale.shortMonths = locale.shortMonths;
          $mdDateLocale.days = locale.days;
          $mdDateLocale.shortDays = locale.shortDays;
        }

        $mdDateLocale.formatDate = function (date) {
          return date ? moment(date).utc().format('DD/MM/YYYY') : '';
        };

        $scope.disabled = false;
        if ($scope.options.permission !== "") {

          $scope.disabled = ($scope.options.permission ? false : true);
        }

        if ($scope.options.dateType == 1) {
          $scope.minDate = new Date();
          $scope.maxDate = null;
        } else if ($scope.options.dateType == 2) {
          $scope.minDate = null;
          $scope.maxDate = null;
        } else {
          $scope.minDate = null;
          $scope.maxDate = new Date();
        }

        $scope.ValidateDate = function (field) {

          var today = moment();
          var fieldMoment = moment(field);
          if ($scope.options.is_adult) {
            if (!ValidationFactory.personales.isAdult(today, fieldMoment)) {
              $scope.validation.isAdult = true;
              $scope.options.ngModel[$scope.options.field] = '';
            } else {
              $scope.validation.isAdult = false;
            }
            /*var mayor = (today > fieldMoment) ? today : fieldMoment;
            var menor = (today > fieldMoment) ? fieldMoment : today;
            if(mayor.diff(menor,'years') < 18){
              $scope.options.ngModel[$scope.options.field] = '';
            }*/
            //
          }
        }

        //var date = ($scope.value ? new Date($scope.value) : new Date());
        var date = "";
        if($scope.value){
          date = moment.utc($scope.value);
          date = new Date(date.year(), date.month(), date.date(), 0, 0, 0);
        }
        $scope.options.ngModel[$scope.options.field] = date;

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {

            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      },
    };
  }

  function inputAutocomplete(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        hidden: '@',
        options: '='
      },
      template: '<md-input-container ng-init="val = value" class="mb-15 all-width">'
        + '<label>{{label}} <span class="" ng-if="options.required">*</span></label>'
        + '<md-autocomplete class="custom-autocomplete" '
        + 'ng-disabled="disabled" '
        + 'md-selected-item="selectedItem" '
        + 'md-search-text-change="searchTextChange(searchText)" '
        + 'md-search-text="searchText" '
        + 'md-selected-item-change="selectedItemChange(item)" '
        + 'md-items="item in querySearch(searchText)' + "| orderBy : 'name'" + '"'
        + 'md-item-text="item.name | capitalize: true" '
        + 'md-min-length="0" '
        + 'placeholder="">'
        + '<md-item-template>'
        + '<span md-highlight-text="searchText" md-highlight-flags="^i">{{item.name | capitalize: true}}</span>'
        + '</md-item-template>'
        + '<md-not-found >'
        + '<span ng-if="!options.extra.create">No se encontraron coincidencias con la palabra "{{searchText}} "<span>'
        + '</md-not-found>'
        + '</md-autocomplete>'
        + '</md-input-container>',

      controller: function ($scope, $element, $attrs) {
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        var self = this;
        self.list = $.map($scope.options.options, function (value, index) {
          return [{ id: index, name: value }];
        });

        $scope.options.ngModel[$scope.options.field] = $scope.value;

        $scope.searchText = "";
        $scope.querySearch = querySearch;

        if ($scope.options.options[$scope.value]) {
          $scope.selectedItem = { id: $scope.value, name: $scope.options.options[$scope.value] };
        } else if ($scope.options.hidden) {
          $scope.selectedItem = { id: 0, name: $scope.options.hidden };
        } else if ($scope.value) {
          $scope.selectedItem = { id: 0, name: $scope.value };
        } else {
          $scope.selectedItem = null;
        }

        $scope.selectedItemChange = selectedItemChange;

        function querySearch(query) {
          if ($scope.options.fieldText) {
            $scope.options.ngModel[$scope.options.field] = 0;
            $scope.options.ngModel[$scope.options.fieldText] = $scope.searchText;
          }

          if ($scope.options.fieldExtra) {
            $scope.options.ngModel[$scope.options.fieldExtra] = $scope.searchText;
          }

          var results = query ? self.list.filter(createFilterFor(query)) : self.list;
          return results;
        }

        function selectedItemChange(item) {
          if (item) {
            $scope.options.ngModel[$scope.options.field] = item.id;
            if ($scope.options.fieldText) {
              $scope.options.ngModel[$scope.options.fieldText] = item.name;
            }

            if ($scope.options.fieldExtra) {
              $scope.options.ngModel[$scope.options.fieldExtra] = item.name;
            }
          } else {
            $scope.options.ngModel[$scope.options.field] = null;
          }
        }

        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);

          return function filterFn(res) {
            res = angular.lowercase(res.name);
            if (!res) {
              return false;
            }
            //return (res.indexOf(lowercaseQuery) === 0);
            return res.indexOf(lowercaseQuery.toLowerCase()) != -1;
          };
        }



        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            // Finally, directives are evaluated
            // and templates are renderer here
            //var children = $element.children();
            //console.log(children);

            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      },
    };
  }

  function inputAutocompletesearch(ValidationService, IkanoFactory) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        hidden: '@',
        options: '='
      },
      template: '<md-input-container ng-init="val = value" class="mb-15 all-width">'
        + '<label>{{label}} <span class="" ng-if="options.required">*</span></label>'
        + '<md-autocomplete class="custom-autocomplete" '
        + 'ng-disabled="disabled" '
        + 'md-selected-item="selectedItem" '
        + 'md-search-text-change="searchTextChange(searchText)" '
        + 'md-search-text="searchText" '
        + 'md-selected-item-change="selectedItemChange(item)" '
        + 'md-items="item in querySearch(searchText)' + "| orderBy : 'name'" + '"'
        + 'md-item-text="item.name | capitalize: true" '
        + 'md-min-length="3" '
        + 'md-no-cache="true" '
        + 'placeholder="Escribe para empezar a buscar">'
        + '<md-item-template>'
        + '<span md-highlight-text="searchText" md-highlight-flags="^i">{{item.name | capitalize: true}}</span>'
        + '</md-item-template>'
        + '<md-not-found>'
        + 'No se encontraron coincidencias con la palabra "{{searchText}}"'
        + '</md-not-found>'
        + '</md-autocomplete>'
        + '</md-input-container>',

      controller: function ($scope, $element, $attrs) {
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        var self = this;
        self.list = $.map($scope.options.options, function (value, index) {
          return [{ id: index, name: value }];
        });

        $scope.options.ngModel[$scope.options.field] = $scope.value;


        $scope.searchText = "";
        $scope.querySearch = querySearch;

        if ($scope.options.options[$scope.value]) {
          $scope.selectedItem = { id: $scope.value, name: $scope.options.options[$scope.value] };
        } else if ($scope.options.hidden) {
          $scope.selectedItem = { id: 0, name: $scope.options.hidden };
        }  else if ($scope.value) {
          $scope.selectedItem = { id: 0, name: $scope.value };
        } else {
          $scope.selectedItem = null;
        }

        $scope.selectedItemChange = selectedItemChange;

        function querySearch(query) {
          if ($scope.options.fieldText) {
            $scope.options.ngModel[$scope.options.field] = 0;
            $scope.options.ngModel[$scope.options.fieldText] = $scope.searchText;
          }

          if ($scope.options.fieldExtra) {
            $scope.options.ngModel[$scope.options.fieldExtra] = $scope.searchText;
          }

          var results = query ? self.list.filter(createFilterFor(query)) : self.list;
          return results;
        }

        function selectedItemChange(item) {
          if (item) {
            $scope.options.ngModel[$scope.options.field] = item.id;
            if ($scope.options.fieldText) {
              $scope.options.ngModel[$scope.options.fieldText] = item.name;
            }

            if ($scope.options.fieldExtra) {
              $scope.options.ngModel[$scope.options.fieldExtra] = item.name;
            }
          } else {
            $scope.options.ngModel[$scope.options.field] = null;
          }
        }

        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);

          return function filterFn(res) {
            res = angular.lowercase(res.name);
            if (!res) {
              return false;
            }
            //return (res.indexOf(lowercaseQuery) === 0);
            return res.indexOf(lowercaseQuery.toLowerCase()) != -1;
          };
        }

        $scope.$on('changeList' + $scope.options.field, function (evt, data) {
          $scope.selectedItem = null;
          self.list = [];
          self.list = $.map(data, function (value, index) {
            return [{ id: index, name: value }];
          });
        });

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            // Finally, directives are evaluated
            // and templates are renderer here
            //var children = $element.children();
            //console.log(children);

            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      },
    };
  }

  function inputAutocompletechip(ValidationService, $filter) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        hidden: '@',
        options: '='
      },
      template: '<md-input-container class="mb-15 all-width">'
        + '<label>{{label}} <span class="" ng-if="options.required">*</span></label>'
        + '<md-chips ng-model="values" md-autocomplete-snap="" md-removable="true" md-on-add="validationChip(values,$chip)" md-on-remove="removeChip($chip)"> '
        + '<md-autocomplete class="custom-autocomplete" '
        + 'ng-disabled="disabled" '
        + 'md-selected-item="selectedItem" '
        + 'md-search-text-change="searchTextChange(searchText)" '
        + 'md-search-text="searchText" '
        + 'md-items="item in querySearch(searchText)' + "| orderBy : 'name'" + '"'
        + 'md-item-text="item.name | capitalize: true" '
        + 'md-min-length="3" '
        + 'placeholder="Escribe para empezar a buscar">'
        + '<md-item-template>'
        + '<span md-highlight-text="searchText" md-highlight-flags="^i">{{item.name | capitalize: true}}</span>'
        + '</md-item-template>'
        + '<md-not-found>'
        + 'No se encontraron coincidencias con la palabra "{{searchText}}"'
        + '</md-not-found>'
        + '</md-autocomplete>'
        + '<md-chip-template>'
        + '<span class="chipsValue">'
        + '{{$chip.name}}'
        + '</span>'
        + '</md-chip-template>'
        + '</md-chips>'
        + '</md-input-container>',

      controller: function ($scope, $element, $attrs) {

        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }
        $scope.values = [];

        var self = this;
        self.list = $.map($scope.options.options, function (value, index) {
          return [{ id: index, name: value }];
        });

        $scope.searchText = "";
        $scope.querySearch = querySearch;
        $scope.validationChip = validationChip;
        $scope.removeChip = removeChip;

        function initValue() {
          var value = $scope.options.ngModel[$scope.options.field] = ($scope.value ? $scope.value.split(",") : []);
          if (value.length > 0) {
            $scope.values = self.list.filter(function (data) {
              if (value.indexOf(data.id) != -1) {
                return data;
              }
            });
          }
        }

        function validationChip(data, chip) {
          if (!angular.isObject(chip)) {
            data.pop();
          } else {
            $scope.options.ngModel[$scope.options.field].push(chip.id);
          }
        }

        function removeChip(chip) {
          var values = $scope.options.ngModel[$scope.options.field];
          for (var i in values) {
            if (values[i] == chip.id) {
              values.splice(i, 1);
              break;
            }
          }
          $scope.options.ngModel[$scope.options.field] = values;
        }

        function querySearch(query) {
          var results = query ? $filter('filter')(self.list, query) : self.list;
          return results;
        }

        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);

          return function filterFn(res) {

            res = angular.lowercase(res.name);
            if (!res) {
              return false;
            }
            //return (res.indexOf(lowercaseQuery) === 0);
            return res.indexOf(lowercaseQuery.toLowerCase()) != -1;
          };
        }

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            // Finally, directives are evaluated
            // and templates are renderer here
            //var children = $element.children();
            //console.log(children);
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });

        initValue();
      },
    };
  }

  function inputAutocompletespecial(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        hidden: '@',
        options: '='
      },
      template: '<md-input-container ng-init="val = value" class="mb-0 all-width">'
        + '<label>{{label}} <span class="" ng-if="options.required">*</span></label>'
        + '<md-autocomplete class="custom-autocomplete"'
        + 'ng-disabled="disabled" '
        + 'md-selected-item="selectedItem" '
        + 'md-search-text-change="searchTextChange(searchText)" '
        + 'md-search-text="searchText" '
        + 'md-selected-item-change="selectedItemChange(item)" '
        + 'md-items="item in querySearch(searchText)" '
        + 'md-item-text="item.name | capitalize:true" '
        + 'md-min-length="0" '
        + 'placeholder="">'
        + '<md-item-template>'
        + '<span md-highlight-text="searchText" md-highlight-flags="^i">{{item.name | capitalize:true}}</span>'
        + '</md-item-template>'
        + '<md-not-found>'
        + 'No se encontraron coincidencias con la palabra "{{searchText}}"'
        + '</md-not-found>'
        + '</md-autocomplete>'
        + '</md-input-container>',

      controller: function ($scope, $element, $attrs) {
        var self = this;

        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        if (!$scope.options.ngModel[$scope.options.field]) {
          $scope.options.ngModel[$scope.options.field] = [];
        }

        self.list = $.map($scope.options.options, function (value, index) {
          if ($scope.options.ngModel[$scope.options.field].length) {
            var i = $scope.options.ngModel[$scope.options.field].indexOf(index);
            if (i <= 0) {
              return [{ id: index, name: (value.cod_empleado ? value.cod_empleado + " - " : "") + value.name }];
            }
          } else {
            return [{ id: index, name: (value.cod_empleado ? value.cod_empleado + " - " : "") + value.name }];
          }
        });

        if ($scope.value) {
          $scope.options.ngModel[$scope.options.field][$scope.options.index] = $scope.value;
        }

        $scope.searchText = "";
        $scope.querySearch = querySearch;

        if ($scope.options.options[$scope.value]) {
          $scope.selectedItem = { id: $scope.value, name: $scope.options.options[$scope.value].name };
        } else if ($scope.options.hidden) {
          $scope.selectedItem = { id: 0, name: $scope.options.hidden };
        } else if ($scope.value) {
          $scope.selectedItem = { id: 0, name: $scope.value };
        } else {
          $scope.selectedItem = null;
        }

        $scope.selectedItemChange = selectedItemChange;

        function querySearch(query) {
          //$scope.options.ngModel[$scope.options.field][$scope.options.index] = 0;

          var results = query ? self.list.filter(createFilterFor(query)) : self.list;
          return results;
        }

        function selectedItemChange(item) {
          if (item) {
            $scope.options.ngModel[$scope.options.field][$scope.options.index] = item.id;
          } else {
            $scope.options.ngModel[$scope.options.field][$scope.options.index] = null;
          }
        }

        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);

          return function filterFn(res) {
            res = angular.lowercase(res.name);
            if (!res) {
              return false;
            }
            //return (res.indexOf(lowercaseQuery) === 0);
            return res.indexOf(lowercaseQuery.toLowerCase()) != -1;
          };
        }

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            // Finally, directives are evaluated
            // and templates are renderer here
            //var children = $element.children();
            //console.log(children);

            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      },
    };
  }

  function inputAutocompletedepend() {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<md-input-container class="mb-0 all-width">'
        + '<label>{{label}} <span class="" ng-if="options.required">*</span></label>'
        + '<md-autocomplete class="custom-autocomplete"'
        + 'ng-disabled="disabled" '
        + 'md-no-cache="cache"'
        + 'md-selected-item="selectedItem" '
        + 'md-search-text-change="searchTextChange(searchText)" '
        + 'md-search-text="searchText" '
        + 'md-selected-item-change="selectedItemChange(item)" '
        + 'md-items="item in querySearch(searchText)" '
        + 'md-item-text="item.name | capitalize:true" '
        + 'md-min-length="0" '
        + 'placeholder="Escribe para empezar a buscar">'
        + '<md-item-template>'
        + '<span md-highlight-text="searchText" md-highlight-flags="^i">{{item.name | capitalize:true}}</span>'
        + '</md-item-template>'
        + '<md-not-found>'
        + 'No se encontraron coincidencias con la palabra "{{searchText}}"'
        + '</md-not-found>'
        + '</md-autocomplete>'
        + '</md-input-container>',

      controller: function ($scope, $element, $attrs) {
        var self = this;

        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.cache = true;
        $scope.list = [];
        self.data = [];
        var data = $.map($scope.options.options, function (value, index) {
          return [{ id: index, industria_id: value.industria_id, name: value.name }];
        });

        for (var index = 0; index < data.length; index++) {
          var element = data[index];
          if (!self.data[element.industria_id]) {
            self.data[element.industria_id] = [];
          }

          self.data[element.industria_id].push(element);
        }

        $scope.list = (self.data[$scope.options.ngModel[$scope.options.depend]] ? self.data[$scope.options.ngModel[$scope.options.depend]] : []);

        $scope.options.ngModel[$scope.options.field] = $scope.value;

        $scope.searchText = "";
        $scope.querySearch = querySearch;
        $scope.selectedItem = ($scope.options.options[$scope.value] ? { id: $scope.value, name: $scope.options.options[$scope.value].name } : null);
        $scope.selectedItemChange = selectedItemChange;

        $scope.first = true;

        function querySearch(query) {
          var results = query ? $scope.list.filter(createFilterFor(query)) : $scope.list;
          return results;
        }

        function selectedItemChange(item) {
          if (item) {
            $scope.options.ngModel[$scope.options.field] = item.id;
            if ($scope.options.fieldText) {
              $scope.options.ngModel[$scope.options.fieldText] = item.name;
            }

            if ($scope.options.fieldExtra) {
              $scope.options.ngModel[$scope.options.fieldExtra] = item.name;
            }

          } else {
            $scope.options.ngModel[$scope.options.field] = null;
          }
        }

        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);

          return function filterFn(res) {
            res = angular.lowercase(res.name);
            if (!res) {
              return false;
            }
            //return (res.indexOf(lowercaseQuery) === 0);
            return res.indexOf(lowercaseQuery.toLowerCase()) != -1;
          };
        }

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            $scope.$watch("options.ngModel['" + $scope.options.depend + "']", function (newVal, oldVal) {
              if (!$scope.first) {
                if ($scope.options.ngModel[$scope.options.depend]) {
                  $scope.list = self.data[$scope.options.ngModel[$scope.options.depend]];
                } else {
                  $scope.list = [];
                }

                $scope.selectedItem = null;
              }

              $scope.first = false;
            });
          });
        });
      },
    };
  }

  function inputRadio(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<div class="p-5">'
        + '<div class="p-5 h6">{{label}}</div>'
        + '<div class="p-5">'
        + '<md-radio-group class="custom-radio-form" ng-disabled="disabled" layout="column" ng-required="options.required" ng-value="value" name="{{options.field}}" ng-model="options.ngModel[options.field]">'
        + '<md-radio-button ng-repeat="(key, value) in options.options track by $index" ng-value="key">{{value}}</md-radio-button>'
        + '</md-radio-group>'
        + '</div>'
        + '</div>',
      controller: function ($scope, $element, $attrs) {
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.options.ngModel[$scope.options.field] = $scope.value;

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            // Finally, directives are evaluated
            // and templates are renderer here
            //var children = $element.children();
            //console.log(children);
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputCheckbox(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<div class="">'
        + '<div class="p-5 h5">{{label}}</div>'
        + '<div ng-repeat="(key, value) in options.options track by $index" class="pt-10 pr-5 pb-10 pl-5" layout="row" layout-align="start center">'
        + '<md-checkbox class="custom-checkbox-form" ng-disabled="disabled" class="no-padding no-margin" ng-model="options.ngModel[options.field]" aria-label="aria-label">'
        + '{{(value.name ? value.name : "Si")}}'
        + '</md-checkbox>'
        + '</div>'
        + '</div>',
      controller: function ($scope, $element, $attrs) {
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.options.options = $.map($scope.options.options, function (value, index) {
          return [{ id: index, name: value }];
        });

        $scope.options.ngModel[$scope.options.field] = ($scope.value == "" ? false : JSON.parse($scope.value));

        if (!$scope.options.options.length) {
          $scope.options.options = [{ id: 0, name: "" }];
        }

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputCheckboxmultiple(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<div class="p-5">'
        + '<div class="p-5 h6">{{label}}</div>'
        + '<div ng-repeat="(key, value) in options.options track by $index" class="pt-10 pr-5 pb-10 pl-5" layout="row" layout-align="start center">'
        + '<md-checkbox class="custom-checkbox-form" ng-disabled="disabled" class="no-padding no-margin" ng-change="addValue(value.id)" ng-model="checks[value.id]" aria-label="{{value.name}}">'
        + '{{value.name}}'
        + '</md-checkbox>'
        + '</div>'
        + '</div>',
      controller: function ($scope, $element, $attrs) {
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.options.options = $.map($scope.options.options, function (value, index) {
          return [{ id: index, name: value }];
        });

        if (!$scope.options.options.length) {
          $scope.options.options = [{ id: 0, name: "" }];
        }

        $scope.checks = [];
        $scope.value = $scope.value.split(",");
        $scope.options.ngModel[$scope.options.field] = ($scope.value.length ? $scope.value : []);

        for (var index = 0; index < $scope.value.length; index++) {
          var element = $scope.value[index];
          $scope.checks[element] = true;
        }

        $scope.addValue = function (id) {
          $scope.options.ngModel[$scope.options.field] = (!$scope.options.ngModel[$scope.options.field] || !$scope.options.ngModel[$scope.options.field].length ? [] : $scope.options.ngModel[$scope.options.field]);
          var index = $scope.options.ngModel[$scope.options.field].indexOf(id);
          if (index > -1) {
            $scope.options.ngModel[$scope.options.field].splice(index, 1);
          } else {
            $scope.options.ngModel[$scope.options.field].push(id);
          }
        }

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          // Wait for templates to render
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputFile(CandidateService, ValidationService) {
    return {
      require: 'Upload',
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<div class="mb-0 all-width">'
        + '<div class="h6 grey-500-fg font-weight-300">{{label}}</div>'
        + ' <input class="" ng-disabled="disabled" type="file" onchange="angular.element(this).scope().processImage(this)"/>'
        + ' <div class="h6 grey-500-fg font-weight-300">El nombre del archivo no puede contener tildes o caracteres especiales.</div>'
        + ' <div ng-if="error" class="p-5 h6 red-500-fg">{{error}}</div>'
        + '</div>',
      controller: function ($scope, $element, $attrs) {
        if ($scope.value && $scope.value != null && $scope.value != 'undefined') {
          $scope.options.ngModel[$scope.options.field] = true;
        }
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.processImage = function (element) {
          var reader = new FileReader();
          reader.onload = function (event) {
            $scope.$apply(function ($scope) {
              $scope.uploadFile(element.files[0]);
            });
          }
          reader.readAsDataURL(element.files[0]);
        };

        $scope.uploadFile = function (file) {

          $scope.error = "";
          var fd = new FormData();
          fd.append('app_file', file);
          fd.append("field", $scope.options.field);
          fd.append("model", $scope.options.model);
          if ($scope.options.idblock) {
            fd.append("id", $scope.options.idblock);
          }

          var config = {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
          };

          CandidateService.saveFile(fd, config,
            function (response) {
              if (response.data.result.status) {
                $scope.options.ngModel[$scope.options.field] = true;
                if (!$scope.options.idblock) {
                  if (localStorage.getItem('FormData')) {
                    var localData = JSON.parse(localStorage.getItem('FormData'));
                    localData.push({
                      formData: {
                        field: $scope.options.field,
                        model: $scope.options.model,
                        file: response.data.result.data
                      },
                      fieldModule: $scope.options.fieldModule,
                      field: $scope.options.field
                    });
                    localStorage.setItem('FormData', JSON.stringify(localData));
                  } else {
                    localStorage.setItem('FormData', JSON.stringify([{
                      formData: {
                        field: $scope.options.field,
                        model: $scope.options.model,
                        file: response.data.result.data
                      },
                      fieldModule: $scope.options.fieldModule,
                      field: $scope.options.field
                    }]));
                  }

                }
                if ($scope.options.attachments[$scope.options.fieldModule] && $scope.options.attachments[$scope.options.fieldModule][$scope.options.idblock]) {
                  $scope.options.attachments[$scope.options.fieldModule][$scope.options.idblock].push(response.data.result.data);
                } else if ($scope.options.attachments[$scope.options.fieldModule] && $scope.options.attachments[$scope.options.fieldModule] instanceof Array) {
                  $scope.options.attachments[$scope.options.fieldModule].push(response.data.result.data);
                } else {
                  $scope.options.attachments[$scope.options.fieldModule] = {};
                  $scope.options.attachments[$scope.options.fieldModule][$scope.options.idblock] = [];
                  $scope.options.attachments[$scope.options.fieldModule][$scope.options.idblock].push(response.data.result.data);
                }

                if ($scope.options.attachments[$scope.options.field]) {
                  $scope.options.attachments[$scope.options.field].push(response.data.data);
                }
              } else {
                $scope.error = "Formato de archivo no soportado";
              }
            },
            function (response) {
              $scope.error = "Ha ocurrido un error";
            }
          );
        }

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputFileanalista(CandidateService) {
    return {
      require: 'Upload',
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<div class="mb-0 all-width">'
        + '<div class="h6 grey-500-fg font-weight-300">{{label}}</div>'
        + ' <input class="" ng-disabled="disabled" type="file" onchange="angular.element(this).scope().processImage(this)"/>'
        + ' <div ng-if="error" class="p-5 h6 red-500-fg">{{error}}</div>'
        + '</div>',
      controller: function ($scope, $element, $attrs) {
        $scope.disabled = false;
        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.processImage = function (element) {
          var reader = new FileReader();
          reader.onload = function (event) {
            $scope.$apply(function ($scope) {
              $scope.uploadFile(element.files[0]);
            });
          }
          reader.readAsDataURL(element.files[0]);
        };

        $scope.uploadFile = function (file) {
          var fd = new FormData();
          fd.append('app_file', file);
          fd.append("field", $scope.options.field);
          fd.append("model", $scope.options.block);
          if ($scope.options.idblock) {
            fd.append("id", $scope.options.idblock);
          }
          if (!angular.equals($scope.options.extra, {})) {
            fd.append("etapa_id", $scope.options.extra.etapa_id);
            fd.append("proceso_id", $scope.options.extra.proceso_id);
            fd.append("hv_id", $scope.options.extra.hv_id);
          }

          var config = {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
          };

          CandidateService.savefileanalista(fd, config,
            function (response) {
              if (response.data.status) {
                if ($scope.options.attachments[$scope.options.fieldModule] && $scope.options.attachments[$scope.options.fieldModule][$scope.options.idblock]) {
                  $scope.options.attachments[$scope.options.fieldModule][$scope.options.idblock].push(response.data.data);
                } else if ($scope.options.attachments[$scope.options.fieldModule] && $scope.options.attachments[$scope.options.fieldModule] instanceof Array) {
                  $scope.options.attachments[$scope.options.fieldModule].push(response.data.data);
                } else {
                  $scope.options.attachments[$scope.options.fieldModule] = {};
                  $scope.options.attachments[$scope.options.fieldModule][$scope.options.idblock] = [];
                  $scope.options.attachments[$scope.options.fieldModule][$scope.options.idblock].push(response.data.data);
                }
                if ($scope.options.attachments[$scope.options.field]) {
                  $scope.options.attachments[$scope.options.field].push(response.data.data);
                } else {
                  $scope.options.attachments[$scope.options.field] = [];
                  $scope.options.attachments[$scope.options.field].push(response.data.data);
                }
                $scope.error = "";
              } else {
                $scope.error = response.data.message;
              }
            },
            function (response) {
              $scope.error = response.data.message;
            }
          );
        }
      }
    };
  }

  function inputMatriz(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      templateUrl: 'app/main/templates/directive/matriz/matriz.html',
      controller: function ($scope, $element, $attrs) {

        $scope.disabled = false;

        if ($scope.options.permission !== "") {
          $scope.disabled = ($scope.options.permission ? false : true);
        }

        $scope.nameColumns = [];
        $scope.configrows = [];

        $scope.nameColumns.push('Factor');

        for (var c in $scope.options.cols) {
          var col = $scope.options.cols[c];
          var keyColCurrent = Object.keys(col)[0];
          var valueColCurrent = col[keyColCurrent];
          $scope.nameColumns.push(valueColCurrent.label);
        }

        for (var r in $scope.options.rows) {
          var rowsCurrent = $scope.options.rows[r];
          var keyCurrent = Object.keys(rowsCurrent)[0];
          var textCurrent = rowsCurrent[keyCurrent];
          $scope.configrows.push({
            factor: {
              type: 'read',
              value: textCurrent
            }
          });
          for (var c in $scope.options.cols) {
            var col = $scope.options.cols[c];
            var keyColCurrent = Object.keys(col)[0];
            var valueColCurrent = col[keyColCurrent];
            $scope.configrows[$scope.configrows.length - 1][valueColCurrent.label] = {
              type: valueColCurrent.type,
              model: keyCurrent + keyColCurrent
            };
          }
        }

        //$scope.options.ngModel[$scope.options.field] = $scope.value;

        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function inputLabel(ValidationService) {
    return {
      restrict: 'E',
      scope: {
        label: '@',
        value: '@',
        options: '='
      },
      template: '<div class="mb-0 all-width pt-5 pb-5">'
        + '<div class="h4 grey-600-fg font-weight-500">{{label}}</div>'
        + '</div>',
      controller: function ($scope, $element, $attrs) {
        //console.log($scope);
        var watch = $scope.$watch(function () {
          return $element.children().length;
        }, function () {
          $scope.$evalAsync(function () {
            ValidationService.validateForm($scope.options.block, $scope, $scope.options);
          });
        });
      }
    };
  }

  function fileModel($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var model = $parse(attrs.fileModel);
        var modelSetter = model.assign;

        element.bind('change', function () {
          scope.$apply(function () {
            modelSetter(scope, element[0].files[0]);
          });
        });
      }
    };
  }

  function mdx($mdThemingProvider) {
    return {
      $get: function () {
        "use strict";
        return {
          mdxThemeColors: $mdThemingProvider
        }
      }
    }
  }

  function mdxPaintFg(mdx) {
    return {
      restrict: 'A',
      link: function (scope, element, attributes) {
        setRGB(element, 'color', mdx.mdxThemeColors, attributes.mdxPaintFg, 'mdx-paint-fg');
      }
    };
  }

  function mdxPaintBg(mdx) {
    return {
      restrict: 'A',
      link: function (scope, element, attributes) {
        setRGB(element, 'background-color', mdx.mdxThemeColors, attributes.mdxPaintBg, 'mdx-paint-bg');
      }
    };
  }

  function setRGB(element, styled, themeProvider, input, directiveName) {
    "use strict";
    var themeName = 'default';
    var hueName = 'default';
    var intentionName = 'primary';
    var hueKey, theme, hue, intention;

    // Do our best to parse out the attributes
    angular.forEach(input.split(" "), function (value, key) {
      if (0 === key) {
        themeName = value;
      } else if ({
        primary: 'primary',
        accent: 'accent',
        warn: 'warn',
        background: 'background'
      }[value]) {
        intentionName = value;
      } else if ({
        default: 'default',
        'hue-1': 'hue-1',
        'hue-2': 'hue-2',
        'hue-3': 'hue-3'
      }[value]) {
        hueName = value;
      } else if ({
        '50': '50',
        '100': '100',
        '200': '200',
        '300': '300',
        '400': '400',
        '500': '500',
        '600': '600',
        '700': '700',
        '800': '800',
        'A100': 'A100',
        'A200': 'A200',
        'A400': 'A400',
        'A700': 'A700'
      }[value]) {
        hueKey = value;
      }
    });

    // Lookup and assign the right values
    if ((theme = (themeProvider._THEMES[themeName] || themeProvider._THEMES.default))) {
      if ((intention = theme.colors[intentionName])) {
        if (!hueKey) {
          hueKey = intention.hues[hueName];
        }
        if ((hue = themeProvider._PALETTES[intention.name][hueKey])) {
          element.css(styled, 'rgb(' + hue.value[0] + ',' + hue.value[1] + ',' + hue.value[2] + ')');
          return;
        }
      }
    }
    reportError("%s='%s' bad or missing attributes", directiveName, input);
  }

  function reportError(errString, name, input) {
    "use strict";
    console.error(errString, name, input);
    console.log('  usage %s="[theme] intention [hue]"', name);
    console.log('  acceptable intentions : primary,accent,warn,background');
    console.log('  acceptable hues     : default,hue-1,hue-2,hue-3');
  }

})();

(function () {
    'use strict'

    angular.module('app.auth')
        .directive('filterLista', filterLista);

    function filterLista($mdDateLocale) { 
        return {
            restrict: 'E',
            scope: {   
                filters: '=',
                callbacksenddata: '&',
                callbackcleardata: '&',
                filtersdata: '='
            },
            templateUrl: 'app/main/templates/directive/filter/filterlista.html',
            controllerAs: 'vm',
            controller: function ($scope, $element, $attrs,$filter) {
                var vm = this;

                vm.limit = 10;

                $mdDateLocale.formatDate = function (date) {
                    return date ? moment(date).format('DD/MMMM/YYYY') : '';
                };
 
                vm.filtersMisc = [];
                vm.valueFilter =  {};

                function setFilter() {
                    vm.filtersMisc = angular.copy($scope.filters);
                    for (var i in vm.filtersMisc) {
                        var filter = vm.filtersMisc[i];
                        if (vm.filtersMisc[i].options) {
                            vm.filtersMisc[i].options = modelFilter(vm.filtersMisc[i].options);
                        }
                        if (vm.filtersMisc[i].dependency) {
                            vm.filtersMisc[i].show = false;
                        } else {
                            vm.filtersMisc[i].show = true;
                        }
                        if(vm.valueFilter[filter.id]){
                            if(filter.type == 'DATE' || filter.type == 'DATE_BETWEEN'){
                                vm.valueFilter[filter.id] = moment(vm.valueFilter[filter.id]).toDate();
                            }
                        }
                    }
                }

                function setData() {
                    vm.valueFilter = $scope.filtersdata ? $scope.filtersdata : {};
                }

                function modelFilter(data) {
                    var arrReturn = [];
                    if (!angular.equals(data, {}) && data instanceof Object) {
                        angular.forEach(data, function (v, k) {
                            
                            var key = parseInt(k);
                            if(isNaN(key)){
                                key = k
                            }
                            arrReturn.push({ id: key, name: v });
                        });
                        arrReturn.sort(function (a, b) {
                            if (a.name < b.name) { return -1; }
                            if (a.name > b.name) { return 1; }
                            return 0;
                        });
                    }
                    return arrReturn;
                }

                function changeDependency(current) {
                    var dependency = vm.filtersMisc.filter(function (row) {
                        return row.dependency;
                    });
                    if (dependency.length == 0) {
                        return;
                    }
                    for (var i in vm.filtersMisc) {
                        for (var j in dependency) {
                            if (vm.valueFilter[dependency[j].dependency] && vm.filtersMisc[i].id == dependency[j].id) {
                                vm.filtersMisc[i].show = true;
                                break;
                            } else if (!vm.valueFilter[dependency[j].dependency] && vm.filtersMisc[i].id == dependency[j].id) {
                                vm.filtersMisc[i].show = false;
                                break;
                            }
                        }
                    }
                }

                function changeDate(current) {
                    var date = vm.filtersMisc.filter(function (row) {
                        return row.type == 'DATE';
                    });

                    if (date.length == 0) {
                        return;
                    }


                    for (var i in date) {
                        getDateBetween(date[i].relation_id, date[i].id);
                    }

                }

                function getDateBetween(id, idOrigin) {
                    var date_between = vm.filtersMisc.filter(function (row) {
                        return (row.type == 'DATE_BETWEEN' && row.id == id);
                    });

                    if (date_between.length == 0) {
                        return;
                    }
                    if (vm.valueFilter[date_between[0].id]) {

                        if (vm.valueFilter[idOrigin]) {
                            if (moment(vm.valueFilter[date_between[0].id]) > moment(vm.valueFilter[idOrigin])) {
                                vm.valueFilter[idOrigin] = '';
                            }
                        }

                        for (var i in vm.filtersMisc) {
                            if (vm.filtersMisc[i].id == idOrigin) {
                                vm.filtersMisc[i].min_date = vm.valueFilter[date_between[0].id];
                            }
                        }
                    }
                };

                function validateDate() {
                    var date = vm.filtersMisc.filter(function (row) {
                        return row.type == 'DATE';
                    });

                    if (date.length == 0) {
                        return true;
                    }

                    for (var i in date) {

                        if ((!vm.valueFilter[date[i].id] || vm.valueFilter[date[i].id] == "") && (vm.valueFilter[date[i].relation_id] && vm.valueFilter[date[i].relation_id] != "")) {
                            return false;
                        }

                        if ((!vm.valueFilter[date[i].relation_id] || vm.valueFilter[date[i].relation_id] == "") && (vm.valueFilter[date[i].id] && vm.valueFilter[date[i].id] != "")) {
                            return false;
                        }

                    }



                    return true;
                }

                vm.sendData = function(){
                    var filtros = {};
                    for(var i in vm.filtersMisc){
                        var filternow = vm.filtersMisc[i].id;
                        if(vm.valueFilter[filternow] == null || vm.valueFilter[filternow] == 'undefined'){
                            continue;
                        }

                        if (vm.filtersMisc[i].type == 'DATE' || vm.filtersMisc[i].type == 'DATE_BETWEEN') {
                            filtros[filternow] = moment(vm.valueFilter[filternow]).format('YYYY-MM-DD');
                            continue;
                        }

                        if(vm.filtersMisc[i].type == "AUTOCOMPLETE"){
                            filtros[filternow] = vm.valueFilter[filternow].id;
                            continue;
                        }

                        if(vm.valueFilter[i] instanceof Object){
                            filtros[filternow] = vm.valueFilter[filternow].id;
                        }else{
                            filtros[filternow] = vm.valueFilter[filternow];
                        }
                    }
                    $scope.callbacksenddata({filter:filtros});
                }

                vm.clearData = function(){
                    vm.valueFilter = {};
                    $scope.callbackcleardata();
                }

                vm.search = function (arr, filter) {
                    var arrReturn = [];
                    if (filter && filter.length >= 3) {
                        return $filter('filter')(arr, filter);
                    } else {
                        for (var i = 0; i < vm.limit; i++) {
                            var pushIndex = i + length;
                            arrReturn.push(arr[pushIndex]);
                        }
                    }
                    return arrReturn;
                }

                $scope.$watch('filters', function (newValue, oldValue) {
                    if (newValue) {
                        setData();
                        setFilter();
                        
                    }
                }, true);

                $scope.$watch('vm.valueFilter', function (current) {
                    if (vm.filtersMisc.length == 0) { return; }
                    changeDependency(current);
                    changeDate(current);
                }, true);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $location) {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        //moment.tz.setDefault("America/New_York");
        // Store state in the root scope for easy access
        $rootScope.state = $state;
        //console.log($state);
        

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, globalConstant) {
        $locationProvider.html5Mode(true);

        //if ($state.current.name == "" || $state.current.views == null) {
        //console.log("entro a redireccion url");
        var arrUrl = globalConstant.URL;

        var host = window.location.hostname;

        if (arrUrl.indexOf(host) == -1) {
            if (host.search("requisicion") !== -1 || host.search("rq") !== -1) {
                $urlRouterProvider.when("", "/req");
                $urlRouterProvider.when("/", "/req");
                $urlRouterProvider.otherwise('/req');
            } else {
                $urlRouterProvider.when("", '/dashboard/');
                $urlRouterProvider.when("/", '/dashboard/');
                $urlRouterProvider.otherwise('/dashboard/');
            }
            /*if(host.search("seleccion") !== -1 || host.search("analista") !== -1){
                $urlRouterProvider.when("", "/login-analyst");
                $urlRouterProvider.when("/", "/login-analyst");
                $urlRouterProvider.otherwise('/login-analyst');
            } else if(host.search("requisicion") !== -1 || host.search("rq") !== -1){
                $urlRouterProvider.when("", "/login-req");
                $urlRouterProvider.when("/", "/login-req");
                $urlRouterProvider.otherwise('/login-req');
            }else{
                $urlRouterProvider.when("", "/login-admin");
                $urlRouterProvider.when("/", "/login-admin");
                $urlRouterProvider.otherwise('/login-admin');
            }*/

        } else {
            $urlRouterProvider.when("", '/dashboard/');
            $urlRouterProvider.when("/", '/dashboard/');
            $urlRouterProvider.otherwise('/dashboard/');
        }
        //}



        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('fuse')
        .provider('apiProvider', apiProvider);

    function apiProvider() {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url) {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl() {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject() {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource) {
            if (!angular.isString(key)) {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if (!angular.isArray(resource)) {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url: baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions: resource[2] || [],
                options: resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope) {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register: register,
                resolve: resolve,
                request: request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters) {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response) {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response) {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error) {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response) {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');

                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if (angular.isDefined(success) && angular.isFunction(success)) {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response) {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');

                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if (angular.isDefined(error) && angular.isFunction(error)) {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, msNavigationService)
    {
        var vm = this;
        
        // Data
        vm.themes = fuseTheming.themes;

        var domain = localStorage.getItem('DOMAIN_SELECTION');

        vm.splashLogo = "/assets/licenses/localhost/images/logos/logo.png";
        if (domain) {
            vm.splashLogo = "/assets/licenses/" + domain + "/images/logos/logo.png";
        }
        //////////
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .constant('globalConstant', {
            VERSION: '1.1.2',
            RAMA: 'master',
            URL: [
                'desarrollo-tecnoquimicas.ikanosmart.com',
                'pruebas-tecnoquimicas.ikanosmart.com',
                'tecnoquimicas.ikanosmart.com',
                'desarrollo-colombina.ikanosmart.com',
                'pruebas-colombina.ikanosmart.com',
                'colombina.ikanosmart.com',
                'desarrollo-riopailacastilla.ikanosmart.com',
                'pruebas-riopailacastilla.ikanosmart.com',
                'riopailacastilla.ikanosmart.com',
                'n.ikanosmart.com',
                'seleccion.tqconfiable.com',
                'pruebas-candidatostq.ikanosmart.com'
            ],
            LISTSLOGIN: [
                'cargos',
                'generos',
                'paises',
                'departamentos',
                'ciudades',
                'areas'
            ]
        });
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, $httpProvider) {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
        $httpProvider.interceptors.push(validateToken);
    }

    function validateToken($location, $injector, $q, $rootScope,globalConstant) {
        // Para mostrar el spinner que se ve mientras se está haciendo un request
        var numLoadings = 0;

        return {
            request: function (config) {
               //console.log(config);
                if(config.jwt){
                    console.log(config);
                }
                var licenseKey = localStorage.getItem('LICENSE_KEY_SELECTION');
                var jwt = localStorage.getItem('JWT_SELECTION');
                numLoadings++;

                if(config.jwt){
                    config.headers['X-Auth-Token'] = config.jwt;
                    return config || $q.when(config);
                }


                if (licenseKey) {
                    config.headers['X-Token-Licencia'] = licenseKey;
                }

                if (jwt) {
                    config.headers['X-Auth-Token'] = jwt;
                }

                

                // Show loader
                //$rootScope.$broadcast("loader_show");
                return config || $q.when(config);
            },

            requestError: function (config) {
                if ((--numLoadings) === 0) {
                    // Hide loader
                    $rootScope.$broadcast("loader_hide");
                }

                return config;
            },

            response: function (response) {
                if ((--numLoadings) === 0) {
                    // Hide loader
                    $rootScope.$broadcast("loader_hide");
                }

                return response || $q.when(response);
            },

            responseError: function (response) {
                if ((--numLoadings) === 0) {
                    // Hide loader
                    $rootScope.$broadcast("loader_hide");
                }

                //token error
                if (response.status == 401) {
                    var u = localStorage.getItem('USER_DATA_SELECTION');
                    $injector.get('AuthService').logout();
                    if (u) {
                        var user = JSON.parse(u);
                        if (user && (user.group_id == 1 )) {
                            $injector.get('$state').transitionTo('app.auth-login-admin');
                        } else if(user.group_id == 5){
                            $injector.get('$state').transitionTo('app.auth-login-analyst');
                        } else if(user.group_id == 8 || user.group_id == 7){
                            $injector.get('$state').transitionTo('app.auth-login-requisicion');
                        } else {
                            $injector.get('$state').transitionTo('app.auth-login');
                        }
                    } else {
                        var arrUrl = globalConstant.URL;
                        var host = window.location.hostname;
                        if (arrUrl.indexOf(host) == -1) {
                            if(host.search("requisicion") !== -1 || host.search("rq") !== -1){
                                $injector.get('$state').transitionTo('app.auth-login-requisicion');
                            }else{
                                $injector.get('$state').transitionTo('app.auth-login');
                            }
                        } else {
                            $injector.get('$state').transitionTo('app.auth-login');
                        }
                    }
                }

                return $q.reject(response);
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $http, $location, $mdDialog, analystConstant, $rootScope) {
        var api = {};
        var host = $location.host();
        var hostParts = host.split('.');
        var domain = hostParts[0];
        /* url API */
        //var API_LOCAL = 'http://192.168.0.18:3000';
        //var API_LOCAL = 'http://localhost:3000';
        var API_LOCAL = 'http://pruebas-apiseleccion.ikanosmart.com';
        var API_DEV = 'http://desarrollo-apiseleccion.ikanosmart.com';
        var API_TEST_RP = 'http://pruebasrp-apiseleccion.ikanosmart.com';
        var API_TEST = 'http://pruebas-apiseleccion.ikanosmart.com';
        var API_PROD = 'http://apiseleccion.ikanosmart.com';
        var API_PROD_N = 'http://apiv2.ikanosmart.com';
        var API_PROD_RP = 'http://apiriopailaseleccion.ikanosmart.com';
        var API_DEMO = 'http://demo-apiseleccion.ikanosmart.com';
        /* License Keys */
        var LICENSE_KEY_TQ = 'tyJ0eXAiOiJKV1QiLCJhbGciO';
        var LICENSE_KEY_COLOMBINA = 'jE1NDE5MywiZ3JvdXBfaWQiOj';
        var LICENSE_KEY_RIOPAILA = 'kxMDg0OTZ9h5XkTrjIxTNbfLT';
        var LICENSE_KEY_DEMO = 'd3m01k4n0sm4rt';


        if (host.search("pruebas") !== -1) {
            switch (host) {
                case 'pruebas-analistatq.ikanosmart.com':
                case 'pruebas-admintq.ikanosmart.com':
                case 'pruebas-candidatostq.ikanosmart.com':
                case 'pruebas-tecnoquimicasrq.ikanosmart.com':
                    api.baseUrl = API_TEST;
                    break;
                case 'pruebas-riopailacastillarq.ikanosmart.com':
                case 'pruebas-riopailacastillaseleccion.ikanosmart.com':
                case 'pruebas-riopailacastilla.ikanosmart.com':
                    api.baseUrl = API_TEST;
                    break;
                case 'pruebas-colombinarq.ikanosmart.com':
                case 'pruebas-colombinaseleccion.ikanosmart.com':
                case 'pruebas-colombina.ikanosmart.com':
                    api.baseUrl = API_TEST;
                    break;
            }
        } else if (host.search("-") == -1) {
            switch (host) {
                case 'tecnoquimicasrq.ikanosmart.com':
                case 'tecnoquimicasseleccion.ikanosmart.com':
                case 'tecnoquimicas.ikanosmart.com':

                    api.baseUrl = API_PROD.replace("http", "https");
                    break;
                case 'nrq.ikanosmart.com':
                case 'nseleccion.ikanosmart.com':
                case 'n.ikanosmart.com':
                    api.baseUrl = API_PROD_N.replace("http", "https");
                    break;
                case 'seleccion.tqconfiable.com':
                case 'analistatq.ikanosmart.com':
                case 'admintq.ikanosmart.com':
                case 'requisicion.tqconfiable.com':
                    api.baseUrl = API_PROD_N.replace("http", "https");
                    break;
                case 'riopailacastillarq.ikanosmart.com':
                case 'riopailacastillaseleccion.ikanosmart.com':
                case 'riopailacastilla.ikanosmart.com':
                    api.baseUrl = API_PROD_RP.replace("http", "https");
                    break;
                case 'colombinarq.ikanosmart.com':
                case 'colombinaseleccion.ikanosmart.com':
                case 'colombina.ikanosmart.com':
                    api.baseUrl = API_PROD.replace("http", "https");
                    break;
            }
        } else {

            api.baseUrl = API_DEV;
        }

        switch (host) {
            case 'localhost':
                api.baseUrl = API_LOCAL;
                localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_TQ);
                //localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_COLOMBINA);
                //localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_RIOPAILA);
                localStorage.setItem('DOMAIN_SELECTION', "tecnoquimicas");
                //localStorage.setItem('DOMAIN_SELECTION', "colombina");
                //localStorage.setItem('DOMAIN_SELECTION', "riopaila");
                localStorage.setItem('HELP_URL', "TQREQ_");
                break;

            //PRUEBA
            case 'pruebas-analistatq.ikanosmart.com':
            case 'pruebas-admintq.ikanosmart.com':
            case 'pruebas-candidatostq.ikanosmart.com':
            //RQ
            case 'desarrollo-tecnoquimicasrq.ikanosmart.com':
            case 'pruebas-tecnoquimicasrq.ikanosmart.com':
            case 'tecnoquimicasrq.ikanosmart.com':


            //SELECCION
            case 'desarrollo-tecnoquimicasseleccion.ikanosmart.com':
            case 'pruebas-tecnoquimicasseleccion.ikanosmart.com':
            case 'tecnoquimicasseleccion.ikanosmart.com':
            //CANDIDATO
            case 'desarrollo-tecnoquimicas.ikanosmart.com':
            case 'pruebas-tecnoquimicas.ikanosmart.com':
            case 'tecnoquimicas.ikanosmart.com':
            // N
            case 'nrq.ikanosmart.com':
            case 'nseleccion.ikanosmart.com':
            case 'n.ikanosmart.com':
            // N
            case 'seleccion.tqconfiable.com':
            case 'analistatq.ikanosmart.com':
            case 'admintq.ikanosmart.com':
            case 'requisicion.tqconfiable.com':
                //api.baseUrl = API_DEV;
                localStorage.setItem('DOMAIN_SELECTION', "tecnoquimicas");
                localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_TQ);
                localStorage.setItem('HELP_URL', "TQREQ_");
                break;

            //RQ
            case 'desarrollo-colombinarq.ikanosmart.com':
            case 'pruebas-colombinarq.ikanosmart.com':
            case 'colombinarq.ikanosmart.com':
            //SELECCION
            case 'desarrollo-colombinaseleccion.ikanosmart.com':
            case 'pruebas-colombinaseleccion.ikanosmart.com':
            case 'colombinaseleccion.ikanosmart.com':
            //CANDIDATO
            case 'desarrollo-colombina.ikanosmart.com':
            case 'pruebas-colombina.ikanosmart.com':
            case 'colombina.ikanosmart.com':
                //api.baseUrl = API_DEV;
                localStorage.setItem('DOMAIN_SELECTION', "colombina");
                localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_COLOMBINA);
                localStorage.setItem('HELP_URL', "CLMB_");
                break;

            //RQ
            case 'desarrollo-riopailacastillarq.ikanosmart.com':
            case 'pruebas-riopailacastillarq.ikanosmart.com':
            case 'riopailacastillarq.ikanosmart.com':
            //SELECCION
            case 'desarrollo-riopailacastillaseleccion.ikanosmart.com':
            case 'pruebas-riopailacastillaseleccion.ikanosmart.com':
            case 'riopailacastillaseleccion.ikanosmart.com':
            //CANDIDATO
            case 'desarrollo-riopailacastilla.ikanosmart.com':
            case 'pruebas-riopailacastilla.ikanosmart.com':
            case 'riopailacastilla.ikanosmart.com':
                //api.baseUrl = API_DEV;
                localStorage.setItem('DOMAIN_SELECTION', "riopaila");
                localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_RIOPAILA);
                localStorage.setItem('HELP_URL', "");
                break;

            case 'demo-requisiciones.ikanosmart.com':
            case 'demo-seleccion.ikanosmart.com':
            case 'demo.ikanosmart.com':
                api.baseUrl = API_DEMO;
                localStorage.setItem('DOMAIN_SELECTION', "demoikanosmart");
                localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_DEMO);
                localStorage.setItem('HELP_URL', "");
                break;
        }

        /** LOCAL
        if (host == 'localhost') {
            api.baseUrl = API_LOCAL;
            localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_TQ);
            //localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_COLOMBINA);
            //localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_RIOPAILA);
            localStorage.setItem('DOMAIN_SELECTION', "tecnoquimicas");
            //localStorage.setItem('DOMAIN_SELECTION', "colombina");
            //localStorage.setItem('DOMAIN_SELECTION', "riopaila");
            localStorage.setItem('HELP_URL', "TQREQ_");


        } **/

        /** Desarollo
        // TQ
        else if (host == 'desarrollo-tecnoquimicasrq.ikanosmart.com') {
            api.baseUrl = API_DEV;
            localStorage.setItem('DOMAIN_SELECTION', "tecnoquimicas");
            localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_TQ);
            localStorage.setItem('HELP_URL', "TQREQ_");
        }
        // Colombina
        else if (host == 'desarrollo-colombinarq.ikanosmart.com') {
            api.baseUrl = API_DEV;
            localStorage.setItem('DOMAIN_SELECTION', "colombina");
            localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_COLOMBINA);
            localStorage.setItem('HELP_URL', "CLMB_");
        }
        // Riopaila Castilla
        else if (host == 'desarrollo-riopailacastillarq.ikanosmart.com') {
            api.baseUrl = API_DEV;
            localStorage.setItem('DOMAIN_SELECTION', "riopaila");
            localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_RIOPAILA);
            localStorage.setItem('HELP_URL', "");
        } **/

        /** Pruebas
        // TQ
        else if (host == 'pruebas-tecnoquimicasrq.ikanosmart.com') {
            api.baseUrl = API_TEST_RP;
            localStorage.setItem('DOMAIN_SELECTION', "tecnoquimicas");
            localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_TQ);
            localStorage.setItem('HELP_URL', "TQREQ_");
        }
        // Colombina
        else if (host == 'pruebas-colombinarq.ikanosmart.com') {
            api.baseUrl = API_TEST_RP;
            localStorage.setItem('DOMAIN_SELECTION', "colombina");
            localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_COLOMBINA);
            localStorage.setItem('HELP_URL', "CLMB_");
        }
        // Riopaila Castilla
        else if (host == 'pruebas-riopailacastillarq.ikanosmart.com') {
            api.baseUrl = API_TEST_RP;
            localStorage.setItem('DOMAIN_SELECTION', "riopaila");
            localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_RIOPAILA);
            localStorage.setItem('HELP_URL', "");
        } **/

        /** Producción
        // TQ
        else if (host == 'tecnoquimicasrq.ikanosmart.com' || host == 'requisicion.tqconfiable.com') {
            api.baseUrl = API_PROD.replace("http", "https");
            localStorage.setItem('DOMAIN_SELECTION', "tecnoquimicas");
            localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_TQ);
            localStorage.setItem('HELP_URL', "TQREQ_");
        }
        // Colombina
        else if (host == 'colombinarq.ikanosmart.com') {
            api.baseUrl = API_PROD.replace("http", "https");
            localStorage.setItem('DOMAIN_SELECTION', "colombina");
            localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_COLOMBINA);
            localStorage.setItem('HELP_URL', "CLMB_");
        }
        // Riopaila Castilla
        else if (host == 'riopailacastillarq.ikanosmart.com') {
            api.baseUrl = API_PROD.replace("http", "https");
            //api.baseUrl = "http://pruebasrp-apiseleccion.ikanosmart.com";
            localStorage.setItem('DOMAIN_SELECTION', "riopaila");
            localStorage.setItem('LICENSE_KEY_SELECTION', LICENSE_KEY_RIOPAILA);
            localStorage.setItem('HELP_URL', "");
        } **/

        /*** General ***/
        api.general = {
            getUrlBase: function () {
                return api.baseUrl;
            },
            urlHelp: 'http://usermanual.ikanosmart.com/login/'
        };

        /*** Login ***/
        api.authentication = {
            getLoginDashboardOffers: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/ofertas_home', data, config, callback_success, callback_error);
            },
            login: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/login', data, config, callback_success, callback_error);
            },
            loginToken: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/login_token', data, config, callback_success, callback_error);
            },
            logout: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/logout', data, config, callback_success, callback_error);
            },
            signin: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/crear_registro_hv', data, config, callback_success, callback_error);
            },
            getUserData: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/get_perfil', data, config, callback_success, callback_error);
            },
            getInforecoverPassword: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_info_recuperar_passwd', data, config, callback_success, callback_error);
            },
            recoverPasswordByEmail: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/email_recover_password', data, config, callback_success, callback_error);
            },
            recoverPasswordByQuestions: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/recover_password_hv', data, config, callback_success, callback_error);
            },
            recoverPassword: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/recover_password', data, config, callback_success, callback_error);
            },
            getQuestionsForRecoverPassword: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_preguntas_hv', data, config, callback_success, callback_error);
            },
            validateSignup: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/validate_registro_hv', data, config, callback_success, callback_error);
            },
            socialNetworkLogin: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/login_redes', data, config, callback_success, callback_error);
            },
            socialNetworkSignin: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/finalizar_registro_hv', data, config, callback_success, callback_error);
            },
            getLoginType: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/get_license_data', data, config, callback_success, callback_error);
            },
            licenseLogin: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/login_licencia', data, config, callback_success, callback_error);
            },
            save_respuesta_acuerdo_servicio: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + '/api/ikano/seleccion/save_respuesta_acuerdo_servicio';
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
        };

        /*** Candidate ***/
        api.candidate = {
            getDashboard: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/ikano/seleccion_dashboard', data, config, callback_success, callback_error);
            },
            changePassword: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/change_password', data, config, callback_success, callback_error);
            },
            getAppliedOffers: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/ikano/seleccion_ofertas_aplico', data, config, callback_success, callback_error);
            },
            getOffersSuggested: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_ofertas_disponibles', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_ofertas_disponibles', data, config, callback_success, callback_error);
            },
            getApplyOfferInfo: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/info_aplicar_oferta', data, config, callback_success, callback_error);
            },
            applyOffer: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/aplicar_oferta', data, config, callback_success, callback_error);
            },
            getResumeData: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion_ver_hojavida', data, config, callback_success, callback_error);
            },
            saveResumeBlock: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_hoja_vida', data, config, callback_success, callback_error);
            },
            getLists: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/listas_hojavida', data, config, callback_success, callback_error);
            },
            deleteBlock: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/delete_bloque_hoja_vida', data, config, callback_success, callback_error);
            },
            saveFile: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_file_hv', data, config, callback_success, callback_error);
            },
            savefileanalista: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_file_analista', data, config, callback_success, callback_error);
            },
            deletefileanalista: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/delete_file_analista', data, config, callback_success, callback_error);
            },
            getFileUrl: function () {
                return api.baseUrl + '/api/get_file/';
            },
            getFile: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + '/api/get_file/' + data.id;
                download_file(url, config, callback_success, callback_error, configLoad);
            },
            deleteFile: function (id, data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/delete_file/' + id, data, config, callback_success, callback_error);
            },
            saveResumePhoto: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_photo_hv', data, config, callback_success, callback_error);
            },
            acceptAgreement: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/aceptar_acuerdo_servicio', data, config, callback_success, callback_error);
            },


        };

        api.requester = {
            getRequests: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_jefe', data, config, callback_success, callback_error);
            },
            getRequestsByAdmin: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_admin', data, config, callback_success, callback_error);
            },
            getRequestsByApprover: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_aprobador', data, config, callback_success, callback_error);
            },
            getRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_requisicion_colaborador', data, config, callback_success, callback_error);
            },
            getRequestApprover: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_requisicion_aprobador', data, config, callback_success, callback_error);
            },
            getRequestAdmin: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_requisicion_admin', data, config, callback_success, callback_error);
            },
            saveRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_requisicion_colaborador', data, config, callback_success, callback_error);
            },
            saveRequestAdmin: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_requisicion_admin', data, config, callback_success, callback_error);
            },
            saveRequestApprover: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_requisicion_aprobador', data, config, callback_success, callback_error);
            },
            sendRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/enviar_solicitud_requisicion', data, config, callback_success, callback_error);
            },
            cloneRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/duplicar_requisicion', data, config, callback_success, callback_error);
            },
            cancelRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/anular_requisicion', data, config, callback_success, callback_error);
            },
            divideRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/dividir_requisicion', data, config, callback_success, callback_error);
            },
            approveRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/aprobar_requisicion', data, config, callback_success, callback_error);
            },
            undoApproveRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/deshacer_aprobar_requisicion', data, config, callback_success, callback_error);
            },
            saveObservationsRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_observaciones_requisicion', data, config, callback_success, callback_error);
            },
            deleteObservationsRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/delete_observaciones_requisicion', data, config, callback_success, callback_error);
            },
            dismissRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/rechazar_requisicion', data, config, callback_success, callback_error);
            },
            undoDismissRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/deshacer_rechazar_requisicion', data, config, callback_success, callback_error);
            },
            giveBackRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/devolver_requisicion', data, config, callback_success, callback_error);
            },
            getPDFReport: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/get_pdf', data, config, callback_success, callback_error);
            },
            //Requester
            getDraftRequests: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_construccion', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_construccion', data, config, callback_success, callback_error);
            },
            getInProcessRequests: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_enaprobacion', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_enaprobacion', data, config, callback_success, callback_error);
            },
            getApproveRequests: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_aprobadas', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_aprobadas', data, config, callback_success, callback_error);
            },
            getNoApproveRequests: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_noaprobadas', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_noaprobadas', data, config, callback_success, callback_error);
            },
            getAllRequests: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_todas', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_todas', data, config, callback_success, callback_error);
            },
            getUnderstandingPosition: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_entendimiento_cargo_solicitante', data, config, callback_success, callback_error);
            },
            sendApproveUnderstanding: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/aprobar_entendimiento_cargo', data, config, callback_success, callback_error);
            },
            getTerna: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_terna_solicitante', data, config, callback_success, callback_error);
            },
            getDasboardFinalistCandidate: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_dashboard_solicitante', data, config, callback_success, callback_error);
            },
            sendEmailsRequest: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/send_process', data, config, callback_success, callback_error);
            },
            //Approver
            getForApproveRequestsApprover: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_aprobacion', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_aprobacion', data, config, callback_success, callback_error);
            },
            getInProcessRequestsApprover: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_proceso', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_proceso', data, config, callback_success, callback_error);
            },
            getNotifications: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/get_notificacions', data, config, callback_success, callback_error);
            },
            //Admin
            getInProcessRequestsByAdmin: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_admin_proceso', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_admin_proceso', data, config, callback_success, callback_error);
            },
            getApprovedRequestsByAdmin: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_admin_aprobadas', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_admin_aprobadas', data, config, callback_success, callback_error);
            },
            getDismissRequestsByAdmin: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_admin_noaprobadas', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_admin_noaprobadas', data, config, callback_success, callback_error);
            },
            getAllRequestsByAdmin: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_admin', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_admin', data, config, callback_success, callback_error);
            },
            getPositionColaborators: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_list_colaboradores', data, config, callback_success, callback_error);
            },
            updateRequestType: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/update_tipo_solicitud_requisicion', data, config, callback_success, callback_error);
            },
            getRequestsReportByYear: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/informe_requisiciones_anio', data, config, callback_success, callback_error);
            },
            getServicePerformanceReport: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/informe_nivel_servicio', data, config, callback_success, callback_error);
            },
            getServiceReportAdmin: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/reporte_requisiciones_admin', data, config, callback_success, callback_error);
            },
            getServiceReportLevelService: function (data, config, callback_success, callback_error, configLoad, extra) {
                //http_post(api.baseUrl + '/api/ikano/seleccion_reporte_nivel_servicio', data, config, callback_success, callback_error);
                console.log(data,extra);
                if (extra.old) {
                    http_resource(api.baseUrl + '/api/get_report', 'GET', data, config, callback_success, callback_error);
                } else {
                    http_post(api.baseUrl + '/api/getreport', data, config, callback_success, callback_error);
                }


            },
            getServiceLists: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/get_lists', data, config, callback_success, callback_error);
            },
        };

        api.admin = {
            getSystemSettings: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/ikano/core_get_configuracions', data, config, callback_success, callback_error);
            },
            saveSystemSettings: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/core/save_configuracions', data, config, callback_success, callback_error);
            },
            getOutbox: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/ikano/core_get_bandeja_salida', data, config, callback_success, callback_error);
            },
            getOutboxPaginate: function (data, config, page, filter, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/ikano/core_get_bandeja_salida?page=' + page + filter, data, config, callback_success, callback_error);
            },
            getMailTemplates: function (data, config, callback_success, callback_error) {
                http_get(api.baseUrl + '/api/ikano/core_get_plantillas', data, config, callback_success, callback_error);
            },
            updateMailTemplate: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/core/update_plantilla', data, config, callback_success, callback_error);
            },
            getVarMailTemplate: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/core/get_variables_plantillas', data, config, callback_success, callback_error);
            },
            probarTemplate: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/core/probar_plantilla', data, config, callback_success, callback_error);
            },
            getApprovers: function (data, config, callback_success, callback_error) {
                //http_get(api.baseUrl + '/api/ikano/seleccion_requisiciones_aprobadores', data, config, callback_success, callback_error);
                http_post(api.baseUrl + '/api/ikano/seleccion_requisiciones_aprobadores', data, config, callback_success, callback_error);
            },
            addApprover: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_aprobador', data, config, callback_success, callback_error);
            },
            enableApprover: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/activar_aprobador', data, config, callback_success, callback_error);
            },
            disableApprover: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/inactivar_aprobador', data, config, callback_success, callback_error);
            },
            addSubstitute: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/set_suplente', data, config, callback_success, callback_error);
            },
            removeSubstitute: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/retirar_suplente', data, config, callback_success, callback_error);
            },
            addAssistant: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/set_asistente', data, config, callback_success, callback_error);
            },
            removeAssistant: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/retirar_asistente', data, config, callback_success, callback_error);
            },
            downloadReport: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/reporte_aprobadores', data, config, callback_success, callback_error);
            },
            downloadFileCollaborator: function (data, config, callback_success, callback_error) {
                http_post(api.baseUrl + '/api/ikano/seleccion/download_candidate_files', data, config, callback_success, callback_error);
            },
            getCollaborators: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_colaborators', data, config, callback_success, callback_error, load);
            },
            getCollaborator: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_colaborator', data, config, callback_success, callback_error, load);
            },
            getHojasVida: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/get_hojas_vida', data, config, callback_success, callback_error, load);
                //http_post('http://pruebas-tecnoquimicas.ikanosmart.com/api/getHojasVida.json', data, { jwt: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9eyJpYXQiOjE0ODA5NzEwOTUsImV4cCI6MTQ4MTA1NzQ5NSwiZGF0YSI6eyJ1c2VyX2lkIjoxLCJlbWFpbCI6InNvcG9ydGVAdmVjdG9yaWFsLmNvIiwidXNlcm5hbWUiOiJhZG1pbiJ9fQ' }, callback_success, callback_error, load);
            },
            saveCenso: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/marcar_hojas_vidas', data, config, callback_success, callback_error, load);
                //http_post('http://pruebas-tecnoquimicas.ikanosmart.com/api/marcarHojasVidas.json', data, { jwt: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9eyJpYXQiOjE0ODA5NzEwOTUsImV4cCI6MTQ4MTA1NzQ5NSwiZGF0YSI6eyJ1c2VyX2lkIjoxLCJlbWFpbCI6InNvcG9ydGVAdmVjdG9yaWFsLmNvIiwidXNlcm5hbWUiOiJhZG1pbiJ9fQ' }, callback_success, callback_error, load);
            },
            removeCollaborator: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/remove_colaborator', data, config, callback_success, callback_error, load);
            },
            addCollaborator: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/add_colaborator', data, config, callback_success, callback_error, load);
            },
            searchCandidate: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/search_candidates', data, config, callback_success, callback_error, load);
            },
            getLists: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/get_lists', data, config, callback_success, callback_error, load);
            },
            get_onchange_data: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_onchange_data', data, config, callback_success, callback_error, load);
            },
            requestAdmin: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_procesos_admin', data, config, callback_success, callback_error, load);
            },
            getRequestAdminSeleccion: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_proceso', data, config, callback_success, callback_error, load);
            },
            searchCandidateSeleccion: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/buscar_candidatos_admin', data, config, callback_success, callback_error, load);
            },
            getUnderstandingCharge: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_entendimiento_cargo_admin', data, config, callback_success, callback_error, load);
            },
            downloadUnderstandingPdf: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_entendimiento_cargo_pdf_admin', data, config, callback_success, callback_error, load);
            },
            activarRequest: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_reactivar_proceso_admin', data, config, callback_success, callback_error, load);
            },
            get_team_processes_admin: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_team_processes_admin', data, config, callback_success, callback_error, load);
            },
            filterAllCandidateHv: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/buscar_hv_admin', data, config, callback_success, callback_error, load);
            },
            updateProcessData: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/update_process_data_admin', data, config, callback_success, callback_error, load);
            },
            setAnalystProcess: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/set_analyst_to_process_admin', data, config, callback_success, callback_error, load);
            },
            restablecer_colaborador_enviado: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/restablecer_colaborador_enviado', data, config, callback_success, callback_error, load);
            },
            get_sociedades_paises: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/get_sociedades_paises', data, config, callback_success, callback_error, load);
            },
            save_sociedades_paises: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/save_sociedades_paises', data, config, callback_success, callback_error, load);
            },
            delete_process: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/delete_process', data, config, callback_success, callback_error, load);
            },
            activate_process: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/activate_process', data, config, callback_success, callback_error, load);
            },
            uploadCharge: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/organigrama/cargos_actualizacion_masiva_excel', data, config, callback_success, callback_error, load);
            },
            uploadStructures: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/organigrama/estructuras_actualizacion_masiva_excel', data, config, callback_success, callback_error, load);
            },
            get_base_cargos: function (data, config, callback_success, callback_error, load) {
                http_get(api.baseUrl + '/api/ikano/organigrama/get_base_cargos', data, config, callback_success, callback_error, load);
            },
            get_tiempos_objetivos: function (data, config, callback_success, callback_error, load) {
                http_get(api.baseUrl + '/api/ikano/get_tiempos_objetivos', data, config, callback_success, callback_error, load);
            },
            update_tiempo_objetivo: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/update_tiempo_objetivo', data, config, callback_success, callback_error, load);
            },
            get_info_rol_aprobadores: function (data, config, callback_success, callback_error, load) {
                http_get(api.baseUrl + '/api/ikano/get_info_rol_aprobadores', data, config, callback_success, callback_error, load);
            },
            update_rol_aprobadores: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/update_rol_aprobadores', data, config, callback_success, callback_error, load);
            },


        };

        api.analyst = {
            getRequests: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.REQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getAllAnalysts: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETALLANALYSTS;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            createAnalyst: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.CREATEANALYST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            updateAnalyst: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.UPDATEANALYST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            deleteAnalyst: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.DELETEANALYST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            activeAnalyst: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.ACTIVATEANALYST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            deactiveAnalyst: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.INACTIVATEANALYST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getCandidate: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.CANDIDATE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.CANDIDATE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            setFavorite: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SETFAVORITE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            addNote: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.ADDNOTE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            addNoteRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.ADDNOTEREQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            addScheduleCandidate: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.ADDSCHEDULEDATECANDIDATE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            addRecommendCandidate: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.ADDRECOMMENDCANDIDATE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getCandidateDetail: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETCANDIDATEDETAIL;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getCandidateHistory: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETCANDIDATEHISTORY;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getUnderstandingCharge: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETUNDERSRANDINGCHARGE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getShareRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETSHAREREQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            postShareRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.POSTSHAREREQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            saveSuspensionRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.POSTSUSPENSIONREQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            activarRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.POSTACTIVARREQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getCandidateRevision: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETCANDIDATEREVISION;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            sendCandidateApplicant: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.POSTSENDCANDIDATEAPPLICANT;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            saveRequestAnalyst: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SAVEREQUESTANALYST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            downloadUnderstandingPdf: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.DOWNLOADUNDERSTANDINGPDF;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            setSpecial: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SETSPECIAL;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            deleteNote: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.DELETENOTE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            deleteObservacion: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.DELETEOBSERVACION;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            approveRequestAnalyst: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.APPROVEREQUESTANALYST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            sendApproveUnderstanding: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SENDAPPROVEDUNDERSTANDING;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            postPublicRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.TOPOSTREQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getPublicRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETPUBLICREQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            changeDateEndOffer: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.CHANGEDATEENDOFFER;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            saveReportForToclient: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SAVEREPORTFORTOCLIENT;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            saveStage: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SAVESTAGE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            saveStageFinalist: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SAVESTAGEFINALIST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            searchCandidate: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SEARCHCANDIDATE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            filterAllCandidate: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.FILTERALLCANDIDATE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getHojaVida: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETHOJAVIDA;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            preseleccionar: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.PRESELECCIONAR;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            retirarPreseleccionar: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.RETIRARPRESELECCIONAR;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getFile: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + '/api/get_file/' + data.id;
                download_file(url, config, callback_success, callback_error, configLoad);
            },
            downloadStage: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.DOWNLOADSTAGE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            closeOffer: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.CLOSEOFFER;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            searchProcess: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SEARCHPROCESS;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            referredCandidate: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.REFERREDCANDIDATE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            removeReferredCandidate: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.REMOVEREFERREDCANDIDATE;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getCandidateSimilar: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.CANDIDATESIMILAR;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            saveEvaluation: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SAVEEVALUATION;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            downloadTerna: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.DOWNLOADTERNA;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getTeamProcesses: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETTEAMPROCESSES;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            setAnalystProcess: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SETANALYSTPROCESS;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            finishRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.FINISHREQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            reOpenRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.REOPENREQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            saveMarker: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SAVEMARKER;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getHistoryRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETHISTORYREQUEST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getRequestReport: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETREQUESTREPORT;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getDataRequestAnalyst: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETDATAREQUESTANALYST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            saveNewRequest: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SAVEDATAREQUESTANALYST;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            importCandidateElempleo: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.IMPORTCANDIDATEELEMPLEO;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            importStages: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.IMPORTSTAGES;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getHojaVidas: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.GETHOJADEVIDAS;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            set_candidate_as_visto: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + analystConstant.URL.API.SETCANDIDATEASVIEW;
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getOtherProcess: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + '/api/ikano/seleccion/get_otros_procesos';
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getFilterHv: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + '/api/ikano/seleccion/get_filters_buscar_hv';
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            sendNotificacionDiscard: function (data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + '/api/ikano/seleccion/envia_notificacion_descarte';
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
            getHistoryProcessCandidate: function(data, config, callback_success, callback_error, configLoad) {
                var url = api.baseUrl + '/api/ikano/seleccion/get_participation_history';
                http_post(url, data, config, callback_success, callback_error, configLoad);
            },
        };

        api.global = {
            getConfigurationCandidate: function (data, config, callback_success, callback_error, load) {
                http_post(api.baseUrl + '/api/ikano/seleccion/configuracion_candidatos', data, config, callback_success, callback_error, load);
            },
        }

        // Request
        function http_post(url, data, config, cb_success, cb_error, configLoad) {
            if (!configLoad) {
                $rootScope.$broadcast("loader_show");
            }
            $http.post(url, data, config).then(function (response) {
                cb_success(response);
            }, function (response) {
                if (cb_error) {
                    cb_error(response);
                } else {
                    if (response.status == 404) {
                        showNotification({ title: "Error", message: "No se ha encontrado la página solicitada." });
                    } else if (response.status == 500) {
                        showNotification({ title: "Error", message: "Ha ocurrido un error, por favor intente de nuevo" });
                    } else if (response.status == 401) {
                        showNotification({ title: "Error", message: "Usuario o contraseña invalido" });
                    } else {
                        showNotification({ title: "Error", message: "Se ha presentado un problema, por favor intente de nuevo" });
                    }
                }
            });
        }

        function http_get(url, data, config, cb_success, cb_error, configLoad) {
            if (!configLoad) {
                $rootScope.$broadcast("loader_show");
            }
            $http.get(url, data, config).then(function (response) {
                cb_success(response);
            }, function (response) {
                if (cb_error) {
                    cb_error(response);
                } else {
                    if (response.status == 404) {
                        showNotification({ title: "Error", message: "No se ha encontrado la página solicitada, por favor intente de nuevo" });
                    } else if (response.status == 500) {
                        showNotification({ title: "Error", message: "Ha ocurrido un error, por favor intente de nuevo" });
                    } else if (response.status == 401) {
                        showNotification({ title: "Error", message: "Usuario o contraseña invalido" });
                    } else {
                        showNotification({ title: "Error", message: "Se ha presentado un problema, por favor intente de nuevo" });
                    }
                }
            });
        }

        function http_put(url, data, config, cb_success, cb_error, configLoad) {
            if (!configLoad) {
                $rootScope.$broadcast("loader_show");
            }
            $http.put(url, data, config).then(function (response) {
                cb_success(response);
            }, function (response) {
                if (cb_error) {
                    cb_error(response);
                } else {
                    if (response.status == 404) {
                        showNotification({ title: "Error", message: "No se ha encontrado la página solicitada." });
                    } else if (response.status == 500) {
                        showNotification({ title: "Error", message: "Ha ocurrido un error, por favor intente de nuevo" });
                    } else if (response.status == 401) {
                        showNotification({ title: "Error", message: "Usuario o contraseña invalido" });
                    } else {
                        showNotification({ title: "Error", message: "Se ha presentado un problema, por favor intente de nuevo" });
                    }
                }
            });
        }

        function http_delete(url, data, config, cb_success, cb_error, configLoad) {
            if (!configLoad) {
                $rootScope.$broadcast("loader_show");
            }
            $http.delete(url, data, config)
                .then(
                function (response) {
                    cb_success(response);
                },
                function (response) {
                    if (cb_error) {
                        cb_error(response);
                    } else {
                        if (response.status == 404) {
                            showNotification({ title: "Error", message: "No se ha encontrado la página solicitada." });
                        } else if (response.status == 500) {
                            showNotification({ title: "Error", message: "Ha ocurrido un error, por favor intente de nuevo" });
                        } else if (response.status == 401) {
                            showNotification({ title: "Error", message: "Usuario o contraseña invalido" });
                        } else {
                            showNotification({ title: "Error", message: "Se ha presentado un problema, por favor intente de nuevo" });
                        }
                    }
                }
                );
        }

        function http_resource(url, method, data, config, cb_success, cb_error, configLoad) {
            if (!configLoad) {
                $rootScope.$broadcast("loader_show");
            }
            console.log(data);
            $http({
                url: url,
                method: method,
                params: data,
            }).then(function (response) {
                cb_success(response);
            }, function (response) {
                if (cb_error) {
                    cb_error(response);
                } else {
                    if (response.status == 404) {
                        showNotification({ title: "Error", message: "No se ha encontrado la página solicitada, por favor intente de nuevo" });
                    } else if (response.status == 500) {
                        showNotification({ title: "Error", message: "Ha ocurrido un error, por favor intente de nuevo" });
                    } else if (response.status == 401) {
                        showNotification({ title: "Error", message: "Usuario o contraseña invalido" });
                    } else {
                        showNotification({ title: "Error", message: "Se ha presentado un problema, por favor intente de nuevo" });
                    }
                }
            });
        }

        function showNotification(message) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title(message.title)
                    .textContent(message.message)
                    .ok('Aceptar')
            );
        }

        /**
         * Donwload file GET
         */

        function download_file(url, config, cb_success, cb_error, configLoad) {
            if (!configLoad) {
                $rootScope.$broadcast("loader_show");
            }
            $http.get(url, config).then(function (response) {
                cb_success(response);
            }, function (response) {
                if (cb_error) {
                    cb_error(response);
                } else {
                    if (response.status == 404) {
                        showNotification({ title: "Error", message: "No se ha encontrado la página solicitada, por favor intente de nuevo" });
                    } else if (response.status == 500) {
                        showNotification({ title: "Error", message: "Ha ocurrido un error, por favor intente de nuevo" });
                    } else if (response.status == 401) {
                        showNotification({ title: "Error", message: "Usuario o contraseña invalido" });
                    } else {
                        showNotification({ title: "Error", message: "Se ha presentado un problema, por favor intente de nuevo" });
                    }
                }
            });
        }


        return api;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.login-token', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-login-token', {
            url      : '/login-token/:username/:token',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-login-token': {
                    templateUrl: 'app/main/auth/login-token/login-token.html',
                    controller : 'LoginTokenController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.login-admin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-login-admin', {
            url: '/admin',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.auth-login-admin': {
                    templateUrl: 'app/main/auth/login-admin/login-admin.html',
                    controller: 'LoginAdminController as vm'
                }
            },
            bodyClass: 'login'
        }).state('app.auth-login-requisicion', {
            url: '/req',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.auth-login-requisicion': {
                    templateUrl: 'app/main/auth/login-admin/login-admin.html',
                    controller: 'LoginAdminController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.acuerdo-servicio', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.auth-acuerdo-servicio', {
            url      : '/proceso/acuerdo-servicio/:proceso/:approve/:token',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth-acuerdo-servicio': {
                    templateUrl: 'app/main/auth/acuerdo-servicio/acuerdo-servicio.html',
                    controller : 'AcuerdoServicio as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" \nlayout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\">\n<md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/toast/template/toast.default.html","<md-toast><div layout=\"row\" layout-align=\"space-between\" class=\"all-width\"><div layout=\"row\" \nlayout-align=\"start center\"><i ng-if=\"vm.config.icon\" class=\"s16 pr-5\" ng-class=\"vm.config.icon\" aria-hidden=\"true\">\n</i><div layout=\"column\" class=\"md-toast-text\"><span ng-if=\"vm.config.title\" class=\"font-weight-500\">\n{{vm.config.title}}</span> <span ng-if=\"vm.config.message\" flex>{{vm.config.message}}</span></div></div><md-button \nng-id=\"vm.options.length > 0\" ng-repeat=\"option in vm.options\" ng-click=\"option.callback()\">{{option.title}}\n</md-button><md-button ng-if=\"vm.config.showClose\" ng-click=\"vm.closeToast()\">Cerrar</md-button></div></md-toast>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/admin/crud-society/crud-society.html","<div id=\"collaborators\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div>\n<div ng-if=\"vm.loading\" class=\"p-30 md-title text-center md-whiteframe-4dp white-bg\">\nCargando contenido, por favor espere...</div><div ng-if=\"!vm.loading\" class=\"main scrollable\" ms-scroll><div \nlayout=\"column\" flex=\"100\" layout-align=\"start\"><div layout=\"column\" class=\"p-20 mb-20\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.createSociety()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Crear nueva sociedad\n</md-button></div></div><div class=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" \nid=\"tableCandidates\" layout=\"row\" ng-if=\"vm.societys\"><table class=\"row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnSociety\"><thead><tr><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Id</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Sociedad</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Pais</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"society in vm.societys track by $index\"><td><a ng-click=\"vm.createSociety(society)\" \nclass=\"cursor-pointer\">{{society.id}}</a></td><td class=\"grey-100-bg\">{{society.society | capitalize:true}}</td><td \nclass=\"\">{{society.country | capitalize:true}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/admin/lists-requests/lists-requests.html","<div id=\"lists-requests-admin\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\">\n</div><filter-lista filters=\"vm.filters\" callbacksenddata=\"vm.callbackSendData(filter)\" \ncallbackcleardata=\"vm.clearFilter()\"></filter-lista><div class=\"content p-20\"><div \nclass=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" id=\"tableCandidates\" layout=\"row\" \nng-if=\"vm.misc.request\"><table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefsCandidate\"><thead><tr><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Proceso</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Responsable de selección</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Fecha de creación</span></div>\n</th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Solicitante</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Estado proceso</span></div>\n</th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Estado requisición</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Acciones</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"request in vm.misc.request track by $index\"><td><div layout=\"column\"><span \nclass=\"font-weight-500 cursor-pointer\" ng-click=\"vm.goDetail(request.id);\">{{request.name}}</span><div layout=\"row\">\n<span>Ciudad: </span><span class=\"font-weight-500 cursor-pointer\">{{request.state}}</span></div><div layout=\"row\">\n<span>No.req: </span><span class=\"font-weight-500 cursor-pointer\">{{request.cod}}</span></div></div></td><td \nclass=\"grey-100-bg\"><div layout=\"column\" ng-show=\"!request.selected\"><span>{{request.analyst.name}}</span> <u \nng-click=\"request.selected = true;\" class=\"cursor-pointer blue-300-fg text_underline\">Modificar</u></div><div \nlayout=\"column\" ng-if=\"request.selected\"><md-input-container><div class=\"h4 grey-fg font-weight-300\"><label>\nLista analistas</label></div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.data[request.id]\" class=\"\">\n<md-option ng-repeat=\"data in vm.listAnalyst track by $index\" ng-value=\"data\">{{data.name}}</md-option></md-select>\n</md-input-container><md-progress-circular ng-if=\"request.loading\" md-mode=\"indeterminate\"></md-progress-circular><div \nclass=\"pt-5\" layout=\"row\" layout-align=\"space-between\" ng-if=\"!request.loading\"><md-button ng-if=\"request.selected\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"request.selected = false;vm.data[request.id] = null;\">Cancelar</md-button><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.updateAnalyst(vm.data[request.id],request);\">Guardar</md-button></div></div></td><td class=\"\">\n{{request.createdDate.formatDate | capitalize:true}}</td><td class=\"w-200 grey-100-bg\"><div layout=\"column\"><span \nclass=\"grey-400-fg font-weight-300\">{{request.applicant_from}}</span> <span>{{request.applicant}}</span></div></td><td \nclass=\"\"><div layout=\"column\" ng-style=\"{\'background-color\':request.status_process.color}\" class=\"status-process\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"white-fg text-center\">{{request.status_process.estado}}</div>\n</div></td><td class=\"w-200 grey-100-bg\"><div layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\">\n{{request.status_request.estado}}</div></div></td><td><div layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg md-warn\" \nng-if=\"request.status_process.id != vm.status_process_status.PROCESO_ELIMINADO\" ng-disabled=\"request.loading\" \nng-click=\"vm.showAlertConfirm($event,1,request)\">Eliminar</md-button><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-if=\"request.status_process.id == vm.status_process_status.PROCESO_ELIMINADO\" ng-disabled=\"request.loading\" \nng-click=\"vm.showAlertConfirm($event,2,request)\">Activar</md-button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/request/request.html","<div id=\"detail-analyst\" class=\"page-layout simple tabbed\"><header-request request=\"vm.request\" project=\"vm.project\">\n</header-request><div class=\"content pt-20\"><div \nclass=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" id=\"tableCandidates\" layout=\"row\" \nng-if=\"vm.candidates && !vm.candidateSelected\"><table class=\"row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefsCandidate\"><thead><tr><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Documento de identidad</span>\n</div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Nombre</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Etapa</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Indicadores</span></div></th></tr></thead><tbody><tr \nng-repeat=\"candidate in vm.candidates track by $index\"><td><span class=\"cursor-pointer\" \nng-click=\"vm.goToCandidateDetail(candidate.id,$index)\">{{candidate.key}}</span></td><td class=\"grey-100-bg\">\n{{candidate.name}}</td><td class=\"\">\n{{(candidate.stage.short_name?candidate.stage.short_name:candidate.stage.name_corto)}}</td><td class=\"grey-100-bg\"><div\n layout=\"row\" layout-align=\"space-between center\"><div><md-tooltip md-direction=\"top\">\nIndica si la hoja de vida ha sido vista en este proceso</md-tooltip><i \nclass=\"s22 icon-eye subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!candidate.view\"></i> <i \nclass=\"s22 icon-eye subtitle secondary-text pr-10\" ng-if=\"candidate.view\" md-colors=\"{color:\'accent\'}\"></i></div><div>\n<md-tooltip md-direction=\"top\" ng-if=\"!candidate.recommended\">Indica si es una hoja de vida recomendada.</md-tooltip>\n<md-tooltip md-direction=\"top\" ng-if=\"candidate.recommended\">\nHoja de vida recomendada por: {{candidate.recomendaciones[0].analista.name}} para {{candidate.recomendaciones[0].cargo.name}}\n</md-tooltip><i class=\"s22 icon-shopping subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!candidate.recommended\"></i>\n <i class=\"s22 icon-shopping subtitle secondary-text pr-10\" ng-if=\"candidate.recommended\" md-colors=\"{color:\'accent\'}\">\n</i></div><div><md-tooltip md-direction=\"top\" ng-if=\"!candidate.referred\">Indica si es una hoja de vida referida.\n</md-tooltip><md-tooltip md-direction=\"top\" ng-if=\"candidate.referred\">\nHoja de vida referida por: {{candidate.referredBy[0].referente}}</md-tooltip><i \nclass=\"s22 icon-swap-horizontal subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!candidate.referred\"></i> <i \nclass=\"s22 icon-swap-horizontal subtitle secondary-text pr-10\" ng-if=\"candidate.referred\" md-colors=\"{color:\'accent\'}\">\n</i></div><div><md-tooltip md-direction=\"top\">\nIndica si el candidato ha participado en procesos anteriores en la empresa</md-tooltip><i \nclass=\"s22 icon-basket subtitle secondary-text pr-10 grey-400-fg\" \nng-if=\"!candidate.max_stage || !candidate.max_stage.name\"></i> <i \nclass=\"s22 icon-basket subtitle secondary-text pr-10\" ng-if=\"candidate.max_stage && candidate.max_stage.name\" \nmd-colors=\"{color:\'accent\'}\"></i></div><div ng-click=\"vm.addFavorite(candidate);\" class=\"cursor-pointer\"><md-tooltip \nmd-direction=\"top\">Indica si la hoja de vida ha sido señalada como favorita</md-tooltip><i \nclass=\"s22 icon-star subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!candidate.favorite\"></i> <i \nclass=\"s22 icon-star subtitle secondary-text pr-10\" ng-if=\"candidate.favorite\" md-colors=\"{color:\'accent\'}\"></i></div>\n<div ng-click=\"candidate.showMarker?candidate.showMarker = false : candidate.showMarker = true; \" \nclass=\"cursor-pointer\"><md-tooltip md-direction=\"top\">Indica si la hoja de vida ha sido marcada</md-tooltip><i \nclass=\"s22 icon-bookmark subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!candidate.marker\"></i> <i \nclass=\"s22 icon-bookmark subtitle secondary-text pr-10\" ng-if=\"candidate.marker\" md-colors=\"{color:\'accent\'}\"></i>\n</div></div></td></tr></tbody></table></div><div ng-show=\"vm.showDetailCandidate\"><div class=\"p-30\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"mb-10\"><md-button ng-click=\"vm.showListsCandidate()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Volver a la lista\n</md-button></div><div class=\"mb-15\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"pt-10 pr-0 pb-10 pl-10\">\nCandidato {{vm.indexSelected + 1}} de {{vm.candidates.length}}</div><div layout=\"row\" layout-aling=\"space-between\">\n<span class=\"cursor-pointer\" ng-hide=\"vm.indexSelected == 0\" ng-click=\"vm.backCandidate()\"><i \nclass=\"icon-chevron-left s30 grey-500-fg\"></i> </span><span class=\"cursor-pointer\" \nng-hide=\"vm.indexSelected == (vm.candidates.length - 1)\" ng-click=\"vm.nextCandidate()\"><i \nclass=\"icon-chevron-right s30 grey-500-fg\"></i></span></div></div></div></div><candidatedetail \nselected=\"vm.candidateSelected\" data=\"vm.candidateSelectedAll\" config=\"vm.configCandidate\" \nbackup=\"vm.candidateChanges\" listas=\"vm.lists\" proceso=\"vm.request\"></candidatedetail></div></div></div>");
$templateCache.put("app/main/admin/search_hv/search_hv.html","<div id=\"search-hv-admin\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div>\n<div class=\"content p-20\"><div layout-wrap layout=\"column\" layout-align=\"space-between\" class=\"mb-10\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"pb-10 bb\"><div><div ng-if=\"vm.misc.filter.length > 0\" \nclass=\"h3 font-weight-400\">Filtros Seleccionados</div></div><md-button ng-click=\"vm.showfilterCandidate()\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Buscar hoja de vida\n</md-button></div><div><div ng-repeat=\"(key,filter) in vm.misc.filter | orderBy : filter.order track by $index \"><div \nclass=\"badgeFilter\" ng-if=\"filter.notArray\" layout=\"row\"><span>{{filter.valuesShow}}</span> <button \nng-click=\"vm.deleteFilter(filter,key);\" class=\"md-chip-remove\"><md-icon md-font-icon=\"icon-close\" \nmd-colors=\"{color:\'accent\'}\"></md-icon></button></div><div class=\"badgeFilter\" ng-if=\"!filter.notArray\" \nng-repeat=\"value in filter.valuesShow track by $index\" layout=\"row\"><span>{{value}}</span> <button \nng-click=\"vm.deleteFilter(filter,key,$index);\" class=\"md-chip-remove\"><md-icon md-font-icon=\"icon-close\" \nmd-colors=\"{color:\'accent\'}\"></md-icon></button></div></div></div></div><div ng-if=\"vm.loading\" layout=\"row\" \nflex=\"100\" layout-align=\"center center\" class=\"grey-200-bg p-30\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2\">\nCargando información por favor espere...</div><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nng-if=\"vm.loading\"></md-progress-circular></div><div \nng-if=\"!vm.loading && !vm.candidates.length &&  vm.misc.filter.length > 0\" layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" class=\"grey-200-bg p-30 mt-10\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2\">\nNo se encontraron candidatos bajo los parametros de busqueda.</div></div><div \nng-if=\"!vm.loading && vm.misc.filter.length == 0\" layout=\"row\" flex=\"100\" layout-align=\"center center\" \nclass=\"grey-200-bg p-30 mt-10\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2\">\nDebe de seleccionar un filtro para encontrar los candidatos.</div></div><div \nng-if=\"(!vm.loading && vm.candidates.length > 0) && !vm.showDetailCandidate\"><div \nclass=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" id=\"tableCandidates\" layout=\"row\" \nng-if=\"vm.candidates\"><table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefsCandidate\"><thead><tr><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Nombre y apellido</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Documento de identidad</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Maxima etapa alcanzada</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"candidate in vm.candidates track by $index\"><td><div \nng-click=\"vm.showHV(candidate,$index)\" \nng-class=\"{\'cursor-pointer\':vm.candidatesBackup[$index].hoja_vida,\'text-underlined\':vm.candidatesBackup[$index].hoja_vida}\" \nclass=\"font-weight-500 grey-600-fg\">{{candidate.name | capitalize:true}}</div></td><td class=\"grey-100-bg\">\n{{candidate.key}}</td><td class=\"\">{{candidate.max_stage.name_corto}}</td></tr></tbody></table></div></div><div \nng-show=\"vm.showDetailCandidate\"><div class=\"p-30\"><div layout=\"row\" layout-align=\"end center\" class=\"mb-10\"><md-button\n ng-click=\"vm.showListsCandidate()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Volver a la lista\n</md-button></div><div class=\"mb-15\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"pt-10 pr-0 pb-10 pl-10\">\nCandidato {{vm.indexSelected + 1}} de {{vm.candidates.length}}</div><div layout=\"row\" layout-aling=\"space-between\">\n<span class=\"cursor-pointer\" ng-hide=\"vm.indexSelected == 0\" ng-click=\"vm.backCandidate()\"><i \nclass=\"icon-chevron-left s30 grey-500-fg\"></i> </span><span class=\"cursor-pointer\" \nng-hide=\"vm.indexSelected == (vm.candidates.length - 1)\" ng-click=\"vm.nextCandidate()\"><i \nclass=\"icon-chevron-right s30 grey-500-fg\"></i></span></div></div></div></div><candidatedetail \nselected=\"vm.candidateSelected\" data=\"vm.candidateSelectedAll\" config=\"vm.configCandidate\" listas=\"vm.lists\" \npositions=\"vm.positions\" etapas=\"vm.stages\" proceso=\"vm.request\" recomendaciones=\"null\"></candidatedetail></div></div>\n</div>");
$templateCache.put("app/main/admin/understanding-charge/understanding-charge.html","<div id=\"understanding-charge\" class=\"page-layout simple tabbed\"><header-request request=\"vm.request\" \nproject=\"vm.project\"></header-request><div class=\"content\" md-background-bg><div ng-if=\"vm.loading\" \nclass=\"p-30 md-title text-center\">Cargando contenido, por favor espere...</div><div ng-if=\"!vm.loading \" \nclass=\"main scrollable p-7\" ms-scroll><div layout=\"row\" layout-align=\"start center\" class=\"pl-20 pr-20\"><div \nlayout=\"row\" class=\"tab\" ng-click=\"vm.selectedTab(\'rq\');\" \nng-style=\"vm.misc.tabSelected == \'rq\' ? {\'border-bottom-color\':vm.getThemeColor(\'accent\'),\'border-bottom-width\': \'1px\',\n                \'border-bottom-style\': \'solid\'} : {}\">\nREQUISICIÓN</div><div layout=\"row\" class=\"tab\" ng-click=\"vm.selectedTab(\'ec\');\" \nng-style=\"vm.misc.tabSelected == \'ec\' ? {\'border-bottom-color\':vm.getThemeColor(\'accent\'),\'border-bottom-width\': \'1px\',\n                \'border-bottom-style\': \'solid\'} : {}\">\nEntendimiento del cargo</div></div><div layout=\"column\" ng-show=\"vm.misc.tabSelected == \'rq\'\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"m-15\"><div md-colors=\"{color: \'accent\'}\"><i class=\"icon-file-pdf-box cursor-pointer\" \nng-click=\"vm.downloadRequestPDF()\"></i></div></div><div ng-repeat=\"block in vm.blocksRequests\"><div \nng-include=\"\'app/main/templates/block-generic/read/\' + block.type + \'.html\'\" \nng-init=\"item = block; root = vm.proccess\"></div></div></div><div layout=\"column\" \nng-show=\"vm.misc.tabSelected == \'ec\'\"><div layout=\"row\" layout-align=\"end center\" class=\"m-15\"><div \nmd-colors=\"{color: \'accent\'}\"><i class=\"icon-file-pdf-box cursor-pointer\" ng-click=\"vm.downloadPDF()\"></i></div></div>\n<div ng-repeat=\"block in vm.blocksUnderstanding\"><div layout=\"column\" layout-align=\"end end\" class=\"mr-15 ml-15\"><div \nlayout=\"row\" layout-align=\"start center\"><span ng-if=\"block.date_created\"><strong>Fecha de creación:</strong>\n {{block.date_created}}</span></div><div layout=\"row\" layout-align=\"start center\"><span ng-if=\"block.date_updated\">\n<strong>Fecha de actualización:</strong> {{block.date_updated}}</span></div></div><div \nng-include=\"\'app/main/templates/block-generic/read/\' + block.type + \'.html\'\" \nng-init=\"item = block;root = vm.understanding\"></div></div><div layout=\"row\" class=\"pb-15\" \nlayout-align=\"center center\"><div class=\"p-5\" \nng-if=\"vm.request.approve_understanding.enviar_entendimiento_aprobacion == 1\"><div layout-wrap \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'No enviado\' || vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Rechazado\'\">\n<md-button ng-disabled=\"vm.understanding.saving\" ng-click=\"vm.validateUnderstanding(true,2)\" \nclass=\"md-raised light-green-500-bg h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg all-width\" \naria-label=\"Guardar y aprobar\">Guardar y enviar aprobación</md-button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/analyst/candidate-detail/candidate-detail.html","<div id=\"big-sidebar\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"content\" flex ms-scroll><div \nid=\"candidate-detail\" class=\"page-layout simple\"><div class=\"\" ng-include=\"\'app/main/templates/header/request.html\'\">\n</div><div class=\"content\"><div layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"p-15 b text-center\" \nflex>Candidatos que están participando {{vm.request.candidates}}</div><div class=\"p-15 b text-center\" flex>\nCandidatos que te pueden interesar 5</div><div class=\"p-15 b text-center\" flex>Análisis de candidatos</div><div \nclass=\"p-15 b text-center\" flex>Buscar candidatos</div></div><div class=\"pl-30 pr-30 pt-15 pb-30\"><div class=\"mb-15\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div><md-checkbox class=\"no-margin\" \nng-model=\"vm.onlyCandidateNotView\" aria-label=\"Only no viewed\" ng-change=\"vm.changeOnlyCandidateNotView()\">\nNavegar solo hojas de vida no vistas hasta el momento</md-checkbox></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"pt-10 pr-0 pb-10 pl-10\">\nCandidato {{vm.positionCandidate.positionShow}} de {{vm.misc.candidatesRequest.length}}</div><div layout=\"row\" \nlayout-aling=\"space-between\"><span class=\"cursor-pointer\" ng-hide=\"vm.positionCandidate.positionShow == 1\" \nng-click=\"vm.backCandidate()\"><i class=\"icon-chevron-left s30 grey-500-fg\"></i></span> <span class=\"cursor-pointer\" \nng-hide=\"vm.positionCandidate.positionShow == vm.misc.candidatesRequest.length\" ng-click=\"vm.nextCandidate()\"><i \nclass=\"icon-chevron-right s30 grey-500-fg\"></i></span></div></div></div><div class=\"b\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div layout=\"row\" layout-align=\"start center\" \nclass=\"p-10 cursor-pointer\" ng-click=\"vm.markAsFavorite()\"><div><i class=\"icon-star subtitle secondary-text\" \nng-class=\"{\'yellow-600-fg\': vm.candidate.favorita, \'grey-400-fg\': !vm.candidate.favorita}\" aria-label=\"Favorita\"></i>\n</div><div class=\"p-8 cursor-pointer text-underlined\"><span ng-if=\"!vm.candidate.favorita\">Marcar</span> <span \nng-if=\"vm.candidate.favorita\">Desmarcar</span> como favorito</div></div><div class=\"p-10 cursor-pointer\" \nng-click=\"vm.setScheduleCandidate(vm.candidate)\"><span>Cita agendada :</span> <span>\n{{vm.candidate.cita.cita.nameShowFormat | capitalize:true}}</span></div><div \nclass=\"p-10 cursor-pointer text-underlined orange-600-fg\" ng-click=\"vm.openShowCandidateNotesDialog()\">Ver notas <span \nclass=\"pt-5 pb-5 pl-10 pr-10 orange-600-bg white-fg brad-12\">{{vm.candidate.notas.length}}</span></div><div \nclass=\"p-10 cursor-pointer text-underlined blue-600-fg\" ng-click=\"vm.openShowCandidateHistoryDialog()\">Historial <span \nclass=\"pt-5 pb-5 pl-10 pr-10 blue-600-bg white-fg brad-12\">{{vm.history.length}}</span></div><div class=\"p-10\"><div \nclass=\"pt-5 pb-5 pl-10 pr-10 text-center brad-5\" ng-style=\"{\'background-color\': vm.candidate.etapa.color}\"><span \nclass=\"h5 white-fg\">{{vm.candidate.etapa.name}}</span></div></div><div class=\"p-10\"><md-button \nng-click=\"vm.openRecommendCandidateDialog()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Recomendar candidato\n</md-button></div><div class=\"p-10\"><md-button ng-click=\"vm.showModalInfoToClient()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">\nInforme para el cliente</md-button></div></div></div><div ng-if=\"!vm.loading\"><div ng-repeat=\"block in vm.blocks\"><div \nng-if=\"block.name == \'personales\' && true\" ng-include=\"\'app/main/templates/resume/personal-info.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'perfil\'\" \nng-include=\"\'app/main/templates/resume/one-column-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'experiencia\'\" ng-include=\"\'app/main/templates/resume/laboral-experience.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'estudios_formales\'\" \nng-include=\"\'app/main/templates/resume/formal-study.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'estudios_no_formales\'\" ng-include=\"\'app/main/templates/resume/non-formal-study.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'laboral\'\" \nng-include=\"\'app/main/templates/resume/one-column-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'contacto_emergencia\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'idiomas\'\" \nng-include=\"\'app/main/templates/resume/languages.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'grupo_familiar\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'hijos\'\" \nng-include=\"\'app/main/templates/resume/childrens.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'madre\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'padre\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'conyuge\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'viven_usted\'\" \nng-include=\"\'app/main/templates/resume/two-columns.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'vivienda\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'contacto\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'salud\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'adicional\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div></div></div><div \nng-if=\"vm.loading\" class=\"p-30 md-title text-center\">Cargando contenido, por favor espere...</div></div></div></div>\n</div>");
$templateCache.put("app/main/analyst/create-request/create-request.html","<div id=\"create-request-analyst\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\">\n</div><div class=\"content p-20\"><div ng-if=\"vm.loading\" layout=\"row\" flex=\"100\" layout-align=\"center center\" \nclass=\"grey-200-bg p-30\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2 mt-10\">Cargando información por favor espere...</div>\n</div><div layout=\"row\" layout-align=\"end end\" class=\"p-17\"><md-button \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg no-margin\" \nng-click=\"vm.goToDashboard();\">Regresar</md-button></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.showLoadingBlock\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-repeat=\"block in vm.blocks\" ng-if=\"!vm.showLoadingBlock\"><div \nng-include=\"\'app/main/templates/request/blocks/update/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div></div><div\n layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 white-fg\" ng-click=\"vm.goToDashboard();\">\nCancelar</md-button><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 white-fg\" ng-click=\"vm.saveRequest();\">\nGuardar</md-button></div></div></div>");
$templateCache.put("app/main/analyst/dashboard/dashboard.html","<div id=\"dashboard-analyst\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\">\n</div><filter-lista filters=\"vm.filters\" callbacksenddata=\"vm.callbackSendData(filter)\" \ncallbackcleardata=\"vm.clearFilter()\"></filter-lista><div class=\"content pb-20\"><div layout=\"row\" \nlayout-align=\"end end\" class=\"pl-25 pr-25 pt-15 pb-15 h2 mt-10\"><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.goToNewRequest();\">Crear nuevo proceso</md-button></div><div ng-if=\"vm.loading\" layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" class=\"grey-200-bg p-30 mt-10\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2 mt-10\">\nCargando información por favor espere...</div></div><div ng-if=\"!vm.loading && !vm.misc.request.length > 0\" \nlayout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"grey-200-bg mt-15\"><div \nclass=\"pl-25 pr-25 pt-15 pb-15 h2 mt-10\">No se encontró coincidencias con los filtros seleccionados.</div></div><div \nng-if=\"!vm.loading && vm.misc.request.length > 0\"><div class=\"container\"><div data-pagination \nng-if=\"vm.pager.pages.length\" layout=\"row\" layout-align=\"center center\"><span \nng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(1)\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(\'backflash\')\" ng-mouseleave=\"vm.setHover(\'backflash\')\" \nmd-colors=\"(vm.misc.hover.backflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-left\"></i> \n</span><span ng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(vm.pager.currentPage - 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'back\')\" ng-mouseleave=\"vm.setHover(\'back\')\" \nmd-colors=\"(vm.misc.hover.back)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-left\"></i></span><ul><li \nng-repeat=\"page in vm.pager.pages\" ng-class=\"{current:vm.pager.currentPage === page}\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(page)\" ng-mouseleave=\"vm.setHover(page)\" \nmd-colors=\"(vm.misc.hover[page] || vm.pager.currentPage === page)?{color: \'accent\'}:{color: \'primary\'}\"><span \nng-click=\"vm.setPage(page)\">{{page}}</span></li></ul><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.currentPage + 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'after\')\" ng-mouseleave=\"vm.setHover(\'after\')\" \nmd-colors=\"(vm.misc.hover.after)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-right\"></i> </span><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.totalPages)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'afterflash\')\" ng-mouseleave=\"vm.setHover(\'afterflash\')\" \nmd-colors=\"(vm.misc.hover.afterflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-right\"></i>\n</span></div></div><div class=\"widget-group margin-widgets\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nng-repeat=\"request in vm.misc.request track by $index\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" layout-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-16 pt-5 pb-5 grey-100-bg border-bottom h-150\" layout=\"column\" \nlayout-align=\"space-between\" hide-xs hide-sm><div class=\"mt-5 mb-10\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" layout-align-xs=\"space-between \" layout-align-gt-xs=\"space-between\" layout-align-sm=\"space-between\" \nlayout-align-gt-sm=\"space-between\" layout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\" \nlayout-align-lg=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-xl=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"h5 blue-300-fg mr-10 cursor-pointer\" ng-click=\"vm.goDetail(request.id);\">Código: <span \nng-bind-html=\"request.cod | highlight:vm.filter.search\"></span></span></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div ng-style=\"{\'background-color\':request.status_process.color}\" \nclass=\"pl-15 pr-15 pt-5 pb-5 text-center\"><span class=\"h5 white-fg\">{{request.status_process.estado}}</span></div><i \nclass=\"s16 icon-dots-vertical cursor-pointer grey-700-fg\" ng-click=\"flipWidget()\" ng-if=\"request.custom_data\"></i>\n</div></div><div layout=\"column\" layout-align=\"center start\" class=\"h-70 pb-10\"><div class=\"h4 title grey-600-fg\"><span\n ng-bind-html=\"request.name | highlight:vm.filter.search\" class=\"text-uppercase cursor-pointer name_request\" \nng-click=\"vm.goDetail(request.id);\"></span></div><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"h5 pr-5 subtitle secondary-text grey-500-fg\">{{request.tipo_solicitud_label}}</div><div class=\"grey-fg h6 pr-5\" \nng-if=\"request.tipo_solicitud_b_label\">{{request.tipo_solicitud_b_label}}</div><div class=\"grey-fg h6\" \nng-if=\"request.tipo_solicitud_c_label\">{{request.tipo_solicitud_c_label}}</div></div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h6 subtitle secondary-text grey-500-fg\" ng-if=\"request.country\"><span ng-bind-html=\"request.country\"></span>\n</div><div class=\"h6 subtitle secondary-text grey-500-fg\" ng-if=\"request.country\"><span class=\"mr-5 ml-5\">/</span>\n</div><div class=\"h6 subtitle secondary-text grey-500-fg\"><span \nng-bind-html=\"request.state | highlight:vm.filter.search \"></span></div></div><div layout=\"row\" \nlayout-align=\"center center\"><i class=\"s20 icon-account-circle grey-600-fg\"></i> <span class=\"pl-5 h6 grey-500-fg\">\n{{request.count_vacant}} VACANTE <span ng-if=\"request.count_vacant>1\">S</span></span></div></div></div><div \nclass=\"pl-16 pr-16 pt-5 pb-5 grey-100-bg border-bottom h-200\" layout=\"column\" layout-align=\"space-between\" hide-md \nhide-lg hide-xl><div class=\"mt-5\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" layout-align-xs=\"space-between \" \nlayout-align-gt-xs=\"space-between\" layout-align-sm=\"space-between\" layout-align-gt-sm=\"space-between\" \nlayout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\" \nlayout-align-lg=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-xl=\"space-between center\"><div layout=\"row\" layout-align=\"space-between\" class=\"mb-10\"><span \nclass=\"h5 blue-300-fg mr-10 cursor-pointer\" ng-click=\"vm.goDetail(request.id);\">Código: <span \nng-bind-html=\"request.cod | highlight:vm.filter.search \"></span> </span><i \nclass=\"s16 icon-dots-vertical cursor-pointer grey-700-fg\" ng-click=\"flipWidget()\" ng-if=\"request.custom_data\"></i>\n</div><div layout=\"row\" layout-align=\"start center\"><div ng-style=\"{\'background-color\':request.status_process.color}\" \nclass=\"pl-15 pr-15 pt-5 pb-5 text-center\"><span class=\"h5 white-fg\">{{request.status_process.estado}}</span></div>\n</div></div><div layout=\"column\" layout-align=\"center start\" class=\"pb-10 h-100\"><div class=\"h4 title grey-600-fg\">\n<span ng-bind-html=\"request.name | highlight:vm.filter.search\" class=\"text-uppercase cursor-pointer name_request\" \nng-click=\"vm.goDetail(request.id);\"></span></div><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"h5 pr-5 subtitle secondary-text grey-500-fg\">{{request.tipo_solicitud_label}}</div><div class=\"grey-fg h6 pr-5\" \nng-if=\"request.tipo_solicitud_b_label\">{{request.tipo_solicitud_b_label}}</div><div class=\"grey-fg h6\" \nng-if=\"request.tipo_solicitud_c_label\">{{request.tipo_solicitud_c_label}}</div></div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h6 subtitle secondary-text grey-500-fg\" ng-if=\"request.country\"><span ng-bind-html=\"request.country\"></span>\n</div><div class=\"h6 subtitle secondary-text grey-500-fg\" ng-if=\"request.country\"><span class=\"mr-5 ml-5\">/</span>\n</div><div class=\"h6 subtitle secondary-text grey-500-fg\"><span \nng-bind-html=\"request.state | highlight:vm.filter.search \"></span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"s20 icon-account-circle grey-600-fg\"></i> <span class=\"pl-5 h6 grey-500-fg\">\n{{request.count_vacant}} VACANTE <span ng-if=\"request.count_vacant>1\">S</span></span></div></div></div><div \nclass=\"pl-16 pr-16 pt-5\" layout=\"column\" layout-align=\"space-between \"><div class=\"mt-10 mb-10\"><div \nclass=\"h6 subtitle secondary-text grey-500-fg\">Solicitante</div><div class=\"h6 title\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\"><span class=\"font-weight-500\">{{request.applicant | capitalize:true}} &nbsp;</span> \n<span class=\"h6 subtitle secondary-text grey-600-fg\" ng-if=\"request.applicant_from\">\n({{request.applicant_from | capitalize:true}})</span></div></div><div class=\"mt-10 mb-10\"><div \nclass=\"h6 subtitle secondary-text grey-500-fg\">Fecha de aprobación</div><div class=\"h6 title\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\"><span ng-if=\"!request.date_request\">No se encontró fecha de aprobación</span> <span \nng-if=\"request.date_request\" class=\"font-weight-500\">{{request.date_approve.formatDate | capitalize:true}} &nbsp;\n</span> <span ng-if=\"request.date_request\" class=\"h6 subtitle secondary-text grey-600-fg\">\n({{request.date_approve.stringDateInMonth}})</span></div></div><div class=\"mt-10 mb-10\"><div \nclass=\"h6 subtitle secondary-text grey-500-fg\">Fecha de creación</div><div class=\"h6 title\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\"><span ng-if=\"!request.date_created\">No se encontró fecha de creación</span> <span \nng-if=\"request.date_created\" class=\"font-weight-500\">{{request.date_created.formatDate | capitalize:true}} &nbsp;\n</span> <span ng-if=\"request.date_created\" class=\"h6 subtitle secondary-text grey-600-fg\">\n({{request.date_created.stringDateInMonth}})</span></div></div><div class=\"mt-10 mb-10\"><div \nclass=\"h6 subtitle secondary-text grey-500-fg\">Estado de publicación</div><div class=\"h6 title\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\"><span class=\"font-weight-500\" ng-style=\"{\'color\':request.color_status_publish}\">\n{{request.status_publish}} &nbsp;</span> <span ng-if=\"request.date_publish\" \nclass=\"h6 subtitle secondary-text grey-600-fg\">(Desde {{request.date_publish.formatDate}} <span \nng-if=\"request.date_publish_close_string\">hasta {{request.date_publish_close.formatDate}}</span>)</span><div \nclass=\"blue-300-fg cursor-pointer z-index-2 pl-5\"><u ng-click=\"vm.publishRequest(request.id);\" \nng-if=\"request.status_offer.id != 2\">Publicación de la oferta</u> <u ng-click=\"vm.publishRequest(request.id);\" \nng-if=\"request.status_offer.id == 2\">Editar publicación de la oferta</u></div></div></div></div><div \nclass=\"grey-50-bg border-top\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div layout=\"column\" \nlayout-align=\"space-between center\" class=\"border-right pt-10 pb-10\" flex=\"20\" flex-xs=\"20\" flex-gt-xs=\"20\" \nflex-sm=\"20\" flex-gt-sm=\"20\" flex-md=\"20\" flex-gt-md=\"20\" flex-lg=\"20\" flex-gt-lg=\"20\" flex-xl=\"20\" \nclass=\"text-truncate\"><div class=\"md-display-1 font-weight-600\">{{request.candidate_info.candidates}}</div><div \nclass=\"h6 blue-300-fg text-truncate\" layout=\"row\" layout-align=\"start\"><span \nng-if=\"request.candidate_info.candidates <=1\">Candidato</span> <span ng-if=\"request.candidate_info.candidates > 1\">\nCandidatos</span></div></div><div layout=\"column\" layout-align=\"space-between center\" \nclass=\"border-right grey-200-bg pt-10 pb-10\" flex=\"20\" flex-xs=\"20\" flex-gt-xs=\"20\" flex-sm=\"20\" flex-gt-sm=\"20\" \nflex-md=\"20\" flex-gt-md=\"20\" flex-lg=\"20\" flex-gt-lg=\"20\" flex-xl=\"20\" class=\"text-truncate\"><div \nclass=\"md-display-1 font-weight-600\">{{request.candidate_info.unread}}</div><div layout=\"row\" \nlayout-align=\"space-between center\"><i class=\"s20 red-400-fg icon-flickr-before text-truncate\"></i> <span class=\"h6\" \nhide-xs hide-sm><span ng-if=\"request.candidate_info.unread <= 1\">No leído</span> <span \nng-if=\"request.candidate_info.unread > 1\">No leídos</span> </span><span class=\"h6\" hide-md hide-lg hide-xl>No...</span>\n</div></div><div layout=\"column\" layout-align=\"space-between center\" class=\"border-right pt-10 pb-10\" flex=\"20\" \nflex-xs=\"20\" flex-gt-xs=\"20\" flex-sm=\"20\" flex-gt-sm=\"20\" flex-md=\"20\" flex-gt-md=\"20\" flex-lg=\"20\" flex-gt-lg=\"20\" \nflex-xl=\"20\"><div class=\"md-display-1 font-weight-600\">{{request.candidate_info.preSelected}}</div><div \nclass=\"h6 blue-300-fg text-truncate\"><span ng-if=\"request.candidate_info.preSelected <= 1\">Preseleccionado</span> <span\n ng-if=\"request.candidate_info.preSelected > 1\">Preseleccionados</span></div></div><div layout=\"column\" \nlayout-align=\"space-between center\" class=\"border-right pt-10 pb-10\" flex=\"20\" flex-xs=\"20\" flex-gt-xs=\"20\" \nflex-sm=\"20\" flex-gt-sm=\"20\" flex-md=\"20\" flex-gt-md=\"20\" flex-lg=\"20\" flex-gt-lg=\"20\" flex-xl=\"20\"><div \nclass=\"md-display-1 font-weight-600\">{{request.candidate_info.finalist}}</div><div \nclass=\"h6 blue-300-fg text-truncate\"><span ng-if=\"request.candidate_info.finalist <= 1\">Finalista</span> <span \nng-if=\"request.candidate_info.finalist > 1\">Finalistas</span></div></div><div layout=\"column\" \nlayout-align=\"space-between center\" class=\"pt-10 pb-10\" flex=\"50\" flex-xs=\"20\" flex-gt-xs=\"20\" flex-sm=\"20\" \nflex-gt-sm=\"20\" flex-md=\"20\" flex-gt-md=\"20\" flex-lg=\"20\" flex-gt-lg=\"20\" flex-xl=\"20\"><div \nclass=\"md-display-1 font-weight-600 green-400-fg\">{{request.candidate_info.selected}}</div><div \nclass=\"h6 blue-300-fg text-truncate\"><span ng-if=\"request.candidate_info.selected <= 1\">Seleccionado</span> <span \nng-if=\"request.candidate_info.selected > 1\">Seleccionados</span></div></div></div></ms-widget-front><ms-widget-back \nclass=\"white-bg\" ms-scroll><div class=\"blue-300-bg border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"h4 white-fg pl-16 pr-16 pt-5 pb-5\">Información Adicional</div><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"close\"><md-icon md-font-icon=\"icon-close\" class=\"s16 white-fg\"></md-icon>\n</md-button></div><div class=\"pl-16 pr-16 pt-5 pb-5\" layout=\"column\" layout-align=\"center start\"><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"custom in request.custom_data\" class=\"pt-10 pb-10\"><label>\n{{custom.label}}:&nbsp;</label><span ng-bind-html=\"custom.value | highlight:vm.filter.search\"></span></div></div>\n</ms-widget-back></ms-widget></div><div class=\"container\"><div data-pagination ng-if=\"vm.pager.pages.length\" \nlayout=\"row\" layout-align=\"center center\"><span ng-class=\"{disabled:vm.pager.currentPage <= 1}\" \nng-click=\"vm.setPage(1)\" class=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'backflash\')\" \nng-mouseleave=\"vm.setHover(\'backflash\')\" md-colors=\"(vm.misc.hover.backflash)?{color: \'accent\'}:{color: \'primary\'}\"><i \nclass=\"icon-chevron-double-left\"></i> </span><span ng-class=\"{disabled:vm.pager.currentPage <= 1}\" \nng-click=\"vm.setPage(vm.pager.currentPage - 1)\" class=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'back\')\" \nng-mouseleave=\"vm.setHover(\'back\')\" md-colors=\"(vm.misc.hover.back)?{color: \'accent\'}:{color: \'primary\'}\"><i \nclass=\"icon-chevron-left\"></i></span><ul><li ng-repeat=\"page in vm.pager.pages\" \nng-class=\"{current:vm.pager.currentPage === page}\" class=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(page)\" \nng-mouseleave=\"vm.setHover(page)\" \nmd-colors=\"(vm.misc.hover[page] || vm.pager.currentPage === page)?{color: \'accent\'}:{color: \'primary\'}\"><span \nng-click=\"vm.setPage(page)\">{{page}}</span></li></ul><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.currentPage + 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'after\')\" ng-mouseleave=\"vm.setHover(\'after\')\" \nmd-colors=\"(vm.misc.hover.after)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-right\"></i> </span><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.totalPages)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'afterflash\')\" ng-mouseleave=\"vm.setHover(\'afterflash\')\" \nmd-colors=\"(vm.misc.hover.afterflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-right\"></i>\n</span></div></div></div></div></div>");
$templateCache.put("app/main/analyst/detail/detail.html","<div id=\"detail-analyst\" class=\"page-layout simple tabbed\"><header-request request=\"vm.request\" project=\"vm.project\">\n</header-request><div class=\"content\" ng-init=\"vm.setTabs()\"><md-tabs md-dynamic-height md-selected=\"vm.selectedTab\">\n<md-tab ng-repeat=\"tab in vm.tabbes\" ng-click=\"vm.callEvents(tab)\"><md-tab-label>{{tab.name}}</md-tab-label>\n<md-tab-body><div ng-include=\"tab.template\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/analyst/history-process-candidate/history-process-candidate.html","<div id=\"historyRequest\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div>\n<div class=\"break-tool-bar border-bottom pl-40 pr-40\" layout=\"row\" flex=\"100\" layout-wrap><ul \nclass=\"horizontal-list m-0 p-0 h6\" flex=\"100\" layout=\"row\" layout-wrap><li layout=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"20\" flex-lg=\"20\" flex-gt-lg=\"20\" flex-xl=\"20\">\n<div class=\"text-left mt-8 mb-10 pl-10 all-width\"><label class=\"\">Etapa</label><md-select class=\"m-0\" \naria-label=\"applicant\" ng-model=\"vm.selectedStage\" ng-change=\"selectBlock(stage)\"><md-option \nng-repeat=\"stage in vm.stages track by $index\" ng-value=\"stage.id\">{{stage.name | capitalize:true}}</md-option>\n</md-select></div></li></ul></div><div class=\"content m-24\"><div ng-if=\"vm.loading\" \nclass=\"p-30 md-title text-center md-whiteframe-4dp white-bg\">Cargando contenido, por favor espere...</div><div \nng-repeat=\"block in vm.blocksUnderstanding\"><div \nng-include=\"\'app/main/templates/block-generic/read/\' + block.type + \'.html\'\" \nng-init=\"item = block;root = vm.understanding\"></div></div></div></div>");
$templateCache.put("app/main/analyst/history-request/history-request.html","<div id=\"historyRequest\" class=\"page-layout simple\"><header-request request=\"vm.request\" project=\"vm.project\">\n</header-request><div class=\"content m-24\"><div ng-if=\"vm.loading\" \nclass=\"p-30 md-title text-center md-whiteframe-4dp white-bg\">Cargando contenido, por favor espere...</div><div \nng-if=\"!vm.loading\" class=\"main scrollable\" ms-scroll><div layout=\"column\" flex=\"100\" layout-align=\"start\"><div \nclass=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" layout=\"row\"><table class=\"row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Fecha y hora</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Usuario</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br text-center\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Acción</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br text-center\"><div class=\"table-header\"><span class=\"column-title white-fg\">Detalle</span>\n</div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br text-center\"><div class=\"table-header\"><span\n class=\"column-title white-fg\"></span></div></th></tr></thead><tbody><tr \nng-repeat=\"history in vm.historys  track by $index\"><td class=\"name font-weight-500\">\n{{history.date.formatDate | capitalize:true}}</td><td class=\"grey-100-bg\">{{history.user}}</td><td class=\"text-center\">\n{{history.action}}</td><td class=\"office text-center grey-100-bg\"><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"(key,value) in history.detail track by $index\" class=\"mt-10 mb-10\"><span class=\"font-weight-500 mr-10\">\n{{key}}:</span> <span class=\"w-500 text-left\">{{value }}</span></div></td><td class=\"office text-center\"><u \nclass=\"blue-300-fg cursor-pointer\" ng-click=\"vm.showDetail(history)\">Ver detalle</u></td></tr></tbody></table></div>\n</div></div></div></div>");
$templateCache.put("app/main/analyst/publish_request/publish_request.html","<div id=\"big-sidebar\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"content\" flex ms-scroll><div \nid=\"publishRequest\" class=\"page-layout simple\"><header-request request=\"vm.request\" project=\"vm.project\">\n</header-request><div class=\"content p-12\"><div layout=\"column\" class=\"p-17\"><div layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" layout-gt-md=\"row\" layout-gt-lg=\"row\" \nlayout-lg=\"row\" layout-align-xs=\"space-between center\" layout-align-gt-xs=\"space-between center\" \nlayout-align-sm=\"space-between center\" layout-align-gt-sm=\"space-between center\" \nlayout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-align-lg=\"space-between center\"><div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.request.status_offer.id == 2\"><div><span>Oferta <span class=\"font-weight-900\">\npublicada hasta</span></span></div><div layout=\"column\" layout-align=\"space-between\"><md-datepicker \nng-model=\"vm.dataPost.dateEnd\" md-placeholder=\"Fecha final\" md-min-date=\"vm.misc.tomorrow\" md-open-on-focus>\n</md-datepicker><span class=\"p-5 h6 red-500-fg\" ng-if=\"vm.misc.error.dataEnd\">\nDebe seleccionar una fecha limite para la publicación de la oferta</span></div><div class=\"ml-5\"><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 white-fg\" \nng-click=\"vm.changeDateOffer();\">Cambiar fecha</md-button></div></div></div><div><md-button \nng-if=\"vm.request.status_offer.id != 2\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.searchOffer();\">Importar publicación de oferta</md-button><md-button \nng-if=\"vm.request.status_offer.id == 2\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.closeOffer();\">Retirar oferta</md-button></div></div></div><div ng-repeat=\"block in vm.blocks\"><div \nng-include=\"\'app/main/templates/request/blocks/update/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div><div \nlayout=\"row\" layout-align=\"end end\" class=\"mr-17\"><md-button ng-disabled=\"block.saving\" ng-click=\"vm.saveBlock(block)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\" \naria-label=\"Guardar\">Guardar <span ng-class=\"{\'pl-5\':!$first}\" ng-repeat=\"title in block.title track by $index\">\n{{title}}</span></md-button></div></div><div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"grey-100-bg bb\" layout-xs=\"row\" \nlayout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" layout-gt-md=\"row\" layout-gt-lg=\"row\" \nlayout-lg=\"row\" layout-align-xs=\"space-between center\" layout-align-gt-xs=\"space-between center\" \nlayout-align-sm=\"space-between center\" layout-align-gt-sm=\"space-between center\" \nlayout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-align-lg=\"space-between center\"><div \nclass=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\"><div class=\"h5 text-uppercase\"><span class=\"font-weight-900\">\nCompartir </span>Oferta</div></div></div><div class=\"pt-20 pb-20 pl-20 pr-30 bb\"><div layout=\"column\" \nlayout-align=\"center center\"><div layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"row\" layout-gt-sm=\"row\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between \" layout-align-gt-sm=\"space-between \" \nlayout-align-md=\"space-between \" layout-align-gt-md=\"space-between \" layout-align-gt-lg=\"space-between \" \nlayout-align-lg=\"space-between \" class=\"mb-10\" flex=\"100\" layout-wrap><div class=\"margin-media\" flex-xs=\"100\" \nflex-sm=\"50\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"25\"><div class=\"container-social-media\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-link-variant s30 grey-500-fg m-10 color-web\"></i> <span class=\"h3\">\n{{vm.links.web}}</span></div></div><div class=\"margin-media\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"50\" flex-lg=\"50\" \nflex-xl=\"25\" layout-align=\"start center\"><div class=\"container-social-media\" layout=\"row\" layout-align=\"start center\">\n<i class=\"icon-facebook s30 grey-500-fg m-10 color-facebook\"></i> <span class=\"h3\">{{vm.links.facebook}}</span></div>\n</div><div class=\"margin-media\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"25\" \nlayout-align=\"start center\"><div class=\"container-social-media\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-twitter s30 grey-500-fg m-10 color-twitter\"></i> <span class=\"h3\">{{vm.links.twitter}}</span></div></div>\n<div class=\"margin-media\" flex-xs=\"100\" flex-sm=\"50\" flex-md=\"50\" flex-lg=\"50\" flex-xl=\"25\" \nlayout-align=\"start center\"><div class=\"container-social-media\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-linkedin s30 grey-500-fg m-10 color-linkedin\"></i> <span class=\"h3\">{{vm.links.linkedin}}</span></div>\n</div></div><div layout=\"column\" class=\"previewShare\"><div layout=\"row\" class=\"contentImgPublish\"><img \nng-src=\"{{vm.theme.media.shared}}\" class=\"imgPublish\"></div><div layout=\"column\" layout-align=\"center start\" \nclass=\"contentPublish\"><div layout=\"row\" class=\"urlPublish\">{{ vm.linkPublish}}</div><div layout=\"row\" \nclass=\"titlePublish text-truncate\">{{vm.values[\'nombre_cargo_publicacion\']}}</div><div layout=\"descition\" \nclass=\"descriptionPublish\"><span class=\"text-truncate\">{{vm.values[\'descripcion_cargo\']}}</span></div></div></div>\n</div></div><div layout=\"column\" class=\"grey-200-bg p-20\" layout-wrap><div layout-xs=\"row\" layout-gt-xs=\"row\" \nlayout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" layout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" \nlayout-align-xs=\"start center\" layout-align-gt-xs=\"start center\" layout-align-sm=\"start center\" \nlayout-align-gt-sm=\"start center\" layout-align-md=\"star center\" layout-align-gt-md=\"start center\" \nlayout-align-gt-lg=\"start center\" layout-align-lg=\"start center\" layout-wrap class=\"mb-10\"><div class=\"pr-10 pl-12\">\n<span>¿Desea compartir los enlaces de publicación al community manager?</span></div><div><md-checkbox \nclass=\"no-margin no-padding\" ng-model=\"vm.dataPost.share\" aria-label=\"publicar en redes\"></md-checkbox></div></div><div\n layout=\"row\" ng-if=\"vm.dataPost.share\" layout-wrap><ms-widget ng-repeat=\"community in vm.communities track by $index\" \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" layout-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><ms-widget-front class=\"p-10 white-bg\" \nng-style=\"{\'border-top-color\':vm.getThemeColor(\'accent\'),\'border-top-width\': \'3px\',\n                                        \'border-top-style\': \'solid\'}\">\n<div class=\"pb-5\" layout=\"row\" layout-align=\"start center\"><div layout-align=\"start center\"><div \nclass=\"h3 grey-600-fg text-light\"></div></div></div><div layout=\"column\" layout-between=\"space-between\"><div \nclass=\"md-title\">{{community.name}}</div><div class=\"subtitle secondary-text\">{{community.email}}</div><div \nclass=\"subtitle secondary-text\">{{community.phone}}</div></div></ms-widget-front></ms-widget></div></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"row\" flex=\"100\" ng-if=\"!vm.hide_bloque_other_medios\"><ms-widget-front \nclass=\"white-bg\"><div class=\"grey-100-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between center\" \nlayout-align-gt-sm=\"space-between center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-lg=\"space-between center\"><div class=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\"><div \nclass=\"h5 text-uppercase\"><span class=\"font-weight-900\">Publicación </span>en otros medios</div></div></div><div \nclass=\"pt-20 pb-20 pl-20 pr-30 bb\"><div layout=\"column\" ng-if=\"!vm.request.el_empleo_id\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"pr-10 w-30\"><md-checkbox class=\"no-margin no-padding\" \nng-model=\"vm.dataPost.public_empleo\"></md-checkbox></div><div><span>Publicar oferta en <span class=\"font-weight-700\">\nelempleo.com</span></span></div></div><div class=\"bb mt-20 mb-10\"></div></div><div layout=\"column\" \nng-if=\"vm.request.el_empleo_id\"><div layout=\"row\" layout-align=\"start center\"><div class=\"pr-10 w-30\"><i \nclass=\"icon-checkbox-marked-circle green-400-fg s20\"></i></div><div class=\"pr-10\"><span>Oferta publicada en <span \nclass=\"font-weight-700\">elempleo.com</span></span></div><div><span class=\"grey-400-fg\">\n{{vm.request.date_publish_elempleo.formatDate | capitalize:true}}</span></div></div></div></div></ms-widget-front>\n</ms-widget></div><div layout=\"column\" class=\"p-17\" layout-wrap><div class=\"bb mb-10\"></div><div layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" layout-gt-md=\"row\" layout-gt-lg=\"row\" \nlayout-lg=\"row\" layout-align-xs=\"space-between center\" layout-align-gt-xs=\"space-between center\" \nlayout-align-sm=\"space-between center\" layout-align-gt-sm=\"space-between center\" \nlayout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-align-lg=\"space-between center\"><div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.request.status_offer.id != 2\"><div><span>Publicar <span class=\"font-weight-900\">\noferta hasta</span></span></div><div layout=\"column\" layout-align=\"space-between\"><md-datepicker \nng-model=\"vm.dataPost.dateEnd\" md-placeholder=\"Fecha final\" md-min-date=\"vm.misc.tomorrow\" md-open-on-focus>\n</md-datepicker><span class=\"p-5 h6 red-500-fg\" ng-if=\"vm.misc.error.dataEnd\">\nDebe seleccionar una fecha limite para la publicación de la oferta</span></div></div></div><div><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 white-fg\" ng-click=\"vm.save();\" \nng-disabled=\"!vm.change || vm.saving\">Guardar</md-button><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.save(2);\" ng-if=\"vm.request.status_offer.id != 2\">Guardar y publicar oferta</md-button></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/analyst/reports/reports.html","<div id=\"reports\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/reports.html\'\"></div><div \nclass=\"content p-30\"><div layout=\"column\" flex=\"100\" layout-align=\"start\"><div layout=\"column\" \nclass=\"md-whiteframe-4dp all-width white-bg p-20 mb-20\"><div layout=\"row\"><span class=\"h2 font-weigth-500 mr-5\">Filtrar\n</span> <span class=\"h2\">resultados</span></div><div layout=\"row\" layout-align=\"start\" flex=\"100\" layout-wrap><div \nflex=\"33\" ng-repeat=\"(key,data) in vm.filters\"><div \nng-include=\"\'app/main/analyst/reports/template/filtros/\' + data.type + \'.html\'\" ng-init=\"filter = data;\"></div></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.search()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Buscar</md-button>\n<md-button ng-click=\"vm.clearFilter()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Limpiar</md-button></div></div>\n<div class=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" id=\"tableCollaborator\" layout=\"row\">\n<table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nng-repeat=\"(key,value) in vm.header\" md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div \nclass=\"table-header\"><span class=\"column-title white-fg\">{{value}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in vm.rows track by $index\"><td ng-repeat=\"(k,v) in row track by $index\"><cell-report value=\"v\">\n</cell-report></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/analyst/send-candidate-applicant/send-candidate-applicant.html","<div id=\"big-sidebar\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"content\" flex ms-scroll><div \nid=\"sendCandidateApplicant\" class=\"page-layout simple\"><header-request request=\"vm.request\" project=\"vm.project\">\n</header-request><div class=\"content m-24\"><div ng-if=\"vm.loading\" \nclass=\"p-30 md-title text-center md-whiteframe-4dp white-bg\">Cargando contenido, por favor espere...</div><div \nng-if=\"!vm.loading\" class=\"main scrollable\" ms-scroll><div layout=\"column\" flex=\"100\" layout-align=\"start\"><div \nlayout=\"row\" layout-align=\"space-between\" class=\"mb-10\"><span class=\"md-display-1 font-weight-300\">\nCandidatos disponibles para enviar al solicitante</span></div><div layout=\"row\" layout-align=\"space-between\" \nclass=\"mb-20 md-subhead font-weight-300\"><span>\nLos candidatos disponibles para enviar al solicitante son aquellos que se encuentran en las etapas: Finalista y dupla final\n</span></div><div class=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" layout=\"row\"><table \nclass=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Nombre</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Ciudad</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Edad</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Última fecha de envío</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Etapa de proceso</span></div>\n</th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Estado de revisión</span></div></th></tr></thead><tbody><tr \nng-repeat=\"candidate in vm.misc.candidate\"><td><div layout=\"row\"><div ng-if=\"!candidate.send_cliente\"><md-checkbox \nclass=\"no-label\" ng-model=\"candidate.isSelected\"></md-checkbox></div><div><span class=\"font-weight-500\">\n{{candidate.name}}</span></div></div></td><td class=\"grey-100-bg\">{{candidate.city}}</td><td class=\"text-center\">\n{{candidate.age}}</td><td class=\"grey-100-bg\"><div ng-if=\"candidate.last_send\"><span>\n{{candidate.last_send.formatDate | capitalize:true}}</span><br><span>({{candidate.last_send.stringDateInMonth}})</span>\n</div></td><td>{{candidate.stage}}</td><td><div layout=\"row\" layout-align=\"start center\" class=\"h-60\"><div><span \nclass=\"badge-estado-suspension\" ng-style=\"{\'background-color\':candidate.colorStateReview}\">{{candidate.stateReview}}\n</span></div><div ng-if=\"candidate.send_cliente\" class=\"ml-5\"><md-tooltip md-direction=\"top\">Volver a enviar finalista\n</md-tooltip><i class=\"icon-email\" md-colors=\"{color:\'accent\'}\" ng-click=\"vm.sendCandidateSelected(candidate)\"></i>\n</div></div></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"end center\" class=\"mt-20\"><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.sendCandidateSelecteds()\">Enviar candidatos</md-button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/analyst/share-request/share-request.html","<div id=\"shareDetail\" class=\"page-layout simple\"><header-request request=\"vm.request\" project=\"vm.project\">\n</header-request><div class=\"content m-24\"><div ng-if=\"vm.loading\" \nclass=\"p-30 md-title text-center md-whiteframe-4dp white-bg\">Cargando contenido, por favor espere...</div><div \nng-if=\"!vm.loading\" class=\"main scrollable\" ms-scroll><div layout=\"column\" flex=\"100\" layout-align=\"start\"><div \nclass=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" layout=\"row\"><table class=\"row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Responsable de la selección</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Email</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br text-center\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Enviar tema final</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br text-center\"><div class=\"table-header\"><span class=\"column-title white-fg\">\nSeleccionar candidato final</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br text-center\"><div class=\"table-header\"><span class=\"column-title white-fg\">Suspender proceso\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"analyst in vm.misc.analysts\"><td class=\"name font-weight-500\">\n{{analyst.name}}</td><td class=\"grey-100-bg\">{{analyst.email}}</td><td class=\"office text-center\"><md-checkbox \nclass=\"no-label\" ng-model=\"analyst.prm_enviar_cliente\" aria-label=\"enviar\"></md-checkbox></td><td \nclass=\"office text-center grey-100-bg\"><md-checkbox class=\"no-label\" ng-model=\"analyst.prm_aprobar\" \naria-label=\"aprobar\"></md-checkbox></td><td class=\"office text-center\"><md-checkbox class=\"no-label\" \nng-model=\"analyst.prm_suspender\" aria-label=\"suspender\"></md-checkbox></td></tr></tbody></table></div><div \nlayout=\"row\" layout-align=\"end end\" class=\"mt-10\"><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 mb-10 white-fg no-margin\" \nng-click=\"vm.dataSerielizate()\" aria-label=\"aceptar\">ACEPTAR</md-button></div></div></div></div></div>");
$templateCache.put("app/main/analyst/suspension-request/suspension-request.html","<div id=\"big-sidebar\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"content\" flex ms-scroll><div \nid=\"suspensionRequest\" class=\"page-layout simple\"><header-request request=\"vm.request\" project=\"vm.project\">\n</header-request><div class=\"content mb-30\"><div ng-if=\"vm.loading\" class=\"p-30 md-title text-center\">\nCargando contenido, por favor espere...</div><div ng-if=\"!vm.loading\" class=\"main scrollable\" ms-scroll><div \nlayout=\"column\" flex=\"100\" layout-align=\"start\" class=\"m-24\"><div layout=\"column \"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-15\"><span class=\"md-display-1 font-weight-300\">Historial de suspensiones\n</span><div \nng-if=\"vm.request.status_process.id != vm.status_process_status.PROCESO_SUSPENDIDO && vm.user.group_id != 1\"><md-button\n aria-label=\"Guardar\" \nclass=\"md-primary submit-button md-raised h6 h-30 line-height-30 white-fg pl-20 pr-20 no-margin remove-uppercase\" \nng-click=\"vm.showModalSuspension()\">Suspender proceso</md-button></div><div \nng-if=\"vm.request.status_process.id == vm.status_process_status.PROCESO_SUSPENDIDO\"><md-button aria-label=\"Guardar\" \nclass=\"md-accent md-raised h6 h-30 line-height-30 white-fg pl-20 pr-20 no-margin remove-uppercase\" \nng-click=\"vm.activarRequest()\">Activar proceso</md-button></div></div><div \nclass=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" layout=\"row\"><table datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead class=\"\"><tr><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Fecha de suspensión</span>\n</div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Responsable</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Motivo de suspensión</span>\n</div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Tiempo suspendido</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Fecha de activación</span>\n</div></th></tr></thead><tbody><tr ng-init=\"color = {\'background-color\': request.estado_color}\" \nng-repeat=\"suspension in vm.misc.arrSupension \"><td class=\"colot-text-table\">\n{{suspension.date_suspension.formatDate | capitalizeFirstLetter}}</td><td \nclass=\"grey-100-bg font-weight-500 colot-text-table\">{{suspension.name | capitalize:true}}</td><td><div \nlayout=\"column\" layout-align=\"space-between\" class=\"p-10\"><div><span class=\"badge-title-suspension font-weight-300\">\n{{suspension.criterioString}}</span></div><div class=\"mt-10\"><span class=\"h4 colot-text-table pre-line\">\n{{suspension.reason_suspension}}</span></div></div></td><td \nclass=\"text-center grey-100-bg font-weight-500 colot-text-table\"><span \nng-if=\"suspension.date_suspension.serializeDate.isToday\"><span \nng-if=\"suspension.date_suspension.serializeDate.hours > 0\">\n{{ suspension.date_suspension.serializeDate.textSuggested.hours }} </span><span \nng-if=\"suspension.date_suspension.serializeDate.hours == 0 && suspension.date_suspension.serializeDate.minutes > 0\">\n{{ suspension.date_suspension.serializeDate.textSuggested.minutes }} </span><span \nng-if=\"suspension.date_suspension.serializeDate.minutes == 0 \">\n{{ suspension.date_suspension.serializeDate.textSuggested.seconds }} </span></span><span \nng-if=\"!suspension.date_suspension.serializeDate.isToday\">\n{{ suspension.date_suspension.stringDateInMonth | limitTo : 20 : 5 | capitalize:true}}</span></td><td \nclass=\"colot-text-table\">{{ suspension.date_restart.formatDate | capitalizeFirstLetter }}</td></tr></tbody></table>\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/analyst/team-processes/team_processes.html","<div id=\"teamProcesses\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div>\n<div class=\"break-tool-bar border-bottom pl-40 pr-40\" layout=\"row\" flex=\"100\" layout-wrap><ul \nclass=\"horizontal-list m-0 p-0 h6\" flex=\"100\" layout=\"row\" layout-wrap><li layout=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"20\" flex-gt-lg=\"20\" flex-xl=\"20\">\n<div class=\"pl-10 pr-10 pt-15\"><div class=\"search\" layout=\"row\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.filter.query\" type=\"text\" \nplaceholder=\"Buscar\" flex></div></div></li><li layout=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"20\" flex-gt-lg=\"20\" flex-xl=\"20\"><div \nclass=\"text-left border-left mt-8 mb-10 pl-10\"><label class=\"\">Solicitante</label><md-select class=\"m-0\" \naria-label=\"applicant\" ng-model=\"vm.filter.solicitante_id\"><md-option ng-value=\"-1\" \nng-selected=\"-1 == vm.misc.filter.defaultApplicant\">Todos los solicitantes</md-option><md-option \nng-repeat=\"applicant in vm.misc.arrApplicant track by $index\" ng-value=\"applicant.id\">\n{{applicant.name | capitalize:true}}</md-option></md-select></div></li><li layout=\"row\" flex=\"100\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"20\" flex-gt-lg=\"20\" flex-xl=\"20\">\n<div class=\"text-left border-left mt-8 mb-10 pl-10\"><label class=\"\">Estado del proceso</label><md-select class=\"m-0\" \naria-label=\"status\" ng-model=\"vm.filter.estado_proceso\"><md-option ng-value=\"-1\" \nng-selected=\"-1 == vm.misc.filter.defaultStatusRequest\">Todos los estados</md-option><md-option \nng-repeat=\"status in vm.misc.arrStatusRequest\" ng-value=\"status.id\">{{status.name | capitalize:true}}</md-option>\n</md-select></div></li><li layout=\"row\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"20\" flex-gt-lg=\"20\" flex-xl=\"20\"><div \nclass=\"text-left border-left mt-8 mb-10 pl-10\"><label class=\"\">Regionales</label><md-select class=\"m-0\" \naria-label=\"status\" ng-model=\"vm.filter.regional_id\"><md-option ng-value=\"-1\" \nng-selected=\"-1 == vm.misc.filter.defaultRegionalRequest\">Todas las empresas</md-option><md-option \nng-repeat=\"status in vm.misc.arrRegionalRequest\" ng-value=\"status.id\">{{status.name | capitalize:true}}</md-option>\n</md-select></div></li><li layout=\"row\" flex=\"20\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"20\" flex-gt-lg=\"20\" flex-xl=\"20\"><div \nclass=\"text-left border-left mt-8 mb-10 pl-10\"><label class=\"\">Responsables</label><md-select class=\"m-0\" \naria-label=\"status\" ng-model=\"vm.filter.analista_id\"><md-option ng-value=\"-1\" \nng-selected=\"-1 == vm.misc.filter.defaultAnalystRequest\">Todas los responsables</md-option><md-option \nng-repeat=\"status in vm.misc.arrAnalysts\" ng-value=\"status.id\">{{status.name | capitalize:true}}</md-option>\n</md-select></div></li><li layout=\"row\" layout-align=\"start center\" flex=\"100\"><md-datepicker \nng-model=\"vm.filter.startDate\" md-placeholder=\"Inicio\" md-open-on-focus></md-datepicker><md-datepicker \nng-disabled=\"!vm.filter.startDate\" md-min-date=\"vm.filter.startDate\" ng-model=\"vm.filter.endDate\" md-placeholder=\"Fin\" \nmd-open-on-focus></md-datepicker></li></ul><div class=\"text-left mt-8 mb-10 pl-10\" layout=\"row\" \nlayout-align=\"center center\"><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.search();\">Buscar</md-button><md-button \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.clearFilter();\">Limpiar</md-button></div></div><div ng-if=\"vm.loading\" \nclass=\"p-30 md-title text-center md-whiteframe-4dp white-bg\">Cargando contenido, por favor espere...</div><div \nclass=\"content p-30\"><div ng-if=\"!vm.loading\" class=\"main scrollable\" ms-scroll><div layout=\"column\" flex=\"100\" \nlayout-align=\"start\"><div class=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" \nid=\"tableCollaborator\" layout=\"row\"><table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Proceso</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Vacantes</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Responsable de selección</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Fecha de creación</span></div>\n</th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Estado</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Solicitante</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Solicitantes</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Base de datos</span></div></th>\n<th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Candidatos que aplicaron</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Preseleccionados</span></div>\n</th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">En proceso</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Finalista</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Aprobado cliente</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Seleccionados</span></div></th>\n<th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Descartados</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Recomendados</span></div></th>\n<th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Total</span></div></th></tr></thead><tbody><tr ng-repeat=\"request in vm.requests\"><td>\n<div layout=\"column\"><span class=\"font-weight-500 cursor-pointer\" ng-click=\"vm.goDetail(request.id);\">{{request.name}}\n</span><div layout=\"row\"><span>Ciudad: </span><span class=\"font-weight-500 cursor-pointer\">{{request.state}}</span>\n</div><div layout=\"row\"><span>No.req: </span><span class=\"font-weight-500 cursor-pointer\">{{request.cod}}</span></div>\n</div></td><td class=\"grey-100-bg text-center\">{{request.count_vacant}}</td><td class=\"\"><div layout=\"column\" \nng-show=\"!request.selected\"><span>{{request.analyst.name}}</span> <u ng-click=\"request.selected = true;\" \nclass=\"cursor-pointer blue-300-fg text_underline\">Modificar</u></div><div layout=\"column\" ng-if=\"request.selected\">\n<md-input-container><div class=\"h4 grey-fg font-weight-300\"><label>Lista analistas</label></div><md-select \naria-label=\"Seleccionar Etapa\" ng-model=\"vm.data[request.id]\" class=\"\"><md-option \nng-repeat=\"data in vm.misc.arrAnalysts track by $index\" ng-value=\"data\">{{data.name}}</md-option></md-select>\n</md-input-container><md-progress-circular ng-if=\"request.loading\" md-mode=\"indeterminate\"></md-progress-circular><div \nclass=\"pt-5\" layout=\"row\" layout-align=\"space-between\"><md-button ng-if=\"request.selected\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"request.selected = false;\">Cancelar</md-button><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.updateAnalyst(vm.data[request.id],request);\">Guardar</md-button></div></div></td><td class=\"grey-100-bg\">\n{{request.createdDate.formatDate | capitalize:true}}</td><td>{{request.status_process.estado}}</td><td \nclass=\"grey-100-bg\"><div layout=\"column\"><span class=\"grey-400-fg font-weight-300\">{{request.applicant_from}}</span> \n<span>{{request.applicant}}</span></div></td><td class=\"text-center\">{{request.candidate_info.solicitantes}}</td><td \nclass=\"grey-100-bg text-center\">{{request.candidate_info.db}}</td><td class=\"text-center\">\n{{request.candidate_info.applicants}}</td><td class=\"grey-100-bg text-center\">{{request.candidate_info.preSelected}}\n</td><td class=\"text-center\">{{request.candidate_info.in_process}}</td><td class=\"grey-100-bg text-center\">\n{{request.candidate_info.finalysts}}</td><td class=\"text-center\">{{request.candidate_info.approved}}</td><td \nclass=\"grey-100-bg text-center\">{{request.candidate_info.selected}}</td><td class=\"text-center\">\n{{request.candidate_info.discards}}</td><td class=\"grey-100-bg text-center\">{{request.candidate_info.recommends}}</td>\n<td class=\"text-center\">{{request.candidate_info.candidates}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/analyst/understanding-charge/understanding-charge-autocomplete.html","<div layout=\"column\" layout-align=\"space-betweeen\" class=\"main scrollable p-7\" ms-scroll><div layout=\"row\" \nlayout-align=\"end center\" class=\"p-24\"><md-button \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 mb-10 white-fg no-margin\" \nng-click=\"vm.stateGo(\'app.entendimiento_cargo.index\')\">Regresar</md-button></div><div layout=\"row\" layout-wrap><div \nlayout=\"column\" class=\"pl-24 mt-15 br\" flex=\"30\"><div layout=\"column\" layout-align=\"start \" class=\"p-10 grey-200-bg\">\n<div class=\"search-wrapper md-whiteframe-4dp h-50 mb-10 white-bg p-20\" layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input flex ng-model=\"vm.query\" ng-change=\"vm.getProcess(vm.idRequest,vm.query);\" \ntype=\"text\" placeholder=\"Search for an e-mail or contact\" translate translate-attr-placeholder=\"Buscar Cargo\" \nng-model-options=\"{ debounce: 1000 }\"></div></div></div><div layout=\"row\" class=\"p-10\" md-colors=\"{color:\'warn\'}\"><div>\n<i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i></div><span>Seleccione el proceso que desea visualizar.</span>\n</div><div ng-if=\"!vm.errorSearch.valid\" class=\"p-5\"><div layout=\"row\" layout-align=\"center center\" class=\"mt-15\"><div \nclass=\"pl-25 pr-25 pt-15 pb-15 h2 mt-10 grey-500-fg\">{{vm.errorSearch.message}}</div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.loadingProcess\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><ms-widget ng-if=\"vm.errorSearch.valid\" ng-repeat=\"proceso in vm.process track by $index\" \nclass=\"p-5\" ng-click=\"vm.getUnderstandingCharge(proceso)\"><ms-widget-front class=\"p-15 process\" \nng-style=\"{\'border-top-color\':vm.getThemeColor(\'accent\'),\'border-top-width\': \'3px\',\n                \'border-top-style\': \'solid\'}\">\n<div class=\"pb-5\" layout=\"row\" layout-align=\"start center\"><div layout-align=\"start center\"><div \nclass=\"h3 grey-600-fg text-light\"></div></div></div><div layout=\"column\" layout-between=\"space-between\"><div \nlayout=\"row\" layout-align=\"end center\"><span class=\"bagde mb-10 secondary-text\"><span class=\"h5 font-weight-500\">\nCódigo:&nbsp;</span> <span class=\"h5 font-weight-500\">{{proceso.codigo | capitalize:true}}</span></span></div><div \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h4 font-weight-700 grey-600-fg line-height-20\">\n{{proceso.cargo_ocupar | capitalize:true}}</span></div><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"h5 font-weight-500 grey-500-fg\">Solicitante:&nbsp;</span><div layout=\"row\" layout-align=\"start center\" \nclass=\"h5 font-weight-400 grey-500-fg\"><span>{{proceso.solicitante | capitalize:true}} </span><span \nng-if=\"proceso.cliente.empresa  && proceso.cliente.area\">\n({{proceso.cliente.empresa | capitalize:true}} - {{proceso.cliente.area}})</span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h5 font-weight-500 grey-500-fg\">Fecha solicitud:&nbsp; </span><span \nclass=\"h5 font-weight-400 grey-500-fg\">\n{{proceso.fecha_solicitud | moment: \'format\': \'MMM DD, YYYY\'  | capitalizeFirstLetter}}</span></div></div>\n</ms-widget-front></ms-widget></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.misc.showPage\" \nclass=\"pl-10 pr-24 mt-15\" flex=\"70\"><div layout=\"row\" layout-align=\"center center\" class=\"mt-15 all-width\"><div \nclass=\"pl-25 pr-25 pt-15 pb-15 h2 mt-10 grey-500-fg\">No hay ningún proceso seleccionado</div></div></div><div \nlayout=\"column\" ng-if=\"vm.misc.showPage\" class=\"pl-10 mt-15\" flex=\"70\"><div layout=\"row\" class=\"mb-10\" \nng-if=\"vm.misc.showPage\"><span class=\"ml-17\">\nPor favor seleccione los bloques que desea copiar en el entendimiento del cargo actual.</span></div><div \nng-repeat=\"block in vm.blocks\"><div \nng-include=\"\'app/main/templates/request/blocks/autocomplete/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div>\n</div><div layout=\"row\" layout-align=\"center center\"><div class=\"m-10\"><md-button \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 mb-10 no-margin\" \nng-click=\"vm.stateGo(\'app.entendimiento_cargo.index\')\">CANCELAR</md-button></div><div class=\"m-10\"><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 mb-10 white-fg no-margin\" \nng-click=\"vm.saveAutocomplete()\" ng-disabled=\"vm.checkBlock.length == 0\">ACEPTAR</md-button></div></div></div></div>\n</div>");
$templateCache.put("app/main/analyst/understanding-charge/understanding-charge-primary.html","<div ng-if=\"vm.loading\" class=\"p-30 md-title text-center\">Cargando contenido, por favor espere...</div><div \nng-if=\"!vm.loading \" class=\"main scrollable p-7\" ms-scroll><div layout-align-xs=\"start start\" \nlayout-align-gt-xs=\"start start\" layout-align-sm=\"start start\" layout-align-gt-sm=\"start start\" \nlayout-align-md=\"start start\" layout-align-gt-md=\"start start\" layout-align-lg=\"end center\" \nlayout-align-gt-lg=\"end center\" ayout-align-xl=\"end center\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-sm=\"column\" layout-md=\"column\" layout-gt-md=\"column\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" layout-wrap class=\"m-15\"><md-button \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 mb-10 white-fg no-margin\" \nng-click=\"vm.stateGo(\'app.entendimiento_cargo.autocompletar\');\">Autocompletar entendimiento del cargo</md-button></div>\n<div layout=\"row\" layout-align=\"start center\" class=\"pl-20 pr-20\"><div layout=\"row\" class=\"tab\" \nng-click=\"vm.selectedTab(\'rq\');\" \nng-style=\"vm.misc.tabSelected == \'rq\' ? {\'border-bottom-color\':vm.getThemeColor(\'accent\'),\'border-bottom-width\': \'1px\',\n        \'border-bottom-style\': \'solid\'} : {}\">\nREQUISICIÓN</div><div layout=\"row\" class=\"tab\" ng-click=\"vm.selectedTab(\'ec\');\" \nng-style=\"vm.misc.tabSelected == \'ec\' ? {\'border-bottom-color\':vm.getThemeColor(\'accent\'),\'border-bottom-width\': \'1px\',\n        \'border-bottom-style\': \'solid\'} : {}\">\nEntendimiento del cargo</div></div><div layout=\"column\" ng-show=\"vm.misc.tabSelected == \'rq\'\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"m-15\"><div md-colors=\"{color: \'primary\'}\"><i class=\"icon-email cursor-pointer\" \nng-click=\"vm.showModalApprovedEmails(2)\"></i></div><div md-colors=\"{color: \'accent\'}\"><i \nclass=\"icon-file-pdf-box cursor-pointer\" ng-click=\"vm.downloadRequestPDF()\"></i></div></div><div \nng-repeat=\"block in vm.blocksRequests\"><div \nng-include=\"\'app/main/templates/block-generic/read/\' + block.type + \'.html\'\" \nng-init=\"item = block; root = vm.proccess\"></div></div></div><div layout=\"column\" \nng-show=\"vm.misc.tabSelected == \'ec\'\"><div layout=\"row\" layout-align=\"end center\" class=\"m-15\"><div \nmd-colors=\"{color: \'primary\'}\"><i class=\"icon-email cursor-pointer\" ng-click=\"vm.showModalApprovedEmails(1)\"></i></div>\n<div md-colors=\"{color: \'accent\'}\"><i class=\"icon-file-pdf-box cursor-pointer\" ng-click=\"vm.downloadPDF()\"></i></div>\n</div><div ng-repeat=\"block in vm.blocksUnderstanding\"><div layout=\"column\" layout-align=\"end end\" class=\"mr-15 ml-15\">\n<div layout=\"row\" layout-align=\"start center\"><span ng-if=\"block.date_created\"><strong>Fecha de creación:</strong>\n {{block.date_created}}</span></div><div layout=\"row\" layout-align=\"start center\"><span ng-if=\"block.date_updated\">\n<strong>Fecha de actualización:</strong> {{block.date_updated}}</span></div></div><div \nng-include=\"\'app/main/templates/block-generic/read/\' + block.type + \'.html\'\" \nng-init=\"item = block;root = vm.understanding\"></div></div><div layout=\"row\" class=\"pb-15\" \nlayout-align=\"center center\"><div class=\"p-5\" \nng-if=\"vm.request.approve_understanding.enviar_entendimiento_aprobacion == 1\"><div layout-wrap \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'No enviado\' || vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Rechazado\'\">\n<md-button ng-disabled=\"vm.understanding.saving\" ng-click=\"vm.validateUnderstanding(true,2)\" \nclass=\"md-raised light-green-500-bg h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg all-width\" \naria-label=\"Guardar y aprobar\">Guardar y enviar aprobación</md-button></div></div></div></div></div>");
$templateCache.put("app/main/analyst/understanding-charge/understanding-charge.html","<div id=\"understanding-charge\" class=\"page-layout simple\"><header-request request=\"vm.request\" project=\"vm.project\">\n</header-request><div class=\"content\" md-background-bg><div ui-view></div></div></div>");
$templateCache.put("app/main/auth/acuerdo-servicio/acuerdo-servicio.html","<div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div layout=\"column\" flex=\"100\" \nclass=\"p-20\"><div class=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div><h1 class=\"text-center\" \nng-if=\"vm.approve == 1\">¡Gracias por guardar tu repuesta!</h1><form name=\"acuerdoform\" novalidate class=\"p-20\" \nlayout=\"column\" ng-if=\"vm.approve == 0\"><md-input-container class=\"md-block\" md-no-float><label for=\"comment\">\nComentario</label><textarea name=\"comment\" ng-model=\"vm.acuerdoform.comment\" rows=\"3\" required></textarea><div \nng-messages=\"acuerdoform.comment.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FIELD_REQUIRED\">Campo requerido</span></div></div></md-input-container><div class=\"text-center\"><md-button \nng-click=\"vm.save()\" aria-label=\"ACEPTAR\" type=\"submit\" ng-disabled=\"acuerdoform.$invalid || acuerdoform.$pristine\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></form><div layout=\"row\" layout-align=\"center center\" class=\"mt-10 p-20\"><span>Powered by | <a \nclass=\"light-blue-500-fg\" href=\"http://vectorial.co\" target=\"_blank\">Vectorial</a></span></div></div></div></div></div>");
$templateCache.put("app/main/auth/login/login.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button href=\"/login-dashboard/\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Regresar</md-button></div>\n<div class=\"pl-5 pr-5\"><md-button href=\"/signin\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Registrarse</md-button></div>\n</div></div><div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div layout=\"column\" flex=\"100\" \nclass=\"p-20\"><div class=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div><form name=\"loginForm\" \nnovalidate class=\"p-20\" layout=\"column\"><md-input-container class=\"md-block\" md-no-float><label for=\"user\">\nDocumento de identidad</label><input name=\"user\" ng-model=\"vm.form.user\" required><div \nng-messages=\"loginForm.user.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FIELD_REQUIRED\">Campo requerido</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><label for=\"password\">Contraseña</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nrequired><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"FIELD_REQUIRED\">Campo requerido</span></div></div></md-input-container><div class=\"text-center\"><md-button \nng-click=\"vm.login()\" aria-label=\"ACEPTAR\" type=\"submit\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div><div layout=\"row\" layout-align=\"center center\" class=\"p-10\"><a ui-sref=\"app.auth-recover-password\" \nclass=\"forgot-password cursor-pointer md-accent-color h6\">Olvidé mi contraseña</a></div></form><div layout=\"row\" \nlayout-align=\"center center\" class=\"mt-10 p-20\"><span>Powered by | <a class=\"light-blue-500-fg\" \nhref=\"http://vectorial.co\" target=\"_blank\">Vectorial</a></span></div></div></div></div></div>");
$templateCache.put("app/main/auth/login-admin/login-admin.html","<div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div layout=\"column\" flex=\"100\" \nclass=\"p-20\"><div class=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div><form \nng-if=\"vm.loginType.auth_type == \'credentials\'\" name=\"loginForm\" novalidate class=\"p-20\"><md-input-container \nclass=\"md-block\" md-no-float><label for=\"user\">{{ vm.label_user }}</label><input name=\"user\" ng-model=\"vm.form.user\" \nrequired><div ng-messages=\"loginForm.user.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nCampo requerido</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><label \nfor=\"password\">Contraseña</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Campo requerido</span></div>\n</div></md-input-container><div layout=\"row\" layout-align=\"center center\" class=\"p-10\"><a \nui-sref=\"app.auth-recover-password\" class=\"forgot-password cursor-pointer md-accent-color h6\">Olvidé mi contraseña</a>\n</div><div class=\"text-center\"><md-button ng-click=\"vm.login()\" aria-label=\"ACEPTAR\" type=\"submit\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></form><form ng-if=\"vm.loginType.auth_type == \'custom\'\" name=\"loginForm\" novalidate class=\"p-20\">\n<md-input-container ng-repeat=\"field in vm.loginType.auth_fields\" class=\"md-block\" md-no-float><label \nfor=\"{{field.field}}\">{{field.label}}</label><input name=\"{{field.field}}\" type=\"{{field.type}}\" \nng-model=\"vm.form[field.field]\" required><div ng-messages=\"loginForm.user.$error\" role=\"alert\" multiple=\"multiple\"><div\n ng-message=\"required\"><span>Campo requerido</span></div></div></md-input-container><div layout=\"row\" \nlayout-align=\"center center\" class=\"p-10\"><a ui-sref=\"app.auth-recover-password-admin\" \nclass=\"forgot-password cursor-pointer md-accent-color h6\">Olvidé mi contraseña</a></div><div class=\"text-center\">\n<md-button ng-click=\"vm.loginCustom()\" aria-label=\"ACEPTAR\" type=\"submit\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></form><div layout=\"row\" layout-align=\"center center\" class=\"mt-10 p-20\"><span>Powered by | <a \nclass=\"light-blue-500-fg\" href=\"http://vectorial.co\" target=\"_blank\">Vectorial</a></span></div></div></div></div></div>");
$templateCache.put("app/main/auth/login-analyst/login_analyst.html","<div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div layout=\"column\" flex=\"100\" \nclass=\"p-20\"><div class=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div><form name=\"loginForm\" \nnovalidate class=\"p-20\"><md-input-container class=\"md-block\" md-no-float><label for=\"user\">{{ vm.label_user }}</label>\n<input name=\"user\" ng-model=\"vm.form.user\" required><div ng-messages=\"loginForm.user.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Campo requerido</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label for=\"password\">Contraseña</label><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Campo requerido</span></div></div></md-input-container><div layout=\"row\" \nlayout-align=\"center center\" class=\"p-10\"><a ui-sref=\"app.auth-recover-password-admin\" \nclass=\"forgot-password cursor-pointer md-accent-color h6\">Olvidé mi contraseña</a></div><div class=\"text-center\">\n<md-button ng-click=\"vm.login()\" aria-label=\"ACEPTAR\" type=\"submit\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></form><div layout=\"row\" layout-align=\"center center\" class=\"mt-10 p-20\"><span>Powered by | <a \nclass=\"light-blue-500-fg\" href=\"http://vectorial.co\" target=\"_blank\">Vectorial</a></span></div></div></div></div></div>");
$templateCache.put("app/main/auth/login-dashboard/login-dashboard.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button href=\"/login\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-10 pr-10 no-margin\">Iniciar sesión</md-button>\n</div><div class=\"pl-5 pr-5\"><md-button href=\"/signin\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase no-padding no-margin\">Registrarse</md-button></div>\n</div></div><div layout=\"row\" class=\"content page-layout all-height\" layout-wrap><div class=\"login-background\" \nlayout=\"column\" ng-style=\"vm.theme.loginBackground\" flex=\"60\" hide-xs hide-gt-xs hide-sm hide-gt-sm show-md show-gt-md \nlayout-align=\"center start\" layout-wrap><div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div \nclass=\"md-display-3 font-weight-200\">TRABAJA CON</div><div class=\"md-display-3 font-weight-400\">NOSOTROS</div><div \nclass=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES</div></div></div><div flex-xs=\"100\" flex-gt-xs=\"100\" \nflex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"40\" flex-gt-md=\"40\" ms-scroll><div class=\"white-bg p-25\"><div \nmd-colors=\"{color: \'primary\'}\" class=\"h3\">OFERTAS LABORALES</div><div class=\"h6\"><strong>\nA continuación podrás conocer algunas de nuestras ofertas</strong>\n laborales. si deseas aplicar a alguna debes registrarte y completar tu hoja de vida.</div></div><div \nng-if=\"vm.loading\" class=\"grey-200-bg pl-25 pr-25 pt-15 pb-15 h3\">\nEspera un momento por favor, estamos cargando las ofertas...</div><div ng-if=\"!vm.loading\" layout=\"column\" \nclass=\"grey-200-bg pl-25 pr-25 pt-15 pb-15\"><div layout=\"column\" layout-align=\"start start\"><div class=\"pl-5\"><span \nclass=\"color-input h6\">Seleccione un país:</span></div><div class=\"pt-8 pb-10\" layout=\"row\" layout-wrap \nlayout-align=\"start center\" flex=\"100\"><div ng-repeat=\"(key,pais) in vm.paises\" \nclass=\"p-5 cursor-pointer container-img\"><img ng-src=\"assets/images/banderas/{{key}}.jpg\" class=\"width-img\" \nng-click=\"vm.setPaisSelected(key)\" alt=\"prueba\"><md-tooltip md-direction=\"bottom\">{{pais}}</md-tooltip></div></div>\n</div><div class=\"pt-8 pb-10 h-80\" layout=\"row\" layout-wrap><div class=\"pl-5 pr-5 pt-8 pb-10\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\">\n<md-input-container class=\"md-block h6 no-padding no-margin all-width\"><label class=\"pb-5 pt-5\">Ciudad</label>\n<md-autocomplete ng-disabled=\"vm.isDisabled\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCity\" \nmd-search-text=\"vm.searchCityText\" md-selected-item-change=\"vm.selectedCityChange(item)\" \nmd-items=\"item in vm.queryCitySearch(vm.searchCityText)\" md-item-text=\"item.name | capitalize:true\" md-min-length=\"0\" \nplaceholder=\"Escribe para buscar\"><md-item-template><span md-highlight-text=\"vm.searchCityText\" \nmd-highlight-flags=\"^i\">{{item.name | capitalize:true}}</span></md-item-template><md-not-found>\nNo se encontraron coincidencias con el texto \"{{vm.searchCityText}}\".</md-not-found></md-autocomplete>\n</md-input-container></div><div class=\"pl-5 pr-5 pt-8 pb-10\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" \nflex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><md-input-container \nclass=\"md-block h6 no-padding no-margin all-width\"><label class=\"pb-5 pt-5\">Área</label><md-autocomplete \nng-disabled=\"vm.isDisabled\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedArea\" \nmd-search-text=\"vm.searchAreaText\" md-selected-item-change=\"vm.selectedAreaChange(item)\" \nmd-items=\"item in vm.queryAreaSearch(vm.searchAreaText)\" md-item-text=\"item.name | capitalize:true\" md-min-length=\"0\" \nplaceholder=\"Escribe para buscar\"><md-item-template><span md-highlight-text=\"vm.searchAreaText\" \nmd-highlight-flags=\"^i\">{{item.name | capitalize:true}}</span></md-item-template><md-not-found>\nNo se encontraron coincidencias con el texto \"{{vm.searchAreaText}}\".</md-not-found></md-autocomplete>\n</md-input-container></div></div><div class=\"pt-8 pb-10 h-50\" layout=\"row\"><div layout-align=\"start center\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\">\n<label class=\"pl-5 pb-5 pt-5 grey-500-fg h7\">Publicados desde</label><md-input-container \nclass=\"no-padding no-margin all-width\"><md-datepicker md-max-date=\"vm.maxDate\" ng-change=\"vm.resetSearch()\" \nclass=\"all-width\" ng-model=\"vm.filters[2]\" md-placeholder=\"\" aria-label=\"Date filter\" md-open-on-focus></md-datepicker>\n</md-input-container></div><div class=\"pt-8 pb-5 pr-5 pl-5\" layout=\"row\" layout-align=\"start center\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div \nng-click=\"vm.resetFilters()\" class=\"cursor-pointer mt-20\" aria-label=\"Reset\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><md-tooltip md-direction=\"top\">Limpiar filtros</md-tooltip></div></div></div></div><div ng-if=\"!vm.loading\" \nclass=\"white-bg\"><div ng-if=\"vm.offers.length\" infinite-scroll=\"vm.loadMore()\" infinite-scroll-disabled=\"vm.loading\" \ninfinite-scroll-distance=\"1\" infinite-scroll-container=\'\"#content\"\' class=\"bb\" ng-repeat=\"offer in vm.offers\"><div \nclass=\"pl-15 pr-15 pt-10 pb-10\"><div class=\"h4 pt-5 pl-8 pr-8\">{{offer.name | capitalize:true}}</div><div \nclass=\"pl-5 pr-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"grey-400-fg\"><md-icon \nclass=\"h2 grey-400-fg\" md-font-icon=\"icon-map-marker\" aria-label=\"icon-map-marker\"></md-icon><span class=\"h6 mt-8\">\n{{offer.city | capitalize}}</span></div><div ng-if=\"!vm.showOffer[offer.id]\" \nclass=\"light-blue-500-fg cursor-pointer text-underlined h6\" ng-click=\"vm.showDetails(offer.id)\">Ver oferta</div><div \nng-if=\"vm.showOffer[offer.id]\" class=\"light-blue-500-fg cursor-pointer text-underlined h6\" \nng-click=\"vm.closeDetails(offer.id)\">Cerrar</div></div></div><div ng-if=\"vm.showOffer[offer.id]\" \nclass=\"grey-100-bg pt-20 pl-15 pr-15 pb-20\"><div ng-repeat=\"(key,value) in offer.custom\" class=\"mb-5\"><div \nclass=\"grey-800-fg h5 pl-8 pr-8\">{{value.label}}</div><div class=\"grey-600-fg h6 pl-8 pr-8\">{{value.value}}</div></div>\n<div class=\"pl-8 pr-8 pt-15\" layout=\"row\" layout-align=\"space-between center\"><div><div ng-if=\"offer.areas.areas\" \nclass=\"h6 text-light\">Áreas: {{offer.areas.areas | capitalize:true}}</div><div class=\"h6 grey-500-fg text-light\">\nPublicado: {{offer.publicationDate | fecha: \'MMMM D, YYYY\'}}</div><div class=\"h6 grey-500-fg text-light\">\nVence: {{offer.finishDate | fecha: \'MMMM D, YYYY\'}}</div></div><div class=\"h6 grey-500-fg text-light\" layout=\"row\" \nlayout-align=\"space-between center\"><md-icon md-font-icon=\"icon-account-circle\" class=\"h2 grey-500-fg\"></md-icon><div \nclass=\"p-5\">{{offer.vacants}} VACANTE <span ng-if=\"offer.vacants > 1 || offer.vacants == 0\">S</span></div></div></div>\n<div class=\"pl-8 pr-8 pt-15\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"offer.publish_salary\" \nclass=\"h2 text-light green-400-fg\">{{offer.salary.name}}</div><div ng-if=\"!offer.publish_salary || !offer.salary.name\" \nclass=\"h2 text-light green-400-fg\">Salario confidencial</div></div><div class=\"pl-8 pr-8 pt-15\" layout=\"row\" \nlayout-align=\"space-between center\"><div><md-button href=\"/login\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aplicar</md-button></div>\n</div></div></div><div ng-if=\"!vm.offers.length\" class=\"p-25 grey-700-fg h4\">\nNo se encontraron ofertas con los filtros seleccionados...</div></div></div></div>");
$templateCache.put("app/main/auth/login-token/login-token.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap></div></div>\n<div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div class=\"all-width p-20\"><div \nclass=\"text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div><div \nclass=\"mt-40 mb-40 pt-20 pb-20 pl-10 pr-10 h2 text-center\">Espere un momento por favor, estamos validando sus datos...\n</div><div class=\"text-center\"><div layout=\"row\" layout-align=\"center center\" class=\"p-20\"><span>Powered by | <a \nclass=\"light-blue-500-fg\" href=\"http://vectorial.co\" target=\"_blank\">Vectorial</a></span></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/auth/new-password/new-password.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button href=\"/login-dashboard/\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Regresar</md-button></div>\n<div class=\"pl-5 pr-5\"><md-button href=\"/signin\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Registrarse</md-button></div>\n</div></div><div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div class=\"all-width p-20\"><div \nclass=\"text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div><form name=\"form\" novalidate class=\"p-20\"><div \nclass=\"pt-10 pb-10 h4 grey-600-fg\">Por favor escribe y confirma tu nueva contraseña.</div><md-input-container \nclass=\"md-block\" md-no-float><label>Contraseña</label><input type=\"password\" name=\"password\" minlength=\"6\" \nmaxlength=\"40\" ng-model=\"vm.form.password\" \nng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" required><div \nng-messages=\"form.password.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FIELD_REQUIRED\">\nCampo requerido</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div><div ng-if=\"vm.errors[\'password\']\" class=\"h6 red-500-fg\">{{vm.errors[\'password\']}}</div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label>Confirmar contraseña</label><input \ntype=\"password\" name=\"password_confirm\" minlength=\"6\" maxlength=\"40\" ng-model=\"vm.form.password_confirm\" \nng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" required><div \nng-messages=\"form.password_confirm.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FIELD_REQUIRED\">\nCampo requerido</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div><div ng-if=\"vm.errors[\'password_confirm\']\" class=\"h6 red-500-fg\">{{vm.errors[\'password_confirm\']}}</div>\n</md-input-container><div class=\"text-center\"><md-button ng-click=\"vm.recoverPassword()\" aria-label=\"ACEPTAR\" \ntype=\"submit\" ng-disabled=\"form.$invalid || form.$pristine\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></form><div class=\"text-center\"><div layout=\"row\" layout-align=\"center center\" class=\"p-20\"><span>\nPowered by | <a class=\"light-blue-500-fg\" href=\"http://vectorial.co\" target=\"_blank\">Vectorial</a></span></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/auth/recover-password/recover-password-params.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button href=\"/login-dashboard/\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Regresar</md-button></div>\n<div class=\"pl-5 pr-5\"><md-button href=\"/signin\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Registrarse</md-button></div>\n</div></div><div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div class=\"all-width p-20\" \nlayout=\"column\" flex=\"100\" ms-scroll><div class=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div>\n<form ng-if=\"!vm.recoverReady\" name=\"recoverReadyForm\" novalidate class=\"p-20\"><div class=\"pt-10 pb-10 h4 grey-600-fg\">\nPor favor ingresa documento de identidad</div><md-input-container class=\"md-block\" md-no-float><label for=\"cedula\">\nDocumento de identidad</label><input type=\"text\" name=\"cedula\" ng-model=\"vm.formValidateId.cedula\" required><div \nng-messages=\"recoverReadyForm.cedula.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FIELD_REQUIRED\">Este campo es requerido</span></div></div></md-input-container><div class=\"text-center\">\n<md-button ng-click=\"vm.validateId()\" aria-label=\"ACEPTAR\" type=\"submit\" ng-disabled=\"recoverReadyForm.$invalid\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></form><div ng-if=\"vm.recoverReady\" class=\"pt-20 pb-10 pl-20 pr-20\"><div \nclass=\"pt-10 pb-10 h4 grey-600-fg\">¿Como deseas recuperar tu contraseña? Por favor haz click sobre una opción.</div>\n<div class=\"p-5\"><ul><li><a href=\"#\" ng-click=\"vm.recoverPassword()\" class=\"font-weight-400 h5\">\nQuiero recibir instrucciones al correo {{vm.data.correo}}.</a></li><li><a href=\"#\" \nng-click=\"vm.openSecurityQuestionsDialog($event)\" class=\"font-weight-400 h5\">\nQuiero validar mi identidad respondiendo algunas preguntas de seguridad.</a></li><li ng-if=\"vm.data.red_social\"><a \nhref=\"#\" class=\"font-weight-400 h5\">Ingresé por medio de<md-icon md-font-icon=\"icon-{{vm.data}}\" \naria-label=\"{{vm.data}}\"></md-icon></a></li></ul></div></div><div class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"p-20\"><span>Powered by | <a class=\"light-blue-500-fg\" href=\"http://vectorial.co\" \ntarget=\"_blank\">Vectorial</a></span></div></div></div></div></div></div>");
$templateCache.put("app/main/auth/recover-password/recover-password.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button href=\"/login-dashboard/\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Regresar</md-button></div>\n<div class=\"pl-5 pr-5\"><md-button href=\"/signin\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Registrarse</md-button></div>\n</div></div><div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div class=\"all-width p-20\" \nlayout=\"column\" flex=\"100\" ms-scroll><div class=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div>\n<form ng-if=\"!vm.recoverReady\" name=\"recoverReadyForm\" novalidate class=\"p-20\"><div class=\"pt-10 pb-10 h4 grey-600-fg\">\nPor favor ingresa documento de identidad</div><md-input-container class=\"md-block\" md-no-float><label for=\"cedula\">\ndocumento de identidad</label><input type=\"number\" name=\"cedula\" ng-model=\"vm.formValidateId.cedula\" required><div \nng-messages=\"recoverReadyForm.cedula.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FIELD_REQUIRED\">Este campo es requerido</span></div></div></md-input-container><div class=\"text-center\">\n<md-button ng-click=\"vm.recoverPassword()\" aria-label=\"ACEPTAR\" type=\"submit\" ng-disabled=\"recoverReadyForm.$invalid\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></form><div ng-if=\"vm.recoverReady\" class=\"pt-20 pb-10 pl-20 pr-20\"><div \nclass=\"pt-10 pb-10 h4 grey-600-fg\">¿Como deseas recuperar tu contraseña? Por favor haz click sobre una opción.</div>\n<div class=\"p-5\"><ul><li><a href=\"#\" ng-click=\"vm.recoverPassword()\" class=\"font-weight-400 h5\">\nQuiero recibir instrucciones al correo {{vm.data.correo}}.</a></li><li><a href=\"#\" \nng-click=\"vm.openSecurityQuestionsDialog($event)\" class=\"font-weight-400 h5\">\nQuiero validar mi identidad respondiendo algunas preguntas de seguridad.</a></li><li ng-if=\"vm.data.red_social\"><a \nhref=\"#\" class=\"font-weight-400 h5\">Ingresé por medio de<md-icon md-font-icon=\"icon-{{vm.data}}\" \naria-label=\"{{vm.data}}\"></md-icon></a></li></ul></div></div><div class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"p-20\"><span>Powered by | <a class=\"light-blue-500-fg\" href=\"http://vectorial.co\" \ntarget=\"_blank\">Vectorial</a></span></div></div></div></div></div></div>");
$templateCache.put("app/main/auth/recover-password-admin/recover-password.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button href=\"/\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Regresar</md-button></div>\n</div></div><div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div class=\"all-width p-20\" \nlayout=\"column\" flex=\"100\" ms-scroll><div class=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div>\n<form ng-if=\"!vm.recoverReady\" name=\"recoverReadyForm\" novalidate class=\"p-20\"><div class=\"pt-10 pb-10 h4 grey-600-fg\">\nPor favor ingresa el correo electrónico</div><md-input-container class=\"md-block\" md-no-float><label for=\"cedula\">\nCorreo</label><input type=\"email\" name=\"cedula\" ng-model=\"vm.correo\" required ng-pattern=\"vm.regex\"><div \nng-messages=\"recoverReadyForm.cedula.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FIELD_REQUIRED\">Este campo es requerido</span></div><div ng-message=\"pattern\"><span>\nPor favor ingresar un correo valido</span></div></div></md-input-container><div class=\"text-center\"><md-button \nng-click=\"vm.recoverPassword()\" aria-label=\"ACEPTAR\" type=\"submit\" ng-disabled=\"recoverReadyForm.$invalid\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></form><div class=\"text-center\"><div layout=\"row\" layout-align=\"center center\" class=\"p-20\"><span>\nPowered by | <a class=\"light-blue-500-fg\" href=\"http://vectorial.co\" target=\"_blank\">Vectorial</a></span></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/auth/signin/signin.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button href=\"/login-dashboard/\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Regresar</md-button></div>\n</div></div><div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\" ms-scroll><div layout=\"column\" \nflex=\"100\" class=\"p-20\"><div class=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div>\n<ms-form-wizard flex=\"100\"><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" \nmd-align-tabs=\"top\"><md-tab ng-disabled=\"msWizard.selectedIndex != 0\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\"></span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate ms-scroll><md-input-container class=\"md-block\" md-no-float>\n<label>Documento de identidad</label><input type=\"text\" minlength=\"2\" maxlength=\"100\" name=\"cedula\" \nng-model=\"vm.form.cedula\" required><div ng-messages=\"wizardStep1.cedula.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"FIELD_REQUIRED\">Campo requerido</span></div></div><div \nng-if=\"vm.errors[\'cedula\']\" class=\"h6 red-500-fg pt-5 pb-5\">{{vm.errors[\'cedula\']}}</div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>Confirmar documento de identidad</label><input type=\"text\" \nminlength=\"2\" maxlength=\"100\" name=\"cedula_confirm\" ng-model=\"vm.form.cedula_confirm\" required><div \nng-messages=\"wizardStep1.cedula_confirm.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FIELD_REQUIRED\">Campo requerido</span></div></div><div ng-if=\"vm.errors[\'cedula_confirm\']\" \nclass=\"h6 red-500-fg pt-5 pb-5\"><span>\nEl documento de identidad no coincide con el documento de identidad ingresado anteriormente</span></div>\n</md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"msWizard.selectedIndex != 1\"><md-tab-label>\n<span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\"></span></span></md-tab-label><md-tab-body>\n<form name=\"wizardStep2\" class=\"md-inline-form\" ms-form-wizard-form novalidate ms-scroll><md-input-container \nclass=\"md-block\" md-no-float><label>Nombres</label><input name=\"nombres\" minlength=\"1\" maxlength=\"100\" \nng-model=\"vm.form.nombres\" ng-pattern=\"/^[a-zA-ZáéíóúÁÉÍÓÚ\\s]*$/\" required><div \nng-messages=\"wizardStep2.nombres.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FIELD_REQUIRED\">Campo requerido</span></div><div ng-message=\"pattern\">\nEste campo no debe contener números ni caracteres extraños.</div></div><div ng-if=\"vm.errors[\'nombres\']\" \nclass=\"h6 red-500-fg pt-5 pb-5\">{{vm.errors[\'nombres\']}}</div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><label>Apellidos</label><input name=\"apellidos\" minlength=\"1\" maxlength=\"100\" \nng-model=\"vm.form.apellidos\" ng-pattern=\"/^[a-zA-ZáéíóúÁÉÍÓÚ\\s]*$/\" required><div \nng-messages=\"wizardStep2.apellidos.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FIELD_REQUIRED\">Campo requerido</span></div><div ng-message=\"pattern\">\nEste campo no debe contener números ni caracteres extraños.</div></div><div ng-if=\"vm.errors[\'apellidos\']\" \nclass=\"h6 red-500-fg pt-5 pb-5\">{{vm.errors[\'apellidos\']}}</div></md-input-container><md-input-container \nclass=\"md-block\"><label>Correo electrónico</label><input required type=\"email\" name=\"correo\" ng-model=\"vm.form.correo\" \nminlength=\"5\" maxlength=\"100\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"wizardStep2.correo.$error\" role=\"alert\"><div\n ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Debes ingresar un correo electrónico valido.</div>\n</div><div ng-if=\"vm.errors[\'correo\']\" class=\"h6 red-500-fg pt-5 pb-5\">{{vm.errors[\'correo\']}}</div>\n</md-input-container><md-autocomplete flex required md-input-name=\"autocompleteField\" \nmd-search-text-change=\"vm.searchTextChange(searchText)\" md-selected-item=\"vm.form.ciudad_id\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-require-match=\"\" md-floating-label=\"Ciudad de residencia\" input-aria-describedby=\"favoriteStateDescription\">\n<md-item-template><span md-highlight-text=\"ctrl.searchText\">{{item.name}}</span></md-item-template><div \nng-messages=\"searchForm.autocompleteField.$error\" ng-if=\"searchForm.autocompleteField.$touched\"><div \nng-message=\"required\">No se encontraron coincidencias con la palabra {{item.name}}.</div><div \nng-message=\"md-require-match\">Please select an existing state.</div><div ng-message=\"minlength\">\nYour entry is not long enough.</div><div ng-message=\"maxlength\">Your entry is too long.</div></div><div \nng-if=\"vm.errors[\'correo\']\" class=\"h6 red-500-fg pt-5 pb-5\">{{vm.errors[\'correo\']}}</div></md-autocomplete><div \nng-if=\"vm.loadingLists\" class=\"h6 red-500-fg pt-5 pb-5\">Cargando las ciudades...</div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"msWizard.selectedIndex != 2\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\"></span></span></md-tab-label><md-tab-body><div \nclass=\"pt-20 pl-20 pr-20 h3 grey-600-fg text-center\">¿Como deseas autenticarte?</div><form name=\"wizardStep3\" \nclass=\"p-30\" ms-form-wizard-form novalidate><div class=\"pt-10 pb-10 h4\">Crear una contraseña</div><md-input-container \nclass=\"md-block\" md-no-float><label>Contraseña</label><input type=\"password\" name=\"password\" minlength=\"6\" \nmaxlength=\"40\" ng-model=\"vm.form.password\" \nng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" required><div \nng-messages=\"wizardStep3.password.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FIELD_REQUIRED\">\nCampo requerido</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div><div ng-if=\"vm.errors[\'password\']\" class=\"h6 red-500-fg pt-5 pb-5\">{{vm.errors[\'password\']}}</div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label>Confirmar contraseña</label><input \ntype=\"password\" name=\"password_confirm\" minlength=\"6\" maxlength=\"40\" ng-model=\"vm.form.password_confirm\" \nng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" \nng-change=\"vm.changePasswordConfirm();\" required><div ng-messages=\"wizardStep3.password_confirm.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"FIELD_REQUIRED\">Campo requerido</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div><div ng-if=\"vm.errors[\'password_confirm\']\" class=\"h6 red-500-fg pt-5 pb-5\">\n{{vm.errors[\'password_confirm\']}}</div><div ng-if=\"vm.errors.passwordConfirm\" class=\"h6 red-500-fg pt-5 pb-5\">\nLa contraseña de confirmación no coincide, por favor revisar.</div></md-input-container></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\" ng-hide=\"vm.formSent\"><md-button \nng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized pl-10 pr-10\">Anterior</md-button><md-button \nng-click=\"vm.next(msWizard.selectedIndex, msWizard, 1)\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized pl-10 pr-10\">Siguiente</md-button><md-button \nng-click=\"vm.signin()\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || wizardStep3.$invalid || wizardStep3.$pristine || vm.errors.passwordConfirm\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 text-capitalized pl-10 pr-10\">Finalizar</md-button></div>\n</ms-form-wizard><div layout=\"row\" layout-align=\"center center\" class=\"p-20\"><span>Powered by | <a \nclass=\"light-blue-500-fg\" href=\"http://vectorial.co\" target=\"_blank\">Vectorial</a></span></div></div></div></div></div>");
$templateCache.put("app/main/auth/social-network-error/social-network-error.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button href=\"/login-dashboard/\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Regresar</md-button></div>\n<div class=\"pl-5 pr-5\"><md-button href=\"/signin\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Registrarse</md-button></div>\n</div></div><div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div class=\"all-width p-20\"><div \nclass=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div><div class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"p-20\"><span>Powered by | <a class=\"light-blue-500-fg\" href=\"http://vectorial.co\" \ntarget=\"_blank\">Vectorial</a></span></div></div></div></div></div></div>");
$templateCache.put("app/main/auth/social-network-response/social-network-response.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button href=\"/login-dashboard/\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Regresar</md-button></div>\n<div class=\"pl-5 pr-5\"><md-button href=\"/signin\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Registrarse</md-button></div>\n</div></div><div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div class=\"all-width p-20\"><div \nclass=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div><div class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"p-20\"><span>Powered by | <a class=\"light-blue-500-fg\" href=\"http://vectorial.co\" \ntarget=\"_blank\">Vectorial</a></span></div></div></div></div></div></div>");
$templateCache.put("app/main/auth/social-network-signin/social-network-signin.html","<div class=\"white-bg pl-30 pr-20\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-wrap><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"><div \nclass=\"p-10\" layout=\"row\" layout-align-xs=\"center center\" layout-align-gt-xs=\"center center\" \nlayout-align-sm=\"center center\" layout-align-gt-sm=\"center center\" layout-align-md=\"end center\" \nlayout-align-gt-md=\"end center\" layout-align-lg=\"end center\" layout-align-gt-lg=\"end center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button href=\"/login-dashboard/\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Regresar</md-button></div>\n<div class=\"pl-5 pr-5\"><md-button href=\"/signin\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Registrarse</md-button></div>\n</div></div><div class=\"content page-layout all-height\"><div layout=\"row\" class=\"all-height\" layout-wrap><div \nclass=\"login-background\" ng-style=\"vm.theme.loginBackground\" layout=\"column\" hide-xs hide-gt-xs hide-sm hide-gt-sm \nshow-gt-md show-md flex-md=\"60\" flex-gt-md=\"60\" flex-lg=\"60\" flex-gt-lg=\"60\" layout-align=\"center start\" layout-wrap>\n<div class=\"bl-light-blue-1 white-fg ml-40 pl-10\"><div class=\"md-display-3 font-weight-200\">TRABAJA CON</div><div \nclass=\"md-display-3 font-weight-400\">NOSOTROS</div><div class=\"h4 font-weight-200\">CONOCE NUESTRAS OFERTAS LABORALES\n</div></div></div><div class=\"height-100p\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"100\" flex-xs=\"100\" \nflex-offset-gt-sm=\"20\" flex-gt-sm=\"60\" flex-offset-sm=\"20\" flex-sm=\"60\" flex-offset-md=\"0\" flex-offset-lg=\"0\" \nflex-offset-gt-lg=\"0\" flex-md=\"40\" flex-gt-md=\"40\" flex-lg=\"40\" flex-gt-lg=\"40\"><div class=\"all-width p-20\"><div \nclass=\"p-20 text-center\"><img src=\"{{vm.theme.loginLogo}}\" alt=\"logo\"></div><div class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"p-20\"><span>Powered by | <a class=\"light-blue-500-fg\" href=\"http://vectorial.co\" \ntarget=\"_blank\">Vectorial</a></span></div></div></div></div></div></div>");
$templateCache.put("app/main/candidate/applied-offers/applied-offers.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content\"><div ng-if=\"!vm.loading\" class=\"pt-15\"><div ng-include=\"\'app/main/templates/offers/offers.html\'\"></div>\n</div><div ng-if=\"vm.loading\" class=\"p-20 text-center h2\">\nEspera un momento por favor, estamos cargando las ofertas a las que has aplicado...</div></div></div>");
$templateCache.put("app/main/candidate/dashboard/dashboard.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content\"><div ng-if=\"vm.messages.length\" class=\"pt-30 pb-5 pl-30 pr-30\"><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"message in vm.messages\" \nng-class=\"[message.background_color, message.text_color]\" class=\"p-10 mb-10\"><div class=\"pl-5 pt-5 pb-5 pr-15\"><md-icon\n md-font-icon=\"{{message.icon}}\" ng-class=\"[message.text_color]\" class=\"\"></md-icon></div><div class=\"p-5\" \ncompile=\"message.message\"></div></div></div><div class=\"widget-group pt-5 pb-5 pl-20 pr-20\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"25\"><ms-widget-front class=\"p-15 orange-400-bg\"><div \nclass=\"p-5 orange-900-fg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h6\">\nOFERTAS LABORALES NUEVAS DESDE SU ÚLTIMA VISITA</div></div><div class=\"p-5\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"white-fg font-size-40 line-height-40 text-light-200 cursor-pointer\" \nng-click=\"vm.goToOffersAVailables()\">{{vm.dashboardData.nuevas_ofertas_ultima_visita | number}}</div><span \nng-click=\"vm.goToOffersAVailables()\" class=\"orange-200-bg font-weight-200 white-fg cursor-pointer text-boxed m-0\">\n<strong>Haz clic para verlas</strong></span></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"25\">\n<ms-widget-front class=\"p-15 green-400-bg\"><div class=\"p-5 green-900-fg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h6\">PROCESOS VIGENTES</div></div><div class=\"p-5\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"white-fg font-size-40 line-height-40 text-light-200\">\n{{vm.dashboardData.procesos_aplicados.en_proceso | number}}</div></div><div class=\"pl-5 pr-5\" layout=\"column\" \nlayout-align=\"center start\"><div ng-if=\"vm.dashboardData.procesos_aplicados.total\" class=\"white-fg text-light\">\nHas aplicado a {{vm.dashboardData.procesos_aplicados.total | number}} oferta<span \nng-if=\"vm.dashboardData.procesos_aplicados.total > 1\">s</span></div><div \nng-if=\"!vm.dashboardData.procesos_aplicados.total\" class=\"white-fg text-light\">No has aplicado a ofertas</div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"50\" \nflex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"25\"><ms-widget-front class=\"p-15 white-bg bb-light-blue\"><div \nclass=\"green-900-fg\" layout=\"row\" layout-align=\"end center\"><div><md-icon md-font-icon=\"icon-calendar\" \nclass=\"h3 grey-400-fg\"></md-icon></div></div><div class=\"p-5\" layout=\"column\" layout-align=\"center start\"><div \nclass=\"light-blue-600-fg font-size-40 line-height-40 text-light-200\">\n{{vm.dashboardData.fecha_ultima_actualizacion | fecha: \'MMMM D, YYYY\' | capitalize}}</div></div><div class=\"pl-5 pr-5\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"grey-600-fg text-light\">\nÚltima actualización de su hoja de vida.</div></div></ms-widget-front></ms-widget></div><div \nclass=\"pt-15 pb-5 pl-30 pr-30\"><div class=\"bb pb-5\"><span class=\"h5 grey-600-fg bb-light-blue-2 pb-5\">\nINDICADORES DE SU <strong class=\"grey-900-fg\">HOJA DE VIDA</strong></span></div></div><div \nclass=\"pt-5 pb-20 pl-20 pr-20\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"widget-group\" layout=\"row\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-md=\"100\" flex-gt-md=\"70\" flex-lg=\"70\" flex-gt-lg=\"70\" layout-wrap><ms-widget \nng-repeat=\"indicator in vm.indicators\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"50\" \nflex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"25\"><ms-widget-front class=\"p-15 white-bg bb-light-blue\"><div \nclass=\"p-5 h-50 grey-500-fg\" layout=\"row\" layout-align=\"start start\"><div class=\"h5\">{{indicator.name}}</div></div><div\n class=\"p-5\" layout=\"column\" layout-align=\"center start\"><div class=\"font-size-30 line-height-30 text-light\">\n{{indicator.value}}</div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-md=\"100\" flex-gt-md=\"30\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"light-blue-700-bg\"><div \nclass=\"p-15 light-blue-400-bg\"><div class=\"h2 white-fg pb-8 text-light\">Información de contacto</div><div \nclass=\"h6 light-blue-900-fg pb-5\">TELÉFONOS</div><div \nng-repeat=\"phone in vm.dashboardData.informacion_contactos.telefonos track by $index\" class=\"h6 white-fg\">{{phone}}\n</div></div><div class=\"p-15 light-blue-700-bg\"><div class=\"h6 light-blue-900-fg pb-5\">\nDIRECCIONES DE CORREO ELECTRÓNICO</div><div \nng-repeat=\"email in vm.dashboardData.informacion_contactos.correos  track by $index\" class=\"h6 white-fg\">{{email}}\n</div></div></ms-widget-front></ms-widget></div></div><div class=\"grey-200-bg pt-15\"><div \nclass=\"pt-15 pb-5 pl-30 pr-30\"><div class=\"bb pb-5\"><span class=\"h5 grey-600-fg bb-light-blue-2 pb-5\"><strong \nclass=\"grey-900-fg\">OFERTAS</strong> QUE SE AJUSTAN A SU PERFIL PROFESIONAL</span></div></div><div \nng-include=\"\'app/main/templates/offers/offers.html\'\"></div></div></div></div>");
$templateCache.put("app/main/candidate/offers-available/offers-available.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content\"><div ng-if=\"vm.messages.length\" class=\"pt-30 pb-30 pl-30 pr-30\"><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"message in vm.messages\" \nng-class=\"[message.background_color, message.text_color]\" class=\"p-10 mb-10\"><div class=\"pl-5 pt-5 pb-5 pr-15\"><md-icon\n md-font-icon=\"{{message.icon}}\" ng-class=\"[message.text_color]\" class=\"\"></md-icon></div><div class=\"p-5\" \nng-bind-html=\"message.message\"></div></div></div><div class=\"white-bg b pl-30 pr-30\" layout=\"row\" layout-wrap><div \nclass=\"h-60 pt-5 pl-5 pr-15 search bb-light-blue\" layout=\"row\" layout-align=\"start center\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\"><input \nid=\"search h6\" ng-model=\"vm.filters[0]\" ng-change=\"vm.resetSearch()\" \nclass=\"search-input all-height all-width light-blue-500-fg light-blue-500-placeholder\" type=\"text\" \nplaceholder=\"Buscar ofertas\"></div><div class=\"pt-20 pb-15 pr-5 pl-5\" layout=\"row\" layout-align=\"start center\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\">\n<md-input-container class=\"md-block no-padding no-margin all-width\"><label class=\"pb-5 pt-5\">Paises</label><md-select \nng-change=\"vm.refreshOffers()\" class=\"simplified h6\" ng-model=\"vm.paisSelected\" aria-label=\"Change salary\"><md-option \nng-repeat=\"(key, name) in vm.countries track by $index\" ng-value=\"key\">{{name}}</md-option></md-select>\n</md-input-container></div><div class=\"pt-20 pb-5 pr-10 pl-10\" ng-if=\"vm.paisSelected\" layout=\"row\" \nlayout-align=\"start center\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" \nflex-lg=\"33\" flex-gt-lg=\"33\"><md-input-container class=\"md-block h6 no-padding no-margin all-width\"><label \nclass=\"pb-5 pt-5\">Ciudad</label><md-autocomplete ng-disabled=\"vm.isDisabled\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedCity\" md-search-text=\"vm.searchCityText\" \nmd-selected-item-change=\"vm.selectedCityChange(item)\" md-items=\"item in vm.queryCitySearch(vm.searchCityText)\" \nmd-item-text=\"item.name | capitalize:true\" md-min-length=\"0\" placeholder=\"Escribe para buscar\"><md-item-template><span \nmd-highlight-text=\"vm.searchCityText\" md-highlight-flags=\"^i\">{{item.name | capitalize:true}}</span></md-item-template>\n<md-not-found>No se encontraron coincidencias con el texto \"{{vm.searchCityText}}\".</md-not-found></md-autocomplete>\n</md-input-container></div><div class=\"pt-20 pb-5 pr-10 pl-10\" layout=\"row\" layout-align=\"start center\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\">\n<md-input-container class=\"md-block h6 no-padding no-margin all-width\"><label class=\"pb-5 pt-5\">Área</label>\n<md-autocomplete ng-disabled=\"vm.isDisabled\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedArea\" \nmd-search-text=\"vm.searchAreaText\" md-selected-item-change=\"vm.selectedAreaChange(item)\" \nmd-items=\"item in vm.queryAreaSearch(vm.searchAreaText)\" md-item-text=\"item.name | capitalize:true\" md-min-length=\"0\" \nplaceholder=\"Escribe para buscar\"><md-item-template><span md-highlight-text=\"vm.searchAreaText\" \nmd-highlight-flags=\"^i\">{{item.name | capitalize:true}}</span></md-item-template><md-not-found>\nNo se encontraron coincidencias con el texto \"{{vm.searchAreaText}}\".</md-not-found></md-autocomplete>\n</md-input-container></div><div class=\"pt-20 pb-15 pr-5 pl-5\" layout=\"row\" layout-align=\"start center\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\">\n<md-input-container class=\"md-block no-padding no-margin all-width\"><label class=\"pb-5 pt-5\">Salario</label><md-select \nng-change=\"vm.resetSearch()\" class=\"simplified h6\" ng-model=\"vm.filters[3]\" aria-label=\"Change salary\"><md-option \nng-repeat=\"(key, salary) in vm.salaries track by $index\" ng-value=\"salary.id\">{{salary.name}}</md-option></md-select>\n</md-input-container></div><div class=\"pt-20 pb-15 pr-5 pl-5\" layout=\"row\" layout-align=\"start center\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\">\n<md-input-container class=\"md-block no-padding no-margin all-width\"><label class=\"pb-5 pt-5\">Tiempo de publicación\n</label><md-select ng-change=\"vm.resetSearch()\" class=\"simplified h6\" ng-model=\"vm.filters[4]\" \naria-label=\"Change time\"><md-option ng-repeat=\"(key, time) in vm.times\" value=\"{{key}}\">{{time}}</md-option>\n</md-select></md-input-container></div><div class=\"pt-20 pb-15 pr-5 pl-5\" layout=\"row\" layout-align=\"start center\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\">\n<div ng-click=\"vm.resetFilters()\" class=\"cursor-pointer\" aria-label=\"Reset\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><md-tooltip md-direction=\"top\">Limpiar filtros</md-tooltip></div></div></div><div ng-if=\"!vm.loading\" \nclass=\"pt-20 pb-5\"><div infinite-scroll=\"vm.loadMore()\" infinite-scroll-disabled=\"vm.loading\" \ninfinite-scroll-distance=\"1\" infinite-scroll-container=\'\"#content\"\' \nng-include=\"\'app/main/templates/offers/offers.html\'\"></div></div><div ng-if=\"vm.loading\" class=\"p-20 text-center h2\">\nEspera un momento por favor, estamos cargando las ofertas disponibles...</div></div></div>");
$templateCache.put("app/main/candidate/resume/resume.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content\"><div ng-if=\"!vm.loading\"><div ng-if=\"vm.indicators.percentage < 100\" \nclass=\"pt-30 pb-20 pl-30 pr-30 grey-100-bg\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"red-100-bg red-900-fg p-10 mb-10\"><div class=\"pl-5 pt-5 pb-5 pr-15\"><md-icon md-font-icon=\"icon-alert\" \nclass=\"red-900-fg\"></md-icon></div><div class=\"p-5\"><strong>\nTu hoja de vida aún no se encuentra completamente diligenciada ({{vm.indicators.percentage}}%).</strong>\n En este momento no puedes aplicar a ofertas laborales ni podrás ser tenido en cuenta para posibles vacantes. Por favor completa la información de tu \n<span class=\"red-900-fg\"><strong>hoja de vida</strong></span></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"blue-100-bg blue-900-fg p-10 mb-10\"><div class=\"pl-5 pt-5 pb-5 pr-15\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"blue-900-fg\"></md-icon></div><div class=\"p-5\">\nPara actualizar los datos de su hoja de vida haga clic en la opción <strong>Editar</strong>\n ubicada a la derecha de la pantalla. Para nosotros es muy importante contar con sus datos actualizados, ya que de esta forma garantizamos que su hoja de vida esté en los primeros puestos de la lista de candidatos cuando haya una vacante que vaya acorde con su perfil.\n</div></div></div><div layout=\"row\" layout-align=\"end end\" class=\"pt-30 pb-20 pl-30 pr-30\"><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg m-0\" \nng-click=\"vm.downloadPDF()\" aria-label=\"back button\" layout=\"row\" layout-align=\"center center\">Descargar hoja de vida\n<md-icon md-font-icon=\"icon-download\"></md-icon></md-button></div><div ng-repeat=\"block in vm.blocks\"><div \nng-include=\"\'app/main/templates/resume/\' + block.data.type + \'.html\'\" ng-init=\"item = block.data\" ng-hide=\"block.hide\">\n</div></div></div><div ng-if=\"vm.loading\" class=\"p-30 md-title text-center\">Cargando contenido, por favor espere...\n</div></div></div>");
$templateCache.put("app/main/candidate/service-agreement/service-agreement.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content p-40\"><div class=\"p-20\" layout=\"row\"><div flex=\"100\" class=\"h2 text-center\">\nPara finalizar el registro, por favor lee la política de tratamiento de datos y acepta sus términos al final</div>\n</div><div class=\"p-10 mt-10 mb-10 light-blue-500-bg\" layout=\"row\"><div flex=\"100\" class=\"h1 text-center white-fg\">\nPolítica de tratamiento de datos</div></div><div class=\"p-20 white-bg\" layout=\"column\"><div flex=\"100\" class=\"p-10\">\n<div class=\"pre-wrap\" ng-bind-html=\"vm.agreement\"></div></div><div flex=\"100\" class=\"m-10 p-10 text-center b\">\n<md-checkbox class=\"no-margin no-padding\" ng-model=\"vm.accept\" aria-label=\"Accept\">Acepto terminos y condiciones\n</md-checkbox></div></div><div class=\"p-20\" layout=\"column\"><div flex=\"100\" class=\"text-center\"><md-button \nng-click=\"vm.acceptService()\" ng-disabled=\"!vm.accept && !vm.saving\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized pl-10 pr-10 no-margin\">Aceptar</md-button></div>\n</div></div></div>");
$templateCache.put("app/main/templates/block-generic/block-title-selected.html","<div class=\"grey-100-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between center\" \nlayout-align-gt-sm=\"space-between center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-lg=\"space-between center\"><div class=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\"><div \nclass=\"h5 text-uppercase\"><span ng-class=\"{\'font-weight-900\' : $last,\'pl-5\':!$first}\" \nng-repeat=\"title in item.title track by $index\">{{title}}</span></div></div><div><md-checkbox class=\"no-margin\" \nng-model=\"item.isCheckeable\" ng-change=\"vm.blockSelected($index);\" aria-label=\"check block\"></md-checkbox></div></div>");
$templateCache.put("app/main/templates/block-generic/block-title.html","<div class=\"grey-100-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between center\" \nlayout-align-gt-sm=\"space-between center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-lg=\"space-between center\"><div class=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\" layout=\"row\"><div \nclass=\"h5 text-uppercase\"><span ng-class=\"{\'font-weight-900\' : $last,\'pl-5\':!$first}\" \nng-repeat=\"title in item.title track by $index\">{{title}}</span></div></div><div class=\"h5\" ng-show=\"item.collapse\"><i \nng-class=\"item.hideCollapse ? \'icon-chevron-down\':\'icon-chevron-up\'\" md-colors=\"{color:\'accent\'}\" \nclass=\"cursor-pointer\" ng-click=\"item.hideCollapse = !item.hideCollapse\"></i></div></div>");
$templateCache.put("app/main/templates/finalist/aditional-info.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" \nflex=\"100\"><ms-widget-front class=\"white-bg\"><div ng-include=\"\'app/main/templates/resume/shared/block-title.html\'\">\n</div><div ng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div \nclass=\"pt-20 pb-20 pl-20 pr-30 bb\"><div class=\"p-5 mb-20\"><div class=\"p-5 text-bold\">¿Ha tenido personal a cargo?</div>\n<div class=\"p-5\"><md-radio-group layout=\"row\" ng-model=\"data.group1\"><md-radio-button value=\"1\">Si</md-radio-button>\n<md-radio-button value=\"0\">No</md-radio-button></md-radio-group></div></div><div class=\"p-5 mb-20\"><div \nclass=\"p-5 text-bold\">¿Que tipo de cargos han tenido sus personas a cargo?</div><div class=\"pt-10 pr-5 pb-10 pl-5 bb\" \nlayout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-padding no-margin\" ng-model=\"data.cb1\" \naria-label=\"Checkbox 1\">Operativos</md-checkbox></div><div class=\"pt-10 pr-5 pb-10 pl-5 bb\"><md-checkbox \nclass=\"no-padding no-margin\" ng-model=\"data.cb1\" aria-label=\"Checkbox 1\">Supervisores</md-checkbox></div><div \nclass=\"pt-10 pr-5 pb-10 pl-5 bb\"><md-checkbox class=\"no-padding no-margin\" ng-model=\"data.cb1\" aria-label=\"Checkbox 1\">\nJefes</md-checkbox></div><div class=\"pt-10 pr-5 pb-10 pl-5 bb\"><md-checkbox class=\"no-padding no-margin\" \nng-model=\"data.cb1\" aria-label=\"Checkbox 1\">Directivos</md-checkbox></div><div class=\"pt-10 pr-5 pb-10 pl-5 bb\">\n<md-checkbox class=\"no-padding no-margin\" ng-model=\"data.cb1\" aria-label=\"Checkbox 1\">\nAsistentes, analistas, auxiliares administrativos</md-checkbox></div></div><div class=\"p-5 mb-20\"><div \nclass=\"p-5 text-bold\">¿Ha liderado proyectos estrátegicos dentro de la organización?</div><div class=\"p-5\">\n<md-radio-group layout=\"row\" ng-model=\"data.group1\"><md-radio-button value=\"1\">Si</md-radio-button><md-radio-button \nvalue=\"0\">No</md-radio-button></md-radio-group></div></div><div class=\"p-5 mb-10\"><div class=\"p-5 text-bold\">\nMencione por lo menos un proyecto liderado</div><div class=\"\"><md-input-container \nclass=\"md-block no-padding no-margin\"><textarea ng-model=\"user.biography\" md-maxlength=\"150\" rows=\"3\"></textarea>\n</md-input-container></div></div></div><div ng-if=\"!vm.analyst\" class=\"pt-20 pb-20 pl-20 pr-30 bb\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.save()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/childrens.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div ng-if=\"item.data.length\" class=\"p-30 bb\" \nng-repeat=\"children in item.data\"><div class=\"mb-20\" layout=\"column\"><div \nclass=\"h2 pl-5 pr-15 light-blue-500-fg text-capitalized\">\n{{children.nombres}} {{children.primer_apellido}} {{children.segundo_apellido}}</div><div class=\"md-subhead\" \nlayout=\"row\"><div class=\"font-weight-300 pl-5 pr-5\">Documento de identidad:</div><div \nclass=\"font-weight-300 pl-5 pr-5\">{{children.documento}}</div></div></div><div class=\"\" layout=\"row\" layout-wrap><div \nclass=\"\" ng-repeat=\"field in item.campos\" \nng-if=\"field.field != \'nombres\' \n                            && field.field != \'primer_apellido\' \n                            && field.field != \'segundo_apellido\'\n                            && vm.validationService.validate(item.name, children, field)\n                            && field.label\" \nlayout=\"column\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" \nflex-lg=\"33\" flex-gt-lg=\"33\"><div class=\"pt-5 pb-5 pr-5\"><span \nclass=\"h5 font-weight-500 pt-5 pl-5 pr-5 text-capitalized\">{{field.label}}:</span> <span \nng-if=\"!vm.attachments[field.module]\" class=\"h5 font-weight-300 text-capitalized\">\n{{(children[field.field_extra] ? children[field.field_extra] : children[field.field]) | formatValue : field.type : vm.lists[field.options]}}\n</span><dl ng-if=\"vm.attachments[info.module][children._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, children._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][children._id]\"><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h6\">{{attach.name}}</span><a ng-click=\"vm.getAttachmentUrl(attach)\"><span \nclass=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a></div>\n</dd></dl></div></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" class=\"pl-5 pr-5 pt-20\" layout-align=\"end center\">\n<div class=\"pr-15 red-300-fg\"><span class=\"icon-trash\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openDeleteDialog($event, item, children)\">Eliminar</span></div><div class=\"grey-500-fg\"><span \nclass=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, vm.getBlockData(item, children))\">Editar</span></div></div></div><div class=\"p-30\" \nng-if=\"!item.data.length\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div><div \nng-if=\"vm.resume.grupo_familiar.data.cantidad_hijos > item.data.length\" class=\"p-10\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">\nIngresar información del {{vm.getOrdinalNumber(item.data.length + 1) | lowercase }} hijo</md-button></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/formal-study.html","<div class=\"widget-group formal-study\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div ng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nclass=\"p-30\" ng-if=\"item.text_view\"><div class=\"h3\">{{item.text_view}}</div></div><div \nclass=\"pt-30 pb-30 pl-30 pr-30 bb\" ng-if=\"item.data && item.data.length\" ng-repeat=\"study in item.data\"><div \nclass=\"pb-10\"><div class=\"\" layout=\"column\" layout-align=\"start start\"><div layout=\"column\"><div layout=\"row\"><div \nng-if=\"study.titulo\" class=\"h2 pl-5 pr-15 pt-5 text-capitalized font-weight-500\">{{study.titulo | capitalize : true}}\n</div><div ng-if=\"!study.titulo\" class=\"h2 pl-5 pr-15 pt-5 text-capitalized font-weight-500\">\n{{study.profesion_name | capitalize : true}}</div></div><div ng-if=\"study.institucion\" class=\"h5 pl-5 pr-5\"><span \nclass=\"font-weight-400 text-capitalized\">{{study.institucion | capitalize : true}}</span></div><div \nng-if=\"!study.institucion\" class=\"h5 pl-5 pr-5\"><span class=\"font-weight-400 text-capitalized\">\n{{study.instituto_name | capitalize : true}}</span></div></div><div layout=\"column\"><div \nclass=\"h3 pt-5 pl-5 pb-5 pr-15\">Promedio acumulado {{study.promedio_acumulado}}</div><div \nclass=\"h5 text-light-400 pt-5 pl-5\"><strong>Inicio:</strong> {{study.anio_inicio}}</div><div \nclass=\"h5 text-light-400 pt-5 pl-5\"><strong>Finalización:</strong> {{study.anio}}</div></div></div><div \nclass=\"pl-5 pt-5 pr-5 h5 font-weight-400 text-capitalized\">{{study.ciudad_name | capitalize : true}}</div><div \nclass=\"pl-5 pr-5 pt-20\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.campos\" \nng-if=\"field.field != \'profesion_id\' && field.field != \'instituto_id\' && field.field != \'ciudad_id\' \" layout=\"column\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"33\">\n<div class=\"pt-5\"><span class=\"h5 text-capitalized font-weight-500\">{{field.label}}:</span> <span \nng-if=\"!vm.attachments[field.module]\" class=\"h5 font-weight-300\">\n{{(study[field.field_text] ? study[field.field_text] : (study[field.field_extra] ? study[field.field_extra] : study[field.field])) | formatValue : field.type : vm.lists[field.options] : field.field : null : study[field.field_extra] : field.use_same_value}}\n</span></div></div></div></div></div><div class=\"p-30\" ng-if=\"!item.data || !item.data.length\"><div \nclass=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-comment-check\" \nclass=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span class=\"grey-600-fg font-weight-400\">\nValioso consejo: </span><span class=\"grey-500-fg font-weight-300\">{{item.emptyRowsMessage}}</span></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/laboral-experience.html","<div class=\"widget-group laboral-experience\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div ng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nclass=\"pt-30 pb-30 pl-30 pr-30 bb\" ng-repeat=\"data in item.data\" ng-if=\"item.data && item.data.length\"><div \nclass=\"pb-10\" layout=\"column\" layout=\"start start\"><div><div layout=\"row\"><div \nclass=\"h2 pl-5 pr-15 pt-5 text-capitalized font-weight-500\">{{data.cargo_desempenado}}</div></div><div \nclass=\"h5 pl-5 pr-5 pb-5\"><span class=\"font-weight-400 text-capitalized\">{{data.empresa}}</span></div></div><div \nlayout=\"column\"><div class=\"h3 pt-5 pl-5 pb-5 pr-15\">\n{{vm.getDiffBetweenTwoDates(data.fecha_ingreso, data.fecha_retiro)}}</div><div class=\"h5 text-light-400 pt-5 pl-5\">\n<strong>Ingreso:</strong> {{data.fecha_ingreso | formatValue : \'date\'}}</div><div class=\"h5 text-light-400 pt-5 pl-5\">\n<strong>Retiro:</strong> {{data.fecha_retiro | formatValue : \'date\'}}</div></div></div><div class=\"pl-5 pr-5 pt-20\" \nlayout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.campos\" layout=\"column\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"33\"><div \nclass=\"pt-5\"><span class=\"h5 text-capitalized font-weight-500\">{{field.label}}:</span> <span \nng-if=\"!vm.attachments[field.module]\" class=\"h5 font-weight-300\">\n{{(data[field.field_extra] ? data[field.field_extra] : data[field.field]) | formatValue : field.type : vm.lists[field.options] : field.field : null : data[field.field_extra] : field.use_same_value}}\n</span></div></div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/languages.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div ng-if=\"item.data.length\" \nng-repeat=\"data in item.data\" class=\"pt-30 pb-30 pl-30 pr-30 bb\"><div class=\"pb-10\" layout=\"row\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-gt-md=\"row\" layout-md=\"row\" layout-align-gt-xs=\"start start\" \nlayout-align-xs=\"start start\" layout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\"><div>\n<div layout=\"row\"><div class=\"h3 light-blue-500-fg pl-5 pr-15 pt-5 text-capitalized\">\n{{data.idioma_id | formatValue : \'select\' : vm.lists[\'idiomas\']}}</div></div><div class=\"pt-15 pl-5 pr-5 pb-5\"><div>\n<span class=\"font-weight-500\">Nivel según marco europeo (solo persona certificada):</span> <span>\n{{data.nivel_marco_europeo | formatValue : \'select\' : vm.lists[\'get_niveles_marco_europeo\']}}</span></div><div><span \nclass=\"font-weight-500\">Fecha de vigencia de nivel:</span> <span>{{data.fecha_vigencia_nivel | formatValue : \'date\'}}\n</span></div></div></div><div layout=\"row\"><div class=\"light-blue-500-fg h2 text-light-200 pt-5 pl-5 pb-5 pr-15\">\nLee: {{data.lee | formatValue : \'select\' : vm.lists[\'get_idioma_nivel\']}}</div><div \nclass=\"light-blue-500-fg h2 text-light-200 pt-5 pl-5 pb-5 pr-15\">\nEscribe: {{data.escribe | formatValue : \'select\' : vm.lists[\'get_idioma_nivel\']}}</div><div \nclass=\"light-blue-500-fg h2 text-light-200 pt-5 pl-5 pb-5 pr-15\">\nHabla: {{data.habla | formatValue : \'select\' : vm.lists[\'get_idioma_nivel\']}}</div></div></div><div \nng-if=\"!vm.analyst\" layout=\"row\" class=\"pl-5 pr-5 pt-20\" layout-align=\"end center\"><div class=\"pr-15 red-300-fg\"><span \nclass=\"icon-trash\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openDeleteDialog($event, item, data)\">Eliminar</span></div><div class=\"grey-500-fg\"><span \nclass=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, vm.getBlockData(item, data))\">Editar</span></div></div></div><div class=\"p-30\" \nng-if=\"!item.data || !item.data.length\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon\n md-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div><div ng-if=\"!vm.analyst\" class=\"grey-100-bg p-8\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar idioma</md-button>\n</div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/non-formal-study.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\" ng-if=\"item.text_view\"><div \nclass=\"h3\">{{item.text_view}}</div></div><div class=\"pt-30 pb-30 pl-30 pr-30 bb\" ng-if=\"item.data && item.data.length\" \nng-repeat=\"study in item.data\"><div class=\"pb-10\"><div class=\"\" layout=\"row\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-gt-md=\"row\" layout-md=\"row\" layout-align-gt-xs=\"start start\" layout-align-xs=\"start start\" \nlayout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\"><div><div layout=\"row\"><div \nclass=\"h1 pl-5 pr-15 pt-5 text-capitalized\">{{study.titulo}}</div></div><div class=\"h6 pl-5 pr-5 pb-5\"><span \nclass=\"light-blue-500-fg text-capitalized\">{{study.instituto | capitalize:true}}</span></div></div><div layout=\"row\">\n<div class=\"light-blue-500-fg h4 text-light-200 pt-5 pl-5 pb-5 pr-15 br-light-blue-1\"><strong>Inicio:</strong>\n {{study.anio_inicio}}</div><div class=\"light-blue-500-fg h4 text-light-200 pt-5 pl-5 pb-5 pr-15\"><strong>Finalización:\n</strong> {{study.anio}}</div></div></div><div class=\"pl-5 pr-5 pt-10\" layout=\"row\" flex=\"100\" layout-wrap><div \nng-if=\"field.field != \'titulo\' && field.field != \'instituto_id\'\" ng-repeat=\"field in item.campos\" layout=\"column\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"33\">\n<div class=\"pt-5\"><span class=\"h5 text-capitalized font-weight-500\">{{field.label}}:</span> <span \nclass=\"h5 font-weight-300\">\n{{(study[field.field_extra] ? study[field.field_extra] : study[field.field]) | formatValue : field.type : vm.lists[field.options]}}\n</span></div><dl ng-if=\"vm.attachments[field.module][study._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, study._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][study._id]\"><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h6\">{{attach.name}}</span><a ng-click=\"vm.getAttachmentUrl(attach)\"><span \nclass=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a></div>\n</dd></dl></div></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" class=\"pl-5 pr-5 pt-20\" layout-align=\"end center\">\n<div class=\"pr-15 red-300-fg\"><span class=\"icon-trash\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openDeleteDialog($event, item, study)\">Eliminar</span></div><div class=\"grey-500-fg\"><span \nclass=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, vm.getBlockData(item, study))\">Editar</span></div></div></div><div class=\"p-30\" \nng-if=\"!item.data || !item.data.length\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon\n md-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div><div ng-if=\"!vm.analyst\" class=\"p-10 bt\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar estudio</md-button>\n</div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/one-column-one-row.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\"><div ng-if=\"item.text_view\">\n<div class=\"h3 pb-15 grey-500-fg\">{{item.text_view}}</div></div><div ng-if=\"item.data\"><div \nng-repeat=\"field in item.campos\" class=\"\" layout=\"column\"><div ng-if=\"item.data[field.field_extra]\" \nng-class=\"{\'pre-wrap\' : item.campos.length == 1}\" class=\"h5 pt-5 pb-5\">\n{{ (item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field]) | capitalize : true}}</div>\n<div ng-if=\"!item.data[field.field_extra]\" ng-class=\"{\'pre-wrap\' : item.campos.length == 1}\" class=\"h5 pt-5 pb-5\">\n{{ (item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field]) | formatValue : field.type : vm.lists[field.options] | capitalize : true}}\n</div></div><di ng-if=\"!vm.analyst\" class=\"pt-10\" layout=\"row\" layout-align=\"end center\"><div class=\"grey-500-fg\"><span\n class=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, item)\">Editar</span></div></di></div></div><div ng-if=\"!item.data\"><div \nclass=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-comment-check\" \nclass=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span class=\"grey-600-fg font-weight-400\">\nValioso consejo: </span><span class=\"grey-500-fg font-weight-300\">{{item.emptyRowsMessage}}</span></div></div>\n</ms-widget-front></ms-widget></div><div ng-if=\"!item.data && !vm.analyst\" layout=\"row\" layout-align=\"end center\" \nclass=\"pt-10 pb-10 pl-30 pr-30 bt\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información\n</md-button></div>");
$templateCache.put("app/main/templates/finalist/one-column.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\"><div \nclass=\"pb-15 grey-500-fg\" ng-if=\"item.text_view\">{{item.text_view}}</div><div ng-if=\"item.data\"><div layout=\"row\" \nng-repeat=\"field in item.campos\" layout-wrap><div class=\"h5 font-weight-300 p-5\">\n{{item.data[field.field] | formatValue : field.type : vm.lists[field.options]}}</div></div><div class=\"pt-10\" \nlayout=\"row\" layout-align=\"end center\"><div layout=\"row\" ng-click=\"vm.openEditDialog($event, item)\"><md-icon \nmd-font-icon=\"icon-pencil no-margin no-padding\" class=\"h3\"></md-icon><div \nclass=\"h6 cursor-pointer text-underlined pt-5 pb-5\">Editar</div></div></div></div><div ng-if=\"!item.data\"><div \nclass=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-comment-check\" \nclass=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span class=\"grey-600-fg font-weight-400\">\nValioso consejo: </span><span class=\"grey-500-fg font-weight-300\">{{item.emptyRowsMessage}}</span></div></div></div>\n<div ng-if=\"!item.data\" layout=\"row\" layout-align=\"end center\" class=\"pt-10 pb-10 pl-30 pr-30 bt\"><md-button \nng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información adicional\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/parents.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div ng-if=\"item.data\" class=\"p-30 bb\"><div \nclass=\"mb-20\" layout=\"column\"><div class=\"h2 pl-5 pr-15 light-blue-500-fg text-capitalized\">\n{{item.data.madre_nombre}} {{item.data.madre_primer_apellido}} {{item.data.madre_segundo_apellido}}</div><div class=\"\" \nlayout=\"row\"><div class=\"h5 font-weight-500 pl-5 pr-5\">Documento de identidad:</div><div \nclass=\"h5 font-weight-300 pl-5 pr-5\">{{item.data.madre_documento}}</div></div></div><div class=\"\" layout=\"row\" \nlayout-wrap><div class=\"\" ng-repeat=\"field in item.campos\" \nng-if=\"vm.validateParentsFields(\'mom\', field) && vm.validationService.validate(item.name, item.data, field)\" \nlayout=\"row\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" \nflex-gt-lg=\"33\"><div class=\"h5 font-weight-500 pt-5 pl-5 pr-5 text-capitalized\">{{field.label}}:</div><div \nng-if=\"!vm.attachments[field.module]\" class=\"h5 font-weight-300 pt-5 pl-5 pr-5 text-capitalized\">\n{{(item.data[field.field_text] ? item.data[field.field_text] : (item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field])) | formatValue : field.type : vm.lists[field.options]}}\n</div><dl ng-if=\"vm.attachments[field.module][item.data._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, item.data._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][item.data._id]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span><a ng-click=\"vm.getAttachmentUrl(attach)\">\n<span class=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a>\n</div></dd></dl></div></div></div><div ng-if=\"item.data\" class=\"p-30 bb\"><div class=\"mb-20\" layout=\"column\"><div \nclass=\"h2 pl-5 pr-15 light-blue-500-fg text-capitalized\">\n{{item.data.padre_nombre}} {{item.data.padre_primer_apellido}} {{item.data.padre_segundo_apellido}}</div><div class=\"\" \nlayout=\"row\"><div class=\"h5 font-weight-500 pl-5 pr-5\">Documento de identidad:</div><div \nclass=\"h5 font-weight-300 pl-5 pr-5\">{{item.data.padre_documento}}</div></div></div><div class=\"\" layout=\"row\" \nlayout-wrap><div class=\"\" ng-repeat=\"field in item.campos\" \nng-if=\"vm.validateParentsFields(\'dad\', field) && vm.validationService.validate(item.name, item.data, field)\" \nlayout=\"row\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" \nflex-gt-lg=\"33\"><div class=\"h5 font-weight-500 pt-5 pl-5 pr-5 text-capitalized\">{{field.label}}:</div><div \nclass=\"h5 font-weight-300 pt-5 pl-5 pr-5 text-capitalized\">\n{{(item.data[field.field_text] ? item.data[field.field_text] : (item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field])) | formatValue : field.type : vm.lists[field.options]}}\n</div></div></div><div layout=\"row\" class=\"pl-5 pr-5 pt-20\" layout-align=\"end center\"><div class=\"grey-500-fg\"><span \nclass=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" ng-click=\"vm.openEditDialog($event, item)\">\nEditar</span></div></div></div><div class=\"p-30\" ng-if=\"!item.data\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div \nclass=\"text-center h3\"><span class=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span \nclass=\"grey-500-fg font-weight-300\">{{item.emptyRowsMessage}}</span></div></div><div class=\"p-10\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información padres\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/personal-info.html","<div class=\"widget-group personal-info\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div ng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"pt-30 pb-30 pl-30 pr-30\" layout=\"row\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"70\" flex-gt-md=\"70\" flex-lg=\"70\" flex-gt-lg=\"70\" layout-wrap>\n<div class=\"pb-20\" layout=\"row\" layout-align-sm=\"center center\" layout-align=\"start center\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"100\" flex-gt-md=\"100\" flex-lg=\"100\" flex-gt-lg=\"100\" \nlayout-wrap><div layout=\"row\" flex=\"100\" layout-align=\"space-between center\" layout-wrap><div layout=\"column\"><div \nclass=\"md-subhead\"><span class=\"font-weight-300\">Documento:</span> {{item.data.cedula}}</div></div></div></div><div \nng-repeat=\"info in item.campos\" ng-if=\"info.label != \'Foto\'\" class=\"\" layout=\"column\" flex-xs=\"100\" flex-gt-xs=\"100\" \nflex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div class=\"pt-5 pb-5 pr-5\">\n<span class=\"h5 text-capitalized font-weight-500\">{{info.label}}:</span> <span ng-if=\"!vm.attachments[info.module]\" \nclass=\"h5 font-weight-300\">\n{{(item.data[info.field_extra] ? item.data[info.field_extra] : item.data[info.field]) | formatValue : info.type : vm.lists[info.options] : info.field : null : item.data[info.field_extra] : info.use_same_value}}\n</span></div></div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/two-columns-one-row.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\"><div ng-if=\"item.text_view\">\n<div class=\"text-center h3\">{{item.text_view}}</div></div><div ng-if=\"item.data\"><div layout=\"row\" layout-wrap><div \nng-if=\"vm.validationService.validate(item.name, item.data, field)\" ng-repeat=\"field in item.campos\" class=\"\" \nlayout=\"column\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"50\"><div class=\"p-5\"><span class=\"h5 text-capitalized font-weight-500\">{{field.label}}:</span> <span \nng-if=\"!vm.attachments[field.module]\" class=\"h5 font-weight-300\">\n{{(item.data[field.field_text] ? item.data[field.field_text] : (item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field])) | formatValue : field.type : vm.lists[field.options]}}\n</span><dl ng-if=\"vm.attachments[field.module][item.data._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, item.data._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][item.data._id]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span><a ng-click=\"vm.getAttachmentUrl(attach)\">\n<span class=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a>\n</div></dd></dl></div></div></div><div ng-if=\"!vm.analyst\" class=\"pt-20\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"grey-500-fg\"><span class=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, item)\">Editar</span></div></div></div><div ng-if=\"!item.data\"><div \nclass=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-comment-check\" \nclass=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span class=\"grey-600-fg font-weight-400\">\nValioso consejo: </span><span class=\"grey-500-fg font-weight-300\">{{item.emptyRowsMessage}}</span></div></div></div>\n<div ng-if=\"!item.data && !vm.analyst\" layout=\"row\" layout-align=\"end center\" class=\"pt-10 pb-10 pl-30 pr-30 bt\">\n<md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/two-columns.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\" ng-if=\"item.text_view\"><div \nclass=\"text-center h3\">{{item.text_view}}</div></div><div class=\"p-30 bb\" ng-if=\"item.data.length\" \nng-repeat=\"data in item.data\"><div layout=\"row\" layout-wrap><div ng-repeat=\"field in item.campos\" \nng-if=\"vm.validationService.validate(item.name, data, field)\" class=\"\" layout=\"column\" flex-xs=\"100\" flex-gt-xs=\"100\" \nflex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div class=\"p-5\"><span \nclass=\"h5 text-capitalized font-weight-500\">{{field.label}}:</span> <span ng-if=\"!vm.attachments[field.module]\" \nclass=\"h5 font-weight-300\">{{data[field.field] | formatValue : field.type : vm.lists[field.options]}}</span><dl \nng-if=\"vm.attachments[field.module][data._id].length\" ng-init=\"vm.validateMultipleAttachment(field.module, data._id)\">\n<dd class=\"p-8 m-5 grey-300-bg b\" ng-repeat=\"attach in vm.attachments[field.module][data._id]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span><a ng-click=\"vm.getAttachmentUrl(attach)\">\n<span class=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a>\n</div></dd></dl></div></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" class=\"pl-5 pr-5 pt-20\" \nlayout-align=\"end center\"><div class=\"pr-15 red-300-fg\"><span class=\"icon-trash\"></span> <span \nclass=\"h6 cursor-pointer text-underlined\" ng-click=\"vm.openDeleteDialog($event, item, data)\">Eliminar</span></div><div \nclass=\"grey-500-fg\"><span class=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, vm.getBlockData(item, data))\">Editar</span></div></div></div><div class=\"p-30\" \nng-if=\"!item.data.length\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" layout-align=\"end center\" \nclass=\"pt-10 pb-10 pl-30 pr-10 bt\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/header/default.html","<div class=\"header white-fg h-170 office-background\" layout=\"column\" layout-align=\"space-between start\"><div \nclass=\"all-width\" layout=\"column\" layout-align=\"space-between start\"><div class=\"pl-30 pt-15\" layout=\"row\" \nlayout-align=\"start start\"><md-icon ng-if=\"vm.pageInfo.icon\" md-font-icon=\"{{vm.pageInfo.icon}}\" class=\"h4\"></md-icon>\n<div ng-if=\"vm.pageInfo.icon\" ng-repeat=\"parent in vm.pageInfo.parents\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"separator h3\"></md-icon><span class=\"h6 parent white-text\">{{parent}}</span></div></div><div hide-xs hide-sm \nshow-md show-lg show-xl ng-class=\"{\'pb-15\' : !vm.pageInfo.subtitle && !vm.adminDashboard}\" class=\"pl-30 h1 text-light\" \nng-bind-html=\"vm.pageInfo.title\" layout=\"row\" layout-align=\"start center\"></div><div show-xs show-sm hide-md hide-lg \nhide-xl ng-class=\"{\'pb-15\' : !vm.pageInfo.subtitle && !vm.adminDashboard}\" class=\"pl-30 h3 text-light\" \nng-bind-html=\"vm.pageInfo.title\" layout=\"row\" layout-align=\"start center\"></div><div ng-if=\"vm.pageInfo.subtitle\" \nng-bind-html=\"vm.pageInfo.subtitle\" class=\"pl-30 pb-15 text-light\"></div><div ng-if=\"vm.adminDashboard\" layout=\"row\" \nclass=\"z-index-1 pl-30\"><div class=\"selected-project\">{{vm.year}}</div><md-menu id=\"projects-menu\" md-offset=\"0 48\">\n<md-button class=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"(key, value) in vm.years\"><md-button ng-click=\"vm.getReport(value)\" \naria-label=\"{{value}}\"><span ng-class=\"{\'secondary-text\': vm.year == value}\">{{value}}</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"all-width pl-20\" layout=\"row\" \nlayout-align=\"space-between end\" layout-wrap><div layout=\"column\" layout-align=\"center center\" class=\"z-index-1\">\n<md-button ng-if=\"vm.sidebar\" class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"space-between end\" class=\"pr-20 pl-20 z-index-1\"><div ng-if=\"vm.pageInfo.vacants\" \nclass=\"p-15\" layout=\"column\" layout-align=\"center end\"><div md-colors=\"{color: \'accent\'}\" \nclass=\"h1 text-light text-center\">{{vm.pageInfo.vacants}}</div><div class=\"h6 text-light\">Vacante <span \nng-if=\"vm.pageInfo.vacants > 1\">s</span></div></div><div \nng-if=\"vm.showRequest && vm.data.options.update_tipo_solicitud\" layout=\"row\" class=\"p-10 z-index-1\" \nlayout-align=\"start end\"><md-button hide-xs hide-sm show-md show-lg show-xl \nng-click=\"vm.openUpdateRequestTypeDialog($event)\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Tipo solicitud o país\n</md-button><md-button show-xs show-sm hide-md hide-lg hide-xl ng-click=\"vm.openUpdateRequestTypeDialog($event)\" \nclass=\"md-raised md-warn h6 w-40 h-30 line-height-30 remove-uppercase no-margin\"><md-tooltip md-direction=\"bottom\">\nTipo solicitud o país</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button></div><div \nng-if=\"vm.newRequest\" layout=\"row\" class=\"p-10 z-index-1\" layout-align=\"start end\"><md-button \nng-click=\"vm.openSelectTypeNewRequestDialog($event)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Nueva requisición</md-button>\n</div><div ng-if=\"vm.downloadPDFReportButton\" layout=\"row\" class=\"p-10 z-index-1\" layout-align=\"start end\" layout-wrap>\n<md-button hide-xs hide-sm show-md show-lg show-xl ng-click=\"vm.downloadPDFReport()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Descargar requisición\n</md-button><md-button show-xs show-sm hide-md hide-lg hide-xl ng-click=\"vm.downloadPDFReport()\" \nclass=\"md-raised md-accent h6 w-40 h-30 line-height-30 remove-uppercase no-margin\"><md-tooltip md-direction=\"bottom\">\nDescargar requisición</md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon></md-button></div><div \nng-if=\"vm.downloadApprover\" layout=\"row\" class=\"p-10 z-index-1\" layout-align=\"start end\"><md-button hide-xs hide-sm \nshow-md show-lg show-xl ng-click=\"vm.downloadReport($event)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Descargar reporte en excel\n</md-button><md-button show-xs show-sm hide-md hide-lg hide-xl ng-click=\"vm.downloadReport($event)\" \nclass=\"md-raised md-accent h6 w-40 h-30 line-height-30 remove-uppercaseno-margin\"><md-tooltip md-direction=\"bottom\">\nDescargar reporte en excel</md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon></md-button></div></div></div>\n</div>");
$templateCache.put("app/main/templates/header/finalist.html","<div id=\"header_request\"><div class=\"header white-fg h-310 office-background\" layout=\"column\" \nlayout-align=\"space-between\" layout-wrap><div layout=\"column\" layout-align=\"space-between\" class=\"padding-header\"><div \nlayout=\"column\" layout-align=\"space-between start\" class=\"mb-10\"><div class=\"\" layout=\"row\" layout-align=\"start start\">\n<md-icon ng-if=\"vm.pageInfo.icon\" md-font-icon=\"{{vm.pageInfo.icon}}\" class=\"h4\"></md-icon><div \nng-if=\"vm.pageInfo.icon\" ng-repeat=\"parent in vm.pageInfo.parents\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"separator h3\"></md-icon><span class=\"h6 parent white-text\">{{parent}}</span></div></div></div><div \nlayout=\"column\" layout-align=\"space-between\" hide-xs hide-sm ng-if=\"vm.request.cod\"><div \nlayout-align-xs=\"space-between\" layout-align-sm=\"space-between\" layout-align-md=\"space-between center\" \nlayout-align-lg=\"space-between center\" layout-align-xl=\"space-between\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" class=\"mb-10\"><div layout=\"row\" layout-align=\"space-between\"><div><span \nclass=\"blue-300-fg font-weight-300 md-display-1\">{{vm.request.cod}}</span></div><div><span \nclass=\"pl-10 pr-10 font-weight-300 md-display-1\">|</span></div><div><span class=\"md-display-1\">\n{{vm.request.name | capitalize:true}}</span></div></div><div layout=\"column\" layout-align=\"between\"><span \nclass=\"h3 white-fg\" ng-if=\"vm.request.approve_understanding.enviar_entendimiento_aprobacion == 1\">\nEstado del entendimiento: <span class=\"h3 font-weight-400 orange-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'No enviado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 blue-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Enviado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 red-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Rechazado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 light-green-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Aprobado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}}</span></span></div><div layout=\"row\" \nlayout-align=\"end center\"><i class=\"s20 icon-account-circle mr-10\"></i> <span class=\"h4\">\n{{vm.request.count_vacant}} VACANTE<span class=\"h4\" ng-if=\"vm.request.count_vacant > 1\">S</span></span></div></div><div\n layout=\"row\" layout-align=\"start start\" class=\"mb-10\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.request.applicant_from\" class=\"h3 subtitle secondary-text pl-10 pr-10\"><i class=\"icon-city white-fg\"></i> \n<span>{{vm.request.applicant_from}}</span></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.request.state\" \nclass=\"h3 subtitle secondary-text pl-10 pr-10\"><i class=\"icon-map-marker white-fg\"></i> <span>{{vm.request.state}}\n</span></div></div><div layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"\"><div \nlayout=\"row\" layout-align=\"start center\" layout-align=\"start\"><div class=\"h3 font-weight-500 pr-5\">Estado del proceso:\n</div><div layout=\"row\" class=\"h3 font-weight-300\">{{vm.request.status_process.estado}}</div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-align=\"start\"><div class=\"h3 font-weight-500 pr-5\">Estado oferta:</div><div \nlayout=\"row\" class=\"h3 font-weight-300\">{{vm.request.status_publish}} <span ng-if=\"vm.request.date_publish\" \nclass=\"h3 font-weight-300 white-fg mr-5 ml-5\">(Desde {{vm.request.date_publish.formatDate}} <span \nng-if=\"vm.request.date_publish_close\">hasta {{vm.request.date_publish_close.formatDate}}</span>)</span></div></div><div\n layout=\"row\" layout-align=\"start center\" layout-align=\"start\"><div class=\"h3 font-weight-500 pr-5\">Solicitante:</div>\n<div class=\"h3 font-weight-300\">{{vm.request.applicant | capitalize:true}} <span ng-if=\"vm.request.applicant_from\">\n({{vm.request.applicant_from}})</span></div></div><div layout=\"row\" layout-align=\"start center\" layout-align=\"start\">\n<div class=\"h3 font-weight-500 pr-5\">Fecha de solicitud:</div><div class=\"h3 font-weight-300\">\n{{vm.request.date_request_format | capitalize:true}} <span ng-if=\"vm.request.date_request_compared_string\">\n({{vm.request.date_request_compared_string}})</span></div></div></div></div></div><div layout=\"column\" \nlayout-align=\"center\" hide-md hide-lg hide-xl><div class=\"text-light\" layout-align-xs=\"space-between\" \nlayout-align-sm=\"space-between\" layout-align-md=\"space-between\" layout-align-lg=\"space-between\" \nlayout-align-xl=\"space-between\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\"><div><span \nclass=\"blue-300-fg font-weight-300 md-display-1\" hide-xs hide-sm>{{vm.request.cod}}</span> <span \nclass=\"blue-300-fg font-weight-300 md-title\" hide-md hide-lg hide-xl>{{vm.request.cod}}</span></div><div><span \nclass=\"pl-10 pr-10 font-weight-300 md-display-1\" hide-xs hide-sm>|</span></div><div layout=\"row\" \nlayout-align=\"space-between\"><span class=\"md-display-1\" hide-xs hide-sm>{{vm.request.name | capitalize:true}}</span> \n<span class=\"md-title\" hide-md hide-lg hide-xl>{{vm.request.name | capitalize:true}}</span> <i \nclass=\"s20 icon-menu cursor-pointer z-index-2\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-md hide-lg hide-xl></i>\n</div></div><div class=\"h4 subtitle secondary-text\">{{vm.request.state | capitalize:true}}</div></div></div><div \nhide-xs hide-sm layout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"space-between\" \nlayout-align-lg=\"space-between\" layout-align-xl=\"space-between\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" class=\"row-opacity\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Candidatos</div><div class=\"h2 white-fg font-weight-600\">\n{{vm.request.candidate_info.candidates}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">No leídos</div><div class=\"h2 white-fg font-weight-600\">\n{{vm.request.candidate_info.unread}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Preseleccionados</div><div class=\"h2 white-fg font-weight-600\">\n{{vm.request.candidate_info.preSelected}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Finalistas</div><div class=\"h2 white-fg font-weight-600\">\n{{vm.request.candidate_info.finalist}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Seleccionados</div><div class=\"h2 white-fg font-weight-600\">\n{{vm.request.candidate_info.selected}}</div></div></div></div></div>");
$templateCache.put("app/main/templates/header/reports.html","<div id=\"header_request\"><div class=\"header white-fg office-background\" id=\"header_request_heigth\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" class=\"padding-header\"><div \nlayout=\"column\" layout-align=\"space-between start\" class=\"mb-10\"><div class=\"\" layout=\"row\" layout-align=\"start start\">\n<md-icon ng-if=\"vm.pageInfo.icon\" md-font-icon=\"{{vm.pageInfo.icon}}\" class=\"h4\"></md-icon><div \nng-if=\"vm.pageInfo.icon\" ng-repeat=\"parent in vm.pageInfo.parents\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"separator h3\"></md-icon><span class=\"h6 parent white-text\">{{parent}}</span></div></div></div><div \nlayout=\"column\" layout-align=\"space-between\"><div hide-xs hide-sm show-md show-lg show-xl \nng-class=\"{\'pb-15\' : !vm.pageInfo.subtitle && !vm.adminDashboard}\" class=\"pl-30 h1 text-light\" \nng-bind-html=\"vm.pageInfo.title\" layout=\"row\" layout-align=\"start center\"></div><div show-xs show-sm hide-md hide-lg \nhide-xl ng-class=\"{\'pb-15\' : !vm.pageInfo.subtitle && !vm.adminDashboard}\" class=\"pl-30 h3 text-light\" \nng-bind-html=\"vm.pageInfo.title\" layout=\"row\" layout-align=\"start center\"></div><div ng-if=\"vm.pageInfo.subtitle\" \nng-bind-html=\"vm.pageInfo.subtitle\" class=\"pl-30 pb-15 text-light\"></div></div></div><div hide-xs hide-sm hide-md \nlayout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"space-between\" \nlayout-align-lg=\"space-between\" layout-align-xl=\"space-between\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" class=\"row-opacity\"><div layout=\"row\" layout-align=\"center end\"><div class=\"selected-project\">\n{{vm.report.name}}</div><md-menu id=\"reports-menu\" md-offset=\"0 48 \" class=\"z-index-2\"><md-button \nclass=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"report in vm.reports\"><md-button ng-click=\"vm.selectProject(report)\" \naria-label=\"{{report.name}}\"><span ng-class=\"{\'secondary-text\': vm.selectedReport == report}\">{{report.name}}</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div hide-lg hide-xl layout=\"row\" \nlayout-align=\"space-between\" class=\"row-opacity\" flex=\"100\" layout-wrap><div layout=\"row\" layout-align=\"center center\" \nflex=\"100\"><div class=\"selected-project\">{{vm.report.name}}</div><md-menu id=\"reports-menu\" md-offset=\"0 48 \" \nclass=\"z-index-2\"><md-button class=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Select project\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"report in vm.reports\">\n<md-button ng-click=\"vm.selectProject(report)\" aria-label=\"{{report.name}}\"><span \nng-class=\"{\'secondary-text\': vm.selectedReport == report}\">{{report.name}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div>");
$templateCache.put("app/main/templates/header/request.html","<div id=\"header_request\"><div class=\"header white-fg office-background\" id=\"header_request_heigth\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\" class=\"padding-header\"><div \nlayout=\"column\" layout-align=\"space-between start\" class=\"mb-10\"><div class=\"\" layout=\"row\" layout-align=\"start start\">\n<md-icon ng-if=\"vm.pageInfo.icon\" md-font-icon=\"{{vm.pageInfo.icon}}\" class=\"h4\"></md-icon><div \nng-if=\"vm.pageInfo.icon\" ng-repeat=\"parent in vm.pageInfo.parents\"><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"separator h3\"></md-icon><span class=\"h6 parent white-text\">{{parent}}</span></div></div></div><div \nlayout=\"column\" layout-align=\"space-between\" hide-xs hide-sm ng-if=\"vm.request.cod\"><div \nlayout-align-xs=\"space-between\" layout-align-sm=\"space-between\" layout-align-md=\"space-between center\" \nlayout-align-lg=\"space-between center\" layout-align-xl=\"space-between\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" class=\"mb-10\"><div layout=\"row\" layout-align=\"space-between\"><div><span \nclass=\"blue-300-fg font-weight-300 md-display-1\">{{vm.request.cod}}</span></div><div><span \nclass=\"pl-10 pr-10 font-weight-300 md-display-1\">|</span></div><div><span class=\"md-display-1\">\n{{vm.request.name | capitalize:true}}</span></div></div><div layout=\"column\" layout-align=\"between\"><span \nclass=\"h3 white-fg\" ng-if=\"vm.request.approve_understanding.enviar_entendimiento_aprobacion == 1\">\nEstado del entendimiento: <span class=\"h3 font-weight-400 orange-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'No enviado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 blue-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Enviado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 red-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Rechazado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 light-green-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Aprobado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}}</span></span></div><div layout=\"row\" \nlayout-align=\"end center\"><i class=\"s20 icon-account-circle mr-10\"></i> <span class=\"h4\">\n{{vm.request.count_vacant}} VACANTE <span class=\"h4\" ng-if=\"vm.request.count_vacant > 1\">S</span></span></div></div>\n<div layout=\"row\" layout-align=\"start start\" class=\"mb-10\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.request.applicant_from\" class=\"h3 subtitle secondary-text pr-10\"><i class=\"icon-city white-fg\"></i> <span>\n{{vm.request.applicant_from}}</span></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.request.state\" \nclass=\"h3 subtitle secondary-text pl-10 pr-10\"><i class=\"icon-map-marker white-fg\"></i> <span \nng-if=\"vm.request.country\">{{vm.request.country}} /&nbsp;</span> <span>{{vm.request.state}}</span></div></div><div \nlayout=\"row\"><div class=\"h4 pr-5\">{{vm.request.tipo_solicitud_label}}</div><div class=\"h5 pr-5\" \nng-if=\"vm.request.tipo_solicitud_b_label\">{{vm.request.tipo_solicitud_b_label}}</div><div class=\"h5\" \nng-if=\"vm.request.tipo_solicitud_c_label\">{{vm.request.tipo_solicitud_c_label}}</div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"\"><div layout=\"row\" layout-align=\"start center\" \nlayout-align=\"start\"><div class=\"h3 font-weight-500 pr-5\">Estado del proceso:</div><div layout=\"row\" \nclass=\"h3 font-weight-300\">{{vm.request.status_process.estado}}</div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-align=\"start\"><div class=\"h3 font-weight-500 pr-5\">Estado oferta:</div><div \nlayout=\"row\" class=\"h3 font-weight-300\">{{vm.request.status_publish}} <span ng-if=\"vm.request.date_publish\" \nclass=\"h3 font-weight-300 white-fg mr-5 ml-5\">(Desde {{vm.request.date_publish.formatDate}} <span \nng-if=\"vm.request.date_publish_close\">hasta {{vm.request.date_publish_close.formatDate}}</span>)</span><div \nclass=\"blue-300-fg cursor-pointer z-index-2\" ng-if=\"vm.user.group_id == 5\"><u ng-click=\"vm.publishRequest();\" \nng-if=\"vm.request.status_publish != \'Publicada\'\">Publicación de la oferta</u> <u ng-click=\"vm.publishRequest();\" \nng-if=\"vm.request.status_publish == \'Publicada\'\">Editar publicación de la oferta</u></div></div></div><div \nlayout=\"row\" layout-align=\"start center\" layout-align=\"start\"><div class=\"h3 font-weight-500 pr-5\">Solicitante:</div>\n<div class=\"h3 font-weight-300\">{{vm.request.applicant | capitalize:true}} <span ng-if=\"vm.request.applicant_from\">\n({{vm.request.applicant_from}})</span></div></div><div layout=\"row\" layout-align=\"start center\" layout-align=\"start\">\n<div class=\"h3 font-weight-500 pr-5\">Fecha de aprobación:</div><div class=\"h3 font-weight-300\">\n{{vm.request.date_approve.formatDate | capitalize:true}} <span ng-if=\"vm.request.applicant_from\">\n({{vm.request.date_approve.stringDateInMonth}})</span></div></div><div layout=\"row\" layout-align=\"start center\" \nlayout-align=\"start\" ng-if=\"vm.request.el_empleo_id\"><div class=\"h3 font-weight-500 pr-5\">\nFecha de publicación en el empleo:</div><div class=\"h3 font-weight-300\">\n{{vm.request.date_publish_elempleo.formatDate | capitalize:true}} <span ng-if=\"vm.request.applicant_from\">\n({{vm.request.date_publish_elempleo.stringDateInMonth}})</span></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.user.group_id == 5\"><md-button \nclass=\"md-raised md-primary white-fg h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 z-index-2 mb-10 no-margin\" \nng-click=\"vm.openShowRequestNotesDialog()\" aria-label=\"Crear nota\"><span ng-if=\"vm.request.notes.length > 0\">\nVer notas del proceso ({{vm.request.notes.length}})</span> <span ng-if=\"vm.request.notes.length <= 0\">Crear una nota\n</span></md-button></div></div></div><div layout=\"column\" layout-align=\"center\" hide-md hide-lg hide-xl><div \nclass=\"text-light\" layout-align-xs=\"space-between\" layout-align-sm=\"space-between\" layout-align-md=\"space-between\" \nlayout-align-lg=\"space-between\" layout-align-xl=\"space-between\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\"><div><span class=\"blue-300-fg font-weight-300 md-title\">{{vm.request.cod}}</span></div><div \nlayout=\"row\" layout-align=\"space-between\"><span class=\"md-title\">{{vm.request.name | capitalize:true}}</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><i class=\"s20 icon-account-circle mr-10\"></i> <span class=\"h4\">\n{{vm.request.count_vacant}} VACANTE <span class=\"h4\" ng-if=\"vm.request.count_vacant > 1\">S</span></span></div><div \nlayout=\"column\" layout-align=\"between\"><span class=\"h3 white-fg\" \nng-if=\"vm.request.approve_understanding.enviar_entendimiento_aprobacion == 1\">Estado del entendimiento: <span \nclass=\"h3 font-weight-400 orange-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'No enviado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 blue-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Enviado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 red-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Rechazado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 light-green-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Aprobado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}}</span></span></div><div layout=\"row\"><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"vm.request.applicant_from\" class=\"h3 subtitle secondary-text pr-10\"><i \nclass=\"icon-city white-fg\"></i> <span>{{vm.request.applicant_from}}</span></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.request.state\" class=\"h3 subtitle secondary-text pr-10\"><i \nclass=\"icon-map-marker white-fg\"></i> <span ng-if=\"vm.request.country\">{{vm.request.country}} /&nbsp;</span> <span>\n{{vm.request.state}}</span></div></div><div layout=\"row\"><div class=\"h4 pr-5\">{{vm.request.tipo_solicitud_label}}</div>\n<div class=\"h5 pr-5\" ng-if=\"vm.request.tipo_solicitud_b_label\">{{vm.request.tipo_solicitud_b_label}}</div><div \nclass=\"h5\" ng-if=\"vm.request.tipo_solicitud_c_label\">{{vm.request.tipo_solicitud_c_label}}</div></div><div \nlayout=\"row\" layout-align=\"start center\" layout-align=\"start\"><div class=\"h3 font-weight-500 pr-5\">Estado del proceso:\n</div><div layout=\"row\" class=\"h3 font-weight-300\">{{vm.request.status_process.estado}}</div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-align=\"start\"><div class=\"h3 font-weight-500 pr-5\">Estado oferta:</div><div \nlayout=\"row\" class=\"h3 font-weight-300\">{{vm.request.status_publish}} <span ng-if=\"vm.request.date_publish\" \nclass=\"h3 font-weight-300 white-fg mr-5 ml-5\">(Desde {{vm.request.date_publish.formatDate}} <span \nng-if=\"vm.request.date_publish_close\">hasta {{vm.request.date_publish_close.formatDate}}</span>)</span><div \nclass=\"blue-300-fg cursor-pointer z-index-2\" ng-if=\"vm.user.group_id == 5\"><u ng-click=\"vm.publishRequest();\" \nng-if=\"vm.request.status_publish != \'Publicada\'\">Publicación de la oferta</u> <u ng-click=\"vm.publishRequest();\" \nng-if=\"vm.request.status_publish == \'Publicada\'\">Editar publicación de la oferta</u></div></div></div><div \nlayout=\"row\" layout-align=\"start center\" layout-align=\"start\"><div class=\"h3 font-weight-500 pr-5\">Solicitante:</div>\n<div class=\"h3 font-weight-300\">{{vm.request.applicant | capitalize:true}} <span ng-if=\"vm.request.applicant_from\">\n({{vm.request.applicant_from}})</span></div></div><div layout=\"row\" layout-align=\"start center\" layout-align=\"start\">\n<div class=\"h3 font-weight-500 pr-5\">Fecha de aprobación:</div><div class=\"h3 font-weight-300\">\n{{vm.request.date_approve.formatDate | capitalize:true}} <span ng-if=\"vm.request.applicant_from\">\n({{vm.request.date_approve.stringDateInMonth}})</span></div></div><div layout=\"row\" layout-align=\"start center\" \nlayout-align=\"start\" ng-if=\"vm.request.el_empleo_id\"><div class=\"h3 font-weight-500 pr-5\">\nFecha de publicación en el empleo:</div><div class=\"h3 font-weight-300\">\n{{vm.request.date_publish_elempleo.formatDate | capitalize:true}} <span ng-if=\"vm.request.applicant_from\">\n({{vm.request.date_publish_elempleo.stringDateInMonth}})</span></div></div></div></div><div hide-xs hide-sm hide-md \nlayout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"space-between\" \nlayout-align-lg=\"space-between\" layout-align-xl=\"space-between\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" class=\"row-opacity\"><div layout=\"row\" layout-align=\"center end\"><div class=\"selected-project\">\n{{vm.project.name}}</div><md-menu id=\"projects-menu\" md-offset=\"0 48 \" class=\"z-index-2\"><md-button \nclass=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item ng-repeat=\"project in vm.projects\"><md-button \nng-click=\"vm.selectProject(project)\" aria-label=\"{{project.name}}\"><span \nng-class=\"{\'secondary-text\': vm.selectedProject == project}\">{{project.name}}</span></md-button></md-menu-item>\n<md-menu-item \nng-if=\"vm.user.group_id == 1 && vm.request.status_process.id == vm.status_process_status.PROCESO_FINALIZADO\"><md-button\n ng-click=\"vm.showFinishProcess()\" aria-label=\"finalizar\"><span>Habilitar proceso</span></md-button></md-menu-item>\n<md-menu-item \nng-if=\"vm.user.group_id == 5 && vm.request.status_process.id != vm.status_process_status.PROCESO_FINALIZADO\"><md-button\n ng-click=\"vm.showFinishProcess()\" aria-label=\"finalizar\"><span>Finalizar proceso</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Candidatos</div><div class=\"h2 white-fg font-weight-600\">\n{{vm.request.candidate_info.candidates}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">No leídos</div><div class=\"h2 white-fg font-weight-600\">\n{{vm.request.candidate_info.unread}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Preseleccionados</div><div class=\"h2 white-fg font-weight-600\">\n{{vm.request.candidate_info.preSelected}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Finalistas</div><div class=\"h2 white-fg font-weight-600\">\n{{vm.request.candidate_info.finalist}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Seleccionados</div><div class=\"h2 white-fg font-weight-600\">\n{{vm.request.candidate_info.selected}}</div></div></div><div hide-lg hide-xl layout=\"row\" layout-align=\"space-between\" \nclass=\"row-opacity\" flex=\"100\" layout-wrap><div layout=\"column\" layout-align=\"center center\" flex=\"50\"><div \nclass=\"h2 white-fg font-weight-600\">{{vm.request.candidate_info.candidates}}</div><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Candidatos</div></div><div layout=\"column\" layout-align=\"start center\" \nflex=\"50\"><div class=\"h2 white-fg font-weight-600\">{{vm.request.candidate_info.unread}}</div><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">No leídos</div></div><div layout=\"column\" layout-align=\"start center\" \nflex=\"50\"><div class=\"h2 white-fg font-weight-600\">{{vm.request.candidate_info.preSelected}}</div><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Preseleccionados</div></div><div layout=\"column\" layout-align=\"start center\" \nflex=\"50\"><div class=\"h2 white-fg font-weight-600\">{{vm.request.candidate_info.finalist}}</div><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Finalistas</div></div><div layout=\"column\" layout-align=\"start center\" \nflex=\"50\"><div class=\"h2 white-fg font-weight-600\">{{vm.request.candidate_info.selected}}</div><div \nclass=\"h4 grey-200-fg text-truncate pr-5\">Seleccionados</div></div><div layout=\"row\" layout-align=\"center center\" \nflex=\"100\"><div class=\"selected-project\">{{vm.project.name}}</div><md-menu id=\"projects-menu\" md-offset=\"0 48 \" \nclass=\"z-index-2\"><md-button class=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Select project\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"project in vm.projects\">\n<md-button ng-click=\"vm.selectProject(project)\" aria-label=\"{{project.name}}\"><span \nng-class=\"{\'secondary-text\': vm.selectedProject == project}\">{{project.name}}</span></md-button></md-menu-item>\n<md-menu-item \nng-if=\"vm.user.group_id == 1 && vm.request.status_process.id == vm.status_process_status.PROCESO_FINALIZADO\"><md-button\n ng-click=\"vm.showFinishProcess()\" aria-label=\"finalizar\"><span>Habilitar proceso</span></md-button></md-menu-item>\n<md-menu-item \nng-if=\"vm.user.group_id == 5 && vm.request.status_process.id != vm.status_process_status.PROCESO_FINALIZADO\"><md-button\n ng-click=\"vm.showFinishProcess()\" aria-label=\"finalizar\"><span>Finalizar proceso</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div>");
$templateCache.put("app/main/templates/offers/offers.html","<div ng-if=\"vm.offersSuggested.length\" class=\"widget-group pt-5 pb-5 pl-20 pr-20\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"true\" layout=\"column\" ng-repeat=\"offer in vm.offersSuggested\" flippable=\"true\" flex=\"100\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"33\"><ms-widget-front class=\"white-bg ms-widget-front {{vm.factory.offerStatusBarColor(offer.status)}}\"><div\n class=\"pt-15 pr-15 pl-15 pb-5 bb\"><div layout=\"row\" layout-align=\"space-between\" class=\"pt-5 pr-5 pl-5\"><div><div \nclass=\"h2 h-55 grey-600-fg text-light\">{{offer.name | capitalize:true}}</div><div \nng-if=\"offer.city && offer.city != \'null\'\" class=\"h7 grey-500-fg\">{{offer.city | uppercase}}</div></div><div \nng-if=\"offer.new\"><span class=\"text-boxed m-0 h6 text-light white-fg md-orange-500-bg\">Nueva</span></div></div><div \nclass=\"pt-10 pb-5 pr-5 pl-5 h-60\"><div ng-if=\"offer.salary\" class=\"h2 text-light green-400-fg\">{{offer.salary}}</div>\n<div ng-if=\"!offer.salary\" class=\"h2 text-light green-400-fg\">Confidencial</div><div ng-if=\"offer.area.areas\" \nclass=\"h6\"><span class=\"grey-500-fg\">Área:</span> {{offer.area.areas | capitalize:true}}</div></div><div \nclass=\"pt-10 pb-5 pr-5 pl-5\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h6 grey-500-fg text-light\">\nPublicado: {{offer.date | fecha: \'MMMM D, YYYY\' | capitalize}}</div><div class=\"h6 grey-500-fg text-light\" \nlayout=\"row\" layout-align=\"space-between center\"><md-icon md-font-icon=\"icon-account-circle\" class=\"h2 grey-500-fg\">\n</md-icon><div class=\"p-5\">{{offer.vacants}} VACANTE<span ng-if=\"offer.vacants > 1\">S</span></div></div></div></div>\n<div class=\"text-light grey-50-bg grey-500-fg pl-20 pr-20 bb h-50\" \nng-class=\"{\'pt-8 pb-8\' : offer.appliedDays, \'pt-15 pb-15\' : !offer.appliedDays}\"><div ng-if=\"offer.applied\" \nlayout=\"column\" layout-align=\"center start\"><div>\nFecha de aplicación: {{offer.appliedDate | fecha: \'MMMM D, YYYY\' | capitalize}}</div><div class=\"h6\" \nng-if=\"offer.appliedDays\">(Hace {{offer.appliedDays}} días)</div></div></div><div class=\"pt-5 pr-15 pl-15 pb-15\"><div \nclass=\"pt-10 pb-5 pr-5 pl-5\" layout=\"row\" layout-wrap><div flex=\"50\"><div \nng-show=\"offer.details.description.text || offer.details.requeriments.text\" ng-click=\"flipWidget()\" \nclass=\"h6 grey-700-fg text-light cursor-pointer text-underlined\">Ver más información</div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div ng-show=\"!offer.applied && offer.resumeStatus >= 100\" \nng-click=\"vm.openNoticeDialog($event, offer)\" class=\"h6 grey-500-fg text-light\"><span \nclass=\"text-boxed m-0 h6 text-light cursor-pointer {{vm.factory.offerStatusColor(offer.status)}}\">{{offer.status}}\n</span></div><span ng-show=\"!vm.applied && offer.applied && offer.resumeStatus >= 100\" \nclass=\"text-boxed m-0 h6 md-accent-bg white-fg text-light\">Ya has aplicado a esta oferta</span><div \nng-show=\"vm.applied\" class=\"h6 grey-500-fg text-light\"><span \nclass=\"text-boxed m-0 h6 text-light {{vm.factory.offerStatusColor(offer.status)}}\">{{offer.status}}</span></div><div \nng-show=\"offer.resumeStatus < 100\" class=\"cursor-pointer h6 text-light\"><a href=\"/resume\" class=\"red-500-fg\">\nDebes completar tu hoja de vida para poder aplicar</a></div></div></div></div></ms-widget-front><ms-widget-back \nclass=\"white-bg ms-widget-back\" ms-scroll><div class=\"{{vm.factory.offerStatusBarColor(offer.status)}} white-fg\" \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div \nlayout=\"column\" class=\"p-20 white-bg\"><div ng-show=\"offer.details.description.text\"><div class=\"h4 green-500-fg pb-5\">\n{{offer.details.description.title | capitalize}}</div><div class=\"h6\">{{offer.details.description.text | capitalize}}\n</div></div><div ng-show=\"offer.details.requeriments.text\" class=\"pt-20\"><div class=\"h4 green-500-fg pb-5\">\n{{offer.details.requeriments.title | capitalize}}</div><div class=\"h6\">{{offer.details.requeriments.text | capitalize}}\n</div></div></div></ms-widget-back></ms-widget></div><div ng-if=\"!vm.offersSuggested.length\" class=\"p-30\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"p-10 mb-10 orange-100-bg orange-900-fg\"><div \nclass=\"pl-5 pt-5 pb-5 pr-15\"><md-icon md-font-icon=\"icon-information\" class=\"orange-900-fg\"></md-icon></div><div \nclass=\"p-5\">No se encontraron ofertas.</div></div></div>");
$templateCache.put("app/main/templates/paginator/paginator.html","<div layout=\"row\" layout-align=\"center center\"><div class=\"cursor-pointer pr-10\" ng-click=\"vm.firstPage()\"><md-tooltip \nmd-direction=\"bottom\">Primer página</md-tooltip><i class=\"icon icon-chevron-double-left s30\"></i></div><div \nclass=\"cursor-pointer pr-30\" ng-click=\"vm.backward()\"><md-tooltip md-direction=\"bottom\">Página anterior</md-tooltip><i \nclass=\"icon icon-chevron-left s30\"></i></div><div><div>Página <strong>{{vm.page}}</strong> de <strong>{{vm.pages}}\n</strong></div><div>{{vm.totalMails}} Registros</div></div><div class=\"cursor-pointer pl-30\" ng-click=\"vm.forward()\">\n<md-tooltip md-direction=\"bottom\">Página siguiente</md-tooltip><i class=\"icon icon-chevron-right s30\"></i></div><div \nclass=\"cursor-pointer pl-10\" ng-click=\"vm.lastPage()\"><md-tooltip md-direction=\"bottom\">Última página</md-tooltip><i \nclass=\"icon icon-chevron-double-right s30\"></i></div></div>");
$templateCache.put("app/main/templates/resume/aditional-info.html","<div ng-if=\"vm.validation && vm.validation[item.name] && !vm.validation[item.name].completo\" \nclass=\"pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap>{{vm.validation[item.name].msg}}</div>\n<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"pt-20 pb-20 pl-20 pr-30 bb\"><div \nclass=\"p-5 mb-20\"><div class=\"p-5 text-bold\">¿Ha tenido personal a cargo?</div><div class=\"p-5\"><md-radio-group \nlayout=\"row\" ng-model=\"data.group1\"><md-radio-button value=\"1\">Si</md-radio-button><md-radio-button value=\"0\">No\n</md-radio-button></md-radio-group></div></div><div class=\"p-5 mb-20\"><div class=\"p-5 text-bold\">\n¿Que tipo de cargos han tenido sus personas a cargo?</div><div class=\"pt-10 pr-5 pb-10 pl-5 bb\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-padding no-margin\" ng-model=\"data.cb1\" aria-label=\"Checkbox 1\">\nOperativos</md-checkbox></div><div class=\"pt-10 pr-5 pb-10 pl-5 bb\"><md-checkbox class=\"no-padding no-margin\" \nng-model=\"data.cb1\" aria-label=\"Checkbox 1\">Supervisores</md-checkbox></div><div class=\"pt-10 pr-5 pb-10 pl-5 bb\">\n<md-checkbox class=\"no-padding no-margin\" ng-model=\"data.cb1\" aria-label=\"Checkbox 1\">Jefes</md-checkbox></div><div \nclass=\"pt-10 pr-5 pb-10 pl-5 bb\"><md-checkbox class=\"no-padding no-margin\" ng-model=\"data.cb1\" aria-label=\"Checkbox 1\">\nDirectivos</md-checkbox></div><div class=\"pt-10 pr-5 pb-10 pl-5 bb\"><md-checkbox class=\"no-padding no-margin\" \nng-model=\"data.cb1\" aria-label=\"Checkbox 1\">Asistentes, analistas, auxiliares administrativos</md-checkbox></div></div>\n<div class=\"p-5 mb-20\"><div class=\"p-5 text-bold\">¿Ha liderado proyectos estrátegicos dentro de la organización?</div>\n<div class=\"p-5\"><md-radio-group layout=\"row\" ng-model=\"data.group1\"><md-radio-button value=\"1\">Si</md-radio-button>\n<md-radio-button value=\"0\">No</md-radio-button></md-radio-group></div></div><div class=\"p-5 mb-10\"><div \nclass=\"p-5 text-bold\">Mencione por lo menos un proyecto liderado</div><div class=\"\"><md-input-container \nclass=\"md-block no-padding no-margin\"><textarea ng-model=\"user.biography\" md-maxlength=\"150\" rows=\"3\"></textarea>\n</md-input-container></div></div></div><div ng-if=\"!vm.analyst\" class=\"pt-20 pb-20 pl-20 pr-30 bb\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.save()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/resume/childrens.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div ng-if=\"item.data.length\" class=\"p-30 bb\" \nng-repeat=\"children in item.data\"><div class=\"mb-20\" layout=\"column\"><div \nclass=\"h2 pl-5 pr-15 light-blue-500-fg text-capitalized\">\n{{children.nombres}} {{children.primer_apellido}} {{children.segundo_apellido}}</div><div class=\"md-subhead\" \nlayout=\"row\"><div class=\"font-weight-300 pl-5 pr-5\">Documento de identidad:</div><div \nclass=\"font-weight-300 pl-5 pr-5\">{{children.documento_hijo}}</div></div></div><div class=\"\" layout=\"row\" layout-wrap>\n<div class=\"\" ng-repeat=\"field in item.campos\" \nng-if=\"field.field != \'nombres\' \n                            && field.field != \'primer_apellido\' \n                            && field.field != \'segundo_apellido\'\n                            && vm.validationService.validate(item.name, children, field)\n                            && field.label\" \nlayout=\"column\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" \nflex-lg=\"33\" flex-gt-lg=\"33\"><div class=\"pt-5 pb-5 pr-5\"><span \nclass=\"h5 font-weight-500 pt-5 pl-5 pr-5 text-capitalized\">{{field.label}}:</span> <span \nng-if=\"!vm.attachments[field.module]\" class=\"h5 font-weight-300 text-capitalized\">\n{{(children[field.field_extra] ? children[field.field_extra] : children[field.field]) | formatValue : field.type : vm.lists[field.options] : field.field : null : children[field.field_extra] : field.use_same_value}}\n</span><dl ng-if=\"vm.attachments[field.module][children._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, children._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][children._id]\"><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h6\">{{attach.name}}</span> <a ng-click=\"vm.getAttachmentUrl(attach)\"><span \nclass=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a></div>\n</dd></dl></div></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" class=\"pl-5 pr-5 pt-20\" layout-align=\"end center\">\n<div class=\"pr-15 red-300-fg\"><span class=\"icon-trash\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openDeleteDialog($event, item, children)\">Eliminar</span></div><div class=\"grey-500-fg\"><span \nclass=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, vm.getBlockData(item, children))\">Editar</span></div></div></div><div class=\"p-30\" \nng-if=\"!item.data.length\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div><div \nng-if=\"vm.resume.grupo_familiar.data.cantidad_hijos > item.data.length\" class=\"p-10\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">\nIngresar información del {{vm.getOrdinalNumber(item.data.length + 1) | lowercase }} hijo</md-button></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/resume/formal-study.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div class=\"grey-100-bg bb\" layout=\"row\" \nlayout-xs=\"column\"><div class=\"pl-15 pr-15 pt-5 pb-5\" layout=\"row\" flex=\"100\" layout-align=\"space-between center\" \nlayout-wrap><div class=\"pr-15\" layout=\"row\" layout-align=\"center center\"><div class=\"grey-500-fg h6 p-5\">\nNúmero de estudios formales realizados</div><div class=\"h1 text-light p-5\">{{item.indicadores.numero_estudios}}</div>\n</div><div class=\"pr-15\" layout=\"row\" layout-align=\"center center\"><div class=\"grey-500-fg h6 p-5\">\nMayor título finalizado</div><div class=\"h1 text-light p-5 text-capitalized\">\n{{item.indicadores.estudio_mas_avanzado | capitalize : true}}</div></div><div class=\"pr-15\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"grey-500-fg h6 p-5\">Fecha de finalización del último estudio</div><div \nclass=\"h1 text-light p-5\">{{item.indicadores.ultimo_estudio_realizado}}</div></div></div></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\" ng-if=\"item.text_view\"><div \nclass=\"h3\">{{item.text_view}}</div></div><div class=\"pt-30 pb-30 pl-30 pr-30 bb\" ng-if=\"item.data && item.data.length\" \nng-repeat=\"study in item.data\"><div class=\"pb-10\"><div class=\"\" layout=\"row\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-gt-md=\"row\" layout-md=\"row\" layout-align-gt-xs=\"start start\" layout-align-xs=\"start start\" \nlayout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\"><div><div layout=\"row\"><div \nng-if=\"study.titulo\" class=\"h1 pl-5 pr-15 pt-5 text-capitalized\">{{study.titulo | capitalize : true}}</div><div \nng-if=\"!study.titulo\" class=\"h1 pl-5 pr-15 pt-5 text-capitalized\">{{study.profesion_name | capitalize : true}}</div>\n</div><div ng-if=\"study.institucion\" class=\"h6 pl-5 pr-5\"><span class=\"light-blue-500-fg text-capitalized\">\n{{study.institucion | capitalize : true}}</span></div><div ng-if=\"!study.institucion\" class=\"h6 pl-5 pr-5\"><span \nclass=\"light-blue-500-fg text-capitalized\">{{study.instituto_name | capitalize : true}}</span></div></div><div \nlayout=\"row\"><div class=\"light-blue-500-fg h2 text-light-200 pt-5 pl-5 pb-5 pr-15 br-light-blue-1\">\nPromedio acumulado {{study.promedio_acumulado}}</div><div class=\"pt-5 pb-5 pl-15 pr-15\"><div class=\"h7\"><strong>Inicio:\n</strong> {{study.anio_inicio}}</div><div class=\"h7\"><strong>Finalización:</strong> {{study.anio}}</div></div></div>\n</div><div class=\"pl-5 pt-5 pr-5 h6 text-capitalized\">{{study.ciudad_name | capitalize : true}}</div><div \nclass=\"pl-5 pr-5 pt-20\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.campos\" \nng-if=\"field.field != \'profesion_id\' && field.field != \'instituto_id\' && field.field != \'ciudad_id\' && (vm.attachments[field.module][study._id].length || study[field.field_text] || study[field.field_extra] || study[field.field]) \n                                \" \nlayout=\"column\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"33\"><div class=\"pt-5\"><span class=\"h5 text-capitalized font-weight-500\">{{field.label}}:</span> <span \nng-if=\"!vm.attachments[field.module]\" class=\"h5 font-weight-300\">\n{{(study[field.field_text] ? study[field.field_text] : (study[field.field_extra] ? study[field.field_extra] : study[field.field])) | formatValue : field.type : vm.lists[field.options] : field.field : null : study[field.field_extra] : field.use_same_value}}\n</span><dl ng-if=\"vm.attachments[field.module][study._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, study._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][study._id]\"><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h6\">{{attach.name}}</span> <a ng-click=\"vm.getAttachmentUrl(attach)\"><span \nclass=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a></div>\n</dd></dl></div></div></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" class=\"pl-5 pr-5 pt-20\" \nlayout-align=\"end center\"><div class=\"pr-15 red-300-fg\"><span class=\"icon-trash\"></span> <span \nclass=\"h6 cursor-pointer text-underlined\" ng-click=\"vm.openDeleteDialog($event, item, study)\">Eliminar</span></div><div\n class=\"grey-500-fg\"><span class=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, vm.getBlockData(item, study))\">Editar</span></div></div></div><div class=\"p-30\" \nng-if=\"!item.data || !item.data.length\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon\n md-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" layout-align=\"end center\" \nclass=\"pt-10 pb-10 pl-30 pr-10 bt\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar estudio</md-button>\n</div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/resume/laboral-experience.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div class=\"grey-100-bg bb\" layout=\"row\" \nlayout-xs=\"column\"><div class=\"pl-15 pr-15 pt-5 pb-5\" layout=\"row\" flex=\"100\" layout-align=\"space-between center\" \nlayout-wrap><div class=\"pr-15\" layout=\"row\" layout-align=\"center center\"><div class=\"grey-500-fg h6 p-5\">\nAños de experiencia laboral</div><div class=\"md-display-1 text-light p-5\">{{item.indicadores.anios_experiencia}}</div>\n</div><div class=\"pr-15\" layout=\"row\" layout-align=\"center center\"><div class=\"grey-500-fg h6 p-5\">\nNúmero de empresas registradas</div><div class=\"md-display-1 text-light p-5\">{{item.indicadores.numero_empresas}}</div>\n</div><div class=\"pr-15\" layout=\"row\" layout-align=\"center center\"><div class=\"grey-500-fg h6 p-5\">\nNúmero de cargos registradas</div><div class=\"md-display-1 text-light p-5\">{{item.indicadores.numero_cargos}}</div>\n</div></div></div><div ng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\" \nng-if=\"!item.data || !item.data.length\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon\n md-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div><div class=\"pt-30 pb-30 pl-30 pr-30 bb\" \nng-repeat=\"data in item.data | orderBy : \'-fecha_ingreso\'\" ng-if=\"item.data && item.data.length\" \nng-init=\"vm.addCompany(data)\"><div class=\"pb-10\" layout=\"row\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-gt-md=\"row\" layout-md=\"row\" layout-align-gt-xs=\"start start\" layout-align-xs=\"start start\" \nlayout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\"><div><div layout=\"row\"><div \nclass=\"h1 pl-5 pr-15 pt-5 text-capitalized\">{{data.cargo_desempenado}}</div></div><div class=\"h6 pl-5 pr-5 pb-5\"><span \nclass=\"light-blue-500-fg text-capitalized\">{{data.empresa}}</span></div></div><div layout=\"row\"><div \nclass=\"light-blue-500-fg h2 text-light-200 pt-5 pl-5 pb-5 pr-15 br-light-blue-1\">\n{{vm.getDiffBetweenTwoDates(data.fecha_ingreso, data.fecha_retiro)}}</div><div class=\"pt-5 pb-5 pl-15 pr-15\"><div \nclass=\"h7\"><strong>Ingreso:</strong> {{data.fecha_ingreso | formatValue : \'date\'}}</div><div ng-if=\"data.fecha_retiro\" \nclass=\"h7\"><strong>Retiro:</strong> {{data.fecha_retiro | formatValue : \'date\'}}</div></div></div></div><div \nclass=\"pl-5 pr-5 pt-20\" layout=\"row\" flex=\"100\" layout-wrap><div \nng-if=\"vm.validationService.validate(item.name, data, field)\" ng-repeat=\"field in item.campos\" layout=\"column\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"33\">\n<div class=\"pt-5\"><span class=\"h5 text-capitalized font-weight-500\">{{field.label}}:</span> <span \nng-if=\"!vm.attachments[field.module]\" class=\"h5 font-weight-300\">\n{{(data[field.field_extra] ? data[field.field_extra] : data[field.field]) | formatValue : field.type : vm.lists[field.options] : field.field : null : data[field.field_extra] : field.use_same_value}}\n</span><dl ng-if=\"vm.attachments[field.module][data._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, data._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][data._id]\"><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h6\">{{attach.name}}</span><a ng-click=\"vm.getAttachmentUrl(attach)\"><span \nclass=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a></div>\n</dd></dl></div></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" class=\"pt-20\" layout-align=\"end center\"><div \nclass=\"pr-15 red-300-fg\"><span class=\"icon-trash\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openDeleteDialog($event, item, data)\">Eliminar</span></div><div class=\"pl-15 grey-500-fg\"><span \nclass=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, vm.getBlockData(item, data))\">Editar</span></div></div></div><div \nng-if=\"!vm.analyst\" layout=\"row\" layout-align=\"end center\" class=\"pt-10 pb-10 pl-30 pr-10 bt\"><md-button \nng-click=\"vm.openAddExperienceDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar experiencia laboral\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/resume/languages.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div ng-if=\"item.data.length\" \nng-repeat=\"data in item.data\" class=\"pt-30 pb-30 pl-30 pr-30 bb\"><div class=\"pb-10\" layout=\"row\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-gt-md=\"row\" layout-md=\"row\" layout-align-gt-xs=\"start start\" \nlayout-align-xs=\"start start\" layout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\"><div>\n<div layout=\"row\"><div class=\"h3 light-blue-500-fg pl-5 pr-15 pt-5 text-capitalized\">\n{{data.idioma_id | formatValue : \'select\' : vm.lists[\'idiomas\']}}</div></div><div class=\"pt-15 pl-5 pr-5 pb-5\"><div>\n<span class=\"font-weight-500\">Nivel según marco europeo (solo persona certificada):</span> <span>\n{{data.nivel_marco_europeo | formatValue : \'select\' : vm.lists[\'get_niveles_marco_europeo\']}}</span></div><div><span \nclass=\"font-weight-500\">Fecha de vigencia de nivel:</span> <span>{{data.fecha_vigencia_nivel | formatValue : \'date\'}}\n</span></div></div></div><div layout=\"row\"><div class=\"light-blue-500-fg h2 text-light-200 pt-5 pl-5 pb-5 pr-15\">\nLee: {{data.lee | formatValue : \'select\' : vm.lists[\'get_idioma_nivel\']}}</div><div \nclass=\"light-blue-500-fg h2 text-light-200 pt-5 pl-5 pb-5 pr-15\">\nEscribe: {{data.escribe | formatValue : \'select\' : vm.lists[\'get_idioma_nivel\']}}</div><div \nclass=\"light-blue-500-fg h2 text-light-200 pt-5 pl-5 pb-5 pr-15\">\nHabla: {{data.habla | formatValue : \'select\' : vm.lists[\'get_idioma_nivel\']}}</div></div></div><div \nng-if=\"!vm.analyst\" layout=\"row\" class=\"pl-5 pr-5 pt-20\" layout-align=\"end center\"><div class=\"pr-15 red-300-fg\"><span \nclass=\"icon-trash\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openDeleteDialog($event, item, data)\">Eliminar</span></div><div class=\"grey-500-fg\"><span \nclass=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, vm.getBlockData(item, data))\">Editar</span></div></div></div><div class=\"p-30\" \nng-if=\"!item.data || !item.data.length\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon\n md-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div><div ng-if=\"!vm.analyst\" class=\"grey-100-bg p-8\" layout=\"row\" \nlayout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar idioma</md-button>\n</div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/resume/non-formal-study.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\" ng-if=\"item.text_view\"><div \nclass=\"h3\">{{item.text_view}}</div></div><div class=\"pt-30 pb-30 pl-30 pr-30 bb\" ng-if=\"item.data && item.data.length\" \nng-repeat=\"study in item.data\"><div class=\"pb-10\"><div class=\"\" layout=\"row\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-gt-md=\"row\" layout-md=\"row\" layout-align-gt-xs=\"start start\" layout-align-xs=\"start start\" \nlayout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\"><div><div layout=\"row\"><div \nclass=\"h1 pl-5 pr-15 pt-5 text-capitalized\">{{study.titulo}}</div></div><div class=\"h6 pl-5 pr-5 pb-5\"><span \nclass=\"light-blue-500-fg text-capitalized\">{{study.instituto | capitalize:true}}</span></div></div><div layout=\"row\">\n<div class=\"light-blue-500-fg h4 text-light-200 pt-5 pl-5 pb-5 pr-15 br-light-blue-1\"><strong>Inicio:</strong>\n {{study.anio_inicio}}</div><div class=\"light-blue-500-fg h4 text-light-200 pt-5 pl-5 pb-5 pr-15\"><strong>Finalización:\n</strong> {{study.anio}}</div></div></div><div class=\"pl-5 pr-5 pt-10\" layout=\"row\" flex=\"100\" layout-wrap><div \nng-if=\"field.field != \'titulo\' && field.field != \'instituto_id\'\" ng-repeat=\"field in item.campos\" layout=\"column\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"33\">\n<div class=\"pt-5\"><span class=\"h5 text-capitalized font-weight-500\">{{field.label}}:</span> <span \nclass=\"h5 font-weight-300\">\n{{(study[field.field_text] ? study[field.field_text] : (study[field.field_extra] ? study[field.field_extra] : study[field.field])) | formatValue : field.type : vm.lists[field.options] : field.field : null : study[field.field_extra] : field.use_same_value}}\n</span></div><dl ng-if=\"vm.attachments[field.module][study._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, study._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][study._id]\"><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h6\">{{attach.name}}</span><a ng-click=\"vm.getAttachmentUrl(attach)\"><span \nclass=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a></div>\n</dd></dl></div></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" class=\"pl-5 pr-5 pt-20\" layout-align=\"end center\">\n<div class=\"pr-15 red-300-fg\"><span class=\"icon-trash\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openDeleteDialog($event, item, study)\">Eliminar</span></div><div class=\"grey-500-fg\"><span \nclass=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, vm.getBlockData(item, study))\">Editar</span></div></div></div><div class=\"p-30\" \nng-if=\"!item.data || !item.data.length\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon\n md-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div><div ng-if=\"!vm.analyst\" class=\"p-10 bt\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar estudio</md-button>\n</div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/resume/one-column-one-row.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\"><div ng-if=\"item.text_view\">\n<div class=\"h3 pb-15 grey-500-fg\">{{item.text_view}}</div></div><div ng-if=\"item.data\"><div \nng-repeat=\"field in item.campos\" class=\"\" layout=\"column\"><div ng-if=\"item.data[field.field_extra]\" \nng-class=\"{\'pre-wrap\' : item.campos.length == 1}\" class=\"h5 pt-5 pb-5\">\n{{(item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field]) | formatValue : field.type : vm.lists[field.options] : field.field : null : item.data[field.field_extra] : field.use_same_value | capitalize : true}}\n</div><div ng-if=\"!item.data[field.field_extra]\" ng-class=\"{\'pre-wrap\' : item.campos.length == 1}\" \nclass=\"h5 pt-5 pb-5\">\n{{(item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field]) | formatValue : field.type : vm.lists[field.options] : field.field : null : item.data[field.field_extra] : field.use_same_value | capitalize : true}}\n</div></div><di ng-if=\"!vm.analyst\" class=\"pt-10\" layout=\"row\" layout-align=\"end center\"><div class=\"grey-500-fg\"><span\n class=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, item)\">Editar</span></div></di></div></div><div ng-if=\"!item.data\"><div \nclass=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-comment-check\" \nclass=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span class=\"grey-600-fg font-weight-400\">\nValioso consejo: </span><span class=\"grey-500-fg font-weight-300\">{{item.emptyRowsMessage}}</span></div></div>\n</ms-widget-front></ms-widget></div><div ng-if=\"!item.data && !vm.analyst\" layout=\"row\" layout-align=\"end center\" \nclass=\"pt-10 pb-10 pl-30 pr-30 bt\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información\n</md-button></div>");
$templateCache.put("app/main/templates/resume/one-column.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\"><div \nclass=\"pb-15 grey-500-fg\" ng-if=\"item.text_view\">{{item.text_view}}</div><div ng-if=\"item.data\"><div layout=\"row\" \nng-repeat=\"field in item.campos\" layout-wrap><div class=\"h5 font-weight-300 p-5\">\n{{(item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field]) | formatValue : field.type : vm.lists[field.options] : field.field : null : item.data[field.field_extra] : field.use_same_value}}\n</div></div><div class=\"pt-10\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nng-click=\"vm.openEditDialog($event, item)\"><md-icon md-font-icon=\"icon-pencil no-margin no-padding\" class=\"h3\">\n</md-icon><div class=\"h6 cursor-pointer text-underlined pt-5 pb-5\">Editar</div></div></div></div><div \nng-if=\"!item.data\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div></div><div ng-if=\"!item.data\" layout=\"row\" layout-align=\"end center\" \nclass=\"pt-10 pb-10 pl-30 pr-30 bt\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información adicional\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/resume/parents.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div ng-if=\"item.data\" class=\"p-30 bb\"><div \nclass=\"mb-20\" layout=\"column\"><div class=\"h2 pl-5 pr-15 light-blue-500-fg text-capitalized\">\n{{item.data.madre_nombre}} {{item.data.madre_primer_apellido}} {{item.data.madre_segundo_apellido}}</div><div class=\"\" \nlayout=\"row\"><div class=\"h5 font-weight-500 pl-5 pr-5\">Documento de identidad:</div><div \nclass=\"h5 font-weight-300 pl-5 pr-5\">{{item.data.madre_documento}}</div></div></div><div class=\"\" layout=\"row\" \nlayout-wrap><div class=\"\" ng-repeat=\"field in item.campos\" \nng-if=\"vm.validateParentsFields(\'mom\', field) && vm.validationService.validate(item.name, item.data, field)\" \nlayout=\"row\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" \nflex-gt-lg=\"33\"><div class=\"h5 font-weight-500 pt-5 pl-5 pr-5 text-capitalized\">{{field.label}}:</div><div \nng-if=\"!vm.attachments[field.module]\" class=\"h5 font-weight-300 pt-5 pl-5 pr-5 text-capitalized\">\n{{(item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field]) | formatValue : field.type : vm.lists[field.options] : field.field : null : item.data[field.field_extra] : field.use_same_value}}\n</div><dl ng-if=\"vm.attachments[field.module][item.data._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, item.data._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][item.data._id]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span><a ng-click=\"vm.getAttachmentUrl(attach)\">\n<span class=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a>\n</div></dd></dl></div></div></div><div ng-if=\"item.data\" class=\"p-30 bb\"><div class=\"mb-20\" layout=\"column\"><div \nclass=\"h2 pl-5 pr-15 light-blue-500-fg text-capitalized\">\n{{item.data.padre_nombre}} {{item.data.padre_primer_apellido}} {{item.data.padre_segundo_apellido}}</div><div class=\"\" \nlayout=\"row\"><div class=\"h5 font-weight-500 pl-5 pr-5\">Documento de identidad:</div><div \nclass=\"h5 font-weight-300 pl-5 pr-5\">{{item.data.padre_documento}}</div></div></div><div class=\"\" layout=\"row\" \nlayout-wrap><div class=\"\" ng-repeat=\"field in item.campos\" \nng-if=\"vm.validateParentsFields(\'dad\', field) && vm.validationService.validate(item.name, item.data, field)\" \nlayout=\"row\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" \nflex-gt-lg=\"33\"><div class=\"h5 font-weight-500 pt-5 pl-5 pr-5 text-capitalized\">{{field.label}}:</div><div \nclass=\"h5 font-weight-300 pt-5 pl-5 pr-5 text-capitalized\">\n{{(item.data[field.field_text] ? item.data[field.field_text] : (item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field])) | formatValue : field.type : vm.lists[field.options]}}\n</div></div></div><div layout=\"row\" class=\"pl-5 pr-5 pt-20\" layout-align=\"end center\"><div class=\"grey-500-fg\"><span \nclass=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" ng-click=\"vm.openEditDialog($event, item)\">\nEditar</span></div></div></div><div class=\"p-30\" ng-if=\"!item.data\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div \nclass=\"text-center h3\"><span class=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span \nclass=\"grey-500-fg font-weight-300\">{{item.emptyRowsMessage}}</span></div></div><div class=\"p-10\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información padres\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/resume/personal-info.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"pt-30 pb-0 pr-30 pl-30\" layout=\"column\" \nlayout-align=\"center center\" layout-wrap><div class=\"resume-profile-picture-container w-200 h-220 cursor-pointer\" \nng-click=\"vm.openUploadProfilePictureDialog($event, item)\"><img class=\"resume-profile-picture w-200 h-220\" \ncheck-if-profile-image-exists ng-src=\"{{vm.getProfilePictureSrc(item.data.foto)}}\" \nalt=\"{{item.data.nombres}} {{item.data.primer_apellido}}\"><md-icon md-font-icon=\"icon-file-image-box\" \nclass=\"resume-profile-picture-icon\"></md-icon></div></div><div class=\"pt-30 pb-30 pl-30 pr-30\" layout=\"row\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"70\" flex-gt-md=\"70\" flex-lg=\"70\" \nflex-gt-lg=\"70\" layout-wrap><div class=\"pb-20\" layout=\"row\" layout-align-sm=\"center center\" \nlayout-align=\"start center\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"100\" \nflex-gt-md=\"100\" flex-lg=\"100\" flex-gt-lg=\"100\" layout-wrap><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\" layout-wrap><div layout=\"column\"><div \nclass=\"md-headline font-weight-200 light-blue-500-fg labe-uppercase\">\n{{item.data.nombres}} {{item.data.primer_apellido}}</div><div class=\"md-subhead\"><span class=\"font-weight-300\">\nDocumento:</span> {{item.data.cedula}}</div></div><div class=\"md-display-2 font-weight-200 light-blue-500-fg\">\n{{item.indicadores.edad}} años</div></div></div><div ng-repeat=\"info in item.campos\" \nng-if=\"info.label != \'Foto\' && vm.validationService.validate(item.name, item.data, info)\" class=\"\" layout=\"column\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\">\n<div class=\"pt-5 pb-5 pr-5\"><span class=\"h5 font-weight-500 labe-uppercase\">{{info.label}}:</span> <span \nng-if=\"!vm.attachments[info.module]\" class=\"h5 font-weight-300\">\n{{(item.data[info.field_extra] ? item.data[info.field_extra] : item.data[info.field]) | formatValue : info.type : vm.lists[info.options] : info.field : null : item.data[info.field_extra] : info.use_same_value}}\n</span><dl ng-show=\"vm.attachments[info.module].length\" ng-init=\"vm.validateAttachment(info.module)\"><dd \nclass=\"p-8 m-5 grey-300-bg b\" ng-repeat=\"attach in vm.attachments[info.module]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span><a ng-click=\"vm.getAttachmentUrl(attach)\">\n<span class=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a>\n</div></dd></dl></div></div></div></div><div ng-if=\"!vm.analyst\" class=\"pl-30 pr-30 pt-20 pb-20\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"pl-15 grey-500-fg\"><span class=\"icon-pencil\"></span> <span \nclass=\"h6 cursor-pointer text-underlined\" ng-click=\"vm.openEditDialog($event, item)\">Editar</span></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/resume/two-columns-one-row.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\"><div ng-if=\"item.text_view\">\n<div class=\"text-center h3 p-30\">{{item.text_view}}</div></div><div ng-if=\"item.data\"><div layout=\"row\" layout-wrap>\n<div ng-if=\"vm.validationService.validate(item.name, item.data, field)\" ng-repeat=\"field in item.campos\" class=\"\" \nlayout=\"column\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"50\"><div class=\"p-5\"><span class=\"h5 font-weight-500 label-two-columns\">{{field.label}}:</span> <span \nng-if=\"!vm.attachments[field.module]\" class=\"h5 font-weight-300\">\n{{(item.data[field.field_extra] ? item.data[field.field_extra] : item.data[field.field]) | formatValue : field.type : vm.lists[field.options] : field.field : null : item.data[field.field_extra] : field.use_same_value}}\n</span><dl ng-if=\"vm.attachments[field.module][item.data._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, item.data._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][item.data._id]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span><a ng-click=\"vm.getAttachmentUrl(attach)\">\n<span class=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a>\n</div></dd></dl></div></div></div><div ng-if=\"!vm.analyst\" class=\"pt-20\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"grey-500-fg\"><span class=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, item)\">Editar</span></div></div></div><div ng-if=\"!item.data\"><div \nclass=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-comment-check\" \nclass=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span class=\"grey-600-fg font-weight-400\">\nValioso consejo: </span><span class=\"grey-500-fg font-weight-300\">{{item.emptyRowsMessage}}</span></div></div></div>\n<div ng-if=\"!item.data && !vm.analyst\" layout=\"row\" layout-align=\"end center\" class=\"pt-10 pb-10 pl-30 pr-30 bt\">\n<md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/resume/two-columns.html","<div class=\"widget-group pt-20 pb-10 pl-20 pr-20 grey-200-bg\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div \nng-include=\"\'app/main/templates/resume/shared/block-alerts.html\'\"></div><div class=\"p-30\" ng-if=\"item.text_view\"><div \nclass=\"text-center h3\">{{item.text_view}}</div></div><div class=\"p-30 bb\" ng-if=\"item.data.length\" \nng-repeat=\"data in item.data\"><div layout=\"row\" layout-wrap><div ng-repeat=\"field in item.campos\" \nng-if=\"vm.validationService.validate(item.name, data, field)\" class=\"\" layout=\"column\" flex-xs=\"100\" flex-gt-xs=\"100\" \nflex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div class=\"p-5\"><span \nclass=\"h5 text-capitalized font-weight-500\">{{field.label}}:</span> <span ng-if=\"!vm.attachments[field.module]\" \nclass=\"h5 font-weight-300\">\n{{(data[field.field_extra] ? data[field.field_extra] : data[field.field]) | formatValue : field.type : vm.lists[field.options] : field.field : null : data[field.field_extra] : field.use_same_value}}\n</span><dl ng-if=\"vm.attachments[field.module][data._id].length\" \nng-init=\"vm.validateMultipleAttachment(field.module, data._id)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field.module][data._id]\"><div layout=\"row\" layout-align=\"space-between center\">\n<span class=\"h6\">{{attach.name}}</span> <a ng-click=\"vm.getAttachmentUrl(attach)\"><span \nclass=\"icon-download cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></a></div>\n</dd></dl></div></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" class=\"pl-5 pr-5 pt-20\" layout-align=\"end center\">\n<div class=\"pr-15 red-300-fg\"><span class=\"icon-trash\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openDeleteDialog($event, item, data)\">Eliminar</span></div><div class=\"grey-500-fg\"><span \nclass=\"icon-pencil\"></span> <span class=\"h6 cursor-pointer text-underlined\" \nng-click=\"vm.openEditDialog($event, vm.getBlockData(item, data))\">Editar</span></div></div></div><div class=\"p-30\" \nng-if=\"!item.data.length\"><div class=\"pl-5 pr-5 pb-10\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-comment-check\" class=\"grey-400-fg\"></md-icon></div><div class=\"text-center h3\"><span \nclass=\"grey-600-fg font-weight-400\">Valioso consejo: </span><span class=\"grey-500-fg font-weight-300\">\n{{item.emptyRowsMessage}}</span></div></div><div ng-if=\"!vm.analyst\" layout=\"row\" layout-align=\"end center\" \nclass=\"pt-10 pb-10 pl-30 pr-10 bt\"><md-button ng-click=\"vm.openAddDialog($event, item)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Agregar información\n</md-button></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"white-bg navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"80\" class=\"logo\" layout=\"row\" layout-align=\"center center\"><img src=\"{{vm.theme.principalLogo}}\" \nclass=\"nav-logo\" alt=\"logo\"></div><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><md-icon \nmd-colors=\"{color: \'primary\'}\" class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></div></md-toolbar><ms-navigation class=\"scrollable\" \nfolded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target check-if-profile-image-exists class=\"avatar\" \nng-src=\"{{vm.urlBase + \'/\' + vm.user.foto}}\"></div><span class=\"username\" hide-sm>\n{{(vm.user.nombre ? vm.user.nombre : vm.user.name) | capitalize:true}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button ng-click=\"vm.openChangePasswordDialog()\">\nCambiar contraseña</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Cerrar sesión</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button \nclass=\"md-icon-button\" layout=\"row\" ng-href=\"{{vm.urlHelp}}\" target=\"_blank\" aria-label=\"Help\"><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"icon\"></md-icon><md-tooltip md-direction=\"left\">Ayuda</md-tooltip></md-button>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img src=\"{{vm.theme.principalLogo}}\" alt=\"logo\"></div><div \nclass=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target \ncheck-if-profile-image-exists class=\"avatar\" src=\"{{vm.user.foto}}\"></div><span class=\"username\" hide-sm>\n{{vm.user.nombre | capitalize:true}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button ng-click=\"vm.openChangePasswordDialog()\">\nCambiar contraseña</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Cerrar sesión</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <div class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n           \n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n             <span class=\"title width-100-p no-nowrap\" translate=\"{{node.translate}}\" flex>{{node.title}} </span> \n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/admin/admin/dashboard/admin-dashboard.html","<div class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div class=\"white-bg\">\n<div class=\"widget-group p-30\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-xs=\"100\" flex-gt-xs=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"25\" flex-gt-lg=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pt-40 pb-20\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"green-600-fg font-size-60 line-height-60\">{{vm.report.aprobados}}</div><div \nclass=\"h5 secondary-text font-weight-500 m-5\"></div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 secondary-text\">REQUISICIONES APROBADAS</span></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"25\" flex-gt-lg=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pt-40 pb-20\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"blue-600-fg font-size-60 line-height-60\">{{vm.report.proceso}}\n</div><div class=\"h5 secondary-text font-weight-500 m-5\"></div></div><div \nclass=\"p-16 grey-50-bg border-top ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 secondary-text text-truncate ng-binding\">REQUISICIONES EN PROCESO</span>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" \nflex-gt-xs=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"25\" flex-gt-lg=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pt-40 pb-20\" layout=\"column\" layout-align=\"center center\"><div class=\"red-600-fg font-size-60 line-height-60\">\n{{vm.report.rechazados}}</div><div class=\"h5 secondary-text font-weight-500 m-5\"></div></div><div \nclass=\"p-16 grey-50-bg border-top ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 secondary-text text-truncate ng-binding\">REQUISICIONES RECHAZADAS</span>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" \nflex-gt-xs=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"25\" flex-gt-lg=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pt-30 pb-20\" layout=\"column\" layout-align=\"center center\"><div><div \nclass=\"blue-grey-600-fg font-size-60 line-height-60\">{{vm.report.dias_promedio_aprobacion}}</div><div \nclass=\"h5 secondary-text font-weight-500\">Día<span \nng-if=\"vm.report.dias_promedio_aprobacion == 0 || vm.report.dias_promedio_aprobacion > 1\">s</span></div></div></div>\n<div class=\"p-16 grey-50-bg border-top ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"h4 secondary-text text-truncate ng-binding\">TIEMPO PROMEDIO DE APROBACIÓN\n</span></div></ms-widget-front></ms-widget></div></div><div class=\"grey-50-bg\" layout=\"row\" layout-wrap><div \nclass=\"m-10 p-30 all-width\"><div class=\"bb\" layout=\"row\" flex=\"100\" layout-align=\"space-between center\"><div \nclass=\"h2 grey-500-fg font-weight-300\">Gestión de requisciones por mes</div></div><div class=\"pt-40\"><canvas id=\"bar\" \nclass=\"chart chart-bar\" chart-data=\"vm.barChart.data\" chart-dataset-override=\"vm.barChart.datasetOverride\" \nchart-labels=\"vm.barChart.labels\" chart-series=\"vm.barChart.series\" chart-options=\"vm.barChart.options\"></canvas></div>\n</div></div><div class=\"grey-50-bg\" layout=\"row\" layout-wrap><div flex-xs=\"100\" flex-gt-xs=\"100\" flex-md=\"100\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" layout-wrap><div class=\"m-10 pl-30\"><ms-widget flippable=\"false\">\n<ms-widget-front class=\"white-bg\"><div md-colors=\"{background: \'accent\'}\" class=\"ph-16 pv-24 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\nTipos de solicitudes creadas</span></div></div><div ng-if=\"vm.report.tipos_solicitud.length\" \nng-repeat=\"request in vm.report.tipos_solicitud | orderBy: \'-total\'\" class=\"ph-16 pv-15 border-bottom\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"h4 text-bold\" flex>{{request.nombre}}</div><div \nclass=\"h4 font-weight-500 secondary-text\">{{request.total}}</div></div><div class=\"p-15\" \nng-if=\"!vm.report.tipos_solicitud.length\">No se encontró información con el año/periodo seleccionado.</div>\n</ms-widget-front></ms-widget></div></div><div flex-xs=\"100\" flex-gt-xs=\"100\" flex-md=\"100\" flex-gt-md=\"50\" \nflex-lg=\"50\" flex-gt-lg=\"50\" layout-wrap><div class=\"m-10 pr-30\"><ms-widget flippable=\"false\"><ms-widget-front \nclass=\"white-bg\"><div md-colors=\"{background: \'accent\'}\" class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">\nTiempo promedio de respuesta por responsable</span></div></div><div ng-if=\"vm.report.dias_promedio_por_rol.length\" \nng-repeat=\"rol in vm.report.dias_promedio_por_rol\" class=\"ph-16 pv-15 border-bottom\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"h4 text-bold\" flex>{{rol.rol_name}}</div><div \nclass=\"h4 font-weight-500 secondary-text\">{{rol.promedio}}</div></div><div class=\"p-15\" \nng-if=\"!vm.report.dias_promedio_por_rol.length\">No se encontró información con el año/periodo seleccionado.</div>\n</ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/admin/admin/requests/requests.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content p-30\"><div ng-if=\"vm.loading\" layout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"grey-200-bg\">\n<div class=\"pl-25 pr-25 pt-15 pb-15 h2\">Cargando información por favor espere...</div></div><div ng-if=\"!vm.loading\" \nclass=\"white-bg md-whiteframe-4dp\"><filter-lista filters=\"vm.filters\" callbacksenddata=\"vm.callbackSendData(filter)\" \ncallbackcleardata=\"vm.clearFilter()\" filtersdata=\"vm.filtersData\"></filter-lista><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead \nclass=\"\"><tr><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span \nclass=\"column-title\">Código</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div \nclass=\"table-header\"><span class=\"column-title\">Cargo</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">Solicitante</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">\nFecha de solicitud</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div \nclass=\"table-header\"><span class=\"column-title\">Vacantes</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">Tipo de solicitud</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Estado requisicion</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Estado proceso</span></div>\n</th></tr></thead><tbody><tr ng-init=\"color = {\'background-color\': request.estado_color}\" \nng-repeat=\"request in vm.requests\"><td class=\"\"><a href=\"/show-admin-request/{{request.id}}\">{{request.codigo}}</a>\n</td><td class=\"\"><div layout=\"column\"><a href=\"/show-admin-request/{{request.id}}\">{{ request.cargo_ocupar }} </a>\n<span class=\"h6 font-weight-600\">{{request.ciudad_trabajo}} </span><span class=\"h6 font-weight-600\">\nOcupantes: {{request.info_ocupante_nombres}}</span></div></td><td class=\"\">{{ request.colaborador | capitalize: true}}\n</td><td class=\"grey-50-bg text-center\">{{ request.fecha_solicitud | fecha: \'DD/MMMM/YYYY\'}}</td><td \nclass=\"grey-50-bg text-center\">{{ request.no_vacantes }}</td><td>{{ request.tipo_solicitud_label }} <span \nng-if=\"request.extra.tipo_solicitudes.length\" class=\"grey-fg\">({{ request.extra.tipo_solicitudes | join: \', \'}})</span>\n</td><td class=\"grey-50-bg text-center\"><span ng-style=\"{\'background-color\':request.estado_aprobacion_color}\" \nclass=\"text-boxed radius-15 white-fg h6 no-margin font-weight-200\">{{request.estado_aprobacion_label}}</span></td><td \nclass=\"text-center\"><span ng-style=\"{\'background-color\':request.estado_proceso.color}\" \nclass=\"text-boxed radius-15 white-fg h6 no-margin font-weight-200\">{{request.estado_proceso.estado}}</span></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/admin/admin/show-request/show-request.html","<div id=\"big-sidebar\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/templates/header/default.html\'\"></div><div ng-if=\"vm.loading\" \nclass=\"m-15 pl-25 pr-25 pt-15 pb-15 all-width grey-200-bg\"><span class=\"h4\">Cargando información por favor espere...\n</span></div><div ng-if=\"!vm.loading && vm.blocks.length\" class=\"p-15\"><div \nng-include=\"\'app/main/admin/admin/show-request/partials/content.html\'\"></div><div \nng-include=\"\'app/main/admin/approver/show-request/partials/observations.html\'\"></div></div></div><md-sidenav \nng-if=\"!vm.loading && vm.blocks.length\" class=\"sidenav md-sidenav-right no-margin no-padding b\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/admin/requester/show-request/partials/sidebar.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/admin/admin/update-request/update-request.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nng-include=\"\'app/main/templates/header/default.html\'\"></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><div ng-if=\"vm.loading\" class=\"m-15 pl-25 pr-25 pt-15 pb-15 all-width grey-200-bg\"><span \nclass=\"h4\">Cargando información por favor espere...</span></div><div ng-if=\"!vm.loading && vm.blocks.length\" \nclass=\"main scrollable\" ms-scroll><div ng-repeat=\"block in vm.blocks\"><div \nng-include=\"\'app/main/templates/request/blocks/update/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div></div><div\n ng-include=\"\'app/main/admin/approver/show-request/partials/observations.html\'\"></div><div layout=\"row\" flex=\"100\" \nclass=\"pb-15\" layout-align=\"center center\" layout-wrap><div class=\"p-5\"><md-button \nng-href=\"/show-admin-request/{{vm.id}}\" \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Cancelar</md-button></div></div></div>\n</div><md-button ng-if=\"!vm.loading && vm.blocks.length\" class=\"md-fab md-warn md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.save()\" ng-disabled=\"!vm.change || vm.saving\" aria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon></md-button></div>");
$templateCache.put("app/main/admin/admin/update-rol-aprobadores/update-rol-aprobadores.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content p-30\"><table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\"><thead class=\"\"><tr><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div \nclass=\"table-header\"><span class=\"column-title\">Rol</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"white-fg b\"></th></tr></thead><tbody><tr ng-init=\"color = {\'background-color\': request.estado_color}\" \nng-repeat=\"rol in vm.roles\"><td class=\"\">{{ rol.label }}</td><td class=\"\"><a href=\"\" ng-click=\"vm.update(rol)\">\nActualizar nombre</a></td></tr></tbody></table></div></div><modal title=\"Update Form\" visible=\"vm.showModal\"></modal>");
$templateCache.put("app/main/admin/admin/update-tiempos/update-tiempos.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content p-30\"><table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\"><thead class=\"\"><tr><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div \nclass=\"table-header\"><span class=\"column-title\">Rol Aprobador</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">Tiempo Objetivo (Horas)</span></div></th></tr>\n</thead><tbody><tr ng-init=\"color = {\'background-color\': request.estado_color}\" ng-repeat=\"rol in vm.roles\"><td \nclass=\"\">{{ rol.rol_aprobador.label }}</td><td class=\"\">{{ rol.horas }}<br><a href=\"\" ng-click=\"vm.update(rol)\">\nActualizar</a></td></tr></tbody></table></div></div><modal title=\"Update Form\" visible=\"vm.showModal\"></modal>");
$templateCache.put("app/main/admin/admin/upload-structures/upload-structures.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content p-30\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" class=\"pt-30 pl-30\"><span \nclass=\"cursor-pointer text-underlined\" md-colors=\"{color: \'accent\'}\" ng-click=\"vm.get_base_cargos()\">\nDescargar plantilla de cargos</span></div><div layout=\"row\" class=\"bb filtro_fechas\" layout-align=\"start center\" \nlayout-wrap flex=\"100\" layout-wrap><div layout=\"column\" layout-align=\"center start\" class=\"p-30\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"100\" flex-gt-md=\"100\" flex-lg=\"50\" flex-gt-lg=\"50\"><div><span \nclass=\"font-weight-400 h4\">Cargar estructuras</span></div><div md-colors=\"{color: \'accent\'}\"><input id=\"file\" \nname=\"file\" type=\"file\" onchange=\"angular.element(this).scope().onFileChange(this,\'structures\')\"><md-button \naria-label=\"Cargar\" class=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.uploadStructures()\" ng-disabled=\"!vm.file.structures || vm.loading.structures\">\n{{ vm.loading.structures ? \'Enviándo archivo..\' : \'Cargar\' }}</md-button></div></div><div layout=\"column\" \nlayout-align=\"center start\" class=\"p-30\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"100\" \nflex-gt-md=\"100\" flex-lg=\"50\" flex-gt-lg=\"50\"><div><span class=\"font-weight-400 h4\">Cargar cargos</span></div><div \nmd-colors=\"{color: \'accent\'}\"><input id=\"file\" name=\"file\" type=\"file\" \nonchange=\"angular.element(this).scope().onFileChange(this,\'charge\')\"><md-button aria-label=\"Cargar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.uploadCharge()\" \nng-disabled=\"!vm.file.charge || vm.loading.charge\">{{ vm.loading.charge ? \'Enviándo archivo..\' : \'Cargar\' }}\n</md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/admin/analyst/create/createanalyst.html","<div id=\"createAnalyst\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div>\n<div class=\"content p-30\" layout=\"column\"><div layout=\"row\" layout-align=\"end center\" class=\"mb-10\"><md-button \nng-click=\"vm.returnDashboard()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Regresar</md-button>\n</div><form name=\"analystForm\" novalidate ng-submit=\"analystForm.$valid &&  vm.createAnalyst()\"><div \nclass=\"md-whiteframe-4dp white-bg p-30\" layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-align-xs=\"center \" layout-align-xs-gt=\"center \" layout-align-sm=\"center \" layout-sm=\"column\" layout-xs=\"column\" \nlayout-xs-gt=\"column\" flex=\"100\" layout-wrap><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-xs-gt=\"100\" \nflex-sm-gt=\"100\"><md-input-container class=\"all-width\"><md-checkbox ng-model=\"vm.data.is_boss\" aria-label=\"¿es jefe?\">\nEs jefe</md-checkbox></md-input-container></div><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-xs-gt=\"100\" \nflex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>\nDocumento de identidad</label></div><input type=\"number\" ng-model=\"vm.data.cedula\"></md-input-container></div></div>\n<div layout=\"row\" layout-align=\"space-between center\" layout-align-xs=\"center \" layout-align-xs-gt=\"center \" \nlayout-align-sm=\"center \" layout-sm=\"column\" layout-xs=\"column\" layout-xs-gt=\"column\" flex=\"100\" layout-wrap><div \nflex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Nombre</label></div><input type=\"text\" ng-model=\"vm.data.name\" name=\"name\" \nrequired><div ng-messages=\"analystForm.name.$error\"><div ng-message=\"required\">El nombre es obligatorio</div></div>\n</md-input-container></div><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-xs-gt=\"100\" flex-sm-gt=\"100\">\n<md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>Teléfono</label></div><input \ntype=\"number\" ng-model=\"vm.data.phone\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-align-xs=\"center \" layout-align-xs-gt=\"center \" layout-align-sm=\"center \" \nlayout-sm=\"column\" layout-xs=\"column\" layout-xs-gt=\"column\" flex=\"100\" layout-wrap><div flex=\"50\" flex-sm=\"100\" \nflex-xs=\"100\" flex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Correo</label></div><input type=\"email\" ng-model=\"vm.data.email\" \nname=\"email\" required ng-pattern=\"/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,10}$/\"><div \nng-messages=\"analystForm.email.$error\"><div ng-message=\"required\">El correo es obligatorio</div><div \nng-message=\"pattern\">El correo no es valido</div></div></md-input-container></div><div flex=\"50\" flex-sm=\"100\" \nflex-xs=\"100\" flex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Contraseña</label></div><input type=\"password\" ng-model=\"vm.data.password\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"space-between center\" layout-align-xs=\"center \" \nlayout-align-xs-gt=\"center \" layout-align-sm=\"center \" layout-sm=\"column\" layout-xs=\"column\" layout-xs-gt=\"column\" \nflex=\"100\" layout-wrap><div ng-if=\"!vm.data.is_boss\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-xs-gt=\"100\" \nflex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>Jefe</label>\n</div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.parent\" class=\"\"><md-option value=\"0\">Ninguno\n</md-option><md-option ng-repeat=\"data in vm.analystsBoss track by $index\" ng-value=\"data.id\">{{data.name}}</md-option>\n</md-select></md-input-container></div><div ng-if=\"vm.data.is_boss\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" \nflex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>\nEmpresa</label></div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.companies\" class=\"\" \nmultiple=\"multiple\"><md-option ng-repeat=\"companie in vm.misc.companies track by $index\" ng-value=\"companie.id\">\n{{companie.name}}</md-option></md-select></md-input-container></div><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" \nflex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width padding-top-25\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Area</label></div><textarea ng-model=\"vm.data.area\" md-maxlength=\"1500\" \nrows=\"1\"></textarea></md-input-container></div></div><div ng-if=\"!vm.data.is_boss\" layout=\"row\" \nlayout-align=\"space-between center\" layout-align-xs=\"center \" layout-align-xs-gt=\"center \" layout-align-sm=\"center \" \nlayout-sm=\"column\" layout-xs=\"column\" layout-xs-gt=\"column\" flex=\"100\" layout-wrap><div flex=\"50\" flex-sm=\"100\" \nflex-xs=\"100\" flex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Empresa</label></div><md-select aria-label=\"Seleccionar Etapa\" \nng-model=\"vm.data.companies\" class=\"\" multiple=\"multiple\"><md-option \nng-repeat=\"companie in vm.misc.companies track by $index\" ng-value=\"companie.id\">{{companie.name}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" class=\"m-10\"><md-button \ntype=\"submit\" ng-disabled=\"analystForm.$invalid\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Guardar</md-button></div>\n</div></form></div></div>");
$templateCache.put("app/main/admin/analyst/dashboard/dashboard.html","<div id=\"dashboardAnalyst\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div>\n<filter-lista filters=\"vm.filters\" callbacksenddata=\"vm.callbackSendData(filter)\" callbackcleardata=\"vm.clearFilter()\">\n</filter-lista><div class=\"content p-30\"><div ng-if=\"vm.loading\" \nclass=\"p-30 md-title text-center md-whiteframe-4dp white-bg\">Cargando contenido, por favor espere...</div><div \nng-if=\"!vm.loading\" class=\"main scrollable\" ms-scroll><div layout=\"column\" flex=\"100\" layout-align=\"start\"><div \nlayout=\"row\" layout-align=\"end center\" class=\"mb-10\"><md-button type=\"submit\" \nng-click=\"vm.goState(\'app.create_analyst\')\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Crear analista\n</md-button></div><div class=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" layout=\"row\"><table \nclass=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Nombre</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">ID</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div\n class=\"table-header\"><span class=\"column-title white-fg\">Correo</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Jefe</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Empresa(s)</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Area(s)</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Telefono</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Opciones</span></div></th></tr></thead><tbody><tr ng-repeat=\"analyst in vm.analysts\"><td \nclass=\"\"><span class=\"font-weight-500 cursor-pointer\" ng-click=\"vm.goState(\'app.update_analyst\',{id:analyst.id})\">\n{{analyst.name | capitalize:true}}</span></td><td class=\"grey-100-bg text-center\"><span class=\"cursor-pointer\" \nng-click=\"vm.goState(\'app.update_analyst\',{id:analyst.id})\">{{analyst.cedula}}</span></td><td><span>{{analyst.email}}\n</span></td><td class=\"grey-100-bg text-center\">{{analyst.boss | capitalize:true}}</td><td><div \nng-repeat=\"companie in analyst.companies\" layout=\"column\">{{companie.name | capitalize:true}}</div></td><td \nclass=\"grey-100-bg w-200\">{{analyst.area}}</td><td class=\"text-center\">{{analyst.phone}}</td><td \nclass=\"text-center grey-100-bg\"><md-button ng-click=\"vm.goState(\'app.update_analyst\',{id:analyst.id})\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Editar</md-button>\n<md-button ng-if=\"!analyst.status\" ng-click=\"vm.showDialogActive($event,analyst,$index)\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Activar</md-button>\n<md-button ng-if=\"analyst.status\" ng-click=\"vm.showDialogDeactive($event,analyst,$index)\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Desactivar</md-button>\n</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/admin/analyst/update/update.html","<div id=\"updateAnalyst\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div>\n<div class=\"content p-30\" layout=\"column\"><div layout=\"row\" layout-align=\"end center\" class=\"mb-10\"><md-button \nng-click=\"vm.returnDashboard()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Regresar</md-button>\n</div><form name=\"analystForm\" novalidate ng-submit=\"analystForm.$valid &&  vm.updateAnalyst()\"><div \nclass=\"md-whiteframe-4dp white-bg p-30\" layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-align-xs=\"center \" layout-align-xs-gt=\"center \" layout-align-sm=\"center \" layout-sm=\"column\" layout-xs=\"column\" \nlayout-xs-gt=\"column\" flex=\"100\" layout-wrap><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-xs-gt=\"100\" \nflex-sm-gt=\"100\"><md-input-container class=\"all-width\"><md-checkbox ng-model=\"vm.data.is_boss\" aria-label=\"¿es jefe?\">\nEs jefe</md-checkbox></md-input-container></div><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-xs-gt=\"100\" \nflex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>\nDocumento de identidad</label></div><input type=\"number\" ng-model=\"vm.data.cedula\"></md-input-container></div></div>\n<div layout=\"row\" layout-align=\"space-between center\" layout-align-xs=\"center \" layout-align-xs-gt=\"center \" \nlayout-align-sm=\"center \" layout-sm=\"column\" layout-xs=\"column\" layout-xs-gt=\"column\" flex=\"100\" layout-wrap><div \nflex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Nombre</label></div><input type=\"text\" ng-model=\"vm.data.name\" name=\"name\" \nrequired><div ng-messages=\"analystForm.name.$error\"><div ng-message=\"required\">El nombre es obligatorio</div></div>\n</md-input-container></div><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-xs-gt=\"100\" flex-sm-gt=\"100\">\n<md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>Teléfono</label></div><input \ntype=\"number\" ng-model=\"vm.data.phone\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-align-xs=\"center \" layout-align-xs-gt=\"center \" layout-align-sm=\"center \" \nlayout-sm=\"column\" layout-xs=\"column\" layout-xs-gt=\"column\" flex=\"100\" layout-wrap><div flex=\"50\" flex-sm=\"100\" \nflex-xs=\"100\" flex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Correo</label></div><input type=\"email\" ng-model=\"vm.data.email\" \nname=\"email\" required ng-pattern=\"/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,10}$/\"><div \nng-messages=\"analystForm.email.$error\"><div ng-message=\"required\">El correo es obligatorio</div><div \nng-message=\"pattern\">El correo no es valido</div></div></md-input-container></div><div flex=\"50\" flex-sm=\"100\" \nflex-xs=\"100\" flex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Contraseña</label></div><input type=\"password\" ng-model=\"vm.data.password\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"space-between center\" layout-align-xs=\"center \" \nlayout-align-xs-gt=\"center \" layout-align-sm=\"center \" layout-sm=\"column\" layout-xs=\"column\" layout-xs-gt=\"column\" \nflex=\"100\" layout-wrap><div ng-if=\"!vm.data.is_boss\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" flex-xs-gt=\"100\" \nflex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>Jefe</label>\n</div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.parent\" class=\"\"><md-option value=\"0\">Ninguno\n</md-option><md-option ng-repeat=\"data in vm.analystsBoss track by $index\" ng-value=\"data.id\">{{data.name}}</md-option>\n</md-select></md-input-container></div><div ng-if=\"vm.data.is_boss\" flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" \nflex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>\nEmpresa</label></div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.companies\" class=\"\" \nmultiple=\"multiple\"><md-option ng-repeat=\"companie in vm.misc.companies track by $index\" ng-value=\"companie.id\">\n{{companie.name}}</md-option></md-select></md-input-container></div><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" \nflex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width padding-top-25\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Area</label></div><textarea ng-model=\"vm.data.area\" md-maxlength=\"1500\" \nrows=\"1\"></textarea></md-input-container></div></div><div ng-if=\"!vm.data.is_boss\" layout=\"row\" \nlayout-align=\"space-between center\" layout-align-xs=\"center \" layout-align-xs-gt=\"center \" layout-align-sm=\"center \" \nlayout-sm=\"column\" layout-xs=\"column\" layout-xs-gt=\"column\" flex=\"100\" layout-wrap><div flex=\"50\" flex-sm=\"100\" \nflex-xs=\"100\" flex-xs-gt=\"100\" flex-sm-gt=\"100\"><md-input-container class=\"all-width\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Empresa</label></div><md-select aria-label=\"Seleccionar Etapa\" \nng-model=\"vm.data.companies\" class=\"\" multiple=\"multiple\"><md-option \nng-repeat=\"companie in vm.misc.companies track by $index\" ng-value=\"companie.id\">{{companie.name}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" class=\"m-10\"><md-button \ntype=\"submit\" ng-disabled=\"analystForm.$invalid\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Guardar</md-button></div>\n</div></form></div></div>");
$templateCache.put("app/main/admin/approver/requests/requests.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content p-30\"><div ng-if=\"vm.loading\" layout=\"row\" flex=\"100\" layout-align=\"start center\" class=\"grey-200-bg\">\n<div class=\"pl-25 pr-25 pt-15 pb-15 h4\">Cargando información por favor espere...</div></div><div ng-if=\"!vm.loading\" \nclass=\"white-bg md-whiteframe-4dp\"><filter-lista filters=\"vm.filters\" callbacksenddata=\"vm.callbackSendData(filter)\" \ncallbackcleardata=\"vm.clearFilter()\" filtersdata=\"vm.filtersData\"></filter-lista><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead \nclass=\"\"><tr><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Código</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Cargo</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Fecha de solicitud</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Solicitante</span></div></th>\n<th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Vacantes</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Tipo de solicitud</span></div>\n</th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Estado requisicion</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Estado proceso</span></div>\n</th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\" ng-if=\"vm.showAprobationTime\"><div \nclass=\"table-header\"><span class=\"column-title white-fg\">Tiempo objetivo de aprobación</span></div></th></tr></thead>\n<tbody><tr ng-init=\"color = {\'background-color\': request.estado_color}\" ng-repeat=\"request in vm.requests\"><td \nclass=\"grey-50-bg\"><a href=\"/show-approver-request/{{request.id}}\">{{request.codigo}}</a></td><td class=\"\"><div \nlayout=\"column\"><a href=\"/show-approver-request/{{request.id}}\">{{ request.cargo_ocupar }} </a><span \nclass=\"h6 font-weight-600\">{{request.ciudad_trabajo}} </span><span class=\"h6 font-weight-600\">\nOcupantes: {{request.info_ocupante_nombres}}</span></div></td><td class=\"grey-50-bg text-center\">\n{{ request.fecha_solicitud | fecha: \'DD/MMMM/YYYY\'}}</td><td class=\"\">{{ request.colaborador | capitalize: true}}</td>\n<td class=\"grey-50-bg text-center\">{{ request.no_vacantes }}</td><td class=\"\">{{ request.tipo_solicitud_label }} <span \nng-if=\"request.extra.tipo_solicitudes.length\" class=\"grey-fg\">({{ request.extra.tipo_solicitudes | join: \', \'}})</span>\n</td><td class=\"grey-50-bg text-center\"><span ng-style=\"{\'background-color\':request.estado_aprobacion_color}\" \nclass=\"text-boxed radius-15 white-fg h6 no-margin font-weight-200\">{{request.estado_aprobacion_label}}</span></td><td \nclass=\"text-center\"><span ng-style=\"{\'background-color\':request.estado_proceso.color}\" \nclass=\"text-boxed radius-15 white-fg h6 no-margin font-weight-200\">{{request.estado_proceso.estado}}</span></td><td \nclass=\"text-center\" ng-if=\"vm.showAprobationTime\"><div ng-bind-html=\"vm.infoTiempo(request.limite_aprobacion)\"></div>\n</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/approver/show-request/show-request.html","<div id=\"big-sidebar\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/templates/header/default.html\'\"></div><div ng-if=\"vm.loading\" \nclass=\"m-30 pl-25 pr-25 pt-15 pb-15 grey-200-bg all-width\"><span class=\"h4\">Cargando información por favor espere...\n</span></div><div ng-if=\"!vm.loading && vm.blocks.length\" class=\"p-15\"><div \nng-include=\"\'app/main/admin/approver/show-request/partials/content.html\'\"></div><div \nng-include=\"\'app/main/admin/approver/show-request/partials/observations.html\'\"></div></div></div><md-sidenav \nng-if=\"!vm.loading && vm.blocks.length\" class=\"sidenav md-sidenav-right no-margin no-padding b\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/admin/requester/show-request/partials/sidebar.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/admin/approver/understanding/understanding-position.html","<div id=\"understanding-charge\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header white-fg h-300 office-background p-24\" layout=\"column\" layout-align=\"space-between\" layout-wrap><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"\" layout=\"row\" layout-align=\"start start\"><md-icon \nng-if=\"vm.pageInfo.icon\" md-font-icon=\"{{vm.pageInfo.icon}}\" class=\"h4\"></md-icon><div ng-if=\"vm.pageInfo.icon\" \nng-repeat=\"parent in vm.pageInfo.parents\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"separator h3\"></md-icon>\n<span class=\"h6 parent white-text\">{{parent}}</span></div></div></div><div layout=\"column\" \nlayout-align=\"space-between\" hide-xs hide-sm><div layout-align-xs=\"space-between\" layout-align-sm=\"space-between\" \nlayout-align-md=\"space-between center\" layout-align-lg=\"space-between center\" layout-align-xl=\"space-between\" \nlayout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" \nlayout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" class=\"mb-10\"><div layout=\"row\" layout-align=\"space-between\"><div>\n<span class=\"blue-300-fg font-weight-300 md-display-1\">{{vm.request.cod}}</span></div><div><span \nclass=\"pl-10 pr-10 font-weight-300 md-display-1\">|</span></div><div><span class=\"md-display-1\">\n{{vm.request.name | capitalize:true}}</span></div></div><div layout=\"column\" layout-align=\"between\"><span \nclass=\"h3 white-fg\">Estado del entendimiento: <span class=\"h3 font-weight-400 orange-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'No enviado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 blue-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Enviado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 red-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Rechazado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span><span \nclass=\"h3 font-weight-400 light-green-300-fg\" \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Aprobado\'\">\n{{vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion}} </span></span><span \nclass=\"md-display-1 font-weight-400\" ng-style=\"{\'color\':vm.request.color_status_publish}\">\n{{vm.request.status_publish}} &nbsp;</span></div><div layout=\"row\" layout-align=\"end center\"><i \nclass=\"s20 icon-account-circle mr-10\"></i> <span class=\"h4\">{{vm.request.count_vacant}} VACANTE <span class=\"h4\" \nng-if=\"vm.request.count_vacant > 1\">S</span></span></div></div><div class=\"h3 subtitle secondary-text mb-10\">\n{{vm.request.state | capitalize:true}}</div><div layout=\"row\" layout-align=\"start\" class=\"mb-10\"><div \nclass=\"h4 font-weight-500 pr-5\">Solicitante:</div><div class=\"h4\">{{vm.request.applicant | capitalize:true}} <span \nng-if=\"vm.request.applicant_from\">({{vm.request.applicant_from}})</span></div></div><div layout=\"row\" \nlayout-align=\"start\" class=\"mb-10\"><div class=\"h4 font-weight-500 pr-5\">Fecha de solicitud:</div><div class=\"h4\">\n{{vm.request.date_request_format | capitalize:true}} <span ng-if=\"vm.request.date_request_compared_string\">\n({{vm.request.date_request_compared_string}})</span></div></div></div><div layout=\"column\" layout-align=\"center\" \nhide-md hide-lg hide-xl><div class=\"text-light\" layout-align-xs=\"space-between\" layout-align-sm=\"space-between\" \nlayout-align-md=\"space-between\" layout-align-lg=\"space-between\" layout-align-xl=\"space-between\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\"><div><span class=\"blue-300-fg font-weight-300 md-display-1\" hide-xs hide-sm>\n{{vm.request.cod}}</span> <span class=\"blue-300-fg font-weight-300 md-title\" hide-md hide-lg hide-xl>{{vm.request.cod}}\n</span></div><div><span class=\"pl-10 pr-10 font-weight-300 md-display-1\" hide-xs hide-sm>|</span></div><div \nlayout=\"row\" layout-align=\"space-between\"><span class=\"md-display-1\" hide-xs hide-sm>\n{{vm.request.name | capitalize:true}}</span> <span class=\"md-title\" hide-md hide-lg hide-xl>\n{{vm.request.name | capitalize:true}}</span></div></div><div class=\"h4 subtitle secondary-text\">\n{{vm.request.state | capitalize:true}}</div></div></div><div class=\"content\"><div ng-if=\"vm.loading\" \nclass=\"p-30 md-title text-center\">Cargando contenido, por favor espere...</div><div id=\"request\" \nclass=\"main scrollable p-7\" ms-scroll><div ng-repeat=\"block in vm.blocks\"><div \nng-include=\"\'app/main/templates/request/blocks/read/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div></div><div \nlayout=\"row\" class=\"pb-15\" layout-align=\"center center\" layout-wrap \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion != \'Rechazado\' && vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion != \'Aprobado\'\">\n<div class=\"p-5\"><md-button ng-click=\"vm.sendApprove(0)\" \nclass=\"md-raised red-500-bg h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg all-width\" \naria-label=\"Guardar\">Rechazar</md-button></div><div class=\"p-5\"><md-button ng-click=\"vm.sendApprove(1)\" \nclass=\"md-raised light-green-500-bg h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg all-width\" \naria-label=\"Guardar y aprobar\">Aprobar</md-button></div></div></div></div></div>");
$templateCache.put("app/main/admin/approver/update-request/update-request.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nng-include=\"\'app/main/templates/header/default.html\'\"></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><div ng-if=\"vm.loading\" class=\"m-15 pl-25 pr-25 pt-15 pb-15 all-width grey-200-bg\"><span \nclass=\"h4\">Cargando información por favor espere...</span></div><div id=\"request\" \nng-if=\"!vm.loading && vm.blocks.length\" class=\"main scrollable\" ms-scroll><div \nmd-colors=\"{\'background-color\' : \'warn\'}\" class=\"m-15 p-15 white-fg md-hue-2\"><span class=\"icon-alert\"></span> <span \nclass=\"pl-5\">Recuerde que los campos con asterico (*) son obligatorios</span></div><div ng-repeat=\"block in vm.blocks\">\n<div ng-include=\"\'app/main/templates/request/blocks/update/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div>\n</div><div ng-include=\"\'app/main/admin/approver/show-request/partials/observations.html\'\"></div><div layout=\"row\" \nflex=\"100\" class=\"pb-15\" layout-align=\"center center\" layout-wrap><div class=\"p-5\"><md-button \nng-href=\"/show-approver-request/{{vm.id}}\" \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\" ng-if=\"!vm.change || vm.saving || vm.data.options.aprobar\"><md-button ng-click=\"vm.save(true)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Guardar y aprobar\n</md-button></div><div class=\"p-5\" ng-if=\"!vm.change || vm.saving || vm.data.options.rechazar\"><md-button \nng-click=\"vm.saveAndDismiss()\" \nclass=\"md-raised red-bg white-fg h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">\nGuardar y rechazar</md-button></div></div></div></div><md-button ng-if=\"!vm.loading && vm.blocks.length\" \nclass=\"md-fab md-warn md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.save()\" \nng-disabled=\"!vm.change || vm.saving\" aria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/admin/collaborators/collaborators/collaborator.html","<div id=\"collaboratorDetail\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\">\n</div><div class=\"content\" ng-if=\"!vm.loading\"><div class=\"m-30\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"mb-10\"><md-button ng-click=\"vm.pageCollaborators()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Regresar</md-button>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"vm.existsAttchments\" \nng-click=\"vm.saveReportForToclientFn()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Descargar adjuntos</md-button>\n<md-button ng-if=\"vm.hv_license.es_colaborador\" ng-click=\"vm.removeCollaborator()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Retirar colaborador</md-button>\n<md-button ng-if=\"!vm.hv_license.es_colaborador\" ng-click=\"vm.selectedCollaborator()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Seleccionar colaborador\n</md-button><md-button ng-click=\"vm.downloadPDF()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Descargar hoja de vida\n<md-icon md-font-icon=\"icon-download\"></md-icon></md-button></div><div layout=\"column\" class=\"containerPorc\"><div \nlayout=\"row\" layout-align=\"end center\"><span class=\"h2 font-weight-300\" md-colors=\"{color:\'accent\'}\">{{vm.porcHv}}%\n</span></div><div layout=\"column\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.porcHv}}\"></md-progress-linear>\n<span class=\"h4 font-weight-500\">Estado hoja de vida</span></div></div></div><div><div ng-repeat=\"block in vm.blocks\" \nng-if=\"!vm.showReporrForTheClient && !vm.showStageSelected\" class=\"report-for-client\"><div \nng-if=\"block.name == \'personales\' && true\" ng-include=\"\'app/main/templates/resume/personal-info.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'perfil\'\" \nng-include=\"\'app/main/templates/resume/one-column-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'experiencia\'\" ng-include=\"\'app/main/templates/resume/laboral-experience.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'estudios_formales\'\" \nng-include=\"\'app/main/templates/resume/formal-study.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'estudios_no_formales\'\" ng-include=\"\'app/main/templates/resume/non-formal-study.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'laboral\'\" \nng-include=\"\'app/main/templates/resume/one-column-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'contacto_emergencia\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'idiomas\'\" \nng-include=\"\'app/main/templates/resume/languages.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'grupo_familiar\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'hijos\'\" \nng-include=\"\'app/main/templates/resume/childrens.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'madre\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'padre\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'conyuge\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'viven_usted\'\" \nng-include=\"\'app/main/templates/resume/two-columns.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'vivienda\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'contacto\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'salud\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'adicional\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div></div></div><div \nng-if=\"vm.loading\" class=\"p-30 md-title text-center\">Cargando contenido, por favor espere...</div></div></div>");
$templateCache.put("app/main/admin/collaborators/collaborators/collaborators.html","<div id=\"collaborators\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div>\n<div layout=\"row\" layout-align=\"start center\" class=\"pl-20 pr-20\"><div layout=\"row\" class=\"tab\" \nng-click=\"vm.misc.tabSelected = \'collaborators\';vm.createPaginationCollaborators()\" \nng-style=\"vm.misc.tabSelected == \'collaborators\' ? {\'border-bottom-color\':vm.getThemeColor(\'accent\'),\'border-bottom-width\': \'1px\',\n        \'border-bottom-style\': \'solid\'} : {}\">\nColaboradores</div><div layout=\"row\" class=\"tab\" \nng-click=\"vm.misc.tabSelected = \'candidates\';vm.createPaginationCandidates()\" \nng-style=\"vm.misc.tabSelected == \'candidates\' ? {\'border-bottom-color\':vm.getThemeColor(\'accent\'),\'border-bottom-width\': \'1px\',\n        \'border-bottom-style\': \'solid\'} : {}\">\nCandidatos</div></div><div ng-if=\"vm.loading\" class=\"p-30 md-title text-center md-whiteframe-4dp white-bg\">\nCargando contenido, por favor espere...</div><div class=\"content p-30\" \nng-show=\"vm.misc.tabSelected == \'collaborators\'\"><div ng-if=\"!vm.loading\" class=\"main scrollable\" ms-scroll><div \nlayout=\"column\" flex=\"100\" layout-align=\"start\"><div layout=\"column\" \nclass=\"md-whiteframe-4dp all-width white-bg p-20 mb-20\"><div layout=\"row\"><span class=\"h2 font-weigth-500 mr-5\">Filtrar\n</span> <span class=\"h2\">resultados</span></div><div layout=\"row\" layout-align=\"start\" flex=\"100\"><md-input-container \nflex=\"20\"><div class=\"h4 grey-fg font-weight-300\"><label>Responsable de selección</label></div><md-select \naria-label=\"Seleccionar Etapa\" ng-model=\"vm.filter.collaborators.analista_id\" class=\"\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.search.responsable_seleccion\" type=\"search\" \nplaceholder=\"Escribe para buscar\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option \nng-repeat=\"data in vm.analysts | filter:vm.search.responsable_seleccion  track by $index\" ng-value=\"data.id\">\n{{data.name | capitalize:true}}</md-option></md-select></md-input-container><md-input-container flex=\"20\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>Nombre ó Documento de identidad</label></div><input type=\"text\" \nng-model=\"vm.filter.collaborators.query\"></md-input-container></div><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-click=\"vm.saveSearchCollaborators()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Buscar</md-button>\n<md-button ng-click=\"vm.filter.collaborators = {};vm.saveSearchCollaborators()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Limpiar</md-button></div></div>\n<div class=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" id=\"tableCollaborator\" layout=\"row\">\n<table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefsCollaborator\">\n<thead><tr><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Candidato</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Cargo</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Compañía</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Responsable de selección</span>\n</div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Fecha selección</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Fecha de ingreso</span></div>\n</th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Estado hoja de vida (%)</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Última modificación</span>\n</div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Última validación</span></div></th></tr></thead><tbody><tr \nng-repeat=\"collaborator in vm.collaborators\"><td layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"s20 icon-attachment pr-5 blue-500-fg cursor-pointer\" \nng-hide=\"collaborator.hideAttachments\" ng-click=\"vm.donwloadFile(collaborator)\"></i> <span \nclass=\"font-weight-500 cursor-pointer text-capitalized\" \nng-click=\"vm.goState(\'app.show_collaborator\',{id:collaborator.hv_id})\">{{collaborator.full_name | capitalize:true}}\n</span></div><div layout=\"row\"><span>C.C. </span><span class=\"font-weight-500 cursor-pointer\">{{collaborator.cedula}}\n</span></div></td><td class=\"grey-100-bg\">{{collaborator.position | capitalize:true}}</td><td class=\"\">\n{{collaborator.company | capitalize:true}}</td><td class=\"grey-100-bg\">{{collaborator.analyst.name | capitalize:true}}\n</td><td class=\"w-200 text-capitalized\">{{collaborator.selecteddate.formatDate | capitalize:true}}</td><td \nclass=\"grey-100-bg text-capitalized\">{{collaborator.entrydate.formatDate | capitalize:true}}</td><td \nclass=\"text-center\">{{collaborator.porc}}%</td><td class=\"grey-100-bg text-capitalized\">\n{{collaborator.updatedate.formatDate | capitalize:true}}</td><td class=\"text-capitalized\">\n{{collaborator.lastvalidatedate.formatDate | capitalize:true}}</td></tr></tbody></table></div></div></div></div><div \nclass=\"content p-30\" ng-show=\"vm.misc.tabSelected == \'candidates\'\"><div ng-if=\"!vm.loading\" class=\"main scrollable\" \nms-scroll><div layout=\"column\" flex=\"100\" layout-align=\"start\"><div layout=\"column\" \nclass=\"md-whiteframe-4dp all-width white-bg p-20 mb-20\"><div layout=\"row\"><span class=\"h2 font-weigth-500 mr-5\">Filtrar\n</span> <span class=\"h2\">resultados</span></div><div layout=\"row\" layout-align=\"start\" flex=\"100\"><md-input-container \nflex=\"20\"><div class=\"h4 grey-fg font-weight-300\"><label>Nombre ó Documento de identidad</label></div><input \ntype=\"text\" ng-model=\"vm.filter.candidates.query\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"vm.saveSearchCandidates()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Buscar</md-button>\n<md-button ng-click=\"vm.filter.candidates = {};vm.saveSearchCandidates()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Limpiar</md-button></div></div>\n<div class=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" id=\"tableCandidates\" layout=\"row\" \nng-if=\"vm.candidates\"><table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefsCandidate\"><thead><tr><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Candidato</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Cargo</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Compañía</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Etapa en el proceso</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Responsable de selección</span>\n</div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Fecha de ingreso</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Seleccionar</span></div></th>\n</tr></thead><tbody><tr ng-repeat=\"candidate in vm.candidates track by $index\"><td><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"s20 icon-attachment pr-5 blue-500-fg cursor-pointer\" ng-hide=\"candidate.hideAttachments\" \nng-click=\"vm.donwloadFile(candidate)\"></i> <span class=\"font-weight-500 cursor-pointer text-capitalized\" \nng-click=\"vm.goState(\'app.show_collaborator\',{id:candidate.hv_id})\">{{candidate.full_name | capitalize:true}}</span>\n</div><div layout=\"row\"><span>C.C. </span><span class=\"font-weight-500 cursor-pointer\">{{candidate.cedula}}</span>\n</div></div></td><td class=\"grey-100-bg\">{{candidate.position | capitalize:true}}</td><td class=\"\">\n{{candidate.company | capitalize:true}}</td><td class=\"grey-100-bg\">{{candidate.stage | capitalize:true}}</td><td \nclass=\"w-200\">{{candidate.analyst.name | capitalize:true}}</td><td class=\"grey-100-bg\">\n{{candidate.entrydate.formatDate | capitalize:true}}</td><td class=\"text-center\"><div layout=\"column\"><div \nng-if=\"candidate.es_colaborador\"><md-button \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.removeCollaborator(candidate);\">Retirar colaborador</md-button><md-progress-circular \nng-if=\"candidate.loading\" md-mode=\"indeterminate\"></md-progress-circular></div><div ng-if=\"!candidate.es_colaborador\">\n<md-button ng-if=\"!candidate.selected && !candidate.isColaborator\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"candidate.selected = true;\">Seleccionar como colaborador</md-button><div ng-show=\"candidate.selected\" \nlayout=\"column\" class=\"pt-5\"><md-autocomplete md-selected-item=\"candidate.positions\" \nmd-search-text=\"candidate.filterpositions\" \nmd-search-text-change=\"vm.loadData($index,candidate.filterpositions,\'positions\')\" \nmd-items=\"data in vm.misc.candidates[$index].positions | orderBy : \'name\'\" md-item-text=\"data.name\" \nplaceholder=\"Buscar cargos\"><md-item-template><span md-highlight-text=\"candidate.filter\">{{data.name}}</span>\n</md-item-template><md-not-found>No se encuentran cargos bajo el parametro.</md-not-found></md-autocomplete>\n<md-autocomplete md-selected-item=\"candidate.sociedades\" md-search-text=\"candidate.filtersociedades\" \nmd-search-text-change=\"vm.loadData($index,candidate.filtersociedades,\'sociedades\')\" \nmd-items=\"data in vm.misc.candidates[$index].sociedades | orderBy : \'name\'\" md-item-text=\"data.name\" \nplaceholder=\"Buscar sociedades\" class=\"mt-10\"><md-item-template><span md-highlight-text=\"vm.filter.sociedades\">\n{{data.name}}</span></md-item-template><md-not-found>No se encuentran cargos bajo el parametro.</md-not-found>\n</md-autocomplete><md-progress-circular ng-if=\"candidate.loading\" md-mode=\"indeterminate\"></md-progress-circular><div \nclass=\"pt-5\" layout=\"row\" layout-align=\"space-between\" ng-if=\"!candidate.loading\"><md-button \nng-if=\"candidate.selected\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"candidate.selected = false;candidate.positions = \'\';candidate.sociedades = \'\';\">Cancelar</md-button>\n<md-button class=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-disabled=\"!candidate.sociedades || !candidate.positions\" ng-click=\"vm.saveCollaborator(candidate);\">Guardar\n</md-button></div></div></div></div></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/admin/config/approvers/approvers.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nng-include=\"\'app/main/templates/header/default.html\'\"></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><div class=\"main scrollable\" ms-scroll><filter-lista filters=\"vm.filters\" \ncallbacksenddata=\"vm.callbackSendData(filter)\" callbackcleardata=\"vm.clearFilter()\" filtersdata=\"vm.filtersData\">\n</filter-lista><div ng-if=\"vm.loading\" layout=\"row\" flex=\"100\" layout-align=\"start center\" class=\"grey-200-bg\"><div \nclass=\"pl-25 pr-25 pt-15 pb-15 h4\">Cargando información por favor espere...</div></div><div \nng-if=\"!vm.loading && !vm.data.aprobadores.length\" layout=\"row\" flex=\"100\" layout-align=\"start center\" \nclass=\"orange-100-bg\"><div class=\"pl-25 pr-25 pt-15 pb-15 h4 orange-900-fg\"><md-icon md-font-icon=\"icon-information\" \nclass=\"h2 orange-900-fg\"></md-icon><span class=\"pl-5\">No se encontraron registros.</span></div></div><div \nng-if=\"!vm.loading && vm.data.aprobadores.length\" class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"\"><tr><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Rol</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Nombre</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Suplente</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Asistente</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"approver in vm.data.aprobadores\"><td\n class=\"\">{{approver.rol}}</td><td class=\"grey-50-bg\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\"><div \nng-class=\"{\'red-fg\' : !approver.estado}\" class=\"p-5\">{{approver.aprobador | capitalize:true}}</div></div></td><td \nclass=\"\"><div layout-align=\"start center\"><div class=\"p-5\">{{approver.suplente | capitalize:true}}</div><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"approver.fecha_max_suplente\" class=\"p-5 grey-fg\"><div><i \nclass=\"icon icon-calendar-select s20\"></i></div><div class=\"p-5\">\n{{approver.fecha_max_suplente | fecha: \'DD/MMMM/YYYY\'}}</div></div></div></td><td class=\"grey-50-bg\"><div layout=\"row\" \nflex=\"100\" layout-align=\"start center\"><div class=\"p-5\">{{approver.asistente | capitalize:true}}</div></div></td><td \nclass=\"\"><div layout=\"column\" flex=\"100\" layout-align=\"start start\"><div class=\"p-5\"><a href=\"\" \nng-click=\"vm.openApproverDetailDialog($event, approver)\">Ver detalles</a></div><div class=\"p-5\" \nng-if=\"!approver.estado && !vm.loading\"><a href=\"\" ng-click=\"vm.enableApprover($event, approver)\">Habilitar</a></div>\n<div class=\"p-5\" ng-if=\"approver.estado && !vm.loading\"><a class=\"red-fg\" href=\"\" \nng-click=\"vm.disableApprover($event, approver)\">Deshabilitar</a></div></div></td></tr></tbody></table></div></div>\n</div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.openAddApproverDialog($event)\" aria-label=\"Add approver\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/admin/config/mail-templates/mail-templates.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content p-30\"><div ng-if=\"vm.loading\" layout=\"row\" flex=\"100\" layout-align=\"start center\" class=\"grey-200-bg\">\n<div class=\"pl-25 pr-25 pt-15 pb-15 h4\">Cargando información por favor espere...</div></div><div \nng-if=\"!vm.loading && !vm.templates.length\" layout=\"row\" flex=\"100\" layout-align=\"start center\" class=\"orange-100-bg\">\n<div class=\"pl-25 pr-25 pt-15 pb-15 h4 orange-900-fg\"><md-icon md-font-icon=\"icon-information\" \nclass=\"h2 orange-900-fg\"></md-icon><span class=\"pl-5\">No se encontraron registros de plantillas.</span></div></div><div\n ng-if=\"!vm.loading && vm.templates.length\" class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"\"><tr><th \nclass=\"secondary-text light-blue-400-bg br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Nombre</span>\n</div></th><th class=\"secondary-text light-blue-400-bg br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Asunto</span></div></th><th class=\"secondary-text light-blue-400-bg br\"><div \nclass=\"table-header\"><span class=\"column-title white-fg\">Módulo</span></div></th><th \nclass=\"secondary-text light-blue-400-bg br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Descripción\n</span></div></th><th class=\"secondary-text light-blue-400-bg br\"></th><th class=\"secondary-text light-blue-400-bg br\">\n</th><th class=\"secondary-text light-blue-400-bg br\"></th></tr></thead><tbody><tr \nng-repeat=\"template in ::vm.templates\"><td class=\"grey-50-bg\"><a href=\"#\" ng-click=\"vm.goToTemplate($event, template)\">\n{{template.name}}</a></td><td class=\"\">{{template.asunto}}</td><td class=\"grey-50-bg\">{{template.modulo}}</td><td \nclass=\"\">{{template.descripcion}}</td><td class=\"grey-50-bg text-center\"><a href=\"#\" \nng-click=\"vm.goToTemplate($event, template)\">Modificar</a></td><td class=\"text-center\"><a href=\"#\" \nng-click=\"vm.activeAndDesactiveTemplate(template,$index)\">{{template.estado ? \'Desactivar\' : \'Activar\'}}</a></td><td \nclass=\"grey-50-bg text-center\"><a href=\"#\" ng-click=\"vm.goProbar($event, template)\">Probar</a></td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/admin/config/outbox/outbox.html","<div id=\"mail\" class=\"page-layout carded left-sidenav overflow-scroll\"><div \nng-include=\"\'app/main/templates/header/default.html\'\"></div><div class=\"center pt-32 pb-32\" layout=\"column\" flex><div \nclass=\"content-card h-500\" ng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\"></div>\n</div></div>");
$templateCache.put("app/main/admin/config/settings/settings.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nng-include=\"\'app/main/templates/header/default.html\'\"></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><div class=\"main scrollable\" ms-scroll><div ng-if=\"vm.loading\" layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" class=\"grey-200-bg\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2\">\nCargando información por favor espere...</div></div><div ng-if=\"!vm.loading && !vm.settings.length\" layout=\"row\" \nflex=\"100\" layout-align=\"start center\" class=\"orange-100-bg\"><div class=\"pl-25 pr-25 pt-15 pb-15 h4 orange-900-fg\">\n<md-icon md-font-icon=\"icon-information\" class=\"h2 orange-900-fg\"></md-icon><span class=\"pl-5\">\nNo se encontraron opciones para configurar.</span></div></div><div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"grey-100-bg bb\" \nlayout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" layout-gt-md=\"row\" \nlayout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" layout-align-gt-xs=\"space-between center\" \nlayout-align-sm=\"space-between center\" layout-align-gt-sm=\"space-between center\" \nlayout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-align-lg=\"space-between center\"><div \nclass=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\"><div class=\"h5 text-uppercase\">Configuración del sistema</div>\n</div></div><div layout=\"row\" class=\"p-20\" flex=\"100\" layout-wrap ms-scroll><div ng-repeat=\"setting in vm.settings\" \nid=\"{{setting.key}}\" class=\"p-10\" layout=\"column\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" \nflex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div class=\"all-width\" input-generator field=\"setting\" \nmodel=\"vm.data\" idblock=\"setting.id\" value=\"setting.value\" options=\"setting.options\"></div><div layout=\"row\" \nlayout-align=\"end center\" layout-wrap class=\"\"><div><md-icon md-font-icon=\"icon-help-circle\" class=\"cursor-pointer h3\">\n<md-tooltip md-direction=\"bottom\">{{setting.desc}}</md-tooltip></md-icon></div></div><div \nng-if=\"vm.errors[field.field]\" class=\"p-5 h6 red-500-fg\">{{vm.errors[field.field]}}</div></div></div></ms-widget-front>\n</ms-widget></div></div></div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.save()\" ng-disabled=\"!vm.change || vm.saving\" aria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon></md-button></div>");
$templateCache.put("app/main/admin/crud-society/created-society/created-society.html","<md-dialog aria-label=\"List dialog\" flex=\"30\"><md-toolbar><div class=\"md-toolbar-tools\"><span class=\"text-truncate h2\">\n{{vm.society ? \'Editar sociedad\' : \'Crear nueva sociedad\'}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"padding\"><div id=\"content\" layout=\"column\" layout-align=\"center center\">\n<md-input-container class=\"w-90-p\"><div class=\"h4 grey-fg font-weight-300\"><label>Sociedad</label></div><md-select \naria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.society_id\" class=\"\"><md-option \nng-repeat=\"(key,value) in vm.lists.sociedades  track by $index\" ng-value=\"key\">{{value | capitalize:true}}</md-option>\n</md-select></md-input-container><md-input-container class=\"w-90-p\"><div class=\"h4 grey-fg font-weight-300\"><label>País\n</label></div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.country_id\" class=\"\"><md-option \nng-repeat=\"(key,value) in vm.lists.paises   track by $index\" ng-value=\"key\">{{value | capitalize:true}}</md-option>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"p-5\"><md-button aria-label=\"Cancelar\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.closeDialog()\">\nCancelar</md-button></div><div class=\"p-5\"><md-button aria-label=\"Aceptar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.saveSociety()\" \nng-disabled=\"!vm.data.society_id || !vm.data.country_id\">Aceptar</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/requester/dashboard-finalist-candidate/dashboard-finalist-candidate.html","<div id=\"dashboard-finalist\" class=\"page-layout simple\"><div class=\"content p-30\"><div ng-if=\"!vm.ternas.length > 0\" \nlayout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"grey-200-bg mt-15\"><div \nclass=\"pl-25 pr-25 pt-15 pb-15 h2 mt-10\">No se encontraron procesos para evaluar.</div></div><div layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget ng-repeat=\"terna in vm.ternas track by $index\" flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-xs=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" \nflex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><ms-widget-front class=\"white-bg\" \nng-style=\"{\'border-top-color\':vm.getThemeColor(\'accent\'),\'border-top-width\': \'3px\',\n                \'border-top-style\': \'solid\'}\">\n<div class=\"pl-16 pr-16 pt-10 pb-10 border-bottom h-90\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"mb-10 h2 grey-500-fg\">{{terna.proceso.cargo_ocupar | capitalize:true}}</div></div><div \nclass=\"pl-16 pr-16 pt-5 pb-5 h-200\" layout=\"column\" layout-align=\"start\" style=\"overflow-y: auto\"><div \nng-repeat=\"candidate in terna.candidatos track by $index\" layout=\"row\" layout-align=\"start center\" class=\"mb-10 h-100\" \nng-class=\"$last ? \'\' : \'bb\'\"><div class=\"mb-10\"><img class=\"profile-image avatar huge\" \nng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\"></div><div layout=\"column\" layout=\"space-between\"><div \nclass=\"h3 grey-500-fg\">{{candidate.hoja_vida.nombre | capitalize:true}}</div><div class=\"mt-5 h4 grey-400-fg\">\nFecha de envio: {{candidate.procesos_candidato.fecha_enviado_cliente}}</div></div></div></div><div \nclass=\"grey-50-bg border-top pl-16 pr-16 pt-5 pb-5\" layout=\"row\" layout-align=\"end center\" layout-wrap><md-button \nng-click=\"vm.goToFinalist(terna.proceso.id)\" aria-label=\"evaluar\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Evaluar</md-button></div>\n</ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/admin/requester/dashboard-requester/dashboard-requester.html","<div id=\"dashboard\" class=\"page-layout simple\"><div class=\"content p-30\"></div></div>");
$templateCache.put("app/main/admin/requester/new-request/new-request.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nng-include=\"\'app/main/templates/header/default.html\'\"></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><div ng-if=\"vm.loading\" class=\"m-15 pl-25 pr-25 pt-15 pb-15 grey-200-bg all-width\"><span \nclass=\"h4\">Cargando información por favor espere...</span></div><div id=\"request\" \nng-if=\"!vm.loading && vm.blocks.length\" class=\"main scrollable\" ms-scroll><div \nmd-colors=\"{\'background-color\' : \'warn\'}\" class=\"m-15 p-15 white-fg md-hue-2\"><span class=\"icon-alert\"></span> <span \nclass=\"pl-5\">Recuerde que los campos con asterico (*) son obligatorios</span></div><div ng-repeat=\"block in vm.blocks\">\n<div ng-include=\"\'app/main/templates/request/blocks/create/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div>\n</div><div ng-include=\"\'app/main/admin/approver/show-request/partials/observations.html\'\"></div><div layout=\"row\" \nflex=\"100\" class=\"pb-15\" layout-align=\"center center\" layout-wrap><div class=\"p-5\"><md-button \nng-click=\"vm.saveAndSend()\" ng-disabled=\"vm.saving\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Guardar y enviar solicitud\n</md-button></div></div></div></div><md-button ng-if=\"!vm.loading && vm.blocks.length\" \nclass=\"md-fab md-warn md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.validate(true)\" \nng-disabled=\"!vm.change || vm.saving\" aria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/admin/requester/requests/requests.html","<div id=\"dashboard\" class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"content p-30\"><div ng-if=\"vm.loading\" layout=\"row\" flex=\"100\" layout-align=\"start center\" class=\"grey-200-bg\">\n<div class=\"pl-25 pr-25 pt-15 pb-15 h4\">Cargando información por favor espere...</div></div><div ng-if=\"!vm.loading\" \nclass=\"white-bg md-whiteframe-4dp\"><filter-lista filters=\"vm.filters\" callbacksenddata=\"vm.callbackSendData(filter)\" \ncallbackcleardata=\"vm.clearFilter()\" filtersdata=\"vm.filtersData\"></filter-lista><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead \nclass=\"\"><tr><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Código</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Cargo</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Fecha de solicitud</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Vacantes</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Tipo de solicitud</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Estado requisicion</span></div>\n</th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Estado proceso</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"></th></tr></thead><tbody><tr ng-init=\"color = {\'background-color\': request.estado_color}\" \nng-repeat=\"request in vm.requests\"><td class=\"\"><a href=\"/show-request/{{request.id}}\">{{request.codigo}}</a></td><td \nclass=\"grey-50-bg\"><div layout=\"column\"><a href=\"/show-request/{{request.id}}\">{{ request.cargo_ocupar }} </a><span \nclass=\"h6 font-weight-600\">{{request.ciudad_trabajo}} </span><span class=\"h6 font-weight-600\">\nOcupantes: {{request.info_ocupante_nombres}}</span></div></td><td class=\"text-center\">\n{{ request.fecha_solicitud | fecha: \'DD/MMMM/YYYY\'}}</td><td class=\"grey-50-bg text-center\">{{ request.no_vacantes }}\n</td><td>{{ request.tipo_solicitud_label }}<div ng-if=\"request.tipo_solicitud_b_label\" class=\"grey-fg\">\n{{ request.tipo_solicitud_b_label }}</div><div ng-if=\"request.tipo_solicitud_c_label\" class=\"grey-fg\">\n{{request.tipo_solicitud_c_label}}</div></td><td class=\"grey-50-bg text-center\"><span \nng-style=\"{\'background-color\':request.estado_aprobacion_color}\" \nclass=\"text-boxed radius-15 white-fg h6 no-margin font-weight-200\">{{request.estado_aprobacion_label}}</span></td><td \nclass=\"text-center\"><span ng-style=\"{\'background-color\':request.estado_proceso.color}\" \nclass=\"text-boxed radius-15 white-fg h6 no-margin font-weight-200\">{{request.estado_proceso.estado}}</span></td><td \nclass=\"grey-50-bg text-center\"><a href=\"#\" ng-click=\"vm.confirmClone($event, request.id, request.cargo_ocupar)\">\nDuplicar</a></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/requester/show-finalist-candidate/show-finalist-candidate.html","<div class=\"content\" flex ms-scroll><div ng-include=\"\'app/main/templates/header/finalist.html\'\"></div><div \nng-if=\"vm.loading\" class=\"m-30 pl-25 pr-25 pt-15 pb-15 grey-200-bg all-width\"><span class=\"h4\">\nCargando información por favor espere...</span></div><div ng-if=\"!vm.candidates.length > 0\" layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" class=\"grey-200-bg mt-15\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2 mt-10\">\nNo se encontraron candidatos para evaluar.</div></div><div ng-if=\"!vm.loading\" class=\"p-15\"><div layout=\"row\" \nlayout-align=\"start end\" ng-if=\"vm.candidates.length > 0\"><md-button aria-label=\"descartar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.donwloadExcelTerna()\" layout=\"row\" layout-align=\"center center\">Descargar comparación <i \nclass=\"icon-file-excel cursor-pointer\" ng-click=\"vm.donwloadExcelTerna()\"></i></md-button></div><div layout=\"row\" \nlayout-align=\"start\" id=\"finalist-candidate\" style=\"overflow-x: auto; width:100%\"><ms-widget \nng-repeat=\"candidate in vm.candidates track by $index\" class=\"w-800\"><ms-widget-front class=\"white-bg\" \nng-style=\"{\'border-top-color\':vm.getThemeColor(\'accent\'),\'border-top-width\': \'3px\',\n                    \'border-top-style\': \'solid\'}\">\n<div class=\"pl-16 pr-16 pt-20 pb-10 white-bg border-bottom\" layout=\"row\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"start start\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\"><div class=\"m-10\"><img class=\"profile-image avatar huge\" \nng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\"></div><div layout=\"column\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"space-between\" class=\"h-110\"><div \nng-click=\"vm.goToCandidateDetail(candidate.id)\" class=\"h2 cursor-pointer text-underlined font-weight-500 grey-600-fg\">\n{{candidate.name | capitalize:true}}</div><div layout=\"row\" layout-align=\"start center\" class=\"h5 badge\" \nmd-colors=\"{\'background-color\':\'accent\'}\"><span class=\"pr-5\">{{candidate.age}}</span> <span>Años</span></div><div \nclass=\"h5 font-weight-400 grey-500-fg\" ng-if=\"candidate.count_other_profession\"><span>\n{{candidate.profession | capitalize:true}} <span \nng-if=\"candidate.count_other_profession && candidate.count_other_profession > 0\">{{candidate.count_other_profession}}\n</span></span></div><div layout=\"row\" layout-align=\"start center\" class=\"h5 font-weight-400 grey-500-fg\"><span \nclass=\"pr-5\">Experiencia:</span> <span>{{candidate.experience}}</span></div><div \nclass=\"h5 font-weight-400 grey-500-fg\" ng-if=\"candidate.advanced_study\"><span></span>\n {{candidate.advanced_study | capitalize:true}} <span \nng-if=\"candidate.count_other_study && candidate.count_other_study > 0\">{{candidate.count_other_study}}</span></div>\n</div></div><div class=\"pl-16 pr-16 pt-5 pb-5 grey-50-bg\" layout=\"column\" layout-align=\"space-between\"><div \nng-repeat=\"block in vm.blockHojavida[$index] track by $index\"><div ng-if=\"block.name == \'personales\' && true\" \nng-include=\"\'app/main/templates/finalist/personal-info.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'perfil\'\" ng-include=\"\'app/main/templates/finalist/one-column-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'experiencia\'\" \nng-include=\"\'app/main/templates/finalist/laboral-experience.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'estudios_formales\'\" ng-include=\"\'app/main/templates/finalist/formal-study.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'estudios_no_formales\'\" \nng-include=\"\'app/main/templates/finalist/non-formal-study.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'laboral\'\" ng-include=\"\'app/main/templates/finalist/one-column-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'contacto_emergencia\'\" \nng-include=\"\'app/main/templates/finalist/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'idiomas\'\" ng-include=\"\'app/main/templates/finalist/languages.html\'\" onload=\"item = block.data\">\n</div><div ng-if=\"block.name == \'grupo_familiar\'\" ng-include=\"\'app/main/templates/finalist/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'hijos\'\" \nng-include=\"\'app/main/templates/finalist/childrens.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'madre\'\" ng-include=\"\'app/main/templates/finalist/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'padre\'\" \nng-include=\"\'app/main/templates/finalist/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'conyuge\'\" ng-include=\"\'app/main/templates/finalist/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'viven_usted\'\" \nng-include=\"\'app/main/templates/finalist/two-columns.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'vivienda\'\" ng-include=\"\'app/main/templates/finalist/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'contacto\'\" \nng-include=\"\'app/main/templates/finalist/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'salud\'\" ng-include=\"\'app/main/templates/finalist/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'adicional\'\" \nng-include=\"\'app/main/templates/finalist/two-columns-one-row.html\'\" onload=\"item = block.data\"></div></div></div><div \nclass=\"pl-16 pr-16 pt-5 pb-5 concept-analyst grey-50-bg\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"grey-100-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between center\" \nlayout-align-gt-sm=\"space-between center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-lg=\"space-between center\"><div class=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\"><div \nclass=\"h5 text-uppercase\"><span class=\"font-weight-900\">Concepto </span>entrevista del responsable de selección</div>\n</div></div><div class=\"pt-30 pb-30 pl-30 pr-30 bb\"><div ng-repeat=\"block in vm.blockConcept[$index]\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h5 text-capitalized font-weight-500\">{{block.title}}</span></div>\n<div ng-include=\"\'app/main/templates/finalist/blocks/read/\' + block.type + \'.html\'\" \nng-init=\"item = block;root = candidate.concept\"></div></div></div></ms-widget-front></ms-widget></div></div><div \nclass=\"pl-28 pr-28 pt-5 pb-5 stage-finalist grey-50-bg\" layout=\"column\" layout-align=\"space-between\"><span \nclass=\"h4 font-weight-500\">{{vm.recomendaciones.title}}</span><table class=\"row-border hover table-entrevista-jefe\" \nng-if=\"vm.recomendaciones.recomendaciones\"><thead><tr><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text\" \nng-repeat=\"(key,value) in vm.recomendaciones.recomendaciones\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">{{key}}</span></div></th></tr></thead><tbody><tr><td class=\"b h4 font-weight-300 p-8\" \nng-repeat=\"(key,value) in vm.recomendaciones.recomendaciones\"><u>{{value}}</u></td></tr></tbody></table><span \nclass=\"h4 font-weight-500\">{{vm.recomendaciones.footer}}</span></div><div \nclass=\"pl-16 pr-16 pt-5 pb-5 stage-finalist grey-50-bg\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"grey-100-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between center\" \nlayout-align-gt-sm=\"space-between center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-lg=\"space-between center\"><div class=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\"><div \nclass=\"h5 text-uppercase\"><span class=\"font-weight-900\">Concepto </span>entrevista del jefe</div></div></div><div \nclass=\"pt-10 pb-30 pl-30 pr-10 bb\"><div ng-if=\"!candidate.showStage\"><div \nng-repeat=\"block in vm.blockEvaluation[$index]\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"h5 text-capitalized font-weight-500\">{{block.title}}</span></div><div \nng-include=\"\'app/main/templates/finalist/blocks/update/\' + block.type + \'.html\'\" \nng-init=\"item = block;root = candidate.evaluation\"></div></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-show=\"candidate.loadingEvaluation\" class=\"m-5\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div><div layout=\"row\" layout-align=\"center center\">\n<md-button aria-label=\"aprobar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataEvaluation(candidate)\">Guardar</md-button></div></div><div ng-if=\"candidate.showStage\">\n<md-select ng-model=\"candidate.stageSelected\" ng-change=\"vm.changeStage(candidate,$index);\" class=\"all-width\">\n<md-option ng-value=\"stage\" ng-repeat=\"stage in vm.stages track by stage.id\" \nng-selected=\"stage.id == candidate.stage.id\">{{stage.name_corto}}</md-option></md-select><div \nng-if=\"vm.blockStages[$index]\"><div ng-repeat=\"block in vm.blockStages[$index]\"><div \nng-include=\"\'app/main/templates/finalist/blocks/update/\' + block.type + \'.html\'\" \nng-init=\"item = block;root = candidate\"></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-show=\"candidate.loadingStage\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div><div layout=\"row\" layout-align=\"center center\" class=\"mt-10\" \nng-if=\"candidate.stageSelected\"><md-button ng-if=\"candidate.stageSelected.id != 10\" aria-label=\"aprobar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataStage(candidate,1,false,$index)\">Aprobar</md-button><md-button \nng-if=\"candidate.stageSelected.id == 10\" aria-label=\"descartar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataStage(candidate,1,true,$index)\">Descartar</md-button></div></div><a class=\"pointer\" \nmd-colors=\"{color:\'warn\'}\" ng-click=\"candidate.showStage = false\">Regresar</a></div></div></ms-widget-front>\n</ms-widget></div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/admin/requester/show-request/show-request.html","<div id=\"big-sidebar\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/templates/header/default.html\'\"></div><div ng-if=\"vm.loading\" \nclass=\"m-30 pl-25 pr-25 pt-15 pb-15 grey-200-bg all-width\"><span class=\"h4\">Cargando información por favor espere...\n</span></div><div ng-if=\"!vm.loading && vm.blocks.length\" class=\"p-15\"><div \nng-include=\"\'app/main/admin/requester/show-request/partials/content.html\'\"></div><div \nng-include=\"\'app/main/admin/approver/show-request/partials/observations.html\'\"></div></div></div><md-sidenav \nng-if=\"!vm.loading && vm.blocks.length\" class=\"sidenav md-sidenav-right no-margin no-padding b\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/admin/requester/show-request/partials/sidebar.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/admin/requester/update-request/update-request.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nng-include=\"\'app/main/templates/header/default.html\'\"></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><div id=\"request\" class=\"main scrollable\" ms-scroll><div ng-if=\"vm.loading\" \nclass=\"m-15 pl-25 pr-25 pt-15 pb-15 grey-200-bg\"><span class=\"h4\">Cargando información por favor espere...</span></div>\n<div ng-if=\"!vm.loading && vm.blocks.length\" md-colors=\"{\'background-color\' : \'warn\'}\" \nclass=\"m-15 p-15 white-fg md-hue-2\"><span class=\"icon-alert\"></span> <span class=\"pl-5\">\nRecuerde que los campos con asterico (*) son obligatorios</span></div><div ng-if=\"!vm.loading && vm.blocks.length\" \nng-repeat=\"block in vm.blocks\"><div ng-include=\"\'app/main/templates/request/blocks/update/\' + block.type + \'.html\'\" \nng-init=\"item = block\"></div></div><div ng-if=\"!vm.loading && vm.blocks.length\" \nng-include=\"\'app/main/admin/approver/show-request/partials/observations.html\'\"></div><div \nng-if=\"!vm.data.options.enviar_aprobacion && !vm.loading && vm.blocks.length\" layout=\"row\" flex=\"100\" \nclass=\"p-8 m-10 green-900-fg\" layout-align=\"center center\" layout-wrap><div class=\"p-5\"><md-icon \nmd-font-icon=\"icon-information\" class=\"h2 green-900-fg\"></md-icon>\nLa solicitud ha sido enviada, no es necesario enviarla de nuevo.</div></div><div \nng-if=\"!vm.loading && vm.blocks.length\" layout=\"row\" flex=\"100\" class=\"pb-15\" layout-align=\"center center\" layout-wrap>\n<div class=\"p-5\"><md-button ng-href=\"/show-request/{{vm.id}}\" \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Cancelar</md-button></div><div \nng-if=\"vm.data.options.enviar_aprobacion\" class=\"p-5\"><md-button ng-click=\"vm.saveAndSend()\" ng-disabled=\"vm.saving\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin\">Guardar y enviar solicitud\n</md-button></div></div></div></div><md-button ng-if=\"!vm.loading && vm.blocks.length\" \nclass=\"md-fab md-warn md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.save()\" \nng-disabled=\"!vm.change || vm.saving\" aria-label=\"Save\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/admin/requests/dialogs/cancel-request.html","<md-dialog class=\"w-380\" aria-label=\"Add employee\"><form name=\"cancelForm\"><md-toolbar class=\"md-accent white-text\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\">\n<h3>{{vm.data.data.cargo_ocupar}}</h3></div><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content flex \nms-scroll><div flex=\"100\" class=\"p-30\" layout=\"column\" layout-align><div flex=\"100\" class=\"pt-8 pb-20\">\n<md-input-container class=\"no-padding no-margin all-width\"><label for=\"motivo_rechazo_id\">Motivo</label><md-select \nname=\"motivo_rechazo_id\" ng-model=\"vm.formData.motivo_rechazo_id\" required><md-option \nng-repeat=\"(key, value) in vm.data.motivo_rechazos track by $index\" ng-value=\"key\">{{value}}</md-option></md-select>\n<div ng-messages=\"cancelForm.motivo_rechazo_id.$error\"><div ng-message=\"required\">Este campo es requerido.</div></div>\n</md-input-container></div><div flex=\"100\" class=\"pt-8 pb-8\"><md-input-container \nclass=\"no-padding no-margin all-width\"><label for=\"observaciones\" class=\"no-margin no-padding\">Comentarios adicionales\n</label><textarea name=\"observaciones\" ng-model=\"vm.formData.observaciones\" class=\"no-margin no-padding\" \nmd-maxlength=\"200\" rows=\"3\" required></textarea><div ng-messages=\"cancelForm.observaciones.$error\"><div \nng-message=\"required\">Este campo es requerido.</div></div></md-input-container></div></div></md-content>\n<md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button \nng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.cancel()\" aria-label=\"Anular\" type=\"submit\" \nng-disabled=\"cancelForm.$invalid || cancelForm.$pristine || vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/analyst/candidate-detail/dialogs/confirmStage.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-400\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.candidate.nombre}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"padding\"><div id=\"confirmStage\" layout=\"column\" layout-align=\"space-between\">\n<div class=\"mb-20\" layout=\"row\" layout-align=\"center center\"><span class=\"h2 font-weight-300\" \nng-if=\"vm.stageIncomplet.length == 0\">¿Confirma que desea pasar el candidato al estado &nbsp; <span \nclass=\"h2 font-weight-500\">{{vm.stage.name}}</span>? </span><span class=\"h2 font-weight-300\" \nng-if=\"vm.stageIncomplet.length > 0\">No se puede pasar el candidato a la etapa &nbsp; <span class=\"h2 font-weight-500\">\n{{vm.stage.name}}</span></span></div><div class=\"mb-20\" layout=\"column\" layout-align=\"center start\" \nng-if=\"vm.stageIncomplet.length > 0\"><span class=\"h3 font-weight-300\">\nLa persona ha pasado todas las pruebas requeridas, pero no ha aprobado las siguientes:</span><div><div \nng-repeat=\"stage in vm.stageIncomplet track by $index\"><span class=\"h4 font-weight-500\">- {{stage.name}}</span></div>\n</div></div></div></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!vm.config.onlyViewStages\"><div class=\"p-5\"><md-button aria-label=\"Cancelar\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.closeDialog()\">\nCancelar</md-button></div><div class=\"p-5\"><md-button aria-label=\"Aceptar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateStage(1)\" ng-if=\"vm.stageIncomplet.length == 0\">Aceptar</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/analyst/candidate-detail/dialogs/discardStage.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.title}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"no-padding\"><div id=\"discardStage\" layout=\"column\" layout-align=\"space-between\" \nng-if=\"vm.blocksStage\"><div layout=\"row\" layout-align=\"start center\" class=\"blue-100-bg blue-900-fg p-10 mb-10\" \nng-if=\"vm.incompletStage.length == 0 && vm.stage.id == 9 && !vm.hideMessage\"><div class=\"pl-5 pt-5 pb-5 pr-15\"><md-icon\n md-font-icon=\"icon-information-outline\" class=\"blue-900-fg\"></md-icon></div><div class=\"p-5\">\nEl nuevo colaborador debe actualizar la informacion del censo fase 1 <strong>¿Desea enviar el colaborador al censo? \n</strong><a class=\"pr-5 cursor-pointer\" ng-click=\"vm.sendCenso()\">Si</a> <a class=\"cursor-pointer\" \nng-click=\"vm.hideMessage = true\">No</a></div></div><div ng-repeat=\"block in vm.blocksStage\" \nng-if=\"vm.incompletStage.length == 0 \"><div \nng-include=\"\'app/main/templates/block-generic/update/\' + block.type + \'.html\'\" ng-init=\"item = block;root = vm\"></div>\n</div><div class=\"m-20\" layout=\"column\" layout-align=\"center start\" ng-if=\"vm.incompletStage.length > 0\"><span \nclass=\"h2 font-weight-300\" ng-if=\"vm.incompletStage.length > 0\">No se puede pasar el candidato a la etapa &nbsp; <span \nclass=\"h2 font-weight-500\">{{vm.stage.name_corto}}</span> </span><span class=\"h3 font-weight-300\">\nLa persona ha pasado todas las pruebas requeridas, pero no ha aprobado las siguientes:</span><div><div \nng-repeat=\"stage in vm.incompletStage track by $index\"><span class=\"h4 font-weight-500\">- {{stage.name}}</span></div>\n</div></div></div></md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!vm.config.onlyViewStages\"><div class=\"p-5\"><md-button aria-label=\"Cancelar\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.closeDialog()\">\nCancelar</md-button></div><div class=\"p-5\"><md-button aria-label=\"Aceptar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataStage(1)\" \nng-if=\"vm.incompletStage.length == 0 && vm.hideMessage && vm.values.validacionFechasIncumplimiento\">Aceptar</md-button>\n</div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/analyst/candidate-detail/dialogs/importStage.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Importar etapas </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"no-padding\"><div id=\"discardStage\" layout=\"column\" layout-align=\"space-between\" \nclass=\"p-20\"><md-input-container><div class=\"h4 grey-fg font-weight-300\"><label>Consultar ultimos procesos</label>\n</div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.requestSelected\" \nng-change=\"vm.requestSelectedChange(vm.requestSelected)\"><md-option \nng-repeat=\"data in vm.candidate.otros_procesos track by $index\" ng-value=\"data.id\">{{data.cargo_ocupar}} ({{data.id}})\n</md-option></md-select></md-input-container><div class=\"bb all-width\"></div><div class=\"mt-5 mb-5\" \nng-repeat=\"stages in vm.etapasImport\"><div class=\"grey-50-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" \nlayout-gt-sm=\"row\" layout-md=\"row\" layout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" \nlayout-align-xs=\"space-between center\" layout-align-gt-xs=\"space-between center\" \nlayout-align-sm=\"space-between center\" layout-align-gt-sm=\"space-between center\" \nlayout-align-md=\"space-between center\" layout-align-gt-md=\"space-between center\" \nlayout-align-gt-lg=\"space-between center\" layout-align-lg=\"space-between center\"><div \nclass=\"pl-20 pt-10 pb-10 pr-10 bt-5\"><div class=\"h5 text-uppercase\"><span>{{stages.name}}</span></div></div><div>\n<md-checkbox class=\"no-margin\" ng-model=\"stages.isCheckeable\" ng-change=\"vm.stagesSelecteds($index);\" \naria-label=\"check block\"></md-checkbox></div></div></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div>\n</md-dialog-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button\n aria-label=\"Cancelar\" class=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.closeDialog()\">Cancelar</md-button></div><div class=\"p-5\"><md-button aria-label=\"Aceptar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.sendStagesData()\" ng-disabled=\"vm.checkStages.length == 0\">Aceptar</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/analyst/candidate-detail/dialogs/recommend-candidate.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.title}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"no-padding\"><div id=\"recommend_candidate\" layout=\"column\" \nlayout-align=\"space-between\"><div class=\"grey-200-bg p-20\" layout=\"column\" layout-align=\"space-between\">\n<md-autocomplete md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"position in vm.querySearch(vm.searchText)\" md-item-text=\"position.name | capitalize:true\" md-min-length=\"0\" \nplaceholder=\"Selecciona un cargo\"><md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">\n{{position.name | capitalize:true}}</span></md-item-template><md-not-found>\nNo se encontraron coincidencias con la palabra: \"{{vm.searchText}}\".</md-not-found></md-autocomplete>\n<md-input-container class=\"md-block\"><label>Observaciones (Opcional)</label><textarea name=\"description\" \nng-model=\"vm.data.descripcion\" class=\"no-margin\" md-maxlength=\"200\" rows=\"2\"></textarea></md-input-container><div \nclass=\"pt-10 text-right\"><md-button ng-if=\"vm.selectedItem\" ng-click=\"vm.addRecommendCandidate()\" aria-label=\"Guardar\" \ntype=\"submit\" class=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">\nGuardar</md-button></div></div><div class=\"white-bg\"><div class=\"p-20 bb\" layout=\"column\" layout-align=\"start\" \nng-repeat=\"recomend in vm.candidate.recomendaciones  | orderBy : \'-fecha\'\" \nng-class=\"{\'field-container\': recomend.new}\"><div layout=\"row\" aling=\"space-between\" class=\"\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\" layout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" \nlayout-align-sm=\"space-betweeen\" layout-align-gt-sm=\"space-betweeen\" layout-align-md=\"space-betweeen\" \nlayout-align-gt-md=\"space-betweeen\" layout-align-lg=\"space-betweeen\" layout-align-gt-lg=\"space-betweeen\" \nlayout-align-xl=\"space-betweeen\"><div class=\"mr-10\"><img class=\"profile-image ms-recommend-image\" \nng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\"></div><div layout=\"column\" layout-align=\"start\" class=\"all-width\"><div\n class=\"h2 font-weight-600 grey-600-fg\" layout=\"row\" layout-align=\"start center\"><div>\n{{recomend.cargo.name | capitalize:true}}</div></div><div class=\"mb-10 all-width\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 font-weight-500 grey-500-fg\">\n{{recomend.analista.name | capitalize:true}}</div><div class=\"h4 font-weight-300 grey-400-fg\">\n{{recomend.fecha | fecha: \'D/MMM YYYY h:m a\'}}</div></div><div ng-if=\"recomend.descripcion\" \nclass=\"h5 font-weight-400 mt-10 mb-10 all-width\" layout=\"row\" layout-align=\"start center\">{{recomend.descripcion}}\n</div></div></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/candidate-detail/dialogs/report-for-the-client.html","<md-dialog aria-label=\"List dialog\" flex=\"60\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.title}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"no-padding\"><div id=\"recommend_candidate\" layout=\"column\" \nlayout-align=\"space-between\"><div ng-repeat=\"block in vm.blocks\"><div \nng-include=\"\'app/main/templates/request/blocks/update/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div></div>\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/candidate-detail/dialogs/show-candidate-history.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-500 width-70-p\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.title}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"no-padding\"><div class=\"white-bg\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"pl-20\" ng-show=\"vm.showDetalle\"><md-select id=\"tipo_sel\" ng-change=\"vm.filterProcess()\" \nng-model=\"vm.processSelected\" aria-label=\"Filters\"><md-option ng-value=\"-1\">Seleccione el proceso</md-option><md-option\n ng-repeat=\"filter in vm.procesList\" ng-value=\"filter.id\">{{filter.name}}</md-option></md-select></div><div \nclass=\"p-20 bb\" layout=\"column\" layout-align=\"start\" ng-repeat=\"history in vm.history  | orderBy : \'-fecha\'\" \nng-show=\"vm.showDetalle\"><div layout=\"row\" aling=\"space-between\" class=\"\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" layout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" layout-align-sm=\"space-betweeen\" \nlayout-align-gt-sm=\"space-betweeen\" layout-align-md=\"space-betweeen\" layout-align-gt-md=\"space-betweeen\" \nlayout-align-lg=\"space-betweeen\" layout-align-gt-lg=\"space-betweeen\" layout-align-xl=\"space-betweeen\"><div \nlayout-align=\"start\" class=\"all-width\"><div layout=\"row\" layout-align=\"start end\"><div class=\"grey-600-fg\"><span \nclass=\"h2 font-weight-600\">{{history.proceso.cargo.name | capitalizeFirstLetter}}</span></div></div><div class=\"\" \nlayout=\"row\"><div class=\"font-weight-600 mr-5\">Número del proceso:</div><div>{{history.proceso.numero_requisicion}}\n</div></div><div class=\"\" layout=\"row\"><div class=\"font-weight-600 mr-5\">Responsable de selección:</div><div>\n{{history.analista.nombre | capitalize:true}}</div></div><div class=\"\" layout=\"row\"><div class=\"font-weight-600 mr-5\">\nOrigen candidato:</div><div>{{history.candidato.origen}}</div></div><div class=\"\" layout=\"row\"><div \nclass=\"font-weight-600 mr-5\">Máxima etapa alcanzada:</div><div>\n{{history.proceso.etapa_alcazada.name | capitalizeFirstLetter: true}}</div></div><div class=\"\" layout=\"row\" \nng-if=\"history.proceso.razones_descarte\"><div class=\"font-weight-600 mr-5\">Motivo de descarte:</div><div>\n{{history.proceso.razones_descarte.name | capitalizeFirstLetter: true}}</div></div><div class=\"\" layout=\"row\"><div \nclass=\"font-weight-600 mr-5 text-underline cursor-pointer\" ng-click=\"vm.setHistory(history)\" \nng-if=\"history.proceso.etapa_alcazada.id != 1\">Ver detalle</div></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.loading[history.proceso.id]\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular></div></div></div></div><div class=\"p-20\" layout=\"column\" layout-align=\"start\" \nng-show=\"vm.showBlocks\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><md-select \nid=\"tipo_sel\" ng-change=\"vm.setStage()\" ng-model=\"vm.stageSelected\" aria-label=\"Filters\"><md-option ng-value=\"-1\">\nSelecciona la etapa</md-option><md-option ng-repeat=\"stage in vm.stages\" ng-value=\"stage\">{{stage.name}}</md-option>\n</md-select></div><div class=\"font-weight-600 mr-5 text-underline cursor-pointer\" ng-click=\"vm.setResume(history)\">\nVolver al resumen</div></div><div ng-repeat=\"block in vm.blocksStage\"><div \nng-include=\"\'app/main/templates/block-generic/read/\' + block.type + \'.html\'\" \nng-init=\"item = block; root = vm.stageData\"></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/candidate-detail/dialogs/show-candidate-notes.html","<md-dialog aria-label=\"List dialog\" flex=\"50\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\" \nng-class=\"config.toolbar.class\"><span class=\"text-truncate h2\">{{vm.title | capitalize:true}} </span><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><div \nid=\"noteContect\" layout=\"column\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start \" \nclass=\"grey-200-bg p-20\" ng-if=\"vm.user.group_id != 1\"><div><div ng-if=\"!vm.showForm\" class=\"ms-note-new mb-20\"><div \nng-click=\"vm.changeForm()\" class=\"new-button-note\"><span>Agregar nota</span></div></div><div class=\"ms-note mb-20\" \nng-if=\"vm.showForm\"><form name=\"obsForm\" class=\"\"><md-input-container md-no-float><textarea name=\"comentario\" \nng-model=\"vm.data.note\" placeholder=\"Escribe una nota\" class=\"note-description-textarea mb-8\" autofocus required>\n                                    </textarea></md-input-container><div class=\"footer\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"space-between center\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.changeForm()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding\">Cancelar</md-button><md-button \nng-click=\"vm.addNoteCandidate(vm.data);vm.changeForm()\" aria-label=\"Guardar\" type=\"submit\" \nng-disabled=\"obsForm.$invalid || obsForm.$pristine || vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></div></form></div></div><div ng-if=\"vm.showForm\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" layout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" layout-align-sm=\"space-betweeen\" \nlayout-align-gt-sm=\"space-betweeen\" layout-align-md=\"start center\" layout-align-gt-md=\"start center\" \nlayout-align-lg=\"start center\" layout-align-gt-lg=\"start center\" layout-align-xl=\"start center\"><div class=\"pr-10\">\n<span>Visible para</span></div><div><md-radio-group ng-model=\"vm.data.visibility\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\" layout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" \nlayout-align-sm=\"space-betweeen\" layout-align-gt-sm=\"space-betweeen\" layout-align-md=\"start center\" \nlayout-align-gt-md=\"start center\" layout-align-lg=\"start center\" layout-align-gt-lg=\"start center\" \nlayout-align-xl=\"start center\"><md-radio-button ng-value=\"1\" class=\"mb-10\">Equipo de selección</md-radio-button>\n<md-radio-button ng-value=\"0\" class=\"mb-10\">Solo para mi</md-radio-button></md-radio-group></div></div></div><div \nclass=\"white-bg\"><div class=\"\" layout=\"column\" layout-align=\"start\" ng-repeat=\"note in vm.candidate.notes\" \nng-class=\"{\'field-container\':note.newNote}\"><div layout=\"row\" layout-align=\"space-between\" class=\"p-20\" \nlayout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" \nlayout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" layout-align-xs=\"space-betweeen\" \nlayout-align-gt-xs=\"space-betweeen\" layout-align-sm=\"space-betweeen\" layout-align-gt-sm=\"space-betweeen\" \nlayout-align-md=\"space-betweeen\" layout-align-gt-md=\"space-betweeen\" layout-align-lg=\"space-betweeen\" \nlayout-align-gt-lg=\"space-betweeen\" layout-align-xl=\"space-betweeen\"><div class=\"mr-10\"><img \nclass=\"profile-image ms-note-image\" ng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\"></div><div layout=\"column\" \nlayout-align=\"start\" class=\"all-width\"><div class=\"h2 font-weight-700 grey-600-fg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-aling=\"start center\"><div>{{note.name | capitalize:true}}</div>\n<div><i ng-class=\"note.visibility?\'icon-earth\':\'icon-lock\'\" class=\"s16 pl-10 grey-400-fg\"></i></div></div><div \nng-if=\"vm.user.group_id != 1\"><md-menu md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.editNote(note,$index)\" translate=\"Editar\">Editar nota\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deleteNote(note,$index)\" translate=\"Eliminar\">\nEliminar nota</md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nclass=\"h5 font-weight-500 grey-500-fg mb-10\">{{note.date_create_note | capitalize:true}}</div><div \nng-if=\"$index != vm.noteSelectedIndex\">{{note.note}}</div><div layout=\"column\" layout-aling=\"space-between\" \nng-if=\"$index == vm.noteSelectedIndex\"><div class=\"ms-note mb-20\"><form name=\"obsForm\" class=\"\"><md-input-container \nmd-no-float><textarea name=\"comentario\" ng-model=\"vm.noteSelected.note\" placeholder=\"Escribe una nota\" \nclass=\"note-description-textarea mb-8\" autofocus required>\n                                                            \n</textarea></md-input-container><div class=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\" flex=\"100\" layout-align=\"end center\"><md-button \nng-click=\"vm.deselectedNote()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding\">Cancelar</md-button><md-button \nng-click=\"vm.addNoteCandidate(vm.noteSelected)\" aria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></div></form></div><div layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" \nlayout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" \nlayout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" layout-align-sm=\"space-betweeen\" \nlayout-align-gt-sm=\"space-betweeen\" layout-align-md=\"start center\" layout-align-gt-md=\"start center\" \nlayout-align-lg=\"start center\" layout-align-gt-lg=\"start center\" layout-align-xl=\"start center\"><div class=\"pr-10\">\n<span>Visible para</span></div><div><md-radio-group ng-model=\"vm.noteSelected.visibility\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\" layout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" \nlayout-align-sm=\"space-betweeen\" layout-align-gt-sm=\"space-betweeen\" layout-align-md=\"start center\" \nlayout-align-gt-md=\"start center\" layout-align-lg=\"start center\" layout-align-gt-lg=\"start center\" \nlayout-align-xl=\"start center\"><md-radio-button ng-value=\"1\" class=\"mb-10\">Equipo de selección</md-radio-button>\n<md-radio-button ng-value=\"0\" class=\"mb-10\">Solo para mi</md-radio-button></md-radio-group></div></div></div></div>\n</div><div class=\"border-bottom\" ng-if=\"!$last\"></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/candidate-detail/dialogs/show-request-notes.html","<md-dialog aria-label=\"List dialog\" flex=\"50\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Notas del proceso </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"no-padding\"><div id=\"noteContect\" layout=\"column\" layout-align=\"space-between\">\n<div layout=\"column\" layout-align=\"start \" class=\"grey-200-bg p-20\"><div><div ng-if=\"!vm.showForm\" \nclass=\"ms-note-new mb-20\"><div ng-click=\"vm.changeForm()\" class=\"new-button-note\"><span>Agregar observacion</span>\n</div></div><div class=\"ms-note mb-20\" ng-if=\"vm.showForm\"><form name=\"obsForm\" class=\"\"><md-input-container \nmd-no-float><textarea name=\"comentario\" ng-model=\"data.note\" placeholder=\"Escribe una nota\" \nclass=\"note-description-textarea mb-8\" autofocus required>\n                                    </textarea>\n</md-input-container><div class=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\" flex=\"100\" layout-align=\"end center\"><md-button \nng-click=\"vm.changeForm()\" aria-label=\"Cancelar\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding\">\nCancelar</md-button><md-button ng-click=\"vm.addNoteRequest(data);vm.changeForm()\" aria-label=\"Guardar\" type=\"submit\" \nng-disabled=\"obsForm.$invalid || obsForm.$pristine || vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></div></form></div></div></div><div class=\"white-bg\"><div class=\"\" layout=\"column\" \nlayout-align=\"start\" ng-repeat=\"note in vm.request.notes\" ng-class=\"{\'field-container\':note.newNote}\"><div \nlayout=\"row\" layout-align=\"space-between\" class=\"p-20\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" \nlayout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" \nlayout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" layout-align-sm=\"space-betweeen\" \nlayout-align-gt-sm=\"space-betweeen\" layout-align-md=\"space-betweeen\" layout-align-gt-md=\"space-betweeen\" \nlayout-align-lg=\"space-betweeen\" layout-align-gt-lg=\"space-betweeen\" layout-align-xl=\"space-betweeen\"><div \nclass=\"mr-10\"><img class=\"profile-image ms-note-image\" ng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\"></div><div \nlayout=\"column\" layout-align=\"start\" class=\"all-width\"><div class=\"h2 font-weight-700 grey-600-fg\" layout=\"row\" \nlayout-align=\"space-between\"><div>{{note.name | capitalize:true}}</div><div><md-menu \nmd-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.editNote(note,$index)\" translate=\"Editar\">Editar observacion</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deleteNote(note,$index)\" translate=\"Eliminar\">Eliminar observacion</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div class=\"h5 font-weight-500 grey-500-fg mb-10\">\n{{note.date_create_note | capitalize:true}}</div><div ng-if=\"$index != vm.noteSelectedIndex\">{{note.note}}</div><div \nng-if=\"$index == vm.noteSelectedIndex\" class=\"ms-note\"><form name=\"obsForm\" class=\"\"><md-input-container md-no-float>\n<textarea name=\"comentario\" ng-model=\"vm.noteSelected.note\" placeholder=\"Escribe una nota\" \nclass=\"note-description-textarea mb-8\" autofocus required></textarea></md-input-container><div class=\"footer\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" layout-align=\"center center\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"end center\"><md-button ng-click=\"vm.deselectedNote()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding\">Cancelar</md-button><md-button \nng-click=\"vm.addNoteRequest(vm.noteSelected)\" aria-label=\"Guardar\" type=\"submit\" \nng-disabled=\"obsForm.$invalid || obsForm.$pristine || vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></div></form></div></div></div><div class=\"border-bottom\" ng-if=\"!$last\"></div></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/detail/partial/route.analyst_candidate.html","<div layout=\"column\" flex=\"100\" layout-align=\"start\"><div \nclass=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" layout=\"row\"><table class=\"row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Nombre</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Ciudad</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">Edad</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Aspiración salarial</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Experiencia laboral</span>\n</div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Estudio formal</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text br\"><div class=\"table-header\"><span class=\"column-title white-fg\">Promedio empresa</span></div>\n</th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Promedio cargos</span></div></th></tr></thead><tbody><tr \nng-repeat=\"candidate in vm.candidates\"><td>{{candidate.name}}</td><td class=\"grey-100-bg\">{{candidate.city}}</td><td \nclass=\"text-center\">{{candidate.age}}</td><td class=\"grey-100-bg\">{{candidate.salary}}</td><td><span>\n{{candidate.experience}}</span></td><td class=\"grey-100-bg\"><span>{{candidate.profession}}</span></td><td><span>\n{{candidate.duration_per_company}}</span></td><td class=\"grey-100-bg\"><span>{{candidate.duration_in_charge}}</span>\n</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/analyst/detail/partial/route.candidateSimilar.html","<div ng-if=\"vm.loading\" layout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"grey-200-bg p-30\"><div \nclass=\"pl-25 pr-25 pt-15 pb-15 h2\">Cargando información por favor espere...</div></div><div \nng-if=\"vm.candidates.length == 0\" layout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"grey-200-bg p-30 mt-10\">\n<div class=\"pl-25 pr-25 pt-15 pb-15 h2\">No se encontraron candidatos similares al proceso.</div></div><div \nng-if=\"!vm.loading && vm.candidates.length > 0\"><div class=\"container\"><div data-pagination \nng-if=\"vm.pager.pages.length\" layout=\"row\" layout-align=\"center center\"><span \nng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(1)\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(\'backflash\')\" ng-mouseleave=\"vm.setHover(\'backflash\')\" \nmd-colors=\"(vm.misc.hover.backflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-left\"></i> \n</span><span ng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(vm.pager.currentPage - 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'back\')\" ng-mouseleave=\"vm.setHover(\'back\')\" \nmd-colors=\"(vm.misc.hover.back)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-left\"></i></span><ul><li \nng-repeat=\"page in vm.pager.pages\" ng-class=\"{current:vm.pager.currentPage === page}\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(page)\" ng-mouseleave=\"vm.setHover(page)\" \nmd-colors=\"(vm.misc.hover[page] || vm.pager.currentPage === page)?{color: \'accent\'}:{color: \'primary\'}\"><span \nng-click=\"vm.setPage(page)\">{{page}}</span></li></ul><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.currentPage + 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'after\')\" ng-mouseleave=\"vm.setHover(\'after\')\" \nmd-colors=\"(vm.misc.hover.after)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-right\"></i> </span><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.totalPages)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'afterflash\')\" ng-mouseleave=\"vm.setHover(\'afterflash\')\" \nmd-colors=\"(vm.misc.hover.afterflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-right\"></i>\n</span></div></div><div layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nng-repeat=\"candidate in vm.misc.candidates track by $index\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" \nflex-xl=\"33\"><ms-widget-front class=\"white-bg\" \nng-style=\"{\'border-top-color\':vm.getThemeColor(\'accent\'),\'border-top-width\': \'3px\',\n                \'border-top-style\': \'solid\'}\">\n<div class=\"pl-16 pr-16 pt-20 pb-30 grey-50-bg border-bottom\" layout=\"row\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"start start\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\"><div class=\"mb-10\"><img class=\"profile-image avatar huge\" \nng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\"></div><div layout=\"column\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"space-between\" class=\"h-80\"><div \nng-click=\"vm.showHV(candidate)\" class=\"h2 cursor-pointer text-underlined font-weight-500 grey-600-fg\">\n{{candidate.name | capitalize:true}}</div><div class=\"h5 font-weight-400 grey-500-fg\">\n{{candidate.profession | capitalize:true}} <span \nng-if=\"candidate.count_other_profession && candidate.count_other_profession > 0\">{{candidate.count_other_profession}}\n</span></div><div class=\"h5 font-weight-400 grey-500-fg\">{{candidate.advanced_study | capitalize:true}} <span \nng-if=\"candidate.count_other_study && candidate.count_other_study > 0\">{{candidate.count_other_study}}</span></div>\n</div></div><div class=\"pl-16 pr-16 pt-5 pb-5\" layout=\"column\" layout-align=\"space-between\"><div hide-xs hide-sm \nhide-md layout=\"row\" layout-align=\"start start\" flex=\"100\" layout-xs=\"column\" layout-align-xs=\"start center\" \nlayout-align-sm=\"start center\" layout-align-md=\"start start\" layout-align-lg=\"start start\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" layout-wrap class=\"h-70\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h5 subtitle secondary-text mb-5 font-weight-400 grey-500-fg\">Edad</div><div class=\"h1 font-weight-500\">\n{{candidate.age}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" \nflex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" \nflex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text mb-5 font-weight-400 grey-500-fg\">Empresas</div>\n<div class=\"h1 font-weight-500\">{{candidate.business}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h4 subtitle secondary-text mb-5 font-weight-400 grey-500-fg\">Cargos</div><div class=\"h1 font-weight-500\">\n{{candidate.charges}}</div></div></div><div layout=\"row\" layout-align=\"space-around center\" class=\"border-top\" hide-sm \nhide-xs hide-md></div><div hide-xs hide-sm hide-md layout=\"row\" layout-align=\"start start\" flex=\"100\" \nlayout-xs=\"column\" layout-align-xs=\"start center\" layout-align-sm=\"start center\" layout-align-md=\"start center\" \nlayout-align-lg=\"start center\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" layout-wrap class=\"h-90\"><div \nclass=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" \nflex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"h5 subtitle secondary-text mb-5 h-40 font-weight-400 grey-500-fg\">Experiencia</div>\n<div class=\"text-date-info font-weight-500 line-height maxStageCandidate h-40\">{{candidate.experience}}</div></div><div\n class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" \nflex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nlayout=\"column\" layout-align=\"center center\" class=\"h5 subtitle secondary-text mb-5 h-40 font-weight-400 grey-500-fg\">\n<div class=\"line-height\">Duración por empresa</div></div><div \nclass=\"text-date-info font-weight-500 line-height maxStageCandidate h-40\">{{candidate.duration_per_company}}</div>\n</div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" \nflex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\">\n<div layout=\"column\" layout-align=\"center center\" \nclass=\"h5 subtitle secondary-text mb-5 h-40 font-weight-400 grey-500-fg\"><div class=\"line-height\">Duración por cargo\n</div></div><div class=\"text-date-info font-weight-500 line-height maxStageCandidate h-40\">\n{{candidate.duration_in_charge}}</div></div></div><div layout=\"column\" layout-align=\"space-between\" hide-lg hide-xl>\n<div layout=\"row\" layout-align=\"space-between\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text blue-300-fg mb-5\">Edad\n</div><div class=\"h1 font-weight-500\">{{candidate.age}}</div></div><div class=\"mt-10 mb-10 text-center\" \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h5 subtitle secondary-text blue-300-fg mb-5\">Experiencia</div><div \nclass=\"text-date-info font-weight-500 line-height\">{{candidate.experience}}</div></div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" \nflex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" \nflex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text blue-300-fg mb-5\">Empresas</div><div \nclass=\"h1 font-weight-500\">{{candidate.business}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text blue-300-fg mb-5\">\nDuración/cargo</div><div class=\"text-date-info font-weight-500 line-height\">{{candidate.duration_in_charge}}</div>\n</div></div><div layout=\"row\" layout-align=\"space-between\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h4 subtitle secondary-text blue-300-fg mb-5\">\nCargos</div><div class=\"h1 font-weight-500\">{{candidate.charges}}</div></div><div class=\"mt-10 mb-10 text-center\" \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h5 subtitle secondary-text blue-300-fg mb-5\">Duración/empresa</div><div \nclass=\"text-date-info font-weight-500 line-height\">{{candidate.duration_per_company}}</div></div></div></div><div \nclass=\"border-top\"></div><div layout=\"row\" class=\"pt-10 pb-10\" layout-wrap><div layout=\"row\" \nlayout-align=\"center center\" class=\"text-center titleInfoCandidate all-width\"><span class=\"font-weight-400 h2\">Procesos\n</span></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" \nflex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\">\n<div class=\"h4 subtitle secondary-text mb-5 h-40 line-height font-weight-400 grey-500-fg\">Aplicados</div><div \nclass=\"h1 font-weight-500\">{{candidate.all_process}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h4 subtitle secondary-text mb-5 h-40 line-height font-weight-400 grey-500-fg\">Últimos 6 meses</div><div \nclass=\"h1 font-weight-500\">{{candidate.process_before}}</div></div><div class=\"mt-10 mb-10 text-center\" \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h4 subtitle secondary-text mb-5 h-40 line-height font-weight-400 grey-500-fg\">Máxima etapa alcanzada</div><div \nclass=\"font-weight-500 line-height maxStageCandidate\">{{candidate.max_stage.name_corto}}</div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\"><div \nclass=\"h4 subtitle secondary-text\">Última actualización: &nbsp;</div><div class=\"h4 font-weight-500\" \nng-if=\"candidate.last_update.stringDateInMonth\" \nng-class=\"{\'red-300-fg\':candidate.last_update.serializeDate.months > 5}\">{{candidate.last_update.stringDateInMonth}}\n</div><div class=\"h4 font-weight-500\" ng-if=\"!candidate.last_update.stringDateInMonth\" \nng-class=\"{\'red-300-fg\':candidate.updated_at.serializeDate.months > 5}\">{{candidate.updated_at.stringDateInMonth}}\n</div></div></div></div><div class=\"grey-50-bg border-top pl-16 pr-16 pt-5 pb-5\" layout=\"row\" \nlayout-align=\"space-between\" layout-align-xs=\"start start\" layout-align-sm=\"start start\" layout-align-md=\"start start\" \nlayout-align-lg=\"space-between start\" layout-align-xl=\"space-between center\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"column\" layout-gt-md=\"column\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" layout-wrap><div layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.showHV(candidate)\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Ver hoja de vida</md-button>\n</div><div><md-button ng-if=\"candidate.stage.id != 2\" ng-click=\"vm.preseleccionar(candidate)\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Preseleccionar</md-button>\n<md-button ng-if=\"candidate.stage.id == 2\" ng-click=\"vm.retirarPreseleccionar(candidate)\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Retirar preselección</md-button>\n</div></div></ms-widget-front></ms-widget></div><div class=\"container\"><div data-pagination \nng-if=\"vm.pager.pages.length\" layout=\"row\" layout-align=\"center center\"><span \nng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(1)\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(\'backflash\')\" ng-mouseleave=\"vm.setHover(\'backflash\')\" \nmd-colors=\"(vm.misc.hover.backflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-left\"></i> \n</span><span ng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(vm.pager.currentPage - 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'back\')\" ng-mouseleave=\"vm.setHover(\'back\')\" \nmd-colors=\"(vm.misc.hover.back)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-left\"></i></span><ul><li \nng-repeat=\"page in vm.pager.pages\" ng-class=\"{current:vm.pager.currentPage === page}\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(page)\" ng-mouseleave=\"vm.setHover(page)\" \nmd-colors=\"(vm.misc.hover[page] || vm.pager.currentPage === page)?{color: \'accent\'}:{color: \'primary\'}\"><span \nng-click=\"vm.setPage(page)\">{{page}}</span></li></ul><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.currentPage + 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'after\')\" ng-mouseleave=\"vm.setHover(\'after\')\" \nmd-colors=\"(vm.misc.hover.after)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-right\"></i> </span><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.totalPages)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'afterflash\')\" ng-mouseleave=\"vm.setHover(\'afterflash\')\" \nmd-colors=\"(vm.misc.hover.afterflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-right\"></i>\n</span></div></div></div>");
$templateCache.put("app/main/analyst/detail/partial/route.detail.html","<div id=\"candidate-detail\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"content\" \nng-if=\"vm.candidate\"><div class=\"pl-30 pr-30 pb-30\" layout=\"column\"><div layout=\"row\" layout-align=\"end center\" \nclass=\"mb-10\"><md-button ng-click=\"vm.pageCandidate()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Regresar</md-button>\n</div><div class=\"mb-15\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div><md-checkbox \nclass=\"no-margin\" ng-model=\"vm.onlyCandidateNotView\" aria-label=\"Only no viewed\" \nng-change=\"vm.changeOnlyCandidateNotView()\">Navegar solo hojas de vida no vistas hasta el momento</md-checkbox></div>\n<div layout=\"row\" layout-align=\"space-between center\"><div class=\"pt-10 pr-0 pb-10 pl-10\">\nCandidato {{vm.positionCandidate.positionShow}} de {{vm.misc.candidatesRequest.length}}</div><div layout=\"row\" \nlayout-aling=\"space-between\"><span class=\"cursor-pointer\" ng-hide=\"vm.positionCandidate.positionShow == 1\" \nng-click=\"vm.backCandidate()\"><i class=\"icon-chevron-left s30 grey-500-fg\"></i> </span><span class=\"cursor-pointer\" \nng-hide=\"vm.positionCandidate.positionShow == vm.misc.candidatesRequest.length\" ng-click=\"vm.nextCandidate()\"><i \nclass=\"icon-chevron-right s30 grey-500-fg\"></i></span></div></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"bt\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"h1 font-weight-200 light-blue-500-fg\">{{vm.candidate.nombre | capitalize:true}}</div><div layout=\"row\" \nlayout-align=\"start center\" class=\"p-10 cursor-pointer\" ng-click=\"vm.markAsFavorite()\"><div><i \nclass=\"icon-star subtitle secondary-text\" \nng-class=\"{\'yellow-600-fg\': vm.candidate.favorita, \'grey-400-fg\': !vm.candidate.favorita}\" aria-label=\"Favorita\"></i>\n</div></div><div layout=\"row\" layout-align=\"space-between center\" ng-click=\"vm.setScheduleCandidate(candidate)\" \nclass=\"cursor-pointer\"><md-tooltip md-direction=\"top\"><span ng-if=\"!vm.candidate.cita.cita.nameShowFormat\">\nAgendar citas</span> <span ng-if=\"vm.candidate.cita.cita.nameShowFormat\">\n{{vm.candidate.cita.cita.nameShowFormat | capitalize:true}} (Confirmada)</span></md-tooltip><div><i \nclass=\"s22 icon-calendar-check-multiple mr-10 subtitle secondary-text\"></i></div></div><div \nng-click=\"vm.showMarker?vm.showMarker = false : vm.showMarker = true; \" class=\"cursor-pointer\"><md-tooltip \nmd-direction=\"top\">Indica si la hoja de vida ha sido marcada</md-tooltip><i \nclass=\"s22 icon-bookmark subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!vm.candidate.origen_custom\"></i> <i \nclass=\"s22 icon-bookmark subtitle secondary-text pr-10\" ng-if=\"vm.candidate.origen_custom\" \nmd-colors=\"{color:\'accent\'}\"></i></div><div class=\"pl-16 pr-16\" layout=\"row\" layout-align=\"space-between center\" \nng-show=\"vm.showMarker\"><md-input-container class=\"mr-5\"><div class=\"h4 grey-fg font-weight-300\"><label>Marcar</label>\n</div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.markerSelected\" class=\"\"><md-option \nng-repeat=\"(key,data) in vm.misc.lists.tipos_marca_hv track by $index\" ng-selected=\"key == vm.candidate.origen_custom\" \nng-value=\"key\">{{data}}</md-option></md-select></md-input-container><md-button ng-click=\"vm.saveMarker()\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg no-margin\">Guardar</md-button>\n</div><div class=\"p-10 cursor-pointer text-underlined orange-600-fg\" ng-click=\"vm.openShowCandidateNotesDialog()\">\nVer notas <span class=\"tab-badge orange-600-bg\">{{vm.candidate.notas.length}}</span></div><div \nclass=\"p-10 cursor-pointer text-underlined blue-600-fg\" ng-click=\"vm.openShowCandidateHistoryDialog()\">Historial <span \nclass=\"tab-badge blue-600-bg\">{{vm.history.length}}</span></div></div><div class=\"md-subhead\" layout=\"row\"><span \nclass=\"font-weight-200\">Documento:</span> <span class=\"font-weight-300\">{{vm.candidate.cedula}}</span></div></div>\n</div><div class=\"bb\" layout=\"row\" layout-align=\"end center\" layout-wrap><div class=\"p-10\"><md-button \nng-click=\"vm.openRecommendCandidateDialog()\" aria-label=\"Recommend candidate\" \nclass=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin borderButtom\" \nmd-colors=\"(vm.misc.hover.recomendCandidate)?{\'background-color\':\'primary\'}:{\'border-color\':\'primary\',\'color\':\'primary\'}\" \nng-mouseenter=\"vm.setHover(\'recomendCandidate\')\" ng-mouseleave=\"vm.setHover(\'recomendCandidate\')\">Recomendar candidato\n</md-button></div><div class=\"p-10\"><md-button ng-click=\"vm.showReportForToclientFn()\" \naria-label=\"Recommend candidate\" class=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin borderButtom\" \nmd-colors=\"(vm.misc.hover.reportForClient)?{\'background-color\':\'primary\'}:{\'border-color\':\'primary\',\'color\':\'primary\'}\" \nng-mouseenter=\"vm.setHover(\'reportForClient\')\" ng-mouseleave=\"vm.setHover(\'reportForClient\')\">Informe para el cliente\n</md-button></div><div class=\"p-10\"><md-menu><md-button aria-label=\"Open phone interactions menu\" \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\" \nng-style=\"{\'background-color\':vm.stageSelected.color}\" ng-click=\"$mdOpenMenu()\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>{{vm.stageSelected.name}} </span><i class=\"icon-chevron-down\"></i></div>\n</md-button><md-menu-content width=\"12\" class=\"no-padding\"><md-menu-item \nng-repeat=\"stage in vm.stages track by stage.id\"><md-button ng-click=\"vm.changeStage(stage)\" \nclass=\"line-height-30 remove-uppercase pl-20 pr-20 no-margin bb text-right\" \nng-class=\"(stage.personalizada == 1 && stage.id != vm.candidate.etapa.id)?\'grey-200-bg\':\'\'\" \nng-style=\"{\'background-color\':(stage.id == vm.stageSelected.id)?stage.color:\'white\',\'color\':(stage.id == vm.stageSelected.id)?\'white\':\'\'}\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"mr-10 w-20\"><i ng-show=\"stage.personalizada\" class=\"s20\" \nng-class=\"stage.aprueba == 1?\'icon-check light-green-500-fg\':\'icon-close red-500-fg\'\"></i></div><span>\n{{stage.name_corto}}</span></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div \nng-if=\"!vm.loading\"><div ng-repeat=\"block in vm.blocks\" ng-if=\"!vm.showReporrForTheClient && !vm.showStageSelected\" \nclass=\"report-for-client\"><div ng-if=\"block.name == \'personales\' && true\" \nng-include=\"\'app/main/templates/resume/personal-info.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'perfil\'\" ng-include=\"\'app/main/templates/resume/one-column-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'experiencia\'\" \nng-include=\"\'app/main/templates/resume/laboral-experience.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'estudios_formales\'\" ng-include=\"\'app/main/templates/resume/formal-study.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'estudios_no_formales\'\" \nng-include=\"\'app/main/templates/resume/non-formal-study.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'laboral\'\" ng-include=\"\'app/main/templates/resume/one-column-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'contacto_emergencia\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'idiomas\'\" ng-include=\"\'app/main/templates/resume/languages.html\'\" onload=\"item = block.data\">\n</div><div ng-if=\"block.name == \'grupo_familiar\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'hijos\'\" \nng-include=\"\'app/main/templates/resume/childrens.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'madre\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'padre\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'conyuge\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'viven_usted\'\" \nng-include=\"\'app/main/templates/resume/two-columns.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'vivienda\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'contacto\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'salud\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'adicional\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div></div><div \nng-if=\"vm.showReporrForTheClient\" class=\"report-for-client\"><div ng-repeat=\"block in vm.blocksReportForClient\"><div \nng-include=\"\'app/main/templates/block-generic/update/\' + block.type + \'.html\'\" \nng-init=\"item = block;root = vm.reportClientData\"></div></div><div layout=\"row\" layout-align=\"end\" class=\"p-10\">\n<md-button ng-click=\"vm.showReportForToclientFn()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">\nRegresar al detalle del candidato</md-button><md-button ng-click=\"vm.saveReportForToclientFn()\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Guardar</md-button></div>\n</div><div ng-if=\"vm.showStageSelected\"><div layout=\"row\" layout-align=\"end end\"><md-button ng-click=\"vm.showHV()\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">\nRegresar al detalle del candidato</md-button></div><div layout=\"column\" layout-align=\"space-between end\" \nng-if=\"vm.misc.values\" class=\"pr-30\"><div layout=\"row\" layout-aling=\"start center\"><span class=\"h4 font-weight-300\">\nFecha de creación:&nbsp; </span><span class=\"h4 font-weight-500\">{{vm.misc.values.created_at | capitalize:true}}</span>\n</div><div layout=\"row\" layout-aling=\"start center\"><span class=\"h4 font-weight-300\">Fecha de actualización:&nbsp; \n</span><span class=\"h4 font-weight-500\">{{vm.misc.values.updated_at | capitalize:true}}</span></div><div layout=\"row\" \nlayout-aling=\"start center\"><span class=\"h4 font-weight-300\">Consultor que hizo la modificación:&nbsp; </span><span \nclass=\"h4 font-weight-500\">{{vm.misc.values.analista}}</span></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.showStageSelected && !vm.editStage\"><md-button aria-label=\"No aprobar\" \nclass=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 margin borderButtom\" \nmd-colors=\"(vm.misc.hover.downloadPdfStage)?{\'background-color\':\'accent\'}:{\'border-color\':\'accent\',\'color\':\'accent\'}\" \nng-mouseenter=\"vm.setHover(\'downloadPdfStage\')\" ng-mouseleave=\"vm.setHover(\'downloadPdfStage\')\" \nng-click=\"vm.downloadPdfStage()\">PDF</md-button><md-button aria-label=\"No aprobar\" \nclass=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 margin borderButtom\" \nmd-colors=\"(vm.misc.hover.updateStage)?{\'background-color\':\'primary\'}:{\'border-color\':\'primary\',\'color\':\'primary\'}\" \nng-mouseenter=\"vm.setHover(\'updateStage\')\" ng-mouseleave=\"vm.setHover(\'updateStage\')\" ng-click=\"vm.updateStage()\">\nMODIFICAR</md-button><md-button aria-label=\"No aprobar\" \nclass=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 margin borderButtom\" \nmd-colors=\"(vm.misc.hover.assignStage)?{\'background-color\':\'accent\'}:{\'border-color\':\'accent\',\'color\':\'accent\'}\" \nng-mouseenter=\"vm.setHover(\'assignStage\')\" ng-mouseleave=\"vm.setHover(\'assignStage\')\" ng-click=\"vm.assignStage()\">\nPASAR A ESTA ETAPA</md-button></div><div ng-if=\"vm.stage.etapa == \'entrevista_jefe\'\" class=\"p-17\"><span \nclass=\"h4 font-weight-500\">Algunas recomendaciones para realizar entrevistas</span><table \nclass=\"row-border hover table-entrevista-jefe\"><thead><tr><th md-colors=\"{background: \'accent\'}\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title white-fg\">Al iniciar</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">Durante</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title white-fg\">A terminar</span></div></th></tr></thead><tbody><tr><td \nclass=\"b h4 font-weight-300 p-8\"><u>\nAtienda en la hora acordada al candidato Elimine posibles interrupciones Preséntese usted: Nombre y cargo Establezca una relación cordial: Rompa el hielo Explique el propósito de la entrevista: Cuéntele que quiere conocer su trayectoria profesional, sus logros y motivaciones a través de situaciones laborales recientes Si la persona le pide detalles del cargo y la compañía, cuéntele que al final de la entrevista le contará acerca del tema\n</u></td><td class=\"b h4 font-weight-300 p-8\"><u>\nEvite temas de opinión personal (Ej: política/ religión) Indague temas relacionados con su experiencia Sus preguntas deben buscar respuestas que evidencien comportamientos, teniendo en cuenta el contexto, lo que la persona hizo (el qué y el cómo) y los resultados obtenidos\n</u></td><td class=\"b h4 font-weight-300 p-8\"><u>\nPermita que el entrevistado realice preguntas Explique las responsabilidades principales del cargo Explique las siguientes etapas del proceso Diligencie el informe de selección de jefe inmediato\n</u></td></tr></tbody></table></div><div ng-repeat=\"block in vm.blocksStage\"><div \nng-include=\"\'app/main/templates/block-generic/update/\' + block.type + \'.html\'\" \nng-init=\"item = block; root = vm.stageData\" ng-if=\"vm.editStage\"></div><div \nng-include=\"\'app/main/templates/block-generic/read/\' + block.type + \'.html\'\" \nng-init=\"item = block; root = vm.stageData\" ng-if=\"!vm.editStage\"></div></div><div class=\"mt-15\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.editStage\"><div ng-if=\"vm.modifiStage\"><md-button aria-label=\"No aprobar\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.cancelUpdate()\">\nCancelar</md-button><md-button aria-label=\"aprobar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateUpdate()\">Guardar</md-button></div><div ng-if=\"vm.stage.req_aprobacion && vm.approbeStage\">\n<md-button aria-label=\"No aprobar\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataStage(0,true)\">No aprobar</md-button><md-button aria-label=\"aprobar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataStage(1,true)\">Aprobar</md-button></div><div \nng-if=\"!vm.stage.req_aprobacion && vm.approbeStage\"><md-button aria-label=\"Guardar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataStage(1,false)\">Guardar</md-button></div></div></div></div><div ng-if=\"vm.loading\" \nclass=\"p-30 md-title text-center\">Cargando contenido, por favor espere...</div></div></div>");
$templateCache.put("app/main/analyst/detail/partial/route.index.html","<div layout-wrap layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"pb-10 bb\"><div><div ng-if=\"vm.misc.filter.length > 0\" class=\"h3 font-weight-400\">Filtros Seleccionados</div>\n</div><div layout=\"row\"><md-button ng-click=\"vm.showfilterCandidate()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg mr-5\">Filtrar candidatos\n</md-button><md-button ng-if=\"vm.request.el_empleo_id\" ng-click=\"vm.importCandidateElempleo()\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Importar candidatos del empleo\n</md-button></div></div><div><div ng-repeat=\"(key,filter) in vm.misc.filter | orderBy : filter.order track by $index \">\n<div class=\"badgeFilter\" ng-if=\"filter.notArray\" layout=\"row\"><span>{{filter.valuesShow}}</span> <button \nng-click=\"vm.deleteFilter(filter,key);\" class=\"md-chip-remove\"><md-icon md-font-icon=\"icon-close\" \nmd-colors=\"{color:\'accent\'}\"></md-icon></button></div><div class=\"badgeFilter\" ng-if=\"!filter.notArray\" \nng-repeat=\"value in filter.valuesShow track by $index\" layout=\"row\"><span>{{value}}</span> <button \nng-click=\"vm.deleteFilter(filter,key,$index);\" class=\"md-chip-remove\"><md-icon md-font-icon=\"icon-close\" \nmd-colors=\"{color:\'accent\'}\"></md-icon></button></div></div></div></div><div ng-if=\"vm.loading\" layout=\"row\" \nflex=\"100\" layout-align=\"center center\" class=\"grey-200-bg p-30\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2\">\nCargando información por favor espere...</div></div><div ng-if=\"!vm.loading && !vm.candidates.length\" layout=\"row\" \nflex=\"100\" layout-align=\"center center\" class=\"grey-200-bg p-30\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2\">\nNo se encontraron candidatos bajo los parametros de busqueda.</div></div><div \nng-if=\"(!vm.loading && vm.candidates.length > 0) && !vm.showDetailCandidate\"><div class=\"container\"><div \ndata-pagination ng-if=\"vm.pager.pages.length\" layout=\"row\" layout-align=\"center center\"><span \nng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(1)\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(\'backflash\')\" ng-mouseleave=\"vm.setHover(\'backflash\')\" \nmd-colors=\"(vm.misc.hover.backflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-left\"></i> \n</span><span ng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(vm.pager.currentPage - 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'back\')\" ng-mouseleave=\"vm.setHover(\'back\')\" \nmd-colors=\"(vm.misc.hover.back)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-left\"></i></span><ul><li \nng-repeat=\"page in vm.pager.pages\" ng-class=\"{current:vm.pager.currentPage === page}\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(page)\" ng-mouseleave=\"vm.setHover(page)\" \nmd-colors=\"(vm.misc.hover[page] || vm.pager.currentPage === page)?{color: \'accent\'}:{color: \'primary\'}\"><span \nng-click=\"vm.setPage(page)\">{{page}}</span></li></ul><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.currentPage + 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'after\')\" ng-mouseleave=\"vm.setHover(\'after\')\" \nmd-colors=\"(vm.misc.hover.after)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-right\"></i> </span><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.totalPages)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'afterflash\')\" ng-mouseleave=\"vm.setHover(\'afterflash\')\" \nmd-colors=\"(vm.misc.hover.afterflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-right\"></i>\n</span></div></div><div layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nng-repeat=\"candidate in vm.candidates track by $index\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" \nflex-xl=\"25\"><ms-widget-front class=\"white-bg\" \nng-style=\"{\'border-top-color\':vm.getThemeColor(\'accent\'),\'border-top-width\': \'3px\',\n            \'border-top-style\': \'solid\'}\">\n<div class=\"pl-16 pr-16 pt-20 pb-30 grey-50-bg border-bottom\" layout=\"row\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"start start\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\"><div class=\"mb-10\"><img class=\"profile-image avatar huge\" \nng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\"></div><div layout=\"column\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"space-between\" class=\"h-90\"><div \nng-click=\"vm.goToCandidateDetail(candidate.id,$index)\" \nclass=\"h2 cursor-pointer text-underlined font-weight-500 grey-600-fg\">{{candidate.name | capitalize:true}}</div><div \nclass=\"candidateStageBadge text-center\" ng-style=\"{\'background-color\':candidate.stage.color}\"><span \nclass=\"h5 white-fg\">{{(candidate.stage.short_name?candidate.stage.short_name:candidate.stage.name_corto)}}</span></div>\n<div layout=\"row\" layout-align=\"start center\" \nng-if=\"candidate.stage.id == 10 && vm.candidatesBackup[$index].bloques_etapas_candidato.data[10].fecha_envio_notificacion\">\n<span class=\"font-weight-500 grey-600-fg\">Fecha notificación envio:</span> <span class=\"font-weight-400 grey-600-fg\">\n{{vm.candidatesBackup[$index].bloques_etapas_candidato.data[10].fecha_envio_notificacion}}</span></div><div \nng-if=\"candidate.stage.id == 10 && !vm.candidatesBackup[$index].bloques_etapas_candidato.data[10].fecha_envio_notificacion\">\n<span class=\"cursor-pointer text-underlined font-weight-400 grey-600-fg\" \nng-click=\"vm.sendNotificacion(candidate,$index)\">Enviar notificacion de descarto</span></div><div layout=\"row\" \nclass=\"h5 font-weight-400 grey-500-fg mt-5\" ng-if=\"candidate.profession\"><span class=\"pr-5\">\n{{candidate.profession | capitalize:true}} </span><span \nng-if=\"candidate.count_other_profession && candidate.count_other_profession > 0\">{{candidate.count_other_profession}}\n</span></div><div layout=\"row\" class=\"h5 font-weight-400 grey-500-fg mt-5\" ng-if=\"candidate.advanced_study\"><span \nclass=\"pr-5\">{{candidate.advanced_study | capitalize:true}} </span><span \nng-if=\"candidate.count_other_study && candidate.count_other_study > 0\">{{candidate.count_other_study}}</span></div>\n</div></div><div class=\"pl-16 pr-16 pt-5 pb-5\" layout=\"column\" layout-align=\"space-between\"><div hide-xs hide-sm \nhide-md layout=\"row\" layout-align=\"start start\" flex=\"100\" layout-xs=\"column\" layout-align-xs=\"start center\" \nlayout-align-sm=\"start center\" layout-align-md=\"start start\" layout-align-lg=\"start start\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" layout-wrap class=\"h-70\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h5 subtitle secondary-text mb-5 font-weight-400 grey-500-fg\">Edad</div><div class=\"h1 font-weight-500\">\n{{candidate.age}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" \nflex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" \nflex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text mb-5 font-weight-400 grey-500-fg\">Empresas</div>\n<div class=\"h1 font-weight-500\">{{candidate.business}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h4 subtitle secondary-text mb-5 font-weight-400 grey-500-fg\">Cargos</div><div class=\"h1 font-weight-500\">\n{{candidate.charges}}</div></div></div><div layout=\"row\" layout-align=\"space-around center\" class=\"border-top\" hide-sm \nhide-xs hide-md></div><div hide-xs hide-sm hide-md layout=\"row\" layout-align=\"start start\" flex=\"100\" \nlayout-xs=\"column\" layout-align-xs=\"start center\" layout-align-sm=\"start center\" layout-align-md=\"start center\" \nlayout-align-lg=\"start center\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" layout-wrap class=\"h-90\"><div \nclass=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" \nflex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"h5 subtitle secondary-text mb-5 h-40 font-weight-400 grey-500-fg\">Experiencia</div>\n<div class=\"text-date-info font-weight-500 line-height maxStageCandidate h-40\">{{candidate.experience}}</div></div><div\n class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" \nflex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nlayout=\"column\" layout-align=\"center center\" class=\"h5 subtitle secondary-text mb-5 h-40 font-weight-400 grey-500-fg\">\n<div class=\"line-height\">Duración por empresa</div></div><div \nclass=\"text-date-info font-weight-500 line-height maxStageCandidate h-40\">{{candidate.duration_per_company}}</div>\n</div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" \nflex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\">\n<div layout=\"column\" layout-align=\"center center\" \nclass=\"h5 subtitle secondary-text mb-5 h-40 font-weight-400 grey-500-fg\"><div class=\"line-height\">Duración por cargo\n</div></div><div class=\"text-date-info font-weight-500 line-height maxStageCandidate h-40\">\n{{candidate.duration_in_charge}}</div></div></div><div layout=\"column\" layout-align=\"space-between\" hide-lg hide-xl>\n<div layout=\"row\" layout-align=\"space-between\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text blue-300-fg mb-5\">Edad\n</div><div class=\"h1 font-weight-500\">{{candidate.age}}</div></div><div class=\"mt-10 mb-10 text-center\" \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h5 subtitle secondary-text blue-300-fg mb-5\">Experiencia</div><div \nclass=\"text-date-info font-weight-500 line-height\">{{candidate.experience}}</div></div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" \nflex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" \nflex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text blue-300-fg mb-5\">Empresas</div><div \nclass=\"h1 font-weight-500\">{{candidate.business}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text blue-300-fg mb-5\">\nDuración/cargo</div><div class=\"text-date-info font-weight-500 line-height\">{{candidate.duration_in_charge}}</div>\n</div></div><div layout=\"row\" layout-align=\"space-between\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h4 subtitle secondary-text blue-300-fg mb-5\">\nCargos</div><div class=\"h1 font-weight-500\">{{candidate.charges}}</div></div><div class=\"mt-10 mb-10 text-center\" \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h5 subtitle secondary-text blue-300-fg mb-5\">Duración/empresa</div><div \nclass=\"text-date-info font-weight-500 line-height\">{{candidate.duration_per_company}}</div></div></div></div><div \nclass=\"border-top\"></div><div layout=\"row\" class=\"pt-10 pb-10\" layout-wrap><div layout=\"row\" \nlayout-align=\"center center\" class=\"text-center titleInfoCandidate all-width\"><span class=\"font-weight-400 h2\">Procesos\n</span></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" \nflex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\">\n<div class=\"h4 subtitle secondary-text mb-5 h-40 line-height font-weight-400 grey-500-fg\">Aplicados</div><div \nclass=\"h1 font-weight-500\">{{candidate.all_process}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h4 subtitle secondary-text mb-5 h-40 line-height font-weight-400 grey-500-fg\">Últimos 6 meses</div><div \nclass=\"h1 font-weight-500\">{{candidate.process_before}}</div></div><div class=\"mt-10 mb-10 text-center\" \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h4 subtitle secondary-text mb-5 h-40 line-height font-weight-400 grey-500-fg\">Máxima etapa alcanzada</div><div \nclass=\"font-weight-500 line-height maxStageCandidate\">{{candidate.max_stage.name_corto}}</div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\"><div \nclass=\"h4 subtitle secondary-text\">Última actualización: &nbsp;</div><div class=\"h4 font-weight-500\" \nng-if=\"candidate.last_update.stringDateInMonth\" \nng-class=\"{\'red-300-fg\':candidate.last_update.serializeDate.months > 5}\">{{candidate.last_update.stringDateInMonth}}\n</div><div class=\"h4 font-weight-500\" ng-if=\"!candidate.last_update.stringDateInMonth\" \nng-class=\"{\'red-300-fg\':candidate.updated_at.serializeDate.months > 5}\">{{candidate.updated_at.stringDateInMonth}}\n</div></div></div></div><div layout=\"column\"><div class=\"h-60\"><div class=\"grey-50-bg border-top pl-16 pr-16 pb-5\" \nlayout=\"row\" layout-align=\"space-between center\" ng-show=\"candidate.showMarker && !candidate.loadingMarker\">\n<md-input-container><div class=\"h4 grey-fg font-weight-300\"><label>Marcar</label></div><md-select \naria-label=\"Seleccionar Etapa\" ng-model=\"candidate.markerSelected\" class=\"\"><md-option \nng-repeat=\"(key,data) in vm.request.lists.tipos_marca_hv track by $index\" ng-selected=\"key == candidate.marker\" \nng-value=\"key\">{{data}}</md-option></md-select></md-input-container><md-button ng-click=\"vm.saveMarker(candidate)\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg no-margin\" \nng-class=\"candidate.markerSelected == candidate.marker ? \'md-warn\' : \'md-primary\' \">\n{{candidate.markerSelected == candidate.marker ? \'Desmarcar\' : \'Guardar\' }}</md-button></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"candidate.loadingMarker\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div></div><div \nclass=\"grey-50-bg border-top pl-16 pr-16 pt-5 pb-5 all-width\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><md-tooltip md-direction=\"top\">\nIndica si la hoja de vida ha sido vista en este proceso</md-tooltip><i \nclass=\"s22 icon-eye subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!candidate.view\"></i> <i \nclass=\"s22 icon-eye subtitle secondary-text pr-10\" ng-if=\"candidate.view\" md-colors=\"{color:\'accent\'}\"></i></div><div>\n<md-tooltip md-direction=\"top\" ng-if=\"!candidate.recommended\">Indica si es una hoja de vida recomendada.</md-tooltip>\n<md-tooltip md-direction=\"top\" ng-if=\"candidate.recommended\">\nHoja de vida recomendada por: {{candidate.recomendaciones[0].analista.name}} para {{candidate.recomendaciones[0].cargo.name}}\n</md-tooltip><i class=\"s22 icon-shopping subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!candidate.recommended\"></i>\n <i class=\"s22 icon-shopping subtitle secondary-text pr-10\" ng-if=\"candidate.recommended\" md-colors=\"{color:\'accent\'}\">\n</i></div><div><md-tooltip md-direction=\"top\" ng-if=\"!candidate.referred\">Indica si es una hoja de vida referida.\n</md-tooltip><md-tooltip md-direction=\"top\" ng-if=\"candidate.referred\">\nHoja de vida referida por: {{candidate.referredBy[0].referente}}</md-tooltip><i \nclass=\"s22 icon-swap-horizontal subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!candidate.referred\" \nng-click=\"vm.setReferido(candidate)\"></i> <i class=\"s22 icon-swap-horizontal subtitle secondary-text pr-10\" \nng-if=\"candidate.referred\" ng-click=\"vm.showDialogRemoveReferred($event,candidate)\" md-colors=\"{color:\'accent\'}\"></i>\n</div><div><md-tooltip md-direction=\"top\">Indica si el candidato ha participado en procesos anteriores en la empresa\n</md-tooltip><i class=\"s22 icon-basket subtitle secondary-text pr-10 grey-400-fg\" \nng-if=\"!candidate.max_stage || !candidate.max_stage.name\"></i> <i \nclass=\"s22 icon-basket subtitle secondary-text pr-10\" ng-if=\"candidate.max_stage && candidate.max_stage.name\" \nmd-colors=\"{color:\'accent\'}\"></i></div><div ng-click=\"vm.addFavorite(candidate);\" class=\"cursor-pointer\"><md-tooltip \nmd-direction=\"top\">Indica si la hoja de vida ha sido señalada como favorita</md-tooltip><i \nclass=\"s22 icon-star subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!candidate.favorite\"></i> <i \nclass=\"s22 icon-star subtitle secondary-text pr-10\" ng-if=\"candidate.favorite\" md-colors=\"{color:\'accent\'}\"></i></div>\n<div ng-click=\"candidate.showMarker?candidate.showMarker = false : candidate.showMarker = true; \" \nclass=\"cursor-pointer\"><md-tooltip md-direction=\"top\">Indica si la hoja de vida ha sido marcada</md-tooltip><i \nclass=\"s22 icon-bookmark subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!candidate.marker\"></i> <i \nclass=\"s22 icon-bookmark subtitle secondary-text pr-10\" ng-if=\"candidate.marker\" md-colors=\"{color:\'accent\'}\"></i>\n</div></div><div layout=\"row\" layout-align=\"space-between center\"><div \nng-click=\"vm.openShowCandidateNotesDialog(candidate,$index)\" class=\"cursor-pointer\"><md-tooltip md-direction=\"top\">\n<span ng-if=\"candidate.notes.length > 0\">Ver notas ({{candidate.notes.length}})</span> <span \nng-if=\"candidate.notes.length == 0\">Crear una nota</span></md-tooltip><i \nclass=\"s22 icon-image-filter-none mr-10 subtitle secondary-text\"></i></div><div \nng-click=\"vm.setScheduleCandidate(candidate)\" class=\"cursor-pointer\"><md-tooltip md-direction=\"top\"><span \nng-if=\"!candidate.cita.cita.nameShowFormat\">Agendar citas</span> <span ng-if=\"candidate.cita.cita.nameShowFormat\">\n{{candidate.cita.cita.nameShowFormat | capitalize:true}} (Confirmada)</span></md-tooltip><i \nclass=\"s22 icon-calendar-check-multiple mr-10 subtitle secondary-text\"></i></div></div></div></div></ms-widget-front>\n<ms-widget-back ms-scroll><div class=\"blue-300-bg border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h4 white-fg pl-16 pr-16 pt-5 pb-5\">{{candidate.misc.titleBack}}</div><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"close\"><md-icon md-font-icon=\"icon-close\" class=\"s16 white-fg\"></md-icon>\n</md-button></div><notes ng-if=\"candidate.misc.isNote\" notes=\"candidate.notes\" \ncallback-add-note=\"vm.misc.addNote(data,index)\" index-candidate=\"$index\"></notes></ms-widget-back></ms-widget></div>\n<div class=\"container\"><div data-pagination ng-if=\"vm.pager.pages.length\" layout=\"row\" layout-align=\"center center\">\n<span ng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(1)\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(\'backflash\')\" ng-mouseleave=\"vm.setHover(\'backflash\')\" \nmd-colors=\"(vm.misc.hover.backflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-left\"></i> \n</span><span ng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(vm.pager.currentPage - 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'back\')\" ng-mouseleave=\"vm.setHover(\'back\')\" \nmd-colors=\"(vm.misc.hover.back)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-left\"></i></span><ul><li \nng-repeat=\"page in vm.pager.pages\" ng-class=\"{current:vm.pager.currentPage === page}\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(page)\" ng-mouseleave=\"vm.setHover(page)\" \nmd-colors=\"(vm.misc.hover[page] || vm.pager.currentPage === page)?{color: \'accent\'}:{color: \'primary\'}\"><span \nng-click=\"vm.setPage(page)\">{{page}}</span></li></ul><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.currentPage + 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'after\')\" ng-mouseleave=\"vm.setHover(\'after\')\" \nmd-colors=\"(vm.misc.hover.after)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-right\"></i> </span><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.totalPages)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'afterflash\')\" ng-mouseleave=\"vm.setHover(\'afterflash\')\" \nmd-colors=\"(vm.misc.hover.afterflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-right\"></i>\n</span></div></div></div><div ng-show=\"vm.showDetailCandidate\"><div class=\"p-30\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"mb-10\"><md-button ng-click=\"vm.showListsCandidate()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Volver a la lista\n</md-button></div><div class=\"mb-15\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"pt-10 pr-0 pb-10 pl-10\">\nCandidato {{vm.indexSelected + 1}} de {{vm.candidates.length}}</div><div layout=\"row\" layout-aling=\"space-between\">\n<span class=\"cursor-pointer\" ng-hide=\"vm.indexSelected == 0\" ng-click=\"vm.backCandidate()\"><i \nclass=\"icon-chevron-left s30 grey-500-fg\"></i> </span><span class=\"cursor-pointer\" \nng-hide=\"vm.indexSelected == (vm.candidates.length - 1)\" ng-click=\"vm.nextCandidate()\"><i \nclass=\"icon-chevron-right s30 grey-500-fg\"></i></span></div></div></div></div><candidatedetail \nselected=\"vm.candidateSelected\" data=\"vm.candidateSelectedAll\" config=\"vm.configCandidate\" \nbackup=\"vm.candidateChanges\" listas=\"vm.lists\" proceso=\"vm.request\"></candidatedetail></div>");
$templateCache.put("app/main/analyst/detail/partial/route.searchcandidate.html","<div layout-wrap layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"pb-10 bb\"><div><div ng-if=\"vm.misc.filter.length > 0\" class=\"h3 font-weight-400\">Filtros Seleccionados</div>\n</div><md-button ng-click=\"vm.showfilterCandidate()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Buscar hoja de vida\n</md-button></div><div><div ng-repeat=\"(key,filter) in vm.misc.filter | orderBy : filter.order track by $index \"><div \nclass=\"badgeFilter\" ng-if=\"filter.notArray\" layout=\"row\"><span>{{filter.valuesShow}}</span> <button \nng-click=\"vm.deleteFilter(filter,key);\" class=\"md-chip-remove\"><md-icon md-font-icon=\"icon-close\" \nmd-colors=\"{color:\'accent\'}\"></md-icon></button></div><div class=\"badgeFilter\" ng-if=\"!filter.notArray\" \nng-repeat=\"value in filter.valuesShow track by $index\" layout=\"row\"><span>{{value}}</span> <button \nng-click=\"vm.deleteFilter(filter,key,$index);\" class=\"md-chip-remove\"><md-icon md-font-icon=\"icon-close\" \nmd-colors=\"{color:\'accent\'}\"></md-icon></button></div></div></div></div><div ng-if=\"vm.loading\" layout=\"row\" \nflex=\"100\" layout-align=\"center center\" class=\"grey-200-bg p-30\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2\">\nCargando información por favor espere...</div><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nng-if=\"vm.loading\"></md-progress-circular></div><div \nng-if=\"!vm.loading && !vm.candidates.length &&  vm.misc.filter.length > 0\" layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" class=\"grey-200-bg p-30 mt-10\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2\">\nNo se encontraron candidatos bajo los parametros de busqueda.</div></div><div \nng-if=\"!vm.loading && vm.misc.filter.length == 0\" layout=\"row\" flex=\"100\" layout-align=\"center center\" \nclass=\"grey-200-bg p-30 mt-10\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2\">\nDebe de seleccionar un filtro para encontrar los candidatos.</div></div><div \nng-if=\"(!vm.loading && vm.candidates.length > 0) && !vm.showDetailCandidate\"><div class=\"container\"><div \ndata-pagination ng-if=\"vm.pager.pages\" layout=\"row\" layout-align=\"center center\"><span \nng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(1)\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(\'backflash\')\" ng-mouseleave=\"vm.setHover(\'backflash\')\" \nmd-colors=\"(vm.misc.hover.backflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-left\"></i> \n</span><span ng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(vm.pager.currentPage - 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'back\')\" ng-mouseleave=\"vm.setHover(\'back\')\" \nmd-colors=\"(vm.misc.hover.back)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-left\"></i></span><ul><li \nng-repeat=\"page in vm.pager.pages\" ng-class=\"{current:vm.pager.currentPage === page}\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(page)\" ng-mouseleave=\"vm.setHover(page)\" \nmd-colors=\"(vm.misc.hover[page] || vm.pager.currentPage === page)?{color: \'accent\'}:{color: \'primary\'}\"><span \nng-click=\"vm.setPage(page)\">{{page}}</span></li></ul><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.currentPage + 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'after\')\" ng-mouseleave=\"vm.setHover(\'after\')\" \nmd-colors=\"(vm.misc.hover.after)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-right\"></i> </span><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.totalPages)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'afterflash\')\" ng-mouseleave=\"vm.setHover(\'afterflash\')\" \nmd-colors=\"(vm.misc.hover.afterflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-right\"></i>\n</span></div></div><div layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nng-repeat=\"candidate in vm.candidates track by $index\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-xs=\"100\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" \nflex-xl=\"33\"><ms-widget-front class=\"white-bg\" \nng-style=\"{\'border-top-color\':vm.getThemeColor(\'accent\'),\'border-top-width\': \'3px\',\n            \'border-top-style\': \'solid\'}\">\n<div class=\"pl-16 pr-16 pt-20 pb-30 grey-50-bg border-bottom\" layout=\"row\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"start start\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\"><div class=\"mb-10\"><img class=\"profile-image avatar huge\" \nng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\"></div><div layout=\"column\" layout-align=\"start start\" \nlayout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-md=\"space-between\" class=\"h-80\"><div \nng-click=\"vm.showHV(candidate,$index)\" \nng-class=\"{\'cursor-pointer\':vm.candidatesBackup[$index].hoja_vida,\'text-underlined\':vm.candidatesBackup[$index].hoja_vida}\" \nclass=\"h2 font-weight-500 grey-600-fg\">{{candidate.name | capitalize:true}}</div><div \nclass=\"h5 font-weight-400 grey-500-fg\">{{candidate.profession | capitalize:true}} <span \nng-if=\"candidate.count_other_profession && candidate.count_other_profession > 0\">{{candidate.count_other_profession}}\n</span></div><div class=\"h5 font-weight-400 grey-500-fg\">{{candidate.advanced_study | capitalize:true}} <span \nng-if=\"candidate.count_other_study && candidate.count_other_study > 0\">{{candidate.count_other_study}}</span></div>\n</div></div><div class=\"pl-16 pr-16 pt-5 pb-5\" layout=\"column\" layout-align=\"space-between\"><div hide-xs hide-sm \nhide-md layout=\"row\" layout-align=\"start start\" flex=\"100\" layout-xs=\"column\" layout-align-xs=\"start center\" \nlayout-align-sm=\"start center\" layout-align-md=\"start start\" layout-align-lg=\"start start\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" layout-wrap class=\"h-70\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h5 subtitle secondary-text mb-5 font-weight-400 grey-500-fg\">Edad</div><div class=\"h1 font-weight-500\">\n{{candidate.age}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" \nflex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" \nflex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text mb-5 font-weight-400 grey-500-fg\">Empresas</div>\n<div class=\"h1 font-weight-500\">{{candidate.business}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h4 subtitle secondary-text mb-5 font-weight-400 grey-500-fg\">Cargos</div><div class=\"h1 font-weight-500\">\n{{candidate.charges}}</div></div></div><div layout=\"row\" layout-align=\"space-around center\" class=\"border-top\" hide-sm \nhide-xs hide-md></div><div hide-xs hide-sm hide-md layout=\"row\" layout-align=\"start start\" flex=\"100\" \nlayout-xs=\"column\" layout-align-xs=\"start center\" layout-align-sm=\"start center\" layout-align-md=\"start center\" \nlayout-align-lg=\"start center\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" layout-wrap class=\"h-90\"><div \nclass=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" \nflex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"h5 subtitle secondary-text mb-5 h-40 font-weight-400 grey-500-fg\">Experiencia</div>\n<div class=\"text-date-info font-weight-500 line-height maxStageCandidate h-40\">{{candidate.experience}}</div></div><div\n class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" \nflex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nlayout=\"column\" layout-align=\"center center\" class=\"h5 subtitle secondary-text mb-5 h-40 font-weight-400 grey-500-fg\">\n<div class=\"line-height\">Duración por empresa</div></div><div \nclass=\"text-date-info font-weight-500 line-height maxStageCandidate h-40\">{{candidate.duration_per_company}}</div>\n</div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" \nflex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\">\n<div layout=\"column\" layout-align=\"center center\" \nclass=\"h5 subtitle secondary-text mb-5 h-40 font-weight-400 grey-500-fg\"><div class=\"line-height\">Duración por cargo\n</div></div><div class=\"text-date-info font-weight-500 line-height maxStageCandidate h-40\">\n{{candidate.duration_in_charge}}</div></div></div><div layout=\"column\" layout-align=\"space-between\" hide-lg hide-xl>\n<div layout=\"row\" layout-align=\"space-between\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text blue-300-fg mb-5\">Edad\n</div><div class=\"h1 font-weight-500\">{{candidate.age}}</div></div><div class=\"mt-10 mb-10 text-center\" \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h5 subtitle secondary-text blue-300-fg mb-5\">Experiencia</div><div \nclass=\"text-date-info font-weight-500 line-height\">{{candidate.experience}}</div></div></div><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" \nflex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" \nflex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text blue-300-fg mb-5\">Empresas</div><div \nclass=\"h1 font-weight-500\">{{candidate.business}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h5 subtitle secondary-text blue-300-fg mb-5\">\nDuración/cargo</div><div class=\"text-date-info font-weight-500 line-height\">{{candidate.duration_in_charge}}</div>\n</div></div><div layout=\"row\" layout-align=\"space-between\"><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div class=\"h4 subtitle secondary-text blue-300-fg mb-5\">\nCargos</div><div class=\"h1 font-weight-500\">{{candidate.charges}}</div></div><div class=\"mt-10 mb-10 text-center\" \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h5 subtitle secondary-text blue-300-fg mb-5\">Duración/empresa</div><div \nclass=\"text-date-info font-weight-500 line-height\">{{candidate.duration_per_company}}</div></div></div></div><div \nclass=\"border-top\"></div><div layout=\"row\" class=\"pt-10 pb-10\" layout-wrap><div layout=\"row\" \nlayout-align=\"center center\" class=\"text-center titleInfoCandidate all-width\"><span class=\"font-weight-400 h2\">Procesos\n</span></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" \nflex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\">\n<div class=\"h4 subtitle secondary-text mb-5 h-40 line-height font-weight-400 grey-500-fg\">Aplicados</div><div \nclass=\"h1 font-weight-500\">{{candidate.all_process}}</div></div><div class=\"mt-10 mb-10 text-center\" layout=\"column\" \nlayout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h4 subtitle secondary-text mb-5 h-40 line-height font-weight-400 grey-500-fg\">Últimos 6 meses</div><div \nclass=\"h1 font-weight-500\">{{candidate.process_before}}</div></div><div class=\"mt-10 mb-10 text-center\" \nlayout=\"column\" layout-align=\"start center\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-sm=\"50\" flex-gt-sm=\"50\" \nflex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"33\" flex-gt-lg=\"33\" flex-xl=\"33\"><div \nclass=\"h4 subtitle secondary-text mb-5 h-40 line-height font-weight-400 grey-500-fg\">Máxima etapa alcanzada</div><div \nclass=\"font-weight-500 line-height maxStageCandidate\">{{candidate.max_stage.name_corto}}</div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\"><div \nclass=\"h4 subtitle secondary-text\">Última actualización: &nbsp;</div><div class=\"h4 font-weight-500\" \nng-if=\"candidate.last_update.stringDateInMonth\" \nng-class=\"{\'red-300-fg\':candidate.last_update.serializeDate.months > 5}\">{{candidate.last_update.stringDateInMonth}}\n</div><div class=\"h4 font-weight-500\" ng-if=\"!candidate.last_update.stringDateInMonth\" \nng-class=\"{\'red-300-fg\':candidate.updated_at.serializeDate.months > 5}\">{{candidate.updated_at.stringDateInMonth}}\n</div></div></div></div><div class=\"grey-50-bg border-top pl-16 pr-16 pt-5 pb-5\" layout=\"row\" \nlayout-align=\"space-between\" layout-align-xs=\"start start\" layout-align-sm=\"start start\" layout-align-md=\"start start\" \nlayout-align-lg=\"space-between start\" layout-align-xl=\"space-between center\" layout-xs=\"column\" layout-gt-xs=\"column\" \nlayout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"column\" layout-gt-md=\"column\" layout-lg=\"row\" layout-gt-lg=\"row\" \nlayout-xl=\"row\" layout-wrap><div layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.showHV(candidate,$index)\" ng-disabled=\"!vm.candidatesBackup[$index].hoja_vida\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Ver hoja de vida</md-button>\n</div><div><md-button ng-if=\"candidate.stage.id != 2\" ng-disabled=\"!vm.candidatesBackup[$index].hoja_vida\" \nng-click=\"vm.preseleccionar(candidate,$index)\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Preseleccionar</md-button>\n<md-button ng-if=\"candidate.stage.id == 2\" ng-click=\"vm.retirarPreseleccionar(candidate,$index)\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Retirar preselección</md-button>\n</div></div></ms-widget-front></ms-widget></div><div class=\"container\"><div data-pagination \nng-if=\"vm.pager.pages.length\" layout=\"row\" layout-align=\"center center\"><span \nng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(1)\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(\'backflash\')\" ng-mouseleave=\"vm.setHover(\'backflash\')\" \nmd-colors=\"(vm.misc.hover.backflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-left\"></i> \n</span><span ng-class=\"{disabled:vm.pager.currentPage <= 1}\" ng-click=\"vm.setPage(vm.pager.currentPage - 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'back\')\" ng-mouseleave=\"vm.setHover(\'back\')\" \nmd-colors=\"(vm.misc.hover.back)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-left\"></i></span><ul><li \nng-repeat=\"page in vm.pager.pages\" ng-class=\"{current:vm.pager.currentPage === page}\" class=\"cursor-pointer\" \nng-mouseenter=\"vm.setHover(page)\" ng-mouseleave=\"vm.setHover(page)\" \nmd-colors=\"(vm.misc.hover[page] || vm.pager.currentPage === page)?{color: \'accent\'}:{color: \'primary\'}\"><span \nng-click=\"vm.setPage(page)\">{{page}}</span></li></ul><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.currentPage + 1)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'after\')\" ng-mouseleave=\"vm.setHover(\'after\')\" \nmd-colors=\"(vm.misc.hover.after)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-right\"></i> </span><span \nng-class=\"{disabled:vm.pager.currentPage === vm.pager.totalPages}\" ng-click=\"vm.setPage(vm.pager.totalPages)\" \nclass=\"cursor-pointer\" ng-mouseenter=\"vm.setHover(\'afterflash\')\" ng-mouseleave=\"vm.setHover(\'afterflash\')\" \nmd-colors=\"(vm.misc.hover.afterflash)?{color: \'accent\'}:{color: \'primary\'}\"><i class=\"icon-chevron-double-right\"></i>\n</span></div></div></div><div ng-show=\"vm.showDetailCandidate\"><div class=\"p-30\"><div layout=\"row\" \nlayout-align=\"end center\" class=\"mb-10\"><md-button ng-click=\"vm.showListsCandidate()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\">Volver a la lista\n</md-button></div><div class=\"mb-15\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"pt-10 pr-0 pb-10 pl-10\">\nCandidato {{vm.indexSelected + 1}} de {{vm.candidates.length}}</div><div layout=\"row\" layout-aling=\"space-between\">\n<span class=\"cursor-pointer\" ng-hide=\"vm.indexSelected == 0\" ng-click=\"vm.backCandidate()\"><i \nclass=\"icon-chevron-left s30 grey-500-fg\"></i> </span><span class=\"cursor-pointer\" \nng-hide=\"vm.indexSelected == (vm.candidates.length - 1)\" ng-click=\"vm.nextCandidate()\"><i \nclass=\"icon-chevron-right s30 grey-500-fg\"></i></span></div></div></div></div><candidatedetail \nselected=\"vm.candidateSelected\" data=\"vm.candidateSelectedAll\" config=\"vm.configCandidate\" listas=\"vm.lists\" \nproceso=\"vm.request\"></candidatedetail></div>");
$templateCache.put("app/main/analyst/detail/partial/sidebar.html","<div class=\"grey-200-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\" class=\"m-30\"><div layout=\"row\" layout-align=\"end center\" class=\"mb-20\"><i \nclass=\"s20 icon-account-circle grey-500-fg\"></i> <span class=\"pl-5 h6 grey-600-fg\">{{vm.request.count_vacant}} VACANTE \n<span ng-if=\"vm.request.count_vacant > 1\">S</span></span></div><div layout=\"column\" layout-align=\"space-between\"><div \nclass=\"h2 font-weight-500 grey-700-fg\">{{vm.request.applicant | capitalize:true}}</div><div \nclass=\"h5 font-weight-400 grey-500-fg\">Solicitante</div><div class=\"h5 font-weight-600 grey-500-fg\">\n{{vm.request.applicant_from}}</div></div></div></div><div class=\"m-30\" layout=\"column\" layout-align=\"space-between\">\n<div layout=\"column\" layout-align=\"space-between\" class=\"mb-30\"><div class=\"h5 font-weight-400 grey-500-fg\">\nFecha de solicitud</div><div class=\"h2 font-weight-200 grey-600-fg\">\n{{vm.request.date_request_format | capitalize:true}}</div><div class=\"h3 font-weight-300 grey-500-fg\">\n({{vm.request.date_request_compared_string}})</div></div><div class=\"border-top\"></div><div layout=\"column\" \nlayout-align=\"space-between\" class=\"mb-30\"><div class=\"h5 font-weight-400 grey-500-fg\">Estado de la publicación</div>\n<div class=\"h2 font-weight-200 grey-600-fg\" layout=\"row\" layout-align=\"start start\"><div><i \nng-class=\"{\'green-600-fg\':vm.request.status_publish,\'red-600-fg\':!vm.request.status_publish}\" \nclass=\"icon-flickr-before text-left\"></i></div><div layout=\"column\" layout-align=\"space-between\"><span \nclass=\"green-600-fg font-weight-400\">{{vm.request.status_publish}} &nbsp;</span> <span ng-if=\"vm.request.date_publish\" \nclass=\"h3 font-weight-300 grey-500-fg\">(Desde {{vm.request.date_publish_start_string}} <span \nng-if=\"vm.request.date_publish_close_string\">hasta {{vm.request.date_publish_close_string}}</span>)</span></div></div>\n</div><div layout=\"row\" layout-align=\"center start\"><div \nclass=\"pt-5 pb-5 pl-10 pr-10 text-center green-600-bg radius-border-3\"><span class=\"h5 white-fg\">\nSeleccionados: {{vm.request.candidate_info.selected}}</span></div></div></div>");
$templateCache.put("app/main/analyst/detail/tabs/analyst_candidate.html","<div ng-controller=\"analystCandidate as vm\"><div \nng-include=\"\'app/main/analyst/detail/partial/route.analyst_candidate.html\'\"></div></div>");
$templateCache.put("app/main/analyst/detail/tabs/candidate_similar.html","<div ng-controller=\"candidateSimilar as vm\"><div \nng-include=\"\'app/main/analyst/detail/partial/route.candidateSimilar.html\'\"></div></div>");
$templateCache.put("app/main/analyst/detail/tabs/candidates_participating.html","<div ui-view></div>");
$templateCache.put("app/main/analyst/detail/tabs/searchcandidate.html","<div ng-controller=\"SearchcandidateController as vm\"><div \nng-include=\"\'app/main/analyst/detail/partial/route.searchcandidate.html\'\"></div></div>");
$templateCache.put("app/main/analyst/partials/approve_emails/approveEmailsDialog.html","<md-dialog aria-label=\"List dialog\" flex=\"50\" class=\"h-300\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.title}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><form name=\"emailsForm\"><div id=\"approveEmailsDialogContent\" \nlayout=\"column\" layout-align=\"space-between center\"><div class=\"all-width mb-30\"><md-chips ng-model=\"vm.data.emails\" \nname=\"emails\" md-removable=\"true\" md-max-chips=\"10\" placeholder=\"Agregar correo\" ng-required=\"true\" \nmd-separator-keys=\"vm.keysSeparator\" md-add-on-blur=\"true\"><md-chip-template><strong>{{$chip}}</strong>\n</md-chip-template></md-chips><div class=\"errors-chip mt-10\" ng-messages=\"emailsForm.emails.$error\"><div \nng-message=\"md-max-chips\">La maxima cantidad de correos es 10.</div><div ng-message=\"required\">\nEl campo debe de tener al menos un correo valido.</div></div><div class=\"errors-chip mt-10\" \nng-if=\"vm.emailsError.length > 0\"><span>Los siguientes correos no tienen un formato valido:</span><div layout=\"column\" \nng-repeat=\"emails in vm.emailsError\"><span>- {{emails}}</span></div></div></div><div class=\"text-center\"><div \nclass=\"errors-chip\" ng-if=\"vm.emptyCorrectEmails\"><span>No se encontraron correos validos, por favor validar.</span>\n</div><md-button type=\"submit\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg all-width\" \nng-click=\"vm.sendEmail()\">Aceptar</md-button></div></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/candidate-detail/candidate-detail.html","<div id=\"candidate-detail\" ng-if=\"vm.candidate\"><div class=\"pl-30 pr-30 pb-30\" layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"bt\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"h1 font-weight-200 light-blue-500-fg\">{{vm.candidate.name | capitalize:true}}\n</div><div layout=\"row\" layout-align=\"start center\" class=\"p-10 cursor-pointer\" ng-click=\"vm.markAsFavorite()\" \nng-if=\"vm.config.showFavorite\"><div><i class=\"icon-star subtitle secondary-text\" \nng-class=\"{\'yellow-600-fg\': vm.candidate.favorite, \'grey-400-fg\': !vm.candidate.favorite}\" aria-label=\"Favorita\"></i>\n</div></div><div layout=\"row\" layout-align=\"space-between center\" ng-click=\"vm.setScheduleCandidate(candidate)\" \nclass=\"cursor-pointer\" ng-if=\"vm.config.showCite\"><md-tooltip md-direction=\"top\"><span \nng-if=\"!vm.candidate.cita.cita.nameShowFormat\">Agendar citas</span> <span \nng-if=\"vm.candidate.cita.cita.nameShowFormat\">{{vm.candidate.cita.cita.nameShowFormat | capitalize:true}} (Confirmada)\n</span></md-tooltip><div><i class=\"s22 icon-calendar-check-multiple mr-10 subtitle secondary-text\"></i></div></div><div\n ng-click=\"vm.showMarker?vm.showMarker = false : vm.showMarker = true; \" class=\"cursor-pointer\" \nng-if=\"vm.config.showMarker\"><md-tooltip md-direction=\"top\">Indica si la hoja de vida ha sido marcada</md-tooltip><i \nclass=\"s22 icon-bookmark subtitle secondary-text pr-10 grey-400-fg\" ng-if=\"!vm.candidate.marker\"></i> <i \nclass=\"s22 icon-bookmark subtitle secondary-text pr-10\" ng-if=\"vm.candidate.marker\" md-colors=\"{color:\'accent\'}\"></i>\n</div><div class=\"pl-16 pr-16\" layout=\"row\" layout-align=\"space-between center\" ng-show=\"vm.showMarker\">\n<md-input-container class=\"mr-5\"><div class=\"h4 grey-fg font-weight-300\"><label>Marcar</label></div><md-select \naria-label=\"Seleccionar Etapa\" ng-model=\"vm.markerSelected\" class=\"\"><md-option \nng-repeat=\"(key,data) in vm.lists.tipos_marca_hv track by $index\" ng-selected=\"key == vm.candidate.marker\" \nng-value=\"key\">{{data}}</md-option></md-select></md-input-container><md-button ng-click=\"vm.saveMarker()\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg no-margin\" \nng-class=\"vm.markerSelected == vm.candidate.marker ? \'md-warn\' : \'md-primary\' \">\n{{vm.markerSelected == vm.candidate.marker ? \'Desmarcar\' : \'Guardar\'}}</md-button></div><div \nclass=\"p-10 cursor-pointer text-underlined orange-600-fg\" ng-click=\"vm.openShowCandidateNotesDialog()\" \nng-if=\"vm.config.showNote\">Ver notas <span class=\"tab-badge orange-600-bg\">{{vm.candidate.notes.length}}</span></div>\n<div class=\"p-10 cursor-pointer text-underlined blue-600-fg\" ng-click=\"vm.openShowCandidateHistoryDialog()\" \nng-if=\"vm.config.showHistory\">Historial <span class=\"tab-badge blue-600-bg\">{{vm.history.length}}</span></div></div>\n<div class=\"md-subhead\" layout=\"row\"><span class=\"font-weight-200\">Documento:</span> <span class=\"font-weight-300\">\n{{vm.candidate.key}}</span></div></div></div><div class=\"bb\" layout=\"row\" layout-align=\"end center\" layout-wrap><div \nclass=\"p-10\"><md-button ng-click=\"vm.downloadPDF()\" aria-label=\"Recommend candidate\" \nclass=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin borderButtom\" \nmd-colors=\"(vm.misc.hover.hojavida)?{\'background-color\':\'primary\'}:{\'border-color\':\'primary\',\'color\':\'primary\'}\" \nng-mouseenter=\"vm.setHover(\'hojavida\')\" ng-mouseleave=\"vm.setHover(\'hojavida\')\">Descargar hoja de vida<md-icon \nmd-font-icon=\"icon-download\"></md-icon></md-button></div><div class=\"p-10\" ng-if=\"vm.config.showRecommendCandidate\">\n<md-button ng-click=\"vm.openRecommendCandidateDialog()\" aria-label=\"Recommend candidate\" \nclass=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin borderButtom\" \nmd-colors=\"(vm.misc.hover.recomendCandidate)?{\'background-color\':\'primary\'}:{\'border-color\':\'primary\',\'color\':\'primary\'}\" \nng-mouseenter=\"vm.setHover(\'recomendCandidate\')\" ng-mouseleave=\"vm.setHover(\'recomendCandidate\')\">Recomendar candidato\n</md-button></div><div class=\"p-10\" ng-if=\"vm.config.showReportClient\"><md-button \nng-click=\"vm.showReportForToclientFn()\" aria-label=\"Recommend candidate\" \nclass=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin borderButtom\" \nmd-colors=\"(vm.misc.hover.reportForClient)?{\'background-color\':\'primary\'}:{\'border-color\':\'primary\',\'color\':\'primary\'}\" \nng-mouseenter=\"vm.setHover(\'reportForClient\')\" ng-mouseleave=\"vm.setHover(\'reportForClient\')\">Informe para el cliente\n</md-button></div><div class=\"p-10\" ng-if=\"vm.config.showPreseleccion\"><md-button ng-click=\"vm.preseleccionar()\" \naria-label=\"Recommend candidate\" class=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin borderButtom\" \nmd-colors=\"(vm.misc.hover.preseleccionar)?{\'background-color\':\'primary\'}:{\'border-color\':\'primary\',\'color\':\'primary\'}\" \nng-mouseenter=\"vm.setHover(\'preseleccionar\')\" ng-mouseleave=\"vm.setHover(\'preseleccionar\')\" \nng-if=\"vm.candidate.stage.id != 2\">Preseleccionar</md-button><md-button ng-click=\"vm.retirarPreseleccionar()\" \naria-label=\"Recommend candidate\" class=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin borderButtom\" \nmd-colors=\"(vm.misc.hover.preseleccionar)?{\'background-color\':\'primary\'}:{\'border-color\':\'primary\',\'color\':\'primary\'}\" \nng-mouseenter=\"vm.setHover(\'preseleccionar\')\" ng-mouseleave=\"vm.setHover(\'preseleccionar\')\" \nng-if=\"vm.candidate.stage.id == 2\">Retirar preselección</md-button></div><div class=\"p-10\" \nng-if=\"vm.config.importStage\"><md-button ng-click=\"vm.importStages()\" aria-label=\"Recommend candidate\" \nclass=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin borderButtom\" \nmd-colors=\"(vm.misc.hover.importStages)?{\'background-color\':\'primary\'}:{\'border-color\':\'primary\',\'color\':\'primary\'}\" \nng-mouseenter=\"vm.setHover(\'importStages\')\" ng-mouseleave=\"vm.setHover(\'importStages\')\">Importar etapas</md-button>\n</div><div class=\"p-10\" ng-if=\"vm.config.showStage\"><md-menu><md-button aria-label=\"Open phone interactions menu\" \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\" \nng-style=\"{\'background-color\':vm.stageSelected.color}\" ng-click=\"$mdOpenMenu()\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>{{vm.stageSelected.name}} </span><i class=\"icon-chevron-down\"></i></div>\n</md-button><md-menu-content width=\"12\" class=\"no-padding\"><md-menu-item \nng-repeat=\"stage in vm.stages track by stage.id\"><md-button ng-click=\"vm.changeStage(stage)\" \nclass=\"line-height-30 remove-uppercase pl-20 pr-20 no-margin bb text-right\" \nng-class=\"(stage.personalizada == 1 && stage.id != vm.candidate.stage.id)?\'grey-200-bg\':\'\'\" \nng-style=\"{\'background-color\':(stage.id == vm.stageSelected.id)?stage.color:\'white\',\'color\':(stage.id == vm.stageSelected.id)?\'white\':\'\'}\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"mr-10 w-20\"><i ng-show=\"stage.personalizada\" class=\"s20\" \nng-class=\"stage.aprueba == 1?\'icon-check light-green-500-fg\':\'icon-close red-500-fg\'\"></i></div><span>\n{{stage.name_corto}}</span></div></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"p-10\" \nng-if=\"vm.config.showStageFake\"><md-menu><md-button aria-label=\"Open phone interactions menu\" \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg\" \nng-style=\"{\'background-color\':vm.stageSelected.color}\" ng-click=\"$mdOpenMenu()\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span>{{vm.stageSelected.name}} </span><i class=\"icon-chevron-down\"></i></div>\n</md-button><md-menu-content width=\"12\" class=\"no-padding\"><md-menu-item \nng-repeat=\"stage in vm.stages track by stage.id\"><md-button \nclass=\"line-height-30 remove-uppercase pl-20 pr-20 no-margin bb text-right\" \nng-class=\"(stage.personalizada == 1 && stage.id != vm.candidate.stage.id)?\'grey-200-bg\':\'\'\" \nng-style=\"{\'background-color\':(stage.id == vm.stageSelected.id)?stage.color:\'white\',\'color\':(stage.id == vm.stageSelected.id)?\'white\':\'\'}\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"mr-10 w-20\"><i ng-show=\"stage.personalizada\" class=\"s20\" \nng-class=\"stage.aprueba == 1?\'icon-check light-green-500-fg\':\'icon-close red-500-fg\'\"></i></div><span>\n{{stage.name_corto}}</span></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div \nng-if=\"vm.showAlertHojaVida\" layout=\"row\" flex=\"100\" layout-align=\"center center\" class=\"grey-200-bg p-30\"><div \nclass=\"pl-25 pr-25 pt-15 pb-15 h2\">Cargando hoja de vida por favor espere...</div></div><div \nng-repeat=\"block in vm.blocks\" ng-if=\"!vm.showReporrForTheClient && !vm.showStageSelected\" class=\"report-for-client\">\n<div ng-if=\"block.name == \'personales\' && true\" ng-include=\"\'app/main/templates/resume/personal-info.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'perfil\'\" \nng-include=\"\'app/main/templates/resume/one-column-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'experiencia\'\" ng-include=\"\'app/main/templates/resume/laboral-experience.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'estudios_formales\'\" \nng-include=\"\'app/main/templates/resume/formal-study.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'estudios_no_formales\'\" ng-include=\"\'app/main/templates/resume/non-formal-study.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'laboral\'\" \nng-include=\"\'app/main/templates/resume/one-column-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'contacto_emergencia\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'idiomas\'\" \nng-include=\"\'app/main/templates/resume/languages.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'grupo_familiar\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'hijos\'\" \nng-include=\"\'app/main/templates/resume/childrens.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'madre\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'padre\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'conyuge\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'viven_usted\'\" \nng-include=\"\'app/main/templates/resume/two-columns.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'vivienda\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'contacto\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'salud\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'adicional\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div></div><div \nng-if=\"vm.showReporrForTheClient\" class=\"report-for-client\"><div ng-repeat=\"block in vm.blocksReportForClient\"><div \nng-include=\"\'app/main/templates/block-generic/update/\' + block.type + \'.html\'\" \nng-init=\"item = block;root = vm.reportClientData\"></div></div><div layout=\"row\" layout-align=\"end\" class=\"p-10\">\n<md-button ng-click=\"vm.showReportForToclientFn()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">\nRegresar al detalle del candidato</md-button><md-button ng-click=\"vm.saveReportForToclientFn()\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Guardar</md-button></div>\n</div><div ng-if=\"vm.showStageSelected\"><div layout=\"row\" layout-align=\"end end\"><md-button ng-click=\"vm.showHV()\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">\nRegresar al detalle del candidato</md-button></div><div layout=\"column\" layout-align=\"space-between end\" \nng-if=\"vm.misc.values\" class=\"pr-30\"><div layout=\"row\" layout-aling=\"start center\"><span class=\"h4 font-weight-300\">\nFecha de creación:&nbsp; </span><span class=\"h4 font-weight-500\">{{vm.misc.values.created_at | capitalize:true}}</span>\n</div><div layout=\"row\" layout-aling=\"start center\"><span class=\"h4 font-weight-300\">Fecha de actualización:&nbsp; \n</span><span class=\"h4 font-weight-500\">{{vm.misc.values.updated_at | capitalize:true}}</span></div><div layout=\"row\" \nlayout-aling=\"start center\"><span class=\"h4 font-weight-300\">Consultor que hizo la modificación:&nbsp; </span><span \nclass=\"h4 font-weight-500\">{{vm.misc.values.analista}}</span></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.showStageSelected && !vm.editStage && !vm.config.onlyViewStages\"><md-button \naria-label=\"No aprobar\" class=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 margin borderButtom\" \nmd-colors=\"(vm.misc.hover.downloadPdfStage)?{\'background-color\':\'accent\'}:{\'border-color\':\'accent\',\'color\':\'accent\'}\" \nng-mouseenter=\"vm.setHover(\'downloadPdfStage\')\" ng-mouseleave=\"vm.setHover(\'downloadPdfStage\')\" \nng-click=\"vm.downloadPdfStage()\">PDF</md-button><md-button aria-label=\"No aprobar\" \nclass=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 margin borderButtom\" \nmd-colors=\"(vm.misc.hover.updateStage)?{\'background-color\':\'primary\'}:{\'border-color\':\'primary\',\'color\':\'primary\'}\" \nng-mouseenter=\"vm.setHover(\'updateStage\')\" ng-mouseleave=\"vm.setHover(\'updateStage\')\" ng-click=\"vm.updateStage()\">\nMODIFICAR</md-button><md-button aria-label=\"No aprobar\" \nclass=\"h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 margin borderButtom\" \nmd-colors=\"(vm.misc.hover.assignStage)?{\'background-color\':\'accent\'}:{\'border-color\':\'accent\',\'color\':\'accent\'}\" \nng-mouseenter=\"vm.setHover(\'assignStage\')\" ng-mouseleave=\"vm.setHover(\'assignStage\')\" ng-click=\"vm.assignStage()\">\nPASAR A ESTA ETAPA</md-button></div><div ng-if=\"vm.stage.etapa == \'entrevista_jefe\'\" class=\"p-17\"><span \nclass=\"h4 font-weight-500\">{{vm.recomendaciones.title}}</span><table class=\"row-border hover table-entrevista-jefe\" \nng-if=\"vm.recomendaciones.recomendaciones\"><thead><tr><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text\" \nng-repeat=\"(key,value) in vm.recomendaciones.recomendaciones\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\">{{key}}</span></div></th></tr></thead><tbody><tr><td class=\"b h4 font-weight-300 p-8\" \nng-repeat=\"(key,value) in vm.recomendaciones.recomendaciones\"><u>{{value}}</u></td></tr></tbody></table><span \nclass=\"h4 font-weight-500\">{{vm.recomendaciones.footer}}</span></div><div ng-repeat=\"block in vm.blocksStage\"><div \nng-include=\"\'app/main/templates/block-generic/update/\' + block.type + \'.html\'\" \nng-init=\"item = block; root = vm.stageData\" ng-if=\"vm.editStage\"></div><div \nng-include=\"\'app/main/templates/block-generic/read/\' + block.type + \'.html\'\" \nng-init=\"item = block; root = vm.stageData\" ng-if=\"!vm.editStage\"></div></div><div class=\"mt-15\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.editStage && vm.blocksStage.length > 0\"><div ng-if=\"vm.modifiStage\"><md-button \naria-label=\"No aprobar\" class=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.cancelUpdate()\">Cancelar</md-button><md-button aria-label=\"aprobar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateUpdate()\">Guardar</md-button></div><div ng-if=\"vm.stage.req_aprobacion && vm.approbeStage\">\n<md-button aria-label=\"No aprobar\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataStage(0,true)\">No aprobar</md-button><md-button aria-label=\"aprobar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataStage(1,true)\">Aprobar</md-button></div><div \nng-if=\"!vm.stage.req_aprobacion && vm.approbeStage\"><md-button aria-label=\"Guardar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataStage(1,false)\">Guardar</md-button></div></div></div></div>");
$templateCache.put("app/main/analyst/partials/change_date_public_request/change_date_public_request.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-300\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Editar final cierre de publicación </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"no-padding\"><div id=\"changedatepublicrequestDialogContent\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\" class=\"grey-100-bg bb md-padding\"><span \nclass=\"h3 grey-500-fg font-weigth-500 mr-10\">¿Dejar fecha de finalicación en blanco?</span><md-checkbox \nng-model=\"vm.data.emptyDateEnd\" ng-change=\"vm.changeEmptyEnd();\" class=\"no-margin\"></md-checkbox></div><div \nlayout=\"column\" layout-align=\"space-between\" class=\"mt-10 md-padding\" ng-if=\"!vm.data.emptyDateEnd\"><span>\nSeleccionar la fecha final de la publicación de la oferta</span><md-datepicker ng-model=\"vm.data.dateEnd\" \nmd-placeholder=\"Fecha final\" md-min-date=\"vm.tomorrow\" md-open-on-focus class=\"no-margin\"></md-datepicker><span \nng-if=\"vm.error.dateEmpty\" class=\"red-500-fg h5 font-weigth-300\">La fecha final de publicación es obligatorio.</span>\n</div><div layout=\"column\" layout-align=\"space-between center\" class=\"mt-20\"><md-button \nclass=\"md-raise light-green-500-bg white-fg h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 mb-10\" \nng-click=\"vm.save();\">Guardar</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/filter_candidate/filter_candidate.html","<md-dialog aria-label=\"List dialog\" flex=\"50\" class=\"h-400\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Filtros candidatos </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"padding\"><div id=\"FilterCandidate\" layout=\"column\" layout-align=\"space-between\">\n<div layout=\"column\" layout-aling=\"center center\" class=\"mb-15\"><div class=\"title-collapse\" layout=\"row\" \nlayout-align=\"space-between center\"><span ng-class=\"vm.collapse.showCollapseOne ? \'grey-600-fg\' : \'grey-400-fg\'\">\nGENERAL </span><i ng-class=\"vm.collapse.showCollapseOne ? \'icon-chevron-up\':\'icon-chevron-down\'\" \nmd-colors=\"{color:\'accent\'}\" class=\"cursor-pointer\" ng-click=\"vm.showCollapse(1);\"></i></div><div layout=\"column\" \nlayout-align=\"space-between\" class=\"content-collapse\" ng-if=\"vm.collapse.showCollapseOne\"><div layout=\"row\" \nlayout-align=\"start\"><md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>Palabra clave\n</label></div><input type=\"text\" ng-model=\"vm.data.query\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>\nÁrea de trabajo</label></div><md-chips ng-model=\"vm.data.areas_trabajo\" md-autocomplete-snap=\"\" md-removable=\"true\" \nmd-on-add=\"vm.validationChip(vm.data.areas_trabajo,$chip)\"><md-autocomplete md-selected-item=\"vm.selectedAreas\" \nmd-search-text=\"vm.filter.areas\" md-search-text-change=\"vm.loadData(\'areas\')\" md-items=\"data in vm.misc.areas\" \nmd-item-text=\"data.value\" placeholder=\"Buscar área de trabajo\"><span md-highlight-text=\"vm.filter.areas\">{{data.value}}\n</span></md-autocomplete><md-chip-template><span class=\"chipsValue\">{{$chip.value}}</span></md-chip-template>\n</md-chips></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"h4 grey-fg font-weight-300\"><label>Posibilidad de traslado</label></div>\n<div layout=\"row\" layout-align=\"space-between center\"><md-radio-group ng-model=\"vm.data.traslado\" layout=\"row\" \nlayout-align=\"start center\"><md-radio-button ng-value=\"1\" class=\"mb-5\">Si</md-radio-button><md-radio-button \nng-value=\"0\" class=\"mb-5\">No</md-radio-button></md-radio-group></div></div><md-input-container><div \nclass=\"h4 grey-fg font-weight-300\"><label>Aspiracion salarial</label></div><md-select aria-label=\"Seleccionar Etapa\" \nng-model=\"vm.data.salarios\" class=\"\" whenscrollends=\"vm.loadData(\'salario\')\" multiple=\"multiple\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.filter.salario\" ng-change=\"vm.loadData(\'salario\')\" type=\"search\" \nplaceholder=\"Escribe para buscar\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"data in vm.lists.salarios track by $index\" ng-value=\"data.id\">{{data.name}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"space-between end\">\n<md-input-container><div class=\"h4 font-weight-300\"><label>Seleccionar Etapa</label></div><md-select \naria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.etapa_id\" class=\"simplified2\"><md-option \nng-repeat=\"data in vm.lists.etapas\" ng-value=\"data.id\">{{data.name}}</md-option></md-select></md-input-container>\n<md-input-container><div class=\"h4 font-weight-300\"><label>Origen</label></div><md-chips ng-model=\"vm.data.origenes\" \nmd-autocomplete-snap=\"\" md-removable=\"true\" md-on-add=\"vm.validationChip(vm.data.origenes,$chip)\"><md-autocomplete \nmd-selected-item=\"vm.selectedOrigenes\" md-search-text=\"vm.filter.origenes\" \nmd-search-text-change=\"vm.loadData(\'origenes\')\" md-items=\"data in vm.misc.origenes\" md-item-text=\"data.value\" \nplaceholder=\"Buscar origen\"><span md-highlight-text=\"vm.filter.origenes\">{{data.value}}</span></md-autocomplete>\n<md-chip-template><span class=\"chipsValue\">{{$chip.value}}</span></md-chip-template></md-chips></md-input-container>\n</div></div></div><div layout=\"column\" layout-aling=\"center center\" class=\"mb-15\"><div class=\"title-collapse\" \nlayout=\"row\" layout-align=\"space-between center\"><span \nng-class=\"vm.collapse.showCollapseTwo ? \'grey-600-fg\' : \'grey-400-fg\'\">INFORMACIÓN DEMOGRÁFICA </span><i \nng-class=\"vm.collapse.showCollapseTwo ? \'icon-chevron-up\':\'icon-chevron-down\'\" md-colors=\"{color:\'accent\'}\" \nclass=\"cursor-pointer\" ng-click=\"vm.showCollapse(2);\"></i></div><div layout=\"column\" layout-align=\"space-between\" \nclass=\"content-collapse\" ng-if=\"vm.collapse.showCollapseTwo\"><div layout=\"column\" layout-align=\"space-between\" \nclass=\"bb mb-10\"><div class=\"h4 grey-500-fg font-weight-300 mb-10 mt-10\">Género</div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mb-10\"><md-radio-group ng-model=\"vm.data.genero\" layout=\"row\" \nlayout-align=\"start center\"><md-radio-button ng-value=\"key\" class=\"mb-5\" ng-repeat=\"(key,data) in vm.lists.generos\">\n{{data}}</md-radio-button></md-radio-group></div></div><div layout=\"column\" layout-align=\"space-between\"><div \nlayout=\"row\" layout-align=\"space-between end\"><md-input-container><div class=\"h4 grey-fg font-weight-300\"><label>\nCiudades</label></div><md-chips ng-model=\"vm.data.ciudades\" md-autocomplete-snap=\"\" md-removable=\"true\" \nmd-on-add=\"vm.validationChip(vm.data.ciudades,$chip)\"><md-autocomplete md-selected-item=\"vm.selectedCiudad\" \nmd-search-text=\"vm.filter.ciudades\" md-search-text-change=\"vm.loadData(\'ciudades\')\" \nmd-items=\"data in vm.misc.ciudades\" md-item-text=\"data.value\" placeholder=\"Buscar ciudad\"><span \nmd-highlight-text=\"vm.filter.ciudades\">{{data.value}}</span></md-autocomplete><md-chip-template><span \nclass=\"chipsValue\">{{$chip.value}}</span></md-chip-template></md-chips></md-input-container><md-input-container><div \nclass=\"h4 grey-fg font-weight-300\"><label>Edades</label></div><md-select aria-label=\"Seleccionar Etapa\" \nng-model=\"vm.data.edades\" class=\"\" whenscrollends=\"vm.loadData(\'edades\')\" multiple=\"multiple\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.filter.edades\" ng-change=\"vm.loadData(\'edades\')\" type=\"search\" \nplaceholder=\"Escribe para buscar\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option ng-repeat=\"data in vm.misc.edades track by $index\" ng-value=\"data.id\" \nng-selected=\"vm.inSelectedGroups(\'edades\',data.id)\">{{data.value}}</md-option></md-select></md-input-container></div>\n</div></div></div><div layout=\"column\" layout-aling=\"center center\" class=\"mb-15\"><div class=\"title-collapse\" \nlayout=\"row\" layout-align=\"space-between center\"><span \nng-class=\"vm.collapse.showCollapseThree ? \'grey-600-fg\' : \'grey-400-fg\'\">INFORMACIÓN PROFESIONAL </span><i \nng-class=\"vm.collapse.showCollapseThree ? \'icon-chevron-up\':\'icon-chevron-down\'\" md-colors=\"{color:\'accent\'}\" \nclass=\"cursor-pointer\" ng-click=\"vm.showCollapse(3);\"></i></div><div layout=\"column\" layout-align=\"space-between\" \nclass=\"content-collapse\" ng-if=\"vm.collapse.showCollapseThree\"><div layout=\"row\" layout-align=\"space-between end\">\n<md-input-container><div class=\"h4 font-weight-300\"><label>Idiomas</label></div><md-select \naria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.idiomas\" class=\"\" multiple=\"multiple\"><md-option \nng-repeat=\"data in vm.misc.idiomas track by $index\" ng-value=\"data.id\">{{data.value}}</md-option></md-select>\n</md-input-container><md-input-container><div class=\"h4 grey-fg font-weight-300\"><label>Profesiones</label></div>\n<md-chips ng-model=\"vm.data.profesiones\" md-autocomplete-snap=\"\" md-removable=\"true\" \nmd-on-add=\"vm.validationChip(vm.data.profesiones,$chip)\"><md-autocomplete md-selected-item=\"vm.selectedProfesiones\" \nmd-search-text=\"vm.filter.profesiones\" md-search-text-change=\"vm.loadData(\'profesiones\')\" \nmd-items=\"data in vm.misc.profesiones\" md-item-text=\"data.value\" placeholder=\"Buscar profesiones\"><span \nmd-highlight-text=\"vm.filter.profesiones\">{{data.value}}</span></md-autocomplete><md-chip-template><span \nclass=\"chipsValue\">{{$chip.value}}</span></md-chip-template></md-chips></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between end\"><md-input-container><div class=\"h4 grey-fg font-weight-300\"><label>Niveles academicos\n</label></div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.niveles_educativos\" class=\"\" \nmultiple=\"multiple\"><md-option ng-repeat=\"data in vm.misc.niveles_academicos track by $index\" ng-value=\"data.id\">\n{{data.value}}</md-option></md-select></md-input-container><md-input-container><div class=\"h4 font-weight-300\"><label>\nInstitución</label></div><md-chips ng-model=\"vm.data.instituciones\" md-autocomplete-snap=\"\" md-removable=\"true\" \nmd-on-add=\"vm.validationChip(vm.data.instituciones,$chip)\"><md-autocomplete md-selected-item=\"vm.selectedInstitutos\" \nmd-search-text=\"vm.filter.institutos\" md-search-text-change=\"vm.loadData(\'institutos\')\" \nmd-items=\"data in vm.misc.institutos\" md-item-text=\"data.value\" placeholder=\"Buscar institutos\"><span \nmd-highlight-text=\"vm.filter.institutos\">{{data.value}}</span></md-autocomplete><md-chip-template><span \nclass=\"chipsValue\">{{$chip.value}}</span></md-chip-template></md-chips></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between\"><md-input-container><div class=\"h4 grey-fg font-weight-300\"><label>\nUltima fecha de actualización</label></div><md-select aria-label=\"Seleccionar Etapa\" \nng-model=\"vm.data.ultima_modificacion\" class=\"\"><md-option \nng-repeat=\"data in vm.misc.ultimas_modificaciones track by $index\" ng-value=\"data.id\">{{data.value}}</md-option>\n</md-select></md-input-container></div></div></div><div layout=\"column\" layout-aling=\"center center\" class=\"mb-15\"><div\n class=\"title-collapse\" layout=\"row\" layout-align=\"space-between center\"><span \nng-class=\"vm.collapse.showCollapseFour ? \'grey-600-fg\' : \'grey-400-fg\'\">CLASIFICACIÓN </span><i \nng-class=\"vm.collapse.showCollapseFour ? \'icon-chevron-up\':\'icon-chevron-down\'\" md-colors=\"{color:\'accent\'}\" \nclass=\"cursor-pointer\" ng-click=\"vm.showCollapse(4);\"></i></div><div layout=\"column\" layout-align=\"space-between\" \nclass=\"content-collapse\" ng-if=\"vm.collapse.showCollapseFour\"><div layout=\"row\" layout-align=\"space-between end\">\n<md-input-container><div class=\"h4 font-weight-300\"><label>Candidatos recomendados a estos cargos</label></div>\n<md-chips ng-model=\"vm.data.cargos_recomendados\" md-autocomplete-snap=\"\" md-removable=\"true\" \nmd-on-add=\"vm.validationChip(vm.data.cargos_recomendados,$chip)\"><md-autocomplete \nmd-selected-item=\"vm.selectedCargos_recomendados\" md-search-text=\"vm.filter.cargos_recomendados\" \nmd-search-text-change=\"vm.loadData(\'cargos_recomendados\')\" md-items=\"data in vm.misc.cargos_recomendados\" \nmd-item-text=\"data.name\" placeholder=\"Buscar cargos\"><span md-highlight-text=\"vm.filter.cargos_recomendados\">\n{{data.name}}</span></md-autocomplete><md-chip-template><span class=\"chipsValue\">{{$chip.name}}</span>\n</md-chip-template></md-chips></md-input-container><md-input-container><div class=\"h4 grey-fg font-weight-300\"><label>\nCandidatos que hayan participado en procesos anteriores</label></div><md-select aria-label=\"Seleccionar Etapa\" \nng-model=\"vm.data.candidate_process\" class=\"\"><md-option ng-value=\"vm.request.id\">Este mismo cargo</md-option>\n<md-option ng-value=\"1\">Cualquier proceso de la compañia</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"space-between\"><md-input-container><div class=\"h4 font-weight-300\"><label>Maxima etapa\n</label></div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.max_etapa\" class=\"simplified2\"><md-option \nng-repeat=\"data in vm.lists.etapas\" ng-value=\"data.id\">{{data.name}}</md-option></md-select></md-input-container>\n<md-input-container><div class=\"h4 font-weight-300\"><label>Recomendado por</label></div><md-select \naria-label=\"Seleccionar Etapa\" ng-model=\"vm.data.recomendado_por\" class=\"simplified2\" multiple=\"multiple\"><md-option \nng-repeat=\"data in vm.misc.recomendado_por\" ng-value=\"data.id\">{{data.value}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between\"><md-input-container><div \nclass=\"h4 grey-fg font-weight-300\"><label>Referido por</label></div><input type=\"text\" ng-model=\"vm.data.referido_por\">\n</md-input-container><md-input-container><div class=\"h4 grey-fg font-weight-300\"><span>Referido</span></div><div \nlayout=\"row\" layout-align=\"space-between center\"><md-radio-group ng-model=\"vm.data.referido\" layout=\"row\" \nlayout-align=\"start center\"><md-radio-button ng-value=\"1\" class=\"mb-5\">Si</md-radio-button><md-radio-button \nng-value=\"0\" class=\"mb-5\">No</md-radio-button></md-radio-group></div></md-input-container></div></div></div><div \nlayout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nng-if=\"vm.loading\"></md-progress-circular></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\" class=\"p-10\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20\">Cancelar</md-button><md-button \nng-click=\"vm.saveSearch()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Buscar</md-button><md-button \nng-click=\"vm.clearFilters()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Limpiar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/analyst/partials/filter_hv/filter_hv.html","<md-dialog aria-label=\"List dialog\" flex=\"50\" class=\"h-400\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.candidate ? \'Filtros candidatos\' : \'Filtros hoja de vida\'}} </span><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"padding\"><div \nid=\"FilterHv\" layout=\"column\" layout-align=\"space-between\"><div layout=\"column\" layout-aling=\"center center\" \nclass=\"mb-15\" ng-repeat=\"(key,filters) in vm.filters\"><div class=\"title-collapse\" layout=\"row\" \nlayout-align=\"space-between center\"><span ng-class=\"vm.collapse[key] ? \'grey-600-fg\' : \'grey-400-fg\'\">\n{{key | titlecollapse}} </span><i ng-class=\"vm.collapse[key] ? \'icon-chevron-up\':\'icon-chevron-down\'\" \nmd-colors=\"{color:\'accent\'}\" class=\"cursor-pointer\" ng-click=\"vm.showCollapse(key);\"></i></div><div layout=\"row\" \nclass=\"content-collapse\" ng-show=\"vm.collapse[key]\" layout-align=\"space-between center\" layout-wrap><div flex=\"50\" \nng-repeat=\"filter in filters track by $index\"><md-input-container class=\"md-block h-50 all-width\" flex-gt-sm \nng-if=\"filter.type == \'TEXT\'\"><label>{{filter.name}}</label><input ng-model=\"vm.data[filter.id]\"></md-input-container>\n<md-input-container class=\"md-block h-50 all-width\" flex-gt-sm ng-if=\"filter.type == \'SELECT\'\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>{{filter.name}}</label></div><md-select aria-label=\"Seleccionar Etapa\" \nng-model=\"vm.data[filter.id]\" whenscrollends=\"vm.loadData(filter.id,key,filter)\" class=\"\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.filter[filter.id]\" ng-change=\"vm.loadData(filter.id,key,filter)\" \ntype=\"search\" placeholder=\"Escribe para buscar\" class=\"demo-header-searchbox md-text\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"option in filter.optionsshow track by $index\" ng-value=\"option.id\">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block h-50 all-width\" flex-gt-sm \nng-if=\"filter.type == \'AUTOCOMPLETE\'\"><div class=\"h4 font-weight-300\"><label>{{filter.name}}</label></div><md-chips \nng-model=\"vm.data[filter.id]\" md-autocomplete-snap=\"\" md-removable=\"true\" \nmd-on-add=\"vm.validationChip(vm.data[filter.id],$chip)\"><md-autocomplete md-selected-item=\"vm.selected[filter.id]\" \nmd-no-cache md-search-text=\"vm.filter[filter.id]\" md-search-text-change=\"vm.loadData(filter.id,key,filter)\" \nmd-items=\"data in filter.optionsshow \" md-item-text=\"data.name\" placeholder=\"Buscar origen\"><span \nmd-highlight-text=\"vm.filter[filter.id]\">{{data.name}}</span></md-autocomplete><md-chip-template><span \nclass=\"chipsValue\">{{$chip.name}}</span></md-chip-template></md-chips></md-input-container><div layout=\"column\" \nlayout-align=\"space-between start\" class=\"md-block h-50 all-width\" flex-gt-sm ng-if=\"filter.type == \'RADIO\'\"><div \nclass=\"h4 grey-fg font-weight-300\"><label>{{filter.name}}</label></div><div layout=\"row\" \nlayout-align=\"space-between center\"><md-radio-group ng-model=\"vm.data[filter.id]\" layout=\"row\" \nlayout-align=\"start center\"><md-radio-button ng-value=\"option.id\" class=\"mb-5\" ng-repeat=\"option in filter.options\">\n{{option.name}}</md-radio-button></md-radio-group></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" ng-if=\"vm.loading\">\n</md-progress-circular></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\" \nclass=\"p-10\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20\">Cancelar</md-button><md-button \nng-click=\"vm.saveSearch()\" ng-disabled=\"vm.loading || vm.filtrosClear\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Buscar</md-button><md-button \nng-click=\"vm.clearFilters()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Limpiar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/analyst/partials/finish_process/finish_process.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-300\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.request.name}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"padding\"><div id=\"confirmStage\" layout=\"column\" layout-align=\"space-between\">\n<div class=\"mb-20\" layout=\"row\" layout-align=\"center center\"><span class=\"h2 font-weight-300\" \nng-if=\"vm.request.status_process.id != vm.status_process_status.PROCESO_FINALIZADO\">\n¿Confirma que desea pasar el proceso &nbsp; <span class=\"h2 font-weight-500\">{{vm.request.name}}</span>\n al estado finalizado ? </span><span class=\"h2 font-weight-300\" \nng-if=\"vm.request.status_process.id == vm.status_process_status.PROCESO_FINALIZADO\">\n¿Confirma que desea habilitar el proceso &nbsp; <span class=\"h2 font-weight-500\">{{vm.request.name}}</span> ?</span>\n</div><div class=\"mt-15\" layout=\"row\" layout-align=\"center center\"><md-button aria-label=\"Cancelar\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.closeDialog()\">\nCancelar</md-button><md-button aria-label=\"Aceptar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validatePetition()\">Aceptar</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/history-request/history-request.html","<md-dialog aria-label=\"List dialog\" flex=\"70\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Detalle de la historia </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"padding\"><div id=\"historyRequestDialog\" layout=\"column\" \nlayout-align=\"space-between\"><div class=\"ms-responsive-table-wrapper md-whiteframe-4dp all-width white-bg\" \nlayout=\"row\"><table class=\"row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\">\n<thead><tr><th></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div class=\"table-header\"><span \nclass=\"column-title white-fg\"></span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"secondary-text br\"><div \nclass=\"table-header\"><span class=\"column-title white-fg\">Descripción</span></div></th></tr></thead><tbody><tr><td>1\n</td><td class=\"name font-weight-500\">ID</td><td class=\"grey-100-bg\">{{vm.logDetail.id }}</td></tr><tr><td>2</td><td \nclass=\"name font-weight-500\">Fecha y hora</td><td class=\"grey-100-bg\">\n{{vm.logDetail.date.formatDate | capitalize:true}}</td></tr><tr><td>3</td><td class=\"name font-weight-500\">Usuario</td>\n<td class=\"grey-100-bg\">{{vm.logDetail.usuario | capitalize:true}}</td></tr><tr><td>4</td><td \nclass=\"name font-weight-500\">Acción</td><td class=\"grey-100-bg\">{{vm.logDetail.action | capitalize:true}}</td></tr><tr>\n<td>5</td><td class=\"name font-weight-500\">IP</td><td class=\"grey-100-bg\">{{vm.logDetail.ip | capitalize:true}}</td>\n</tr><tr><td>8</td><td class=\"name font-weight-500\">Detalle</td><td class=\"grey-100-bg\"><div \nng-repeat=\"(key,data) in vm.logDetail.detalle\" layout=\"row\" layout-align=\"start center\"><span class=\"font-weight-500\">\n{{key}}:</span> <span class=\"\">{{data}}</span></div></td></tr><tr><td>9</td><td class=\"name font-weight-500\">Data</td>\n<td class=\"grey-100-bg\"><div ng-repeat=\"(key,data) in vm.logDetail.data\" layout=\"row\" layout-align=\"start center\"><span\n class=\"font-weight-500\">{{key}}:</span> <span class=\"\">{{data | parseJson}}</span></div></td></tr></tbody></table>\n</div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/notes/note.html","<div id=\"noteContect\" layout=\"column\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start \" \nclass=\"grey-200-bg p-20\"><div><div ng-if=\"!showForm\" class=\"ms-note-new mb-20\"><div ng-click=\"changeForm()\" \nclass=\"new-button-note\"><span>Agregar nota</span></div></div><div class=\"ms-note mb-20\" ng-if=\"showForm\"><form \nname=\"obsForm\" class=\"\"><md-input-container md-no-float><textarea name=\"comentario\" ng-model=\"data.note\" \nplaceholder=\"Tome una nota\" class=\"note-description-textarea mb-8\" required>\n                                    \n</textarea></md-input-container><div class=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\" flex=\"100\" layout-align=\"end center\"><md-button \nng-click=\"changeForm()\" aria-label=\"Cancelar\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding\">\nCancelar</md-button><md-button ng-click=\"callbackAddNote({data:data,index:indexCandidate})\" aria-label=\"Guardar\" \ntype=\"submit\" ng-disabled=\"obsForm.$invalid || obsForm.$pristine || vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></div></form></div></div><div layout=\"column\" layout-align=\"start\"><div><span>visible para</span>\n</div><div><md-radio-group ng-model=\"data.visualize\" layout=\"row\" layout-align=\"space-between\"><md-radio-button \nng-value=\"1\">Equipo de selección</md-radio-button><md-radio-button ng-value=\"2\">Solo para mi</md-radio-button>\n</md-radio-group></div></div></div><div class=\"p-20 white-bg\"><div layout=\"column\" layout-align=\"start\" \nng-repeat=\"note in notes\" class=\"border-bottom pt-20 pb-20\"><div layout=\"row\" aling=\"space-between\"><div class=\"mr-10\">\n<img class=\"profile-image ms-note-image\" ng-src=\"{{note.image}}\"></div><div layout=\"column\" layout-align=\"start\"><div \nclass=\"h2 font-weight-700 grey-600-fg\" ng-click=\"flipWidget()\">{{note.name | capitalize:true}}</div><div \nclass=\"h5 font-weight-500 grey-500-fg\">{{note.date_create_note }}</div><div>{{note.note}}</div></div></div></div></div>\n</div>");
$templateCache.put("app/main/analyst/partials/notes/noteDialog.html","<md-dialog aria-label=\"List dialog\" flex=\"50\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\" \nng-class=\"config.toolbar.class\"><span class=\"text-truncate h2\">{{config.toolbar.name}} </span><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><div id=\"noteContect\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"start \" class=\"grey-200-bg p-20\"><div><div \nng-if=\"!showForm\" class=\"ms-note-new mb-20\"><div ng-click=\"changeForm()\" class=\"new-button-note\"><span>Agregar nota\n</span></div></div><div class=\"ms-note mb-20\" ng-if=\"showForm\"><form name=\"obsForm\" class=\"\"><md-input-container \nmd-no-float><textarea name=\"comentario\" ng-model=\"data.note\" placeholder=\"Escribe una nota\" \nclass=\"note-description-textarea mb-8\" autofocus required>\n                                </textarea>\n</md-input-container><div class=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\" flex=\"100\" layout-align=\"end center\"><md-button ng-click=\"changeForm()\" \naria-label=\"Cancelar\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding\">Cancelar</md-button>\n<md-button ng-click=\"config.callbackSuccess(data);changeForm()\" aria-label=\"Guardar\" type=\"submit\" \nng-disabled=\"obsForm.$invalid || obsForm.$pristine || vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></div></form></div></div><div ng-if=\"!config.hideVisibility && showForm\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\" layout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" \nlayout-align-sm=\"space-betweeen\" layout-align-gt-sm=\"space-betweeen\" layout-align-md=\"start center\" \nlayout-align-gt-md=\"start center\" layout-align-lg=\"start center\" layout-align-gt-lg=\"start center\" \nlayout-align-xl=\"start center\"><div class=\"pr-10\"><span>Visible para</span></div><div><md-radio-group \nng-model=\"data.visualize\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" layout-align-xs=\"space-betweeen\" \nlayout-align-gt-xs=\"space-betweeen\" layout-align-sm=\"space-betweeen\" layout-align-gt-sm=\"space-betweeen\" \nlayout-align-md=\"start center\" layout-align-gt-md=\"start center\" layout-align-lg=\"start center\" \nlayout-align-gt-lg=\"start center\" layout-align-xl=\"start center\"><md-radio-button ng-value=\"1\" class=\"mb-10\">\nEquipo de selección</md-radio-button><md-radio-button ng-value=\"0\" class=\"mb-10\">Solo para mi</md-radio-button>\n</md-radio-group></div></div></div><div class=\"white-bg\"><div class=\"\" layout=\"column\" layout-align=\"start\" \nng-repeat=\"note in config.notes\" ng-class=\"{\'field-container\':note.newNote}\"><div layout=\"row\" \nlayout-align=\"space-between\" class=\"p-20\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" \nlayout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" \nlayout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" layout-align-sm=\"space-betweeen\" \nlayout-align-gt-sm=\"space-betweeen\" layout-align-md=\"space-betweeen\" layout-align-gt-md=\"space-betweeen\" \nlayout-align-lg=\"space-betweeen\" layout-align-gt-lg=\"space-betweeen\" layout-align-xl=\"space-betweeen\"><div \nclass=\"mr-10\"><img class=\"profile-image ms-note-image\" ng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\"></div><div \nlayout=\"column\" layout-align=\"start\" class=\"all-width\"><div class=\"h2 font-weight-700 grey-600-fg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"row\" layout-aling=\"start center\"><div>{{note.name | capitalize:true}}</div>\n<div><i ng-if=\"!config.hideVisibility\" ng-class=\"note.visibility?\'icon-earth\':\'icon-lock\'\" \nclass=\"s16 pl-10 grey-400-fg\"></i></div></div><div><i class=\"icon-pen\" ng-click=\"vm.editNote()\"></i></div></div><div \nclass=\"h5 font-weight-500 grey-500-fg mb-10\">{{note.date_create_note | capitalize:true}}</div><div>{{note.note}}</div>\n</div></div><div class=\"border-bottom\" ng-if=\"!$last\"></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/recommend_candidate/recommend_candidate.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\" \nng-class=\"config.toolbar.class\"><span class=\"text-truncate h2\">{{config.toolbar.name}} </span><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><div id=\"recommend_candidate\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"grey-200-bg p-20\" layout=\"column\" \nlayout-align=\"space-between\"><md-autocomplete md-selected-item=\"data.selectedItem\" md-search-text=\"data.searchText\" \nmd-selected-item-change=\"config.functions.selectedItemChange(item)\" \nmd-items=\"item in config.functions.querySearch(data.searchText)\" md-item-text=\"item.name\" md-min-length=\"0\" \nplaceholder=\"Selecciona un cargo\"><md-item-template><span md-highlight-text=\"data.searchText\" md-highlight-flags=\"^i\">\n{{item.name}}</span></md-item-template><md-not-found>\nNo se encontro un cargo bajo el siguiente parametro: \"{{data.searchText}}\".</md-not-found></md-autocomplete><div \nclass=\"pt-10 text-right\"><md-button ng-if=\"data.selectedItem\" ng-click=\"config.callbackSuccess(data)\" \naria-label=\"Guardar\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></div><div class=\"p-20 white-bg\"><div layout=\"column\" layout-align=\"start\" \nng-repeat=\"recomend in config.historyRecommend\" ng-class=\"{\'field-container\':recomend.newRecommend}\"><div layout=\"row\" \naling=\"space-between\" class=\"pt-20 pb-20\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" \nlayout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" \nlayout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" layout-align-sm=\"space-betweeen\" \nlayout-align-gt-sm=\"space-betweeen\" layout-align-md=\"space-betweeen\" layout-align-gt-md=\"space-betweeen\" \nlayout-align-lg=\"space-betweeen\" layout-align-gt-lg=\"space-betweeen\" layout-align-xl=\"space-betweeen\"><div \nclass=\"mr-10\"><img class=\"profile-image ms-recommend-image\" ng-src=\"{{\'assets/images/avatars/profile.jpg\'}}\"></div><div\n layout=\"column\" layout-align=\"start\"><div class=\"h2 font-weight-700 grey-600-fg\" layout=\"row\" layout=\"start center\">\n<div>{{recomend.charge | capitalize:true}}</div></div><div class=\"h5 font-weight-500 grey-500-fg mb-10\">\n{{recomend.name | capitalize:true}}</div></div></div><div class=\"border-bottom\" ng-if=\"!$last\"></div></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/referred_candidate/referred_candidate.html","<md-dialog aria-label=\"List dialog\" flex=\"40\" class=\"h-300\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Referir candidato {{vm.candidate.name | capitalize:true}} </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-padding\"><div id=\"noteContect\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"start \" class=\"p-20\"><md-input-container><div \nclass=\"h4 grey-fg font-weight-300\"><label>Referido por</label></div><input type=\"text\" ng-model=\"vm.data.referente\">\n</md-input-container><div ng-if=\"vm.errors.referente\" class=\"h5 red-500-fg\">{{vm.errors.referente}}</div></div><div \nlayout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nng-if=\"vm.loading\"></md-progress-circular></div><div layout=\"row\" layout-align=\"center center\" class=\"p-10\"><md-button \nng-click=\"vm.sendReferred()\" aria-label=\"Recommend candidate\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Enviar</md-button></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/scheduled_citation/scheduled_citationDialog.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\" \nng-class=\"vm.config.toolbar.class\"><span class=\"text-truncate h2\">{{vm.config.toolbar.name}} </span><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"Agendar cita\"><md-content class=\"md-padding\"><div \nid=\"scheduleCitationDialog\" layout=\"column\" layout-align=\"space-between\"><table class=\"md-api-table\"><tr><td \nclass=\"font-weight-600\">Candidato</td><td>{{vm.candidate.name | capitalize:true}}</td></tr><tr><td \nclass=\"font-weight-600\">Correo</td><td>{{(vm.candidate.email ? vm.candidate.email : vm.candidate.email_alternative)}}\n</td></tr><tr><td class=\"font-weight-600\">Telefono</td><td><div layout=\"column\" layout-align=\"space-between\"><span \nng-if=\"vm.candidate.cell_phone\">{{vm.candidate.cell_phone}}</span> <span ng-if=\"vm.candidate.phone\">\n{{vm.candidate.phone}}</span> <span ng-if=\"!vm.candidate.phone && !vm.candidate.cell_phone\">\nNo se encuentra registrado un numero de contacto</span></div></td></tr><tr><td class=\"font-weight-600\">Fecha</td><td \nclass=\"pl-4\"><md-datepicker ng-model=\"vm.data.dateSelected\" md-placeholder=\"Agendar fecha\" format=\"\"></md-datepicker>\n</td></tr><tr><td class=\"font-weight-600\">Hora</td><td class=\"no-padding\"><md-time-picker \nng-model=\"vm.data.timeSelected\" message=\"message\"></md-time-picker></td></tr><tr><td class=\"font-weight-600\">Lugar</td>\n<td><md-select class=\"m-0\" aria-label=\"status\" ng-model=\"vm.data.placeSelected\"><md-option \nng-repeat=\"place in vm.config.lists.placeCita\" ng-value=\"place.id\">{{place.name | capitalize:true}}</md-option>\n</md-select></td></tr><tr><td class=\"font-weight-600\">Tipo de cita</td><td><md-select class=\"m-0\" aria-label=\"status\" \nng-model=\"vm.data.typecitaSelected\"><md-option ng-repeat=\"type in vm.config.lists.typeCita\" ng-value=\"type.id\">\n{{type.name | capitalize:true}}</md-option></md-select></td></tr></table><div layout=\"row\" \nlayout-align=\"center center\" class=\"mt-20\"><md-button \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin white-fg\" \nng-click=\"vm.executeCallback()\">Agendar Cita</md-button></div></div></md-content></md-tab><md-tab \nlabel=\"Historial de citas\"><md-content class=\"no-padding\"><div class=\"md-padding light-blue-50-bg\"><table \nclass=\"md-api-table\"><tr><td class=\"font-weight-600 h4\">Candidato</td><td class=\"h4\">\n{{vm.candidate.name | capitalize:true}}</td></tr><tr><td class=\"font-weight-600 h4\">Correo</td><td class=\"h4\">\n{{(vm.candidate.email ? vm.candidate.email : vm.candidate.email_alternative)}}</td></tr><tr><td \nclass=\"font-weight-600 h4\">Telefono</td><td class=\"h4\"><div layout=\"column\" layout-align=\"space-between\"><span \nng-if=\"vm.candidate.cell_phone\">{{vm.candidate.cell_phone}}</span> <span ng-if=\"vm.candidate.phone\">\n{{vm.candidate.phone}}</span> <span ng-if=\"!vm.candidate.phone && !vm.candidate.cell_phone\">\nNo se encuentra registrado un numero de contacto</span></div></td></tr></table></div><div layout=\"column\" \nng-repeat=\"cita in vm.config.citas\" class=\"md-padding\" \nng-class=\"{\'bt\':$first,\'bb\':!$last,\'grey-50-bg\':vm.data.keyArray > $index}\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"mb-5\"><span class=\"h3 font-weight-600\" \nng-class=\"vm.data.keyArray > $index ? \'grey-500-fg\' : \'grey-700-fg\'\">{{cita.nameShowFormat | capitalize:true}}</span>\n</div><div layout=\"row\" layout-align=\"start center\"><span class=\"h4 font-weight-400\" \nng-class=\"vm.data.keyArray > $index ? \'grey-400-fg\' : \'grey-600-fg\'\">Lugar de cita: {{cita.place}}</span></div><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 font-weight-400\" \nng-class=\"vm.data.keyArray > $index ? \'grey-400-fg\' : \'grey-600-fg\'\">Tipo de cita: {{cita.type}}</span></div></div>\n</md-content></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/search_offer/search_offer.html","<md-dialog aria-label=\"List dialog\" flex=\"50\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Importar publicación de oferta </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"no-padding\"><div id=\"understandingDialogContent\" layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"start \" class=\"p-20 grey-200-bg\"><md-autocomplete \nmd-search-text=\"vm.query\" md-items=\"item in vm.process\" md-item-text=\"item.cargo_ocupar\" md-min-length=\"0\" \nplaceholder=\"Buscar ofertas\" md-autofocus=\"\" md-search-text-change=\"vm.searchOffer(vm.idRequest,vm.query)\" \nmd-selected-item-change=\"vm.getOffer(item);\" md-autofocus=\"true\"><md-item-template><span md-highlight-text=\"vm.query\" \nmd-highlight-flags=\"^i\">{{item.cargo_ocupar}}</span></md-item-template><md-not-found>\nPara este cargo no se han publicado ofertas</md-not-found></md-autocomplete></div><div \nng-if=\"!vm.loading && vm.blocks\" ng-repeat=\"block in vm.blocks\"><div \nng-include=\"\'app/main/templates/request/blocks/read/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div></div><div \nng-if=\"vm.data && !vm.loading\" layout=\"row\" layout-align=\"center center\" class=\"mb-10 mt-10\"><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg\" \nng-click=\"vm.hideModal();\">Importar publicación de oferta</md-button></div></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"h-100\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nng-if=\"vm.loading\"></md-progress-circular></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/show_hv/show_hv.html","<md-dialog aria-label=\"List dialog\" flex=\"80\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">{{vm.candidate.name}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"padding\"><div ng-if=\"vm.blocks.length == 0\" layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" class=\"grey-200-bg p-30\"><div class=\"pl-25 pr-25 pt-15 pb-15 h2\">\nCargando información por favor espere...</div></div><div ng-repeat=\"block in vm.blocks\"><div \nng-if=\"block.name == \'personales\' && true\" ng-include=\"\'app/main/templates/resume/personal-info.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'perfil\'\" \nng-include=\"\'app/main/templates/resume/one-column-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'experiencia\'\" ng-include=\"\'app/main/templates/resume/laboral-experience.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'estudios_formales\'\" \nng-include=\"\'app/main/templates/resume/formal-study.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'estudios_no_formales\'\" ng-include=\"\'app/main/templates/resume/non-formal-study.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'laboral\'\" \nng-include=\"\'app/main/templates/resume/one-column-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'contacto_emergencia\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'idiomas\'\" \nng-include=\"\'app/main/templates/resume/languages.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'grupo_familiar\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'hijos\'\" \nng-include=\"\'app/main/templates/resume/childrens.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'madre\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'padre\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'conyuge\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'viven_usted\'\" \nng-include=\"\'app/main/templates/resume/two-columns.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'vivienda\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'contacto\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div><div \nng-if=\"block.name == \'salud\'\" ng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" \nonload=\"item = block.data\"></div><div ng-if=\"block.name == \'adicional\'\" \nng-include=\"\'app/main/templates/resume/two-columns-one-row.html\'\" onload=\"item = block.data\"></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/understanding/understanding.html","<md-dialog aria-label=\"List dialog\" flex=\"50\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Seleccionar entendimiento del cargo </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\"><div id=\"understandingDialogContent\" \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start \" class=\"p-20 grey-200-bg\"><div \nclass=\"search-wrapper md-whiteframe-4dp h-50 mb-10 white-bg p-20\" layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon><input flex ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for an e-mail or contact\" translate \ntranslate-attr-placeholder=\"Buscar\"></div></div><div layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" \nlayout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" layout-xl=\"row\" \nlayout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" layout-align-sm=\"space-betweeen\" \nlayout-align-gt-sm=\"space-betweeen\" layout-align-md=\"start center\" layout-align-gt-md=\"start center\" \nlayout-align-lg=\"start center\" layout-align-gt-lg=\"start center\" layout-align-xl=\"start center\"><div class=\"pr-10\">\n<span>Buscan en:</span></div><div><md-radio-group ng-model=\"vm.data.visibility\" layout-xs=\"column\" \nlayout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-xs=\"column\" layout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" \nlayout-gt-lg=\"row\" layout-xl=\"row\" layout-align-xs=\"space-betweeen\" layout-align-gt-xs=\"space-betweeen\" \nlayout-align-sm=\"space-betweeen\" layout-align-gt-sm=\"space-betweeen\" layout-align-md=\"start center\" \nlayout-align-gt-md=\"start center\" layout-align-lg=\"start center\" layout-align-gt-lg=\"start center\" \nlayout-align-xl=\"start center\"><md-radio-button ng-value=\"1\" class=\"mb-10\">Cargos iguales al actual</md-radio-button>\n<md-radio-button ng-value=\"0\" class=\"mb-10\">Todos los cargos</md-radio-button></md-radio-group></div></div></div><div \nclass=\"p-20 white-bg\"><div layout=\"column\" layout-align=\"start\" ng-repeat=\"proceso in vm.procesos | filter:vm.search\" \nclass=\"pt-20 pb-10\"><div layout=\"row\" aling=\"space-between\" class=\"mb-10\"><div layout=\"column\" \nlayout-align=\"space-between\" class=\"all-width\"><div layout=\"row\" layout-align=\"space-between\"><div \nclass=\"h4 font-weight-700 grey-600-fg\">{{proceso.cargo_ocupar | capitalize:true}}</div><div \nclass=\"h4 font-weight-500 blue-300-fg\">{{proceso.codigo | capitalize:true}}</div></div><div layout=\"row\" \nlayout-align=\"start\"><span class=\"h5 font-weight-500 grey-600-fg\">\nRealizado por: {{proceso.colaborador | capitalize:true}}</span></div><div><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 mb-10 white-fg no-margin\" \nng-click=\"vm.SelectedRequest(proceso)\">Seleccionar</md-button></div></div></div><div class=\"bb\" ng-if=\"!$last\"></div>\n</div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/partials/update-request/update.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-500\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Actualizar información del proceso </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"padding\"><div id=\"confirmStage\" layout=\"column\" layout-align=\"space-between\">\n<div class=\"mb-20\" layout=\"row\" layout-align=\"start center\"><span class=\"h3 font-weight-500\">Nombre proceso:</span> \n<span class=\"h3 font-weight-300\">{{vm.request.name}}</span></div><div class=\"mb-20\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h3 font-weight-500\">No.req:</span> <span class=\"h3 font-weight-300\">\n{{vm.request.cod}}</span></div><div class=\"mb-20\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h3 font-weight-500\">Fecha acuerdo de servicio:</span> <span class=\"h3 font-weight-300\">\n{{vm.fechaAcuerdo | capitalize:true}}</span></div><div layout=\"column\" layout-align=\"center start\"><span \nclass=\"h3 font-weight-500\">Nueva fecha acuerdo de servicio:</span><md-datepicker ng-model=\"vm.newDate\" \nmd-placeholder=\"Nueva fecha acuerdo de servicio\" md-open-on-focus></md-datepicker></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\" class=\"p-10\"><md-button aria-label=\"Cancelar\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.closeDialog()\">\nCancelar</md-button><md-button aria-label=\"Aceptar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.save()\" \nng-disabled=\"!vm.newDate || !vm.fechaAcuerdo\">Aceptar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/analyst/suspension-request/dialog/suspension-dialog.html","<md-dialog aria-label=\"List dialog\" flex=\"50\"><md-toolbar><div class=\"md-toolbar-tools\" \nng-class=\"config.toolbar.class\"><span class=\"text-truncate h2\">Suspender proceso </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"p-30\"><div id=\"suspensionDialogContent\" \nlayout=\"column\" layout-align=\"space-between\"><form name=\"suspensionForm\" \nng-submit=\"vm.saveSuspensionRequest(suspensionForm.$valid)\" novalidate><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"text-left all-width\"><md-input-container class=\"all-width\"><label>\nMotivo de suspensión</label><md-select name=\"criterio\" class=\"m-0\" aria-label=\"status\" ng-model=\"vm.data.suspension\" \nrequired><md-option ng-repeat=\"status in vm.misc.arrCrSuspension\" ng-value=\"status\">\n{{status.name |capitalizeFirstLetter }}</md-option></md-select><div ng-messages=\"suspensionForm.criterio.$error\"><div \nng-message=\"required\">Es requerido un criterio para la suspension del proceso.</div></div></md-input-container></div>\n</div><div layout=\"column\" layout-align=\"start start\"><md-input-container class=\"all-width\"><label>Observaciones\n</label><textarea name=\"observation\" ng-model=\"vm.data.observation\" rows=\"4\" md-maxlength=\"200\" md-select-on-focus \nrequired></textarea><div ng-messages=\"suspensionForm.observation.$error\"><div ng-message=\"required\">\nEs requerido una observacion para la suspension del proceso.</div><div ng-message=\"md-maxlength\">\nLa observacion no puede tener mas de 200 caracteres</div></div></md-input-container></div><div layout=\"column\" \nlayout-align=\"space-between start\" ng-if=\"vm.request.status_offer.id == vm.statusOffer.PUBLICADO\"><div \nclass=\"text-left all-width\"><md-input-container class=\"all-width\"><label>¿Mantener el proceso publicado?</label>\n<md-select name=\"publicado\" class=\"m-0\" aria-label=\"status\" ng-model=\"vm.data.publicado\" required><md-option \nng-repeat=\"status in vm.misc.arrOpPublish\" ng-selected=\"status.id == 1\" ng-value=\"status\">\n{{status.name | capitalize:true}}</md-option></md-select><div ng-messages=\"suspensionForm.criterio.$error\"><div \nng-message=\"required\">Es requerido un criterio para la suspension del proceso.</div></div></md-input-container></div>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button aria-label=\"Guardar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized\" ng-click=\"vm.closeDialog()\">Cancelar</md-button><md-button \ntype=\"submit\" aria-label=\"Guardar\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized white-fg\" \nng-disabled=\"!suspensionForm.$valid\">Suspender</md-button></div></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/analyst/understanding-charge/dialog/block.html","<md-dialog aria-label=\"List dialog\" flex=\"80\"><md-toolbar><div class=\"md-toolbar-tools\"><span class=\"text-truncate h2\">\n{{vm.title}} </span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content\n class=\"no-padding\"><div layout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\" ng-show=\"vm.loadingBlock\"></md-progress-circular></div><div id=\"discardStage\" layout=\"column\" \nlayout-align=\"space-between\"><div ng-repeat=\"block in vm.blocksStage\"><div \nng-include=\"\'app/main/templates/request/blocks/update/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div></div>\n</div><div layout=\"row\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nng-show=\"vm.saving\"></md-progress-circular></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\" class=\"p-10\"><md-button aria-label=\"Cancelar\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.closeDialog()\" \nng-disabled=\"vm.saving\">Cancelar</md-button><md-button aria-label=\"Aceptar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" \nng-click=\"vm.validateDataStage()\" ng-disabled=\"vm.saving\">Aceptar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/analyst/understanding-charge/tabs/request.html","<div layout=\"row\" layout-align=\"end center\" class=\"m-15\"><div md-colors=\"{color: \'primary\'}\"><i \nclass=\"icon-email cursor-pointer\" ng-click=\"vm.showModalApprovedEmails(2)\"></i></div><div \nmd-colors=\"{color: \'accent\'}\"><i class=\"icon-file-pdf-box cursor-pointer\" ng-click=\"vm.downloadRequestPDF()\"></i></div>\n</div><div ng-repeat=\"block in vm.blocks\"><div \nng-include=\"\'app/main/templates/request/blocks/read/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div></div>");
$templateCache.put("app/main/analyst/understanding-charge/tabs/understanding.html","<div layout=\"row\" layout-align=\"end center\" class=\"m-15\"><div md-colors=\"{color: \'primary\'}\"><i \nclass=\"icon-email cursor-pointer\" ng-click=\"vm.showModalApprovedEmails(1)\"></i></div><div \nmd-colors=\"{color: \'accent\'}\"><i class=\"icon-file-pdf-box cursor-pointer\" ng-click=\"vm.downloadPDF()\"></i></div></div>\n<div ng-repeat=\"block in vm.blocks\"><div \nng-include=\"\'app/main/templates/request/blocks/update/\' + block.type + \'.html\'\" ng-init=\"item = block\"></div></div><div\n layout=\"row\" class=\"pb-15\" layout-align=\"center center\"><div class=\"p-5\"><md-button \nng-disabled=\"!vm.change || vm.saving\" ng-click=\"vm.save(true,1)\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg all-width\" \naria-label=\"Guardar\">Guardar</md-button></div><div class=\"p-5\" \nng-if=\"vm.request.approve_understanding.enviar_entendimiento_aprobacion == 1\"><div layout-wrap \nng-if=\"vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'No enviado\' || vm.request.approve_understanding.estado_entendimiento_cargo_aprobacion == \'Rechazado\'\">\n<md-button ng-disabled=\"!vm.change || vm.saving\" ng-click=\"vm.save(true,2)\" \nclass=\"md-raised light-green-500-bg h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg all-width\" \naria-label=\"Guardar y aprobar\">Guardar y enviar aprobación</md-button></div></div></div>");
$templateCache.put("app/main/auth/recover-password/dialogs/security-questions.html","<md-dialog aria-label=\"Recover\" class=\"\"><md-toolbar class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column>\n<div layout=\"row\" flex=\"100\" layout-align=\"end end\"><md-button class=\"md-icon-button no-padding no-margin\" \nng-click=\"vm.closeDialog()\"><md-icon class=\"\" md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div><div layout=\"row\" class=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div \nclass=\"h2 text-uppercase\"><span ng-class=\"{\'font-weight-900\' : $last}\" class=\"\" ng-repeat=\"tit in vm.title\">{{tit}}\n</span></div></div></div></md-toolbar><md-dialog-content class=\"p-10\" layout-padding><div ng-if=\"vm.questionsForm\" \nclass=\"all-width p-20\" layout=\"column\" flex=\"100\"><div class=\"pt-10 h4 grey-600-fg\">\nPor favor lea atentamente y responda las siguientes preguntas. Las usaremos para validar su identidad.</div><form \nname=\"form\" novalidate class=\"pt-10 pb-20 pl-20 pr-20 white-bg\" ms-scroll><md-input-container \nng-repeat=\"field in vm.questions track by $index\" class=\"md-block no-margin\" md-no-float><div \nclass=\"h5 pt-10 pb-10 gray-600-fg font-weight-600\">{{field.label}}</div><md-radio-group ng-required=\"true\" \nclass=\"no-margin\" name=\"{{field.key}}\" ng-model=\"vm.answers[field.key]\"><md-radio-button \nng-repeat=\"(key, option) in field.options  track by $index\" value=\"{{key}}\" class=\"ml-10 mb-5 md-primary\" \naria-label=\"{{key}}\"><span class=\"font-weight-400 h6\">{{option}}</span></md-radio-button></md-radio-group><div \nng-if=\"vm.errors[field.key]\" class=\"h5 pt-10 pb-10 red-500-fg font-weight-600\">{{vm.errors[field.key]}}</div>\n</md-input-container></form></div><div ng-if=\"!vm.questionsForm\" class=\"all-width p-20\" layout=\"column\" flex=\"100\">\n<form name=\"form\" novalidate class=\"\"><div class=\"pt-10 pb-10 h4 grey-600-fg\">\nHas contestado correctamente las preguntas, por favor escribe y confirma tu nueva contraseña.</div><md-input-container \nclass=\"md-block\" md-no-float><label>Contraseña</label><input type=\"password\" name=\"new\" minlength=\"6\" maxlength=\"40\" \nng-model=\"vm.form.new\" ng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" required><div \nng-messages=\"form.new.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FIELD_REQUIRED\">Campo requerido\n</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div><div ng-if=\"vm.errors[\'new\']\" class=\"h6 red-500-fg\">{{vm.errors[\'new\']}}</div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>Confirmar contraseña</label><input type=\"password\" \nname=\"confirm\" minlength=\"6\" maxlength=\"40\" ng-model=\"vm.form.confirm\" \nng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" required><div \nng-messages=\"form.confirm.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FIELD_REQUIRED\">\nCampo requerido</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div><div ng-if=\"vm.errors[\'confirm\']\" class=\"h6 red-500-fg\">{{vm.errors[\'confirm\']}}</div></md-input-container>\n<div class=\"text-center\"><md-button ng-click=\"vm.recoverPassword()\" aria-label=\"ACEPTAR\" type=\"submit\" \nng-disabled=\"form.$invalid || form.$pristine\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></form></div></md-dialog-content><md-dialog-actions ng-if=\"vm.questionsForm\" class=\"bt h-90\" \nlayout=\"column\"><div ng-if=\"vm.error\" class=\"p-5 h4 red-500-fg font-weight-600 text-center\">{{vm.error}}</div><div \nclass=\"p-5\" flex=\"100\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"pl-5 pr-5\"><md-button \nng-click=\"vm.closeDialog()\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.sendAnswers()\" type=\"submit\" ng-disabled=\"vm.saving\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">{{vm.saveButtonTitle}}\n</md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/templates/block-generic/autocomplete/one-column-info.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/resume/shared/block-title-selected.html\'\"></div><div \nclass=\"p-10\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"column\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label  && vm.validationService.validateShowRequestFields(field, vm.data.data)\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{vm.fields[field].label}} <span \nng-if=\"vm.fields[field].label_help\">({{vm.fields[field].label_help}})</span></div><div class=\"grey-fg h6 p-8\">\n{{vm.data.data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]}}</div><div \nng-if=\"vm.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">{{vm.errors[field]}}</div></div><div class=\"p-10\" flex-md=\"30\" \nflex-gt-md=\"30\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/autocomplete/one-column.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title-selected.html\'\"></div><div \nclass=\"p-20\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" \nng-class=\"{\'bb\' : !$last}\" layout=\"column\" flex=\"100\" class=\"pl-5 pr-5 pt-10 pb-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{vm.fields[field].label}} <span \nng-if=\"vm.fields[field].label_help\">({{vm.fields[field].label_help}})</span></div><div \nng-class=\"{\'pre-line\': vm.fields[field].type == \'textarea\'}\" class=\"grey-fg h6 p-8\" \nng-bind-html=\"vm.data.data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]\"></div>\n<div ng-if=\"vm.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">{{vm.errors[field]}}</div></div></div></ms-widget-front>\n</ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/autocomplete/two-column-multiple-rows.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title-selected.html\'\"></div><div \nng-repeat=\"(modelKey, values) in vm.data.data[item.model]\" class=\"bb pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" \nlayout-wrap><div ng-repeat=\"(keyFieldData, fieldData) in vm.fields[item.model]\" ng-class=\"{\'bt\' : $index > 1}\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div class=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{fieldData.label}} <span \nng-if=\"fieldData.label_help\">({{fieldData.label_help}})</span></div><div \nng-class=\"{\'pre-line\': fieldData.type == \'textarea\'}\" class=\"grey-fg h6 p-8\"><div ng-bind-html=\"values[keyFieldData]\">\n</div></div><div ng-if=\"vm.errors[field]\" class=\"p-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/autocomplete/two-columns.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title-selected.html\'\"></div><div \nclass=\"p-20\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{vm.fields[field].label}} <span \nng-if=\"vm.data.original_data[field]\" class=\"text-strike grey-fg pr-5 pl-5\"><span \nng-if=\"vm.data.original_data[field + \'_lista\']\" \nng-bind-html=\"vm.data.original_data[field] | formatValue : vm.fields[field].type : vm.data.original_data[field + \'_lista\']\">\n</span> <span ng-if=\"!vm.data.original_data[field + \'_lista\']\" \nng-bind-html=\"vm.data.original_data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]\">\n</span></span></div><div ng-class=\"{\'pre-line\': vm.fields[field].type == \'textarea\'}\" class=\"grey-fg h6 p-8\"><div \nng-bind-html=\"vm.data.data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]\"></div>\n</div><div ng-if=\"vm.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">{{vm.errors[field]}}</div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/create/one-column-info.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-10 pr-10 pt-10 pb-20\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" flex=\"100\" layout-wrap><div class=\"p-10\" \nflex-md=\"70\" flex-gt-md=\"70\" flex-lg=\"70\" flex-gt-lg=\"70\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[field]\" fieldname=\"field\" \nmodel=\"vm.values\" block=\"item.model\" idblock=\"item.id\" options=\"vm.lists[vm.fields[field].options]\"></div><div \nng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div><div \nng-if=\"vm.values.title\" class=\"p-10\" flex-md=\"30\" flex-gt-md=\"30\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap><div \nclass=\"h4 pl-10 pr-10 pt-5 pb-5\">Descripción del trámite a realizar</div><div class=\"grey-50-bg p-10 b\"><div \nclass=\"font-weight-600 h5\">{{vm.values.title}}</div><div class=\"h6\">{{vm.values.desc}}</div></div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/create/one-column.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[field]\" fieldname=\"field\" \nmodel=\"vm.values\" block=\"item.model\" idblock=\"item.id\" options=\"vm.lists[vm.fields[field].options]\"></div><div \nng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div></ms-widget-front>\n</ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/create/select-current-employee.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap id=\"\"><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.getVacants().length && vm.checkEmptyObject(vm.lists.position_colaborators) == false\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div ng-repeat=\"value in vm.values[field]\" \nng-if=\"vm.lists[vm.fields[field].options][value].name\" ng-class=\"{\'bb\' : !$last, \'pt-15\' : !$first}\" class=\"pb-15\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\"><div class=\"pb-10 pr-10\"><div class=\"h3 text-bold\"><span \nng-if=\"vm.lists[vm.fields[field].options][value].cod_empleado\">\n{{vm.lists[vm.fields[field].options][value].cod_empleado}} - </span>\n{{vm.lists[vm.fields[field].options][value].name | capitalize:true}}</div><div class=\"h5\" \nng-if=\"vm.lists[vm.fields[field].options][value].cargo\">{{vm.lists[vm.fields[field].options][value].cargo}}</div></div>\n<div ng-if=\"vm.fields[field].permiso\" class=\"pb-10 pr-10\"><a href=\"#\" \nng-click=\"vm.openSetEmployeesDialog($event, $index, field, vm.fields[field])\">Cambiar</a></div></div></div><dl \nclass=\"no-margin no-padding\"><dd ng-if=\"vm.values[field][$index] == undefined\" ng-repeat=\"value in vm.getVacants()\"><a \nhref=\"#\" ng-click=\"vm.openSetEmployeesDialog($event, $index, field, vm.fields[field])\">\nSeleccionar persona a reemplazar o sujeta a modificación {{value + 1}}</a></dd></dl><div ng-if=\"vm.errors[field]\" \nclass=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div><div \nng-if=\"!vm.getVacants().length || vm.checkEmptyObject(vm.lists.position_colaborators) == true\"><div \nclass=\"pl-10 pr-10 h5 grey-fg\">Por favor seleccione el cargo y cantidad de vacantes.</div><div \nclass=\"pl-10 pr-10 h6 red-500-fg\">Este campo es obligatorio</div></div></div><div \nng-if=\"!vm.getVacants().length || vm.checkEmptyObject(vm.lists.position_colaborators) == true\"><div \nclass=\"pl-10 pr-10 h5 grey-fg\">Por favor seleccione el cargo y cantidad de vacantes.</div><div \nclass=\"pl-10 pr-10 h6 red-500-fg\">Este campo es obligatorio</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/create/two-column-multiple-rows.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div ng-if=\"item.notes\" \nmd-colors=\"{\'background-color\': \'primary\'}\" class=\"p-15 ml-30 mr-30 mt-20 mb-5 white-fg\"><span \nclass=\"icon-alert-circle\"></span> <span>{{item.notes}}</span></div><div \nng-repeat=\"(modelKey, model) in vm.values[item.model]\"><div class=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" \nlayout-wrap><div ng-repeat=\"(field, value) in model\" ng-if=\"vm.fields[item.model][field].label\" id=\"{{field}}\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[item.model][field]\" \nfieldname=\"field\" model=\"vm.values[item.model][modelKey]\" value=\"vm.values[item.model][modelKey][field]\" \nblock=\"item.model\" idblock=\"item.id\" options=\"vm.lists[vm.fields[item.model][field].options]\"></div><div \nng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div><div \nng-if=\"$index > 0\" class=\"pt-5 pb-20 pr-40 pl-40\" layout=\"row\" layout-align=\"end center\"><div \nng-click=\"vm.removeModelToBlock(item, $index)\" class=\"cursor-pointer red-fg\">Eliminar</div></div></div><div \nclass=\"pt-20 pb-20 pr-40 pl-40\" layout=\"row\" layout-align=\"end center\"><div ng-click=\"vm.addModelToBlock(item)\" \nclass=\"cursor-pointer blue-fg\">Agregar otro</div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/create/two-columns.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div ng-if=\"item.notes\" \nmd-colors=\"{\'background-color\': \'primary\'}\" class=\"p-15 ml-30 mr-30 mt-20 mb-5 white-fg\"><span \nclass=\"icon-alert-circle\"></span> <span>{{item.notes}}</span></div><div class=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" \nflex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label  && vm.validationService.validateShowRequestFields(field, vm.data.data)\" id=\"{{field}}\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[field]\" fieldname=\"field\" \nmodel=\"vm.values\" value=\"vm.values[field]\" block=\"item.model\" idblock=\"item.id\" \noptions=\"vm.lists[vm.fields[field].options]\"></div><div ng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">\n{{vm.errors[field]}}</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/read/one-column-info.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div class=\"p-10\" \nlayout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"column\" layout-md=\"row\" layout-gt-md=\"row\" \nlayout-lg=\"row\" layout-gt-lg=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div \nng-repeat=\"field in item.fields\" \nng-if=\"root.fields[field].label  && vm.validationService.validateShowRequestFields(field, root.data.data)\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{root.fields[field].label}} <span \nng-if=\"root.fields[field].label_help\">({{root.fields[field].label_help}})</span></div><div class=\"grey-fg h6 p-8\">\n{{root.data.data[field] | formatValue : root.fields[field].type : root.lists[root.fields[field].options]}}</div><div \nng-if=\"root.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">{{root.errors[field]}}</div></div><div class=\"p-10\" \nflex-md=\"30\" flex-gt-md=\"30\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/read/one-column.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div class=\"p-20\" \nlayout=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div ng-repeat=\"field in item.fields\" \nng-class=\"{\'bb\' : !$last}\" layout=\"column\" flex=\"100\" class=\"pl-5 pr-5 pt-10 pb-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{field.label}} <span ng-if=\"field.label_help\">\n({{field.label_help}})</span></div><div ng-class=\"{\'pre-line\': field.type == \'textarea\'}\" class=\"grey-fg h6 p-8\" \nng-bind-html=\"field.field_text ? root.data.data[field.field_text] : root.data.data[field.field] | formatValue : field.type : root.lists[field.options]\">\n</div><div ng-if=\"field.type == \'matriz\'\"><div class=\"all-width\" input-generator field=\"field\" fieldname=\"field.field\" \nvalue=\"root.data.data[field.field]\" model=\"root.values\" block=\"item.model\" idblock=\"item.id\" \nattachments=\"root.attachments\" options=\"root.lists[root.fields[field.field].options]\" extra=\"root.extra\" \nreadonly=\"true\"></div></div><dl ng-show=\"root.attachments[field.field].length\" \nng-init=\"vm.validateAttachment(field.field,root)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in root.attachments[field.field]\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"h6\">{{attach.name}}</span> <span class=\"icon-download cursor-pointer grey-500-fg\" \nng-click=\"vm.getAttachmentUrl(attach)\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></div></dd></dl><div\n ng-if=\"vm.errors[field.field]\" class=\"pl-8 pr-8 pb-8 red-fg\">{{vm.errors[field.field]}}</div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/read/select-current-employee.html","");
$templateCache.put("app/main/templates/block-generic/read/two-column-multiple-rows.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div \nng-if=\"item.subtitle\"><div class=\"all-width pl-20 pr-20 pt-20 pb-30\"><div class=\"h4 grey-600-fg font-weight-500\">\n{{item.subtitle}}</div></div></div><div ng-repeat=\"(modelKey, values) in root.data.data[item.model]\" \nclass=\"bb pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div \nng-repeat=\"field in item.fields\" ng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" \nflex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{field.label}} <span ng-if=\"field.label_help\">\n({{field.label_help}})</span></div><div ng-class=\"{\'pre-line\': fieldData.type == \'textarea\'}\" class=\"grey-fg h6 p-8\">\n<div \nng-bind-html=\"values[field.field] | formatValue : field.type : root.lists[root.fields[item.model][field.field].options]\">\n</div></div><div ng-if=\"root.errors[field.field]\" class=\"p-5 h6 red-500-fg\">{{root.errors[field.field]}}</div></div>\n</div><div class=\"p-20 grey-500-fg\" layout=\"row\" layout-align=\"end center\" flex=\"100\" layout-wrap \nng-if=\"item.popupEdit\"><span class=\"icon-pencil\"></span> <span class=\"h5 cursor-pointer text-underlined\" \nng-click=\"item.popupEdit(item,root)\">Editar</span></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/read/two-columns.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div class=\"p-20\" \nlayout=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div ng-repeat=\"field in item.fields\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{field.label}} <span ng-if=\"root.data.original_data[field.field]\" \nclass=\"text-strike grey-fg pr-5 pl-5\"><span \nng-bind-html=\"root.data.original_data[field.field] | formatValue : field.type : root.lists[root.fields[field.field].options]\">\n</span></span></div><div ng-class=\"{\'pre-line\': field.type == \'textarea\'}\" class=\"grey-fg h6 p-8\"><div \nng-bind-html=\"field.field_text ? root.data.data[field.field_text] : root.data.data[field.field] | formatValue : field.type : root.lists[root.fields[field.field].options]\">\n</div></div><dl ng-show=\"root.attachments[field.field].length\" ng-init=\"vm.validateAttachment(field.field)\"><dd \nclass=\"p-8 m-5 grey-300-bg b\" ng-repeat=\"attach in root.attachments[field.field]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span> <span \nclass=\"icon-download cursor-pointer grey-500-fg\" ng-click=\"root.getAttachmentUrl(attach)\"><md-tooltip \nmd-direction=\"top\">Descargar</md-tooltip></span></div></dd></dl><div ng-if=\"root.errors[field.field]\" \nclass=\"pl-8 pr-8 pb-8 red-fg\">{{root.errors[field.field]}}</div></div><div class=\"p-20 grey-500-fg\" layout=\"row\" \nlayout-align=\"end center\" flex=\"100\" layout-wrap ng-if=\"item.popupEdit\"><span class=\"icon-pencil\"></span> <span \nclass=\"h5 cursor-pointer text-underlined\" ng-click=\"item.popupEdit(item,root)\">Editar</span></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/update/one-column-info.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div \nclass=\"pl-10 pr-10 pt-10 pb-20\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" flex=\"100\" layout-wrap \nng-show=\"!item.hideCollapse\"><div class=\"p-10\" flex-md=\"70\" flex-gt-md=\"70\" flex-lg=\"70\" flex-gt-lg=\"70\" layout-wrap>\n<div ng-repeat=\"field in item.fields\" \nng-if=\"root.fields[field].label && vm.validationService.validateShowRequestFields(field, root.data.data)\" \nid=\"{{field}}\" flex=\"100\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"root.fields[field]\" \nfieldname=\"field\" value=\"root.data.data[field]\" model=\"root.values\" block=\"item.model\" idblock=\"item.id\" \noptions=\"root.lists[root.fields[field].options]\" extra=\"root.extra\"></div><div ng-if=\"root.errors[field]\" \nclass=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{root.errors[field]}}</div></div></div><div ng-if=\"root.values.title\" \nclass=\"p-10\" flex-md=\"30\" flex-gt-md=\"30\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap><div \nclass=\"h4 pl-10 pr-10 pt-5 pb-5\">Descripción del trámite a realizar</div><div class=\"grey-50-bg p-10 b\"><div \nclass=\"font-weight-600 h5\">{{root.values.title}}</div><div class=\"h6\">{{root.values.desc}}</div></div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/update/one-column.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div \nclass=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div \nng-repeat=\"field in item.fields\" id=\"{{field.field}}\" flex=\"100\" class=\"pl-10 pr-10\"><div class=\"all-width\" \ninput-generator field=\"field\" fieldname=\"field.field\" value=\"root.data.data[field.field]\" model=\"root.values\" \nblock=\"item.model\" idblock=\"item.id\" options=\"root.lists[root.fields[field.field].options]\" extra=\"root.extra\" \nattachments=\"root.attachments\" showif=\"field.show_if\"></div><dl ng-show=\"root.attachments[field.field].length\" \nng-init=\"vm.validateAttachment(root,field.field)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in root.attachments[field.field]\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"h6\">{{attach.name}}</span> <span class=\"icon-download cursor-pointer grey-500-fg\" \nng-click=\"vm.getAttachmentUrl(attach)\"><md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></div></dd></dl><div\n ng-if=\"root.errors[field.field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{root.errors[field.field]}}</div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/update/select-current-employee.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap id=\"\"><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div \nng-repeat=\"field in item.fields\" \nng-if=\"vm.getVacants().length && vm.checkEmptyObject(vm.lists.position_colaborators) == false\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div ng-repeat=\"value in vm.values[field]\" \nng-if=\"vm.lists[vm.fields[field].options][value].name\" ng-class=\"{\'bb\' : !$last, \'pt-15\' : !$first}\" class=\"pb-15\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\"><div class=\"pb-10 pr-10\"><div class=\"h3 text-bold\"><span \nng-if=\"vm.lists[vm.fields[field].options][value].cod_empleado\">\n{{vm.lists[vm.fields[field].options][value].cod_empleado}} - </span>\n{{vm.lists[vm.fields[field].options][value].name | capitalize:true}}</div><div class=\"h5\" \nng-if=\"vm.lists[vm.fields[field].options][value].cargo\">{{vm.lists[vm.fields[field].options][value].cargo}}</div></div>\n<div ng-if=\"vm.fields[field].permiso\" class=\"pb-10 pr-10\"><a href=\"#\" \nng-click=\"vm.openSetEmployeesDialog($event, $index, field, vm.fields[field])\">Cambiar</a></div></div></div><dl \nclass=\"no-margin no-padding\"><dd ng-if=\"vm.values[field][$index] == undefined\" ng-repeat=\"value in vm.getVacants()\"><a \nhref=\"#\" ng-click=\"vm.openSetEmployeesDialog($event, $index, field, vm.fields[field])\">\nSeleccionar persona a reemplazar o sujeta a modificación {{value + 1}}</a></dd></dl><div ng-if=\"vm.errors[field]\" \nclass=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div><div \nng-if=\"!vm.getVacants().length || vm.checkEmptyObject(vm.lists.position_colaborators) == true\"><div \nclass=\"pl-10 pr-10 h5 grey-fg\">Por favor seleccione el cargo y cantidad de vacantes.</div><div \nclass=\"pl-10 pr-10 h6 red-500-fg\">Este campo es obligatorio</div></div></div><div \nng-if=\"!vm.getVacants().length || vm.checkEmptyObject(vm.lists.position_colaborators) == true\"><div \nclass=\"pl-10 pr-10 h5 grey-fg\">Por favor seleccione el cargo y cantidad de vacantes.</div><div \nclass=\"pl-10 pr-10 h6 red-500-fg\">Este campo es obligatorio</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/update/two-column-multiple-rows.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div ng-if=\"item.notes\" \nmd-colors=\"{\'background-color\': \'primary\'}\" class=\"p-15 ml-30 mr-30 mt-20 mb-5 white-fg\"><span \nclass=\"icon-alert-circle\"></span> <span>{{item.notes}}</span></div><div ng-if=\"item.subtitle\"><div \nclass=\"all-width pl-20 pr-20 pt-20 pb-30\"><div class=\"h4 grey-600-fg font-weight-500\">{{item.subtitle}}</div></div>\n</div><div ng-repeat=\"(modelKey, model) in root.values[item.model]\" ng-class=\"{\'bb\':!$last}\" \nng-show=\"!item.hideCollapse\"><div class=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap><div \nng-repeat=\"field in item.fields\" ng-if=\"field.label\" id=\"{{field.field}}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" \nflex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div class=\"all-width\" \ninput-generator field=\"field\" fieldname=\"field.field\" model=\"root.values[item.model][modelKey]\" \nvalue=\"root.values[item.model][modelKey][field.field]\" block=\"item.model\" idblock=\"item.id\" \noptions=\"root.lists[root.fields[item.model][field.field].options]\" extra=\"root.extra\"></div><div \nng-if=\"root.errors[field.field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{root.errors[field.field]}}</div></div></div>\n<div class=\"pt-5 pb-20 pr-40 pl-40\" layout=\"row\" layout-align=\"end center\"><div \nng-click=\"vm.removeModelToBlock(item, $index,root)\" class=\"cursor-pointer\" md-colors=\"{color: \'warn\'}\"><i \nclass=\"icon-trash s25\"></i></div></div></div><div class=\"pt-20 pb-20 pr-40 pl-40\" layout=\"row\" \nlayout-align=\"end center\" ng-show=\"!item.hideCollapse\"><div ng-click=\"vm.addModelToBlock(item,root)\" \nclass=\"cursor-pointer\" md-colors=\"{color: \'primary\'}\"><i class=\"icon-plus-circle s25\"></i></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/block-generic/update/two-columns.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div ng-if=\"item.notes\" \nmd-colors=\"{\'background-color\': \'primary\'}\" class=\"p-15 ml-30 mr-30 mt-20 mb-5 white-fg\"><span \nclass=\"icon-alert-circle\"></span> <span>{{item.notes}}</span></div><div class=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" \nflex=\"100\" layout-wrap layout-wrap ng-show=\"!item.hideCollapse\"><div ng-repeat=\"field in item.fields\" \nid=\"{{field.field}}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" \nflex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"field\" \nfieldname=\"field.field\" value=\"root.data.data[field.field]\" model=\"root.values\" block=\"item.model\" idblock=\"item.id\" \noptions=\"root.lists[root.fields[field.field].options]\" extra=\"root.extra\" attachments=\"root.attachments\" \nshowif=\"field.show_if\"></div><dl ng-show=\"root.attachments[field.field].length\" \nng-init=\"vm.validateAttachment(field.field)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in root.attachments[field.field]\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"h6\">{{attach.name}}</span><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"icon-download cursor-pointer grey-500-fg\" ng-click=\"root.getAttachmentUrl(attach)\"><md-tooltip \nmd-direction=\"top\">Descargar</md-tooltip></span><span class=\"icon-delete cursor-pointer red-500-fg\" \nng-if=\"root.deleteAttachtment\" ng-click=\"root.deleteAttachtment(root,field.field,item,attach)\"><md-tooltip \nmd-direction=\"top\">Eliminar adjunto</md-tooltip></span></div></div></dd></dl><div ng-if=\"root.errors[field]\" \nclass=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{root.errors[field]}}</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/directive/filter/filterlista.html","<div class=\"break-tool-bar border-bottom pl-40 pr-40\" layout=\"row\" layout-align=\"start end\" flex=\"100\" layout-wrap><div\n flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"25\" \nflex-gt-lg=\"25\" flex-xl=\"25\" ng-repeat=\"filter in vm.filtersMisc\"><md-input-container class=\"md-block h-50\" \nmd-no-float flex-gt-sm ng-if=\"filter.type == \'SELECT\' || filter.type == \'SELECT_DATE_RANGE\' && filter.show\"><label>\n{{filter.name}}</label><md-select ng-model=\"vm.valueFilter[filter.id]\"><md-option \nng-repeat=\"option in filter.options track by $index\" ng-value=\"option.id\">{{option.name | capitalize:true}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block h-50\" flex-gt-sm \nng-if=\"filter.type == \'TEXT\' && filter.show\"><label>{{filter.name}}</label><input ng-model=\"vm.valueFilter[filter.id]\">\n</md-input-container><md-input-container class=\"md-block h-50\" \nng-if=\"(filter.type == \'DATE\' || filter.type == \'DATE_BETWEEN\') && filter.show\"><label>{{filter.name}}</label>\n<md-datepicker ng-model=\"vm.valueFilter[filter.id]\" readonly=\"readonly\" md-placeholder=\"{{filter.name}}\" \nmd-min-date=\"filter.min_date\" md-open-on-focus></md-datepicker></md-input-container><div class=\"md-block\" flex-gt-sm \nng-if=\"filter.type == \'AUTOCOMPLETE\' && filter.show\"><md-autocomplete md-selected-item=\"vm.valueFilter[filter.id]\" \nmd-search-text=\"vm.searchFilter[filter.id]\" md-items=\"data in vm.search(filter.options,vm.searchFilter[filter.id])\" \nmd-item-text=\"data.name\" md-require-match md-floating-label=\"{{filter.name}}\"><md-item-template><span \nmd-highlight-text=\"vm.searchFilter[filter.id]\">{{data.name}}</span></md-item-template><md-not-found>\nNo se encuentran resultados bajo el parametro.</md-not-found></md-autocomplete></div></div><div \nclass=\"text-left mt-8 mb-10 pl-10\" layout=\"row\" layout-align=\"end center\" flex=\"100\"><md-button \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 white-fg\" ng-click=\"vm.sendData();\">\nBuscar</md-button><md-button class=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 white-fg\" \nng-click=\"vm.clearData();\">Limpiar</md-button></div></div>");
$templateCache.put("app/main/templates/directive/matriz/matriz.html","<table class=\"matrizDirective dataTable\"><thead><tr><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\" \nng-repeat=\"value in nameColumns\"><div class=\"table-header\"><span class=\"title-column\">{{value}}</span></div></th></tr>\n</thead><tbody><tr class=\"h7\" ng-repeat=\"row in configrows track by $index\"><td \nng-repeat=\"(key,value) in row track by $index\" class=\"text-center\"><div ng-if=\"value.type == \'read\'\"><span \nclass=\"text-row-column\">{{value.value}}</span></div><div ng-if=\"value.type == \'text\'\"><md-input-container \nclass=\"mb-0 mt-0 all-width hide-validation-error\" ng-if=\"!options.readonly\"><input type=\"text\" class=\"custom-form\" \nng-required=\"options.required\" ng-disabled=\"options.disabled\" name=\"{{options.field}}\" \nng-model=\"options.ngModel[value.model]\" aria-label=\"{{label}}\"></md-input-container><span class=\"text-row\" \nng-if=\"options.readonly\">{{options.ngModel[value.model]}}</span></div></td></tr></tbody></table>");
$templateCache.put("app/main/templates/finalist/dialogs/add-experience.html","<md-dialog aria-label=\"Notice\" class=\"\"><form name=\"form\" class=\"md-inline-form\" novalidate layout=\"column\"><md-toolbar\n class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column><div layout=\"row\" flex=\"100\" layout-align=\"end end\">\n<md-button class=\"md-icon-button no-padding no-margin\" ng-click=\"vm.closeDialog()\"><md-icon class=\"\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" \nclass=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div class=\"h2 text-uppercase\"><span class=\"pr-5\" \nng-class=\"{\'font-weight-900\' : $last}\" ng-repeat=\"title in vm.fields.titulo\">{{title}}</span></div></div></div>\n</md-toolbar><md-dialog-content class=\"p-10 w-1000\" layout-padding><div ng-if=\"vm.ready\"><div \nclass=\"pt-15 pb-20 pl-15 pr-15 grey-700-fg font-weight-300\" ng-if=\"vm.fields.text_edit\" layout=\"row\" layout-wrap>\n{{vm.fields.text_edit}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div id=\"{{field.field}}\" class=\"p-8\" \nng-repeat=\"field in vm.fields.campos\" ng-if=\"vm.fields.campos.length > 4\" layout=\"column\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div \nclass=\"all-width\" input-generator field=\"field\" block=\"vm.fields.name\" value=\"vm.fields.item[field.field]\" \nmodel=\"vm.data\" options=\"vm.lists[field.options]\"></div><div ng-if=\"vm.errors[field.field]\" class=\"h6 red-500-fg\">\n{{vm.errors[field.field]}}</div></div><div id=\"{{field.field}}\" class=\"p-8\" ng-repeat=\"field in vm.fields.campos\" \nng-if=\"vm.fields.campos.length <= 4\" layout=\"column\" flex=\"100\"><div class=\"all-width\" input-generator field=\"field\" \nblock=\"vm.fields.name\" value=\"vm.fields.item[field.field]\" model=\"vm.data\" options=\"vm.lists[field.options]\"></div><div\n ng-if=\"vm.errors[field.field]\" class=\"h6 red-500-fg\">{{vm.errors[field.field]}}</div></div></div></div><div \nng-if=\"!vm.ready\" class=\"pt-15 pb-20 pl-15 pr-15\"><div class=\"grey-700-fg font-weight-300\">\n¿Que tipo de experiencia laboral vas a ingresar?</div><div class=\"pt-10 pb-5\"><md-input-container class=\"m-0 p-0\">\n<md-radio-group layout=\"column\" ng-model=\"vm.offerType\" ng-change=\"vm.validate()\"><md-radio-button value=\"0\" \nclass=\"md-primary\">Nuevo cargo en una empresa nueva</md-radio-button><md-radio-button value=\"1\">\nNuevo cargo en una de las empresas que ya ha registrado</md-radio-button></md-radio-group></md-input-container></div>\n<div ng-if=\"vm.showCompaniesSelector\" class=\"pb-10 pl-30 pr-10\"><md-input-container class=\"m-0 p-0\"><label>Empresa\n</label><md-select ng-model=\"vm.company\" ng-change=\"vm.setCompanyData()\"><md-option \nng-repeat=\"company in vm.fields.companies\" ng-value=\"company\" aria-label=\"Company\">{{company.name}}</md-option>\n</md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions class=\"bt h-60\" layout=\"column\">\n<div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"pl-5 pr-5\"><md-button \nng-click=\"vm.closeDialog()\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.save()\" ng-disabled=\"vm.saving\" type=\"submit\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">{{vm.saveButtonTitle}}\n</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/finalist/dialogs/add.html","<md-dialog aria-label=\"Notice\" class=\"\"><form name=\"form\" class=\"md-inline-form\" novalidate layout=\"column\"><md-toolbar\n class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column><div layout=\"row\" flex=\"100\" layout-align=\"end end\">\n<md-button class=\"md-icon-button no-padding no-margin\" ng-click=\"vm.closeDialog()\"><md-icon class=\"\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" \nclass=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div class=\"h2 text-uppercase\"><span class=\"pr-5\" \nng-class=\"{\'font-weight-900\' : $last}\" ng-repeat=\"title in vm.fields.titulo\">{{title}}</span></div></div></div>\n</md-toolbar><md-dialog-content class=\"p-10 w-1000\" layout-padding><div \nclass=\"pt-15 pb-20 pl-15 pr-15 grey-700-fg font-weight-300\" ng-if=\"vm.fields.text_edit\" layout=\"row\" layout-wrap>\n{{vm.fields.text_edit}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div id=\"{{field.field}}\" class=\"p-8\" \nng-repeat=\"field in vm.fields.campos\" ng-if=\"vm.fields.campos.length > 4 && field.type != \'file\'\" layout=\"column\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"50\"><div class=\"all-width\" input-generator field=\"field\" block=\"vm.fields.name\" \nvalue=\"vm.fields.block[field.field]\" model=\"vm.data\" options=\"vm.lists[field.options]\"></div><div \nng-if=\"vm.errors[field.field]\" class=\"h6 p-5 red-500-fg\">{{vm.errors[field.field]}}</div></div><div \nid=\"{{field.field}}\" class=\"p-8\" ng-repeat=\"field in vm.fields.campos\" \nng-if=\"vm.fields.campos.length <= 4 && field.type != \'file\'\" layout=\"column\" flex=\"100\"><div class=\"all-width\" \ninput-generator field=\"field\" block=\"vm.fields.name\" value=\"vm.fields.block[field.field]\" model=\"vm.data\" \noptions=\"vm.lists[field.options]\"></div><div ng-if=\"vm.errors[field.field]\" class=\"h6 p-5 red-500-fg\">\n{{vm.errors[field.field]}}</div></div></div></md-dialog-content><md-dialog-actions class=\"bt h-60\" layout=\"row\"><div \nclass=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"pl-5 pr-5\"><md-button \nng-click=\"vm.closeDialog()\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.save()\" type=\"submit\" ng-disabled=\"vm.saving\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">{{vm.saveButtonTitle}}\n</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/finalist/dialogs/delete.html","<md-dialog aria-label=\"Notice\" class=\"\"><md-toolbar class=\"h-90 md-accent white-fg\"><div class=\"p-5\" layout-column><div\n layout=\"row\" flex=\"100\" layout-align=\"end end\"><md-button class=\"md-icon-button no-padding no-margin\" \nng-click=\"vm.closeDialog()\"><md-icon class=\"\" md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div><div layout=\"row\" class=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div \nclass=\"h3 text-uppercase\"><span class=\"\" ng-class=\"{\'font-weight-900\' : $last}\" ng-repeat=\"title in vm.block.titulo\">\n{{title}}</span></div></div></div></md-toolbar><md-dialog-content class=\"p-10\" layout-padding><div \nclass=\"p-10 text-center\">¿Está seguro(a) que desea eliminar el elemento {{vm.itemName}}?</div></md-dialog-content>\n<md-dialog-actions class=\"bt h-50\" layout=\"row\"><div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"center center\" \nlayout-wrap><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"pl-5 pr-5\"><md-button ng-click=\"vm.delete()\" type=\"submit\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Eliminar</md-button></div></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/templates/finalist/dialogs/edit.html","<md-dialog aria-label=\"Notice\" class=\"\"><md-toolbar class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column>\n<div layout=\"row\" flex=\"100\" layout-align=\"end end\"><md-button class=\"md-icon-button no-padding no-margin\" \nng-click=\"vm.closeDialog()\"><md-icon class=\"\" md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div><div layout=\"row\" class=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div \nclass=\"h2 text-uppercase\"><span ng-class=\"{\'font-weight-900\' : $last}\" ng-repeat=\"title in vm.fields.titulo\">{{title}}\n</span></div></div></div></md-toolbar><md-dialog-content class=\"p-10 w-1000\" layout-padding><div \nclass=\"pt-15 pb-20 pl-15 pr-15 grey-700-fg font-weight-300\" ng-if=\"vm.fields.text_edit\" layout=\"row\" layout-wrap>\n{{vm.fields.text_edit}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in vm.fields.campos\" \nid=\"{{field.field}}\" class=\"p-8\" ng-if=\"vm.fields.campos.length > 4 && field.label && field.field != \'foto\'\" \nlayout=\"column\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" \nflex-lg=\"50\" flex-gt-lg=\"50\"><div ng-include=\"\'app/main/templates/resume/dialogs/fields.html\'\"></div></div><div \nng-repeat=\"field in vm.fields.campos\" id=\"{{field.field}}\" \nng-if=\"vm.fields.campos.length <= 4 && field.label && field.field != \'foto\'\" class=\"p-8\" layout=\"column\" flex=\"100\">\n<div ng-include=\"\'app/main/templates/resume/dialogs/fields.html\'\"></div></div></div></md-dialog-content>\n<md-dialog-actions class=\"bt h-60\" layout=\"row\"><div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"center center\" \nlayout-wrap><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"pl-5 pr-5\"><md-button ng-click=\"vm.save()\" type=\"submit\" ng-disabled=\"vm.saving\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">{{vm.saveButtonTitle}}\n</md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/templates/finalist/dialogs/fields.html","<div class=\"all-width\" input-generator field=\"field\" model=\"vm.data\" block=\"vm.fields.name\" \nidblock=\"vm.fields.item._id\" hvalue=\"vm.fields.item[field.field_extra]\" \nvalue=\"(!vm.fields.item[field.field] ? (vm.fields.item[field.field_extra] ? vm.fields.item[field.field_extra] : vm.fields.item[field.field_text]) : vm.fields.item[field.field])\" \nattachments=\"vm.attachments\" options=\"vm.lists[field.options]\"></div><div ng-if=\"vm.errors[field.field]\" \nclass=\"p-5 h6 red-500-fg\">{{vm.errors[field.field]}}</div><dl ng-if=\"vm.attachments[field.module]\"><dd \nclass=\"p-8 m-5 grey-300-bg b\" ng-repeat=\"attach in vm.getAttachments(field.module)\" \nng-click=\"vm.removeAttachment(field.module, attach)\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"h6\">{{attach.name}}</span> <span class=\"icon-trash cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">\nEliminar</md-tooltip></span></div></dd></dl>");
$templateCache.put("app/main/templates/finalist/dialogs/form.html","<div class=\"pt-15 pb-20 pl-15 pr-15\" ng-if=\"vm.fields.text_edit\" layout=\"row\" layout-wrap>{{vm.fields.text_edit}}</div>\n<div layout=\"row\" layout-wrap><div ng-if=\"vm.fields.campos.length > 1\" class=\"p-8\" \nng-repeat=\"field in vm.fields.campos\" layout=\"row\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" \nflex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div class=\"all-width\" input-generator field=\"field\" \nmodel=\"vm.data\" value=\"vm.fields.data[field.field]\" options=\"vm.lists[field.options]\"></div></div><div \nng-if=\"vm.fields.campos.length == 1\" class=\"p-8\" ng-repeat=\"field in vm.fields.campos\" layout=\"row\" flex=\"100\"><div \nclass=\"all-width\" input-generator field=\"field\" model=\"vm.data\" value=\"vm.fields.data[field.field]\" \noptions=\"vm.lists[field.options]\"></div></div></div><div class=\"p-8\" layout=\"row\" layout-align=\"center center\" \nlayout-wrap><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"pl-5 pr-5\"><md-button ng-click=\"vm.save()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar</md-button></div>\n</div>");
$templateCache.put("app/main/templates/finalist/dialogs/upload-profile-picture.html","<md-dialog aria-label=\"Notice\" class=\"\"><form name=\"form\" class=\"md-inline-form\" novalidate layout=\"column\"><md-toolbar\n class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column><div layout=\"row\" flex=\"100\" layout-align=\"end end\">\n<md-button class=\"md-icon-button no-padding no-margin\" ng-click=\"vm.closeDialog()\"><md-icon class=\"\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" \nclass=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div class=\"h2 text-uppercase\"><span class=\"\" \nng-class=\"{\'font-weight-900\' : $last}\" ng-repeat=\"title in vm.parts\">{{title}}</span></div></div></div></md-toolbar>\n<md-dialog-content class=\"p-10 w-1000\" layout-padding><div layout=\"row\"><div flex=\"50\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"p-8\" layout=\"column\"><input type=\"file\" img-cropper-fileread \nimage=\"vm.cropper.sourceImage\"></div><div><canvas width=\"400\" height=\"300\" id=\"canvas\" image-cropper \nimage=\"vm.cropper.sourceImage\" cropped-image=\"vm.cropper.croppedImage\" crop-width=\"200\" crop-height=\"220\" \nkeep-aspect=\"true\" touch-radius=\"30\" crop-area-bounds=\"vm.bounds\"></canvas></div></div><div class=\"pt-35\" flex=\"50\" \nlayout=\"column\" layout-align=\"start center\" ng-show=\"vm.cropper.croppedImage != null\"><img \nng-src=\"{{vm.cropper.croppedImage}}\"></div></div></md-dialog-content><md-dialog-actions class=\"bt h-60\" layout=\"row\">\n<div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"pl-5 pr-5\"><md-button \nng-click=\"vm.closeDialog()\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.uploadImage()\" type=\"submit\" \nng-disabled=\"!vm.cropper.croppedImage || vm.saving\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">{{vm.saveButtonTitle}}\n</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/finalist/shared/block-alerts.html","<div class=\"grey-100-bg bb\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"item.pendiente_validar\" \nlayout=\"row\" layout-align=\"start center\" class=\"red-100-bg red-900-fg p-5 m-5\"><div class=\"pl-5 pt-5 pb-5 pr-15\">\n<md-icon md-font-icon=\"icon-alert\" class=\"red-900-fg\"></md-icon></div><div class=\"p-5 h5\">\nPendiente de validar por operaciones</div></div><div \nng-if=\"vm.validations && vm.validations[item.name] && !vm.validations[item.name].completo\" layout=\"row\" \nlayout-align=\"start center\" class=\"orange-100-bg orange-900-fg p-5 m-5\"><div class=\"pl-5 pt-5 pb-5 pr-15\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"orange-900-fg\"></md-icon></div><div class=\"p-5 h5\">\n{{vm.validations[item.name].msg}}</div></div></div>");
$templateCache.put("app/main/templates/finalist/shared/block-title.html","<div class=\"grey-100-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between center\" \nlayout-align-gt-sm=\"space-between center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-lg=\"space-between center\"><div class=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\"><div \nclass=\"h5 text-uppercase\"><span ng-class=\"{\'font-weight-900\' : $last}\" ng-repeat=\"title in item.titulo\">{{title}}\n</span></div></div><div ng-if=\"!vm.analyst\" ng-class=\"vm.getColorBlockIndicator(item.completo)\" class=\"w-40 h-40\" \nlayout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"{{vm.getIconBlockIndicator(item.completo)}}\" class=\"\">\n</md-icon></div></div>");
$templateCache.put("app/main/templates/header/dialogs/change-password.html","<md-dialog aria-label=\"Notice\" class=\"\"><form name=\"form\" class=\"md-inline-form\" novalidate layout=\"column\"><md-toolbar\n class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column><div layout=\"row\" flex=\"100\" layout-align=\"end end\">\n<md-button class=\"md-icon-button no-padding no-margin\" ng-click=\"vm.closeDialog()\"><md-icon class=\"\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" \nclass=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div class=\"h2 text-uppercase\">{{vm.title}}</div>\n</div></div></md-toolbar><md-dialog-content class=\"p-10 w-500\" layout-padding><div class=\"p-10\"><md-input-container \nclass=\"md-block\" md-no-float><label>Contraseña actual</label><input type=\"{{vm.password_anterior_type}}\" \nname=\"password_anterior\" minlength=\"6\" maxlength=\"40\" ng-model=\"vm.form.password_anterior\" required><md-icon \nng-click=\"vm.showPassword(\'password_anterior_type\')\" class=\"icon {{vm.password_anterior_icon}} h2 cursor-pointer\" \nstyle=\"display:inline-block\"></md-icon><div ng-messages=\"form.password_anterior.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"FIELD_REQUIRED\">Campo requerido</span></div></div><div \nng-if=\"vm.errors[\'password_anterior\']\" class=\"h6 pt-5 pb-5 red-500-fg\">{{vm.errors[\'password_anterior\']}}</div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label>Nueva contraseña</label><input \ntype=\"{{vm.password_type}}\" name=\"password\" minlength=\"6\" maxlength=\"40\" ng-model=\"vm.form.password\" \nng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" required><md-icon \nng-click=\"vm.showPassword(\'password_type\')\" class=\"icon {{vm.password_icon}} h2 cursor-pointer\" \nstyle=\"display:inline-block\"></md-icon><div ng-messages=\"form.password.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"FIELD_REQUIRED\">Campo requerido</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div><div ng-if=\"vm.errors[\'password\']\" class=\"h6 pt-5 pb-5 red-500-fg\">{{vm.errors[\'password\']}}</div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label>Confirmar nueva contraseña</label><input \ntype=\"{{vm.password_confirm_type}}\" name=\"password_confirm\" minlength=\"6\" maxlength=\"40\" \nng-model=\"vm.form.password_confirm\" ng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{6,}$/\" \nrequired><md-icon ng-click=\"vm.showPassword(\'password_confirm_type\')\" \nclass=\"icon {{vm.password_confirm_icon}} h2 cursor-pointer\" style=\"display:inline-block\"></md-icon><div \nng-messages=\"form.password_confirm.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"FIELD_REQUIRED\">\nCampo requerido</span></div><div ng-message=\"pattern\">\nLa contraseña debe contener al menos 6 caracteres, un número, una letra mayúscula y un caracter especial ($@$!%*#?&)\n</div></div><div ng-if=\"vm.errors[\'password_confirm\']\" class=\"h6 pt-5 pb-5 red-500-fg\">\n{{vm.errors[\'password_confirm\']}}</div></md-input-container></div></md-dialog-content><md-dialog-actions \nclass=\"bt h-80\" layout=\"column\"><div ng-if=\"vm.message\" class=\"p-5 red-500-fg h5\">{{vm.message | capitalize}}</div><div\n class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"pl-5 pr-5\"><md-button \nng-click=\"vm.closeDialog()\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"text-center\"><md-button ng-click=\"vm.changePassword()\" aria-label=\"Guardar\" \ntype=\"submit\" ng-disabled=\"form.$invalid || form.$pristine\" \nclass=\"md-raised submit-button md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/request/blocks/block-title-selected.html","<div class=\"grey-100-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between center\" \nlayout-align-gt-sm=\"space-between center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-lg=\"space-between center\"><div class=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\"><div \nclass=\"h5 text-uppercase\"><span ng-class=\"{\'font-weight-900\' : $last,\'pl-5\':!$first}\" \nng-repeat=\"title in item.title track by $index\">{{title}}</span></div></div><div><md-checkbox class=\"no-margin\" \nng-model=\"item.isCheckeable\" ng-change=\"vm.blockSelected($index);\" aria-label=\"check block\"></md-checkbox></div></div>");
$templateCache.put("app/main/templates/request/blocks/block-title.html","<div class=\"grey-100-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between center\" \nlayout-align-gt-sm=\"space-between center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-lg=\"space-between center\"><div class=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\" layout=\"row\"><div \nclass=\"h5 text-uppercase\"><span ng-class=\"{\'font-weight-900\' : $last,\'pl-5\':!$first}\" \nng-repeat=\"title in item.title track by $index\">{{title}}</span></div></div><div class=\"h5\" ng-show=\"item.collapse\"><i \nng-class=\"item.hideCollapse ? \'icon-chevron-down\':\'icon-chevron-up\'\" md-colors=\"{color:\'accent\'}\" \nclass=\"cursor-pointer\" ng-click=\"item.hideCollapse = !item.hideCollapse\"></i></div></div>");
$templateCache.put("app/main/templates/resume/dialogs/add-experience.html","<md-dialog aria-label=\"Notice\" class=\"\"><form name=\"form\" class=\"md-inline-form\" novalidate layout=\"column\"><md-toolbar\n class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column><div layout=\"row\" flex=\"100\" layout-align=\"end end\">\n<md-button class=\"md-icon-button no-padding no-margin\" ng-click=\"vm.closeDialog()\"><md-icon class=\"\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" \nclass=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div class=\"h2 text-uppercase\"><span class=\"pr-5\" \nng-class=\"{\'font-weight-900\' : $last}\" class=\"ml-5\" ng-repeat=\"title in vm.fields.titulo track by $index\">{{title}}\n</span></div></div></div></md-toolbar><md-dialog-content class=\"p-10 w-1000\" layout-padding><div ng-if=\"vm.ready\"><div \nclass=\"pt-15 pb-20 pl-15 pr-15 grey-700-fg font-weight-300\" ng-if=\"vm.fields.text_edit\" layout=\"row\" layout-wrap>\n{{vm.fields.text_edit}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div id=\"{{field.field}}\" class=\"p-8\" \nng-repeat=\"field in vm.fields.campos\" ng-if=\"vm.fields.campos.length > 4\" layout=\"column\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div \nclass=\"all-width\" input-generator field=\"field\" block=\"vm.fields.name\" value=\"vm.fields.item[field.field]\" \nmodel=\"vm.data\" options=\"vm.lists[field.options]\" showif=\"field.show_if\"></div><div ng-if=\"vm.errors[field.field]\" \nclass=\"h6 red-500-fg\">{{vm.errors[field.field]}}</div></div><div id=\"{{field.field}}\" class=\"p-8\" \nng-repeat=\"field in vm.fields.campos\" ng-if=\"vm.fields.campos.length <= 4\" layout=\"column\" flex=\"100\"><div \nclass=\"all-width\" input-generator field=\"field\" block=\"vm.fields.name\" value=\"vm.fields.item[field.field]\" \nmodel=\"vm.data\" options=\"vm.lists[field.options]\" showif=\"field.show_if\"></div><div ng-if=\"vm.errors[field.field]\" \nclass=\"h6 red-500-fg\">{{vm.errors[field.field]}}</div></div></div></div><div ng-if=\"!vm.ready\" \nclass=\"pt-15 pb-20 pl-15 pr-15\"><div class=\"grey-700-fg font-weight-300\">\n¿Que tipo de experiencia laboral vas a ingresar?</div><div class=\"pt-10 pb-5\"><md-input-container class=\"m-0 p-0\">\n<md-radio-group layout=\"column\" ng-model=\"vm.offerType\" ng-change=\"vm.validate()\"><md-radio-button value=\"0\" \nclass=\"md-primary\">Nuevo cargo en una empresa nueva</md-radio-button><md-radio-button value=\"1\">\nNuevo cargo en una de las empresas que ya ha registrado</md-radio-button></md-radio-group></md-input-container></div>\n<div ng-if=\"vm.showCompaniesSelector\" class=\"pb-10 pl-30 pr-10\"><md-input-container class=\"m-0 p-0\"><label>Empresa\n</label><md-select ng-model=\"vm.company\" ng-change=\"vm.setCompanyData()\"><md-option \nng-repeat=\"company in vm.companies\" ng-value=\"company\" aria-label=\"Company\">{{company.name}}</md-option></md-select>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions class=\"bt h-60\" layout=\"column\" \nng-if=\"vm.ready\"><div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"center center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"pl-5 pr-5\"><md-button ng-click=\"vm.save()\" ng-disabled=\"vm.saving\" type=\"submit\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">{{vm.saveButtonTitle}}\n</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/resume/dialogs/add.html","<md-dialog aria-label=\"Notice\" class=\"\"><form name=\"form\" class=\"md-inline-form\" novalidate layout=\"column\"><md-toolbar\n class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column><div layout=\"row\" flex=\"100\" layout-align=\"end end\">\n<md-button class=\"md-icon-button no-padding no-margin\" ng-click=\"vm.closeDialog()\"><md-icon class=\"\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" \nclass=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div class=\"h2 text-uppercase text-truncate\"><span \nclass=\"pr-5\" ng-class=\"{\'font-weight-900\' : $last}\" class=\"ml-5\" ng-repeat=\"title in vm.fields.titulo track by $index\">\n{{title}}</span></div></div></div></md-toolbar><md-dialog-content class=\"p-10 w-1000\" layout-padding><div \nclass=\"pt-15 pb-20 pl-15 pr-15 grey-700-fg font-weight-300\" ng-if=\"vm.fields.text_edit\" layout=\"row\" layout-wrap>\n{{vm.fields.text_edit}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div id=\"{{field.field}}\" class=\"p-8\" \nng-repeat=\"field in vm.fields.campos\" ng-if=\"vm.fields.campos.length > 4 \" layout=\"column\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div \nclass=\"all-width\" input-generator field=\"field\" block=\"vm.fields.name\" value=\"vm.fields.block[field.field]\" \nmodel=\"vm.data\" options=\"vm.lists[field.options]\" extra=\"field.extra\" showif=\"field.show_if\"></div><div \nng-if=\"vm.errors[field.field]\" class=\"h6 p-5 red-500-fg\">{{vm.errors[field.field]}}</div></div><div \nid=\"{{field.field}}\" class=\"p-8\" ng-repeat=\"field in vm.fields.campos\" ng-if=\"vm.fields.campos.length <= 4\" \nlayout=\"column\" flex=\"100\"><div class=\"all-width\" input-generator field=\"field\" block=\"vm.fields.name\" \nvalue=\"vm.fields.block[field.field]\" model=\"vm.data\" options=\"vm.lists[field.options]\" showif=\"field.show_if\"></div>\n<div ng-if=\"vm.errors[field.field]\" class=\"h6 p-5 red-500-fg\">{{vm.errors[field.field]}}</div></div></div>\n</md-dialog-content><md-dialog-actions class=\"bt h-60\" layout=\"row\"><div class=\"p-8\" flex=\"100\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"pl-5 pr-5\"><md-button ng-click=\"vm.save()\" type=\"submit\" ng-disabled=\"vm.saving\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">{{vm.saveButtonTitle}}\n</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/resume/dialogs/delete.html","<md-dialog aria-label=\"Notice\" class=\"\"><md-toolbar class=\"h-90 md-accent white-fg\"><div class=\"p-5\" layout-column><div\n layout=\"row\" flex=\"100\" layout-align=\"end end\"><md-button class=\"md-icon-button no-padding no-margin\" \nng-click=\"vm.closeDialog()\"><md-icon class=\"\" md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div><div layout=\"row\" class=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div \nclass=\"h3 text-uppercase\"><span class=\"\" ng-class=\"{\'font-weight-900\' : $last,\'ml-5\':!$first}\" \nng-repeat=\"title in vm.block.titulo track by $index\">{{title}}</span></div></div></div></md-toolbar><md-dialog-content \nclass=\"p-10\" layout-padding><div class=\"p-10 text-center\">\n¿Está seguro(a) que desea eliminar el elemento {{vm.itemName}}?</div></md-dialog-content><md-dialog-actions \nclass=\"bt h-50\" layout=\"row\"><div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"center center\" layout-wrap><div \nclass=\"pl-5 pr-5\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"pl-5 pr-5\"><md-button ng-click=\"vm.delete()\" type=\"submit\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Eliminar</md-button></div></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/templates/resume/dialogs/edit.html","<md-dialog aria-label=\"Notice\" class=\"\"><md-toolbar class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column>\n<div layout=\"row\" flex=\"100\" layout-align=\"end end\"><md-button class=\"md-icon-button no-padding no-margin\" \nng-click=\"vm.closeDialog()\"><md-icon class=\"\" md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div><div layout=\"row\" class=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div \nclass=\"h2 text-uppercase\"><span ng-class=\"{\'font-weight-900\' : $last}\" class=\"ml-5\" \nng-repeat=\"title in vm.fields.titulo track by $index\">{{title}}</span></div></div></div></md-toolbar><md-dialog-content\n class=\"p-10 w-1000\" layout-padding><div class=\"pt-15 pb-20 pl-15 pr-15 grey-700-fg font-weight-300\" \nng-if=\"vm.fields.text_edit\" layout=\"row\" layout-wrap>{{vm.fields.text_edit}}</div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div ng-repeat=\"field in vm.fields.campos\" id=\"{{field.field}}\" class=\"p-8\" \nng-if=\"vm.fields.campos.length > 4 && field.label && field.field != \'foto\'\" layout=\"column\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div \nng-include=\"\'app/main/templates/resume/dialogs/fields.html\'\"></div></div><div ng-repeat=\"field in vm.fields.campos\" \nid=\"{{field.field}}\" ng-if=\"vm.fields.campos.length <= 4 && field.label && field.field != \'foto\'\" class=\"p-8\" \nlayout=\"column\" flex=\"100\"><div ng-include=\"\'app/main/templates/resume/dialogs/fields.html\'\"></div></div></div>\n</md-dialog-content><md-dialog-actions class=\"bt h-60\" layout=\"row\"><div class=\"p-8\" flex=\"100\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"pl-5 pr-5\"><md-button ng-click=\"vm.save()\" type=\"submit\" ng-disabled=\"vm.saving\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">{{vm.saveButtonTitle}}\n</md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/templates/resume/dialogs/fields.html","<div class=\"all-width\" input-generator field=\"field\" model=\"vm.data\" block=\"vm.fields.name\" \nidblock=\"vm.fields.item._id\" hvalue=\"vm.fields.item[field.field_extra]\" \nvalue=\"(!vm.fields.item[field.field] ? (vm.fields.item[field.field_extra] ? vm.fields.item[field.field_extra] : vm.fields.item[field.field_text]) : vm.fields.item[field.field])\" \nattachments=\"vm.attachments\" options=\"vm.lists[field.options]\" showif=\"field.show_if\"></div><div \nng-if=\"vm.errors[field.field]\" class=\"p-5 h6 red-500-fg\">{{vm.errors[field.field]}}</div><dl \nng-if=\"vm.attachments[field.module]\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.getAttachments(field.module)\" ng-click=\"vm.removeAttachment(field.module, attach)\"><div \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span> <span \nclass=\"icon-trash cursor-pointer grey-500-fg\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip></span></div></dd>\n</dl>");
$templateCache.put("app/main/templates/resume/dialogs/form.html","<div class=\"pt-15 pb-20 pl-15 pr-15\" ng-if=\"vm.fields.text_edit\" layout=\"row\" layout-wrap>{{vm.fields.text_edit}}</div>\n<div layout=\"row\" layout-wrap><div ng-if=\"vm.fields.campos.length > 1\" class=\"p-8\" \nng-repeat=\"field in vm.fields.campos\" layout=\"row\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" \nflex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\"><div class=\"all-width\" input-generator field=\"field\" \nmodel=\"vm.data\" value=\"vm.fields.data[field.field]\" options=\"vm.lists[field.options]\"></div></div><div \nng-if=\"vm.fields.campos.length == 1\" class=\"p-8\" ng-repeat=\"field in vm.fields.campos\" layout=\"row\" flex=\"100\"><div \nclass=\"all-width\" input-generator field=\"field\" model=\"vm.data\" value=\"vm.fields.data[field.field]\" \noptions=\"vm.lists[field.options]\"></div></div></div><div class=\"p-8\" layout=\"row\" layout-align=\"center center\" \nlayout-wrap><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"pl-5 pr-5\"><md-button ng-click=\"vm.save()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar</md-button></div>\n</div>");
$templateCache.put("app/main/templates/resume/dialogs/upload-profile-picture.html","<md-dialog aria-label=\"Notice\" class=\"\"><form name=\"form\" class=\"md-inline-form\" novalidate layout=\"column\"><md-toolbar\n class=\"h-100 md-accent white-fg\"><div class=\"p-5\" layout-column><div layout=\"row\" flex=\"100\" layout-align=\"end end\">\n<md-button class=\"md-icon-button no-padding no-margin\" ng-click=\"vm.closeDialog()\"><md-icon class=\"\" \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" \nclass=\"pl-20 pr-20 pt-10 pb-10\" flex=\"100\" layout-align=\"start end\"><div class=\"h2 text-uppercase\"><span class=\"\" \nng-class=\"{\'font-weight-900\' : $last}\" class=\"ml-5\" ng-repeat=\"title in vm.parts track by $index\">{{title}}</span>\n</div></div></div></md-toolbar><md-dialog-content class=\"p-10 w-1000\" layout-padding><div layout=\"row\"><div flex=\"50\" \nlayout=\"column\" layout-align=\"start center\"><div class=\"p-8\" layout=\"column\"><input type=\"file\" img-cropper-fileread \nimage=\"vm.cropper.sourceImage\"></div><div><canvas width=\"400\" height=\"300\" id=\"canvas\" image-cropper \nimage=\"vm.cropper.sourceImage\" cropped-image=\"vm.cropper.croppedImage\" crop-width=\"200\" crop-height=\"220\" \nkeep-aspect=\"true\" touch-radius=\"30\" crop-area-bounds=\"vm.bounds\"></canvas></div></div><div class=\"pt-35\" flex=\"50\" \nlayout=\"column\" layout-align=\"start center\" ng-show=\"vm.cropper.croppedImage != null\"><img \nng-src=\"{{vm.cropper.croppedImage}}\"></div></div></md-dialog-content><md-dialog-actions class=\"bt h-60\" layout=\"row\">\n<div class=\"p-8\" flex=\"100\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"pl-5 pr-5\"><md-button \nng-click=\"vm.closeDialog()\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"pl-5 pr-5\"><md-button ng-click=\"vm.uploadImage()\" type=\"submit\" \nng-disabled=\"!vm.cropper.croppedImage || vm.saving\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">{{vm.saveButtonTitle}}\n</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/resume/shared/block-alerts.html","<div class=\"grey-100-bg bb\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"item.pendiente_validar\" \nlayout=\"row\" layout-align=\"start center\" class=\"red-100-bg red-900-fg p-5 m-5\"><div class=\"pl-5 pt-5 pb-5 pr-15\">\n<md-icon md-font-icon=\"icon-alert\" class=\"red-900-fg\"></md-icon></div><div class=\"p-5 h5\">\nPendiente de validar por operaciones</div></div><div \nng-if=\"vm.validations && vm.validations[item.name] && !vm.validations[item.name].completo\" layout=\"row\" \nlayout-align=\"start center\" class=\"orange-100-bg orange-900-fg p-5 m-5\"><div class=\"pl-5 pt-5 pb-5 pr-15\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"orange-900-fg\"></md-icon></div><div class=\"p-5 h5\">\n{{vm.validations[item.name].msg}}</div></div></div>");
$templateCache.put("app/main/templates/resume/shared/block-title.html","<div class=\"grey-100-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between center\" \nlayout-align-gt-sm=\"space-between center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-lg=\"space-between center\"><div class=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\"><div \nclass=\"h5 text-uppercase\"><span ng-class=\"{\'font-weight-900\' : $last,\'pl-5\':!$first}\" \nng-repeat=\"title in item.titulo track by $index\">{{title}}</span></div></div><div ng-if=\"!vm.analyst\" \nng-class=\"vm.getColorBlockIndicator(item.completo)\" class=\"w-40 h-40\" layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"{{vm.getIconBlockIndicator(item.completo)}}\" class=\"\"></md-icon></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/admin/admin/reports/request-admin/request-admin.html","<div class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"m-20 md-whiteframe-1dp\"><div layout=\"row\" class=\"bb filtro_fechas\" layout-align=\"end center\" layout-wrap><div \nmd-colors=\"{color: \'accent\'}\" class=\"p-10\">Filtrar por</div><div class=\"p-10\"><md-select id=\"tipo_sel\" \nng-change=\"vm.filterByDate()\" ng-model=\"vm.filterType\" aria-label=\"Filters\"><md-option \nng-repeat=\"filter in vm.filters\" ng-value=\"filter.id\">{{filter.name}}</md-option></md-select></div><div class=\"p-10\">\n<md-datepicker ng-change=\"vm.filterByDate()\" ng-disabled=\"!vm.filterType\" ng-model=\"vm.startDate\" \nmd-placeholder=\"Inicio\" md-open-on-focus></md-datepicker></div><div class=\"p-10\"><md-datepicker \nng-change=\"vm.filterByDate()\" ng-disabled=\"!vm.startDate\" md-min-date=\"vm.startDate\" ng-model=\"vm.endDate\" \nmd-placeholder=\"Fin\" md-open-on-focus></md-datepicker></div><div class=\"p-10\"><md-icon class=\"cursor-pointer\" \nng-click=\"vm.resetFilter()\" md-font-icon=\"icon-close\"></md-icon></div></div><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" ms-responsive-table><thead><tr><th md-colors=\"{background: \'accent\'}\" \nclass=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">ID Ikano</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">\nCandidato seleccionado</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div \nclass=\"table-header\"><span class=\"column-title\">Documento de identidad del candidato</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">\nFecha ingreso</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\">\n<span class=\"column-title\">Tipo de contrato</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\">\n<div class=\"table-header\"><span class=\"column-title\">Centro de gasto</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">Regional\n</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span \nclass=\"column-title\">Ciudad de trabajo</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div \nclass=\"table-header\"><span class=\"column-title\">Nombre del jefe que firma la requisición</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">\nDocumento de identidad del jefe</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div \nclass=\"table-header\"><span class=\"column-title\">Estado</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">Número de requisición</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">División\n</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span \nclass=\"column-title\">Grupo actividad/Negocio</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">Área funcional</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">Ubicación\n</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span \nclass=\"column-title\">Sociedad</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div \nclass=\"table-header\"><span class=\"column-title\">Código NN</span></div></th><th md-colors=\"{background: \'accent\'}\" \nclass=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">Fecha aprobación compensación</span></div></th>\n<th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">Cargo\n</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span \nclass=\"column-title\">Tipo de requerimiento</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\">\n<div class=\"table-header\"><span class=\"column-title\">Código persona a reemplazar</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">\nDocumento de identidad persona a reemplazar</span></div></th><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\">\n<div class=\"table-header\"><span class=\"column-title\">Nombre persona a reemplazar</span></div></th><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span class=\"column-title\">\nNumero de caso (SD) de service manager</span></div></th></tr></thead><tbody><tr class=\"h7\" \nng-repeat=\"report in vm.reportData\"><td class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.id}}</div></td><td \nclass=\"md-grey-100-bg\"><div class=\"p-8\">{{report.seleccionado_nombre | capitalize:true}}</div></td><td \nclass=\"md-grey-100-bg\"><div class=\"p-8\">{{report.seleccionado_cedula}}</div></td><td class=\"md-grey-100-bg\"><div \nclass=\"p-8\">{{report.seleccionado_fecha_ingreso | fecha: \'DD/MMMM/YYYY\'}}</div></td><td class=\"md-grey-100-bg\"><div \nclass=\"p-8\">{{report.tipo_contrato}}</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.centro_gasto}}\n</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.regional}}</div></td><td class=\"md-grey-100-bg\"><div \nclass=\"p-8\">{{report.ciudad}}</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.jefe_nombre}}</div></td>\n<td class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.jefe_cedula}}</div></td><td class=\"md-grey-100-bg\"><div \nclass=\"p-8\">{{report.estado_label}}</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.codigo}}</div></td>\n<td class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.division}}</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">\n{{report.grupo_negocio}}</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.area_funcional}}</div></td><td \nclass=\"md-grey-100-bg\"><div class=\"p-8\">{{report.ubicacion}}</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">\n{{report.sociedad}}</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.codigo_nn}}</div></td><td \nclass=\"md-grey-100-bg\"><div class=\"p-8\">{{report.fecha_compensacion | fecha: \'DD/MMMM/YYYY\'}}</div></td><td \nclass=\"md-grey-100-bg\"><div class=\"p-8\">{{report.cargo_ocupar}}</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">\n{{report.tipo_solicitud_label}}<p ng-if=\"report.tipo_solicitud_b_label != \'\'\">{{report.tipo_solicitud_b_label}}</p><p \nng-if=\"report.tipo_solicitud_c_label != \'\'\">{{report.tipo_solicitud_c_label}}</p></div></td><td class=\"md-grey-100-bg\">\n<div class=\"p-8\">{{report.persona_codigo}}</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">\n{{report.persona_cedula}}</div></td><td class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.persona_nombre}}</div></td><td\n class=\"md-grey-100-bg\"><div class=\"p-8\">{{report.numero_caso_service_manager}}</div></td></tr></tbody></table></div>\n<md-button ng-click=\"vm.downloadExcel()\" class=\"md-accent md-raised md-button md-default-theme md-ink-ripple\">\nDescargar reporte en excel</md-button><br></div>");
$templateCache.put("app/main/admin/admin/reports/request-report-service/request-report-service-old.html","<div class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"m-20 md-whiteframe-1dp\"><div layout=\"row\" class=\"filtro_criterios p-20\" layout-align=\"start center\" layout-wrap>\n<div flex=\"20\" ng-repeat=\"filter in vm.filters\"><md-input-container class=\"md-block h-50\" md-no-float flex-gt-sm \nng-if=\"filter.type == \'SELECT\' || filter.type == \'SELECT_DATE_RANGE\' && filter.show\"><label>{{filter.name}}</label>\n<md-select ng-model=\"vm.valueFilterTmp[filter.id]\"><md-option ng-repeat=\"option in filter.values\" \nvalue=\"{{option.id}}\">{{option.name | capitalize:true}}</md-option></md-select></md-input-container><md-input-container\n class=\"md-block h-50\" flex-gt-sm ng-if=\"filter.type == \'TEXT\' && filter.show\"><label>{{filter.name}}</label><input \nng-model=\"vm.valueFilterTmp[filter.id]\"></md-input-container><md-input-container class=\"md-block h-50\" \nng-if=\"(filter.type == \'DATE\' || filter.type == \'DATE_BETWEEN\') && filter.show\"><label>{{filter.name}}</label>\n<md-datepicker ng-model=\"vm.valueFilterTmp[filter.id]\" readonly=\"readonly\" md-placeholder=\"{{filter.name}}\" \nmd-min-date=\"filter.min_date\" md-open-on-focus></md-datepicker></md-input-container><div class=\"md-block\" flex-gt-sm \nng-if=\"filter.type == \'AUTOCOMPLETE\' && filter.show\"><md-autocomplete md-selected-item=\"vm.valueFilterTmp[filter.id]\" \nmd-search-text=\"vm.searchFilter[filter.id]\" md-items=\"data in vm.search(filter.values,vm.searchFilter[filter.id])\" \nmd-item-text=\"data.name\" md-require-match md-floating-label=\"{{filter.name}}\" md-no-cache><md-item-template><span \nmd-highlight-text=\"vm.searchFilter[filter.id]\">{{data.name}}</span></md-item-template><md-not-found>\nNo se encuentran cargos bajo el parametro.</md-not-found></md-autocomplete></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"bb p-20\" layout-wrap><div layout=\"row\" layout-align=\"space-between center\" \nlayout-wrap><md-button ng-click=\"vm.filterByCriteria()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg mr-10\">Filtrar\n</md-button><md-button ng-click=\"vm.resetFilter()\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 no-margin white-fg ml-10\">Limpiar\n</md-button></div><md-button ng-click=\"vm.downloadExcel()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Descargar reporte en excel <i \nclass=\"icon-file-excel cursor-pointer\" ng-click=\"vm.donwloadExcelTerna()\"></i></md-button></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" ms-responsive-table><thead><tr><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\" ng-repeat=\"(key,value) in vm.headersColumn\"><div \nclass=\"table-header\"><span class=\"column-title\">{{value}}</span></div></th></tr></thead><tbody><tr class=\"h7\" \nng-repeat=\"report in vm.reportData\"><td ng-repeat=\"(key,value) in report\">{{value}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/admin/admin/reports/request-report-service/request-report-service.html","<div class=\"page-layout simple\" id=\"request-report-service\"><div ng-include=\"\'app/main/templates/header/default.html\'\">\n</div><div class=\"m-20 md-whiteframe-1dp\"><div layout=\"row\" class=\"filtro_criterios p-20\" layout-align=\"start \" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" flex-gt-sm=\"50\" flex-md=\"33\" \nflex-gt-md=\"33\" layout-lg=\"33\" flex-gt-lg=\"20\" flex-xl=\"20\" ng-repeat=\"filter in vm.filters\"><md-input-container \nclass=\"md-block h-50\" md-no-float flex-gt-sm \nng-if=\"filter.type == \'SELECT\' || filter.type == \'SELECT_DATE_RANGE\' && filter.show\"><label>{{filter.name}}</label>\n<md-select ng-model=\"vm.valueFilterTmp[filter.id]\"><md-option ng-repeat=\"option in filter.options\" \nvalue=\"{{option.id}}\">{{option.name | capitalize:true}}</md-option></md-select></md-input-container><md-input-container\n class=\"md-block h-50\" flex-gt-sm ng-if=\"filter.type == \'TEXT\' && filter.show\"><label>{{filter.name}}</label><input \nng-model=\"vm.valueFilterTmp[filter.id]\"></md-input-container><md-input-container class=\"md-block h-50\" \nng-if=\"(filter.type == \'DATE\' || filter.type == \'DATE_BETWEEN\') && filter.show\"><label>{{filter.name}}</label>\n<md-datepicker ng-model=\"vm.valueFilterTmp[filter.id]\" readonly=\"readonly\" md-placeholder=\"{{filter.name}}\" \nmd-min-date=\"filter.min_date\" md-open-on-focus></md-datepicker></md-input-container><div class=\"md-block\" flex-gt-sm \nng-if=\"filter.type == \'AUTOCOMPLETE\' && filter.show\"><md-autocomplete md-selected-item=\"vm.valueFilterTmp[filter.id]\" \nmd-search-text=\"vm.searchFilter[filter.id]\" md-items=\"data in vm.search(filter.options,vm.searchFilter[filter.id])\" \nmd-item-text=\"data.name\" md-require-match md-floating-label=\"{{filter.name}}\" md-no-cache><md-item-template><span \nmd-highlight-text=\"vm.searchFilter[filter.id]\">{{data.name}}</span></md-item-template><md-not-found>\nNo se encuentran cargos bajo el parametro.</md-not-found></md-autocomplete></div><md-input-container \nclass=\"md-block h-50\" flex-gt-sm ng-if=\"filter.type == \'AUTOCOMPLETECHIP\' && filter.show\"><label>{{filter.name}}\n</label><md-chips ng-model=\"vm.valueFilterTmp[filter.id]\" md-autocomplete-snap=\"\" md-removable=\"true\" \nmd-on-add=\"vm.validationChip(vm.valueFilterTmp[filter.id],$chip)\" \nmd-on-remove=\"vm.removeChip($chip,vm.valueFilterTmp[filter.id])\"><md-autocomplete class=\"custom-autocomplete\" \nng-disabled=\"disabled\" md-selected-item=\"selectedItem\" md-search-text=\"vm.searchFilter[filter.id]\" \nmd-items=\"data in vm.search(filter.options,vm.searchFilter[filter.id]) | orderBy : \'name\'\" \nmd-item-text=\"data.name | capitalize: true\" md-min-length=\"3\"><md-item-template><span \nmd-highlight-text=\"vm.valueFilterTmp[filter.id]\" md-highlight-flags=\"^i\">{{data.name | capitalize: true}}</span>\n</md-item-template><md-not-found>No se encontraron coincidencias con la palabra \"{{vm.valueFilterTmp[filter.id]}}\"\n</md-not-found></md-autocomplete><md-chip-template><span class=\"chipsValue\">{{$chip.name}}</span></md-chip-template>\n</md-chips></md-input-container></div></div></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"bb p-20\" layout-wrap><div layout=\"row\" layout-align=\"space-between center\" layout-wrap><md-button \nng-click=\"vm.filterByCriteria()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 white-fg mr-10\">Filtrar</md-button>\n<md-button ng-click=\"vm.resetFilter()\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-30 pr-30 white-fg ml-10\">Limpiar</md-button></div>\n<md-button ng-click=\"vm.downloadExcel()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Descargar reporte en excel <i \nclass=\"icon-file-excel cursor-pointer\" ng-click=\"vm.donwloadExcelTerna()\"></i></md-button></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" ms-responsive-table><thead><tr><th \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\" ng-repeat=\"(key,value) in vm.headersColumn\"><div \nclass=\"table-header\"><span class=\"column-title\">{{value}}</span></div></th></tr></thead><tbody><tr class=\"h7\" \nng-repeat=\"report in vm.reportData track by $index\"><td ng-repeat=\"(key,value) in report \"><div \nng-class=\"vm.configReportClass[key][$parent.$index]\" ng-style=\"vm.configReportStyle[key][$parent.$index]\"><span \nng-hide=\"vm.reportConfig[key].hide_value\">{{value}}</span></div></td></tr></tbody></table></div>");
$templateCache.put("app/main/admin/admin/reports/service-performance/service-performance.html","<div class=\"page-layout simple\"><div ng-include=\"\'app/main/templates/header/default.html\'\"></div><div \nclass=\"m-20 md-whiteframe-1dp\"><table ng-if=\"vm.report.list\" class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" ms-responsive-table><thead><tr><th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div\n class=\"table-header\"><span class=\"column-title\">Detalle del proceso</span></div></th><th colspan=\"2\" \nng-repeat=\"rol in vm.report.roles\" md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div \nclass=\"table-header text-center\"><span class=\"column-title\">{{rol.label | capitalize:true}}</span></div></th></tr><tr>\n<th md-colors=\"{background: \'accent\'}\" class=\"white-fg b\"></th><th ng-repeat=\"header in vm.headers\" \nmd-colors=\"{background: \'accent\'}\" class=\"white-fg b\"><div class=\"table-header\"><span ng-if=\"$index % 2 == 0\" \nclass=\"column-title\">Fecha</span> <span ng-if=\"$index % 2 == 1\" class=\"column-title\">Tiempo</span></div></th></tr>\n</thead><tbody><tr class=\"h7\" ng-repeat=\"report in vm.report.list\"><td class=\"md-grey-100-bg\"><div class=\"p-8\">\n{{report.cargo_ocupar | capitalize:true}}</div></td><td ng-class=\"{\'md-grey-100-bg\' : $index % 2 == 1}\" \nng-repeat=\"(key, value) in vm.headers\"><div ng-if=\"$index % 2 == 0\" class=\"p-8\">\n{{report.fechas_roles[key].fecha_aprobacion | fecha: \'DD/MMMM/YYYY\'}}</div><div ng-if=\"$index % 2 == 1\" class=\"p-8\">\n{{report.fechas_roles[key].dias_apr}} <span ng-if=\"report.fechas_roles[key].dias_apr\">día</span><span \nng-if=\"report.fechas_roles[key].dias_apr == 0 || report.fechas_roles[key].dias_apr > 1\">s</span></div></td></tr>\n</tbody></table></div></div>");
$templateCache.put("app/main/admin/admin/show-request/partials/content.html","<div ng-repeat=\"block in vm.blocks\"><div ng-include=\"\'app/main/templates/request/blocks/read/\' + block.type + \'.html\'\" \nonload=\"item = block\"></div></div>");
$templateCache.put("app/main/admin/admin/show-request/partials/sidebar.html","<div class=\"grey-100-bg\"><div class=\"grey-200-bg p-15\"><div class=\"h5 grey-700-fg pb-8\">Estado actual de la solicitud\n</div><div><span ng-style=\"vm.statusColor\" class=\"text-boxed white-fg h6 no-margin font-weight-200 radius-15\">\n{{vm.data.data.estado_label}} </span><a ng-if=\"vm.data.rechazo.motivo_rechazo\" href=\"#\" \nng-click=\"vm.showReasons(vm.data.rechazo.motivo_rechazo, vm.data.rechazo.observaciones_rechazo)\" \nclass=\"pl-8 pr-8 cursor-pointer h6\">Ver motivo</a></div></div><div class=\"p-15 bb\"><div \nng-if=\"vm.data.options.aprobar\" class=\"pt-5 pb-5\" layout=\"row\" flex=\"100\"><md-button ng-click=\"vm.approve()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Aprobar</md-button>\n</div><div ng-if=\"vm.data.options.devolver\" class=\"pt-5 pb-5\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.giveBack()\" class=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">\nDevolver</md-button></div><div ng-if=\"vm.data.options.rechazar\" class=\"pt-5 pb-5\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.dismiss()\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Rechazar</md-button>\n</div><div ng-if=\"vm.data.options.anular\" class=\"pt-5 pb-5\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.openCancelRequestDialog()\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Cancelar requisición\n</md-button></div><div ng-if=\"vm.data.options.update\" class=\"pt-5 pb-5\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.update()\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Modificar\n</md-button></div></div><div ng-if=\"vm.data.aprobadores.listado.length\" class=\"p-15 bb\"><div \nclass=\"h5 grey-700-fg pb-8\">Ruta de aprobación</div><div class=\"all-width\"><div \nng-repeat=\"approver in vm.data.aprobadores.listado\" class=\"pt-5 pb-5\" layout=\"row\" layout-align=\"space-between\" \nlayout-wrap><div class=\"grey-500-fg p-5\" layout=\"row\" layout-align=\"space-between center\"><div flex \nng-class=\"vm.getIndicatorColor(approver.estado)\" class=\"circle w-8 h-8 green-bg mr-10\"></div><div><div \nclass=\"grey-500-fg h5\">{{vm.displayCorrectApprover(approver) | capitalize:true}}</div><div \nng-if=\"approver.ejecutor_id && approver.ejecutor_id != approver.colaborador_id\" class=\"grey-500-fg font-weight-300 h6\">\nEn reemplazo de:<br>{{approver.colaborador | capitalize:true}}</div><div class=\"grey-500-fg font-weight-200 h6\">\n{{approver.fecha_aprobacion | date}}</div></div></div><div flex class=\"grey-400-fg h6 p-5 text-right\">\n{{approver.estado_label}}</div></div></div></div><div ng-if=\"vm.data.aprobadores.listado.length\" class=\"p-15 bb\" \nlayout=\"row\" layout-wrap><div flex=\"50\" ng-repeat=\"(key, status) in vm.data.aprobadores.estados_aprobacion\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"circle w-8 h-8 m-5\" ng-class=\"vm.getIndicatorColor(key)\"></div>\n<div class=\"p-5\">{{status}}</div></div></div><div ng-if=\"vm.extra.fecha_solicitud\" class=\"p-15 bb\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"h1 bold-text\">{{vm.extra.fecha_solicitud | date}}</div><div \nclass=\"h6 grey-fg\">Fecha de solicitud</div></div><div ng-if=\"vm.extra.dias_solicitud\" class=\"p-15\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"h1 bold-text\">{{vm.extra.dias_solicitud}}</div><div class=\"h6 grey-fg\">\nDías de solicitud</div></div></div>");
$templateCache.put("app/main/admin/admin/update-rol-aprobadores/modal/moda-rol-aprobadores.html","<md-dialog aria-label=\"List dialog\" flex=\"35\" class=\"h-220\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Actualizar rol aprobador </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><div flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"100\" flex-gt-lg=\"100\" flex-xl=\"100\"><md-input-container \nclass=\"md-block h-10 all-width\"><label>Nombre Rol Aprobador</label><input ng-model=\"vm.rol.label\" type=\"text\">\n</md-input-container><div class=\"text-center\" ng-if=\"vm.hasError\"><label>{{vm.errorMensaje}}</label></div></div><br>\n<div class=\"text-center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg all-width\" \nng-click=\"vm.updateRolAprobador()\">Aceptar</md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/admin/update-tiempos/modal/modal-tiempos.html","<md-dialog aria-label=\"List dialog\" flex=\"35\" class=\"h-220\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Actualizar rol: {{vm.rol.rol_key}} </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><div flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"50\" \nflex-gt-sm=\"50\" flex-md=\"33\" flex-gt-md=\"33\" flex-lg=\"100\" flex-gt-lg=\"100\" flex-xl=\"100\"><md-input-container \nclass=\"md-block h-20 all-width\"><label>Horas</label><input ng-model=\"vm.rol.horas\" type=\"number\"></md-input-container>\n<div class=\"text-center\" ng-if=\"vm.hasError\"><label>{{vm.errorMensaje}}</label></div></div><br><div \nclass=\"text-center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin white-fg all-width\" \nng-click=\"vm.updateTiempo()\">Aceptar</md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/approver/show-request/dialogs/approve-request.html","<md-dialog class=\"w-380\" aria-label=\"Add employee\"><form name=\"cancelForm\"><md-toolbar class=\"md-accent white-text\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\">\n<h3>{{vm.data.data.cargo_ocupar | capitalize:true}}</h3></div><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-content flex ms-scroll><div flex=\"100\" class=\"p-30 h5\" layout=\"column\" layout-align>{{vm.message}}\n</div></md-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button \nng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.approveRequest()\" aria-label=\"Anular\" type=\"submit\" \nng-disabled=\"vm.disable_aprrove_button\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/approver/show-request/dialogs/dismiss-request.html","<md-dialog class=\"w-380\" aria-label=\"Add employee\"><form name=\"dismissForm\"><md-toolbar class=\"md-accent white-text\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\">\n<h3>{{vm.data.data.cargo_ocupar | capitalize:true}}</h3></div><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-content flex ms-scroll><div flex=\"100\" class=\"p-30\" layout=\"column\" layout-align><div flex=\"100\" \nclass=\"pt-8 pb-20\"><md-input-container class=\"no-padding no-margin all-width\"><label>Motivo del rechazo</label>\n<md-select name=\"motivo_rechazo_id\" ng-model=\"vm.formData.motivo_rechazo_id\" required><md-option \nng-repeat=\"(key, value) in vm.data.motivo_rechazos track by $index\" ng-value=\"key\">{{value}}</md-option></md-select>\n<div ng-messages=\"dismissForm.motivo_rechazo_id.$error\"><div ng-message=\"required\">Este campo es requerido.</div></div>\n</md-input-container></div><div flex=\"100\" class=\"pt-8 pb-8\"><md-input-container \nclass=\"no-padding no-margin all-width\"><label>Comentarios adicionales</label><textarea name=\"observaciones\" \nclass=\"no-padding no-margin all-width\" ng-model=\"vm.formData.observaciones\" md-maxlength=\"200\" rows=\"3\" required>\n</textarea><div ng-messages=\"dismissForm.observaciones.$error\"><div ng-message=\"required\">Este campo es requerido.\n</div></div></md-input-container></div></div></md-content><md-dialog-actions class=\"bt\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.dismissRequest()\" aria-label=\"Anular\" type=\"submit\" \nng-disabled=\"dismissForm.$invalid || dismissForm.$pristine || vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/approver/show-request/dialogs/giveback-request.html","<md-dialog class=\"w-380\" aria-label=\"Add employee\"><form name=\"form\"><md-toolbar class=\"md-accent white-text\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\"><h3>\n{{vm.data.data.cargo_ocupar}}</h3></div><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content flex \nms-scroll><div flex=\"100\" class=\"p-30\" layout=\"column\" layout-align><div flex=\"100\" class=\"pt-8 pb-20\">\n<md-input-container class=\"no-padding no-margin all-width\"><label>Devolver al colaborador</label><md-select \nname=\"colaborador_id\" ng-change=\"vm.setRole()\" ng-model=\"vm.colaborator\" required><md-option \nng-repeat=\"(key, value) in vm.data.aprobadores_devolucion track by $index\" ng-value=\"value\">\n{{value.colaborador_name | capitalize:true}} ({{value.rol_name | capitalize:true}})</md-option></md-select><div \nng-messages=\"form.colaborador_id.$error\"><div ng-message=\"required\">Este campo es requerido.</div></div>\n</md-input-container></div><div flex=\"100\" class=\"pt-8 pb-8\"><md-input-container \nclass=\"no-padding no-margin all-width\"><label for=\"observaciones\" class=\"no-margin no-padding\">Comentarios adicionales\n</label><textarea name=\"observaciones\" class=\"no-margin no-padding\" ng-model=\"vm.formData.observaciones\" \nmd-maxlength=\"200\" rows=\"3\" required></textarea><div ng-messages=\"form.observaciones.$error\"><div \nng-message=\"required\">Este campo es requerido.</div></div></md-input-container></div></div></md-content>\n<md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button \nng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.giveBackRequest()\" aria-label=\"Aceptar\" \nng-disabled=\"form.$invalid || form.$pristine || vm.loading\" type=\"submit\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/approver/show-request/dialogs/update-request-type.html","<md-dialog class=\"w-500\" aria-label=\"Add employee\"><form name=\"typeRequest\"><md-toolbar class=\"md-accent white-text\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\">\n<h3>Modificar el tipo de solicitud o país de trabajo</h3></div><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-content flex ms-scroll><div ng-if=\"vm.listCountry\" flex=\"100\" class=\"pt-30 pl-30 pr-30 pb-8\" \nlayout=\"column\" layout-align><div flex=\"100\" class=\"pt-8 pb-8\"><md-input-container \nclass=\"no-padding no-margin all-width\"><label>País de trabajo</label><md-select ng-model=\"vm.countryProcess\" required>\n<md-option ng-repeat=\"item in vm.listCountry \" ng-value=\"item.id\">{{item.name | capitalizeFirstLetter }}</md-option>\n</md-select></md-input-container></div></div><div flex=\"100\" class=\"pt-8 pl-30 pr-30 pb-8\" layout=\"column\" \nlayout-align><div flex=\"100\" class=\"pt-8 pb-8\"><md-input-container class=\"no-padding no-margin all-width\"><label>\nSeleccione el tipo de requisición</label><md-select ng-model=\"vm.requestType\"><md-option \nng-repeat=\"(key, item) in vm.requestTypes | orderBy: \'name\' track by $index\" \nng-disabled=\"vm.checkAvailability(1, item)\" ng-value=\"item\">{{item.name | capitalizeFirstLetter }}</md-option>\n</md-select></md-input-container></div><div ng-if=\"vm.requestType != undefined\" flex=\"100\" \nclass=\"pt-8 pb-8 h6 grey-fg\">{{vm.requestType.description}}</div></div><div ng-if=\"vm.extraRequests.length\" flex=\"100\" \nclass=\"pt-8 pl-30 pr-30 pb-8\" layout=\"column\" layout-align><div flex=\"100\" class=\"pt-8 pb-8\"><md-input-container \nclass=\"no-padding no-margin all-width\"><label>Trámite adicional 1 (opcional)</label><md-select \nng-model=\"vm.extraType1\"><md-option><em>Ninguno</em></md-option><md-option \nng-repeat=\"(key, item) in vm.extraRequests | orderBy: \'name\' track by $index\" \nng-disabled=\"vm.checkAvailability(2, item)\" ng-value=\"item\">{{item.name | capitalizeFirstLetter }}</md-option>\n</md-select></md-input-container></div><div ng-if=\"vm.extraType1 != undefined\" flex=\"100\" class=\"pt-8 pb-8 h6 grey-fg\">\n{{vm.extraType1.description}}</div></div><div ng-if=\"vm.extraRequests.length\" flex=\"100\" \nclass=\"pt-8 pl-30 pr-30 pb-30\" layout=\"column\" layout-align><div flex=\"100\" class=\"pt-8 pb-8\"><md-input-container \nclass=\"no-padding no-margin all-width\"><label>Trámite adicional 2 (opcional)</label><md-select \nng-model=\"vm.extraType2\"><md-option><em>Ninguno</em></md-option><md-option \nng-repeat=\"(key, item) in vm.extraRequests | orderBy: \'name\' track by $index\" \nng-disabled=\"vm.checkAvailability(3, item)\" ng-value=\"item\">{{item.name | capitalizeFirstLetter }}</md-option>\n</md-select></md-input-container></div><div ng-if=\"vm.extraType2 != undefined\" flex=\"100\" class=\"pt-8 pb-8 h6 grey-fg\">\n{{vm.extraType2.description}}</div></div></md-content><md-dialog-actions class=\"bt\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.confirm()\" aria-label=\"Anular\" type=\"submit\" \nng-disabled=\"vm.requestType == undefined || vm.countryProcess == undefined\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/approver/show-request/partials/content.html","<div ng-repeat=\"block in vm.blocks\"><div ng-include=\"\'app/main/templates/request/blocks/read/\' + block.type + \'.html\'\" \nonload=\"item = block\"></div></div>");
$templateCache.put("app/main/admin/approver/show-request/partials/observations.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"grey-100-bg bb\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-sm=\"row\" layout-gt-sm=\"row\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-gt-lg=\"row\" layout-lg=\"row\" layout-align-xs=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\" layout-align-sm=\"space-between center\" \nlayout-align-gt-sm=\"space-between center\" layout-align-md=\"space-between center\" \nlayout-align-gt-md=\"space-between center\" layout-align-gt-lg=\"space-between center\" \nlayout-align-lg=\"space-between center\"><div class=\"pl-20 pt-10 pb-10 pr-10 bt-5 bb-light-blue-2\"><div \nclass=\"h5 text-uppercase\">Observaciones</div></div></div><div class=\"grey-50-bg\"><div \nng-if=\"!vm.showObsForm && !vm.admin\" class=\"ms-new-note\"><div ng-click=\"vm.showObsForm = true\" class=\"new-note-button\">\n<span>Agregar observación</span></div></div><div ng-if=\"vm.showObsForm\" class=\"ms-note-form\"><form name=\"obsForm\" \nclass=\"\"><md-input-container md-no-float><textarea name=\"comentario\" ng-model=\"vm.obsForm.comentario\" \nplaceholder=\"Escriba su observación\" class=\"note-description-textarea mb-8\" autofocus required>\n                            </textarea></md-input-container><div class=\"footer\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"space-between center\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.showObsForm = false\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding\">Cancelar</md-button><md-button \nng-click=\"vm.addObservation()\" aria-label=\"Guardar\" type=\"submit\" ng-disabled=\"obsForm.$invalid || obsForm.$pristine \" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Guardar\n</md-button></div></div></form></div></div><div class=\"white-bg\"><div ng-class=\"{\'bb\' : !$last}\" \nng-if=\"vm.observations.length\" ng-repeat=\"observation in vm.observations\" class=\"p-20 white-bg\"><div \nclass=\"h4 text-capitalize\">{{observation.aprobador | capitalize:true}}</div><div class=\"\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h6 grey-fg\">{{observation.fecha | fecha: \'DD/MMMM/YYYY\'}}</div><div \nng-if=\"observation.edit\" class=\"h6 text-right\" layout=\"row\" layout-align=\"end center\"><span \nclass=\"grey-fg cursor-pointer text-underlined\" ng-click=\"vm.updateObservation(observation)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"grey-fg h6\"></md-icon>Editar </span><span \nclass=\"red-fg cursor-pointer text-underlined\" ng-click=\"vm.deleteObservation($event, observation)\"><md-icon \nmd-font-icon=\"icon-trash\" class=\"red-fg h6\"></md-icon>Eliminar</span></div></div><div class=\"h6 pre-line\">\n{{observation.comentario}}</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/admin/approver/show-request/partials/sidebar.html","<div class=\"grey-100-bg\"><div class=\"grey-200-bg p-15\"><div class=\"h5 grey-700-fg pb-8\">Estado actual de la solicitud\n</div><div><span ng-style=\"vm.statusColor\" class=\"text-boxed white-fg h6 no-margin font-weight-200 radius-15\">\n{{vm.data.data.estado_label}} </span><a ng-if=\"vm.data.rechazo.motivo_rechazo\" href=\"#\" \nng-click=\"vm.showReasons(vm.data.rechazo.motivo_rechazo, vm.data.rechazo.observaciones_rechazo)\" \nclass=\"pl-8 pr-8 cursor-pointer h6\">Ver motivo</a></div></div><div class=\"p-15\"><div \nng-if=\"vm.data.options.undoApprove\" class=\"pt-5 pb-5\" layout=\"column\" flex=\"100\"><div class=\"text-center h2 pt-8 pb-8\">\nRequisición aprobada</div><div class=\"text-right h6 pt-5 pb-5\"><a href=\"#\" ng-click=\"vm.undoApproveRequest()\">Deshacer\n</a></div></div><div ng-if=\"vm.data.options.aprobar\" class=\"pt-5 pb-5\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.openApproveRequestDialog()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Aprobar</md-button>\n</div><div ng-if=\"vm.data.options.devolver\" class=\"pt-5 pb-5\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.openGiveBackRequestDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Devolver</md-button></div>\n<div ng-if=\"vm.data.options.rechazar\" class=\"pt-5 pb-5\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.openDismissRequestDialog($event)\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Rechazar</md-button>\n</div><div ng-if=\"vm.data.options.undoDismiss\" class=\"pt-5 pb-5\" layout=\"column\" flex=\"100\"><div \nclass=\"text-center h2 pt-8 pb-8\">Requisición rechazada</div><div class=\"text-right h6 pt-5 pb-5\"><a href=\"#\" \nng-click=\"vm.undoDismissRequest()\">Deshacer</a></div></div><div ng-if=\"vm.data.options.anular\" class=\"pt-5 pb-5\" \nlayout=\"row\" flex=\"100\"><md-button ng-click=\"vm.openCancelRequestDialog()\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Cancelar requisición\n</md-button></div><div ng-if=\"vm.data.options.update\" class=\"pt-5 pb-5\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.update()\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Modificar\n</md-button></div></div><div ng-if=\"vm.data.aprobadores.listado.length\" class=\"p-15 bt bb\"><div \nclass=\"h5 grey-700-fg pb-8\">Ruta de aprobación</div><div class=\"all-width\"><div \nng-repeat=\"approver in vm.data.aprobadores.listado\" class=\"pt-5 pb-5\" layout=\"row\" layout-align=\"space-between\" \nlayout-wrap><div class=\"grey-500-fg p-5\" layout=\"row\" layout-align=\"space-between center\"><div flex \nng-class=\"vm.getIndicatorColor(approver.estado)\" class=\"circle w-8 h-8 green-bg mr-10\"></div><div><div \nclass=\"grey-500-fg h5\">{{vm.displayCorrectApprover(approver) | capitalize:true}}</div><div \nng-if=\"approver.ejecutor_id && approver.ejecutor_id != approver.colaborador_id\" class=\"grey-500-fg font-weight-300 h6\">\nEn reemplazo de:<br>{{approver.colaborador | capitalize:true}}</div><div class=\"grey-500-fg font-weight-200 h6\">\n{{approver.fecha_aprobacion | date}}</div></div></div><div flex class=\"grey-400-fg h6 p-5 text-right\">\n{{approver.estado_label}}</div></div></div></div><div ng-if=\"vm.data.aprobadores.listado.length\" class=\"p-15 bb\" \nlayout=\"row\" layout-wrap><div flex=\"50\" ng-repeat=\"(key, status) in vm.data.aprobadores.estados_aprobacion\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"circle w-8 h-8 m-5\" ng-class=\"vm.getIndicatorColor(key)\"></div>\n<div class=\"p-5\">{{status}}</div></div></div><div ng-if=\"vm.extra.fecha_solicitud\" class=\"p-15 bb\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"h1 bold-text\">{{vm.extra.fecha_solicitud | date}}</div><div \nclass=\"h6 grey-fg\">Fecha de solicitud</div></div><div ng-if=\"vm.extra.dias_solicitud\" class=\"p-15\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"h1 bold-text\">{{vm.extra.dias_solicitud}}</div><div class=\"h6 grey-fg\">\nDías de solicitud</div></div></div>");
$templateCache.put("app/main/admin/collaborators/partial/position/position.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-300\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Cargo colaborador </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"padding\"><div id=\"positionColaborator\" layout=\"column\" \nlayou-align=\"space-between center\"><md-autocomplete md-selected-item=\"vm.data.positions\" \nmd-search-text=\"vm.filter.positions\" md-search-text-change=\"vm.loadData(\'positions\')\" \nmd-items=\"data in vm.misc.positions\" md-item-text=\"data.name\" placeholder=\"Buscar cargos\" class=\"mb-10\">\n<md-item-template><span md-highlight-text=\"vm.filter.positions\">{{data.name}}</span></md-item-template><md-not-found>\nNo se encuentran cargos bajo el parametro.</md-not-found></md-autocomplete><md-autocomplete \nmd-selected-item=\"vm.data.sociedades\" md-search-text=\"vm.filter.sociedades\" \nmd-search-text-change=\"vm.loadData(\'sociedades\')\" md-items=\"data in vm.misc.sociedades\" md-item-text=\"data.name\" \nplaceholder=\"Buscar sociedad\"><md-item-template><span md-highlight-text=\"vm.filter.sociedades\">{{data.name}}</span>\n</md-item-template><md-not-found>No se encuentran cargos bajo el parametro.</md-not-found></md-autocomplete></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button \nng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.save()\" ng-disabled=\"!vm.data.sociedades || !vm.data.positions\" \naria-label=\"Recommend candidate\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\">Seleccionar</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/config/approvers/dialogs/add-approver.html","<md-dialog class=\"w-480\" aria-label=\"Add approver\"><form name=\"approverForm\"><md-toolbar class=\"md-accent white-text\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\">\n<h3>{{vm.title}}</h3></div><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content flex ms-scroll><div flex=\"100\" \nclass=\"p-30\" layout=\"column\" layout-align><div flex=\"100\" class=\"pt-8 pb-20\"><md-input-container \nclass=\"no-padding no-margin all-width\"><label>Tipo de aprobador</label><md-select name=\"type\" ng-model=\"vm.type\" \nrequired><md-option ng-repeat=\"(key, value) in vm.types track by $index \" ng-value=\"key\">{{value.label}}</md-option>\n</md-select><div class=\"pt-5 pb-5 red-fg\" ng-if=\"vm.errors.type\">{{vm.errors.type}}</div></md-input-container></div>\n<div flex=\"100\" class=\"pt-20\"><md-input-container class=\"no-padding no-margin all-width\"><label>Seleccionar colaborador\n</label><md-autocomplete md-selected-item=\"vm.selectedColaborator\" \nmd-search-text-change=\"searchTextChange(searchColaborator)\" md-search-text=\"searchColaborator\" \nmd-selected-item-change=\"vm.selectedColaboratorChange(item)\" \nmd-items=\"item in vm.colaboratorQuerySearch(searchColaborator) | orderBy : \'name\'\" \nmd-item-text=\"item.name | capitalize:true\" md-min-length=\"0\" placeholder=\"Escribe para empezar a buscar\">\n<md-item-template><span md-highlight-text=\"searchColaborator\" md-highlight-flags=\"^i\">{{item.name | capitalize:true}}\n</span></md-item-template><md-not-found>No se encontraron coincidencias con la palabra \"{{searchColaborator}}\"\n</md-not-found></md-autocomplete></md-input-container></div><div class=\"all-width pt-10 pb-10\" input-generator \nfield=\"field\" fieldname=\"key\" model=\"vm.extraFields\" ng-repeat=\"(key, field) in vm.data.campos_extra_aprobadores\">\n</div><div class=\"pt-10 red-fg h6\" ng-if=\"vm.errors.aprobador_id\">{{vm.errors.aprobador_id}}</div></div><div \nclass=\"pt-5 pb-15 pl-5 pr-5 red-fg text-center h6\" ng-if=\"vm.errors.general\">{{vm.errors.general}}</div></md-content>\n<md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button \nng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.addApprover()\" aria-label=\"button\" type=\"submit\" \nng-disabled=\"approverForm.$invalid || approverForm.$pristine || vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/config/approvers/dialogs/add-assistant.html","<md-dialog class=\"w-380\" aria-label=\"Add assistant\"><form name=\"assistantForm\"><md-toolbar \nclass=\"md-accent white-text\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"p-10\"><h3>{{vm.title | capitalize:true}}</h3></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-content flex ms-scroll><div flex=\"100\" class=\"p-30\" layout=\"column\" \nlayout-align><div flex=\"100\" class=\"pt-8 pb-20\"><md-input-container class=\"no-padding no-margin all-width\"><label>\nSeleccionar asistente</label><md-autocomplete md-selected-item=\"vm.selectedColaborator\" \nmd-search-text-change=\"searchTextChange(searchColaborator)\" md-search-text=\"searchColaborator\" \nmd-selected-item-change=\"vm.selectedColaboratorChange(item)\" \nmd-items=\"item in vm.colaboratorQuerySearch(searchColaborator)\" md-item-text=\"item.name | capitalize:true\" \nmd-min-length=\"0\" placeholder=\"Escribe para empezar a buscar\"><md-item-template><span \nmd-highlight-text=\"searchColaborator\" md-highlight-flags=\"^i\">{{item.name | capitalize:true}}</span></md-item-template>\n<md-not-found>No se encontraron coincidencias con la palabra \"{{searchColaborator}}\"</md-not-found></md-autocomplete>\n<div class=\"pt-8 pb-20 red-fg h6\" ng-if=\"vm.errors.aprobador_id\">{{vm.errors.assistant}}</div></md-input-container>\n</div><div class=\"pt-5 pb-5 red-fg text-center\" ng-if=\"vm.errors.general\">{{vm.errors.general}}</div></div>\n</md-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button \nng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.addAssistant()\" aria-label=\"button\" type=\"submit\" \nng-disabled=\"assistantForm.$invalid || assistantForm.$pristine || vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/config/approvers/dialogs/add-substitute.html","<md-dialog class=\"w-480\" aria-label=\"Add substitute\"><form name=\"substituteForm\"><md-toolbar \nclass=\"md-accent white-text\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"p-10\"><h3>{{vm.title}}</h3></div><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-content flex ms-scroll><div flex=\"100\" class=\"p-30\" layout=\"column\" layout-align><div \nclass=\"pt-8 pb-20\"><div layout=\"row\" flex=\"100\" layout-align=\"start center\" class=\"no-padding no-margin all-width\"><div\n class=\"h5 pt-5 pb-5 pr-5\">Fecha límite</div><div class=\"p-5\"><md-datepicker md-min-date=\"vm.today\" class=\"all-width\" \nname=\"date\" ng-model=\"vm.date\" md-placeholder=\"Seleccionar\" md-open-on-focus></md-datepicker></div></div><div \nclass=\"pt-5 pb-5 red-fg h6\" ng-if=\"vm.errors.date\">{{vm.errors.date}}</div></div><div flex=\"100\" class=\"pt-8 pb-20\">\n<md-input-container class=\"no-padding no-margin all-width\"><label>Seleccionar colaborador</label><md-autocomplete \nmd-selected-item=\"vm.selectedColaborator\" md-search-text-change=\"searchTextChange(searchColaborator)\" \nmd-search-text=\"searchColaborator\" md-selected-item-change=\"vm.selectedColaboratorChange(item)\" \nmd-items=\"item in vm.colaboratorQuerySearch(searchColaborator)\" md-item-text=\"item.name | capitalize:true\" \nmd-min-length=\"0\" placeholder=\"Escribe para empezar a buscar\"><md-item-template><span \nmd-highlight-text=\"searchColaborator\" md-highlight-flags=\"^i\">{{item.name | capitalize:true}}</span></md-item-template>\n<md-not-found>No se encontraron coincidencias con la palabra \"{{searchColaborator}}\"</md-not-found></md-autocomplete>\n<div class=\"pt-8 pb-20 red-fg h6\" ng-if=\"vm.errors.aprobador_id\">{{vm.errors.aprobador_id}}</div></md-input-container>\n</div><div class=\"pt-5 pb-5 red-fg text-center\" ng-if=\"vm.errors.general\">{{vm.errors.general}}</div></div>\n</md-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button \nng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.addSubstitute()\" aria-label=\"button\" type=\"submit\" \nng-disabled=\"substituteForm.$invalid || substituteForm.$pristine || vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/config/approvers/dialogs/approver-detail.html","<md-dialog class=\"w-500\" aria-label=\"Remove approver\"><form name=\"removeForm\"><md-toolbar class=\"md-accent white-text\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\">\n<h3>{{vm.title}}</h3></div><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content flex ms-scroll><div class=\"\" \nlayout=\"column\"><div class=\"p-30\"><div class=\"h3 pb-10 light-blue-fg\">Suplente</div><div class=\"pt-8 pb-20\"><div \nlayout=\"row\" flex=\"100\" layout-align=\"start center\" class=\"no-padding no-margin all-width\"><div \nclass=\"h5 pt-5 pb-5 pr-5\">Fecha límite:</div><div class=\"p-5\"><md-datepicker ng-disabled=\"vm.loading\" \nmd-min-date=\"vm.today\" class=\"all-width\" name=\"date\" ng-model=\"vm.date\" md-placeholder=\"Seleccionar\" md-open-on-focus>\n</md-datepicker></div></div><div class=\"pt-5 pb-5 red-fg h6\" ng-if=\"vm.errors.date\">{{vm.errors.date}}</div></div><div \nflex=\"100\" class=\"pt-8 pb-20\"><md-input-container class=\"no-padding no-margin all-width\"><label>Seleccionar colaborador\n</label><md-autocomplete ng-disabled=\"vm.loading || !vm.date\" md-selected-item=\"vm.selectedSubstitute\" \nmd-search-text-change=\"searchSubstituteTextChange(searchSubstitute)\" md-search-text=\"searchSubstitute\" \nmd-selected-item-change=\"vm.selectedSubstituteChange(item)\" \nmd-items=\"item in vm.substituteQuerySearch(searchSubstitute) | orderBy : \'name\'\" \nmd-item-text=\"item.name | capitalize:true\" md-min-length=\"0\" placeholder=\"Escribe para empezar a buscar\">\n<md-item-template><span md-highlight-text=\"searchSubstitute\" md-highlight-flags=\"^i\">{{item.name | capitalize:true}}\n</span></md-item-template><md-not-found>No se encontraron coincidencias con la palabra \"{{searchSubstitute}}\"\n</md-not-found></md-autocomplete><div class=\"pt-8 pb-20 red-fg h6\" ng-if=\"vm.errors.substitute\">\n{{vm.errors.substitute}}</div></md-input-container></div></div><div class=\"bt bb p-30 grey-50-bg\"><div \nclass=\"h3 pb-10 light-blue-fg\">Asistente</div><div flex=\"100\" class=\"pt-30 pb-5\"><md-input-container \nclass=\"no-padding no-margin all-width\"><label>Seleccionar asistente</label><md-autocomplete ng-disabled=\"vm.loading\" \nmd-selected-item=\"vm.selectedAssitant\" md-search-text-change=\"searchAssitantTextChange(searchAssistant)\" \nmd-search-text=\"searchAssistant\" md-selected-item-change=\"vm.selectedAssistantChange(item)\" \nmd-items=\"item in vm.assistantQuerySearch(searchAssistant) | orderBy : \'name\'\" \nmd-item-text=\"item.name | capitalize:true\" md-min-length=\"0\" placeholder=\"Escribe para empezar a buscar\">\n<md-item-template><span md-highlight-text=\"searchAssistant\" md-highlight-flags=\"^i\">{{item.name | capitalize:true}}\n</span></md-item-template><md-not-found>No se encontraron coincidencias con la palabra \"{{searchAssistant}}\"\n</md-not-found></md-autocomplete><div class=\"pt-8 pb-20 red-fg h6\" ng-if=\"vm.errors.aprobador_id\">\n{{vm.errors.assistant}}</div></md-input-container></div></div><div class=\"p-30\"><div class=\"h3 pb-10 light-blue-fg\">\nDatos adicionales</div><div class=\"all-width pt-10 pb-10\" input-generator field=\"field\" fieldname=\"key\" \nmodel=\"vm.extraFields\" value=\"vm.approver.extra_data[key]\" \nng-repeat=\"(key, field) in vm.data.campos_extra_aprobadores\"></div></div><div class=\"pt-5 pb-5 red-fg text-center\" \nng-if=\"vm.errors.general\">{{vm.errors.general}}</div></div></md-content><md-dialog-actions class=\"bt\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.save()\" aria-label=\"Cancelar\" ng-disabled=\"vm.loading\" \nclass=\"md-raised md-accent white-fg h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/config/approvers/dialogs/remove-colaborator.html","<md-dialog class=\"w-380\" aria-label=\"Remove approver\"><form name=\"removeForm\"><md-toolbar class=\"md-accent white-text\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\">\n<h3>{{vm.title}}</h3></div><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content flex ms-scroll><div flex=\"100\" \nclass=\"p-30\" layout=\"column\" layout-align><div ng-bind-html=\"vm.content\"></div></div></md-content><md-dialog-actions \nclass=\"bt\" layout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" \naria-label=\"Cancelar\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"p-5\"><md-button ng-click=\"vm.remove()\" aria-label=\"button\" type=\"submit\" \nng-disabled=\"vm.loading\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/requester/new-request/dialogs/add-employee.html","<md-dialog class=\"\" aria-label=\"Add employee\"><md-toolbar class=\"md-accent white-text\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\"><h3>\nSeleccionar ocupante actual del cargo <strong>{{vm.values.cargo_ocupar}}</strong></h3></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-content flex ms-scroll><div flex=\"100\" class=\"p-20\"><div class=\"all-width\" \ninput-generator field=\"vm.field\" value=\"vm.value\" fieldname=\"vm.field.name\" model=\"vm.values\" index=\"vm.index\" \noptions=\"vm.lists[vm.field.options]\"></div><div ng-if=\"vm.errors[field]\" class=\"p-5 h6 red-500-fg\">{{vm.errors[field]}}\n</div></div></md-content><md-dialog-actions class=\"bt\" layout=\"row\" layout-align=\"center center\" layout-wrap><div \nclass=\"pl-8 pr-8\"><md-button ng-click=\"vm.cancel()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"pl-8 pr-8\"><md-button ng-click=\"vm.confirm()\" aria-label=\"Aceptar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/requester/requests/dialogs/select-type-new-request.html","<md-dialog class=\"w-500\" aria-label=\"Add employee\"><form name=\"typeRequest\"><md-toolbar class=\"md-accent white-text\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\">\n<h3>Nueva requisición</h3></div><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content flex ms-scroll><div \nng-if=\"vm.listCountry\" flex=\"100\" class=\"pt-30 pl-30 pr-30 pb-8\" layout=\"column\" layout-align><div flex=\"100\" \nclass=\"pt-8 pb-8\"><md-input-container class=\"no-padding no-margin all-width\"><label>País de trabajo</label><md-select \nng-model=\"vm.countryProcess\" required><md-option ng-repeat=\"item in vm.listCountry \" ng-value=\"item.id\">\n{{item.name | capitalizeFirstLetter }}</md-option></md-select></md-input-container></div><div \nng-if=\"vm.countryProcess != undefined\" flex=\"100\" class=\"pt-8 pb-8 h6 grey-fg\">{{vm.countryProcess.description}}</div>\n</div><div flex=\"100\" class=\"pt-8 pl-30 pr-30 pb-8\" layout=\"column\" layout-align><div flex=\"100\" class=\"pt-8 pb-8\">\n<md-input-container class=\"no-padding no-margin all-width\"><label>Seleccione el tipo de requisición</label><md-select \nng-model=\"vm.requestType\"><md-option ng-repeat=\"(key, item) in vm.requestTypes | orderBy: \'name\' track by $index\" \nng-disabled=\"vm.checkAvailability(1, item)\" ng-value=\"item\">{{item.name | capitalizeFirstLetter }}</md-option>\n</md-select></md-input-container></div><div ng-if=\"vm.requestType != undefined\" flex=\"100\" \nclass=\"pt-8 pb-8 h6 grey-fg\">{{vm.requestType.description}}</div></div><div ng-if=\"vm.extraRequests.length\" flex=\"100\" \nclass=\"pt-8 pl-30 pr-30 pb-8\" layout=\"column\" layout-align><div flex=\"100\" class=\"pt-8 pb-8\"><md-input-container \nclass=\"no-padding no-margin all-width\"><label>Trámite adicional 1 (opcional)</label><md-select \nng-model=\"vm.extraType1\"><md-option ng-repeat=\"(key, item) in vm.extraRequests | orderBy: \'name\' track by $index\" \nng-disabled=\"vm.checkAvailability(2, item)\" ng-value=\"item\">{{item.name | capitalizeFirstLetter }}</md-option>\n</md-select></md-input-container></div><div ng-if=\"vm.extraType1 != undefined\" flex=\"100\" class=\"pt-8 pb-8 h6 grey-fg\">\n{{vm.extraType1.description}}</div></div><div ng-if=\"vm.extraRequests.length\" flex=\"100\" \nclass=\"pt-8 pl-30 pr-30 pb-30\" layout=\"column\" layout-align><div flex=\"100\" class=\"pt-8 pb-8\"><md-input-container \nclass=\"no-padding no-margin all-width\"><label>Trámite adicional 2 (opcional)</label><md-select \nng-model=\"vm.extraType2\"><md-option ng-repeat=\"(key, item) in vm.extraRequests | orderBy: \'name\' track by $index\" \nng-disabled=\"vm.checkAvailability(3, item)\" ng-value=\"item\">{{item.name | capitalizeFirstLetter }}</md-option>\n</md-select></md-input-container></div><div ng-if=\"vm.extraType2 != undefined\" flex=\"100\" class=\"pt-8 pb-8 h6 grey-fg\">\n{{vm.extraType2.description}}</div></div></md-content><md-dialog-actions class=\"bt\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.confirm()\" aria-label=\"Anular\" type=\"submit\" \nng-disabled=\"vm.requestType == undefined || vm.countryProcess == undefined \" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/requester/show-request/partials/content.html","<div ng-repeat=\"block in vm.blocks\"><div ng-include=\"\'app/main/templates/request/blocks/read/\' + block.type + \'.html\'\" \nonload=\"item = block\"></div></div>");
$templateCache.put("app/main/admin/requester/show-request/partials/sidebar.html","<div class=\"grey-100-bg\"><div class=\"grey-200-bg\"><div class=\"h5 grey-700-fg p-15\">Estado actual de la solicitud</div>\n<div class=\"pl-15 pr-15 pb-20\"><span ng-style=\"{background: vm.data.data.estado_aprobacion_color}\" \nclass=\"text-boxed white-fg h6 no-margin font-weight-200 radius-15\">{{vm.data.data.estado_aprobacion_label}}</span>\n</div><div ng-if=\"vm.data.rechazo.motivo_rechazo\" class=\"bt p-15 white-bg\"><div class=\"h4 text-bold\">\n{{vm.data.rechazo.motivo_rechazo}}</div><div class=\"h6 pre-line\">{{vm.data.rechazo.observaciones_rechazo}}</div><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h6 pt-8 grey-fg text-right\">\n{{vm.data.rechazo.colaborador_name | capitalize: true}}</div><div class=\"h6 pt-8 grey-fg text-right\">\n{{vm.data.rechazo.fecha_rechazo | fecha: \'DD/MMMM/YYYY\'}}</div></div></div><div \nng-if=\"vm.data.rechazo.observaciones_devolucion\" class=\"bt p-15 white-bg\"><div class=\"h4 text-bold\">\nObservaciones de devolución</div><div class=\"h5 pre-line\">{{vm.data.rechazo.observaciones_devolucion}}</div><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h6 pt-8 grey-fg text-right\">\n{{vm.data.rechazo.colaborador_name | capitalize: true}}</div><div class=\"h6 pt-8 grey-fg text-right\">\n{{vm.data.rechazo.fecha_devolucion | fecha: \'DD/MMMM/YYYY\'}}</div></div></div></div><div class=\"\"><div \nng-if=\"vm.data.options.undoApprove\" class=\"pt-10 pb-10 pl-15 pr-15 green-400-bg\" layout=\"column\" flex=\"100\"><div \nclass=\"text-center h2 pt-8 pb-8 white-fg\">Requisición aprobada</div><div class=\"text-right h6 pt-5 pb-5\"><md-button \nng-click=\"vm.undoApproveRequest()\" \nclass=\"md-raised all-width h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Deshacer\n</md-button></div></div><div ng-if=\"vm.data.options.aprobar\" class=\"pt-10 pb-10 pl-15 pr-15\" layout=\"row\" flex=\"100\">\n<md-button ng-click=\"vm.openApproveRequestDialog()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Aprobar</md-button>\n</div><div ng-if=\"vm.data.options.devolver\" class=\"pt-10 pb-10 pl-15 pr-15\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.openGiveBackRequestDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Devolver</md-button></div>\n<div ng-if=\"vm.data.options.rechazar\" class=\"pt-10 pb-10 pl-15 pr-15\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.openDismissRequestDialog($event)\" \nclass=\"md-raised red-600-bg white-fg h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Rechazar\n</md-button></div><div ng-if=\"vm.data.options.undoDismiss\" class=\"pt-10 pb-10 pl-15 pr-15 red-600-bg\" layout=\"column\" \nflex=\"100\"><div class=\"text-center h2 pt-8 pb-8 white-fg\">Requisición rechazada</div><div \nclass=\"text-right h6 pt-5 pb-5\"><md-button ng-click=\"vm.undoDismissRequest()\" \nclass=\"md-raised b h6 all-width h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Deshacer\n</md-button></div></div><div ng-if=\"vm.data.options.anular\" class=\"pt-10 pb-10 pl-15 pr-15\" layout=\"row\" flex=\"100\">\n<md-button ng-click=\"vm.openCancelRequestDialog()\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Eliminar</md-button>\n</div><div ng-if=\"vm.data.options.update\" class=\"pt-10 pb-10 pl-15 pr-15\" layout=\"row\" flex=\"100\"><md-button \nng-click=\"vm.update()\" \nclass=\"md-raised md-primary h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Modificar\n</md-button></div><div ng-if=\"vm.data.options.enviar_aprobacion\" class=\"pt-10 pb-10 pl-15 pr-15\" layout=\"row\" \nflex=\"100\"><md-button ng-click=\"vm.sendRequest()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Enviar solicitud\n</md-button></div></div><div ng-if=\"vm.data.aprobadores.listado.length\" class=\"p-15 bt bb\"><div \nclass=\"h5 grey-700-fg pb-8\">Ruta de aprobación</div><div class=\"all-width\"><div \nng-repeat=\"approver in vm.data.aprobadores.listado\" class=\"pt-5 pb-5\" layout=\"row\" layout-align=\"space-between\" \nlayout-wrap><div class=\"grey-500-fg p-5\" layout=\"row\" layout-align=\"space-between center\"><div flex \nng-class=\"vm.getIndicatorColor(approver.estado)\" class=\"circle w-8 h-8 mr-10\"></div><div><div class=\"grey-500-fg h5\">\n{{vm.displayCorrectApprover(approver) | capitalize:true}}</div><div \nng-if=\"approver.ejecutor_id && approver.ejecutor_id != approver.colaborador_id\" class=\"grey-500-fg font-weight-300 h6\">\nEn reemplazo de:<br>{{approver.colaborador | capitalize:true}}</div><div class=\"grey-500-fg font-weight-300 h6\">\n{{approver.rol_label | capitalizeFirstLetter:true}}</div><div class=\"grey-500-fg font-weight-200 h6\">\n{{approver.fecha_aprobacion | fecha: \'DD/MMMM/YYYY\'}}</div></div></div><div flex class=\"grey-400-fg h6 p-5 text-right\">\n{{approver.estado_label}}</div></div></div></div><div ng-if=\"vm.data.aprobadores.listado.length\" class=\"p-15 bb\" \nlayout=\"row\" layout-wrap><div flex=\"50\" ng-repeat=\"(key, status) in vm.data.aprobadores.estados_aprobacion\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"circle w-8 h-8 m-5\" ng-class=\"vm.getIndicatorColor(key)\"></div>\n<div class=\"p-5\">{{status}}</div></div></div><div ng-if=\"vm.data.analista\" class=\"p-15 bt bb\"><div \nclass=\"h5 grey-500-fg pb-8\">Responsable de selección</div><div class=\"all-width\"><div class=\"pt-5 pb-5\" layout=\"row\" \nlayout-align=\"space-between\" layout-wrap><div class=\"grey-500-fg\" layout=\"row\" layout-align=\"space-between center\">\n<div><div class=\"grey-900-fg h3 w-180 text-truncate\">{{vm.data.analista.name | capitalize:true}}</div></div></div>\n</div></div></div><div ng-if=\"vm.extra.fecha_solicitud\" class=\"p-15 bb\" layout=\"column\" layout-align=\"center center\">\n<div class=\"h1 bold-text\">{{vm.extra.fecha_solicitud | fecha: \'DD/MMMM/YYYY\'}}</div><div class=\"h6 grey-fg\">\nFecha de solicitud</div></div><div ng-if=\"vm.extra.dias_solicitud\" class=\"p-15\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"h1 bold-text\">{{vm.extra.dias_solicitud}}</div><div class=\"h6 grey-fg\"><span \nng-if=\"vm.extra.dias_solicitud == 0\">Días</span><span ng-if=\"vm.extra.dias_solicitud == 1\">Día</span><span \nng-if=\"vm.extra.dias_solicitud > 1\">Días</span> de solicitud</div></div></div>");
$templateCache.put("app/main/admin/requester/update-request/dialogs/divide-request.html","<md-dialog class=\"w-350\" aria-label=\"Add employee\"><form name=\"form\"><md-toolbar class=\"md-accent white-text\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><div class=\"p-10\"><h3>\n¿Dividir requisición?</h3></div><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"back button\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content flex ms-scroll class=\"p-30\">\n<div flex=\"100\" class=\"pb-10 h4 grey-fg\">Esta requisición tiene {{vm.values.no_vacantes}} vacante<span \nng-if=\"vm.values.no_vacantes > 0\">s</span>, desea realizar el cambio para:</div><div flex=\"100\" \nclass=\"pb-10 h4 grey-fg\" layout=\"column\" layout-align><md-input-container><md-select ng-model=\"vm.option\" \naria-label=\"options\"><md-option ng-repeat=\"option in vm.options\" ng-value=\"option.id\">{{option.name}}</md-option>\n</md-select></md-input-container></div><div ng-if=\"vm.option == 2\" flex=\"100\" class=\"\" layout=\"column\" layout-align>\n<div flex=\"100\" class=\"pt-8 pb-20\"><md-input-container class=\"no-padding no-margin all-width\"><label>\nCantidad de vacantes</label><input type=\"number\" name=\"no_vacantes\" min=\"1\" max=\"{{vm.values.no_vacantes - 1}}\" \nng-model=\"vm.form.no_vacantes\" required><div ng-messages=\"form.no_vacantes.$error\"><div ng-message=\"required\">\nEste campo es requerido.</div><div ng-message=\"min\">El valor de este campo debe ser igual o mayor a 1.</div><div \nng-message=\"max\">El valor de este campo debe ser menor a {{vm.values.no_vacantes}}</div></div><div class=\"red-fg pt-5\" \nng-if=\"vm.error\">{{vm.error}}</div></md-input-container></div></div></md-content><md-dialog-actions class=\"bt\" \nlayout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.validate()\" aria-label=\"Anular\" \ntype=\"submit\" ng-disabled=\"form.$invalid || form.$pristine || !vm.option\" \nclass=\"md-accent submit-button md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Aceptar\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/analyst/reports/template/filtros/date_between.html","{{model}}<div layout=\"row\" layout-align=\"space-between center\" class=\"all-width\"><md-datepicker \nng-model=\"vm.filter[filter.key][0]\" md-placeholder=\"Inicio\" md-open-on-focus></md-datepicker><md-datepicker \nng-disabled=\"!vm.filter[filter.key][0]\" md-min-date=\"vm.filter[filter.key][0]\" ng-model=\"vm.filter[filter.key][1]\" \nmd-placeholder=\"Fin\" md-open-on-focus></md-datepicker></div>");
$templateCache.put("app/main/analyst/reports/template/filtros/select.html","{{model}}<md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>{{filter.label}}</label>\n</div><md-select aria-label=\"Seleccionar Etapa\" ng-model=\"vm.filter[filter.key]\" class=\"\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.search.responsable_seleccion\" type=\"search\" \nplaceholder=\"Escribe para buscar\" class=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\">\n</md-select-header><md-option \nng-repeat=\"list in filter.list | filter:vm.search.responsable_seleccion  track by $index\" ng-value=\"list.id\">\n{{list.name | capitalize:true}}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/analyst/reports/template/filtros/text.html","{{model}}<md-input-container class=\"all-width\"><div class=\"h4 grey-fg font-weight-300\"><label>{{filter.label}}</label>\n</div><input type=\"text\" ng-model=\"vm.filter[filter.key]\"></md-input-container>");
$templateCache.put("app/main/candidate/dashboard/dialogs/apply/apply.html","<md-dialog aria-label=\"Notice\" class=\"w-500\"><md-toolbar class=\"h-100 md-accent white-fg md-hue-2\"><div class=\"\" \nlayout=\"column\"><div layout=\"row\" class=\"pl-5 pr-5 pt-5\" flex=\"100\" layout-align=\"end end\"><md-button \nclass=\"md-icon-button no-padding no-margin\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" class=\"pl-20 pr-10 pt-5 pb-8\" flex=\"100\" \nlayout-align=\"start end\"><div ng-bind-html=\"vm.title\"></div></div></div></md-toolbar><md-dialog-content class=\"\" \nng-if=\"!vm.loading\" layout-padding><div ng-if=\"vm.step == 0\" \nng-include=\"\'app/main/candidate/dashboard/dialogs/apply/templates/notice.html\'\"></div><div ng-if=\"vm.step > 0\" \nng-include=\"\'app/main/candidate/dashboard/dialogs/apply/templates/wizard.html\'\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/candidate/dashboard/dialogs/notice/notice.html","<md-dialog aria-label=\"Notice\" class=\"w-500\"><md-toolbar class=\"h-80 green-500-bg white-fg md-hue-2\"><div class=\"\" \nlayout=\"column\"><div layout=\"row\" class=\"pl-5 pr-5 pt-5\" flex=\"100\" layout-align=\"end end\"><md-button \nclass=\"md-icon-button no-padding no-margin\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div><div layout=\"row\" class=\"pl-20 pr-10 pt-5 pb-8\" flex=\"100\" \nlayout-align=\"start end\"><span class=\"h1 text-light-200\">{{vm.title}}</span></div></div></md-toolbar><md-dialog-content\n class=\"\" layout-padding><div>{{vm.applyData.texto_limite_ofertas}}</div><div class=\"text-center p-15\"><span \nng-if=\"vm.applyData.puede_aplicar\" ng-click=\"vm.openApplyDialog($event)\" \nclass=\"light-blue-500-bg white-fg cursor-pointer pl-35 pr-35 pt-8 pb-8\">Continuar</span> <span \nng-if=\"!vm.applyData.puede_aplicar\" ng-click=\"vm.closeDialog()\" \nclass=\"grey-500-bg white-fg cursor-pointer pl-35 pr-35 pt-8 pb-8\">Cerrar</span></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/templates/finalist/blocks/read/one-column-info.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div class=\"p-10\" \nlayout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"column\" layout-md=\"row\" layout-gt-md=\"row\" \nlayout-lg=\"row\" layout-gt-lg=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div \nng-repeat=\"field in item.fields\" \nng-if=\"root.fields[field].label  && vm.validationService.validateShowRequestFields(field, root.data.data)\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{root.fields[field].label}} <span \nng-if=\"root.fields[field].label_help\">({{root.fields[field].label_help}})</span></div><div class=\"grey-fg h6 p-8\">\n{{root.data.data[field] | formatValue : root.fields[field].type : root.lists[root.fields[field].options]}}</div><div \nng-if=\"root.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">{{root.errors[field]}}</div></div><div class=\"p-10\" \nflex-md=\"30\" flex-gt-md=\"30\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/blocks/read/one-column.html","<div layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" ng-class=\"{\'bb\' : !$last}\" \nlayout=\"column\" flex=\"100\" class=\"pl-5 pr-5 pt-10 pb-10\"><div class=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">\n{{root.fields[field].label}} <span ng-if=\"root.fields[field].label_help\">({{root.fields[field].label_help}})</span>\n</div><div ng-class=\"{\'pre-line\': root.fields[field].type == \'textarea\'}\" class=\"grey-fg h6 p-8\" \nng-bind-html=\"root.data.data[field] | formatValue : root.fields[field].type : root.lists[root.fields[field].options]\">\n</div><div ng-if=\"root.fields[field].type == \'matriz\'\"><div class=\"all-width\" input-generator \nfield=\"root.fields[field]\" fieldname=\"field\" value=\"root.data.data[field]\" model=\"root.values\" block=\"item.model\" \nidblock=\"item.id\" attachments=\"root.attachments\" options=\"root.lists[root.fields[field].options]\" extra=\"root.extra\" \nreadonly=\"true\"></div></div><dl ng-show=\"root.attachments[field].length\" ng-init=\"vm.validateAttachment(field,root)\">\n<dd class=\"p-8 m-5 grey-300-bg b\" ng-repeat=\"attach in root.attachments[field]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span> <span \nclass=\"icon-download cursor-pointer grey-500-fg\" ng-click=\"vm.getAttachmentUrl(attach)\"><md-tooltip md-direction=\"top\">\nDescargar</md-tooltip></span></div></dd></dl><div ng-if=\"vm.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">\n{{vm.errors[field]}}</div></div></div>");
$templateCache.put("app/main/templates/finalist/blocks/read/select-current-employee.html","");
$templateCache.put("app/main/templates/finalist/blocks/read/two-column-multiple-rows.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div \nng-repeat=\"(modelKey, values) in root.data.data[item.model]\" class=\"bb pl-20 pr-20 pt-20 pb-30\" layout=\"row\" \nflex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div \nng-repeat=\"(keyFieldData, fieldData) in root.fields[item.model]\" ng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" \nclass=\"pl-10 pr-10\"><div class=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{fieldData.label}} <span \nng-if=\"fieldData.label_help\">({{fieldData.label_help}})</span></div><div \nng-class=\"{\'pre-line\': fieldData.type == \'textarea\'}\" class=\"grey-fg h6 p-8\"><div \nng-bind-html=\"values[keyFieldData] | formatValue : root.fields[item.model][keyFieldData].type : root.lists[root.fields[item.model][keyFieldData].options]\">\n</div></div><div ng-if=\"root.errors[field]\" class=\"p-5 h6 red-500-fg\">{{root.errors[field]}}</div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/blocks/read/two-columns.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/block-generic/block-title.html\'\"></div><div class=\"p-20\" \nlayout=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div ng-repeat=\"field in item.fields\" \nng-if=\"root.fields[field].label && vm.validationService.validateShowRequestFields(field, root.data.data)\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{root.fields[field].label}} <span \nng-if=\"root.data.original_data[field]\" class=\"text-strike grey-fg pr-5 pl-5\"><span \nng-bind-html=\"root.data.original_data[field] | formatValue : root.fields[field].type : root.lists[root.fields[field].options]\">\n</span></span></div><div ng-class=\"{\'pre-line\': root.fields[field].type == \'textarea\'}\" class=\"grey-fg h6 p-8\"><div \nng-bind-html=\"root.data.data[field] | formatValue : root.fields[field].type : root.lists[root.fields[field].options]\">\n</div></div><dl ng-show=\"root.attachments[field].length\" ng-init=\"vm.validateAttachment(field)\"><dd \nclass=\"p-8 m-5 grey-300-bg b\" ng-repeat=\"attach in root.attachments[field]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span> <span \nclass=\"icon-download cursor-pointer grey-500-fg\" ng-click=\"root.getAttachmentUrl(attach)\"><md-tooltip \nmd-direction=\"top\">Descargar</md-tooltip></span></div></dd></dl><div ng-if=\"root.errors[field]\" \nclass=\"pl-8 pr-8 pb-8 red-fg\">{{root.errors[field]}}</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/blocks/update/one-column-info.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-10 pr-10 pt-10 pb-20\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" flex=\"100\" layout-wrap><div class=\"p-10\" \nflex-md=\"70\" flex-gt-md=\"70\" flex-lg=\"70\" flex-gt-lg=\"70\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[field]\" fieldname=\"field\" \nvalue=\"vm.data.data[field]\" model=\"vm.values\" block=\"item.model\" idblock=\"item.id\" \noptions=\"vm.lists[vm.fields[field].options]\"></div><div ng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">\n{{vm.errors[field]}}</div></div></div><div ng-if=\"vm.values.title\" class=\"p-10\" flex-md=\"30\" flex-gt-md=\"30\" \nflex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap><div class=\"h4 pl-10 pr-10 pt-5 pb-5\">Descripción del trámite a realizar</div>\n<div class=\"grey-50-bg p-10 b\"><div class=\"font-weight-600 h5\">{{vm.values.title}}</div><div class=\"h6\">\n{{vm.values.desc}}</div></div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/blocks/update/one-column.html","<div layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" id=\"{{field}}\" flex=\"100\"><div \nng-if=\"root.fields[field].label  && vm.validationService.validateShowRequestFields(field, root.data.data)\" \nclass=\"all-width\" input-generator field=\"root.fields[field]\" fieldname=\"field\" value=\"root.data.data[field]\" \nmodel=\"root.values\" block=\"item.model\" idblock=\"item.id\" options=\"root.lists[root.fields[field].options]\"></div><div \nng-if=\"root.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{root.errors[field]}}</div></div></div>");
$templateCache.put("app/main/templates/finalist/blocks/update/select-current-employee.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap id=\"\"><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.getVacants().length && vm.checkEmptyObject(vm.lists.position_colaborators) == false\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div ng-repeat=\"value in vm.values[field]\" \nng-if=\"vm.lists[vm.fields[field].options][value].name\" ng-class=\"{\'bb\' : !$last, \'pt-15\' : !$first}\" class=\"pb-15\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\"><div class=\"pb-10 pr-10\"><div class=\"h3 text-bold\"><span \nng-if=\"vm.lists[vm.fields[field].options][value].cod_empleado\">\n{{vm.lists[vm.fields[field].options][value].cod_empleado}} - </span>\n{{vm.lists[vm.fields[field].options][value].name | capitalize:true}}</div><div class=\"h5\" \nng-if=\"vm.lists[vm.fields[field].options][value].cargo\">{{vm.lists[vm.fields[field].options][value].cargo}}</div></div>\n<div ng-if=\"vm.fields[field].permiso\" class=\"pb-10 pr-10\"><a href=\"#\" \nng-click=\"vm.openSetEmployeesDialog($event, $index, field, vm.fields[field])\">Cambiar</a></div></div></div><dl \nclass=\"no-margin no-padding\"><dd ng-if=\"vm.values[field][$index] == undefined\" ng-repeat=\"value in vm.getVacants()\"><a \nhref=\"#\" ng-click=\"vm.openSetEmployeesDialog($event, $index, field, vm.fields[field])\">\nSeleccionar persona a reemplazar o sujeta a modificación {{value + 1}}</a></dd></dl><div ng-if=\"vm.errors[field]\" \nclass=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div><div \nng-if=\"!vm.getVacants().length || vm.checkEmptyObject(vm.lists.position_colaborators) == true\"><div \nclass=\"pl-10 pr-10 h5 grey-fg\">Por favor seleccione el cargo y cantidad de vacantes.</div><div \nclass=\"pl-10 pr-10 h6 red-500-fg\">Este campo es obligatorio</div></div></div><div \nng-if=\"!vm.getVacants().length || vm.checkEmptyObject(vm.lists.position_colaborators) == true\"><div \nclass=\"pl-10 pr-10 h5 grey-fg\">Por favor seleccione el cargo y cantidad de vacantes.</div><div \nclass=\"pl-10 pr-10 h6 red-500-fg\">Este campo es obligatorio</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/blocks/update/two-column-multiple-rows.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div ng-if=\"item.notes\" \nmd-colors=\"{\'background-color\': \'primary\'}\" class=\"p-15 ml-30 mr-30 mt-20 mb-5 white-fg\"><span \nclass=\"icon-alert-circle\"></span> <span>{{item.notes}}</span></div><div \nng-repeat=\"(modelKey, model) in vm.values[item.model]\" ng-class=\"{\'bb\':!$last}\"><div class=\"pl-20 pr-20 pt-20 pb-30\" \nlayout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"(field, value) in model\" \nng-if=\"vm.fields[item.model][field].label\" id=\"{{field}}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" \nflex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div class=\"all-width\" \ninput-generator field=\"vm.fields[item.model][field]\" fieldname=\"field\" model=\"vm.values[item.model][modelKey]\" \nvalue=\"vm.values[item.model][modelKey][field]\" block=\"item.model\" idblock=\"item.id\" \noptions=\"vm.lists[vm.fields[item.model][field].options]\"></div><div ng-if=\"vm.errors[field]\" \nclass=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div><div ng-if=\"$index > 0\" \nclass=\"pt-5 pb-20 pr-40 pl-40\" layout=\"row\" layout-align=\"end center\"><div \nng-click=\"vm.removeModelToBlock(item, $index)\" class=\"cursor-pointer grey-500-fg\"><i class=\"icon-trash s25\"></i></div>\n</div></div><div class=\"pt-20 pb-20 pr-40 pl-40\" layout=\"row\" layout-align=\"end center\"><div \nng-click=\"vm.addModelToBlock(item)\" class=\"cursor-pointer blue-fg\"><i class=\"icon-plus-circle s50\"></i></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/finalist/blocks/update/two-columns.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div ng-if=\"item.notes\" \nmd-colors=\"{\'background-color\': \'primary\'}\" class=\"p-15 ml-30 mr-30 mt-20 mb-5 white-fg\"><span \nclass=\"icon-alert-circle\"></span> <span>{{item.notes}}</span></div><div class=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" \nflex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" id=\"{{field}}\" flex-xs=\"100\" flex-gt-xs=\"100\" \nflex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"all-width\" input-generator field=\"root.fields[field]\" fieldname=\"field\" value=\"root.data.data[field]\" \nmodel=\"root.values\" block=\"item.model\" idblock=\"item.id\" options=\"root.lists[root.fields[field].options]\"></div><div \nng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div></ms-widget-front>\n</ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/autocomplete/one-column-info.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/resume/shared/block-title-selected.html\'\"></div><div \nclass=\"p-10\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"column\" layout-md=\"row\" \nlayout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label  && vm.validationService.validateShowRequestFields(field, vm.data.data)\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{vm.fields[field].label}} <span \nng-if=\"vm.fields[field].label_help\">({{vm.fields[field].label_help}})</span></div><div class=\"grey-fg h6 p-8\">\n{{vm.data.data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]}}</div><div \nng-if=\"vm.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">{{vm.errors[field]}}</div></div><div class=\"p-10\" flex-md=\"30\" \nflex-gt-md=\"30\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/autocomplete/one-column.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title-selected.html\'\"></div><div \nclass=\"p-20\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" \nng-class=\"{\'bb\' : !$last}\" layout=\"column\" flex=\"100\" class=\"pl-5 pr-5 pt-10 pb-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{vm.fields[field].label}} <span \nng-if=\"vm.fields[field].label_help\">({{vm.fields[field].label_help}})</span></div><div \nng-class=\"{\'pre-line\': vm.fields[field].type == \'textarea\'}\" class=\"grey-fg h6 p-8\" \nng-bind-html=\"vm.data.data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]\"></div>\n<div ng-if=\"vm.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">{{vm.errors[field]}}</div></div></div></ms-widget-front>\n</ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/autocomplete/two-column-multiple-rows.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title-selected.html\'\"></div><div \nng-repeat=\"(modelKey, values) in vm.data.data[item.model]\" class=\"bb pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" \nlayout-wrap><div ng-repeat=\"(keyFieldData, fieldData) in vm.fields[item.model]\" ng-class=\"{\'bt\' : $index > 1}\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div class=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{fieldData.label}} <span \nng-if=\"fieldData.label_help\">({{fieldData.label_help}})</span></div><div \nng-class=\"{\'pre-line\': fieldData.type == \'textarea\'}\" class=\"grey-fg h6 p-8\"><div ng-bind-html=\"values[keyFieldData]\">\n</div></div><div ng-if=\"vm.errors[field]\" class=\"p-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/autocomplete/two-columns.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title-selected.html\'\"></div><div \nclass=\"p-20\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{vm.fields[field].label}} <span \nng-if=\"vm.data.original_data[field]\" class=\"text-strike grey-fg pr-5 pl-5\"><span \nng-if=\"vm.data.original_data[field + \'_lista\']\" \nng-bind-html=\"vm.data.original_data[field] | formatValue : vm.fields[field].type : vm.data.original_data[field + \'_lista\']\">\n</span> <span ng-if=\"!vm.data.original_data[field + \'_lista\']\" \nng-bind-html=\"vm.data.original_data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]\">\n</span></span></div><div ng-class=\"{\'pre-line\': vm.fields[field].type == \'textarea\'}\" class=\"grey-fg h6 p-8\"><div \nng-bind-html=\"vm.data.data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]\"></div>\n</div><div ng-if=\"vm.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">{{vm.errors[field]}}</div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/create/one-column-info.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-10 pr-10 pt-10 pb-20\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" flex=\"100\" layout-wrap><div class=\"p-10\" \nflex-md=\"70\" flex-gt-md=\"70\" flex-lg=\"70\" flex-gt-lg=\"70\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[field]\" fieldname=\"field\" \nmodel=\"vm.values\" block=\"item.model\" idblock=\"item.id\" options=\"vm.lists[vm.fields[field].options]\"></div><div \nng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div><div \nng-if=\"vm.values.title\" class=\"p-10\" flex-md=\"30\" flex-gt-md=\"30\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap><div \nclass=\"h4 pl-10 pr-10 pt-5 pb-5\">Descripción del trámite a realizar</div><div class=\"grey-50-bg p-10 b\"><div \nclass=\"font-weight-600 h5\">{{vm.values.title}}</div><div class=\"h6\">{{vm.values.desc}}</div></div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/create/one-column.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[field]\" fieldname=\"field\" \nmodel=\"vm.values\" block=\"item.model\" idblock=\"item.id\" options=\"vm.lists[vm.fields[field].options]\"></div><div \nng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div></ms-widget-front>\n</ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/create/select-current-employee.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap id=\"\"><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.getVacants().length && vm.checkEmptyObject(vm.lists.position_colaborators) == false\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div ng-repeat=\"value in vm.values[field]\" \nng-if=\"vm.lists[vm.fields[field].options][value].name\" ng-class=\"{\'bb\' : !$last, \'pt-15\' : !$first}\" class=\"pb-15\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div layout=\"row\" flex=\"100\" \nlayout-align=\"space-between center\"><div class=\"pb-10 pr-10\"><div class=\"h3 text-bold\"><span \nng-if=\"vm.lists[vm.fields[field].options][value].cod_empleado\">\n{{vm.lists[vm.fields[field].options][value].cod_empleado}} - </span>\n{{vm.lists[vm.fields[field].options][value].name | capitalize:true}}</div><div class=\"h5\" \nng-if=\"vm.lists[vm.fields[field].options][value].cargo\">{{vm.lists[vm.fields[field].options][value].cargo}}</div></div>\n<div ng-if=\"vm.fields[field].permiso\" class=\"pb-10 pr-10\"><a href=\"#\" \nng-click=\"vm.openSetEmployeesDialog($event, $index, field, vm.fields[field])\">Cambiar</a></div></div></div><dl \nclass=\"no-margin no-padding\"><dd ng-if=\"vm.values[field][$index] == undefined\" ng-repeat=\"value in vm.getVacants()\"><a \nhref=\"#\" ng-click=\"vm.openSetEmployeesDialog($event, $index, field, vm.fields[field])\">\nSeleccionar persona a reemplazar o sujeta a modificación {{value + 1}}</a></dd></dl><div ng-if=\"vm.errors[field]\" \nclass=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div><div \nng-if=\"!vm.getVacants().length || vm.checkEmptyObject(vm.lists.position_colaborators) == true\"><div \nclass=\"pl-10 pr-10 h5 grey-fg\">Por favor seleccione el cargo y cantidad de vacantes.</div><div \nclass=\"pl-10 pr-10 h6 red-500-fg\">Este campo es obligatorio</div></div></div><div \nng-if=\"!vm.getVacants().length || vm.checkEmptyObject(vm.lists.position_colaborators) == true\"><div \nclass=\"pl-10 pr-10 h5 grey-fg\">Por favor seleccione el cargo y cantidad de vacantes.</div><div \nclass=\"pl-10 pr-10 h6 red-500-fg\">Este campo es obligatorio</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/create/two-column-multiple-rows.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div ng-if=\"item.notes\" \nmd-colors=\"{\'background-color\': \'primary\'}\" class=\"p-15 ml-30 mr-30 mt-20 mb-5 white-fg\"><span \nclass=\"icon-alert-circle\"></span> <span>{{item.notes}}</span></div><div \nng-repeat=\"(modelKey, model) in vm.values[item.model]\"><div class=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" \nlayout-wrap><div ng-repeat=\"(field, value) in model\" ng-if=\"vm.fields[item.model][field].label\" id=\"{{field}}\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[item.model][field]\" \nfieldname=\"field\" model=\"vm.values[item.model][modelKey]\" value=\"vm.values[item.model][modelKey][field]\" \nblock=\"item.model\" idblock=\"item.id\" options=\"vm.lists[vm.fields[item.model][field].options]\"></div><div \nng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div><div \nng-if=\"$index > 0\" class=\"pt-5 pb-20 pr-40 pl-40\" layout=\"row\" layout-align=\"end center\"><div \nng-click=\"vm.removeModelToBlock(item, $index)\" class=\"cursor-pointer red-fg\">Eliminar</div></div></div><div \nclass=\"pt-20 pb-20 pr-40 pl-40\" layout=\"row\" layout-align=\"end center\"><div ng-click=\"vm.addModelToBlock(item)\" \nclass=\"cursor-pointer blue-fg\">Agregar otro</div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/create/two-columns.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div ng-if=\"item.notes\" \nmd-colors=\"{\'background-color\': \'primary\'}\" class=\"p-15 ml-30 mr-30 mt-20 mb-5 white-fg\"><span \nclass=\"icon-alert-circle\"></span> <span>{{item.notes}}</span></div><div class=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" \nflex=\"100\" layout-wrap><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label  && vm.validationService.validateShowRequestFields(field, vm.data.data)\" id=\"{{field}}\" \nflex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" \nflex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[field]\" fieldname=\"field\" \nmodel=\"vm.values\" value=\"vm.values[field]\" block=\"item.model\" idblock=\"item.id\" \noptions=\"vm.lists[vm.fields[field].options]\"></div><div ng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">\n{{vm.errors[field]}}</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/read/one-column-info.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/resume/shared/block-title.html\'\"></div><div class=\"p-10\" \nlayout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"column\" layout-md=\"row\" layout-gt-md=\"row\" \nlayout-lg=\"row\" layout-gt-lg=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div \nng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label  && vm.validationService.validateShowRequestFields(field, vm.data.data)\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{vm.fields[field].label}} <span \nng-if=\"vm.fields[field].label_help\">({{vm.fields[field].label_help}})</span></div><div class=\"grey-fg h6 p-8\">\n{{vm.data.data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]}}</div><div \nng-if=\"vm.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">{{vm.errors[field]}}</div></div><div class=\"p-10\" flex-md=\"30\" \nflex-gt-md=\"30\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/read/one-column.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div class=\"p-20\" \nlayout=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" \nng-class=\"{\'bb\' : !$last}\" layout=\"column\" flex=\"100\" class=\"pl-5 pr-5 pt-10 pb-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{vm.fields[field].label}} <span \nng-if=\"vm.fields[field].label_help\">({{vm.fields[field].label_help}})</span></div>{{vm.fields[field].field_extra}}<div \nng-class=\"{\'pre-line\': vm.fields[field].type == \'textarea\'}\" class=\"grey-fg h6 p-8\" \nng-bind-html=\"vm.fields[field].field_text ? vm.data.data[vm.fields[field].field_text] : vm.fields[field].field_extra ? vm.data.data[vm.fields[field].field_extra] : vm.data.data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]\">\n</div><dl ng-show=\"vm.attachments[field].length\" ng-init=\"vm.validateAttachment(field)\"><dd \nclass=\"p-8 m-5 grey-300-bg b\" ng-repeat=\"attach in vm.attachments[field]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span> <span \nclass=\"icon-download cursor-pointer grey-500-fg\" ng-click=\"vm.getAttachmentUrl(attach)\"><md-tooltip md-direction=\"top\">\nDescargar</md-tooltip></span></div></dd></dl><div ng-if=\"vm.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">\n{{vm.errors[field]}}</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/read/select-current-employee.html","");
$templateCache.put("app/main/templates/request/blocks/read/two-column-multiple-rows.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nng-repeat=\"(modelKey, values) in vm.data.data[item.model]\" class=\"bb pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" \nlayout-wrap ng-show=\"!item.hideCollapse\"><div ng-repeat=\"(keyFieldData, fieldData) in vm.fields[item.model]\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{fieldData.label}} <span ng-if=\"fieldData.label_help\">\n({{fieldData.label_help}})</span></div><div ng-class=\"{\'pre-line\': fieldData.type == \'textarea\'}\" \nclass=\"grey-fg h6 p-8\"><div \nng-bind-html=\"values[keyFieldData] | formatValue : vm.fields[item.model][keyFieldData].type : vm.lists[vm.fields[item.model][keyFieldData].options]\">\n</div></div><div ng-if=\"vm.errors[field]\" class=\"p-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/read/two-columns.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div class=\"p-20\" \nlayout=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" \nng-class=\"{\'bt\' : $index > 1}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" \nflex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div \nclass=\"text-bold text-uppercase h6 pt-8 pl-8 pr-8\">{{vm.fields[field].label}} <span \nng-if=\"vm.data.original_data[field]\" class=\"text-strike grey-fg pr-5 pl-5\"><span \nng-if=\"vm.data.original_data[field + \'_lista\']\" \nng-bind-html=\"vm.data.original_data[field] | formatValue : vm.fields[field].type : vm.data.original_data[field + \'_lista\']\">\n</span> <span ng-if=\"!vm.data.original_data[field + \'_lista\']\" \nng-bind-html=\"vm.data.original_data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]\">\n</span></span></div><div ng-class=\"{\'pre-line\': vm.fields[field].type == \'textarea\'}\" class=\"grey-fg h6 p-8\"><div \nng-bind-html=\"vm.fields[field].field_text ? vm.data.data[vm.fields[field].field_text] : vm.fields[field].field_extra ? vm.data.data[vm.fields[field].field_extra] : vm.data.data[field] | formatValue : vm.fields[field].type : vm.lists[vm.fields[field].options]\">\n</div></div><dl ng-show=\"vm.attachments[field].length\" ng-init=\"vm.validateAttachment(field)\"><dd \nclass=\"p-8 m-5 grey-300-bg b\" ng-repeat=\"attach in vm.attachments[field]\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"h6\">{{attach.name}}</span> <span \nclass=\"icon-download cursor-pointer grey-500-fg\" ng-click=\"vm.getAttachmentUrl(attach)\"><md-tooltip md-direction=\"top\">\nDescargar</md-tooltip></span></div></dd></dl><div ng-if=\"vm.errors[field]\" class=\"pl-8 pr-8 pb-8 red-fg\">\n{{vm.errors[field]}}</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/update/one-column-info.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-10 pr-10 pt-10 pb-20\" layout-xs=\"column\" layout-gt-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"column\" \nlayout-md=\"row\" layout-gt-md=\"row\" layout-lg=\"row\" layout-gt-lg=\"row\" flex=\"100\" layout-wrap \nng-show=\"!item.hideCollapse\"><div class=\"p-10\" flex-md=\"70\" flex-gt-md=\"70\" flex-lg=\"70\" flex-gt-lg=\"70\" layout-wrap>\n<div ng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[field]\" fieldname=\"field\" \nvalue=\"vm.data.data[field]\" model=\"vm.values\" block=\"item.model\" idblock=\"item.id\" \noptions=\"vm.lists[vm.fields[field].options]\" extra=\"vm.extra\" showif=\"vm.fields[field].show_if\"></div><div \nng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div><div \nng-if=\"vm.values.title\" class=\"p-10\" flex-md=\"30\" flex-gt-md=\"30\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-wrap><div \nclass=\"h4 pl-10 pr-10 pt-5 pb-5\">Descripción del trámite a realizar</div><div class=\"grey-50-bg p-10 b\"><div \nclass=\"font-weight-600 h5\">{{vm.values.title}}</div><div class=\"h6\">{{vm.values.desc}}</div></div></div></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/update/one-column.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div \nng-repeat=\"field in item.fields\" \nng-if=\"vm.fields[field].label  && vm.validationService.validateShowRequestFields(field.field, vm.data.data)\" \nid=\"{{field}}\" flex=\"100\" class=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[field]\" \nfieldname=\"field\" value=\"vm.data.data[field]\" model=\"vm.values\" block=\"item.model\" idblock=\"item.id\" \noptions=\"vm.lists[vm.fields[field].options]\" attachments=\"vm.attachments\" extra=\"vm.extra\" \nshowif=\"vm.fields[field].show_if\" hvalue=\"vm.data.data[vm.fields[field].field_extra]\"></div><dl \nng-show=\"vm.attachments[field].length\" ng-init=\"vm.validateAttachment(field)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field]\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"h6\">\n{{attach.name}}</span> <span class=\"icon-download cursor-pointer grey-500-fg\" ng-click=\"vm.getAttachmentUrl(attach)\">\n<md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></div></dd></dl><div ng-if=\"vm.errors[field]\" \nclass=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/update/select-current-employee.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap id=\"\"><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div \nclass=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div \nng-repeat=\"field in item.fields\" \nng-if=\"vm.getVacants().length && vm.checkEmptyObject(vm.lists.position_colaborators) == false\" id=\"{{field}}\" \nflex=\"100\" class=\"pl-10 pr-10\"><div ng-repeat=\"value in vm.values[field]\" \nng-if=\"vm.lists[vm.fields[field].options][value].name || vm.lists[vm.fields[field].options+\'_read\'][value].name\" \nng-class=\"{\'bb\' : !$last, \'pt-15\' : !$first}\" class=\"pb-15\" layout=\"row\" layout-align=\"space-between center\" \nlayout-wrap><div layout=\"row\" flex=\"100\" layout-align=\"space-between center\"><div class=\"pb-10 pr-10\"><div \nclass=\"h3 text-bold\"><span ng-if=\"vm.lists[vm.fields[field].options][value].cod_empleado\">\n{{vm.lists[vm.fields[field].options][value].cod_empleado}} - </span>\n{{vm.lists[vm.fields[field].options][value].name | capitalize:true}} <span \nng-if=\"vm.lists[vm.fields[field].options+\'_read\'][value].cod_empleado\">\n{{vm.lists[vm.fields[field].options+\'_read\'][value].cod_empleado}} - </span>\n{{vm.lists[vm.fields[field].options+\'_read\'][value].name | capitalize:true}}</div><div class=\"h5\" \nng-if=\"vm.lists[vm.fields[field].options][value].cargo\">{{vm.lists[vm.fields[field].options][value].cargo}}</div></div>\n<div ng-if=\"vm.fields[field].permiso\" class=\"pb-10 pr-10\"><a href=\"#\" \nng-click=\"vm.openSetEmployeesDialog($event, $index, field, vm.fields[field])\">Cambiar</a></div></div></div><dl \nclass=\"no-margin no-padding\"><dd ng-if=\"vm.values[field][$index] == undefined\" ng-repeat=\"value in vm.getVacants()\"><a \nhref=\"#\" ng-click=\"vm.openSetEmployeesDialog($event, $index, field, vm.fields[field])\">\nSeleccionar persona a reemplazar o sujeta a modificación {{value + 1}}</a></dd></dl><div ng-if=\"vm.errors[field]\" \nclass=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div><div \nng-if=\"!vm.getVacants().length || vm.checkEmptyObject(vm.lists.position_colaborators) == true\"><div \nclass=\"pl-10 pr-10 h5 grey-fg\">Por favor seleccione el cargo y cantidad de vacantes.</div><div \nclass=\"pl-10 pr-10 h6 red-500-fg\">Este campo es obligatorio</div></div></div><div \nng-if=\"!vm.getVacants().length || vm.checkEmptyObject(vm.lists.position_colaborators) == true\"><div \nclass=\"pl-10 pr-10 h5 grey-fg\">Por favor seleccione el cargo y cantidad de vacantes.</div><div \nclass=\"pl-10 pr-10 h6 red-500-fg\">Este campo es obligatorio</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/update/two-column-multiple-rows.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div ng-if=\"item.notes\" \nmd-colors=\"{\'background-color\': \'primary\'}\" class=\"p-15 ml-30 mr-30 mt-20 mb-5 white-fg\"><span \nclass=\"icon-alert-circle\"></span> <span>{{item.notes}}</span></div><div \nng-repeat=\"(modelKey, model) in vm.values[item.model]\" ng-class=\"{\'bb\':!$last}\" ng-show=\"!item.hideCollapse\"><div \nclass=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" flex=\"100\" layout-wrap><div ng-repeat=\"(field, value) in model\" \nng-if=\"vm.fields[item.model][field].label\" id=\"{{field}}\" flex-xs=\"100\" flex-gt-xs=\"100\" flex-sm=\"100\" \nflex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" class=\"pl-10 pr-10\"><div class=\"all-width\" \ninput-generator field=\"vm.fields[item.model][field]\" fieldname=\"field\" model=\"vm.values[item.model][modelKey]\" \nvalue=\"vm.values[item.model][modelKey][field]\" block=\"item.model\" idblock=\"item.id\" \noptions=\"vm.lists[vm.fields[item.model][field].options]\" extra=\"vm.extra\" \nshowif=\"vm.fields[item.model][field].show_if\"></div><div ng-if=\"vm.errors[field]\" class=\"pt-5 pb-5 pr-5 h6 red-500-fg\">\n{{vm.errors[field]}}</div></div></div><div class=\"pt-5 pb-20 pr-40 pl-40\" layout=\"row\" layout-align=\"end center\"><div \nng-click=\"vm.removeModelToBlock(item, $index)\" class=\"cursor-pointer\" md-colors=\"{color: \'warn\'}\"><i \nclass=\"icon-trash s25\"></i></div></div></div><div class=\"pt-20 pb-20 pr-40 pl-40\" layout=\"row\" \nlayout-align=\"end center\" ng-show=\"!item.hideCollapse\"><div ng-click=\"vm.addModelToBlock(item)\" class=\"cursor-pointer\" \nmd-colors=\"{color: \'primary\'}\"><i class=\"icon-plus-circle s25\"></i></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/templates/request/blocks/update/two-columns.html","<div class=\"widget-group p-5\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div ng-include=\"\'app/main/templates/request/blocks/block-title.html\'\"></div><div ng-if=\"item.notes\" \nmd-colors=\"{\'background-color\': \'primary\'}\" class=\"p-15 ml-30 mr-30 mt-20 mb-5 white-fg\"><span \nclass=\"icon-alert-circle\"></span> <span>{{item.notes}}</span></div><div class=\"pl-20 pr-20 pt-20 pb-30\" layout=\"row\" \nflex=\"100\" layout-wrap ng-show=\"!item.hideCollapse\"><div ng-repeat=\"field in item.fields\" id=\"{{field}}\" \nng-if=\"vm.fields[field].label && vm.validationService.validateShowRequestFields(field, vm.data.data)\" flex-xs=\"100\" \nflex-gt-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"100\" flex-md=\"50\" flex-gt-md=\"50\" flex-lg=\"50\" flex-gt-lg=\"50\" \nclass=\"pl-10 pr-10\"><div class=\"all-width\" input-generator field=\"vm.fields[field]\" fieldname=\"field\" \nvalue=\"vm.data.data[field]\" model=\"vm.values\" block=\"item.model\" idblock=\"item.id\" \noptions=\"vm.lists[vm.fields[field].options]\" attachments=\"vm.attachments\" extra=\"vm.extra\" \nshowif=\"vm.fields[field].show_if\" hvalue=\"vm.data.data[vm.fields[field].field_extra]\"></div><dl \nng-show=\"vm.attachments[field].length\" ng-init=\"vm.validateAttachment(field)\"><dd class=\"p-8 m-5 grey-300-bg b\" \nng-repeat=\"attach in vm.attachments[field]\"><div layout=\"row\" layout-align=\"space-between center\"><span class=\"h6\">\n{{attach.name}}</span> <span class=\"icon-download cursor-pointer grey-500-fg\" ng-click=\"vm.getAttachmentUrl(attach)\">\n<md-tooltip md-direction=\"top\">Descargar</md-tooltip></span></div></dd></dl><div ng-if=\"vm.errors[field]\" \nclass=\"pt-5 pb-5 pr-5 h6 red-500-fg\">{{vm.errors[field]}}</div></div></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/admin/analyst/dashboard/dialogs/delete/delete.html","<md-dialog aria-label=\"List dialog\" flex=\"30\" class=\"h-300\"><md-toolbar><div class=\"md-toolbar-tools\"><span \nclass=\"text-truncate h2\">Remover analista </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"back button\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"padding\"><div id=\"confirmStage\" layout=\"column\" layout-align=\"space-between\">\n<div class=\"mb-20\" layout=\"row\" layout-align=\"center center\"><span class=\"h2 font-weight-300\">\n¿Confirma que desea remover el analista &nbsp; <span class=\"h2 font-weight-500\">{{vm.analyst.name}}</span>?</span>\n</div><div class=\"mt-15\" layout=\"row\" layout-align=\"center center\"><md-button aria-label=\"Cancelar\" \nclass=\"md-raised md-warn h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.closeDialog()\">\nCancelar</md-button><md-button aria-label=\"Aceptar\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 white-fg\" ng-click=\"vm.deleteAnalyst()\">\nAceptar</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/config/mail-templates/dialogs/edit/edit-mail-template-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form name=\"form\" class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.template.name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-block\"><label>Asunto</label><input name=\"subject\" ng-model=\"vm.template.asunto\" required \ntype=\"text\"><div ng-messages=\"form.subject.$error\"><div ng-message=\"required\">Este campo es requerido.</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label class=\"no padding no-margin\">Descripción</label>\n<textarea class=\"no padding no-margin\" name=\"description\" ng-model=\"vm.template.descripcion\" md-maxlength=\"200\" \nrows=\"2\"></textarea></md-input-container><text-angular name=\"content\" ta-toolbar=\"vm.taToolbar\" \nng-model=\"vm.template.mensaje\"></text-angular></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button></div><div \nclass=\"p-5\"><md-button ng-click=\"vm.save()\" ng-disabled=\"form.$invalid || vm.loading\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Guardar</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/config/mail-templates/dialogs/probar/probar.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form name=\"form\" class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.template.name}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-block\"><label>Para</label><input name=\"subject\" ng-model=\"vm.data.para\" required \ntype=\"text\"><div ng-messages=\"form.subject.$error\"><div ng-message=\"required\">Este campo es requerido.</div></div>\n</md-input-container><md-input-container class=\"md-block\" ng-repeat=\"vars in vm.vars\"><label>{{vars}}</label><input \nname=\"subject\" ng-model=\"vm.data[vars]\" required type=\"text\"><div ng-messages=\"form.subject.$error\"><div \nng-message=\"required\">Este campo es requerido.</div></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"center center\"><div class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" \naria-label=\"Cancelar\" class=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar\n</md-button></div><div class=\"p-5\"><md-button ng-click=\"vm.save()\" ng-disabled=\"form.$invalid || vm.loading\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 remove-uppercase pl-20 pr-20 no-margin all-width\">Guardar</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/config/outbox/views/outlook/outlook-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon><input flex ng-change=\"vm.searchData()\" ng-model=\"vm.search\" ng-disabled=\"vm.loading\" type=\"text\" \nplaceholder=\"Buscar\" ng-model-options=\"{debounce: 1000 }\"></div></div></div><div class=\"content-wrapper\" layout=\"row\" \nflex><div class=\"content thread-list\" ng-include=\"\'app/main/admin/config/outbox/views/outlook/list/list.html\'\" \nms-scroll flex=\"50\"></div><div class=\"content thread-detail\" \nng-include=\"\'app/main/admin/config/outbox/views/outlook/detail/detail.html\'\" ms-scroll layout=\"column\" flex=\"50\"></div>\n</div><div class=\"pl-30 pr-30 pt-10 pb-10 bt\"><div ng-include=\"\'app/main/templates/paginator/paginator.html\'\"></div>\n</div>");
$templateCache.put("app/main/candidate/dashboard/dialogs/apply/steps/step-1.html","<div class=\"p-5 mb-20\"><div class=\"pr-5 pl-5 pb-15 text-bold\">\n¿Cúal de los siguientes argumentos se ajusta más en su caso con respecto al cargo que está aplicando?</div><div \nclass=\"pr-5 pb-10 pt-10 pl-5\" layout=\"row\" layout-align=\"start center\"><md-radio-group ng-model=\"vm.argument\">\n<md-radio-button ng-repeat=\"arg in vm.offer.arguments\" ng-value=\"arg.id\" class=\"md-primary\">{{arg.name}}\n</md-radio-button></md-radio-group></div></div>");
$templateCache.put("app/main/candidate/dashboard/dialogs/apply/steps/step-2.html","<div class=\"p-5 mb-20\"><div ng-init=\"vm.requeriments[$index] = {id: requeriment.id, value: false}\" \nng-class=\"{\'bb\' : !$last}\" ng-repeat=\"requeriment in vm.offer.requeriments\" class=\"pr-5 pb-10 pt-10 pl-5\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-padding no-margin md-primary\" \nng-model=\"vm.requeriments[$index].value\" aria-label=\"requeriment.name\">{{requeriment.name | capitalize}}</md-checkbox>\n</div></div>");
$templateCache.put("app/main/candidate/dashboard/dialogs/apply/templates/notice.html","<div ng-if=\"vm.offer.offersLimit && vm.offer.canApplied\">Solo puedes aplicar a <span class=\"green-500-fg\">\n{{vm.offer.offersLimit}} ofertas</span> por mes. En este momento has aplicado a <span class=\"green-500-fg\">\n{{vm.offer.offersApplied}} ofertas.</span>\n Recuerda validar muy bien los requerimientos de la oferta antes de aplicar para no desperdiciar las oportunidades que tienes para aplicar a otras vacantes.\n</div><div ng-if=\"!vm.offer.canApplied && vm.offer.offersLimit\">Solo puedes aplicar a <span class=\"green-500-fg\">\n{{vm.offer.offersLimit}} ofertas</span> por mes. En este momento has aplicado a <span class=\"green-500-fg\">\n{{vm.offer.offersApplied}} ofertas</span> y has llegado al límite.</div><div \nng-if=\"vm.offer.canApplied && !vm.offer.offersLimit\">En este momento has aplicado a <span class=\"green-500-fg\">\n{{vm.offer.offersApplied}} ofertas.</span> Recuerda validar muy bien los requerimientos de la oferta antes de aplicar.\n</div><div class=\"text-center p-15\"><md-button ng-if=\"vm.offer.canApplied\" ng-click=\"vm.nextStep()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Continuar</md-button>\n<md-button ng-if=\"!vm.offer.canApplied\" ng-click=\"vm.closeDialog()\" \nclass=\"md-raised h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cerrar</md-button></div>");
$templateCache.put("app/main/candidate/dashboard/dialogs/apply/templates/wizard.html","<div ng-if=\"!vm.finalStep\"><div ng-if=\"vm.step == 1\" \nng-include=\"\'app/main/candidate/dashboard/dialogs/apply/steps/step-1.html\'\"></div><div ng-if=\"vm.step == 2\" \nng-include=\"\'app/main/candidate/dashboard/dialogs/apply/steps/step-2.html\'\"></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"p-5\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Cancelar</md-button><md-button \nng-click=\"vm.nextStep()\" class=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">\nSiguiente</md-button></div></div><div ng-if=\"vm.finalStep\"><div class=\"h5\" ng-if=\"vm.applyResponse\">\nCon este, has aplicado a <span ng-if=\"vm.applyResponse.limite_ofertas_mes\" class=\"green-500-fg font-weight-500\">\n{{vm.applyResponse.cant_ofertas_aplico_hv_mes}} de {{vm.applyResponse.limite_ofertas_mes}} cargos posibles</span> <span\n ng-if=\"!vm.applyResponse.limite_ofertas_mes\" class=\"green-500-fg font-weight-500\">\n{{vm.applyResponse.cant_ofertas_aplico_hv_mes}} cargo<span ng-if=\"vm.applyResponse.cant_ofertas_aplico_hv_mes > 1\">s\n</span></span> durante este mes</div><div layout=\"row\" layout-align=\"center center\" class=\"pr-5 pl-5 pt-20 pb-5\">\n<md-button ng-click=\"vm.closeDialog()\" \nclass=\"md-raised md-accent h6 h-30 line-height-30 text-capitalized no-padding no-margin\">Finalizar</md-button></div>\n</div>");
$templateCache.put("app/main/admin/config/outbox/views/outlook/detail/detail.html","<div ng-if=\"!vm.currentThread\" class=\"no-thread-selected\" layout=\"column\" layout-align=\"center center\" flex><md-icon \nmd-font-icon=\"icon-email\" class=\"s120 grey-400-fg\"></md-icon><span class=\"hint-text\">Seleccione un mensaje para leer\n</span></div><div ng-if=\"vm.currentThread\"><div class=\"thread-header\" layout=\"row\" layout-align=\"space-between center\">\n<div><div class=\"subject\" flex>{{vm.currentThread.asunto}}</div></div></div><div class=\"thread-content\"><div \nclass=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div \nlayout=\"row\" layout-align=\"start start\"><div><div>{{vm.currentThread.to}}</div></div></div><a \nclass=\"toggle-details md-accent-color\" ng-hide=\"vm.selectedMailShowDetails\" \nng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\">Ver detalle </a><a \nclass=\"toggle-details md-accent-color\" ng-show=\"vm.selectedMailShowDetails\" \nng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\">Ocultar detalle</a><div \nng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span\n class=\"title\">De:</span> <span class=\"title\">Responder a:</span> <span class=\"title\">Fecha:</span></div><div \nlayout=\"column\"><span class=\"detail\">{{vm.currentThread.from}}</span> <span class=\"detail\">{{vm.currentThread.replyTo}}\n</span> <span class=\"detail\">{{vm.currentThread.created | fecha: \'DD/MMMM/YYYY\'}}</span></div></div></div></div><div \nng-bind-html=\"vm.currentThread.mensaje\"></div></div></div>");
$templateCache.put("app/main/admin/config/outbox/views/outlook/list/list.html","<div class=\"no-threads\" ng-if=\"vm.mails.length === 0\">No se encontraron mensajes</div><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"!vm.mails.length && vm.loading\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>Cargando bandeja de salida</div>\n</div><div class=\"thread\" ms-scroll md-ink-ripple ng-if=\"!vm.loading\" ng-repeat=\"thread in vm.mails\" \nng-click=\"vm.openThread(thread)\"><div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex layout=\"column\">\n<div class=\"name\" layout=\"row\" layout-align=\"start center\"><span class=\"text-truncate\">{{thread.to}}</span></div><div \nclass=\"h5 subject text-truncate\">{{thread.asunto}}</div><div class=\"h6 message text-truncate\">\n{{thread.mensaje | htmlToPlaintext | limitTo:90}}{{thread.message.length > 90 ? \'...\' : \'\'}}</div></div></div></div>");}]);